/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 199);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = newInterval;
var t0 = new Date,
    t1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = new Date(+date)), date;
  }

  interval.floor = interval;

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [];
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(new Date(+start)); while (offseti(start, step), floori(start), start < stop)
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_bisect__ = __webpack_require__(33);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__src_bisect__["a"]; });
/* unused harmony reexport bisectRight */
/* unused harmony reexport bisectLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_ascending__ = __webpack_require__(5);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1__src_ascending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_bisector__ = __webpack_require__(34);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__src_bisector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_cross__ = __webpack_require__(83);
/* unused harmony reexport cross */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_descending__ = __webpack_require__(84);
/* unused harmony reexport descending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_deviation__ = __webpack_require__(35);
/* unused harmony reexport deviation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_extent__ = __webpack_require__(36);
/* unused harmony reexport extent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_histogram__ = __webpack_require__(85);
/* unused harmony reexport histogram */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_threshold_freedmanDiaconis__ = __webpack_require__(95);
/* unused harmony reexport thresholdFreedmanDiaconis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_threshold_scott__ = __webpack_require__(96);
/* unused harmony reexport thresholdScott */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_threshold_sturges__ = __webpack_require__(40);
/* unused harmony reexport thresholdSturges */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_max__ = __webpack_require__(87);
/* unused harmony reexport max */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_mean__ = __webpack_require__(88);
/* unused harmony reexport mean */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_median__ = __webpack_require__(89);
/* unused harmony reexport median */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_merge__ = __webpack_require__(90);
/* unused harmony reexport merge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_min__ = __webpack_require__(37);
/* unused harmony reexport min */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_pairs__ = __webpack_require__(38);
/* unused harmony reexport pairs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_permute__ = __webpack_require__(91);
/* unused harmony reexport permute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_quantile__ = __webpack_require__(15);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_18__src_quantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_range__ = __webpack_require__(39);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_19__src_range__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_scan__ = __webpack_require__(92);
/* unused harmony reexport scan */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_shuffle__ = __webpack_require__(93);
/* unused harmony reexport shuffle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_sum__ = __webpack_require__(94);
/* unused harmony reexport sum */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_ticks__ = __webpack_require__(41);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_transpose__ = __webpack_require__(42);
/* unused harmony reexport transpose */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_variance__ = __webpack_require__(43);
/* unused harmony reexport variance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_zip__ = __webpack_require__(97);
/* unused harmony reexport zip */





























/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return durationSecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return durationMinute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return durationHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return durationDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return durationWeek; });
var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationDay = 864e5;
var durationWeek = 6048e5;


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_color__ = __webpack_require__(17);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_lab__ = __webpack_require__(105);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_lab__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_lab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__ = __webpack_require__(104);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__["a"]; });





/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
var array = Array.prototype;

var map = array.map;
var slice = array.slice;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
});


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x === null ? NaN : +x;
});


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_value__ = __webpack_require__(21);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_value__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_array__ = __webpack_require__(50);
/* unused harmony reexport interpolateArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_basis__ = __webpack_require__(20);
/* unused harmony reexport interpolateBasis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_basisClosed__ = __webpack_require__(51);
/* unused harmony reexport interpolateBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_date__ = __webpack_require__(53);
/* unused harmony reexport interpolateDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_number__ = __webpack_require__(12);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__src_number__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_object__ = __webpack_require__(54);
/* unused harmony reexport interpolateObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_round__ = __webpack_require__(120);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__src_round__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_string__ = __webpack_require__(56);
/* unused harmony reexport interpolateString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_transform_index__ = __webpack_require__(122);
/* unused harmony reexport interpolateTransformCss */
/* unused harmony reexport interpolateTransformSvg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_zoom__ = __webpack_require__(124);
/* unused harmony reexport interpolateZoom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_rgb__ = __webpack_require__(55);
/* unused harmony reexport interpolateRgb */
/* unused harmony reexport interpolateRgbBasis */
/* unused harmony reexport interpolateRgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_hsl__ = __webpack_require__(117);
/* unused harmony reexport interpolateHsl */
/* unused harmony reexport interpolateHslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_lab__ = __webpack_require__(118);
/* unused harmony reexport interpolateLab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_hcl__ = __webpack_require__(116);
/* unused harmony reexport interpolateHcl */
/* unused harmony reexport interpolateHclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(115);
/* unused harmony reexport interpolateCubehelix */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_quantize__ = __webpack_require__(119);
/* unused harmony reexport quantize */



















/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = hue;
/* harmony export (immutable) */ __webpack_exports__["c"] = gamma;
/* harmony export (immutable) */ __webpack_exports__["a"] = nogamma;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(52);


function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(s) {
  return s.match(/.{6}/g).map(function(x) {
    return "#" + x;
  });
});


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = linearish;
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tickFormat__ = __webpack_require__(140);





function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["a" /* ticks */])(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__tickFormat__["a" /* default */])(domain(), count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain(),
        i0 = 0,
        i1 = d.length - 1,
        start = d[i0],
        stop = d[i1],
        step;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }

    step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* tickIncrement */])(start, stop, count);

    if (step > 0) {
      start = Math.floor(start / step) * step;
      stop = Math.ceil(stop / step) * step;
      step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* tickIncrement */])(start, stop, count);
    } else if (step < 0) {
      start = Math.ceil(start * step) / step;
      stop = Math.floor(stop * step) / step;
      step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* tickIncrement */])(start, stop, count);
    }

    if (step > 0) {
      d[i0] = Math.floor(start / step) * step;
      d[i1] = Math.ceil(stop / step) * step;
      domain(d);
    } else if (step < 0) {
      d[i0] = Math.ceil(start * step) / step;
      d[i1] = Math.floor(stop * step) / step;
      domain(d);
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["a" /* interpolateNumber */]);

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__continuous__["c" /* copy */])(scale, linear());
  };

  return linearish(scale);
}


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(19);


/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(Math.abs(x)), x ? x[1] : NaN;
});


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
});


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = deinterpolateLinear;
/* harmony export (immutable) */ __webpack_exports__["c"] = copy;
/* harmony export (immutable) */ __webpack_exports__["a"] = continuous;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(58);






var unit = [0, 1];

function deinterpolateLinear(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(b);
}

function deinterpolateClamp(deinterpolate) {
  return function(a, b) {
    var d = deinterpolate(a = +a, b = +b);
    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
  };
}

function reinterpolateClamp(reinterpolate) {
  return function(a, b) {
    var r = reinterpolate(a = +a, b = +b);
    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
  };
}

function bimap(domain, range, deinterpolate, reinterpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, deinterpolate, reinterpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = deinterpolate(domain[i], domain[i + 1]);
    r[i] = reinterpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* bisect */])(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp());
}

// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
function continuous(deinterpolate, reinterpolate) {
  var domain = unit,
      range = unit,
      interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolate */],
      clamp = false,
      piecewise,
      output,
      input;

  function rescale() {
    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return (output || (output = piecewise(domain, range, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate)))(+x);
  }

  scale.invert = function(y) {
    return (input || (input = piecewise(range, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_2__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["c" /* interpolateRound */], rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, rescale()) : clamp;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  return rescale();
}


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        list: []
    },
    mutations: {
        setExample: function setExample(state, example) {
            state.list = example;
        }
    },
    getters: {
        example: function example(state) {
            return state.example.list;
        }
    }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = (function(values, p, valueof) {
  if (valueof == null) valueof = __WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */];
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
});


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefix; });
var prefix = "$";

function Map() {}

Map.prototype = map.prototype = {
  constructor: Map,
  has: function(key) {
    return (prefix + key) in this;
  },
  get: function(key) {
    return this[prefix + key];
  },
  set: function(key, value) {
    this[prefix + key] = value;
    return this;
  },
  remove: function(key) {
    var property = prefix + key;
    return property in this && delete this[property];
  },
  clear: function() {
    for (var property in this) if (property[0] === prefix) delete this[property];
  },
  keys: function() {
    var keys = [];
    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
    return keys;
  },
  values: function() {
    var values = [];
    for (var property in this) if (property[0] === prefix) values.push(this[property]);
    return values;
  },
  entries: function() {
    var entries = [];
    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
    return entries;
  },
  size: function() {
    var size = 0;
    for (var property in this) if (property[0] === prefix) ++size;
    return size;
  },
  empty: function() {
    for (var property in this) if (property[0] === prefix) return false;
    return true;
  },
  each: function(f) {
    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
  }
};

function map(object, f) {
  var map = new Map;

  // Copy constructor.
  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });

  // Index array by numeric index or specified key function.
  else if (Array.isArray(object)) {
    var i = -1,
        n = object.length,
        o;

    if (f == null) while (++i < n) map.set(i, object[i]);
    else while (++i < n) map.set(f(o = object[i], i, object), o);
  }

  // Convert object to map.
  else if (object) for (var key in object) map.set(key, object[key]);

  return map;
}

/* harmony default export */ __webpack_exports__["a"] = (map);


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = Color;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return darker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return brighter; });
/* harmony export (immutable) */ __webpack_exports__["h"] = color;
/* harmony export (immutable) */ __webpack_exports__["b"] = rgbConvert;
/* harmony export (immutable) */ __webpack_exports__["g"] = rgb;
/* harmony export (immutable) */ __webpack_exports__["a"] = Rgb;
/* unused harmony export hslConvert */
/* harmony export (immutable) */ __webpack_exports__["f"] = hsl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(18);


function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex3 = /^#([0-9a-f]{3})$/,
    reHex6 = /^#([0-9a-f]{6})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Color, color, {
  displayable: function() {
    return this.rgb().displayable();
  },
  toString: function() {
    return this.rgb() + "";
  }
});

function color(format) {
  var m;
  format = (format + "").trim().toLowerCase();
  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format])
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Rgb, rgb, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (0 <= this.r && this.r <= 255)
        && (0 <= this.g && this.g <= 255)
        && (0 <= this.b && this.b <= 255)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  toString: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(")
        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hsl, hsl, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extend;
/* harmony default export */ __webpack_exports__["a"] = (function(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
});

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimal(1.23) returns ["123", 0].
/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
});


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = basis;
function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rgb__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__date__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__object__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__string__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constant__ = __webpack_require__(52);









/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__constant__["a" /* default */])(b)
      : (t === "number" ? __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]
      : t === "string" ? ((c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* color */])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]) : __WEBPACK_IMPORTED_MODULE_6__string__["a" /* default */])
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* color */] ? __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]
      : b instanceof Date ? __WEBPACK_IMPORTED_MODULE_3__date__["a" /* default */]
      : Array.isArray(b) ? __WEBPACK_IMPORTED_MODULE_2__array__["a" /* default */]
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? __WEBPACK_IMPORTED_MODULE_5__object__["a" /* default */]
      : __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */])(a, b);
});


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return timeFormat; });
/* unused harmony export timeParse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return utcFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcParse; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(63);


var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;

defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale(definition) {
  locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  timeFormat = locale.format;
  timeParse = locale.parse;
  utcFormat = locale.utcFormat;
  utcParse = locale.utcParse;
  return locale;
}


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_interval__ = __webpack_require__(0);
/* unused harmony reexport timeInterval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_millisecond__ = __webpack_require__(146);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_1__src_millisecond__["a"]; });
/* unused harmony reexport timeMilliseconds */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__src_millisecond__["a"]; });
/* unused harmony reexport utcMilliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_second__ = __webpack_require__(149);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_2__src_second__["a"]; });
/* unused harmony reexport timeSeconds */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__src_second__["a"]; });
/* unused harmony reexport utcSeconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_minute__ = __webpack_require__(147);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_3__src_minute__["a"]; });
/* unused harmony reexport timeMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_hour__ = __webpack_require__(145);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_4__src_hour__["a"]; });
/* unused harmony reexport timeHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_day__ = __webpack_require__(144);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_5__src_day__["a"]; });
/* unused harmony reexport timeDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_week__ = __webpack_require__(156);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["a"]; });
/* unused harmony reexport timeWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["a"]; });
/* unused harmony reexport timeSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["b"]; });
/* unused harmony reexport timeMondays */
/* unused harmony reexport timeTuesday */
/* unused harmony reexport timeTuesdays */
/* unused harmony reexport timeWednesday */
/* unused harmony reexport timeWednesdays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["c"]; });
/* unused harmony reexport timeThursdays */
/* unused harmony reexport timeFriday */
/* unused harmony reexport timeFridays */
/* unused harmony reexport timeSaturday */
/* unused harmony reexport timeSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_month__ = __webpack_require__(148);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_7__src_month__["a"]; });
/* unused harmony reexport timeMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_year__ = __webpack_require__(157);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_8__src_year__["a"]; });
/* unused harmony reexport timeYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_utcMinute__ = __webpack_require__(152);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_9__src_utcMinute__["a"]; });
/* unused harmony reexport utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_utcHour__ = __webpack_require__(151);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__src_utcHour__["a"]; });
/* unused harmony reexport utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_utcDay__ = __webpack_require__(150);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_11__src_utcDay__["a"]; });
/* unused harmony reexport utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__ = __webpack_require__(154);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["a"]; });
/* unused harmony reexport utcWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["a"]; });
/* unused harmony reexport utcSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["b"]; });
/* unused harmony reexport utcMondays */
/* unused harmony reexport utcTuesday */
/* unused harmony reexport utcTuesdays */
/* unused harmony reexport utcWednesday */
/* unused harmony reexport utcWednesdays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["c"]; });
/* unused harmony reexport utcThursdays */
/* unused harmony reexport utcFriday */
/* unused harmony reexport utcFridays */
/* unused harmony reexport utcSaturday */
/* unused harmony reexport utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_utcMonth__ = __webpack_require__(153);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_13__src_utcMonth__["a"]; });
/* unused harmony reexport utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_utcYear__ = __webpack_require__(155);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_14__src_utcYear__["a"]; });
/* unused harmony reexport utcYears */































/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_bbox__ = __webpack_require__(65);
/* unused harmony reexport bbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_feature__ = __webpack_require__(26);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__src_feature__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_mesh__ = __webpack_require__(164);
/* unused harmony reexport mesh */
/* unused harmony reexport meshArcs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_merge__ = __webpack_require__(163);
/* unused harmony reexport merge */
/* unused harmony reexport mergeArcs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_neighbors__ = __webpack_require__(165);
/* unused harmony reexport neighbors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_quantize__ = __webpack_require__(166);
/* unused harmony reexport quantize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_transform__ = __webpack_require__(27);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__src_transform__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_untransform__ = __webpack_require__(68);
/* unused harmony reexport untransform */










/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export feature */
/* harmony export (immutable) */ __webpack_exports__["b"] = object;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reverse__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transform__ = __webpack_require__(27);



/* harmony default export */ __webpack_exports__["a"] = (function(topology, o) {
  return o.type === "GeometryCollection"
      ? {type: "FeatureCollection", features: o.geometries.map(function(o) { return feature(topology, o); })}
      : feature(topology, o);
});

function feature(topology, o) {
  var id = o.id,
      bbox = o.bbox,
      properties = o.properties == null ? {} : o.properties,
      geometry = object(topology, o);
  return id == null && bbox == null ? {type: "Feature", properties: properties, geometry: geometry}
      : bbox == null ? {type: "Feature", id: id, properties: properties, geometry: geometry}
      : {type: "Feature", id: id, bbox: bbox, properties: properties, geometry: geometry};
}

function object(topology, o) {
  var transformPoint = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__transform__["a" /* default */])(topology.transform),
      arcs = topology.arcs;

  function arc(i, points) {
    if (points.length) points.pop();
    for (var a = arcs[i < 0 ? ~i : i], k = 0, n = a.length; k < n; ++k) {
      points.push(transformPoint(a[k], k));
    }
    if (i < 0) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__reverse__["a" /* default */])(points, n);
  }

  function point(p) {
    return transformPoint(p);
  }

  function line(arcs) {
    var points = [];
    for (var i = 0, n = arcs.length; i < n; ++i) arc(arcs[i], points);
    if (points.length < 2) points.push(points[0]); // This should never happen per the specification.
    return points;
  }

  function ring(arcs) {
    var points = line(arcs);
    while (points.length < 4) points.push(points[0]); // This may happen if an arc has only two points.
    return points;
  }

  function polygon(arcs) {
    return arcs.map(ring);
  }

  function geometry(o) {
    var type = o.type, coordinates;
    switch (type) {
      case "GeometryCollection": return {type: type, geometries: o.geometries.map(geometry)};
      case "Point": coordinates = point(o.coordinates); break;
      case "MultiPoint": coordinates = o.coordinates.map(point); break;
      case "LineString": coordinates = line(o.arcs); break;
      case "MultiLineString": coordinates = o.arcs.map(line); break;
      case "Polygon": coordinates = polygon(o.arcs); break;
      case "MultiPolygon": coordinates = o.arcs.map(polygon); break;
      default: return null;
    }
    return {type: type, coordinates: coordinates};
  }

  return geometry(o);
}


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity__ = __webpack_require__(66);


/* harmony default export */ __webpack_exports__["a"] = (function(transform) {
  if (transform == null) return __WEBPACK_IMPORTED_MODULE_0__identity__["a" /* default */];
  var x0,
      y0,
      kx = transform.scale[0],
      ky = transform.scale[1],
      dx = transform.translate[0],
      dy = transform.translate[1];
  return function(input, i) {
    if (!i) x0 = y0 = 0;
    var j = 2, n = input.length, output = new Array(n);
    output[0] = (x0 += input[0]) * kx + dx;
    output[1] = (y0 += input[1]) * ky + dy;
    while (j < n) output[j] = input[j], ++j;
    return output;
  };
});


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(size, hash, equal, keyType, keyEmpty, valueType) {
  if (arguments.length === 3) {
    keyType = valueType = Array;
    keyEmpty = null;
  }

  var keystore = new keyType(size = 1 << Math.max(4, Math.ceil(Math.log(size) / Math.LN2))),
      valstore = new valueType(size),
      mask = size - 1;

  for (var i = 0; i < size; ++i) {
    keystore[i] = keyEmpty;
  }

  function set(key, value) {
    var index = hash(key) & mask,
        matchKey = keystore[index],
        collisions = 0;
    while (matchKey != keyEmpty) {
      if (equal(matchKey, key)) return valstore[index] = value;
      if (++collisions >= size) throw new Error("full hashmap");
      matchKey = keystore[index = (index + 1) & mask];
    }
    keystore[index] = key;
    valstore[index] = value;
    return value;
  }

  function maybeSet(key, value) {
    var index = hash(key) & mask,
        matchKey = keystore[index],
        collisions = 0;
    while (matchKey != keyEmpty) {
      if (equal(matchKey, key)) return valstore[index];
      if (++collisions >= size) throw new Error("full hashmap");
      matchKey = keystore[index = (index + 1) & mask];
    }
    keystore[index] = key;
    valstore[index] = value;
    return value;
  }

  function get(key, missingValue) {
    var index = hash(key) & mask,
        matchKey = keystore[index],
        collisions = 0;
    while (matchKey != keyEmpty) {
      if (equal(matchKey, key)) return valstore[index];
      if (++collisions >= size) break;
      matchKey = keystore[index = (index + 1) & mask];
    }
    return missingValue;
  }

  function keys() {
    var keys = [];
    for (var i = 0, n = keystore.length; i < n; ++i) {
      var matchKey = keystore[i];
      if (matchKey != keyEmpty) keys.push(matchKey);
    }
    return keys;
  }

  return {
    set: set,
    maybeSet: maybeSet, // set if unset
    get: get,
    keys: keys
  };
});


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = planarTriangleArea;
/* harmony export (immutable) */ __webpack_exports__["b"] = planarRingArea;
function planarTriangleArea(triangle) {
  var a = triangle[0], b = triangle[1], c = triangle[2];
  return Math.abs((a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1])) / 2;
}

function planarRingArea(ring) {
  var i = -1, n = ring.length, a, b = ring[n - 1], area = 0;
  while (++i < n) a = b, b = ring[i], area += a[0] * b[1] - a[1] * b[0];
  return Math.abs(area) / 2;
}


/***/ }),
/* 30 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
    load: function load(store) {
        // loading goes here
    }
});

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
var array = Array.prototype;

var slice = array.slice;
var map = array.map;


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bisectRight */
/* unused harmony export bisectLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisector__ = __webpack_require__(34);



var ascendingBisect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__bisector__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]);
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;
/* harmony default export */ __webpack_exports__["a"] = (bisectRight);


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      }
      return lo;
    },
    right: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;
        else lo = mid + 1;
      }
      return lo;
    }
  };
});

function ascendingComparator(f) {
  return function(d, x) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(f(d), x);
  };
}


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__variance__ = __webpack_require__(43);


/* harmony default export */ __webpack_exports__["a"] = (function(array, f) {
  var v = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__variance__["a" /* default */])(array, f);
  return v ? Math.sqrt(v) : v;
});


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  return [min, max];
});


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  return min;
});


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pair;
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, f) {
  if (f == null) f = pair;
  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
  while (i < n) pairs[i] = f(p, p = array[++i]);
  return pairs;
});

function pair(a, b) {
  return [a, b];
}


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
});


/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
});


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = tickIncrement;
/* harmony export (immutable) */ __webpack_exports__["c"] = tickStep;
var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, count) {
  var reverse,
      i = -1,
      n,
      ticks,
      step;

  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    start = Math.ceil(start / step);
    stop = Math.floor(stop / step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) * step;
  } else {
    start = Math.floor(start * step);
    stop = Math.ceil(stop * step);
    ticks = new Array(n = Math.ceil(start - stop + 1));
    while (++i < n) ticks[i] = (start - i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
});

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__min__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = (function(matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__min__["a" /* default */])(matrix, length), transpose = new Array(m); ++i < m;) {
    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
      row[j] = matrix[j][i];
    }
  }
  return transpose;
});

function length(d) {
  return d.length;
}


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      m = 0,
      i = -1,
      mean = 0,
      value,
      delta,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  if (m > 1) return sum / (m - 1);
});


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deg2rad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rad2deg; });
var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__ = __webpack_require__(106);
/* unused harmony reexport formatDefaultLocale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_locale__ = __webpack_require__(49);
/* unused harmony reexport formatLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__ = __webpack_require__(47);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__ = __webpack_require__(112);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__ = __webpack_require__(113);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__ = __webpack_require__(114);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__["a"]; });








/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefixExponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(19);


var prefixExponent;

/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, Math.max(0, p + i - 1))[0]; // less than 1y!
});


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatSpecifier;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatTypes__ = __webpack_require__(48);


// [[fill]align][sign][symbol][0][width][,][.precision][type]
var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  return new FormatSpecifier(specifier);
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);

  var match,
      fill = match[1] || " ",
      align = match[2] || ">",
      sign = match[3] || "-",
      symbol = match[4] || "",
      zero = !!match[5],
      width = match[6] && +match[6],
      comma = !!match[7],
      precision = match[8] && +match[8].slice(1),
      type = match[9] || "";

  // The "n" type is an alias for ",g".
  if (type === "n") comma = true, type = "g";

  // Map invalid types to the default format.
  else if (!__WEBPACK_IMPORTED_MODULE_0__formatTypes__["a" /* default */][type]) type = "";

  // If zero fill is specified, padding goes after sign and before digits.
  if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

  this.fill = fill;
  this.align = align;
  this.sign = sign;
  this.symbol = symbol;
  this.zero = zero;
  this.width = width;
  this.comma = comma;
  this.precision = precision;
  this.type = type;
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width == null ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
      + this.type;
};


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDefault__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatRounded__ = __webpack_require__(110);




/* harmony default export */ __webpack_exports__["a"] = ({
  "": __WEBPACK_IMPORTED_MODULE_0__formatDefault__["a" /* default */],
  "%": function(x, p) { return (x * 100).toFixed(p); },
  "b": function(x) { return Math.round(x).toString(2); },
  "c": function(x) { return x + ""; },
  "d": function(x) { return Math.round(x).toString(10); },
  "e": function(x, p) { return x.toExponential(p); },
  "f": function(x, p) { return x.toFixed(p); },
  "g": function(x, p) { return x.toPrecision(p); },
  "o": function(x) { return Math.round(x).toString(8); },
  "p": function(x, p) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__formatRounded__["a" /* default */])(x * 100, p); },
  "r": __WEBPACK_IMPORTED_MODULE_2__formatRounded__["a" /* default */],
  "s": __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto__["a" /* default */],
  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
  "x": function(x) { return Math.round(x).toString(16); }
});


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatGroup__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatNumerals__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formatSpecifier__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__formatTypes__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__formatPrefixAuto__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__identity__ = __webpack_require__(111);








var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

/* harmony default export */ __webpack_exports__["a"] = (function(locale) {
  var group = locale.grouping && locale.thousands ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__formatGroup__["a" /* default */])(locale.grouping, locale.thousands) : __WEBPACK_IMPORTED_MODULE_6__identity__["a" /* default */],
      currency = locale.currency,
      decimal = locale.decimal,
      numerals = locale.numerals ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__formatNumerals__["a" /* default */])(locale.numerals) : __WEBPACK_IMPORTED_MODULE_6__identity__["a" /* default */],
      percent = locale.percent || "%";

  function newFormat(specifier) {
    specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        type = specifier.type;

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = __WEBPACK_IMPORTED_MODULE_4__formatTypes__["a" /* default */][type],
        maybeSuffix = !type || /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision == null ? (type ? 6 : 12)
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Perform the initial formatting.
        var valueNegative = value < 0;
        value = formatType(Math.abs(value), precision);

        // If a negative value rounds to zero during formatting, treat as positive.
        if (valueNegative && +value === 0) valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = valueSuffix + (type === "s" ? prefixes[8 + __WEBPACK_IMPORTED_MODULE_5__formatPrefixAuto__["b" /* prefixExponent */] / 3] : "") + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
});


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(21);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(nb),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
});


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(20);


/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__basis__["b" /* basis */])((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var d = new Date;
  return a = +a, b -= a, function(t) {
    return d.setTime(a + b * t), d;
  };
});


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(21);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
});


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export rgbBasis */
/* unused harmony export rgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basisClosed__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__color__ = __webpack_require__(8);





/* harmony default export */ __webpack_exports__["a"] = ((function rgbGamma(y) {
  var color = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__color__["c" /* gamma */])(y);

  function rgb(start, end) {
    var r = color((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* rgb */])(start)).r, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* rgb */])(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1));

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color;
    for (i = 0; i < n; ++i) {
      color = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* rgb */])(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function(t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(__WEBPACK_IMPORTED_MODULE_1__basis__["a" /* default */]);
var rgbBasisClosed = rgbSpline(__WEBPACK_IMPORTED_MODULE_2__basisClosed__["a" /* default */]);


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(12);


var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
});


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
});


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return +x;
});


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export implicit */
/* harmony export (immutable) */ __webpack_exports__["a"] = ordinal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_collection__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(4);



var implicit = {name: "implicit"};

function ordinal(range) {
  var index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["a" /* map */])(),
      domain = [],
      unknown = implicit;

  range = range == null ? [] : __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(range);

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["a" /* map */])();
    var i = -1, n = _.length, d, key;
    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return scale;
}


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calendar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_time_format__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__array__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__continuous__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nice__ = __webpack_require__(57);








var durationSecond = 1000,
    durationMinute = durationSecond * 60,
    durationHour = durationMinute * 60,
    durationDay = durationHour * 24,
    durationWeek = durationDay * 7,
    durationMonth = durationDay * 30,
    durationYear = durationDay * 365;

function date(t) {
  return new Date(t);
}

function number(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__continuous__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__continuous__["b" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["a" /* interpolateNumber */]),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  var tickIntervals = [
    [second,  1,      durationSecond],
    [second,  5,  5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [minute,  1,      durationMinute],
    [minute,  5,  5 * durationMinute],
    [minute, 15, 15 * durationMinute],
    [minute, 30, 30 * durationMinute],
    [  hour,  1,      durationHour  ],
    [  hour,  3,  3 * durationHour  ],
    [  hour,  6,  6 * durationHour  ],
    [  hour, 12, 12 * durationHour  ],
    [   day,  1,      durationDay   ],
    [   day,  2,  2 * durationDay   ],
    [  week,  1,      durationWeek  ],
    [ month,  1,      durationMonth ],
    [ month,  3,  3 * durationMonth ],
    [  year,  1,      durationYear  ]
  ];

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond
        : minute(date) < date ? formatSecond
        : hour(date) < date ? formatMinute
        : day(date) < date ? formatHour
        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year(date) < date ? formatMonth
        : formatYear)(date);
  }

  function tickInterval(interval, start, stop, step) {
    if (interval == null) interval = 10;

    // If a desired tick count is specified, pick a reasonable tick interval
    // based on the extent of the domain and a rough estimate of tick size.
    // Otherwise, assume interval is already a time interval and use it.
    if (typeof interval === "number") {
      var target = Math.abs(stop - start) / interval,
          i = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["e" /* bisector */])(function(i) { return i[2]; }).right(tickIntervals, target);
      if (i === tickIntervals.length) {
        step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["d" /* tickStep */])(start / durationYear, stop / durationYear, interval);
        interval = year;
      } else if (i) {
        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        step = i[1];
        interval = i[0];
      } else {
        step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["d" /* tickStep */])(start, stop, interval);
        interval = millisecond;
      }
    }

    return step == null ? interval : interval.every(step);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(__WEBPACK_IMPORTED_MODULE_4__array__["a" /* map */].call(_, number)) : domain().map(date);
  };

  scale.ticks = function(interval, step) {
    var d = domain(),
        t0 = d[0],
        t1 = d[d.length - 1],
        r = t1 < t0,
        t;
    if (r) t = t0, t0 = t1, t1 = t;
    t = tickInterval(interval, t0, t1, step);
    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return r ? t.reverse() : t;
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval, step) {
    var d = domain();
    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
        ? domain(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__nice__["a" /* default */])(d, interval))
        : scale;
  };

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__continuous__["c" /* copy */])(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
  };

  return scale;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return calendar(__WEBPACK_IMPORTED_MODULE_2_d3_time__["l" /* timeYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["q" /* timeMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["r" /* timeWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["k" /* timeDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["s" /* timeHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["t" /* timeMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["u" /* timeSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["v" /* timeMillisecond */], __WEBPACK_IMPORTED_MODULE_3_d3_time_format__["b" /* timeFormat */]).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
});


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__ = __webpack_require__(23);
/* unused harmony reexport timeFormatDefaultLocale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["c"]; });
/* unused harmony reexport timeParse */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["a"]; });
/* unused harmony reexport utcParse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_locale__ = __webpack_require__(63);
/* unused harmony reexport timeFormatLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_isoFormat__ = __webpack_require__(62);
/* unused harmony reexport isoFormat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_isoParse__ = __webpack_require__(143);
/* unused harmony reexport isoParse */






/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isoSpecifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale__ = __webpack_require__(23);


var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";

function formatIsoNative(date) {
  return date.toISOString();
}

var formatIso = Date.prototype.toISOString
    ? formatIsoNative
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__defaultLocale__["a" /* utcFormat */])(isoSpecifier);

/* unused harmony default export */ var _unused_webpack_default_export = (formatIso);


/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_time__ = __webpack_require__(24);


function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newYear(y) {
  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, newDate) {
    return function(string) {
      var d = newYear(1900),
          i = parseSpecifier(d, specifier, string += "", 0),
          week, day;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ("Q" in d) return new Date(d.Q);

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate(newYear(d.y)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* utcMonday */].ceil(week) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* utcMonday */])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["d" /* utcDay */].offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = newDate(newYear(d.y)), day = week.getDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* timeMonday */].ceil(week) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* timeMonday */])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeDay */].offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return newDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", localDate);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier, utcDate);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"},
    numberRe = /^\s*\d+/, // note: ignores next directive
    percentRe = /^%/,
    requoteRe = /[\\^$*+?|[\]().{}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  var map = {}, i = -1, n = names.length;
  while (++i < n) map[names[i].toLowerCase()] = i;
  return map;
}

function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}

function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = (+n[0]) * 1000, i + n[0].length) : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeDay */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* timeYear */])(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}

function formatWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["m" /* timeSunday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* timeYear */])(d), d), p, 2);
}

function formatWeekNumberISO(d, p) {
  var day = d.getDay();
  d = (day >= 4 || day === 0) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["n" /* timeThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["n" /* timeThursday */].ceil(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["n" /* timeThursday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* timeYear */])(d), d) + (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* timeYear */])(d).getDay() === 4), p, 2);
}

function formatWeekdayNumberSunday(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* timeMonday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* timeYear */])(d), d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["d" /* utcDay */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* utcYear */])(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["o" /* utcSunday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* utcYear */])(d), d), p, 2);
}

function formatUTCWeekNumberISO(d, p) {
  var day = d.getUTCDay();
  d = (day >= 4 || day === 0) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcThursday */].ceil(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcThursday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* utcYear */])(d), d) + (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* utcYear */])(d).getUTCDay() === 4), p, 2);
}

function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* utcMonday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* utcYear */])(d), d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

function formatUnixTimestamp(d) {
  return +d;
}

function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1000);
}


/***/ }),
/* 64 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transform__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = (function(topology) {
  var t = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__transform__["a" /* default */])(topology.transform), key,
      x0 = Infinity, y0 = x0, x1 = -x0, y1 = -x0;

  function bboxPoint(p) {
    p = t(p);
    if (p[0] < x0) x0 = p[0];
    if (p[0] > x1) x1 = p[0];
    if (p[1] < y0) y0 = p[1];
    if (p[1] > y1) y1 = p[1];
  }

  function bboxGeometry(o) {
    switch (o.type) {
      case "GeometryCollection": o.geometries.forEach(bboxGeometry); break;
      case "Point": bboxPoint(o.coordinates); break;
      case "MultiPoint": o.coordinates.forEach(bboxPoint); break;
    }
  }

  topology.arcs.forEach(function(arc) {
    var i = -1, n = arc.length, p;
    while (++i < n) {
      p = t(arc[i], i);
      if (p[0] < x0) x0 = p[0];
      if (p[0] > x1) x1 = p[0];
      if (p[1] < y0) y0 = p[1];
      if (p[1] > y1) y1 = p[1];
    }
  });

  for (key in topology.objects) {
    bboxGeometry(topology.objects[key]);
  }

  return [x0, y0, x1, y1];
});


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(topology, arcs) {
  var stitchedArcs = {},
      fragmentByStart = {},
      fragmentByEnd = {},
      fragments = [],
      emptyIndex = -1;

  // Stitch empty arcs first, since they may be subsumed by other arcs.
  arcs.forEach(function(i, j) {
    var arc = topology.arcs[i < 0 ? ~i : i], t;
    if (arc.length < 3 && !arc[1][0] && !arc[1][1]) {
      t = arcs[++emptyIndex], arcs[emptyIndex] = i, arcs[j] = t;
    }
  });

  arcs.forEach(function(i) {
    var e = ends(i),
        start = e[0],
        end = e[1],
        f, g;

    if (f = fragmentByEnd[start]) {
      delete fragmentByEnd[f.end];
      f.push(i);
      f.end = end;
      if (g = fragmentByStart[end]) {
        delete fragmentByStart[g.start];
        var fg = g === f ? f : f.concat(g);
        fragmentByStart[fg.start = f.start] = fragmentByEnd[fg.end = g.end] = fg;
      } else {
        fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
      }
    } else if (f = fragmentByStart[end]) {
      delete fragmentByStart[f.start];
      f.unshift(i);
      f.start = start;
      if (g = fragmentByEnd[start]) {
        delete fragmentByEnd[g.end];
        var gf = g === f ? f : g.concat(f);
        fragmentByStart[gf.start = g.start] = fragmentByEnd[gf.end = f.end] = gf;
      } else {
        fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
      }
    } else {
      f = [i];
      fragmentByStart[f.start = start] = fragmentByEnd[f.end = end] = f;
    }
  });

  function ends(i) {
    var arc = topology.arcs[i < 0 ? ~i : i], p0 = arc[0], p1;
    if (topology.transform) p1 = [0, 0], arc.forEach(function(dp) { p1[0] += dp[0], p1[1] += dp[1]; });
    else p1 = arc[arc.length - 1];
    return i < 0 ? [p1, p0] : [p0, p1];
  }

  function flush(fragmentByEnd, fragmentByStart) {
    for (var k in fragmentByEnd) {
      var f = fragmentByEnd[k];
      delete fragmentByStart[f.start];
      delete f.start;
      delete f.end;
      f.forEach(function(i) { stitchedArcs[i < 0 ? ~i : i] = 1; });
      fragments.push(f);
    }
  }

  flush(fragmentByEnd, fragmentByStart);
  flush(fragmentByStart, fragmentByEnd);
  arcs.forEach(function(i) { if (!stitchedArcs[i < 0 ? ~i : i]) fragments.push([i]); });

  return fragments;
});


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity__ = __webpack_require__(66);


/* harmony default export */ __webpack_exports__["a"] = (function(transform) {
  if (transform == null) return __WEBPACK_IMPORTED_MODULE_0__identity__["a" /* default */];
  var x0,
      y0,
      kx = transform.scale[0],
      ky = transform.scale[1],
      dx = transform.translate[0],
      dy = transform.translate[1];
  return function(input, i) {
    if (!i) x0 = y0 = 0;
    var j = 2,
        n = input.length,
        output = new Array(n),
        x1 = Math.round((input[0] - dx) / kx),
        y1 = Math.round((input[1] - dy) / ky);
    output[0] = x1 - x0, x0 = x1;
    output[1] = y1 - y0, y0 = y1;
    while (j < n) output[j] = input[j], ++j;
    return output;
  };
});


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(pointA, pointB) {
  return pointA[0] === pointB[0] && pointA[1] === pointB[1];
});


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// TODO if quantized, use simpler Int32 hashing?

var buffer = new ArrayBuffer(16),
    floats = new Float64Array(buffer),
    uints = new Uint32Array(buffer);

/* harmony default export */ __webpack_exports__["a"] = (function(point) {
  floats[0] = point[0];
  floats[1] = point[1];
  var hash = uints[0] ^ uints[1];
  hash = hash << 5 ^ hash >> 7 ^ uints[2] ^ uints[3];
  return hash & 0x7fffffff;
});


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(topology) {
  var ownerByArc = new Array(topology.arcs.length), // arc index -> index of unique associated ring, or -1 if used by multiple rings
      ownerIndex = 0,
      key;

  function testGeometry(o) {
    switch (o.type) {
      case "GeometryCollection": o.geometries.forEach(testGeometry); break;
      case "Polygon": testArcs(o.arcs); break;
      case "MultiPolygon": o.arcs.forEach(testArcs); break;
    }
  }

  function testArcs(arcs) {
    for (var i = 0, n = arcs.length; i < n; ++i, ++ownerIndex) {
      for (var ring = arcs[i], j = 0, m = ring.length; j < m; ++j) {
        var arc = ring[j];
        if (arc < 0) arc = ~arc;
        var owner = ownerByArc[arc];
        if (owner == null) ownerByArc[arc] = ownerIndex;
        else if (owner !== ownerIndex) ownerByArc[arc] = -1;
      }
    }
  }

  for (key in topology.objects) {
    testGeometry(topology.objects[key]);
  }

  return function(ring) {
    for (var j = 0, m = ring.length, arc; j < m; ++j) {
      if (ownerByArc[(arc = ring[j]) < 0 ? ~arc : arc] === -1) {
        return true;
      }
    }
    return false;
  };
});


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_topojson_client__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__planar__ = __webpack_require__(29);



/* harmony default export */ __webpack_exports__["a"] = (function(topology, minWeight, weight) {
  minWeight = minWeight == null ? Number.MIN_VALUE : +minWeight;

  if (weight == null) weight = __WEBPACK_IMPORTED_MODULE_1__planar__["b" /* planarRingArea */];

  return function(ring, interior) {
    return weight(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_topojson_client__["a" /* feature */])(topology, {type: "Polygon", arcs: [ring]}).geometry.coordinates[0], interior) >= minWeight;
  };
});


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_app__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_example__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__view_pollutionmap__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model__ = __webpack_require__(77);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2__view_app__["a" /* default */].store = new __WEBPACK_IMPORTED_MODULE_1_vuex___default.a.Store({
    modules: __WEBPACK_IMPORTED_MODULE_6__model__["a" /* default */]
});

var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
    routes: [{
        path: '/',
        component: __WEBPACK_IMPORTED_MODULE_5__view_pollutionmap__["a" /* default */]
        /*    ,{
                path: '/pollutionmap',
                component: pollutionmap
            }*/
    }]
});

__WEBPACK_IMPORTED_MODULE_2__view_app__["a" /* default */].router = router;

/* harmony default export */ __webpack_exports__["default"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */](__WEBPACK_IMPORTED_MODULE_2__view_app__["a" /* default */]));

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// This file can be required in Browserify and Node.js for automatic polyfill
// To use it:  require('es6-promise/auto');

module.exports = __webpack_require__(158).polyfill();


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
    init: function init() {
        if (typeof document !== 'undefined') {
            window.addEventListener('resize', this.sendHeight.bind(this, {}));

            setInterval(this.sendHeight.bind(this, {}), 200);
        }
    },
    sendHeight: function sendHeight(opts) {
        var heights = [];

        if (typeof document !== 'undefined' && typeof parent !== 'undefined' && parent) {
            var height = document.body.offsetHeight;

            if (typeof opts == 'undefined' || !opts) {
                opts = {};
            }

            opts.height = height + 10;

            parent.postMessage(opts, "*");

            heights.unshift(height + 10);

            if (heights.length > 5) {
                heights.pop();
            }
        }
    },
    scrollTo: function scrollTo(num) {
        this.sendHeight({
            scrollTo: num
        });
    },
    setHash: function setHash(route) {
        this.sendHeight({
            route: route
        });
    }
});

/***/ }),
/* 76 */,
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__example__ = __webpack_require__(14);


/* harmony default export */ __webpack_exports__["a"] = ({
	example: __WEBPACK_IMPORTED_MODULE_0__example__["a" /* default */]
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controller_pym__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_app_html__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_app_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__view_app_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__overview__ = __webpack_require__(80);




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        overview: __WEBPACK_IMPORTED_MODULE_2__overview__["a" /* default */]
    },
    el: '#refineryGraphics',
    render: __WEBPACK_IMPORTED_MODULE_1__view_app_html___default.a.render,
    staticRenderFns: __WEBPACK_IMPORTED_MODULE_1__view_app_html___default.a.staticRenderFns,
    created: function created() {
        __WEBPACK_IMPORTED_MODULE_0__controller_pym__["a" /* default */].init();
    }
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__view_example_html__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__view_example_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__view_example_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_example__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__controller_example__ = __webpack_require__(31);




__WEBPACK_IMPORTED_MODULE_1__model_example__["a" /* default */].actions = __WEBPACK_IMPORTED_MODULE_2__controller_example__["a" /* default */];

/* unused harmony default export */ var _unused_webpack_default_export = ({
    vuex: __WEBPACK_IMPORTED_MODULE_1__model_example__["a" /* default */],
    render: __WEBPACK_IMPORTED_MODULE_0__view_example_html___default.a.render,
    staticRenderFns: __WEBPACK_IMPORTED_MODULE_0__view_example_html___default.a.staticRenderFns
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__view_overview_html__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__view_overview_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__view_overview_html__);


/* harmony default export */ __webpack_exports__["a"] = ({
    render: __WEBPACK_IMPORTED_MODULE_0__view_overview_html___default.a.render,
    staticRenderFns: __WEBPACK_IMPORTED_MODULE_0__view_overview_html___default.a.staticRenderFns
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__view_pollutionmap_html__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__view_pollutionmap_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__view_pollutionmap_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_example__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__controller_example__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_leaflet__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_cali_smaller_json__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_cali_smaller_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__data_cali_smaller_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_refineries_json__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_refineries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__data_refineries_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_topojson__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_d3_scale__ = __webpack_require__(125);









__WEBPACK_IMPORTED_MODULE_1__model_example__["a" /* default */].actions = __WEBPACK_IMPORTED_MODULE_2__controller_example__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = ({
    vuex: __WEBPACK_IMPORTED_MODULE_1__model_example__["a" /* default */],
    render: __WEBPACK_IMPORTED_MODULE_0__view_pollutionmap_html___default.a.render,
    staticRenderFns: __WEBPACK_IMPORTED_MODULE_0__view_pollutionmap_html___default.a.staticRenderFns,
    mounted: function mounted() {
        var map = __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.map(this.$el.querySelector('.map'), {
            scrollWheelZoom: false,
            maxZoom: 14,
            minZoom: 11,
            keyboard: !('ontouchstart' in window),
            maxBounds: [[33.606189, -118.617030], [33.928975, -118.075953]],
            attributionControl: false
        }).setView([33.784497, -118.374455], 12);

        if (this.$el.offsetWidth < 600) {
            map.setView([33.797805, -118.337050], 11);
        }
        /*
        this.$el.addEventListener('resize',() => {
        if (this.$el.offsetWidth < 600) {
            map.setView([33.798126, -118.326579], 11);
        }
        });*/

        __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.tileLayer('https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_nolabels/{z}/{x}/{y}@2x.png', {
            maxZoom: 14,
            minZoom: 10,
            attribution: 'Map data &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>' + '<a href="https://carto.com/attribution">CARTO</a>'
        }).addTo(map);

        // control that shows state info on hover
        var info = __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.control();

        info.onAdd = function (map) {
            this._div = __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.DomUtil.create('div', 'info');
            this.update();
            return this._div;
        };

        info.update = function (props) {
            this._div.innerHTML = props ? '<b>Tract in ' + props.City + '</b><br />\n                  <br>  \n                  <em>Numbers reflect scores<br>ranging from zero (best)<br>to 100 (worst).</em><br>\n                  <br>\n                  Pollution burden: ' + props.Poll_pctl + '<br />\n                  Diesel particulates: ' + props.DPM_pctl + '<br />\n                  Toxic release: ' + props.TR_pctl + '<br />\n                  Asthma: ' + props.Asthma_Pct + '<br />\n                  Cardiovascular disease: ' + props.CVD_pctl + '<br />\n                  Poverty: ' + props.Pov_pctl : '';
        };

        info.addTo(map);

        var colors = ['#fbe6c5', '#f5ccb3', '#ecb4a2', '#df9c93', '#d18784', '#c17077', '#af5c6a', '#9b4a5f', '#873854', '#70284a'];

        var breaks = [10, 20, 30, 40, 50, 60, 70, 80, 90];

        var colorScale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_d3_scale__["a" /* scaleThreshold */])().domain(breaks).range(colors);

        var highlightedFeature = null;

        function style(feature) {
            return {
                weight: 1,
                opacity: 0.5,
                color: colorScale(feature.properties.Poll_pctl),
                fillOpacity: 0.7,
                fillColor: colorScale(feature.properties.Poll_pctl)
            };
        }

        function highlightFeature(e) {
            var layer = e.target;

            if (highlightedFeature) {
                geojson.resetStyle(highlightedFeature);
                info.update();
            }

            highlightedFeature = layer;

            layer.setStyle({
                opacity: 1,
                weight: 2,
                color: 'black',
                dashArray: '',
                fillOpacity: 0.7
            });
            /*
                        if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
                            layer.bringToFront();
                        }*/

            info.update(layer.feature.properties);
        }

        var geojson = void 0;

        function resetHighlight(e) {
            geojson.resetStyle(e.target);
            info.update();
        }

        function zoomToFeature(e) {
            highlightFeature(e);
            map.fitBounds(e.target.getBounds());
        }

        function onEachFeature(feature, layer) {
            layer.on({
                mouseover: highlightFeature,
                mouseout: resetHighlight,
                click: highlightFeature
            });
        }

        geojson = __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.geoJson(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_topojson__["a" /* feature */])(__WEBPACK_IMPORTED_MODULE_4__data_cali_smaller_json___default.a, __WEBPACK_IMPORTED_MODULE_4__data_cali_smaller_json___default.a.objects.cali), {
            style: style,
            onEachFeature: onEachFeature
        }).addTo(map);

        var refinerylayer = __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.geoJson(__WEBPACK_IMPORTED_MODULE_5__data_refineries_json___default.a, {
            style: function style() {
                return {
                    fillOpacity: 0.5,
                    opacity: 1,
                    color: '#000'
                };
            }
        }).addTo(map);

        /*
                map.attributionControl.addAttribution(
                    'Data &copy; <a href="https://oehha.ca.gov/calenviroscreen">Office of Environmental Health Hazard Assessment</a>'
                );*/

        var legend = __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.control({ position: 'bottomleft' });

        legend.onAdd = function (map) {
            var div = __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.DomUtil.create('div', 'info legend');

            var categories = ['0-10', '10-20', '20-30', '30-40', '40-50', '50-60', '60-70', '70-80', '80-90', '90-100'];

            var labels = [];

            div.innerHTML = '<b class="legendHeader">POLLUTION<br>BURDEN</b>';

            for (var i = 0; i < categories.length; i++) {
                // div.innerHTML +=

                labels.push('<i style="background:' + colors[i] + '"></i> ' + (categories[i] ? categories[i] : '+'));
            }

            div.innerHTML += labels.join('<br>');

            div.innerHTML += '<br><br><!--<b class="legendHeader">REFINERIES</b>--><i style="border:2px solid black;background-color:rgb(77, 51, 64);"></i> REFINERY';

            return div;
        };

        legend.addTo(map);

        var marker = new __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.marker([33.772928, -118.261992], { opacity: 0.01 }); //opacity may be set to zero
        marker.bindTooltip('<h4>Wilmington</h4>', {
            permanent: true,
            direction: 'center',
            className: 'my_label',
            offset: [0, 0]
        });
        marker.addTo(map);

        var marker = new __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.marker([33.78339, -118.408621], { opacity: 0.01 }); //opacity may be set to zero
        marker.bindTooltip('<h4>Palos Verdes<br>Peninsula</h4>', {
            permanent: true,
            direction: 'center',
            className: 'my_label',
            offset: [0, 0]
        });
        marker.addTo(map);

        var marker = new __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.marker([33.7445, -118.387], { opacity: 0.01 }); //opacity may be set to zero
        marker.bindTooltip('<h4>Rancho Palos<br>Verdes</h4>', {
            permanent: true,
            className: 'my_label',
            direction: 'center',
            offset: [0, 0]
        });
        marker.addTo(map);

        var marker = new __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.marker([33.835237, -118.258691], { opacity: 0.01 }); //opacity may be set to zero
        marker.bindTooltip('<h4>Carson</h4>', {
            permanent: true,
            className: 'my_label',
            direction: 'center',
            offset: [0, 0]
        });
        marker.addTo(map);
    }
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pairs__ = __webpack_require__(38);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values0, values1, reduce) {
  var n0 = values0.length,
      n1 = values1.length,
      values = new Array(n0 * n1),
      i0,
      i1,
      i,
      value0;

  if (reduce == null) reduce = __WEBPACK_IMPORTED_MODULE_0__pairs__["a" /* pair */];

  for (i0 = i = 0; i0 < n0; ++i0) {
    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
      values[i] = reduce(value0, values1[i1]);
    }
  }

  return values;
});


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisect__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extent__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__range__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ticks__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__ = __webpack_require__(40);









/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */],
      domain = __WEBPACK_IMPORTED_MODULE_3__extent__["a" /* default */],
      threshold = __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__["a" /* default */];

  function histogram(data) {
    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      tz = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__ticks__["c" /* tickStep */])(x0, x1, tz);
      tz = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__range__["a" /* default */])(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) tz.shift(), --m;
    while (tz[m - 1] > x1) tz.pop(), --m;

    var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__bisect__["a" /* default */])(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : value;
  };

  histogram.domain = function(_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["b" /* slice */].call(_)) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : threshold;
  };

  return histogram;
});


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  return max;
});


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(6);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      m = n,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) sum += value;
      else --m;
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) sum += value;
      else --m;
    }
  }

  if (m) return sum / m;
});


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__number__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__quantile__ = __webpack_require__(15);




/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      numbers = [];

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(values[i]))) {
        numbers.push(value);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(valueof(values[i], i, values)))) {
        numbers.push(value);
      }
    }
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__quantile__["a" /* default */])(numbers.sort(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]), 0.5);
});


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(arrays) {
  var n = arrays.length,
      m,
      i = -1,
      j = 0,
      merged,
      array;

  while (++i < n) j += arrays[i].length;
  merged = new Array(j);

  while (--n >= 0) {
    array = arrays[n];
    m = array.length;
    while (--m >= 0) {
      merged[--j] = array[m];
    }
  }

  return merged;
});


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
});


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(5);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, compare) {
  if (!(n = values.length)) return;
  var n,
      i = 0,
      j = 0,
      xi,
      xj = values[j];

  if (compare == null) compare = __WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */];

  while (++i < n) {
    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
      xj = xi, j = i;
    }
  }

  if (compare(xj, xj) === 0) return j;
});


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, i0, i1) {
  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m + i0];
    array[m + i0] = array[i + i0];
    array[i + i0] = t;
  }

  return array;
});


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    }
  }

  else {
    while (++i < n) {
      if (value = +valueof(values[i], i, values)) sum += value;
    }
  }

  return sum;
});


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quantile__ = __webpack_require__(15);





/* unused harmony default export */ var _unused_webpack_default_export = (function(values, min, max) {
  values = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(values, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]).sort(__WEBPACK_IMPORTED_MODULE_1__ascending__["a" /* default */]);
  return Math.ceil((max - min) / (2 * (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.75) - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.25)) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deviation__ = __webpack_require__(35);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, min, max) {
  return Math.ceil((max - min) / (3.5 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__deviation__["a" /* default */])(values) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transpose__ = __webpack_require__(42);


/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__transpose__["a" /* default */])(arguments);
});


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_nest__ = __webpack_require__(101);
/* unused harmony reexport nest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_set__ = __webpack_require__(102);
/* unused harmony reexport set */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_map__ = __webpack_require__(16);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_map__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_keys__ = __webpack_require__(100);
/* unused harmony reexport keys */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_values__ = __webpack_require__(103);
/* unused harmony reexport values */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_entries__ = __webpack_require__(99);
/* unused harmony reexport entries */








/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var entries = [];
  for (var key in map) entries.push({key: key, value: map[key]});
  return entries;
});


/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var keys = [];
  for (var key in map) keys.push(key);
  return keys;
});


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(16);


/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var keys = [],
      sortKeys = [],
      sortValues,
      rollup,
      nest;

  function apply(array, depth, createResult, setResult) {
    if (depth >= keys.length) {
      if (sortValues != null) array.sort(sortValues);
      return rollup != null ? rollup(array) : array;
    }

    var i = -1,
        n = array.length,
        key = keys[depth++],
        keyValue,
        value,
        valuesByKey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])(),
        values,
        result = createResult();

    while (++i < n) {
      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
        values.push(value);
      } else {
        valuesByKey.set(keyValue, [value]);
      }
    }

    valuesByKey.each(function(values, key) {
      setResult(result, key, apply(values, depth, createResult, setResult));
    });

    return result;
  }

  function entries(map, depth) {
    if (++depth > keys.length) return map;
    var array, sortKey = sortKeys[depth - 1];
    if (rollup != null && depth >= keys.length) array = map.entries();
    else array = [], map.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
  }

  return nest = {
    object: function(array) { return apply(array, 0, createObject, setObject); },
    map: function(array) { return apply(array, 0, createMap, setMap); },
    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
    key: function(d) { keys.push(d); return nest; },
    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
    sortValues: function(order) { sortValues = order; return nest; },
    rollup: function(f) { rollup = f; return nest; }
  };
});

function createObject() {
  return {};
}

function setObject(object, key, value) {
  object[key] = value;
}

function createMap() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])();
}

function setMap(map, key, value) {
  map.set(key, value);
}


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(16);


function Set() {}

var proto = __WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */].prototype;

Set.prototype = set.prototype = {
  constructor: Set,
  has: proto.has,
  add: function(value) {
    value += "";
    this[__WEBPACK_IMPORTED_MODULE_0__map__["b" /* prefix */] + value] = value;
    return this;
  },
  remove: proto.remove,
  clear: proto.clear,
  values: proto.keys,
  size: proto.size,
  empty: proto.empty,
  each: proto.each
};

function set(object, f) {
  var set = new Set;

  // Copy constructor.
  if (object instanceof Set) object.each(function(value) { set.add(value); });

  // Otherwise, assume it’s an array.
  else if (object) {
    var i = -1, n = object.length;
    if (f == null) while (++i < n) set.add(object[i]);
    else while (++i < n) set.add(f(object[i], i, object));
  }

  return set;
}

/* unused harmony default export */ var _unused_webpack_default_export = (set);


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var values = [];
  for (var key in map) values.push(map[key]);
  return values;
});


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cubehelix;
/* unused harmony export Cubehelix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(44);




var A = -0.14861,
    B = +1.78277,
    C = -0.29227,
    D = -0.90649,
    E = +1.97294,
    ED = E * D,
    EB = E * B,
    BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["a" /* Rgb */])) o = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["b" /* rgbConvert */])(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* rad2deg */] - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Cubehelix, cubehelix, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* Color */], {
  brighter: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["d" /* brighter */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["d" /* brighter */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["e" /* darker */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["e" /* darker */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* deg2rad */],
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["a" /* Rgb */](
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + D * sinh)),
      255 * (l + a * (E * cosh)),
      this.opacity
    );
  }
}));


/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = lab;
/* unused harmony export Lab */
/* harmony export (immutable) */ __webpack_exports__["a"] = hcl;
/* unused harmony export Hcl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(44);




var Kn = 18,
    Xn = 0.950470, // D65 standard referent
    Yn = 1,
    Zn = 1.088830,
    t0 = 4 / 29,
    t1 = 6 / 29,
    t2 = 3 * t1 * t1,
    t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) {
    var h = o.h * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* deg2rad */];
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
  }
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["a" /* Rgb */])) o = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["b" /* rgbConvert */])(o);
  var b = rgb2xyz(o.r),
      a = rgb2xyz(o.g),
      l = rgb2xyz(o.b),
      x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
      y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
      z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Lab, lab, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* Color */], {
  brighter: function(k) {
    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    y = Yn * lab2xyz(y);
    x = Xn * lab2xyz(x);
    z = Zn * lab2xyz(z);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["a" /* Rgb */](
      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
      this.opacity
    );
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function xyz2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2xyz(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  var h = Math.atan2(o.b, o.a) * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* rad2deg */];
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hcl, hcl, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* Color */], {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return labConvert(this).rgb();
  }
}));


/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatPrefix; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(49);


var locale;
var format;
var formatPrefix;

defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale(definition) {
  locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  x = x.toPrecision(p);

  out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (x[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      case "e": break out;
      default: if (i0 > 0) i0 = 0; break;
    }
  }

  return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
});


/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
});


/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
});


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(19);


/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
});


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(11);


/* harmony default export */ __webpack_exports__["a"] = (function(step) {
  return Math.max(0, -__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(11);


/* harmony default export */ __webpack_exports__["a"] = (function(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3 - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(11);


/* harmony default export */ __webpack_exports__["a"] = (function(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(max) - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(step)) + 1;
});


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cubehelixLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(8);



function cubehelix(hue) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(start)).h, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(end)).h),
          s = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
          l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
          opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix.gamma = cubehelixGamma;

    return cubehelix;
  })(1);
}

/* unused harmony default export */ var _unused_webpack_default_export = (cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["b" /* hue */]));
var cubehelixLong = cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(8);



function hcl(hue) {
  return function(start, end) {
    var h = hue((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* hcl */])(start)).h, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* hcl */])(end)).h),
        c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.c, end.c),
        l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (hcl(__WEBPACK_IMPORTED_MODULE_1__color__["b" /* hue */]));
var hclLong = hcl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(8);



function hsl(hue) {
  return function(start, end) {
    var h = hue((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(start)).h, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(end)).h),
        s = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
        l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (hsl(__WEBPACK_IMPORTED_MODULE_1__color__["b" /* hue */]));
var hslLong = hsl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(8);



function lab(start, end) {
  var l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* lab */])(start)).l, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* lab */])(end)).l),
      a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.a, end.a),
      b = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.b, end.b),
      opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
  return function(t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
});


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return Math.round(a + b * t);
  };
});


/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return identity; });
var degrees = 180 / Math.PI;

var identity = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

/* harmony default export */ __webpack_exports__["b"] = (function(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
});


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export interpolateTransformCss */
/* unused harmony export interpolateTransformSvg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse__ = __webpack_require__(123);



function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["a" /* parseCss */], "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["b" /* parseSvg */], ", ", ")", ")");


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseCss;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseSvg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decompose__ = __webpack_require__(121);


var cssNode,
    cssRoot,
    cssView,
    svgNode;

function parseCss(value) {
  if (value === "none") return __WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* identity */];
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* default */])(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return __WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* identity */];
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return __WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* identity */];
  value = value.matrix;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* default */])(value.a, value.b, value.c, value.d, value.e, value.f);
}


/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rho = Math.SQRT2,
    rho2 = 2,
    rho4 = 4,
    epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
/* unused harmony default export */ var _unused_webpack_default_export = (function(p0, p1) {
  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

  // Special case for u0 ≅ u1.
  if (d2 < epsilon2) {
    S = Math.log(w1 / w0) / rho;
    i = function(t) {
      return [
        ux0 + t * dx,
        uy0 + t * dy,
        w0 * Math.exp(rho * t * S)
      ];
    }
  }

  // General case.
  else {
    var d1 = Math.sqrt(d2),
        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    S = (r1 - r0) / rho;
    i = function(t) {
      var s = t * S,
          coshr0 = cosh(r0),
          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
      return [
        ux0 + u * dx,
        uy0 + u * dy,
        w0 * coshr0 / cosh(rho * s + r0)
      ];
    }
  }

  i.duration = S * 1000;

  return i;
});


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_band__ = __webpack_require__(126);
/* unused harmony reexport scaleBand */
/* unused harmony reexport scalePoint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_identity__ = __webpack_require__(132);
/* unused harmony reexport scaleIdentity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_linear__ = __webpack_require__(10);
/* unused harmony reexport scaleLinear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_log__ = __webpack_require__(133);
/* unused harmony reexport scaleLog */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_ordinal__ = __webpack_require__(59);
/* unused harmony reexport scaleOrdinal */
/* unused harmony reexport scaleImplicit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_pow__ = __webpack_require__(134);
/* unused harmony reexport scalePow */
/* unused harmony reexport scaleSqrt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_quantile__ = __webpack_require__(135);
/* unused harmony reexport scaleQuantile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_quantize__ = __webpack_require__(136);
/* unused harmony reexport scaleQuantize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_threshold__ = __webpack_require__(139);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_8__src_threshold__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_time__ = __webpack_require__(60);
/* unused harmony reexport scaleTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_utcTime__ = __webpack_require__(141);
/* unused harmony reexport scaleUtc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_category10__ = __webpack_require__(127);
/* unused harmony reexport schemeCategory10 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_category20b__ = __webpack_require__(129);
/* unused harmony reexport schemeCategory20b */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_category20c__ = __webpack_require__(130);
/* unused harmony reexport schemeCategory20c */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_category20__ = __webpack_require__(128);
/* unused harmony reexport schemeCategory20 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(131);
/* unused harmony reexport interpolateCubehelixDefault */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_rainbow__ = __webpack_require__(137);
/* unused harmony reexport interpolateRainbow */
/* unused harmony reexport interpolateWarm */
/* unused harmony reexport interpolateCool */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_viridis__ = __webpack_require__(142);
/* unused harmony reexport interpolateViridis */
/* unused harmony reexport interpolateMagma */
/* unused harmony reexport interpolateInferno */
/* unused harmony reexport interpolatePlasma */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_sequential__ = __webpack_require__(138);
/* unused harmony reexport scaleSequential */







































/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export point */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ordinal__ = __webpack_require__(59);



function band() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ordinal__["a" /* default */])().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      range = [0, 1],
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = range[1] < range[0],
        start = range[reverse - 0],
        stop = range[1 - reverse];
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["h" /* range */])(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = [+_[0], +_[1]], round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band()
        .domain(domain())
        .range(range)
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return rescale();
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function() {
    return pointish(copy());
  };

  return scale;
}

function point() {
  return pointish(band().paddingInner(1));
}


/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(9);


/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"));


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(9);


/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5"));


/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(9);


/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6"));


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(9);


/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9"));


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(7);



/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["d" /* interpolateCubehelixLong */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(300, 0.5, 0.0), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(-240, 0.5, 1.0)));


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(58);




function identity() {
  var domain = [0, 1];

  function scale(x) {
    return +x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]), scale) : domain.slice();
  };

  scale.copy = function() {
    return identity().domain(domain);
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__linear__["a" /* linearish */])(scale);
}


/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nice__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__continuous__ = __webpack_require__(13);






function deinterpolate(a, b) {
  return (b = Math.log(b / a))
      ? function(x) { return Math.log(x / a) / b; }
      : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(b);
}

function reinterpolate(a, b) {
  return a < 0
      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10
      : base === Math.E ? Math.exp
      : function(x) { return Math.pow(base, x); };
}

function logp(base) {
  return base === Math.E ? Math.log
      : base === 10 && Math.log10
      || base === 2 && Math.log2
      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
}

function reflect(f) {
  return function(x) {
    return -f(-x);
  };
}

function log() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__continuous__["a" /* default */])(deinterpolate, reinterpolate).domain([1, 10]),
      domain = scale.domain,
      base = 10,
      logs = logp(10),
      pows = powp(10);

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
    return scale;
  }

  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function(count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.round(i) - 1, j = Math.round(j) + 1;
      if (u > 0) for (; i < j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i < j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
    } else {
      z = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["a" /* ticks */])(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function(count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f" /* format */])(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function(d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function() {
    return domain(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__nice__["a" /* default */])(domain(), {
      floor: function(x) { return pows(Math.floor(logs(x))); },
      ceil: function(x) { return pows(Math.ceil(logs(x))); }
    }));
  };

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__continuous__["c" /* copy */])(scale, log().base(base));
  };

  return scale;
}


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export sqrt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(13);




function raise(x, exponent) {
  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
}

function pow() {
  var exponent = 1,
      scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* default */])(deinterpolate, reinterpolate),
      domain = scale.domain;

  function deinterpolate(a, b) {
    return (b = raise(b, exponent) - (a = raise(a, exponent)))
        ? function(x) { return (raise(x, exponent) - a) / b; }
        : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(b);
  }

  function reinterpolate(a, b) {
    b = raise(b, exponent) - (a = raise(a, exponent));
    return function(t) { return raise(a + b * t, 1 / exponent); };
  }

  scale.exponent = function(_) {
    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
  };

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__continuous__["c" /* copy */])(scale, pow().exponent(exponent));
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__linear__["a" /* linearish */])(scale);
}

function sqrt() {
  return pow().exponent(0.5);
}


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(4);



function quantile() {
  var domain = [],
      range = [],
      thresholds = [];

  function rescale() {
    var i = 0, n = Math.max(1, range.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["f" /* quantile */])(domain, i / n);
    return scale;
  }

  function scale(x) {
    if (!isNaN(x = +x)) return range[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* bisect */])(thresholds, x)];
  }

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain[0],
      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
    ];
  };

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(__WEBPACK_IMPORTED_MODULE_0_d3_array__["g" /* ascending */]);
    return rescale();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.quantiles = function() {
    return thresholds.slice();
  };

  scale.copy = function() {
    return quantile()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__(10);




function quantize() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range = [0, 1];

  function scale(x) {
    if (x <= x) return range[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* bisect */])(domain, x, 0, n)];
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale;
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
  };

  scale.range = function(_) {
    return arguments.length ? (n = (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_)).length - 1, rescale()) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN]
        : i < 1 ? [x0, domain[0]]
        : i >= n ? [domain[n - 1], x1]
        : [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return quantize()
        .domain([x0, x1])
        .range(range);
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__linear__["a" /* linearish */])(scale);
}


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export warm */
/* unused harmony export cool */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(7);



var warm = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["d" /* interpolateCubehelixLong */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(-100, 0.75, 0.35), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(80, 1.50, 0.8));

var cool = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["d" /* interpolateCubehelixLong */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(260, 0.75, 0.35), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(80, 1.50, 0.8));

var rainbow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])();

/* unused harmony default export */ var _unused_webpack_default_export = (function(t) {
  if (t < 0 || t > 1) t -= Math.floor(t);
  var ts = Math.abs(t - 0.5);
  rainbow.h = 360 * t - 100;
  rainbow.s = 1.5 - 1.5 * ts;
  rainbow.l = 0.8 - 0.9 * ts;
  return rainbow + "";
});


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(10);


function sequential(interpolator) {
  var x0 = 0,
      x1 = 1,
      clamp = false;

  function scale(x) {
    var t = (x - x0) / (x1 - x0);
    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.copy = function() {
    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__linear__["a" /* linearish */])(scale);
}


/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = threshold;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(4);



function threshold() {
  var domain = [0.5],
      range = [0, 1],
      n = 1;

  function scale(x) {
    if (x <= x) return range[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* bisect */])(domain, x, 0, n)];
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return threshold()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(45);



/* harmony default export */ __webpack_exports__["a"] = (function(domain, count, specifier) {
  var start = domain[0],
      stop = domain[domain.length - 1],
      step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["d" /* tickStep */])(start, stop, count == null ? 10 : count),
      precision;
  specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* formatSpecifier */])(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["b" /* precisionPrefix */])(step, value))) specifier.precision = precision;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["c" /* formatPrefix */])(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["d" /* precisionRound */])(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["e" /* precisionFixed */])(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f" /* format */])(specifier);
});


/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__time__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_time_format__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(24);




/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__time__["a" /* calendar */])(__WEBPACK_IMPORTED_MODULE_2_d3_time__["a" /* utcYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["b" /* utcMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["c" /* utcWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["d" /* utcDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["e" /* utcHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["f" /* utcMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["g" /* utcSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["h" /* utcMillisecond */], __WEBPACK_IMPORTED_MODULE_1_d3_time_format__["a" /* utcFormat */]).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
});


/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export magma */
/* unused harmony export inferno */
/* unused harmony export plasma */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(9);


function ramp(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (ramp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725")));

var magma = ramp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));

var inferno = ramp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));

var plasma = ramp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isoFormat__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultLocale__ = __webpack_require__(23);



function parseIsoNative(string) {
  var date = new Date(string);
  return isNaN(date) ? null : date;
}

var parseIso = +new Date("2000-01-01T00:00:00.000Z")
    ? parseIsoNative
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__defaultLocale__["b" /* utcParse */])(__WEBPACK_IMPORTED_MODULE_0__isoFormat__["a" /* isoSpecifier */]);

/* unused harmony default export */ var _unused_webpack_default_export = (parseIso);


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export days */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(2);



var day = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setDate(date.getDate() + step);
}, function(start, end) {
  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationDay */];
}, function(date) {
  return date.getDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (day);
var days = day.range;


/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(2);



var hour = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  var offset = date.getTimezoneOffset() * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */] % __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */];
  if (offset < 0) offset += __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */];
  date.setTime(Math.floor((+date - offset) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */] + offset);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */];
}, function(date) {
  return date.getHours();
});

/* harmony default export */ __webpack_exports__["a"] = (hour);
var hours = hour.range;


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export milliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);


var millisecond = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

/* harmony default export */ __webpack_exports__["a"] = (millisecond);
var milliseconds = millisecond.range;


/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export minutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(2);



var minute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setTime(Math.floor(date / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */];
}, function(date) {
  return date.getMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (minute);
var minutes = minute.range;


/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export months */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);


var month = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (month);
var months = month.range;


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export seconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(2);



var second = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setTime(Math.floor(date / __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationSecond */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationSecond */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationSecond */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationSecond */];
}, function(date) {
  return date.getUTCSeconds();
});

/* harmony default export */ __webpack_exports__["a"] = (second);
var seconds = second.range;


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(2);



var utcDay = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationDay */];
}, function(date) {
  return date.getUTCDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (utcDay);
var utcDays = utcDay.range;


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(2);



var utcHour = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */];
}, function(date) {
  return date.getUTCHours();
});

/* harmony default export */ __webpack_exports__["a"] = (utcHour);
var utcHours = utcHour.range;


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(2);



var utcMinute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */];
}, function(date) {
  return date.getUTCMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMinute);
var utcMinutes = utcMinute.range;


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);


var utcMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMonth);
var utcMonths = utcMonth.range;


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return utcSunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcMonday; });
/* unused harmony export utcTuesday */
/* unused harmony export utcWednesday */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return utcThursday; });
/* unused harmony export utcFriday */
/* unused harmony export utcSaturday */
/* unused harmony export utcSundays */
/* unused harmony export utcMondays */
/* unused harmony export utcTuesdays */
/* unused harmony export utcWednesdays */
/* unused harmony export utcThursdays */
/* unused harmony export utcFridays */
/* unused harmony export utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(2);



function utcWeekday(i) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" /* durationWeek */];
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);

var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);


var utcYear = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (utcYear);
var utcYears = utcYear.range;


/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return monday; });
/* unused harmony export tuesday */
/* unused harmony export wednesday */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return thursday; });
/* unused harmony export friday */
/* unused harmony export saturday */
/* unused harmony export sundays */
/* unused harmony export mondays */
/* unused harmony export tuesdays */
/* unused harmony export wednesdays */
/* unused harmony export thursdays */
/* unused harmony export fridays */
/* unused harmony export saturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(2);



function weekday(i) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" /* durationWeek */];
  });
}

var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export years */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);


var year = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (year);
var years = year.range;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {var require;/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   4.1.1
 */

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}

var _isArray = undefined;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = undefined;
var customSchedulerFn = undefined;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && ({}).toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var r = require;
    var vertx = __webpack_require__(198);
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = undefined;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && "function" === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var _arguments = arguments;

  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;

  if (_state) {
    (function () {
      var callback = _arguments[_state - 1];
      asap(function () {
        return invokeCallback(_state, child, callback, parent._result);
      });
    })();
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(16);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var GET_THEN_ERROR = new ErrorObject();

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    GET_THEN_ERROR.error = error;
    return GET_THEN_ERROR;
  }
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === GET_THEN_ERROR) {
      reject(promise, GET_THEN_ERROR.error);
      GET_THEN_ERROR.error = null;
    } else if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;

  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = undefined,
      callback = undefined,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function ErrorObject() {
  this.error = null;
}

var TRY_CATCH_ERROR = new ErrorObject();

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = undefined,
      error = undefined,
      succeeded = undefined,
      failed = undefined;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value.error = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
      resolve(promise, value);
    } else if (failed) {
      reject(promise, error);
    } else if (settled === FULFILLED) {
      fulfill(promise, value);
    } else if (settled === REJECTED) {
      reject(promise, value);
    }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function Enumerator$1(Constructor, input) {
  this._instanceConstructor = Constructor;
  this.promise = new Constructor(noop);

  if (!this.promise[PROMISE_ID]) {
    makePromise(this.promise);
  }

  if (isArray(input)) {
    this.length = input.length;
    this._remaining = input.length;

    this._result = new Array(this.length);

    if (this.length === 0) {
      fulfill(this.promise, this._result);
    } else {
      this.length = this.length || 0;
      this._enumerate(input);
      if (this._remaining === 0) {
        fulfill(this.promise, this._result);
      }
    }
  } else {
    reject(this.promise, validationError());
  }
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

Enumerator$1.prototype._enumerate = function (input) {
  for (var i = 0; this._state === PENDING && i < input.length; i++) {
    this._eachEntry(input[i], i);
  }
};

Enumerator$1.prototype._eachEntry = function (entry, i) {
  var c = this._instanceConstructor;
  var resolve$$1 = c.resolve;

  if (resolve$$1 === resolve$1) {
    var _then = getThen(entry);

    if (_then === then && entry._state !== PENDING) {
      this._settledAt(entry._state, i, entry._result);
    } else if (typeof _then !== 'function') {
      this._remaining--;
      this._result[i] = entry;
    } else if (c === Promise$2) {
      var promise = new c(noop);
      handleMaybeThenable(promise, entry, _then);
      this._willSettleAt(promise, i);
    } else {
      this._willSettleAt(new c(function (resolve$$1) {
        return resolve$$1(entry);
      }), i);
    }
  } else {
    this._willSettleAt(resolve$$1(entry), i);
  }
};

Enumerator$1.prototype._settledAt = function (state, i, value) {
  var promise = this.promise;

  if (promise._state === PENDING) {
    this._remaining--;

    if (state === REJECTED) {
      reject(promise, value);
    } else {
      this._result[i] = value;
    }
  }

  if (this._remaining === 0) {
    fulfill(promise, this._result);
  }
};

Enumerator$1.prototype._willSettleAt = function (promise, i) {
  var enumerator = this;

  subscribe(promise, undefined, function (value) {
    return enumerator._settledAt(FULFILLED, i, value);
  }, function (reason) {
    return enumerator._settledAt(REJECTED, i, reason);
  });
};

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all$1(entries) {
  return new Enumerator$1(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race$1(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {function} resolver
  Useful for tooling.
  @constructor
*/
function Promise$2(resolver) {
  this[PROMISE_ID] = nextId();
  this._result = this._state = undefined;
  this._subscribers = [];

  if (noop !== resolver) {
    typeof resolver !== 'function' && needsResolver();
    this instanceof Promise$2 ? initializePromise(this, resolver) : needsNew();
  }
}

Promise$2.all = all$1;
Promise$2.race = race$1;
Promise$2.resolve = resolve$1;
Promise$2.reject = reject$1;
Promise$2._setScheduler = setScheduler;
Promise$2._setAsap = setAsap;
Promise$2._asap = asap;

Promise$2.prototype = {
  constructor: Promise$2,

  /**
    The primary way of interacting with a promise is through its `then` method,
    which registers callbacks to receive either a promise's eventual value or the
    reason why the promise cannot be fulfilled.
  
    ```js
    findUser().then(function(user){
      // user is available
    }, function(reason){
      // user is unavailable, and you are given the reason why
    });
    ```
  
    Chaining
    --------
  
    The return value of `then` is itself a promise.  This second, 'downstream'
    promise is resolved with the return value of the first promise's fulfillment
    or rejection handler, or rejected if the handler throws an exception.
  
    ```js
    findUser().then(function (user) {
      return user.name;
    }, function (reason) {
      return 'default name';
    }).then(function (userName) {
      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
      // will be `'default name'`
    });
  
    findUser().then(function (user) {
      throw new Error('Found user, but still unhappy');
    }, function (reason) {
      throw new Error('`findUser` rejected and we're unhappy');
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
    });
    ```
    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
  
    ```js
    findUser().then(function (user) {
      throw new PedagogicalException('Upstream error');
    }).then(function (value) {
      // never reached
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // The `PedgagocialException` is propagated all the way down to here
    });
    ```
  
    Assimilation
    ------------
  
    Sometimes the value you want to propagate to a downstream promise can only be
    retrieved asynchronously. This can be achieved by returning a promise in the
    fulfillment or rejection handler. The downstream promise will then be pending
    until the returned promise is settled. This is called *assimilation*.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // The user's comments are now available
    });
    ```
  
    If the assimliated promise rejects, then the downstream promise will also reject.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // If `findCommentsByAuthor` fulfills, we'll have the value here
    }, function (reason) {
      // If `findCommentsByAuthor` rejects, we'll have the reason here
    });
    ```
  
    Simple Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let result;
  
    try {
      result = findResult();
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
    findResult(function(result, err){
      if (err) {
        // failure
      } else {
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findResult().then(function(result){
      // success
    }, function(reason){
      // failure
    });
    ```
  
    Advanced Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let author, books;
  
    try {
      author = findAuthor();
      books  = findBooksByAuthor(author);
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
  
    function foundBooks(books) {
  
    }
  
    function failure(reason) {
  
    }
  
    findAuthor(function(author, err){
      if (err) {
        failure(err);
        // failure
      } else {
        try {
          findBoooksByAuthor(author, function(books, err) {
            if (err) {
              failure(err);
            } else {
              try {
                foundBooks(books);
              } catch(reason) {
                failure(reason);
              }
            }
          });
        } catch(error) {
          failure(err);
        }
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findAuthor().
      then(findBooksByAuthor).
      then(function(books){
        // found books
    }).catch(function(reason){
      // something went wrong
    });
    ```
  
    @method then
    @param {Function} onFulfilled
    @param {Function} onRejected
    Useful for tooling.
    @return {Promise}
  */
  then: then,

  /**
    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
    as the catch block of a try/catch statement.
  
    ```js
    function findAuthor(){
      throw new Error('couldn't find that author');
    }
  
    // synchronous
    try {
      findAuthor();
    } catch(reason) {
      // something went wrong
    }
  
    // async with promises
    findAuthor().catch(function(reason){
      // something went wrong
    });
    ```
  
    @method catch
    @param {Function} onRejection
    Useful for tooling.
    @return {Promise}
  */
  'catch': function _catch(onRejection) {
    return this.then(null, onRejection);
  }
};

/*global self*/
function polyfill$1() {
    var local = undefined;

    if (typeof global !== 'undefined') {
        local = global;
    } else if (typeof self !== 'undefined') {
        local = self;
    } else {
        try {
            local = Function('return this')();
        } catch (e) {
            throw new Error('polyfill failed because global object is unavailable in this environment');
        }
    }

    var P = local.Promise;

    if (P) {
        var promiseToString = null;
        try {
            promiseToString = Object.prototype.toString.call(P.resolve());
        } catch (e) {
            // silently ignored
        }

        if (promiseToString === '[object Promise]' && !P.cast) {
            return;
        }
    }

    local.Promise = Promise$2;
}

// Strange compat..
Promise$2.polyfill = polyfill$1;
Promise$2.Promise = Promise$2;

return Promise$2;

})));

//# sourceMappingURL=es6-promise.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64), __webpack_require__(30)))

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

/* @preserve
 * Leaflet 1.2.0, a JS library for interactive maps. http://leafletjs.com
 * (c) 2010-2017 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */
(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.L = {})));
}(this, (function (exports) { 'use strict';

var version = "1.2.0";

/*
 * @namespace Util
 *
 * Various utility functions, used by Leaflet internally.
 */

var freeze = Object.freeze;
Object.freeze = function (obj) { return obj; };

// @function extend(dest: Object, src?: Object): Object
// Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
function extend(dest) {
	var i, j, len, src;

	for (j = 1, len = arguments.length; j < len; j++) {
		src = arguments[j];
		for (i in src) {
			dest[i] = src[i];
		}
	}
	return dest;
}

// @function create(proto: Object, properties?: Object): Object
// Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
var create = Object.create || (function () {
	function F() {}
	return function (proto) {
		F.prototype = proto;
		return new F();
	};
})();

// @function bind(fn: Function, …): Function
// Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
// Has a `L.bind()` shortcut.
function bind(fn, obj) {
	var slice = Array.prototype.slice;

	if (fn.bind) {
		return fn.bind.apply(fn, slice.call(arguments, 1));
	}

	var args = slice.call(arguments, 2);

	return function () {
		return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
	};
}

// @property lastId: Number
// Last unique ID used by [`stamp()`](#util-stamp)
var lastId = 0;

// @function stamp(obj: Object): Number
// Returns the unique ID of an object, assiging it one if it doesn't have it.
function stamp(obj) {
	/*eslint-disable */
	obj._leaflet_id = obj._leaflet_id || ++lastId;
	return obj._leaflet_id;
	/*eslint-enable */
}

// @function throttle(fn: Function, time: Number, context: Object): Function
// Returns a function which executes function `fn` with the given scope `context`
// (so that the `this` keyword refers to `context` inside `fn`'s code). The function
// `fn` will be called no more than one time per given amount of `time`. The arguments
// received by the bound function will be any arguments passed when binding the
// function, followed by any arguments passed when invoking the bound function.
// Has an `L.throttle` shortcut.
function throttle(fn, time, context) {
	var lock, args, wrapperFn, later;

	later = function () {
		// reset lock and call if queued
		lock = false;
		if (args) {
			wrapperFn.apply(context, args);
			args = false;
		}
	};

	wrapperFn = function () {
		if (lock) {
			// called too soon, queue to call later
			args = arguments;

		} else {
			// call and lock until later
			fn.apply(context, arguments);
			setTimeout(later, time);
			lock = true;
		}
	};

	return wrapperFn;
}

// @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
// Returns the number `num` modulo `range` in such a way so it lies within
// `range[0]` and `range[1]`. The returned value will be always smaller than
// `range[1]` unless `includeMax` is set to `true`.
function wrapNum(x, range, includeMax) {
	var max = range[1],
	    min = range[0],
	    d = max - min;
	return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
}

// @function falseFn(): Function
// Returns a function which always returns `false`.
function falseFn() { return false; }

// @function formatNum(num: Number, digits?: Number): Number
// Returns the number `num` rounded to `digits` decimals, or to 5 decimals by default.
function formatNum(num, digits) {
	var pow = Math.pow(10, digits || 5);
	return Math.round(num * pow) / pow;
}

// @function trim(str: String): String
// Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
function trim(str) {
	return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

// @function splitWords(str: String): String[]
// Trims and splits the string on whitespace and returns the array of parts.
function splitWords(str) {
	return trim(str).split(/\s+/);
}

// @function setOptions(obj: Object, options: Object): Object
// Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
function setOptions(obj, options) {
	if (!obj.hasOwnProperty('options')) {
		obj.options = obj.options ? create(obj.options) : {};
	}
	for (var i in options) {
		obj.options[i] = options[i];
	}
	return obj.options;
}

// @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
// Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
// translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
// be appended at the end. If `uppercase` is `true`, the parameter names will
// be uppercased (e.g. `'?A=foo&B=bar'`)
function getParamString(obj, existingUrl, uppercase) {
	var params = [];
	for (var i in obj) {
		params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
	}
	return ((!existingUrl || existingUrl.indexOf('?') === -1) ? '?' : '&') + params.join('&');
}

var templateRe = /\{ *([\w_\-]+) *\}/g;

// @function template(str: String, data: Object): String
// Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
// and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
// `('Hello foo, bar')`. You can also specify functions instead of strings for
// data values — they will be evaluated passing `data` as an argument.
function template(str, data) {
	return str.replace(templateRe, function (str, key) {
		var value = data[key];

		if (value === undefined) {
			throw new Error('No value provided for variable ' + str);

		} else if (typeof value === 'function') {
			value = value(data);
		}
		return value;
	});
}

// @function isArray(obj): Boolean
// Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
var isArray = Array.isArray || function (obj) {
	return (Object.prototype.toString.call(obj) === '[object Array]');
};

// @function indexOf(array: Array, el: Object): Number
// Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
function indexOf(array, el) {
	for (var i = 0; i < array.length; i++) {
		if (array[i] === el) { return i; }
	}
	return -1;
}

// @property emptyImageUrl: String
// Data URI string containing a base64-encoded empty GIF image.
// Used as a hack to free memory from unused images on WebKit-powered
// mobile devices (by setting image `src` to this string).
var emptyImageUrl = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';

// inspired by http://paulirish.com/2011/requestanimationframe-for-smart-animating/

function getPrefixed(name) {
	return window['webkit' + name] || window['moz' + name] || window['ms' + name];
}

var lastTime = 0;

// fallback for IE 7-8
function timeoutDefer(fn) {
	var time = +new Date(),
	    timeToCall = Math.max(0, 16 - (time - lastTime));

	lastTime = time + timeToCall;
	return window.setTimeout(fn, timeToCall);
}

var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer;
var cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') ||
		getPrefixed('CancelRequestAnimationFrame') || function (id) { window.clearTimeout(id); };

// @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
// Schedules `fn` to be executed when the browser repaints. `fn` is bound to
// `context` if given. When `immediate` is set, `fn` is called immediately if
// the browser doesn't have native support for
// [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
// otherwise it's delayed. Returns a request ID that can be used to cancel the request.
function requestAnimFrame(fn, context, immediate) {
	if (immediate && requestFn === timeoutDefer) {
		fn.call(context);
	} else {
		return requestFn.call(window, bind(fn, context));
	}
}

// @function cancelAnimFrame(id: Number): undefined
// Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
function cancelAnimFrame(id) {
	if (id) {
		cancelFn.call(window, id);
	}
}


var Util = (Object.freeze || Object)({
	freeze: freeze,
	extend: extend,
	create: create,
	bind: bind,
	lastId: lastId,
	stamp: stamp,
	throttle: throttle,
	wrapNum: wrapNum,
	falseFn: falseFn,
	formatNum: formatNum,
	trim: trim,
	splitWords: splitWords,
	setOptions: setOptions,
	getParamString: getParamString,
	template: template,
	isArray: isArray,
	indexOf: indexOf,
	emptyImageUrl: emptyImageUrl,
	requestFn: requestFn,
	cancelFn: cancelFn,
	requestAnimFrame: requestAnimFrame,
	cancelAnimFrame: cancelAnimFrame
});

// @class Class
// @aka L.Class

// @section
// @uninheritable

// Thanks to John Resig and Dean Edwards for inspiration!

function Class() {}

Class.extend = function (props) {

	// @function extend(props: Object): Function
	// [Extends the current class](#class-inheritance) given the properties to be included.
	// Returns a Javascript function that is a class constructor (to be called with `new`).
	var NewClass = function () {

		// call the constructor
		if (this.initialize) {
			this.initialize.apply(this, arguments);
		}

		// call all constructor hooks
		this.callInitHooks();
	};

	var parentProto = NewClass.__super__ = this.prototype;

	var proto = create(parentProto);
	proto.constructor = NewClass;

	NewClass.prototype = proto;

	// inherit parent's statics
	for (var i in this) {
		if (this.hasOwnProperty(i) && i !== 'prototype' && i !== '__super__') {
			NewClass[i] = this[i];
		}
	}

	// mix static properties into the class
	if (props.statics) {
		extend(NewClass, props.statics);
		delete props.statics;
	}

	// mix includes into the prototype
	if (props.includes) {
		checkDeprecatedMixinEvents(props.includes);
		extend.apply(null, [proto].concat(props.includes));
		delete props.includes;
	}

	// merge options
	if (proto.options) {
		props.options = extend(create(proto.options), props.options);
	}

	// mix given properties into the prototype
	extend(proto, props);

	proto._initHooks = [];

	// add method for calling all hooks
	proto.callInitHooks = function () {

		if (this._initHooksCalled) { return; }

		if (parentProto.callInitHooks) {
			parentProto.callInitHooks.call(this);
		}

		this._initHooksCalled = true;

		for (var i = 0, len = proto._initHooks.length; i < len; i++) {
			proto._initHooks[i].call(this);
		}
	};

	return NewClass;
};


// @function include(properties: Object): this
// [Includes a mixin](#class-includes) into the current class.
Class.include = function (props) {
	extend(this.prototype, props);
	return this;
};

// @function mergeOptions(options: Object): this
// [Merges `options`](#class-options) into the defaults of the class.
Class.mergeOptions = function (options) {
	extend(this.prototype.options, options);
	return this;
};

// @function addInitHook(fn: Function): this
// Adds a [constructor hook](#class-constructor-hooks) to the class.
Class.addInitHook = function (fn) { // (Function) || (String, args...)
	var args = Array.prototype.slice.call(arguments, 1);

	var init = typeof fn === 'function' ? fn : function () {
		this[fn].apply(this, args);
	};

	this.prototype._initHooks = this.prototype._initHooks || [];
	this.prototype._initHooks.push(init);
	return this;
};

function checkDeprecatedMixinEvents(includes) {
	if (!L || !L.Mixin) { return; }

	includes = isArray(includes) ? includes : [includes];

	for (var i = 0; i < includes.length; i++) {
		if (includes[i] === L.Mixin.Events) {
			console.warn('Deprecated include of L.Mixin.Events: ' +
				'this property will be removed in future releases, ' +
				'please inherit from L.Evented instead.', new Error().stack);
		}
	}
}

/*
 * @class Evented
 * @aka L.Evented
 * @inherits Class
 *
 * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
 *
 * @example
 *
 * ```js
 * map.on('click', function(e) {
 * 	alert(e.latlng);
 * } );
 * ```
 *
 * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
 *
 * ```js
 * function onClick(e) { ... }
 *
 * map.on('click', onClick);
 * map.off('click', onClick);
 * ```
 */

var Events = {
	/* @method on(type: String, fn: Function, context?: Object): this
	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
	 *
	 * @alternative
	 * @method on(eventMap: Object): this
	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
	 */
	on: function (types, fn, context) {

		// types can be a map of types/handlers
		if (typeof types === 'object') {
			for (var type in types) {
				// we don't process space-separated events here for performance;
				// it's a hot path since Layer uses the on(obj) syntax
				this._on(type, types[type], fn);
			}

		} else {
			// types can be a string of space-separated words
			types = splitWords(types);

			for (var i = 0, len = types.length; i < len; i++) {
				this._on(types[i], fn, context);
			}
		}

		return this;
	},

	/* @method off(type: String, fn?: Function, context?: Object): this
	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
	 *
	 * @alternative
	 * @method off(eventMap: Object): this
	 * Removes a set of type/listener pairs.
	 *
	 * @alternative
	 * @method off: this
	 * Removes all listeners to all events on the object.
	 */
	off: function (types, fn, context) {

		if (!types) {
			// clear all listeners if called without arguments
			delete this._events;

		} else if (typeof types === 'object') {
			for (var type in types) {
				this._off(type, types[type], fn);
			}

		} else {
			types = splitWords(types);

			for (var i = 0, len = types.length; i < len; i++) {
				this._off(types[i], fn, context);
			}
		}

		return this;
	},

	// attach listener (without syntactic sugar now)
	_on: function (type, fn, context) {
		this._events = this._events || {};

		/* get/init listeners for type */
		var typeListeners = this._events[type];
		if (!typeListeners) {
			typeListeners = [];
			this._events[type] = typeListeners;
		}

		if (context === this) {
			// Less memory footprint.
			context = undefined;
		}
		var newListener = {fn: fn, ctx: context},
		    listeners = typeListeners;

		// check if fn already there
		for (var i = 0, len = listeners.length; i < len; i++) {
			if (listeners[i].fn === fn && listeners[i].ctx === context) {
				return;
			}
		}

		listeners.push(newListener);
	},

	_off: function (type, fn, context) {
		var listeners,
		    i,
		    len;

		if (!this._events) { return; }

		listeners = this._events[type];

		if (!listeners) {
			return;
		}

		if (!fn) {
			// Set all removed listeners to noop so they are not called if remove happens in fire
			for (i = 0, len = listeners.length; i < len; i++) {
				listeners[i].fn = falseFn;
			}
			// clear all listeners for a type if function isn't specified
			delete this._events[type];
			return;
		}

		if (context === this) {
			context = undefined;
		}

		if (listeners) {

			// find fn and remove it
			for (i = 0, len = listeners.length; i < len; i++) {
				var l = listeners[i];
				if (l.ctx !== context) { continue; }
				if (l.fn === fn) {

					// set the removed listener to noop so that's not called if remove happens in fire
					l.fn = falseFn;

					if (this._firingCount) {
						/* copy array in case events are being fired */
						this._events[type] = listeners = listeners.slice();
					}
					listeners.splice(i, 1);

					return;
				}
			}
		}
	},

	// @method fire(type: String, data?: Object, propagate?: Boolean): this
	// Fires an event of the specified type. You can optionally provide an data
	// object — the first argument of the listener function will contain its
	// properties. The event can optionally be propagated to event parents.
	fire: function (type, data, propagate) {
		if (!this.listens(type, propagate)) { return this; }

		var event = extend({}, data, {type: type, target: this});

		if (this._events) {
			var listeners = this._events[type];

			if (listeners) {
				this._firingCount = (this._firingCount + 1) || 1;
				for (var i = 0, len = listeners.length; i < len; i++) {
					var l = listeners[i];
					l.fn.call(l.ctx || this, event);
				}

				this._firingCount--;
			}
		}

		if (propagate) {
			// propagate the event to parents (set with addEventParent)
			this._propagateEvent(event);
		}

		return this;
	},

	// @method listens(type: String): Boolean
	// Returns `true` if a particular event type has any listeners attached to it.
	listens: function (type, propagate) {
		var listeners = this._events && this._events[type];
		if (listeners && listeners.length) { return true; }

		if (propagate) {
			// also check parents for listeners if event propagates
			for (var id in this._eventParents) {
				if (this._eventParents[id].listens(type, propagate)) { return true; }
			}
		}
		return false;
	},

	// @method once(…): this
	// Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
	once: function (types, fn, context) {

		if (typeof types === 'object') {
			for (var type in types) {
				this.once(type, types[type], fn);
			}
			return this;
		}

		var handler = bind(function () {
			this
			    .off(types, fn, context)
			    .off(types, handler, context);
		}, this);

		// add a listener that's executed once and removed after that
		return this
		    .on(types, fn, context)
		    .on(types, handler, context);
	},

	// @method addEventParent(obj: Evented): this
	// Adds an event parent - an `Evented` that will receive propagated events
	addEventParent: function (obj) {
		this._eventParents = this._eventParents || {};
		this._eventParents[stamp(obj)] = obj;
		return this;
	},

	// @method removeEventParent(obj: Evented): this
	// Removes an event parent, so it will stop receiving propagated events
	removeEventParent: function (obj) {
		if (this._eventParents) {
			delete this._eventParents[stamp(obj)];
		}
		return this;
	},

	_propagateEvent: function (e) {
		for (var id in this._eventParents) {
			this._eventParents[id].fire(e.type, extend({layer: e.target}, e), true);
		}
	}
};

// aliases; we should ditch those eventually

// @method addEventListener(…): this
// Alias to [`on(…)`](#evented-on)
Events.addEventListener = Events.on;

// @method removeEventListener(…): this
// Alias to [`off(…)`](#evented-off)

// @method clearAllEventListeners(…): this
// Alias to [`off()`](#evented-off)
Events.removeEventListener = Events.clearAllEventListeners = Events.off;

// @method addOneTimeEventListener(…): this
// Alias to [`once(…)`](#evented-once)
Events.addOneTimeEventListener = Events.once;

// @method fireEvent(…): this
// Alias to [`fire(…)`](#evented-fire)
Events.fireEvent = Events.fire;

// @method hasEventListeners(…): Boolean
// Alias to [`listens(…)`](#evented-listens)
Events.hasEventListeners = Events.listens;

var Evented = Class.extend(Events);

/*
 * @class Point
 * @aka L.Point
 *
 * Represents a point with `x` and `y` coordinates in pixels.
 *
 * @example
 *
 * ```js
 * var point = L.point(200, 300);
 * ```
 *
 * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
 *
 * ```js
 * map.panBy([200, 300]);
 * map.panBy(L.point(200, 300));
 * ```
 */

function Point(x, y, round) {
	// @property x: Number; The `x` coordinate of the point
	this.x = (round ? Math.round(x) : x);
	// @property y: Number; The `y` coordinate of the point
	this.y = (round ? Math.round(y) : y);
}

Point.prototype = {

	// @method clone(): Point
	// Returns a copy of the current point.
	clone: function () {
		return new Point(this.x, this.y);
	},

	// @method add(otherPoint: Point): Point
	// Returns the result of addition of the current and the given points.
	add: function (point) {
		// non-destructive, returns a new point
		return this.clone()._add(toPoint(point));
	},

	_add: function (point) {
		// destructive, used directly for performance in situations where it's safe to modify existing point
		this.x += point.x;
		this.y += point.y;
		return this;
	},

	// @method subtract(otherPoint: Point): Point
	// Returns the result of subtraction of the given point from the current.
	subtract: function (point) {
		return this.clone()._subtract(toPoint(point));
	},

	_subtract: function (point) {
		this.x -= point.x;
		this.y -= point.y;
		return this;
	},

	// @method divideBy(num: Number): Point
	// Returns the result of division of the current point by the given number.
	divideBy: function (num) {
		return this.clone()._divideBy(num);
	},

	_divideBy: function (num) {
		this.x /= num;
		this.y /= num;
		return this;
	},

	// @method multiplyBy(num: Number): Point
	// Returns the result of multiplication of the current point by the given number.
	multiplyBy: function (num) {
		return this.clone()._multiplyBy(num);
	},

	_multiplyBy: function (num) {
		this.x *= num;
		this.y *= num;
		return this;
	},

	// @method scaleBy(scale: Point): Point
	// Multiply each coordinate of the current point by each coordinate of
	// `scale`. In linear algebra terms, multiply the point by the
	// [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
	// defined by `scale`.
	scaleBy: function (point) {
		return new Point(this.x * point.x, this.y * point.y);
	},

	// @method unscaleBy(scale: Point): Point
	// Inverse of `scaleBy`. Divide each coordinate of the current point by
	// each coordinate of `scale`.
	unscaleBy: function (point) {
		return new Point(this.x / point.x, this.y / point.y);
	},

	// @method round(): Point
	// Returns a copy of the current point with rounded coordinates.
	round: function () {
		return this.clone()._round();
	},

	_round: function () {
		this.x = Math.round(this.x);
		this.y = Math.round(this.y);
		return this;
	},

	// @method floor(): Point
	// Returns a copy of the current point with floored coordinates (rounded down).
	floor: function () {
		return this.clone()._floor();
	},

	_floor: function () {
		this.x = Math.floor(this.x);
		this.y = Math.floor(this.y);
		return this;
	},

	// @method ceil(): Point
	// Returns a copy of the current point with ceiled coordinates (rounded up).
	ceil: function () {
		return this.clone()._ceil();
	},

	_ceil: function () {
		this.x = Math.ceil(this.x);
		this.y = Math.ceil(this.y);
		return this;
	},

	// @method distanceTo(otherPoint: Point): Number
	// Returns the cartesian distance between the current and the given points.
	distanceTo: function (point) {
		point = toPoint(point);

		var x = point.x - this.x,
		    y = point.y - this.y;

		return Math.sqrt(x * x + y * y);
	},

	// @method equals(otherPoint: Point): Boolean
	// Returns `true` if the given point has the same coordinates.
	equals: function (point) {
		point = toPoint(point);

		return point.x === this.x &&
		       point.y === this.y;
	},

	// @method contains(otherPoint: Point): Boolean
	// Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
	contains: function (point) {
		point = toPoint(point);

		return Math.abs(point.x) <= Math.abs(this.x) &&
		       Math.abs(point.y) <= Math.abs(this.y);
	},

	// @method toString(): String
	// Returns a string representation of the point for debugging purposes.
	toString: function () {
		return 'Point(' +
		        formatNum(this.x) + ', ' +
		        formatNum(this.y) + ')';
	}
};

// @factory L.point(x: Number, y: Number, round?: Boolean)
// Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.

// @alternative
// @factory L.point(coords: Number[])
// Expects an array of the form `[x, y]` instead.

// @alternative
// @factory L.point(coords: Object)
// Expects a plain object of the form `{x: Number, y: Number}` instead.
function toPoint(x, y, round) {
	if (x instanceof Point) {
		return x;
	}
	if (isArray(x)) {
		return new Point(x[0], x[1]);
	}
	if (x === undefined || x === null) {
		return x;
	}
	if (typeof x === 'object' && 'x' in x && 'y' in x) {
		return new Point(x.x, x.y);
	}
	return new Point(x, y, round);
}

/*
 * @class Bounds
 * @aka L.Bounds
 *
 * Represents a rectangular area in pixel coordinates.
 *
 * @example
 *
 * ```js
 * var p1 = L.point(10, 10),
 * p2 = L.point(40, 60),
 * bounds = L.bounds(p1, p2);
 * ```
 *
 * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
 *
 * ```js
 * otherBounds.intersects([[10, 10], [40, 60]]);
 * ```
 */

function Bounds(a, b) {
	if (!a) { return; }

	var points = b ? [a, b] : a;

	for (var i = 0, len = points.length; i < len; i++) {
		this.extend(points[i]);
	}
}

Bounds.prototype = {
	// @method extend(point: Point): this
	// Extends the bounds to contain the given point.
	extend: function (point) { // (Point)
		point = toPoint(point);

		// @property min: Point
		// The top left corner of the rectangle.
		// @property max: Point
		// The bottom right corner of the rectangle.
		if (!this.min && !this.max) {
			this.min = point.clone();
			this.max = point.clone();
		} else {
			this.min.x = Math.min(point.x, this.min.x);
			this.max.x = Math.max(point.x, this.max.x);
			this.min.y = Math.min(point.y, this.min.y);
			this.max.y = Math.max(point.y, this.max.y);
		}
		return this;
	},

	// @method getCenter(round?: Boolean): Point
	// Returns the center point of the bounds.
	getCenter: function (round) {
		return new Point(
		        (this.min.x + this.max.x) / 2,
		        (this.min.y + this.max.y) / 2, round);
	},

	// @method getBottomLeft(): Point
	// Returns the bottom-left point of the bounds.
	getBottomLeft: function () {
		return new Point(this.min.x, this.max.y);
	},

	// @method getTopRight(): Point
	// Returns the top-right point of the bounds.
	getTopRight: function () { // -> Point
		return new Point(this.max.x, this.min.y);
	},

	// @method getTopLeft(): Point
	// Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
	getTopLeft: function () {
		return this.min; // left, top
	},

	// @method getBottomRight(): Point
	// Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
	getBottomRight: function () {
		return this.max; // right, bottom
	},

	// @method getSize(): Point
	// Returns the size of the given bounds
	getSize: function () {
		return this.max.subtract(this.min);
	},

	// @method contains(otherBounds: Bounds): Boolean
	// Returns `true` if the rectangle contains the given one.
	// @alternative
	// @method contains(point: Point): Boolean
	// Returns `true` if the rectangle contains the given point.
	contains: function (obj) {
		var min, max;

		if (typeof obj[0] === 'number' || obj instanceof Point) {
			obj = toPoint(obj);
		} else {
			obj = toBounds(obj);
		}

		if (obj instanceof Bounds) {
			min = obj.min;
			max = obj.max;
		} else {
			min = max = obj;
		}

		return (min.x >= this.min.x) &&
		       (max.x <= this.max.x) &&
		       (min.y >= this.min.y) &&
		       (max.y <= this.max.y);
	},

	// @method intersects(otherBounds: Bounds): Boolean
	// Returns `true` if the rectangle intersects the given bounds. Two bounds
	// intersect if they have at least one point in common.
	intersects: function (bounds) { // (Bounds) -> Boolean
		bounds = toBounds(bounds);

		var min = this.min,
		    max = this.max,
		    min2 = bounds.min,
		    max2 = bounds.max,
		    xIntersects = (max2.x >= min.x) && (min2.x <= max.x),
		    yIntersects = (max2.y >= min.y) && (min2.y <= max.y);

		return xIntersects && yIntersects;
	},

	// @method overlaps(otherBounds: Bounds): Boolean
	// Returns `true` if the rectangle overlaps the given bounds. Two bounds
	// overlap if their intersection is an area.
	overlaps: function (bounds) { // (Bounds) -> Boolean
		bounds = toBounds(bounds);

		var min = this.min,
		    max = this.max,
		    min2 = bounds.min,
		    max2 = bounds.max,
		    xOverlaps = (max2.x > min.x) && (min2.x < max.x),
		    yOverlaps = (max2.y > min.y) && (min2.y < max.y);

		return xOverlaps && yOverlaps;
	},

	isValid: function () {
		return !!(this.min && this.max);
	}
};


// @factory L.bounds(corner1: Point, corner2: Point)
// Creates a Bounds object from two corners coordinate pairs.
// @alternative
// @factory L.bounds(points: Point[])
// Creates a Bounds object from the given array of points.
function toBounds(a, b) {
	if (!a || a instanceof Bounds) {
		return a;
	}
	return new Bounds(a, b);
}

/*
 * @class LatLngBounds
 * @aka L.LatLngBounds
 *
 * Represents a rectangular geographical area on a map.
 *
 * @example
 *
 * ```js
 * var corner1 = L.latLng(40.712, -74.227),
 * corner2 = L.latLng(40.774, -74.125),
 * bounds = L.latLngBounds(corner1, corner2);
 * ```
 *
 * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
 *
 * ```js
 * map.fitBounds([
 * 	[40.712, -74.227],
 * 	[40.774, -74.125]
 * ]);
 * ```
 *
 * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
 */

function LatLngBounds(corner1, corner2) { // (LatLng, LatLng) or (LatLng[])
	if (!corner1) { return; }

	var latlngs = corner2 ? [corner1, corner2] : corner1;

	for (var i = 0, len = latlngs.length; i < len; i++) {
		this.extend(latlngs[i]);
	}
}

LatLngBounds.prototype = {

	// @method extend(latlng: LatLng): this
	// Extend the bounds to contain the given point

	// @alternative
	// @method extend(otherBounds: LatLngBounds): this
	// Extend the bounds to contain the given bounds
	extend: function (obj) {
		var sw = this._southWest,
		    ne = this._northEast,
		    sw2, ne2;

		if (obj instanceof LatLng) {
			sw2 = obj;
			ne2 = obj;

		} else if (obj instanceof LatLngBounds) {
			sw2 = obj._southWest;
			ne2 = obj._northEast;

			if (!sw2 || !ne2) { return this; }

		} else {
			return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
		}

		if (!sw && !ne) {
			this._southWest = new LatLng(sw2.lat, sw2.lng);
			this._northEast = new LatLng(ne2.lat, ne2.lng);
		} else {
			sw.lat = Math.min(sw2.lat, sw.lat);
			sw.lng = Math.min(sw2.lng, sw.lng);
			ne.lat = Math.max(ne2.lat, ne.lat);
			ne.lng = Math.max(ne2.lng, ne.lng);
		}

		return this;
	},

	// @method pad(bufferRatio: Number): LatLngBounds
	// Returns bigger bounds created by extending the current bounds by a given percentage in each direction.
	pad: function (bufferRatio) {
		var sw = this._southWest,
		    ne = this._northEast,
		    heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio,
		    widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;

		return new LatLngBounds(
		        new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer),
		        new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
	},

	// @method getCenter(): LatLng
	// Returns the center point of the bounds.
	getCenter: function () {
		return new LatLng(
		        (this._southWest.lat + this._northEast.lat) / 2,
		        (this._southWest.lng + this._northEast.lng) / 2);
	},

	// @method getSouthWest(): LatLng
	// Returns the south-west point of the bounds.
	getSouthWest: function () {
		return this._southWest;
	},

	// @method getNorthEast(): LatLng
	// Returns the north-east point of the bounds.
	getNorthEast: function () {
		return this._northEast;
	},

	// @method getNorthWest(): LatLng
	// Returns the north-west point of the bounds.
	getNorthWest: function () {
		return new LatLng(this.getNorth(), this.getWest());
	},

	// @method getSouthEast(): LatLng
	// Returns the south-east point of the bounds.
	getSouthEast: function () {
		return new LatLng(this.getSouth(), this.getEast());
	},

	// @method getWest(): Number
	// Returns the west longitude of the bounds
	getWest: function () {
		return this._southWest.lng;
	},

	// @method getSouth(): Number
	// Returns the south latitude of the bounds
	getSouth: function () {
		return this._southWest.lat;
	},

	// @method getEast(): Number
	// Returns the east longitude of the bounds
	getEast: function () {
		return this._northEast.lng;
	},

	// @method getNorth(): Number
	// Returns the north latitude of the bounds
	getNorth: function () {
		return this._northEast.lat;
	},

	// @method contains(otherBounds: LatLngBounds): Boolean
	// Returns `true` if the rectangle contains the given one.

	// @alternative
	// @method contains (latlng: LatLng): Boolean
	// Returns `true` if the rectangle contains the given point.
	contains: function (obj) { // (LatLngBounds) or (LatLng) -> Boolean
		if (typeof obj[0] === 'number' || obj instanceof LatLng || 'lat' in obj) {
			obj = toLatLng(obj);
		} else {
			obj = toLatLngBounds(obj);
		}

		var sw = this._southWest,
		    ne = this._northEast,
		    sw2, ne2;

		if (obj instanceof LatLngBounds) {
			sw2 = obj.getSouthWest();
			ne2 = obj.getNorthEast();
		} else {
			sw2 = ne2 = obj;
		}

		return (sw2.lat >= sw.lat) && (ne2.lat <= ne.lat) &&
		       (sw2.lng >= sw.lng) && (ne2.lng <= ne.lng);
	},

	// @method intersects(otherBounds: LatLngBounds): Boolean
	// Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
	intersects: function (bounds) {
		bounds = toLatLngBounds(bounds);

		var sw = this._southWest,
		    ne = this._northEast,
		    sw2 = bounds.getSouthWest(),
		    ne2 = bounds.getNorthEast(),

		    latIntersects = (ne2.lat >= sw.lat) && (sw2.lat <= ne.lat),
		    lngIntersects = (ne2.lng >= sw.lng) && (sw2.lng <= ne.lng);

		return latIntersects && lngIntersects;
	},

	// @method overlaps(otherBounds: Bounds): Boolean
	// Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
	overlaps: function (bounds) {
		bounds = toLatLngBounds(bounds);

		var sw = this._southWest,
		    ne = this._northEast,
		    sw2 = bounds.getSouthWest(),
		    ne2 = bounds.getNorthEast(),

		    latOverlaps = (ne2.lat > sw.lat) && (sw2.lat < ne.lat),
		    lngOverlaps = (ne2.lng > sw.lng) && (sw2.lng < ne.lng);

		return latOverlaps && lngOverlaps;
	},

	// @method toBBoxString(): String
	// Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
	toBBoxString: function () {
		return [this.getWest(), this.getSouth(), this.getEast(), this.getNorth()].join(',');
	},

	// @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
	// Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overriden by setting `maxMargin` to a small number.
	equals: function (bounds, maxMargin) {
		if (!bounds) { return false; }

		bounds = toLatLngBounds(bounds);

		return this._southWest.equals(bounds.getSouthWest(), maxMargin) &&
		       this._northEast.equals(bounds.getNorthEast(), maxMargin);
	},

	// @method isValid(): Boolean
	// Returns `true` if the bounds are properly initialized.
	isValid: function () {
		return !!(this._southWest && this._northEast);
	}
};

// TODO International date line?

// @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
// Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.

// @alternative
// @factory L.latLngBounds(latlngs: LatLng[])
// Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
function toLatLngBounds(a, b) {
	if (a instanceof LatLngBounds) {
		return a;
	}
	return new LatLngBounds(a, b);
}

/* @class LatLng
 * @aka L.LatLng
 *
 * Represents a geographical point with a certain latitude and longitude.
 *
 * @example
 *
 * ```
 * var latlng = L.latLng(50.5, 30.5);
 * ```
 *
 * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
 *
 * ```
 * map.panTo([50, 30]);
 * map.panTo({lon: 30, lat: 50});
 * map.panTo({lat: 50, lng: 30});
 * map.panTo(L.latLng(50, 30));
 * ```
 */

function LatLng(lat, lng, alt) {
	if (isNaN(lat) || isNaN(lng)) {
		throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
	}

	// @property lat: Number
	// Latitude in degrees
	this.lat = +lat;

	// @property lng: Number
	// Longitude in degrees
	this.lng = +lng;

	// @property alt: Number
	// Altitude in meters (optional)
	if (alt !== undefined) {
		this.alt = +alt;
	}
}

LatLng.prototype = {
	// @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
	// Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overriden by setting `maxMargin` to a small number.
	equals: function (obj, maxMargin) {
		if (!obj) { return false; }

		obj = toLatLng(obj);

		var margin = Math.max(
		        Math.abs(this.lat - obj.lat),
		        Math.abs(this.lng - obj.lng));

		return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
	},

	// @method toString(): String
	// Returns a string representation of the point (for debugging purposes).
	toString: function (precision) {
		return 'LatLng(' +
		        formatNum(this.lat, precision) + ', ' +
		        formatNum(this.lng, precision) + ')';
	},

	// @method distanceTo(otherLatLng: LatLng): Number
	// Returns the distance (in meters) to the given `LatLng` calculated using the [Haversine formula](http://en.wikipedia.org/wiki/Haversine_formula).
	distanceTo: function (other) {
		return Earth.distance(this, toLatLng(other));
	},

	// @method wrap(): LatLng
	// Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
	wrap: function () {
		return Earth.wrapLatLng(this);
	},

	// @method toBounds(sizeInMeters: Number): LatLngBounds
	// Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
	toBounds: function (sizeInMeters) {
		var latAccuracy = 180 * sizeInMeters / 40075017,
		    lngAccuracy = latAccuracy / Math.cos((Math.PI / 180) * this.lat);

		return toLatLngBounds(
		        [this.lat - latAccuracy, this.lng - lngAccuracy],
		        [this.lat + latAccuracy, this.lng + lngAccuracy]);
	},

	clone: function () {
		return new LatLng(this.lat, this.lng, this.alt);
	}
};



// @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
// Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).

// @alternative
// @factory L.latLng(coords: Array): LatLng
// Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.

// @alternative
// @factory L.latLng(coords: Object): LatLng
// Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.

function toLatLng(a, b, c) {
	if (a instanceof LatLng) {
		return a;
	}
	if (isArray(a) && typeof a[0] !== 'object') {
		if (a.length === 3) {
			return new LatLng(a[0], a[1], a[2]);
		}
		if (a.length === 2) {
			return new LatLng(a[0], a[1]);
		}
		return null;
	}
	if (a === undefined || a === null) {
		return a;
	}
	if (typeof a === 'object' && 'lat' in a) {
		return new LatLng(a.lat, 'lng' in a ? a.lng : a.lon, a.alt);
	}
	if (b === undefined) {
		return null;
	}
	return new LatLng(a, b, c);
}

/*
 * @namespace CRS
 * @crs L.CRS.Base
 * Object that defines coordinate reference systems for projecting
 * geographical points into pixel (screen) coordinates and back (and to
 * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
 * [spatial reference system](http://en.wikipedia.org/wiki/Coordinate_reference_system).
 *
 * Leaflet defines the most usual CRSs by default. If you want to use a
 * CRS not defined by default, take a look at the
 * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
 */

var CRS = {
	// @method latLngToPoint(latlng: LatLng, zoom: Number): Point
	// Projects geographical coordinates into pixel coordinates for a given zoom.
	latLngToPoint: function (latlng, zoom) {
		var projectedPoint = this.projection.project(latlng),
		    scale = this.scale(zoom);

		return this.transformation._transform(projectedPoint, scale);
	},

	// @method pointToLatLng(point: Point, zoom: Number): LatLng
	// The inverse of `latLngToPoint`. Projects pixel coordinates on a given
	// zoom into geographical coordinates.
	pointToLatLng: function (point, zoom) {
		var scale = this.scale(zoom),
		    untransformedPoint = this.transformation.untransform(point, scale);

		return this.projection.unproject(untransformedPoint);
	},

	// @method project(latlng: LatLng): Point
	// Projects geographical coordinates into coordinates in units accepted for
	// this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
	project: function (latlng) {
		return this.projection.project(latlng);
	},

	// @method unproject(point: Point): LatLng
	// Given a projected coordinate returns the corresponding LatLng.
	// The inverse of `project`.
	unproject: function (point) {
		return this.projection.unproject(point);
	},

	// @method scale(zoom: Number): Number
	// Returns the scale used when transforming projected coordinates into
	// pixel coordinates for a particular zoom. For example, it returns
	// `256 * 2^zoom` for Mercator-based CRS.
	scale: function (zoom) {
		return 256 * Math.pow(2, zoom);
	},

	// @method zoom(scale: Number): Number
	// Inverse of `scale()`, returns the zoom level corresponding to a scale
	// factor of `scale`.
	zoom: function (scale) {
		return Math.log(scale / 256) / Math.LN2;
	},

	// @method getProjectedBounds(zoom: Number): Bounds
	// Returns the projection's bounds scaled and transformed for the provided `zoom`.
	getProjectedBounds: function (zoom) {
		if (this.infinite) { return null; }

		var b = this.projection.bounds,
		    s = this.scale(zoom),
		    min = this.transformation.transform(b.min, s),
		    max = this.transformation.transform(b.max, s);

		return new Bounds(min, max);
	},

	// @method distance(latlng1: LatLng, latlng2: LatLng): Number
	// Returns the distance between two geographical coordinates.

	// @property code: String
	// Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
	//
	// @property wrapLng: Number[]
	// An array of two numbers defining whether the longitude (horizontal) coordinate
	// axis wraps around a given range and how. Defaults to `[-180, 180]` in most
	// geographical CRSs. If `undefined`, the longitude axis does not wrap around.
	//
	// @property wrapLat: Number[]
	// Like `wrapLng`, but for the latitude (vertical) axis.

	// wrapLng: [min, max],
	// wrapLat: [min, max],

	// @property infinite: Boolean
	// If true, the coordinate space will be unbounded (infinite in both axes)
	infinite: false,

	// @method wrapLatLng(latlng: LatLng): LatLng
	// Returns a `LatLng` where lat and lng has been wrapped according to the
	// CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
	wrapLatLng: function (latlng) {
		var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng,
		    lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat,
		    alt = latlng.alt;

		return new LatLng(lat, lng, alt);
	},

	// @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
	// Returns a `LatLngBounds` with the same size as the given one, ensuring
	// that its center is within the CRS's bounds.
	// Only accepts actual `L.LatLngBounds` instances, not arrays.
	wrapLatLngBounds: function (bounds) {
		var center = bounds.getCenter(),
		    newCenter = this.wrapLatLng(center),
		    latShift = center.lat - newCenter.lat,
		    lngShift = center.lng - newCenter.lng;

		if (latShift === 0 && lngShift === 0) {
			return bounds;
		}

		var sw = bounds.getSouthWest(),
		    ne = bounds.getNorthEast(),
		    newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift),
		    newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);

		return new LatLngBounds(newSw, newNe);
	}
};

/*
 * @namespace CRS
 * @crs L.CRS.Earth
 *
 * Serves as the base for CRS that are global such that they cover the earth.
 * Can only be used as the base for other CRS and cannot be used directly,
 * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
 * meters.
 */

var Earth = extend({}, CRS, {
	wrapLng: [-180, 180],

	// Mean Earth Radius, as recommended for use by
	// the International Union of Geodesy and Geophysics,
	// see http://rosettacode.org/wiki/Haversine_formula
	R: 6371000,

	// distance between two geographical points using spherical law of cosines approximation
	distance: function (latlng1, latlng2) {
		var rad = Math.PI / 180,
		    lat1 = latlng1.lat * rad,
		    lat2 = latlng2.lat * rad,
		    a = Math.sin(lat1) * Math.sin(lat2) +
		        Math.cos(lat1) * Math.cos(lat2) * Math.cos((latlng2.lng - latlng1.lng) * rad);

		return this.R * Math.acos(Math.min(a, 1));
	}
});

/*
 * @namespace Projection
 * @projection L.Projection.SphericalMercator
 *
 * Spherical Mercator projection — the most common projection for online maps,
 * used by almost all free and commercial tile providers. Assumes that Earth is
 * a sphere. Used by the `EPSG:3857` CRS.
 */

var SphericalMercator = {

	R: 6378137,
	MAX_LATITUDE: 85.0511287798,

	project: function (latlng) {
		var d = Math.PI / 180,
		    max = this.MAX_LATITUDE,
		    lat = Math.max(Math.min(max, latlng.lat), -max),
		    sin = Math.sin(lat * d);

		return new Point(
				this.R * latlng.lng * d,
				this.R * Math.log((1 + sin) / (1 - sin)) / 2);
	},

	unproject: function (point) {
		var d = 180 / Math.PI;

		return new LatLng(
			(2 * Math.atan(Math.exp(point.y / this.R)) - (Math.PI / 2)) * d,
			point.x * d / this.R);
	},

	bounds: (function () {
		var d = 6378137 * Math.PI;
		return new Bounds([-d, -d], [d, d]);
	})()
};

/*
 * @class Transformation
 * @aka L.Transformation
 *
 * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
 * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
 * the reverse. Used by Leaflet in its projections code.
 *
 * @example
 *
 * ```js
 * var transformation = L.transformation(2, 5, -1, 10),
 * 	p = L.point(1, 2),
 * 	p2 = transformation.transform(p), //  L.point(7, 8)
 * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
 * ```
 */


// factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
// Creates a `Transformation` object with the given coefficients.
function Transformation(a, b, c, d) {
	if (isArray(a)) {
		// use array properties
		this._a = a[0];
		this._b = a[1];
		this._c = a[2];
		this._d = a[3];
		return;
	}
	this._a = a;
	this._b = b;
	this._c = c;
	this._d = d;
}

Transformation.prototype = {
	// @method transform(point: Point, scale?: Number): Point
	// Returns a transformed point, optionally multiplied by the given scale.
	// Only accepts actual `L.Point` instances, not arrays.
	transform: function (point, scale) { // (Point, Number) -> Point
		return this._transform(point.clone(), scale);
	},

	// destructive transform (faster)
	_transform: function (point, scale) {
		scale = scale || 1;
		point.x = scale * (this._a * point.x + this._b);
		point.y = scale * (this._c * point.y + this._d);
		return point;
	},

	// @method untransform(point: Point, scale?: Number): Point
	// Returns the reverse transformation of the given point, optionally divided
	// by the given scale. Only accepts actual `L.Point` instances, not arrays.
	untransform: function (point, scale) {
		scale = scale || 1;
		return new Point(
		        (point.x / scale - this._b) / this._a,
		        (point.y / scale - this._d) / this._c);
	}
};

// factory L.transformation(a: Number, b: Number, c: Number, d: Number)

// @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
// Instantiates a Transformation object with the given coefficients.

// @alternative
// @factory L.transformation(coefficients: Array): Transformation
// Expects an coeficients array of the form
// `[a: Number, b: Number, c: Number, d: Number]`.

function toTransformation(a, b, c, d) {
	return new Transformation(a, b, c, d);
}

/*
 * @namespace CRS
 * @crs L.CRS.EPSG3857
 *
 * The most common CRS for online maps, used by almost all free and commercial
 * tile providers. Uses Spherical Mercator projection. Set in by default in
 * Map's `crs` option.
 */

var EPSG3857 = extend({}, Earth, {
	code: 'EPSG:3857',
	projection: SphericalMercator,

	transformation: (function () {
		var scale = 0.5 / (Math.PI * SphericalMercator.R);
		return toTransformation(scale, 0.5, -scale, 0.5);
	}())
});

var EPSG900913 = extend({}, EPSG3857, {
	code: 'EPSG:900913'
});

// @namespace SVG; @section
// There are several static functions which can be called without instantiating L.SVG:

// @function create(name: String): SVGElement
// Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
// corresponding to the class name passed. For example, using 'line' will return
// an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
function svgCreate(name) {
	return document.createElementNS('http://www.w3.org/2000/svg', name);
}

// @function pointsToPath(rings: Point[], closed: Boolean): String
// Generates a SVG path string for multiple rings, with each ring turning
// into "M..L..L.." instructions
function pointsToPath(rings, closed) {
	var str = '',
	i, j, len, len2, points, p;

	for (i = 0, len = rings.length; i < len; i++) {
		points = rings[i];

		for (j = 0, len2 = points.length; j < len2; j++) {
			p = points[j];
			str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
		}

		// closes the ring for polygons; "x" is VML syntax
		str += closed ? (svg ? 'z' : 'x') : '';
	}

	// SVG complains about empty path strings
	return str || 'M0 0';
}

/*
 * @namespace Browser
 * @aka L.Browser
 *
 * A namespace with static properties for browser/feature detection used by Leaflet internally.
 *
 * @example
 *
 * ```js
 * if (L.Browser.ielt9) {
 *   alert('Upgrade your browser, dude!');
 * }
 * ```
 */

var style$1 = document.documentElement.style;

// @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
var ie = 'ActiveXObject' in window;

// @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
var ielt9 = ie && !document.addEventListener;

// @property edge: Boolean; `true` for the Edge web browser.
var edge = 'msLaunchUri' in navigator && !('documentMode' in document);

// @property webkit: Boolean;
// `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
var webkit = userAgentContains('webkit');

// @property android: Boolean
// `true` for any browser running on an Android platform.
var android = userAgentContains('android');

// @property android23: Boolean; `true` for browsers running on Android 2 or Android 3.
var android23 = userAgentContains('android 2') || userAgentContains('android 3');

// @property opera: Boolean; `true` for the Opera browser
var opera = !!window.opera;

// @property chrome: Boolean; `true` for the Chrome browser.
var chrome = userAgentContains('chrome');

// @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
var gecko = userAgentContains('gecko') && !webkit && !opera && !ie;

// @property safari: Boolean; `true` for the Safari browser.
var safari = !chrome && userAgentContains('safari');

var phantom = userAgentContains('phantom');

// @property opera12: Boolean
// `true` for the Opera browser supporting CSS transforms (version 12 or later).
var opera12 = 'OTransition' in style$1;

// @property win: Boolean; `true` when the browser is running in a Windows platform
var win = navigator.platform.indexOf('Win') === 0;

// @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
var ie3d = ie && ('transition' in style$1);

// @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
var webkit3d = ('WebKitCSSMatrix' in window) && ('m11' in new window.WebKitCSSMatrix()) && !android23;

// @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
var gecko3d = 'MozPerspective' in style$1;

// @property any3d: Boolean
// `true` for all browsers supporting CSS transforms.
var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;

// @property mobile: Boolean; `true` for all browsers running in a mobile device.
var mobile = typeof orientation !== 'undefined' || userAgentContains('mobile');

// @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
var mobileWebkit = mobile && webkit;

// @property mobileWebkit3d: Boolean
// `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
var mobileWebkit3d = mobile && webkit3d;

// @property msPointer: Boolean
// `true` for browsers implementing the Microsoft touch events model (notably IE10).
var msPointer = !window.PointerEvent && window.MSPointerEvent;

// @property pointer: Boolean
// `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
var pointer = !!(window.PointerEvent || msPointer);

// @property touch: Boolean
// `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
// This does not necessarily mean that the browser is running in a computer with
// a touchscreen, it only means that the browser is capable of understanding
// touch events.
var touch = !window.L_NO_TOUCH && (pointer || 'ontouchstart' in window ||
		(window.DocumentTouch && document instanceof window.DocumentTouch));

// @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
var mobileOpera = mobile && opera;

// @property mobileGecko: Boolean
// `true` for gecko-based browsers running in a mobile device.
var mobileGecko = mobile && gecko;

// @property retina: Boolean
// `true` for browsers on a high-resolution "retina" screen.
var retina = (window.devicePixelRatio || (window.screen.deviceXDPI / window.screen.logicalXDPI)) > 1;


// @property canvas: Boolean
// `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
var canvas = (function () {
	return !!document.createElement('canvas').getContext;
}());

// @property svg: Boolean
// `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
var svg = !!(document.createElementNS && svgCreate('svg').createSVGRect);

// @property vml: Boolean
// `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
var vml = !svg && (function () {
	try {
		var div = document.createElement('div');
		div.innerHTML = '<v:shape adj="1"/>';

		var shape = div.firstChild;
		shape.style.behavior = 'url(#default#VML)';

		return shape && (typeof shape.adj === 'object');

	} catch (e) {
		return false;
	}
}());


function userAgentContains(str) {
	return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
}


var Browser = (Object.freeze || Object)({
	ie: ie,
	ielt9: ielt9,
	edge: edge,
	webkit: webkit,
	android: android,
	android23: android23,
	opera: opera,
	chrome: chrome,
	gecko: gecko,
	safari: safari,
	phantom: phantom,
	opera12: opera12,
	win: win,
	ie3d: ie3d,
	webkit3d: webkit3d,
	gecko3d: gecko3d,
	any3d: any3d,
	mobile: mobile,
	mobileWebkit: mobileWebkit,
	mobileWebkit3d: mobileWebkit3d,
	msPointer: msPointer,
	pointer: pointer,
	touch: touch,
	mobileOpera: mobileOpera,
	mobileGecko: mobileGecko,
	retina: retina,
	canvas: canvas,
	svg: svg,
	vml: vml
});

/*
 * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
 */


var POINTER_DOWN =   msPointer ? 'MSPointerDown'   : 'pointerdown';
var POINTER_MOVE =   msPointer ? 'MSPointerMove'   : 'pointermove';
var POINTER_UP =     msPointer ? 'MSPointerUp'     : 'pointerup';
var POINTER_CANCEL = msPointer ? 'MSPointerCancel' : 'pointercancel';
var TAG_WHITE_LIST = ['INPUT', 'SELECT', 'OPTION'];
var _pointers = {};
var _pointerDocListener = false;

// DomEvent.DoubleTap needs to know about this
var _pointersCount = 0;

// Provides a touch events wrapper for (ms)pointer events.
// ref http://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890

function addPointerListener(obj, type, handler, id) {
	if (type === 'touchstart') {
		_addPointerStart(obj, handler, id);

	} else if (type === 'touchmove') {
		_addPointerMove(obj, handler, id);

	} else if (type === 'touchend') {
		_addPointerEnd(obj, handler, id);
	}

	return this;
}

function removePointerListener(obj, type, id) {
	var handler = obj['_leaflet_' + type + id];

	if (type === 'touchstart') {
		obj.removeEventListener(POINTER_DOWN, handler, false);

	} else if (type === 'touchmove') {
		obj.removeEventListener(POINTER_MOVE, handler, false);

	} else if (type === 'touchend') {
		obj.removeEventListener(POINTER_UP, handler, false);
		obj.removeEventListener(POINTER_CANCEL, handler, false);
	}

	return this;
}

function _addPointerStart(obj, handler, id) {
	var onDown = bind(function (e) {
		if (e.pointerType !== 'mouse' && e.pointerType !== e.MSPOINTER_TYPE_MOUSE && e.pointerType !== e.MSPOINTER_TYPE_MOUSE) {
			// In IE11, some touch events needs to fire for form controls, or
			// the controls will stop working. We keep a whitelist of tag names that
			// need these events. For other target tags, we prevent default on the event.
			if (TAG_WHITE_LIST.indexOf(e.target.tagName) < 0) {
				preventDefault(e);
			} else {
				return;
			}
		}

		_handlePointer(e, handler);
	});

	obj['_leaflet_touchstart' + id] = onDown;
	obj.addEventListener(POINTER_DOWN, onDown, false);

	// need to keep track of what pointers and how many are active to provide e.touches emulation
	if (!_pointerDocListener) {
		// we listen documentElement as any drags that end by moving the touch off the screen get fired there
		document.documentElement.addEventListener(POINTER_DOWN, _globalPointerDown, true);
		document.documentElement.addEventListener(POINTER_MOVE, _globalPointerMove, true);
		document.documentElement.addEventListener(POINTER_UP, _globalPointerUp, true);
		document.documentElement.addEventListener(POINTER_CANCEL, _globalPointerUp, true);

		_pointerDocListener = true;
	}
}

function _globalPointerDown(e) {
	_pointers[e.pointerId] = e;
	_pointersCount++;
}

function _globalPointerMove(e) {
	if (_pointers[e.pointerId]) {
		_pointers[e.pointerId] = e;
	}
}

function _globalPointerUp(e) {
	delete _pointers[e.pointerId];
	_pointersCount--;
}

function _handlePointer(e, handler) {
	e.touches = [];
	for (var i in _pointers) {
		e.touches.push(_pointers[i]);
	}
	e.changedTouches = [e];

	handler(e);
}

function _addPointerMove(obj, handler, id) {
	var onMove = function (e) {
		// don't fire touch moves when mouse isn't down
		if ((e.pointerType === e.MSPOINTER_TYPE_MOUSE || e.pointerType === 'mouse') && e.buttons === 0) { return; }

		_handlePointer(e, handler);
	};

	obj['_leaflet_touchmove' + id] = onMove;
	obj.addEventListener(POINTER_MOVE, onMove, false);
}

function _addPointerEnd(obj, handler, id) {
	var onUp = function (e) {
		_handlePointer(e, handler);
	};

	obj['_leaflet_touchend' + id] = onUp;
	obj.addEventListener(POINTER_UP, onUp, false);
	obj.addEventListener(POINTER_CANCEL, onUp, false);
}

/*
 * Extends the event handling code with double tap support for mobile browsers.
 */

var _touchstart = msPointer ? 'MSPointerDown' : pointer ? 'pointerdown' : 'touchstart';
var _touchend = msPointer ? 'MSPointerUp' : pointer ? 'pointerup' : 'touchend';
var _pre = '_leaflet_';

// inspired by Zepto touch code by Thomas Fuchs
function addDoubleTapListener(obj, handler, id) {
	var last, touch$$1,
	    doubleTap = false,
	    delay = 250;

	function onTouchStart(e) {
		var count;

		if (pointer) {
			if ((!edge) || e.pointerType === 'mouse') { return; }
			count = _pointersCount;
		} else {
			count = e.touches.length;
		}

		if (count > 1) { return; }

		var now = Date.now(),
		    delta = now - (last || now);

		touch$$1 = e.touches ? e.touches[0] : e;
		doubleTap = (delta > 0 && delta <= delay);
		last = now;
	}

	function onTouchEnd(e) {
		if (doubleTap && !touch$$1.cancelBubble) {
			if (pointer) {
				if ((!edge) || e.pointerType === 'mouse') { return; }
				// work around .type being readonly with MSPointer* events
				var newTouch = {},
				    prop, i;

				for (i in touch$$1) {
					prop = touch$$1[i];
					newTouch[i] = prop && prop.bind ? prop.bind(touch$$1) : prop;
				}
				touch$$1 = newTouch;
			}
			touch$$1.type = 'dblclick';
			handler(touch$$1);
			last = null;
		}
	}

	obj[_pre + _touchstart + id] = onTouchStart;
	obj[_pre + _touchend + id] = onTouchEnd;
	obj[_pre + 'dblclick' + id] = handler;

	obj.addEventListener(_touchstart, onTouchStart, false);
	obj.addEventListener(_touchend, onTouchEnd, false);

	// On some platforms (notably, chrome<55 on win10 + touchscreen + mouse),
	// the browser doesn't fire touchend/pointerup events but does fire
	// native dblclicks. See #4127.
	// Edge 14 also fires native dblclicks, but only for pointerType mouse, see #5180.
	obj.addEventListener('dblclick', handler, false);

	return this;
}

function removeDoubleTapListener(obj, id) {
	var touchstart = obj[_pre + _touchstart + id],
	    touchend = obj[_pre + _touchend + id],
	    dblclick = obj[_pre + 'dblclick' + id];

	obj.removeEventListener(_touchstart, touchstart, false);
	obj.removeEventListener(_touchend, touchend, false);
	if (!edge) {
		obj.removeEventListener('dblclick', dblclick, false);
	}

	return this;
}

/*
 * @namespace DomEvent
 * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
 */

// Inspired by John Resig, Dean Edwards and YUI addEvent implementations.

// @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
// Adds a listener function (`fn`) to a particular DOM event type of the
// element `el`. You can optionally specify the context of the listener
// (object the `this` keyword will point to). You can also pass several
// space-separated types (e.g. `'click dblclick'`).

// @alternative
// @function on(el: HTMLElement, eventMap: Object, context?: Object): this
// Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
function on(obj, types, fn, context) {

	if (typeof types === 'object') {
		for (var type in types) {
			addOne(obj, type, types[type], fn);
		}
	} else {
		types = splitWords(types);

		for (var i = 0, len = types.length; i < len; i++) {
			addOne(obj, types[i], fn, context);
		}
	}

	return this;
}

var eventsKey = '_leaflet_events';

// @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
// Removes a previously added listener function. If no function is specified,
// it will remove all the listeners of that particular DOM event from the element.
// Note that if you passed a custom context to on, you must pass the same
// context to `off` in order to remove the listener.

// @alternative
// @function off(el: HTMLElement, eventMap: Object, context?: Object): this
// Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`

// @alternative
// @function off(el: HTMLElement): this
// Removes all known event listeners
function off(obj, types, fn, context) {

	if (typeof types === 'object') {
		for (var type in types) {
			removeOne(obj, type, types[type], fn);
		}
	} else if (types) {
		types = splitWords(types);

		for (var i = 0, len = types.length; i < len; i++) {
			removeOne(obj, types[i], fn, context);
		}
	} else {
		for (var j in obj[eventsKey]) {
			removeOne(obj, j, obj[eventsKey][j]);
		}
		delete obj[eventsKey];
	}

	return this;
}

function addOne(obj, type, fn, context) {
	var id = type + stamp(fn) + (context ? '_' + stamp(context) : '');

	if (obj[eventsKey] && obj[eventsKey][id]) { return this; }

	var handler = function (e) {
		return fn.call(context || obj, e || window.event);
	};

	var originalHandler = handler;

	if (pointer && type.indexOf('touch') === 0) {
		// Needs DomEvent.Pointer.js
		addPointerListener(obj, type, handler, id);

	} else if (touch && (type === 'dblclick') && addDoubleTapListener &&
	           !(pointer && chrome)) {
		// Chrome >55 does not need the synthetic dblclicks from addDoubleTapListener
		// See #5180
		addDoubleTapListener(obj, handler, id);

	} else if ('addEventListener' in obj) {

		if (type === 'mousewheel') {
			obj.addEventListener('onwheel' in obj ? 'wheel' : 'mousewheel', handler, false);

		} else if ((type === 'mouseenter') || (type === 'mouseleave')) {
			handler = function (e) {
				e = e || window.event;
				if (isExternalTarget(obj, e)) {
					originalHandler(e);
				}
			};
			obj.addEventListener(type === 'mouseenter' ? 'mouseover' : 'mouseout', handler, false);

		} else {
			if (type === 'click' && android) {
				handler = function (e) {
					filterClick(e, originalHandler);
				};
			}
			obj.addEventListener(type, handler, false);
		}

	} else if ('attachEvent' in obj) {
		obj.attachEvent('on' + type, handler);
	}

	obj[eventsKey] = obj[eventsKey] || {};
	obj[eventsKey][id] = handler;
}

function removeOne(obj, type, fn, context) {

	var id = type + stamp(fn) + (context ? '_' + stamp(context) : ''),
	    handler = obj[eventsKey] && obj[eventsKey][id];

	if (!handler) { return this; }

	if (pointer && type.indexOf('touch') === 0) {
		removePointerListener(obj, type, id);

	} else if (touch && (type === 'dblclick') && removeDoubleTapListener) {
		removeDoubleTapListener(obj, id);

	} else if ('removeEventListener' in obj) {

		if (type === 'mousewheel') {
			obj.removeEventListener('onwheel' in obj ? 'wheel' : 'mousewheel', handler, false);

		} else {
			obj.removeEventListener(
				type === 'mouseenter' ? 'mouseover' :
				type === 'mouseleave' ? 'mouseout' : type, handler, false);
		}

	} else if ('detachEvent' in obj) {
		obj.detachEvent('on' + type, handler);
	}

	obj[eventsKey][id] = null;
}

// @function stopPropagation(ev: DOMEvent): this
// Stop the given event from propagation to parent elements. Used inside the listener functions:
// ```js
// L.DomEvent.on(div, 'click', function (ev) {
// 	L.DomEvent.stopPropagation(ev);
// });
// ```
function stopPropagation(e) {

	if (e.stopPropagation) {
		e.stopPropagation();
	} else if (e.originalEvent) {  // In case of Leaflet event.
		e.originalEvent._stopped = true;
	} else {
		e.cancelBubble = true;
	}
	skipped(e);

	return this;
}

// @function disableScrollPropagation(el: HTMLElement): this
// Adds `stopPropagation` to the element's `'mousewheel'` events (plus browser variants).
function disableScrollPropagation(el) {
	addOne(el, 'mousewheel', stopPropagation);
	return this;
}

// @function disableClickPropagation(el: HTMLElement): this
// Adds `stopPropagation` to the element's `'click'`, `'doubleclick'`,
// `'mousedown'` and `'touchstart'` events (plus browser variants).
function disableClickPropagation(el) {
	on(el, 'mousedown touchstart dblclick', stopPropagation);
	addOne(el, 'click', fakeStop);
	return this;
}

// @function preventDefault(ev: DOMEvent): this
// Prevents the default action of the DOM Event `ev` from happening (such as
// following a link in the href of the a element, or doing a POST request
// with page reload when a `<form>` is submitted).
// Use it inside listener functions.
function preventDefault(e) {
	if (e.preventDefault) {
		e.preventDefault();
	} else {
		e.returnValue = false;
	}
	return this;
}

// @function stop(ev): this
// Does `stopPropagation` and `preventDefault` at the same time.
function stop(e) {
	preventDefault(e);
	stopPropagation(e);
	return this;
}

// @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
// Gets normalized mouse position from a DOM event relative to the
// `container` or to the whole page if not specified.
function getMousePosition(e, container) {
	if (!container) {
		return new Point(e.clientX, e.clientY);
	}

	var rect = container.getBoundingClientRect();

	return new Point(
		e.clientX - rect.left - container.clientLeft,
		e.clientY - rect.top - container.clientTop);
}

// Chrome on Win scrolls double the pixels as in other platforms (see #4538),
// and Firefox scrolls device pixels, not CSS pixels
var wheelPxFactor =
	(win && chrome) ? 2 * window.devicePixelRatio :
	gecko ? window.devicePixelRatio : 1;

// @function getWheelDelta(ev: DOMEvent): Number
// Gets normalized wheel delta from a mousewheel DOM event, in vertical
// pixels scrolled (negative if scrolling down).
// Events from pointing devices without precise scrolling are mapped to
// a best guess of 60 pixels.
function getWheelDelta(e) {
	return (edge) ? e.wheelDeltaY / 2 : // Don't trust window-geometry-based delta
	       (e.deltaY && e.deltaMode === 0) ? -e.deltaY / wheelPxFactor : // Pixels
	       (e.deltaY && e.deltaMode === 1) ? -e.deltaY * 20 : // Lines
	       (e.deltaY && e.deltaMode === 2) ? -e.deltaY * 60 : // Pages
	       (e.deltaX || e.deltaZ) ? 0 :	// Skip horizontal/depth wheel events
	       e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : // Legacy IE pixels
	       (e.detail && Math.abs(e.detail) < 32765) ? -e.detail * 20 : // Legacy Moz lines
	       e.detail ? e.detail / -32765 * 60 : // Legacy Moz pages
	       0;
}

var skipEvents = {};

function fakeStop(e) {
	// fakes stopPropagation by setting a special event flag, checked/reset with skipped(e)
	skipEvents[e.type] = true;
}

function skipped(e) {
	var events = skipEvents[e.type];
	// reset when checking, as it's only used in map container and propagates outside of the map
	skipEvents[e.type] = false;
	return events;
}

// check if element really left/entered the event target (for mouseenter/mouseleave)
function isExternalTarget(el, e) {

	var related = e.relatedTarget;

	if (!related) { return true; }

	try {
		while (related && (related !== el)) {
			related = related.parentNode;
		}
	} catch (err) {
		return false;
	}
	return (related !== el);
}

var lastClick;

// this is a horrible workaround for a bug in Android where a single touch triggers two click events
function filterClick(e, handler) {
	var timeStamp = (e.timeStamp || (e.originalEvent && e.originalEvent.timeStamp)),
	    elapsed = lastClick && (timeStamp - lastClick);

	// are they closer together than 500ms yet more than 100ms?
	// Android typically triggers them ~300ms apart while multiple listeners
	// on the same event should be triggered far faster;
	// or check if click is simulated on the element, and if it is, reject any non-simulated events

	if ((elapsed && elapsed > 100 && elapsed < 500) || (e.target._simulatedClick && !e._simulated)) {
		stop(e);
		return;
	}
	lastClick = timeStamp;

	handler(e);
}




var DomEvent = (Object.freeze || Object)({
	on: on,
	off: off,
	stopPropagation: stopPropagation,
	disableScrollPropagation: disableScrollPropagation,
	disableClickPropagation: disableClickPropagation,
	preventDefault: preventDefault,
	stop: stop,
	getMousePosition: getMousePosition,
	getWheelDelta: getWheelDelta,
	fakeStop: fakeStop,
	skipped: skipped,
	isExternalTarget: isExternalTarget,
	addListener: on,
	removeListener: off
});

/*
 * @namespace DomUtil
 *
 * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
 * tree, used by Leaflet internally.
 *
 * Most functions expecting or returning a `HTMLElement` also work for
 * SVG elements. The only difference is that classes refer to CSS classes
 * in HTML and SVG classes in SVG.
 */


// @property TRANSFORM: String
// Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
var TRANSFORM = testProp(
	['transform', 'WebkitTransform', 'OTransform', 'MozTransform', 'msTransform']);

// webkitTransition comes first because some browser versions that drop vendor prefix don't do
// the same for the transitionend event, in particular the Android 4.1 stock browser

// @property TRANSITION: String
// Vendor-prefixed transition style name.
var TRANSITION = testProp(
	['webkitTransition', 'transition', 'OTransition', 'MozTransition', 'msTransition']);

// @property TRANSITION_END: String
// Vendor-prefixed transitionend event name.
var TRANSITION_END =
	TRANSITION === 'webkitTransition' || TRANSITION === 'OTransition' ? TRANSITION + 'End' : 'transitionend';


// @function get(id: String|HTMLElement): HTMLElement
// Returns an element given its DOM id, or returns the element itself
// if it was passed directly.
function get(id) {
	return typeof id === 'string' ? document.getElementById(id) : id;
}

// @function getStyle(el: HTMLElement, styleAttrib: String): String
// Returns the value for a certain style attribute on an element,
// including computed values or values set through CSS.
function getStyle(el, style) {
	var value = el.style[style] || (el.currentStyle && el.currentStyle[style]);

	if ((!value || value === 'auto') && document.defaultView) {
		var css = document.defaultView.getComputedStyle(el, null);
		value = css ? css[style] : null;
	}
	return value === 'auto' ? null : value;
}

// @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
// Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
function create$1(tagName, className, container) {
	var el = document.createElement(tagName);
	el.className = className || '';

	if (container) {
		container.appendChild(el);
	}
	return el;
}

// @function remove(el: HTMLElement)
// Removes `el` from its parent element
function remove(el) {
	var parent = el.parentNode;
	if (parent) {
		parent.removeChild(el);
	}
}

// @function empty(el: HTMLElement)
// Removes all of `el`'s children elements from `el`
function empty(el) {
	while (el.firstChild) {
		el.removeChild(el.firstChild);
	}
}

// @function toFront(el: HTMLElement)
// Makes `el` the last child of its parent, so it renders in front of the other children.
function toFront(el) {
	var parent = el.parentNode;
	if (parent.lastChild !== el) {
		parent.appendChild(el);
	}
}

// @function toBack(el: HTMLElement)
// Makes `el` the first child of its parent, so it renders behind the other children.
function toBack(el) {
	var parent = el.parentNode;
	if (parent.firstChild !== el) {
		parent.insertBefore(el, parent.firstChild);
	}
}

// @function hasClass(el: HTMLElement, name: String): Boolean
// Returns `true` if the element's class attribute contains `name`.
function hasClass(el, name) {
	if (el.classList !== undefined) {
		return el.classList.contains(name);
	}
	var className = getClass(el);
	return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
}

// @function addClass(el: HTMLElement, name: String)
// Adds `name` to the element's class attribute.
function addClass(el, name) {
	if (el.classList !== undefined) {
		var classes = splitWords(name);
		for (var i = 0, len = classes.length; i < len; i++) {
			el.classList.add(classes[i]);
		}
	} else if (!hasClass(el, name)) {
		var className = getClass(el);
		setClass(el, (className ? className + ' ' : '') + name);
	}
}

// @function removeClass(el: HTMLElement, name: String)
// Removes `name` from the element's class attribute.
function removeClass(el, name) {
	if (el.classList !== undefined) {
		el.classList.remove(name);
	} else {
		setClass(el, trim((' ' + getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
	}
}

// @function setClass(el: HTMLElement, name: String)
// Sets the element's class.
function setClass(el, name) {
	if (el.className.baseVal === undefined) {
		el.className = name;
	} else {
		// in case of SVG element
		el.className.baseVal = name;
	}
}

// @function getClass(el: HTMLElement): String
// Returns the element's class.
function getClass(el) {
	return el.className.baseVal === undefined ? el.className : el.className.baseVal;
}

// @function setOpacity(el: HTMLElement, opacity: Number)
// Set the opacity of an element (including old IE support).
// `opacity` must be a number from `0` to `1`.
function setOpacity(el, value) {
	if ('opacity' in el.style) {
		el.style.opacity = value;
	} else if ('filter' in el.style) {
		_setOpacityIE(el, value);
	}
}

function _setOpacityIE(el, value) {
	var filter = false,
	    filterName = 'DXImageTransform.Microsoft.Alpha';

	// filters collection throws an error if we try to retrieve a filter that doesn't exist
	try {
		filter = el.filters.item(filterName);
	} catch (e) {
		// don't set opacity to 1 if we haven't already set an opacity,
		// it isn't needed and breaks transparent pngs.
		if (value === 1) { return; }
	}

	value = Math.round(value * 100);

	if (filter) {
		filter.Enabled = (value !== 100);
		filter.Opacity = value;
	} else {
		el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
	}
}

// @function testProp(props: String[]): String|false
// Goes through the array of style names and returns the first name
// that is a valid style name for an element. If no such name is found,
// it returns false. Useful for vendor-prefixed styles like `transform`.
function testProp(props) {
	var style = document.documentElement.style;

	for (var i = 0; i < props.length; i++) {
		if (props[i] in style) {
			return props[i];
		}
	}
	return false;
}

// @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
// Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
// and optionally scaled by `scale`. Does not have an effect if the
// browser doesn't support 3D CSS transforms.
function setTransform(el, offset, scale) {
	var pos = offset || new Point(0, 0);

	el.style[TRANSFORM] =
		(ie3d ?
			'translate(' + pos.x + 'px,' + pos.y + 'px)' :
			'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') +
		(scale ? ' scale(' + scale + ')' : '');
}

// @function setPosition(el: HTMLElement, position: Point)
// Sets the position of `el` to coordinates specified by `position`,
// using CSS translate or top/left positioning depending on the browser
// (used by Leaflet internally to position its layers).
function setPosition(el, point) {

	/*eslint-disable */
	el._leaflet_pos = point;
	/*eslint-enable */

	if (any3d) {
		setTransform(el, point);
	} else {
		el.style.left = point.x + 'px';
		el.style.top = point.y + 'px';
	}
}

// @function getPosition(el: HTMLElement): Point
// Returns the coordinates of an element previously positioned with setPosition.
function getPosition(el) {
	// this method is only used for elements previously positioned using setPosition,
	// so it's safe to cache the position for performance

	return el._leaflet_pos || new Point(0, 0);
}

// @function disableTextSelection()
// Prevents the user from generating `selectstart` DOM events, usually generated
// when the user drags the mouse through a page with text. Used internally
// by Leaflet to override the behaviour of any click-and-drag interaction on
// the map. Affects drag interactions on the whole document.

// @function enableTextSelection()
// Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
var disableTextSelection;
var enableTextSelection;
var _userSelect;
if ('onselectstart' in document) {
	disableTextSelection = function () {
		on(window, 'selectstart', preventDefault);
	};
	enableTextSelection = function () {
		off(window, 'selectstart', preventDefault);
	};
} else {
	var userSelectProperty = testProp(
		['userSelect', 'WebkitUserSelect', 'OUserSelect', 'MozUserSelect', 'msUserSelect']);

	disableTextSelection = function () {
		if (userSelectProperty) {
			var style = document.documentElement.style;
			_userSelect = style[userSelectProperty];
			style[userSelectProperty] = 'none';
		}
	};
	enableTextSelection = function () {
		if (userSelectProperty) {
			document.documentElement.style[userSelectProperty] = _userSelect;
			_userSelect = undefined;
		}
	};
}

// @function disableImageDrag()
// As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
// for `dragstart` DOM events, usually generated when the user drags an image.
function disableImageDrag() {
	on(window, 'dragstart', preventDefault);
}

// @function enableImageDrag()
// Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
function enableImageDrag() {
	off(window, 'dragstart', preventDefault);
}

var _outlineElement;
var _outlineStyle;
// @function preventOutline(el: HTMLElement)
// Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
// of the element `el` invisible. Used internally by Leaflet to prevent
// focusable elements from displaying an outline when the user performs a
// drag interaction on them.
function preventOutline(element) {
	while (element.tabIndex === -1) {
		element = element.parentNode;
	}
	if (!element.style) { return; }
	restoreOutline();
	_outlineElement = element;
	_outlineStyle = element.style.outline;
	element.style.outline = 'none';
	on(window, 'keydown', restoreOutline);
}

// @function restoreOutline()
// Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
function restoreOutline() {
	if (!_outlineElement) { return; }
	_outlineElement.style.outline = _outlineStyle;
	_outlineElement = undefined;
	_outlineStyle = undefined;
	off(window, 'keydown', restoreOutline);
}


var DomUtil = (Object.freeze || Object)({
	TRANSFORM: TRANSFORM,
	TRANSITION: TRANSITION,
	TRANSITION_END: TRANSITION_END,
	get: get,
	getStyle: getStyle,
	create: create$1,
	remove: remove,
	empty: empty,
	toFront: toFront,
	toBack: toBack,
	hasClass: hasClass,
	addClass: addClass,
	removeClass: removeClass,
	setClass: setClass,
	getClass: getClass,
	setOpacity: setOpacity,
	testProp: testProp,
	setTransform: setTransform,
	setPosition: setPosition,
	getPosition: getPosition,
	disableTextSelection: disableTextSelection,
	enableTextSelection: enableTextSelection,
	disableImageDrag: disableImageDrag,
	enableImageDrag: enableImageDrag,
	preventOutline: preventOutline,
	restoreOutline: restoreOutline
});

/*
 * @class PosAnimation
 * @aka L.PosAnimation
 * @inherits Evented
 * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
 *
 * @example
 * ```js
 * var fx = new L.PosAnimation();
 * fx.run(el, [300, 500], 0.5);
 * ```
 *
 * @constructor L.PosAnimation()
 * Creates a `PosAnimation` object.
 *
 */

var PosAnimation = Evented.extend({

	// @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
	// Run an animation of a given element to a new position, optionally setting
	// duration in seconds (`0.25` by default) and easing linearity factor (3rd
	// argument of the [cubic bezier curve](http://cubic-bezier.com/#0,0,.5,1),
	// `0.5` by default).
	run: function (el, newPos, duration, easeLinearity) {
		this.stop();

		this._el = el;
		this._inProgress = true;
		this._duration = duration || 0.25;
		this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);

		this._startPos = getPosition(el);
		this._offset = newPos.subtract(this._startPos);
		this._startTime = +new Date();

		// @event start: Event
		// Fired when the animation starts
		this.fire('start');

		this._animate();
	},

	// @method stop()
	// Stops the animation (if currently running).
	stop: function () {
		if (!this._inProgress) { return; }

		this._step(true);
		this._complete();
	},

	_animate: function () {
		// animation loop
		this._animId = requestAnimFrame(this._animate, this);
		this._step();
	},

	_step: function (round) {
		var elapsed = (+new Date()) - this._startTime,
		    duration = this._duration * 1000;

		if (elapsed < duration) {
			this._runFrame(this._easeOut(elapsed / duration), round);
		} else {
			this._runFrame(1);
			this._complete();
		}
	},

	_runFrame: function (progress, round) {
		var pos = this._startPos.add(this._offset.multiplyBy(progress));
		if (round) {
			pos._round();
		}
		setPosition(this._el, pos);

		// @event step: Event
		// Fired continuously during the animation.
		this.fire('step');
	},

	_complete: function () {
		cancelAnimFrame(this._animId);

		this._inProgress = false;
		// @event end: Event
		// Fired when the animation ends.
		this.fire('end');
	},

	_easeOut: function (t) {
		return 1 - Math.pow(1 - t, this._easeOutPower);
	}
});

/*
 * @class Map
 * @aka L.Map
 * @inherits Evented
 *
 * The central class of the API — it is used to create a map on a page and manipulate it.
 *
 * @example
 *
 * ```js
 * // initialize the map on the "map" div with a given center and zoom
 * var map = L.map('map', {
 * 	center: [51.505, -0.09],
 * 	zoom: 13
 * });
 * ```
 *
 */

var Map = Evented.extend({

	options: {
		// @section Map State Options
		// @option crs: CRS = L.CRS.EPSG3857
		// The [Coordinate Reference System](#crs) to use. Don't change this if you're not
		// sure what it means.
		crs: EPSG3857,

		// @option center: LatLng = undefined
		// Initial geographic center of the map
		center: undefined,

		// @option zoom: Number = undefined
		// Initial map zoom level
		zoom: undefined,

		// @option minZoom: Number = *
		// Minimum zoom level of the map.
		// If not specified and at least one `GridLayer` or `TileLayer` is in the map,
		// the lowest of their `minZoom` options will be used instead.
		minZoom: undefined,

		// @option maxZoom: Number = *
		// Maximum zoom level of the map.
		// If not specified and at least one `GridLayer` or `TileLayer` is in the map,
		// the highest of their `maxZoom` options will be used instead.
		maxZoom: undefined,

		// @option layers: Layer[] = []
		// Array of layers that will be added to the map initially
		layers: [],

		// @option maxBounds: LatLngBounds = null
		// When this option is set, the map restricts the view to the given
		// geographical bounds, bouncing the user back if the user tries to pan
		// outside the view. To set the restriction dynamically, use
		// [`setMaxBounds`](#map-setmaxbounds) method.
		maxBounds: undefined,

		// @option renderer: Renderer = *
		// The default method for drawing vector layers on the map. `L.SVG`
		// or `L.Canvas` by default depending on browser support.
		renderer: undefined,


		// @section Animation Options
		// @option zoomAnimation: Boolean = true
		// Whether the map zoom animation is enabled. By default it's enabled
		// in all browsers that support CSS3 Transitions except Android.
		zoomAnimation: true,

		// @option zoomAnimationThreshold: Number = 4
		// Won't animate zoom if the zoom difference exceeds this value.
		zoomAnimationThreshold: 4,

		// @option fadeAnimation: Boolean = true
		// Whether the tile fade animation is enabled. By default it's enabled
		// in all browsers that support CSS3 Transitions except Android.
		fadeAnimation: true,

		// @option markerZoomAnimation: Boolean = true
		// Whether markers animate their zoom with the zoom animation, if disabled
		// they will disappear for the length of the animation. By default it's
		// enabled in all browsers that support CSS3 Transitions except Android.
		markerZoomAnimation: true,

		// @option transform3DLimit: Number = 2^23
		// Defines the maximum size of a CSS translation transform. The default
		// value should not be changed unless a web browser positions layers in
		// the wrong place after doing a large `panBy`.
		transform3DLimit: 8388608, // Precision limit of a 32-bit float

		// @section Interaction Options
		// @option zoomSnap: Number = 1
		// Forces the map's zoom level to always be a multiple of this, particularly
		// right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
		// By default, the zoom level snaps to the nearest integer; lower values
		// (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
		// means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
		zoomSnap: 1,

		// @option zoomDelta: Number = 1
		// Controls how much the map's zoom level will change after a
		// [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
		// or `-` on the keyboard, or using the [zoom controls](#control-zoom).
		// Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
		zoomDelta: 1,

		// @option trackResize: Boolean = true
		// Whether the map automatically handles browser window resize to update itself.
		trackResize: true
	},

	initialize: function (id, options) { // (HTMLElement or String, Object)
		options = setOptions(this, options);

		this._initContainer(id);
		this._initLayout();

		// hack for https://github.com/Leaflet/Leaflet/issues/1980
		this._onResize = bind(this._onResize, this);

		this._initEvents();

		if (options.maxBounds) {
			this.setMaxBounds(options.maxBounds);
		}

		if (options.zoom !== undefined) {
			this._zoom = this._limitZoom(options.zoom);
		}

		if (options.center && options.zoom !== undefined) {
			this.setView(toLatLng(options.center), options.zoom, {reset: true});
		}

		this._handlers = [];
		this._layers = {};
		this._zoomBoundLayers = {};
		this._sizeChanged = true;

		this.callInitHooks();

		// don't animate on browsers without hardware-accelerated transitions or old Android/Opera
		this._zoomAnimated = TRANSITION && any3d && !mobileOpera &&
				this.options.zoomAnimation;

		// zoom transitions run with the same duration for all layers, so if one of transitionend events
		// happens after starting zoom animation (propagating to the map pane), we know that it ended globally
		if (this._zoomAnimated) {
			this._createAnimProxy();
			on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
		}

		this._addLayers(this.options.layers);
	},


	// @section Methods for modifying map state

	// @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
	// Sets the view of the map (geographical center and zoom) with the given
	// animation options.
	setView: function (center, zoom, options) {

		zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
		center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
		options = options || {};

		this._stop();

		if (this._loaded && !options.reset && options !== true) {

			if (options.animate !== undefined) {
				options.zoom = extend({animate: options.animate}, options.zoom);
				options.pan = extend({animate: options.animate, duration: options.duration}, options.pan);
			}

			// try animating pan or zoom
			var moved = (this._zoom !== zoom) ?
				this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) :
				this._tryAnimatedPan(center, options.pan);

			if (moved) {
				// prevent resize handler call, the view will refresh after animation anyway
				clearTimeout(this._sizeTimer);
				return this;
			}
		}

		// animation didn't start, just reset the map view
		this._resetView(center, zoom);

		return this;
	},

	// @method setZoom(zoom: Number, options?: Zoom/pan options): this
	// Sets the zoom of the map.
	setZoom: function (zoom, options) {
		if (!this._loaded) {
			this._zoom = zoom;
			return this;
		}
		return this.setView(this.getCenter(), zoom, {zoom: options});
	},

	// @method zoomIn(delta?: Number, options?: Zoom options): this
	// Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
	zoomIn: function (delta, options) {
		delta = delta || (any3d ? this.options.zoomDelta : 1);
		return this.setZoom(this._zoom + delta, options);
	},

	// @method zoomOut(delta?: Number, options?: Zoom options): this
	// Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
	zoomOut: function (delta, options) {
		delta = delta || (any3d ? this.options.zoomDelta : 1);
		return this.setZoom(this._zoom - delta, options);
	},

	// @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
	// Zooms the map while keeping a specified geographical point on the map
	// stationary (e.g. used internally for scroll zoom and double-click zoom).
	// @alternative
	// @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
	// Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
	setZoomAround: function (latlng, zoom, options) {
		var scale = this.getZoomScale(zoom),
		    viewHalf = this.getSize().divideBy(2),
		    containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng),

		    centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale),
		    newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));

		return this.setView(newCenter, zoom, {zoom: options});
	},

	_getBoundsCenterZoom: function (bounds, options) {

		options = options || {};
		bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);

		var paddingTL = toPoint(options.paddingTopLeft || options.padding || [0, 0]),
		    paddingBR = toPoint(options.paddingBottomRight || options.padding || [0, 0]),

		    zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));

		zoom = (typeof options.maxZoom === 'number') ? Math.min(options.maxZoom, zoom) : zoom;

		if (zoom === Infinity) {
			return {
				center: bounds.getCenter(),
				zoom: zoom
			};
		}

		var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2),

		    swPoint = this.project(bounds.getSouthWest(), zoom),
		    nePoint = this.project(bounds.getNorthEast(), zoom),
		    center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);

		return {
			center: center,
			zoom: zoom
		};
	},

	// @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
	// Sets a map view that contains the given geographical bounds with the
	// maximum zoom level possible.
	fitBounds: function (bounds, options) {

		bounds = toLatLngBounds(bounds);

		if (!bounds.isValid()) {
			throw new Error('Bounds are not valid.');
		}

		var target = this._getBoundsCenterZoom(bounds, options);
		return this.setView(target.center, target.zoom, options);
	},

	// @method fitWorld(options?: fitBounds options): this
	// Sets a map view that mostly contains the whole world with the maximum
	// zoom level possible.
	fitWorld: function (options) {
		return this.fitBounds([[-90, -180], [90, 180]], options);
	},

	// @method panTo(latlng: LatLng, options?: Pan options): this
	// Pans the map to a given center.
	panTo: function (center, options) { // (LatLng)
		return this.setView(center, this._zoom, {pan: options});
	},

	// @method panBy(offset: Point, options?: Pan options): this
	// Pans the map by a given number of pixels (animated).
	panBy: function (offset, options) {
		offset = toPoint(offset).round();
		options = options || {};

		if (!offset.x && !offset.y) {
			return this.fire('moveend');
		}
		// If we pan too far, Chrome gets issues with tiles
		// and makes them disappear or appear in the wrong place (slightly offset) #2602
		if (options.animate !== true && !this.getSize().contains(offset)) {
			this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
			return this;
		}

		if (!this._panAnim) {
			this._panAnim = new PosAnimation();

			this._panAnim.on({
				'step': this._onPanTransitionStep,
				'end': this._onPanTransitionEnd
			}, this);
		}

		// don't fire movestart if animating inertia
		if (!options.noMoveStart) {
			this.fire('movestart');
		}

		// animate pan unless animate: false specified
		if (options.animate !== false) {
			addClass(this._mapPane, 'leaflet-pan-anim');

			var newPos = this._getMapPanePos().subtract(offset).round();
			this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
		} else {
			this._rawPanBy(offset);
			this.fire('move').fire('moveend');
		}

		return this;
	},

	// @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
	// Sets the view of the map (geographical center and zoom) performing a smooth
	// pan-zoom animation.
	flyTo: function (targetCenter, targetZoom, options) {

		options = options || {};
		if (options.animate === false || !any3d) {
			return this.setView(targetCenter, targetZoom, options);
		}

		this._stop();

		var from = this.project(this.getCenter()),
		    to = this.project(targetCenter),
		    size = this.getSize(),
		    startZoom = this._zoom;

		targetCenter = toLatLng(targetCenter);
		targetZoom = targetZoom === undefined ? startZoom : targetZoom;

		var w0 = Math.max(size.x, size.y),
		    w1 = w0 * this.getZoomScale(startZoom, targetZoom),
		    u1 = (to.distanceTo(from)) || 1,
		    rho = 1.42,
		    rho2 = rho * rho;

		function r(i) {
			var s1 = i ? -1 : 1,
			    s2 = i ? w1 : w0,
			    t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1,
			    b1 = 2 * s2 * rho2 * u1,
			    b = t1 / b1,
			    sq = Math.sqrt(b * b + 1) - b;

			    // workaround for floating point precision bug when sq = 0, log = -Infinite,
			    // thus triggering an infinite loop in flyTo
			    var log = sq < 0.000000001 ? -18 : Math.log(sq);

			return log;
		}

		function sinh(n) { return (Math.exp(n) - Math.exp(-n)) / 2; }
		function cosh(n) { return (Math.exp(n) + Math.exp(-n)) / 2; }
		function tanh(n) { return sinh(n) / cosh(n); }

		var r0 = r(0);

		function w(s) { return w0 * (cosh(r0) / cosh(r0 + rho * s)); }
		function u(s) { return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2; }

		function easeOut(t) { return 1 - Math.pow(1 - t, 1.5); }

		var start = Date.now(),
		    S = (r(1) - r0) / rho,
		    duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;

		function frame() {
			var t = (Date.now() - start) / duration,
			    s = easeOut(t) * S;

			if (t <= 1) {
				this._flyToFrame = requestAnimFrame(frame, this);

				this._move(
					this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom),
					this.getScaleZoom(w0 / w(s), startZoom),
					{flyTo: true});

			} else {
				this
					._move(targetCenter, targetZoom)
					._moveEnd(true);
			}
		}

		this._moveStart(true);

		frame.call(this);
		return this;
	},

	// @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
	// Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
	// but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
	flyToBounds: function (bounds, options) {
		var target = this._getBoundsCenterZoom(bounds, options);
		return this.flyTo(target.center, target.zoom, options);
	},

	// @method setMaxBounds(bounds: Bounds): this
	// Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
	setMaxBounds: function (bounds) {
		bounds = toLatLngBounds(bounds);

		if (!bounds.isValid()) {
			this.options.maxBounds = null;
			return this.off('moveend', this._panInsideMaxBounds);
		} else if (this.options.maxBounds) {
			this.off('moveend', this._panInsideMaxBounds);
		}

		this.options.maxBounds = bounds;

		if (this._loaded) {
			this._panInsideMaxBounds();
		}

		return this.on('moveend', this._panInsideMaxBounds);
	},

	// @method setMinZoom(zoom: Number): this
	// Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
	setMinZoom: function (zoom) {
		this.options.minZoom = zoom;

		if (this._loaded && this.getZoom() < this.options.minZoom) {
			return this.setZoom(zoom);
		}

		return this;
	},

	// @method setMaxZoom(zoom: Number): this
	// Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
	setMaxZoom: function (zoom) {
		this.options.maxZoom = zoom;

		if (this._loaded && (this.getZoom() > this.options.maxZoom)) {
			return this.setZoom(zoom);
		}

		return this;
	},

	// @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
	// Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
	panInsideBounds: function (bounds, options) {
		this._enforcingBounds = true;
		var center = this.getCenter(),
		    newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));

		if (!center.equals(newCenter)) {
			this.panTo(newCenter, options);
		}

		this._enforcingBounds = false;
		return this;
	},

	// @method invalidateSize(options: Zoom/Pan options): this
	// Checks if the map container size changed and updates the map if so —
	// call it after you've changed the map size dynamically, also animating
	// pan by default. If `options.pan` is `false`, panning will not occur.
	// If `options.debounceMoveend` is `true`, it will delay `moveend` event so
	// that it doesn't happen often even if the method is called many
	// times in a row.

	// @alternative
	// @method invalidateSize(animate: Boolean): this
	// Checks if the map container size changed and updates the map if so —
	// call it after you've changed the map size dynamically, also animating
	// pan by default.
	invalidateSize: function (options) {
		if (!this._loaded) { return this; }

		options = extend({
			animate: false,
			pan: true
		}, options === true ? {animate: true} : options);

		var oldSize = this.getSize();
		this._sizeChanged = true;
		this._lastCenter = null;

		var newSize = this.getSize(),
		    oldCenter = oldSize.divideBy(2).round(),
		    newCenter = newSize.divideBy(2).round(),
		    offset = oldCenter.subtract(newCenter);

		if (!offset.x && !offset.y) { return this; }

		if (options.animate && options.pan) {
			this.panBy(offset);

		} else {
			if (options.pan) {
				this._rawPanBy(offset);
			}

			this.fire('move');

			if (options.debounceMoveend) {
				clearTimeout(this._sizeTimer);
				this._sizeTimer = setTimeout(bind(this.fire, this, 'moveend'), 200);
			} else {
				this.fire('moveend');
			}
		}

		// @section Map state change events
		// @event resize: ResizeEvent
		// Fired when the map is resized.
		return this.fire('resize', {
			oldSize: oldSize,
			newSize: newSize
		});
	},

	// @section Methods for modifying map state
	// @method stop(): this
	// Stops the currently running `panTo` or `flyTo` animation, if any.
	stop: function () {
		this.setZoom(this._limitZoom(this._zoom));
		if (!this.options.zoomSnap) {
			this.fire('viewreset');
		}
		return this._stop();
	},

	// @section Geolocation methods
	// @method locate(options?: Locate options): this
	// Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
	// event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
	// and optionally sets the map view to the user's location with respect to
	// detection accuracy (or to the world view if geolocation failed).
	// Note that, if your page doesn't use HTTPS, this method will fail in
	// modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
	// See `Locate options` for more details.
	locate: function (options) {

		options = this._locateOptions = extend({
			timeout: 10000,
			watch: false
			// setView: false
			// maxZoom: <Number>
			// maximumAge: 0
			// enableHighAccuracy: false
		}, options);

		if (!('geolocation' in navigator)) {
			this._handleGeolocationError({
				code: 0,
				message: 'Geolocation not supported.'
			});
			return this;
		}

		var onResponse = bind(this._handleGeolocationResponse, this),
		    onError = bind(this._handleGeolocationError, this);

		if (options.watch) {
			this._locationWatchId =
			        navigator.geolocation.watchPosition(onResponse, onError, options);
		} else {
			navigator.geolocation.getCurrentPosition(onResponse, onError, options);
		}
		return this;
	},

	// @method stopLocate(): this
	// Stops watching location previously initiated by `map.locate({watch: true})`
	// and aborts resetting the map view if map.locate was called with
	// `{setView: true}`.
	stopLocate: function () {
		if (navigator.geolocation && navigator.geolocation.clearWatch) {
			navigator.geolocation.clearWatch(this._locationWatchId);
		}
		if (this._locateOptions) {
			this._locateOptions.setView = false;
		}
		return this;
	},

	_handleGeolocationError: function (error) {
		var c = error.code,
		    message = error.message ||
		            (c === 1 ? 'permission denied' :
		            (c === 2 ? 'position unavailable' : 'timeout'));

		if (this._locateOptions.setView && !this._loaded) {
			this.fitWorld();
		}

		// @section Location events
		// @event locationerror: ErrorEvent
		// Fired when geolocation (using the [`locate`](#map-locate) method) failed.
		this.fire('locationerror', {
			code: c,
			message: 'Geolocation error: ' + message + '.'
		});
	},

	_handleGeolocationResponse: function (pos) {
		var lat = pos.coords.latitude,
		    lng = pos.coords.longitude,
		    latlng = new LatLng(lat, lng),
		    bounds = latlng.toBounds(pos.coords.accuracy),
		    options = this._locateOptions;

		if (options.setView) {
			var zoom = this.getBoundsZoom(bounds);
			this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
		}

		var data = {
			latlng: latlng,
			bounds: bounds,
			timestamp: pos.timestamp
		};

		for (var i in pos.coords) {
			if (typeof pos.coords[i] === 'number') {
				data[i] = pos.coords[i];
			}
		}

		// @event locationfound: LocationEvent
		// Fired when geolocation (using the [`locate`](#map-locate) method)
		// went successfully.
		this.fire('locationfound', data);
	},

	// TODO handler.addTo
	// TODO Appropiate docs section?
	// @section Other Methods
	// @method addHandler(name: String, HandlerClass: Function): this
	// Adds a new `Handler` to the map, given its name and constructor function.
	addHandler: function (name, HandlerClass) {
		if (!HandlerClass) { return this; }

		var handler = this[name] = new HandlerClass(this);

		this._handlers.push(handler);

		if (this.options[name]) {
			handler.enable();
		}

		return this;
	},

	// @method remove(): this
	// Destroys the map and clears all related event listeners.
	remove: function () {

		this._initEvents(true);

		if (this._containerId !== this._container._leaflet_id) {
			throw new Error('Map container is being reused by another instance');
		}

		try {
			// throws error in IE6-8
			delete this._container._leaflet_id;
			delete this._containerId;
		} catch (e) {
			/*eslint-disable */
			this._container._leaflet_id = undefined;
			/*eslint-enable */
			this._containerId = undefined;
		}

		remove(this._mapPane);

		if (this._clearControlPos) {
			this._clearControlPos();
		}

		this._clearHandlers();

		if (this._loaded) {
			// @section Map state change events
			// @event unload: Event
			// Fired when the map is destroyed with [remove](#map-remove) method.
			this.fire('unload');
		}

		var i;
		for (i in this._layers) {
			this._layers[i].remove();
		}
		for (i in this._panes) {
			remove(this._panes[i]);
		}

		this._layers = [];
		this._panes = [];
		delete this._mapPane;
		delete this._renderer;

		return this;
	},

	// @section Other Methods
	// @method createPane(name: String, container?: HTMLElement): HTMLElement
	// Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
	// then returns it. The pane is created as a child of `container`, or
	// as a child of the main map pane if not set.
	createPane: function (name, container) {
		var className = 'leaflet-pane' + (name ? ' leaflet-' + name.replace('Pane', '') + '-pane' : ''),
		    pane = create$1('div', className, container || this._mapPane);

		if (name) {
			this._panes[name] = pane;
		}
		return pane;
	},

	// @section Methods for Getting Map State

	// @method getCenter(): LatLng
	// Returns the geographical center of the map view
	getCenter: function () {
		this._checkIfLoaded();

		if (this._lastCenter && !this._moved()) {
			return this._lastCenter;
		}
		return this.layerPointToLatLng(this._getCenterLayerPoint());
	},

	// @method getZoom(): Number
	// Returns the current zoom level of the map view
	getZoom: function () {
		return this._zoom;
	},

	// @method getBounds(): LatLngBounds
	// Returns the geographical bounds visible in the current map view
	getBounds: function () {
		var bounds = this.getPixelBounds(),
		    sw = this.unproject(bounds.getBottomLeft()),
		    ne = this.unproject(bounds.getTopRight());

		return new LatLngBounds(sw, ne);
	},

	// @method getMinZoom(): Number
	// Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
	getMinZoom: function () {
		return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
	},

	// @method getMaxZoom(): Number
	// Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
	getMaxZoom: function () {
		return this.options.maxZoom === undefined ?
			(this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom) :
			this.options.maxZoom;
	},

	// @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean): Number
	// Returns the maximum zoom level on which the given bounds fit to the map
	// view in its entirety. If `inside` (optional) is set to `true`, the method
	// instead returns the minimum zoom level on which the map view fits into
	// the given bounds in its entirety.
	getBoundsZoom: function (bounds, inside, padding) { // (LatLngBounds[, Boolean, Point]) -> Number
		bounds = toLatLngBounds(bounds);
		padding = toPoint(padding || [0, 0]);

		var zoom = this.getZoom() || 0,
		    min = this.getMinZoom(),
		    max = this.getMaxZoom(),
		    nw = bounds.getNorthWest(),
		    se = bounds.getSouthEast(),
		    size = this.getSize().subtract(padding),
		    boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(),
		    snap = any3d ? this.options.zoomSnap : 1,
		    scalex = size.x / boundsSize.x,
		    scaley = size.y / boundsSize.y,
		    scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);

		zoom = this.getScaleZoom(scale, zoom);

		if (snap) {
			zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
			zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
		}

		return Math.max(min, Math.min(max, zoom));
	},

	// @method getSize(): Point
	// Returns the current size of the map container (in pixels).
	getSize: function () {
		if (!this._size || this._sizeChanged) {
			this._size = new Point(
				this._container.clientWidth || 0,
				this._container.clientHeight || 0);

			this._sizeChanged = false;
		}
		return this._size.clone();
	},

	// @method getPixelBounds(): Bounds
	// Returns the bounds of the current map view in projected pixel
	// coordinates (sometimes useful in layer and overlay implementations).
	getPixelBounds: function (center, zoom) {
		var topLeftPoint = this._getTopLeftPoint(center, zoom);
		return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
	},

	// TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
	// the map pane? "left point of the map layer" can be confusing, specially
	// since there can be negative offsets.
	// @method getPixelOrigin(): Point
	// Returns the projected pixel coordinates of the top left point of
	// the map layer (useful in custom layer and overlay implementations).
	getPixelOrigin: function () {
		this._checkIfLoaded();
		return this._pixelOrigin;
	},

	// @method getPixelWorldBounds(zoom?: Number): Bounds
	// Returns the world's bounds in pixel coordinates for zoom level `zoom`.
	// If `zoom` is omitted, the map's current zoom level is used.
	getPixelWorldBounds: function (zoom) {
		return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
	},

	// @section Other Methods

	// @method getPane(pane: String|HTMLElement): HTMLElement
	// Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
	getPane: function (pane) {
		return typeof pane === 'string' ? this._panes[pane] : pane;
	},

	// @method getPanes(): Object
	// Returns a plain object containing the names of all [panes](#map-pane) as keys and
	// the panes as values.
	getPanes: function () {
		return this._panes;
	},

	// @method getContainer: HTMLElement
	// Returns the HTML element that contains the map.
	getContainer: function () {
		return this._container;
	},


	// @section Conversion Methods

	// @method getZoomScale(toZoom: Number, fromZoom: Number): Number
	// Returns the scale factor to be applied to a map transition from zoom level
	// `fromZoom` to `toZoom`. Used internally to help with zoom animations.
	getZoomScale: function (toZoom, fromZoom) {
		// TODO replace with universal implementation after refactoring projections
		var crs = this.options.crs;
		fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
		return crs.scale(toZoom) / crs.scale(fromZoom);
	},

	// @method getScaleZoom(scale: Number, fromZoom: Number): Number
	// Returns the zoom level that the map would end up at, if it is at `fromZoom`
	// level and everything is scaled by a factor of `scale`. Inverse of
	// [`getZoomScale`](#map-getZoomScale).
	getScaleZoom: function (scale, fromZoom) {
		var crs = this.options.crs;
		fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
		var zoom = crs.zoom(scale * crs.scale(fromZoom));
		return isNaN(zoom) ? Infinity : zoom;
	},

	// @method project(latlng: LatLng, zoom: Number): Point
	// Projects a geographical coordinate `LatLng` according to the projection
	// of the map's CRS, then scales it according to `zoom` and the CRS's
	// `Transformation`. The result is pixel coordinate relative to
	// the CRS origin.
	project: function (latlng, zoom) {
		zoom = zoom === undefined ? this._zoom : zoom;
		return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
	},

	// @method unproject(point: Point, zoom: Number): LatLng
	// Inverse of [`project`](#map-project).
	unproject: function (point, zoom) {
		zoom = zoom === undefined ? this._zoom : zoom;
		return this.options.crs.pointToLatLng(toPoint(point), zoom);
	},

	// @method layerPointToLatLng(point: Point): LatLng
	// Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
	// returns the corresponding geographical coordinate (for the current zoom level).
	layerPointToLatLng: function (point) {
		var projectedPoint = toPoint(point).add(this.getPixelOrigin());
		return this.unproject(projectedPoint);
	},

	// @method latLngToLayerPoint(latlng: LatLng): Point
	// Given a geographical coordinate, returns the corresponding pixel coordinate
	// relative to the [origin pixel](#map-getpixelorigin).
	latLngToLayerPoint: function (latlng) {
		var projectedPoint = this.project(toLatLng(latlng))._round();
		return projectedPoint._subtract(this.getPixelOrigin());
	},

	// @method wrapLatLng(latlng: LatLng): LatLng
	// Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
	// map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
	// CRS's bounds.
	// By default this means longitude is wrapped around the dateline so its
	// value is between -180 and +180 degrees.
	wrapLatLng: function (latlng) {
		return this.options.crs.wrapLatLng(toLatLng(latlng));
	},

	// @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
	// Returns a `LatLngBounds` with the same size as the given one, ensuring that
	// its center is within the CRS's bounds.
	// By default this means the center longitude is wrapped around the dateline so its
	// value is between -180 and +180 degrees, and the majority of the bounds
	// overlaps the CRS's bounds.
	wrapLatLngBounds: function (latlng) {
		return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
	},

	// @method distance(latlng1: LatLng, latlng2: LatLng): Number
	// Returns the distance between two geographical coordinates according to
	// the map's CRS. By default this measures distance in meters.
	distance: function (latlng1, latlng2) {
		return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
	},

	// @method containerPointToLayerPoint(point: Point): Point
	// Given a pixel coordinate relative to the map container, returns the corresponding
	// pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
	containerPointToLayerPoint: function (point) { // (Point)
		return toPoint(point).subtract(this._getMapPanePos());
	},

	// @method layerPointToContainerPoint(point: Point): Point
	// Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
	// returns the corresponding pixel coordinate relative to the map container.
	layerPointToContainerPoint: function (point) { // (Point)
		return toPoint(point).add(this._getMapPanePos());
	},

	// @method containerPointToLatLng(point: Point): LatLng
	// Given a pixel coordinate relative to the map container, returns
	// the corresponding geographical coordinate (for the current zoom level).
	containerPointToLatLng: function (point) {
		var layerPoint = this.containerPointToLayerPoint(toPoint(point));
		return this.layerPointToLatLng(layerPoint);
	},

	// @method latLngToContainerPoint(latlng: LatLng): Point
	// Given a geographical coordinate, returns the corresponding pixel coordinate
	// relative to the map container.
	latLngToContainerPoint: function (latlng) {
		return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
	},

	// @method mouseEventToContainerPoint(ev: MouseEvent): Point
	// Given a MouseEvent object, returns the pixel coordinate relative to the
	// map container where the event took place.
	mouseEventToContainerPoint: function (e) {
		return getMousePosition(e, this._container);
	},

	// @method mouseEventToLayerPoint(ev: MouseEvent): Point
	// Given a MouseEvent object, returns the pixel coordinate relative to
	// the [origin pixel](#map-getpixelorigin) where the event took place.
	mouseEventToLayerPoint: function (e) {
		return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
	},

	// @method mouseEventToLatLng(ev: MouseEvent): LatLng
	// Given a MouseEvent object, returns geographical coordinate where the
	// event took place.
	mouseEventToLatLng: function (e) { // (MouseEvent)
		return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
	},


	// map initialization methods

	_initContainer: function (id) {
		var container = this._container = get(id);

		if (!container) {
			throw new Error('Map container not found.');
		} else if (container._leaflet_id) {
			throw new Error('Map container is already initialized.');
		}

		on(container, 'scroll', this._onScroll, this);
		this._containerId = stamp(container);
	},

	_initLayout: function () {
		var container = this._container;

		this._fadeAnimated = this.options.fadeAnimation && any3d;

		addClass(container, 'leaflet-container' +
			(touch ? ' leaflet-touch' : '') +
			(retina ? ' leaflet-retina' : '') +
			(ielt9 ? ' leaflet-oldie' : '') +
			(safari ? ' leaflet-safari' : '') +
			(this._fadeAnimated ? ' leaflet-fade-anim' : ''));

		var position = getStyle(container, 'position');

		if (position !== 'absolute' && position !== 'relative' && position !== 'fixed') {
			container.style.position = 'relative';
		}

		this._initPanes();

		if (this._initControlPos) {
			this._initControlPos();
		}
	},

	_initPanes: function () {
		var panes = this._panes = {};
		this._paneRenderers = {};

		// @section
		//
		// Panes are DOM elements used to control the ordering of layers on the map. You
		// can access panes with [`map.getPane`](#map-getpane) or
		// [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
		// [`map.createPane`](#map-createpane) method.
		//
		// Every map has the following default panes that differ only in zIndex.
		//
		// @pane mapPane: HTMLElement = 'auto'
		// Pane that contains all other map panes

		this._mapPane = this.createPane('mapPane', this._container);
		setPosition(this._mapPane, new Point(0, 0));

		// @pane tilePane: HTMLElement = 200
		// Pane for `GridLayer`s and `TileLayer`s
		this.createPane('tilePane');
		// @pane overlayPane: HTMLElement = 400
		// Pane for vector overlays (`Path`s), like `Polyline`s and `Polygon`s
		this.createPane('shadowPane');
		// @pane shadowPane: HTMLElement = 500
		// Pane for overlay shadows (e.g. `Marker` shadows)
		this.createPane('overlayPane');
		// @pane markerPane: HTMLElement = 600
		// Pane for `Icon`s of `Marker`s
		this.createPane('markerPane');
		// @pane tooltipPane: HTMLElement = 650
		// Pane for tooltip.
		this.createPane('tooltipPane');
		// @pane popupPane: HTMLElement = 700
		// Pane for `Popup`s.
		this.createPane('popupPane');

		if (!this.options.markerZoomAnimation) {
			addClass(panes.markerPane, 'leaflet-zoom-hide');
			addClass(panes.shadowPane, 'leaflet-zoom-hide');
		}
	},


	// private methods that modify map state

	// @section Map state change events
	_resetView: function (center, zoom) {
		setPosition(this._mapPane, new Point(0, 0));

		var loading = !this._loaded;
		this._loaded = true;
		zoom = this._limitZoom(zoom);

		this.fire('viewprereset');

		var zoomChanged = this._zoom !== zoom;
		this
			._moveStart(zoomChanged)
			._move(center, zoom)
			._moveEnd(zoomChanged);

		// @event viewreset: Event
		// Fired when the map needs to redraw its content (this usually happens
		// on map zoom or load). Very useful for creating custom overlays.
		this.fire('viewreset');

		// @event load: Event
		// Fired when the map is initialized (when its center and zoom are set
		// for the first time).
		if (loading) {
			this.fire('load');
		}
	},

	_moveStart: function (zoomChanged) {
		// @event zoomstart: Event
		// Fired when the map zoom is about to change (e.g. before zoom animation).
		// @event movestart: Event
		// Fired when the view of the map starts changing (e.g. user starts dragging the map).
		if (zoomChanged) {
			this.fire('zoomstart');
		}
		return this.fire('movestart');
	},

	_move: function (center, zoom, data) {
		if (zoom === undefined) {
			zoom = this._zoom;
		}
		var zoomChanged = this._zoom !== zoom;

		this._zoom = zoom;
		this._lastCenter = center;
		this._pixelOrigin = this._getNewPixelOrigin(center);

		// @event zoom: Event
		// Fired repeatedly during any change in zoom level, including zoom
		// and fly animations.
		if (zoomChanged || (data && data.pinch)) {	// Always fire 'zoom' if pinching because #3530
			this.fire('zoom', data);
		}

		// @event move: Event
		// Fired repeatedly during any movement of the map, including pan and
		// fly animations.
		return this.fire('move', data);
	},

	_moveEnd: function (zoomChanged) {
		// @event zoomend: Event
		// Fired when the map has changed, after any animations.
		if (zoomChanged) {
			this.fire('zoomend');
		}

		// @event moveend: Event
		// Fired when the center of the map stops changing (e.g. user stopped
		// dragging the map).
		return this.fire('moveend');
	},

	_stop: function () {
		cancelAnimFrame(this._flyToFrame);
		if (this._panAnim) {
			this._panAnim.stop();
		}
		return this;
	},

	_rawPanBy: function (offset) {
		setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
	},

	_getZoomSpan: function () {
		return this.getMaxZoom() - this.getMinZoom();
	},

	_panInsideMaxBounds: function () {
		if (!this._enforcingBounds) {
			this.panInsideBounds(this.options.maxBounds);
		}
	},

	_checkIfLoaded: function () {
		if (!this._loaded) {
			throw new Error('Set map center and zoom first.');
		}
	},

	// DOM event handling

	// @section Interaction events
	_initEvents: function (remove$$1) {
		this._targets = {};
		this._targets[stamp(this._container)] = this;

		var onOff = remove$$1 ? off : on;

		// @event click: MouseEvent
		// Fired when the user clicks (or taps) the map.
		// @event dblclick: MouseEvent
		// Fired when the user double-clicks (or double-taps) the map.
		// @event mousedown: MouseEvent
		// Fired when the user pushes the mouse button on the map.
		// @event mouseup: MouseEvent
		// Fired when the user releases the mouse button on the map.
		// @event mouseover: MouseEvent
		// Fired when the mouse enters the map.
		// @event mouseout: MouseEvent
		// Fired when the mouse leaves the map.
		// @event mousemove: MouseEvent
		// Fired while the mouse moves over the map.
		// @event contextmenu: MouseEvent
		// Fired when the user pushes the right mouse button on the map, prevents
		// default browser context menu from showing if there are listeners on
		// this event. Also fired on mobile when the user holds a single touch
		// for a second (also called long press).
		// @event keypress: KeyboardEvent
		// Fired when the user presses a key from the keyboard while the map is focused.
		onOff(this._container, 'click dblclick mousedown mouseup ' +
			'mouseover mouseout mousemove contextmenu keypress', this._handleDOMEvent, this);

		if (this.options.trackResize) {
			onOff(window, 'resize', this._onResize, this);
		}

		if (any3d && this.options.transform3DLimit) {
			(remove$$1 ? this.off : this.on).call(this, 'moveend', this._onMoveEnd);
		}
	},

	_onResize: function () {
		cancelAnimFrame(this._resizeRequest);
		this._resizeRequest = requestAnimFrame(
		        function () { this.invalidateSize({debounceMoveend: true}); }, this);
	},

	_onScroll: function () {
		this._container.scrollTop  = 0;
		this._container.scrollLeft = 0;
	},

	_onMoveEnd: function () {
		var pos = this._getMapPanePos();
		if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) {
			// https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
			// a pixel offset on very high values, see: http://jsfiddle.net/dg6r5hhb/
			this._resetView(this.getCenter(), this.getZoom());
		}
	},

	_findEventTargets: function (e, type) {
		var targets = [],
		    target,
		    isHover = type === 'mouseout' || type === 'mouseover',
		    src = e.target || e.srcElement,
		    dragging = false;

		while (src) {
			target = this._targets[stamp(src)];
			if (target && (type === 'click' || type === 'preclick') && !e._simulated && this._draggableMoved(target)) {
				// Prevent firing click after you just dragged an object.
				dragging = true;
				break;
			}
			if (target && target.listens(type, true)) {
				if (isHover && !isExternalTarget(src, e)) { break; }
				targets.push(target);
				if (isHover) { break; }
			}
			if (src === this._container) { break; }
			src = src.parentNode;
		}
		if (!targets.length && !dragging && !isHover && isExternalTarget(src, e)) {
			targets = [this];
		}
		return targets;
	},

	_handleDOMEvent: function (e) {
		if (!this._loaded || skipped(e)) { return; }

		var type = e.type;

		if (type === 'mousedown' || type === 'keypress') {
			// prevents outline when clicking on keyboard-focusable element
			preventOutline(e.target || e.srcElement);
		}

		this._fireDOMEvent(e, type);
	},

	_mouseEvents: ['click', 'dblclick', 'mouseover', 'mouseout', 'contextmenu'],

	_fireDOMEvent: function (e, type, targets) {

		if (e.type === 'click') {
			// Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
			// @event preclick: MouseEvent
			// Fired before mouse click on the map (sometimes useful when you
			// want something to happen on click before any existing click
			// handlers start running).
			var synth = extend({}, e);
			synth.type = 'preclick';
			this._fireDOMEvent(synth, synth.type, targets);
		}

		if (e._stopped) { return; }

		// Find the layer the event is propagating from and its parents.
		targets = (targets || []).concat(this._findEventTargets(e, type));

		if (!targets.length) { return; }

		var target = targets[0];
		if (type === 'contextmenu' && target.listens(type, true)) {
			preventDefault(e);
		}

		var data = {
			originalEvent: e
		};

		if (e.type !== 'keypress') {
			var isMarker = (target.options && 'icon' in target.options);
			data.containerPoint = isMarker ?
					this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
			data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
			data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
		}

		for (var i = 0; i < targets.length; i++) {
			targets[i].fire(type, data, true);
			if (data.originalEvent._stopped ||
				(targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1)) { return; }
		}
	},

	_draggableMoved: function (obj) {
		obj = obj.dragging && obj.dragging.enabled() ? obj : this;
		return (obj.dragging && obj.dragging.moved()) || (this.boxZoom && this.boxZoom.moved());
	},

	_clearHandlers: function () {
		for (var i = 0, len = this._handlers.length; i < len; i++) {
			this._handlers[i].disable();
		}
	},

	// @section Other Methods

	// @method whenReady(fn: Function, context?: Object): this
	// Runs the given function `fn` when the map gets initialized with
	// a view (center and zoom) and at least one layer, or immediately
	// if it's already initialized, optionally passing a function context.
	whenReady: function (callback, context) {
		if (this._loaded) {
			callback.call(context || this, {target: this});
		} else {
			this.on('load', callback, context);
		}
		return this;
	},


	// private methods for getting map state

	_getMapPanePos: function () {
		return getPosition(this._mapPane) || new Point(0, 0);
	},

	_moved: function () {
		var pos = this._getMapPanePos();
		return pos && !pos.equals([0, 0]);
	},

	_getTopLeftPoint: function (center, zoom) {
		var pixelOrigin = center && zoom !== undefined ?
			this._getNewPixelOrigin(center, zoom) :
			this.getPixelOrigin();
		return pixelOrigin.subtract(this._getMapPanePos());
	},

	_getNewPixelOrigin: function (center, zoom) {
		var viewHalf = this.getSize()._divideBy(2);
		return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
	},

	_latLngToNewLayerPoint: function (latlng, zoom, center) {
		var topLeft = this._getNewPixelOrigin(center, zoom);
		return this.project(latlng, zoom)._subtract(topLeft);
	},

	_latLngBoundsToNewLayerBounds: function (latLngBounds, zoom, center) {
		var topLeft = this._getNewPixelOrigin(center, zoom);
		return toBounds([
			this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
			this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
			this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
			this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
		]);
	},

	// layer point of the current center
	_getCenterLayerPoint: function () {
		return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
	},

	// offset of the specified place to the current center in pixels
	_getCenterOffset: function (latlng) {
		return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
	},

	// adjust center for view to get inside bounds
	_limitCenter: function (center, zoom, bounds) {

		if (!bounds) { return center; }

		var centerPoint = this.project(center, zoom),
		    viewHalf = this.getSize().divideBy(2),
		    viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)),
		    offset = this._getBoundsOffset(viewBounds, bounds, zoom);

		// If offset is less than a pixel, ignore.
		// This prevents unstable projections from getting into
		// an infinite loop of tiny offsets.
		if (offset.round().equals([0, 0])) {
			return center;
		}

		return this.unproject(centerPoint.add(offset), zoom);
	},

	// adjust offset for view to get inside bounds
	_limitOffset: function (offset, bounds) {
		if (!bounds) { return offset; }

		var viewBounds = this.getPixelBounds(),
		    newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));

		return offset.add(this._getBoundsOffset(newBounds, bounds));
	},

	// returns offset needed for pxBounds to get inside maxBounds at a specified zoom
	_getBoundsOffset: function (pxBounds, maxBounds, zoom) {
		var projectedMaxBounds = toBounds(
		        this.project(maxBounds.getNorthEast(), zoom),
		        this.project(maxBounds.getSouthWest(), zoom)
		    ),
		    minOffset = projectedMaxBounds.min.subtract(pxBounds.min),
		    maxOffset = projectedMaxBounds.max.subtract(pxBounds.max),

		    dx = this._rebound(minOffset.x, -maxOffset.x),
		    dy = this._rebound(minOffset.y, -maxOffset.y);

		return new Point(dx, dy);
	},

	_rebound: function (left, right) {
		return left + right > 0 ?
			Math.round(left - right) / 2 :
			Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
	},

	_limitZoom: function (zoom) {
		var min = this.getMinZoom(),
		    max = this.getMaxZoom(),
		    snap = any3d ? this.options.zoomSnap : 1;
		if (snap) {
			zoom = Math.round(zoom / snap) * snap;
		}
		return Math.max(min, Math.min(max, zoom));
	},

	_onPanTransitionStep: function () {
		this.fire('move');
	},

	_onPanTransitionEnd: function () {
		removeClass(this._mapPane, 'leaflet-pan-anim');
		this.fire('moveend');
	},

	_tryAnimatedPan: function (center, options) {
		// difference between the new and current centers in pixels
		var offset = this._getCenterOffset(center)._floor();

		// don't animate too far unless animate: true specified in options
		if ((options && options.animate) !== true && !this.getSize().contains(offset)) { return false; }

		this.panBy(offset, options);

		return true;
	},

	_createAnimProxy: function () {

		var proxy = this._proxy = create$1('div', 'leaflet-proxy leaflet-zoom-animated');
		this._panes.mapPane.appendChild(proxy);

		this.on('zoomanim', function (e) {
			var prop = TRANSFORM,
			    transform = this._proxy.style[prop];

			setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));

			// workaround for case when transform is the same and so transitionend event is not fired
			if (transform === this._proxy.style[prop] && this._animatingZoom) {
				this._onZoomTransitionEnd();
			}
		}, this);

		this.on('load moveend', function () {
			var c = this.getCenter(),
			    z = this.getZoom();
			setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
		}, this);

		this._on('unload', this._destroyAnimProxy, this);
	},

	_destroyAnimProxy: function () {
		remove(this._proxy);
		delete this._proxy;
	},

	_catchTransitionEnd: function (e) {
		if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) {
			this._onZoomTransitionEnd();
		}
	},

	_nothingToAnimate: function () {
		return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
	},

	_tryAnimatedZoom: function (center, zoom, options) {

		if (this._animatingZoom) { return true; }

		options = options || {};

		// don't animate if disabled, not supported or zoom difference is too large
		if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() ||
		        Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) { return false; }

		// offset is the pixel coords of the zoom origin relative to the current center
		var scale = this.getZoomScale(zoom),
		    offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);

		// don't animate if the zoom origin isn't within one screen from the current center, unless forced
		if (options.animate !== true && !this.getSize().contains(offset)) { return false; }

		requestAnimFrame(function () {
			this
			    ._moveStart(true)
			    ._animateZoom(center, zoom, true);
		}, this);

		return true;
	},

	_animateZoom: function (center, zoom, startAnim, noUpdate) {
		if (startAnim) {
			this._animatingZoom = true;

			// remember what center/zoom to set after animation
			this._animateToCenter = center;
			this._animateToZoom = zoom;

			addClass(this._mapPane, 'leaflet-zoom-anim');
		}

		// @event zoomanim: ZoomAnimEvent
		// Fired on every frame of a zoom animation
		this.fire('zoomanim', {
			center: center,
			zoom: zoom,
			noUpdate: noUpdate
		});

		// Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
		setTimeout(bind(this._onZoomTransitionEnd, this), 250);
	},

	_onZoomTransitionEnd: function () {
		if (!this._animatingZoom) { return; }

		removeClass(this._mapPane, 'leaflet-zoom-anim');

		this._animatingZoom = false;

		this._move(this._animateToCenter, this._animateToZoom);

		// This anim frame should prevent an obscure iOS webkit tile loading race condition.
		requestAnimFrame(function () {
			this._moveEnd(true);
		}, this);
	}
});

// @section

// @factory L.map(id: String, options?: Map options)
// Instantiates a map object given the DOM ID of a `<div>` element
// and optionally an object literal with `Map options`.
//
// @alternative
// @factory L.map(el: HTMLElement, options?: Map options)
// Instantiates a map object given an instance of a `<div>` HTML element
// and optionally an object literal with `Map options`.
function createMap(id, options) {
	return new Map(id, options);
}

/*
 * @class Control
 * @aka L.Control
 * @inherits Class
 *
 * L.Control is a base class for implementing map controls. Handles positioning.
 * All other controls extend from this class.
 */

var Control = Class.extend({
	// @section
	// @aka Control options
	options: {
		// @option position: String = 'topright'
		// The position of the control (one of the map corners). Possible values are `'topleft'`,
		// `'topright'`, `'bottomleft'` or `'bottomright'`
		position: 'topright'
	},

	initialize: function (options) {
		setOptions(this, options);
	},

	/* @section
	 * Classes extending L.Control will inherit the following methods:
	 *
	 * @method getPosition: string
	 * Returns the position of the control.
	 */
	getPosition: function () {
		return this.options.position;
	},

	// @method setPosition(position: string): this
	// Sets the position of the control.
	setPosition: function (position) {
		var map = this._map;

		if (map) {
			map.removeControl(this);
		}

		this.options.position = position;

		if (map) {
			map.addControl(this);
		}

		return this;
	},

	// @method getContainer: HTMLElement
	// Returns the HTMLElement that contains the control.
	getContainer: function () {
		return this._container;
	},

	// @method addTo(map: Map): this
	// Adds the control to the given map.
	addTo: function (map) {
		this.remove();
		this._map = map;

		var container = this._container = this.onAdd(map),
		    pos = this.getPosition(),
		    corner = map._controlCorners[pos];

		addClass(container, 'leaflet-control');

		if (pos.indexOf('bottom') !== -1) {
			corner.insertBefore(container, corner.firstChild);
		} else {
			corner.appendChild(container);
		}

		return this;
	},

	// @method remove: this
	// Removes the control from the map it is currently active on.
	remove: function () {
		if (!this._map) {
			return this;
		}

		remove(this._container);

		if (this.onRemove) {
			this.onRemove(this._map);
		}

		this._map = null;

		return this;
	},

	_refocusOnMap: function (e) {
		// if map exists and event is not a keyboard event
		if (this._map && e && e.screenX > 0 && e.screenY > 0) {
			this._map.getContainer().focus();
		}
	}
});

var control = function (options) {
	return new Control(options);
};

/* @section Extension methods
 * @uninheritable
 *
 * Every control should extend from `L.Control` and (re-)implement the following methods.
 *
 * @method onAdd(map: Map): HTMLElement
 * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
 *
 * @method onRemove(map: Map)
 * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
 */

/* @namespace Map
 * @section Methods for Layers and Controls
 */
Map.include({
	// @method addControl(control: Control): this
	// Adds the given control to the map
	addControl: function (control) {
		control.addTo(this);
		return this;
	},

	// @method removeControl(control: Control): this
	// Removes the given control from the map
	removeControl: function (control) {
		control.remove();
		return this;
	},

	_initControlPos: function () {
		var corners = this._controlCorners = {},
		    l = 'leaflet-',
		    container = this._controlContainer =
		            create$1('div', l + 'control-container', this._container);

		function createCorner(vSide, hSide) {
			var className = l + vSide + ' ' + l + hSide;

			corners[vSide + hSide] = create$1('div', className, container);
		}

		createCorner('top', 'left');
		createCorner('top', 'right');
		createCorner('bottom', 'left');
		createCorner('bottom', 'right');
	},

	_clearControlPos: function () {
		for (var i in this._controlCorners) {
			remove(this._controlCorners[i]);
		}
		remove(this._controlContainer);
		delete this._controlCorners;
		delete this._controlContainer;
	}
});

/*
 * @class Control.Layers
 * @aka L.Control.Layers
 * @inherits Control
 *
 * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](http://leafletjs.com/examples/layers-control/)). Extends `Control`.
 *
 * @example
 *
 * ```js
 * var baseLayers = {
 * 	"Mapbox": mapbox,
 * 	"OpenStreetMap": osm
 * };
 *
 * var overlays = {
 * 	"Marker": marker,
 * 	"Roads": roadsLayer
 * };
 *
 * L.control.layers(baseLayers, overlays).addTo(map);
 * ```
 *
 * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
 *
 * ```js
 * {
 *     "<someName1>": layer1,
 *     "<someName2>": layer2
 * }
 * ```
 *
 * The layer names can contain HTML, which allows you to add additional styling to the items:
 *
 * ```js
 * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
 * ```
 */

var Layers = Control.extend({
	// @section
	// @aka Control.Layers options
	options: {
		// @option collapsed: Boolean = true
		// If `true`, the control will be collapsed into an icon and expanded on mouse hover or touch.
		collapsed: true,
		position: 'topright',

		// @option autoZIndex: Boolean = true
		// If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
		autoZIndex: true,

		// @option hideSingleBase: Boolean = false
		// If `true`, the base layers in the control will be hidden when there is only one.
		hideSingleBase: false,

		// @option sortLayers: Boolean = false
		// Whether to sort the layers. When `false`, layers will keep the order
		// in which they were added to the control.
		sortLayers: false,

		// @option sortFunction: Function = *
		// A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
		// that will be used for sorting the layers, when `sortLayers` is `true`.
		// The function receives both the `L.Layer` instances and their names, as in
		// `sortFunction(layerA, layerB, nameA, nameB)`.
		// By default, it sorts layers alphabetically by their name.
		sortFunction: function (layerA, layerB, nameA, nameB) {
			return nameA < nameB ? -1 : (nameB < nameA ? 1 : 0);
		}
	},

	initialize: function (baseLayers, overlays, options) {
		setOptions(this, options);

		this._layerControlInputs = [];
		this._layers = [];
		this._lastZIndex = 0;
		this._handlingClick = false;

		for (var i in baseLayers) {
			this._addLayer(baseLayers[i], i);
		}

		for (i in overlays) {
			this._addLayer(overlays[i], i, true);
		}
	},

	onAdd: function (map) {
		this._initLayout();
		this._update();

		this._map = map;
		map.on('zoomend', this._checkDisabledLayers, this);

		for (var i = 0; i < this._layers.length; i++) {
			this._layers[i].layer.on('add remove', this._onLayerChange, this);
		}

		return this._container;
	},

	addTo: function (map) {
		Control.prototype.addTo.call(this, map);
		// Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
		return this._expandIfNotCollapsed();
	},

	onRemove: function () {
		this._map.off('zoomend', this._checkDisabledLayers, this);

		for (var i = 0; i < this._layers.length; i++) {
			this._layers[i].layer.off('add remove', this._onLayerChange, this);
		}
	},

	// @method addBaseLayer(layer: Layer, name: String): this
	// Adds a base layer (radio button entry) with the given name to the control.
	addBaseLayer: function (layer, name) {
		this._addLayer(layer, name);
		return (this._map) ? this._update() : this;
	},

	// @method addOverlay(layer: Layer, name: String): this
	// Adds an overlay (checkbox entry) with the given name to the control.
	addOverlay: function (layer, name) {
		this._addLayer(layer, name, true);
		return (this._map) ? this._update() : this;
	},

	// @method removeLayer(layer: Layer): this
	// Remove the given layer from the control.
	removeLayer: function (layer) {
		layer.off('add remove', this._onLayerChange, this);

		var obj = this._getLayer(stamp(layer));
		if (obj) {
			this._layers.splice(this._layers.indexOf(obj), 1);
		}
		return (this._map) ? this._update() : this;
	},

	// @method expand(): this
	// Expand the control container if collapsed.
	expand: function () {
		addClass(this._container, 'leaflet-control-layers-expanded');
		this._form.style.height = null;
		var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
		if (acceptableHeight < this._form.clientHeight) {
			addClass(this._form, 'leaflet-control-layers-scrollbar');
			this._form.style.height = acceptableHeight + 'px';
		} else {
			removeClass(this._form, 'leaflet-control-layers-scrollbar');
		}
		this._checkDisabledLayers();
		return this;
	},

	// @method collapse(): this
	// Collapse the control container if expanded.
	collapse: function () {
		removeClass(this._container, 'leaflet-control-layers-expanded');
		return this;
	},

	_initLayout: function () {
		var className = 'leaflet-control-layers',
		    container = this._container = create$1('div', className),
		    collapsed = this.options.collapsed;

		// makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
		container.setAttribute('aria-haspopup', true);

		disableClickPropagation(container);
		disableScrollPropagation(container);

		var form = this._form = create$1('form', className + '-list');

		if (collapsed) {
			this._map.on('click', this.collapse, this);

			if (!android) {
				on(container, {
					mouseenter: this.expand,
					mouseleave: this.collapse
				}, this);
			}
		}

		var link = this._layersLink = create$1('a', className + '-toggle', container);
		link.href = '#';
		link.title = 'Layers';

		if (touch) {
			on(link, 'click', stop);
			on(link, 'click', this.expand, this);
		} else {
			on(link, 'focus', this.expand, this);
		}

		if (!collapsed) {
			this.expand();
		}

		this._baseLayersList = create$1('div', className + '-base', form);
		this._separator = create$1('div', className + '-separator', form);
		this._overlaysList = create$1('div', className + '-overlays', form);

		container.appendChild(form);
	},

	_getLayer: function (id) {
		for (var i = 0; i < this._layers.length; i++) {

			if (this._layers[i] && stamp(this._layers[i].layer) === id) {
				return this._layers[i];
			}
		}
	},

	_addLayer: function (layer, name, overlay) {
		if (this._map) {
			layer.on('add remove', this._onLayerChange, this);
		}

		this._layers.push({
			layer: layer,
			name: name,
			overlay: overlay
		});

		if (this.options.sortLayers) {
			this._layers.sort(bind(function (a, b) {
				return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
			}, this));
		}

		if (this.options.autoZIndex && layer.setZIndex) {
			this._lastZIndex++;
			layer.setZIndex(this._lastZIndex);
		}

		this._expandIfNotCollapsed();
	},

	_update: function () {
		if (!this._container) { return this; }

		empty(this._baseLayersList);
		empty(this._overlaysList);

		this._layerControlInputs = [];
		var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;

		for (i = 0; i < this._layers.length; i++) {
			obj = this._layers[i];
			this._addItem(obj);
			overlaysPresent = overlaysPresent || obj.overlay;
			baseLayersPresent = baseLayersPresent || !obj.overlay;
			baseLayersCount += !obj.overlay ? 1 : 0;
		}

		// Hide base layers section if there's only one layer.
		if (this.options.hideSingleBase) {
			baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
			this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
		}

		this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';

		return this;
	},

	_onLayerChange: function (e) {
		if (!this._handlingClick) {
			this._update();
		}

		var obj = this._getLayer(stamp(e.target));

		// @namespace Map
		// @section Layer events
		// @event baselayerchange: LayersControlEvent
		// Fired when the base layer is changed through the [layer control](#control-layers).
		// @event overlayadd: LayersControlEvent
		// Fired when an overlay is selected through the [layer control](#control-layers).
		// @event overlayremove: LayersControlEvent
		// Fired when an overlay is deselected through the [layer control](#control-layers).
		// @namespace Control.Layers
		var type = obj.overlay ?
			(e.type === 'add' ? 'overlayadd' : 'overlayremove') :
			(e.type === 'add' ? 'baselayerchange' : null);

		if (type) {
			this._map.fire(type, obj);
		}
	},

	// IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see http://bit.ly/PqYLBe)
	_createRadioElement: function (name, checked) {

		var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' +
				name + '"' + (checked ? ' checked="checked"' : '') + '/>';

		var radioFragment = document.createElement('div');
		radioFragment.innerHTML = radioHtml;

		return radioFragment.firstChild;
	},

	_addItem: function (obj) {
		var label = document.createElement('label'),
		    checked = this._map.hasLayer(obj.layer),
		    input;

		if (obj.overlay) {
			input = document.createElement('input');
			input.type = 'checkbox';
			input.className = 'leaflet-control-layers-selector';
			input.defaultChecked = checked;
		} else {
			input = this._createRadioElement('leaflet-base-layers', checked);
		}

		this._layerControlInputs.push(input);
		input.layerId = stamp(obj.layer);

		on(input, 'click', this._onInputClick, this);

		var name = document.createElement('span');
		name.innerHTML = ' ' + obj.name;

		// Helps from preventing layer control flicker when checkboxes are disabled
		// https://github.com/Leaflet/Leaflet/issues/2771
		var holder = document.createElement('div');

		label.appendChild(holder);
		holder.appendChild(input);
		holder.appendChild(name);

		var container = obj.overlay ? this._overlaysList : this._baseLayersList;
		container.appendChild(label);

		this._checkDisabledLayers();
		return label;
	},

	_onInputClick: function () {
		var inputs = this._layerControlInputs,
		    input, layer;
		var addedLayers = [],
		    removedLayers = [];

		this._handlingClick = true;

		for (var i = inputs.length - 1; i >= 0; i--) {
			input = inputs[i];
			layer = this._getLayer(input.layerId).layer;

			if (input.checked) {
				addedLayers.push(layer);
			} else if (!input.checked) {
				removedLayers.push(layer);
			}
		}

		// Bugfix issue 2318: Should remove all old layers before readding new ones
		for (i = 0; i < removedLayers.length; i++) {
			if (this._map.hasLayer(removedLayers[i])) {
				this._map.removeLayer(removedLayers[i]);
			}
		}
		for (i = 0; i < addedLayers.length; i++) {
			if (!this._map.hasLayer(addedLayers[i])) {
				this._map.addLayer(addedLayers[i]);
			}
		}

		this._handlingClick = false;

		this._refocusOnMap();
	},

	_checkDisabledLayers: function () {
		var inputs = this._layerControlInputs,
		    input,
		    layer,
		    zoom = this._map.getZoom();

		for (var i = inputs.length - 1; i >= 0; i--) {
			input = inputs[i];
			layer = this._getLayer(input.layerId).layer;
			input.disabled = (layer.options.minZoom !== undefined && zoom < layer.options.minZoom) ||
			                 (layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom);

		}
	},

	_expandIfNotCollapsed: function () {
		if (this._map && !this.options.collapsed) {
			this.expand();
		}
		return this;
	},

	_expand: function () {
		// Backward compatibility, remove me in 1.1.
		return this.expand();
	},

	_collapse: function () {
		// Backward compatibility, remove me in 1.1.
		return this.collapse();
	}

});


// @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
// Creates an attribution control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
var layers = function (baseLayers, overlays, options) {
	return new Layers(baseLayers, overlays, options);
};

/*
 * @class Control.Zoom
 * @aka L.Control.Zoom
 * @inherits Control
 *
 * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
 */

var Zoom = Control.extend({
	// @section
	// @aka Control.Zoom options
	options: {
		position: 'topleft',

		// @option zoomInText: String = '+'
		// The text set on the 'zoom in' button.
		zoomInText: '+',

		// @option zoomInTitle: String = 'Zoom in'
		// The title set on the 'zoom in' button.
		zoomInTitle: 'Zoom in',

		// @option zoomOutText: String = '&#x2212;'
		// The text set on the 'zoom out' button.
		zoomOutText: '&#x2212;',

		// @option zoomOutTitle: String = 'Zoom out'
		// The title set on the 'zoom out' button.
		zoomOutTitle: 'Zoom out'
	},

	onAdd: function (map) {
		var zoomName = 'leaflet-control-zoom',
		    container = create$1('div', zoomName + ' leaflet-bar'),
		    options = this.options;

		this._zoomInButton  = this._createButton(options.zoomInText, options.zoomInTitle,
		        zoomName + '-in',  container, this._zoomIn);
		this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle,
		        zoomName + '-out', container, this._zoomOut);

		this._updateDisabled();
		map.on('zoomend zoomlevelschange', this._updateDisabled, this);

		return container;
	},

	onRemove: function (map) {
		map.off('zoomend zoomlevelschange', this._updateDisabled, this);
	},

	disable: function () {
		this._disabled = true;
		this._updateDisabled();
		return this;
	},

	enable: function () {
		this._disabled = false;
		this._updateDisabled();
		return this;
	},

	_zoomIn: function (e) {
		if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) {
			this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
		}
	},

	_zoomOut: function (e) {
		if (!this._disabled && this._map._zoom > this._map.getMinZoom()) {
			this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
		}
	},

	_createButton: function (html, title, className, container, fn) {
		var link = create$1('a', className, container);
		link.innerHTML = html;
		link.href = '#';
		link.title = title;

		/*
		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
		 */
		link.setAttribute('role', 'button');
		link.setAttribute('aria-label', title);

		disableClickPropagation(link);
		on(link, 'click', stop);
		on(link, 'click', fn, this);
		on(link, 'click', this._refocusOnMap, this);

		return link;
	},

	_updateDisabled: function () {
		var map = this._map,
		    className = 'leaflet-disabled';

		removeClass(this._zoomInButton, className);
		removeClass(this._zoomOutButton, className);

		if (this._disabled || map._zoom === map.getMinZoom()) {
			addClass(this._zoomOutButton, className);
		}
		if (this._disabled || map._zoom === map.getMaxZoom()) {
			addClass(this._zoomInButton, className);
		}
	}
});

// @namespace Map
// @section Control options
// @option zoomControl: Boolean = true
// Whether a [zoom control](#control-zoom) is added to the map by default.
Map.mergeOptions({
	zoomControl: true
});

Map.addInitHook(function () {
	if (this.options.zoomControl) {
		this.zoomControl = new Zoom();
		this.addControl(this.zoomControl);
	}
});

// @namespace Control.Zoom
// @factory L.control.zoom(options: Control.Zoom options)
// Creates a zoom control
var zoom = function (options) {
	return new Zoom(options);
};

/*
 * @class Control.Scale
 * @aka L.Control.Scale
 * @inherits Control
 *
 * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
 *
 * @example
 *
 * ```js
 * L.control.scale().addTo(map);
 * ```
 */

var Scale = Control.extend({
	// @section
	// @aka Control.Scale options
	options: {
		position: 'bottomleft',

		// @option maxWidth: Number = 100
		// Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
		maxWidth: 100,

		// @option metric: Boolean = True
		// Whether to show the metric scale line (m/km).
		metric: true,

		// @option imperial: Boolean = True
		// Whether to show the imperial scale line (mi/ft).
		imperial: true

		// @option updateWhenIdle: Boolean = false
		// If `true`, the control is updated on [`moveend`](#map-moveend), otherwise it's always up-to-date (updated on [`move`](#map-move)).
	},

	onAdd: function (map) {
		var className = 'leaflet-control-scale',
		    container = create$1('div', className),
		    options = this.options;

		this._addScales(options, className + '-line', container);

		map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
		map.whenReady(this._update, this);

		return container;
	},

	onRemove: function (map) {
		map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
	},

	_addScales: function (options, className, container) {
		if (options.metric) {
			this._mScale = create$1('div', className, container);
		}
		if (options.imperial) {
			this._iScale = create$1('div', className, container);
		}
	},

	_update: function () {
		var map = this._map,
		    y = map.getSize().y / 2;

		var maxMeters = map.distance(
				map.containerPointToLatLng([0, y]),
				map.containerPointToLatLng([this.options.maxWidth, y]));

		this._updateScales(maxMeters);
	},

	_updateScales: function (maxMeters) {
		if (this.options.metric && maxMeters) {
			this._updateMetric(maxMeters);
		}
		if (this.options.imperial && maxMeters) {
			this._updateImperial(maxMeters);
		}
	},

	_updateMetric: function (maxMeters) {
		var meters = this._getRoundNum(maxMeters),
		    label = meters < 1000 ? meters + ' m' : (meters / 1000) + ' km';

		this._updateScale(this._mScale, label, meters / maxMeters);
	},

	_updateImperial: function (maxMeters) {
		var maxFeet = maxMeters * 3.2808399,
		    maxMiles, miles, feet;

		if (maxFeet > 5280) {
			maxMiles = maxFeet / 5280;
			miles = this._getRoundNum(maxMiles);
			this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);

		} else {
			feet = this._getRoundNum(maxFeet);
			this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
		}
	},

	_updateScale: function (scale, text, ratio) {
		scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
		scale.innerHTML = text;
	},

	_getRoundNum: function (num) {
		var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1),
		    d = num / pow10;

		d = d >= 10 ? 10 :
		    d >= 5 ? 5 :
		    d >= 3 ? 3 :
		    d >= 2 ? 2 : 1;

		return pow10 * d;
	}
});


// @factory L.control.scale(options?: Control.Scale options)
// Creates an scale control with the given options.
var scale = function (options) {
	return new Scale(options);
};

/*
 * @class Control.Attribution
 * @aka L.Control.Attribution
 * @inherits Control
 *
 * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
 */

var Attribution = Control.extend({
	// @section
	// @aka Control.Attribution options
	options: {
		position: 'bottomright',

		// @option prefix: String = 'Leaflet'
		// The HTML text shown before the attributions. Pass `false` to disable.
		prefix: '<a href="http://leafletjs.com" title="A JS library for interactive maps">Leaflet</a>'
	},

	initialize: function (options) {
		setOptions(this, options);

		this._attributions = {};
	},

	onAdd: function (map) {
		map.attributionControl = this;
		this._container = create$1('div', 'leaflet-control-attribution');
		disableClickPropagation(this._container);

		// TODO ugly, refactor
		for (var i in map._layers) {
			if (map._layers[i].getAttribution) {
				this.addAttribution(map._layers[i].getAttribution());
			}
		}

		this._update();

		return this._container;
	},

	// @method setPrefix(prefix: String): this
	// Sets the text before the attributions.
	setPrefix: function (prefix) {
		this.options.prefix = prefix;
		this._update();
		return this;
	},

	// @method addAttribution(text: String): this
	// Adds an attribution text (e.g. `'Vector data &copy; Mapbox'`).
	addAttribution: function (text) {
		if (!text) { return this; }

		if (!this._attributions[text]) {
			this._attributions[text] = 0;
		}
		this._attributions[text]++;

		this._update();

		return this;
	},

	// @method removeAttribution(text: String): this
	// Removes an attribution text.
	removeAttribution: function (text) {
		if (!text) { return this; }

		if (this._attributions[text]) {
			this._attributions[text]--;
			this._update();
		}

		return this;
	},

	_update: function () {
		if (!this._map) { return; }

		var attribs = [];

		for (var i in this._attributions) {
			if (this._attributions[i]) {
				attribs.push(i);
			}
		}

		var prefixAndAttribs = [];

		if (this.options.prefix) {
			prefixAndAttribs.push(this.options.prefix);
		}
		if (attribs.length) {
			prefixAndAttribs.push(attribs.join(', '));
		}

		this._container.innerHTML = prefixAndAttribs.join(' | ');
	}
});

// @namespace Map
// @section Control options
// @option attributionControl: Boolean = true
// Whether a [attribution control](#control-attribution) is added to the map by default.
Map.mergeOptions({
	attributionControl: true
});

Map.addInitHook(function () {
	if (this.options.attributionControl) {
		new Attribution().addTo(this);
	}
});

// @namespace Control.Attribution
// @factory L.control.attribution(options: Control.Attribution options)
// Creates an attribution control.
var attribution = function (options) {
	return new Attribution(options);
};

Control.Layers = Layers;
Control.Zoom = Zoom;
Control.Scale = Scale;
Control.Attribution = Attribution;

control.layers = layers;
control.zoom = zoom;
control.scale = scale;
control.attribution = attribution;

/*
	L.Handler is a base class for handler classes that are used internally to inject
	interaction features like dragging to classes like Map and Marker.
*/

// @class Handler
// @aka L.Handler
// Abstract class for map interaction handlers

var Handler = Class.extend({
	initialize: function (map) {
		this._map = map;
	},

	// @method enable(): this
	// Enables the handler
	enable: function () {
		if (this._enabled) { return this; }

		this._enabled = true;
		this.addHooks();
		return this;
	},

	// @method disable(): this
	// Disables the handler
	disable: function () {
		if (!this._enabled) { return this; }

		this._enabled = false;
		this.removeHooks();
		return this;
	},

	// @method enabled(): Boolean
	// Returns `true` if the handler is enabled
	enabled: function () {
		return !!this._enabled;
	}

	// @section Extension methods
	// Classes inheriting from `Handler` must implement the two following methods:
	// @method addHooks()
	// Called when the handler is enabled, should add event hooks.
	// @method removeHooks()
	// Called when the handler is disabled, should remove the event hooks added previously.
});

var Mixin = {Events: Events};

/*
 * @class Draggable
 * @aka L.Draggable
 * @inherits Evented
 *
 * A class for making DOM elements draggable (including touch support).
 * Used internally for map and marker dragging. Only works for elements
 * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
 *
 * @example
 * ```js
 * var draggable = new L.Draggable(elementToDrag);
 * draggable.enable();
 * ```
 */

var START = touch ? 'touchstart mousedown' : 'mousedown';
var END = {
	mousedown: 'mouseup',
	touchstart: 'touchend',
	pointerdown: 'touchend',
	MSPointerDown: 'touchend'
};
var MOVE = {
	mousedown: 'mousemove',
	touchstart: 'touchmove',
	pointerdown: 'touchmove',
	MSPointerDown: 'touchmove'
};


var Draggable = Evented.extend({

	options: {
		// @section
		// @aka Draggable options
		// @option clickTolerance: Number = 3
		// The max number of pixels a user can shift the mouse pointer during a click
		// for it to be considered a valid click (as opposed to a mouse drag).
		clickTolerance: 3
	},

	// @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
	// Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
	initialize: function (element, dragStartTarget, preventOutline$$1, options) {
		setOptions(this, options);

		this._element = element;
		this._dragStartTarget = dragStartTarget || element;
		this._preventOutline = preventOutline$$1;
	},

	// @method enable()
	// Enables the dragging ability
	enable: function () {
		if (this._enabled) { return; }

		on(this._dragStartTarget, START, this._onDown, this);

		this._enabled = true;
	},

	// @method disable()
	// Disables the dragging ability
	disable: function () {
		if (!this._enabled) { return; }

		// If we're currently dragging this draggable,
		// disabling it counts as first ending the drag.
		if (Draggable._dragging === this) {
			this.finishDrag();
		}

		off(this._dragStartTarget, START, this._onDown, this);

		this._enabled = false;
		this._moved = false;
	},

	_onDown: function (e) {
		// Ignore simulated events, since we handle both touch and
		// mouse explicitly; otherwise we risk getting duplicates of
		// touch events, see #4315.
		// Also ignore the event if disabled; this happens in IE11
		// under some circumstances, see #3666.
		if (e._simulated || !this._enabled) { return; }

		this._moved = false;

		if (hasClass(this._element, 'leaflet-zoom-anim')) { return; }

		if (Draggable._dragging || e.shiftKey || ((e.which !== 1) && (e.button !== 1) && !e.touches)) { return; }
		Draggable._dragging = this;  // Prevent dragging multiple objects at once.

		if (this._preventOutline) {
			preventOutline(this._element);
		}

		disableImageDrag();
		disableTextSelection();

		if (this._moving) { return; }

		// @event down: Event
		// Fired when a drag is about to start.
		this.fire('down');

		var first = e.touches ? e.touches[0] : e;

		this._startPoint = new Point(first.clientX, first.clientY);

		on(document, MOVE[e.type], this._onMove, this);
		on(document, END[e.type], this._onUp, this);
	},

	_onMove: function (e) {
		// Ignore simulated events, since we handle both touch and
		// mouse explicitly; otherwise we risk getting duplicates of
		// touch events, see #4315.
		// Also ignore the event if disabled; this happens in IE11
		// under some circumstances, see #3666.
		if (e._simulated || !this._enabled) { return; }

		if (e.touches && e.touches.length > 1) {
			this._moved = true;
			return;
		}

		var first = (e.touches && e.touches.length === 1 ? e.touches[0] : e),
		    newPoint = new Point(first.clientX, first.clientY),
		    offset = newPoint.subtract(this._startPoint);

		if (!offset.x && !offset.y) { return; }
		if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) { return; }

		preventDefault(e);

		if (!this._moved) {
			// @event dragstart: Event
			// Fired when a drag starts
			this.fire('dragstart');

			this._moved = true;
			this._startPos = getPosition(this._element).subtract(offset);

			addClass(document.body, 'leaflet-dragging');

			this._lastTarget = e.target || e.srcElement;
			// IE and Edge do not give the <use> element, so fetch it
			// if necessary
			if ((window.SVGElementInstance) && (this._lastTarget instanceof SVGElementInstance)) {
				this._lastTarget = this._lastTarget.correspondingUseElement;
			}
			addClass(this._lastTarget, 'leaflet-drag-target');
		}

		this._newPos = this._startPos.add(offset);
		this._moving = true;

		cancelAnimFrame(this._animRequest);
		this._lastEvent = e;
		this._animRequest = requestAnimFrame(this._updatePosition, this, true);
	},

	_updatePosition: function () {
		var e = {originalEvent: this._lastEvent};

		// @event predrag: Event
		// Fired continuously during dragging *before* each corresponding
		// update of the element's position.
		this.fire('predrag', e);
		setPosition(this._element, this._newPos);

		// @event drag: Event
		// Fired continuously during dragging.
		this.fire('drag', e);
	},

	_onUp: function (e) {
		// Ignore simulated events, since we handle both touch and
		// mouse explicitly; otherwise we risk getting duplicates of
		// touch events, see #4315.
		// Also ignore the event if disabled; this happens in IE11
		// under some circumstances, see #3666.
		if (e._simulated || !this._enabled) { return; }
		this.finishDrag();
	},

	finishDrag: function () {
		removeClass(document.body, 'leaflet-dragging');

		if (this._lastTarget) {
			removeClass(this._lastTarget, 'leaflet-drag-target');
			this._lastTarget = null;
		}

		for (var i in MOVE) {
			off(document, MOVE[i], this._onMove, this);
			off(document, END[i], this._onUp, this);
		}

		enableImageDrag();
		enableTextSelection();

		if (this._moved && this._moving) {
			// ensure drag is not fired after dragend
			cancelAnimFrame(this._animRequest);

			// @event dragend: DragEndEvent
			// Fired when the drag ends.
			this.fire('dragend', {
				distance: this._newPos.distanceTo(this._startPos)
			});
		}

		this._moving = false;
		Draggable._dragging = false;
	}

});

/*
 * @namespace LineUtil
 *
 * Various utility functions for polyine points processing, used by Leaflet internally to make polylines lightning-fast.
 */

// Simplify polyline with vertex reduction and Douglas-Peucker simplification.
// Improves rendering performance dramatically by lessening the number of points to draw.

// @function simplify(points: Point[], tolerance: Number): Point[]
// Dramatically reduces the number of points in a polyline while retaining
// its shape and returns a new array of simplified points, using the
// [Douglas-Peucker algorithm](http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm).
// Used for a huge performance boost when processing/displaying Leaflet polylines for
// each zoom level and also reducing visual noise. tolerance affects the amount of
// simplification (lesser value means higher quality but slower and with more points).
// Also released as a separated micro-library [Simplify.js](http://mourner.github.com/simplify-js/).
function simplify(points, tolerance) {
	if (!tolerance || !points.length) {
		return points.slice();
	}

	var sqTolerance = tolerance * tolerance;

	    // stage 1: vertex reduction
	    points = _reducePoints(points, sqTolerance);

	    // stage 2: Douglas-Peucker simplification
	    points = _simplifyDP(points, sqTolerance);

	return points;
}

// @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
// Returns the distance between point `p` and segment `p1` to `p2`.
function pointToSegmentDistance(p, p1, p2) {
	return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
}

// @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
// Returns the closest point from a point `p` on a segment `p1` to `p2`.
function closestPointOnSegment(p, p1, p2) {
	return _sqClosestPointOnSegment(p, p1, p2);
}

// Douglas-Peucker simplification, see http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm
function _simplifyDP(points, sqTolerance) {

	var len = points.length,
	    ArrayConstructor = typeof Uint8Array !== undefined + '' ? Uint8Array : Array,
	    markers = new ArrayConstructor(len);

	    markers[0] = markers[len - 1] = 1;

	_simplifyDPStep(points, markers, sqTolerance, 0, len - 1);

	var i,
	    newPoints = [];

	for (i = 0; i < len; i++) {
		if (markers[i]) {
			newPoints.push(points[i]);
		}
	}

	return newPoints;
}

function _simplifyDPStep(points, markers, sqTolerance, first, last) {

	var maxSqDist = 0,
	index, i, sqDist;

	for (i = first + 1; i <= last - 1; i++) {
		sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);

		if (sqDist > maxSqDist) {
			index = i;
			maxSqDist = sqDist;
		}
	}

	if (maxSqDist > sqTolerance) {
		markers[index] = 1;

		_simplifyDPStep(points, markers, sqTolerance, first, index);
		_simplifyDPStep(points, markers, sqTolerance, index, last);
	}
}

// reduce points that are too close to each other to a single point
function _reducePoints(points, sqTolerance) {
	var reducedPoints = [points[0]];

	for (var i = 1, prev = 0, len = points.length; i < len; i++) {
		if (_sqDist(points[i], points[prev]) > sqTolerance) {
			reducedPoints.push(points[i]);
			prev = i;
		}
	}
	if (prev < len - 1) {
		reducedPoints.push(points[len - 1]);
	}
	return reducedPoints;
}

var _lastCode;

// @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
// Clips the segment a to b by rectangular bounds with the
// [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
// (modifying the segment points directly!). Used by Leaflet to only show polyline
// points that are on the screen or near, increasing performance.
function clipSegment(a, b, bounds, useLastCode, round) {
	var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds),
	    codeB = _getBitCode(b, bounds),

	    codeOut, p, newCode;

	    // save 2nd code to avoid calculating it on the next segment
	    _lastCode = codeB;

	while (true) {
		// if a,b is inside the clip window (trivial accept)
		if (!(codeA | codeB)) {
			return [a, b];
		}

		// if a,b is outside the clip window (trivial reject)
		if (codeA & codeB) {
			return false;
		}

		// other cases
		codeOut = codeA || codeB;
		p = _getEdgeIntersection(a, b, codeOut, bounds, round);
		newCode = _getBitCode(p, bounds);

		if (codeOut === codeA) {
			a = p;
			codeA = newCode;
		} else {
			b = p;
			codeB = newCode;
		}
	}
}

function _getEdgeIntersection(a, b, code, bounds, round) {
	var dx = b.x - a.x,
	    dy = b.y - a.y,
	    min = bounds.min,
	    max = bounds.max,
	    x, y;

	if (code & 8) { // top
		x = a.x + dx * (max.y - a.y) / dy;
		y = max.y;

	} else if (code & 4) { // bottom
		x = a.x + dx * (min.y - a.y) / dy;
		y = min.y;

	} else if (code & 2) { // right
		x = max.x;
		y = a.y + dy * (max.x - a.x) / dx;

	} else if (code & 1) { // left
		x = min.x;
		y = a.y + dy * (min.x - a.x) / dx;
	}

	return new Point(x, y, round);
}

function _getBitCode(p, bounds) {
	var code = 0;

	if (p.x < bounds.min.x) { // left
		code |= 1;
	} else if (p.x > bounds.max.x) { // right
		code |= 2;
	}

	if (p.y < bounds.min.y) { // bottom
		code |= 4;
	} else if (p.y > bounds.max.y) { // top
		code |= 8;
	}

	return code;
}

// square distance (to avoid unnecessary Math.sqrt calls)
function _sqDist(p1, p2) {
	var dx = p2.x - p1.x,
	    dy = p2.y - p1.y;
	return dx * dx + dy * dy;
}

// return closest point on segment or distance to that point
function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
	var x = p1.x,
	    y = p1.y,
	    dx = p2.x - x,
	    dy = p2.y - y,
	    dot = dx * dx + dy * dy,
	    t;

	if (dot > 0) {
		t = ((p.x - x) * dx + (p.y - y) * dy) / dot;

		if (t > 1) {
			x = p2.x;
			y = p2.y;
		} else if (t > 0) {
			x += dx * t;
			y += dy * t;
		}
	}

	dx = p.x - x;
	dy = p.y - y;

	return sqDist ? dx * dx + dy * dy : new Point(x, y);
}


// @function isFlat(latlngs: LatLng[]): Boolean
// Returns true if `latlngs` is a flat array, false is nested.
function isFlat(latlngs) {
	return !isArray(latlngs[0]) || (typeof latlngs[0][0] !== 'object' && typeof latlngs[0][0] !== 'undefined');
}

function _flat(latlngs) {
	console.warn('Deprecated use of _flat, please use L.LineUtil.isFlat instead.');
	return isFlat(latlngs);
}


var LineUtil = (Object.freeze || Object)({
	simplify: simplify,
	pointToSegmentDistance: pointToSegmentDistance,
	closestPointOnSegment: closestPointOnSegment,
	clipSegment: clipSegment,
	_getEdgeIntersection: _getEdgeIntersection,
	_getBitCode: _getBitCode,
	_sqClosestPointOnSegment: _sqClosestPointOnSegment,
	isFlat: isFlat,
	_flat: _flat
});

/*
 * @namespace PolyUtil
 * Various utility functions for polygon geometries.
 */

/* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
 * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgeman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
 * Used by Leaflet to only show polygon points that are on the screen or near, increasing
 * performance. Note that polygon points needs different algorithm for clipping
 * than polyline, so there's a seperate method for it.
 */
function clipPolygon(points, bounds, round) {
	var clippedPoints,
	    edges = [1, 4, 2, 8],
	    i, j, k,
	    a, b,
	    len, edge, p;

	for (i = 0, len = points.length; i < len; i++) {
		points[i]._code = _getBitCode(points[i], bounds);
	}

	// for each edge (left, bottom, right, top)
	for (k = 0; k < 4; k++) {
		edge = edges[k];
		clippedPoints = [];

		for (i = 0, len = points.length, j = len - 1; i < len; j = i++) {
			a = points[i];
			b = points[j];

			// if a is inside the clip window
			if (!(a._code & edge)) {
				// if b is outside the clip window (a->b goes out of screen)
				if (b._code & edge) {
					p = _getEdgeIntersection(b, a, edge, bounds, round);
					p._code = _getBitCode(p, bounds);
					clippedPoints.push(p);
				}
				clippedPoints.push(a);

			// else if b is inside the clip window (a->b enters the screen)
			} else if (!(b._code & edge)) {
				p = _getEdgeIntersection(b, a, edge, bounds, round);
				p._code = _getBitCode(p, bounds);
				clippedPoints.push(p);
			}
		}
		points = clippedPoints;
	}

	return points;
}


var PolyUtil = (Object.freeze || Object)({
	clipPolygon: clipPolygon
});

/*
 * @namespace Projection
 * @section
 * Leaflet comes with a set of already defined Projections out of the box:
 *
 * @projection L.Projection.LonLat
 *
 * Equirectangular, or Plate Carree projection — the most simple projection,
 * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
 * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
 * `EPSG:4326` and `Simple` CRS.
 */

var LonLat = {
	project: function (latlng) {
		return new Point(latlng.lng, latlng.lat);
	},

	unproject: function (point) {
		return new LatLng(point.y, point.x);
	},

	bounds: new Bounds([-180, -90], [180, 90])
};

/*
 * @namespace Projection
 * @projection L.Projection.Mercator
 *
 * Elliptical Mercator projection — more complex than Spherical Mercator. Takes into account that Earth is a geoid, not a perfect sphere. Used by the EPSG:3395 CRS.
 */

var Mercator = {
	R: 6378137,
	R_MINOR: 6356752.314245179,

	bounds: new Bounds([-20037508.34279, -15496570.73972], [20037508.34279, 18764656.23138]),

	project: function (latlng) {
		var d = Math.PI / 180,
		    r = this.R,
		    y = latlng.lat * d,
		    tmp = this.R_MINOR / r,
		    e = Math.sqrt(1 - tmp * tmp),
		    con = e * Math.sin(y);

		var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
		y = -r * Math.log(Math.max(ts, 1E-10));

		return new Point(latlng.lng * d * r, y);
	},

	unproject: function (point) {
		var d = 180 / Math.PI,
		    r = this.R,
		    tmp = this.R_MINOR / r,
		    e = Math.sqrt(1 - tmp * tmp),
		    ts = Math.exp(-point.y / r),
		    phi = Math.PI / 2 - 2 * Math.atan(ts);

		for (var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++) {
			con = e * Math.sin(phi);
			con = Math.pow((1 - con) / (1 + con), e / 2);
			dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
			phi += dphi;
		}

		return new LatLng(phi * d, point.x * d / r);
	}
};

/*
 * @class Projection

 * An object with methods for projecting geographical coordinates of the world onto
 * a flat surface (and back). See [Map projection](http://en.wikipedia.org/wiki/Map_projection).

 * @property bounds: Bounds
 * The bounds (specified in CRS units) where the projection is valid

 * @method project(latlng: LatLng): Point
 * Projects geographical coordinates into a 2D point.
 * Only accepts actual `L.LatLng` instances, not arrays.

 * @method unproject(point: Point): LatLng
 * The inverse of `project`. Projects a 2D point into a geographical location.
 * Only accepts actual `L.Point` instances, not arrays.

 */




var index = (Object.freeze || Object)({
	LonLat: LonLat,
	Mercator: Mercator,
	SphericalMercator: SphericalMercator
});

/*
 * @namespace CRS
 * @crs L.CRS.EPSG3395
 *
 * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
 */
var EPSG3395 = extend({}, Earth, {
	code: 'EPSG:3395',
	projection: Mercator,

	transformation: (function () {
		var scale = 0.5 / (Math.PI * Mercator.R);
		return toTransformation(scale, 0.5, -scale, 0.5);
	}())
});

/*
 * @namespace CRS
 * @crs L.CRS.EPSG4326
 *
 * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
 *
 * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
 * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
 * with this CRS, ensure that there are two 256x256 pixel tiles covering the
 * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
 * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
 */

var EPSG4326 = extend({}, Earth, {
	code: 'EPSG:4326',
	projection: LonLat,
	transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
});

/*
 * @namespace CRS
 * @crs L.CRS.Simple
 *
 * A simple CRS that maps longitude and latitude into `x` and `y` directly.
 * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
 * axis should still be inverted (going from bottom to top). `distance()` returns
 * simple euclidean distance.
 */

var Simple = extend({}, CRS, {
	projection: LonLat,
	transformation: toTransformation(1, 0, -1, 0),

	scale: function (zoom) {
		return Math.pow(2, zoom);
	},

	zoom: function (scale) {
		return Math.log(scale) / Math.LN2;
	},

	distance: function (latlng1, latlng2) {
		var dx = latlng2.lng - latlng1.lng,
		    dy = latlng2.lat - latlng1.lat;

		return Math.sqrt(dx * dx + dy * dy);
	},

	infinite: true
});

CRS.Earth = Earth;
CRS.EPSG3395 = EPSG3395;
CRS.EPSG3857 = EPSG3857;
CRS.EPSG900913 = EPSG900913;
CRS.EPSG4326 = EPSG4326;
CRS.Simple = Simple;

/*
 * @class Layer
 * @inherits Evented
 * @aka L.Layer
 * @aka ILayer
 *
 * A set of methods from the Layer base class that all Leaflet layers use.
 * Inherits all methods, options and events from `L.Evented`.
 *
 * @example
 *
 * ```js
 * var layer = L.Marker(latlng).addTo(map);
 * layer.addTo(map);
 * layer.remove();
 * ```
 *
 * @event add: Event
 * Fired after the layer is added to a map
 *
 * @event remove: Event
 * Fired after the layer is removed from a map
 */


var Layer = Evented.extend({

	// Classes extending `L.Layer` will inherit the following options:
	options: {
		// @option pane: String = 'overlayPane'
		// By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
		pane: 'overlayPane',

		// @option attribution: String = null
		// String to be shown in the attribution control, describes the layer data, e.g. "© Mapbox".
		attribution: null,

		bubblingMouseEvents: true
	},

	/* @section
	 * Classes extending `L.Layer` will inherit the following methods:
	 *
	 * @method addTo(map: Map|LayerGroup): this
	 * Adds the layer to the given map or layer group.
	 */
	addTo: function (map) {
		map.addLayer(this);
		return this;
	},

	// @method remove: this
	// Removes the layer from the map it is currently active on.
	remove: function () {
		return this.removeFrom(this._map || this._mapToAdd);
	},

	// @method removeFrom(map: Map): this
	// Removes the layer from the given map
	removeFrom: function (obj) {
		if (obj) {
			obj.removeLayer(this);
		}
		return this;
	},

	// @method getPane(name? : String): HTMLElement
	// Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
	getPane: function (name) {
		return this._map.getPane(name ? (this.options[name] || name) : this.options.pane);
	},

	addInteractiveTarget: function (targetEl) {
		this._map._targets[stamp(targetEl)] = this;
		return this;
	},

	removeInteractiveTarget: function (targetEl) {
		delete this._map._targets[stamp(targetEl)];
		return this;
	},

	// @method getAttribution: String
	// Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
	getAttribution: function () {
		return this.options.attribution;
	},

	_layerAdd: function (e) {
		var map = e.target;

		// check in case layer gets added and then removed before the map is ready
		if (!map.hasLayer(this)) { return; }

		this._map = map;
		this._zoomAnimated = map._zoomAnimated;

		if (this.getEvents) {
			var events = this.getEvents();
			map.on(events, this);
			this.once('remove', function () {
				map.off(events, this);
			}, this);
		}

		this.onAdd(map);

		if (this.getAttribution && map.attributionControl) {
			map.attributionControl.addAttribution(this.getAttribution());
		}

		this.fire('add');
		map.fire('layeradd', {layer: this});
	}
});

/* @section Extension methods
 * @uninheritable
 *
 * Every layer should extend from `L.Layer` and (re-)implement the following methods.
 *
 * @method onAdd(map: Map): this
 * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
 *
 * @method onRemove(map: Map): this
 * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
 *
 * @method getEvents(): Object
 * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
 *
 * @method getAttribution(): String
 * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
 *
 * @method beforeAdd(map: Map): this
 * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
 */


/* @namespace Map
 * @section Layer events
 *
 * @event layeradd: LayerEvent
 * Fired when a new layer is added to the map.
 *
 * @event layerremove: LayerEvent
 * Fired when some layer is removed from the map
 *
 * @section Methods for Layers and Controls
 */
Map.include({
	// @method addLayer(layer: Layer): this
	// Adds the given layer to the map
	addLayer: function (layer) {
		if (!layer._layerAdd) {
			throw new Error('The provided object is not a Layer.');
		}

		var id = stamp(layer);
		if (this._layers[id]) { return this; }
		this._layers[id] = layer;

		layer._mapToAdd = this;

		if (layer.beforeAdd) {
			layer.beforeAdd(this);
		}

		this.whenReady(layer._layerAdd, layer);

		return this;
	},

	// @method removeLayer(layer: Layer): this
	// Removes the given layer from the map.
	removeLayer: function (layer) {
		var id = stamp(layer);

		if (!this._layers[id]) { return this; }

		if (this._loaded) {
			layer.onRemove(this);
		}

		if (layer.getAttribution && this.attributionControl) {
			this.attributionControl.removeAttribution(layer.getAttribution());
		}

		delete this._layers[id];

		if (this._loaded) {
			this.fire('layerremove', {layer: layer});
			layer.fire('remove');
		}

		layer._map = layer._mapToAdd = null;

		return this;
	},

	// @method hasLayer(layer: Layer): Boolean
	// Returns `true` if the given layer is currently added to the map
	hasLayer: function (layer) {
		return !!layer && (stamp(layer) in this._layers);
	},

	/* @method eachLayer(fn: Function, context?: Object): this
	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
	 * ```
	 * map.eachLayer(function(layer){
	 *     layer.bindPopup('Hello');
	 * });
	 * ```
	 */
	eachLayer: function (method, context) {
		for (var i in this._layers) {
			method.call(context, this._layers[i]);
		}
		return this;
	},

	_addLayers: function (layers) {
		layers = layers ? (isArray(layers) ? layers : [layers]) : [];

		for (var i = 0, len = layers.length; i < len; i++) {
			this.addLayer(layers[i]);
		}
	},

	_addZoomLimit: function (layer) {
		if (isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
			this._zoomBoundLayers[stamp(layer)] = layer;
			this._updateZoomLevels();
		}
	},

	_removeZoomLimit: function (layer) {
		var id = stamp(layer);

		if (this._zoomBoundLayers[id]) {
			delete this._zoomBoundLayers[id];
			this._updateZoomLevels();
		}
	},

	_updateZoomLevels: function () {
		var minZoom = Infinity,
		    maxZoom = -Infinity,
		    oldZoomSpan = this._getZoomSpan();

		for (var i in this._zoomBoundLayers) {
			var options = this._zoomBoundLayers[i].options;

			minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
			maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
		}

		this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
		this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;

		// @section Map state change events
		// @event zoomlevelschange: Event
		// Fired when the number of zoomlevels on the map is changed due
		// to adding or removing a layer.
		if (oldZoomSpan !== this._getZoomSpan()) {
			this.fire('zoomlevelschange');
		}

		if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) {
			this.setZoom(this._layersMaxZoom);
		}
		if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) {
			this.setZoom(this._layersMinZoom);
		}
	}
});

/*
 * @class LayerGroup
 * @aka L.LayerGroup
 * @inherits Layer
 *
 * Used to group several layers and handle them as one. If you add it to the map,
 * any layers added or removed from the group will be added/removed on the map as
 * well. Extends `Layer`.
 *
 * @example
 *
 * ```js
 * L.layerGroup([marker1, marker2])
 * 	.addLayer(polyline)
 * 	.addTo(map);
 * ```
 */

var LayerGroup = Layer.extend({

	initialize: function (layers) {
		this._layers = {};

		var i, len;

		if (layers) {
			for (i = 0, len = layers.length; i < len; i++) {
				this.addLayer(layers[i]);
			}
		}
	},

	// @method addLayer(layer: Layer): this
	// Adds the given layer to the group.
	addLayer: function (layer) {
		var id = this.getLayerId(layer);

		this._layers[id] = layer;

		if (this._map) {
			this._map.addLayer(layer);
		}

		return this;
	},

	// @method removeLayer(layer: Layer): this
	// Removes the given layer from the group.
	// @alternative
	// @method removeLayer(id: Number): this
	// Removes the layer with the given internal ID from the group.
	removeLayer: function (layer) {
		var id = layer in this._layers ? layer : this.getLayerId(layer);

		if (this._map && this._layers[id]) {
			this._map.removeLayer(this._layers[id]);
		}

		delete this._layers[id];

		return this;
	},

	// @method hasLayer(layer: Layer): Boolean
	// Returns `true` if the given layer is currently added to the group.
	// @alternative
	// @method hasLayer(id: Number): Boolean
	// Returns `true` if the given internal ID is currently added to the group.
	hasLayer: function (layer) {
		return !!layer && (layer in this._layers || this.getLayerId(layer) in this._layers);
	},

	// @method clearLayers(): this
	// Removes all the layers from the group.
	clearLayers: function () {
		for (var i in this._layers) {
			this.removeLayer(this._layers[i]);
		}
		return this;
	},

	// @method invoke(methodName: String, …): this
	// Calls `methodName` on every layer contained in this group, passing any
	// additional parameters. Has no effect if the layers contained do not
	// implement `methodName`.
	invoke: function (methodName) {
		var args = Array.prototype.slice.call(arguments, 1),
		    i, layer;

		for (i in this._layers) {
			layer = this._layers[i];

			if (layer[methodName]) {
				layer[methodName].apply(layer, args);
			}
		}

		return this;
	},

	onAdd: function (map) {
		for (var i in this._layers) {
			map.addLayer(this._layers[i]);
		}
	},

	onRemove: function (map) {
		for (var i in this._layers) {
			map.removeLayer(this._layers[i]);
		}
	},

	// @method eachLayer(fn: Function, context?: Object): this
	// Iterates over the layers of the group, optionally specifying context of the iterator function.
	// ```js
	// group.eachLayer(function (layer) {
	// 	layer.bindPopup('Hello');
	// });
	// ```
	eachLayer: function (method, context) {
		for (var i in this._layers) {
			method.call(context, this._layers[i]);
		}
		return this;
	},

	// @method getLayer(id: Number): Layer
	// Returns the layer with the given internal ID.
	getLayer: function (id) {
		return this._layers[id];
	},

	// @method getLayers(): Layer[]
	// Returns an array of all the layers added to the group.
	getLayers: function () {
		var layers = [];

		for (var i in this._layers) {
			layers.push(this._layers[i]);
		}
		return layers;
	},

	// @method setZIndex(zIndex: Number): this
	// Calls `setZIndex` on every layer contained in this group, passing the z-index.
	setZIndex: function (zIndex) {
		return this.invoke('setZIndex', zIndex);
	},

	// @method getLayerId(layer: Layer): Number
	// Returns the internal ID for a layer
	getLayerId: function (layer) {
		return stamp(layer);
	}
});


// @factory L.layerGroup(layers?: Layer[])
// Create a layer group, optionally given an initial set of layers.
var layerGroup = function (layers) {
	return new LayerGroup(layers);
};

/*
 * @class FeatureGroup
 * @aka L.FeatureGroup
 * @inherits LayerGroup
 *
 * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
 *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
 *  * Events are propagated to the `FeatureGroup`, so if the group has an event
 * handler, it will handle events from any of the layers. This includes mouse events
 * and custom events.
 *  * Has `layeradd` and `layerremove` events
 *
 * @example
 *
 * ```js
 * L.featureGroup([marker1, marker2, polyline])
 * 	.bindPopup('Hello world!')
 * 	.on('click', function() { alert('Clicked on a member of the group!'); })
 * 	.addTo(map);
 * ```
 */

var FeatureGroup = LayerGroup.extend({

	addLayer: function (layer) {
		if (this.hasLayer(layer)) {
			return this;
		}

		layer.addEventParent(this);

		LayerGroup.prototype.addLayer.call(this, layer);

		// @event layeradd: LayerEvent
		// Fired when a layer is added to this `FeatureGroup`
		return this.fire('layeradd', {layer: layer});
	},

	removeLayer: function (layer) {
		if (!this.hasLayer(layer)) {
			return this;
		}
		if (layer in this._layers) {
			layer = this._layers[layer];
		}

		layer.removeEventParent(this);

		LayerGroup.prototype.removeLayer.call(this, layer);

		// @event layerremove: LayerEvent
		// Fired when a layer is removed from this `FeatureGroup`
		return this.fire('layerremove', {layer: layer});
	},

	// @method setStyle(style: Path options): this
	// Sets the given path options to each layer of the group that has a `setStyle` method.
	setStyle: function (style) {
		return this.invoke('setStyle', style);
	},

	// @method bringToFront(): this
	// Brings the layer group to the top of all other layers
	bringToFront: function () {
		return this.invoke('bringToFront');
	},

	// @method bringToBack(): this
	// Brings the layer group to the top of all other layers
	bringToBack: function () {
		return this.invoke('bringToBack');
	},

	// @method getBounds(): LatLngBounds
	// Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
	getBounds: function () {
		var bounds = new LatLngBounds();

		for (var id in this._layers) {
			var layer = this._layers[id];
			bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
		}
		return bounds;
	}
});

// @factory L.featureGroup(layers: Layer[])
// Create a feature group, optionally given an initial set of layers.
var featureGroup = function (layers) {
	return new FeatureGroup(layers);
};

/*
 * @class Icon
 * @aka L.Icon
 *
 * Represents an icon to provide when creating a marker.
 *
 * @example
 *
 * ```js
 * var myIcon = L.icon({
 *     iconUrl: 'my-icon.png',
 *     iconRetinaUrl: 'my-icon@2x.png',
 *     iconSize: [38, 95],
 *     iconAnchor: [22, 94],
 *     popupAnchor: [-3, -76],
 *     shadowUrl: 'my-icon-shadow.png',
 *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
 *     shadowSize: [68, 95],
 *     shadowAnchor: [22, 94]
 * });
 *
 * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
 * ```
 *
 * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
 *
 */

var Icon = Class.extend({

	/* @section
	 * @aka Icon options
	 *
	 * @option iconUrl: String = null
	 * **(required)** The URL to the icon image (absolute or relative to your script path).
	 *
	 * @option iconRetinaUrl: String = null
	 * The URL to a retina sized version of the icon image (absolute or relative to your
	 * script path). Used for Retina screen devices.
	 *
	 * @option iconSize: Point = null
	 * Size of the icon image in pixels.
	 *
	 * @option iconAnchor: Point = null
	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
	 * will be aligned so that this point is at the marker's geographical location. Centered
	 * by default if size is specified, also can be set in CSS with negative margins.
	 *
	 * @option popupAnchor: Point = null
	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
	 *
	 * @option shadowUrl: String = null
	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
	 *
	 * @option shadowRetinaUrl: String = null
	 *
	 * @option shadowSize: Point = null
	 * Size of the shadow image in pixels.
	 *
	 * @option shadowAnchor: Point = null
	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
	 * as iconAnchor if not specified).
	 *
	 * @option className: String = ''
	 * A custom class name to assign to both icon and shadow images. Empty by default.
	 */

	initialize: function (options) {
		setOptions(this, options);
	},

	// @method createIcon(oldIcon?: HTMLElement): HTMLElement
	// Called internally when the icon has to be shown, returns a `<img>` HTML element
	// styled according to the options.
	createIcon: function (oldIcon) {
		return this._createIcon('icon', oldIcon);
	},

	// @method createShadow(oldIcon?: HTMLElement): HTMLElement
	// As `createIcon`, but for the shadow beneath it.
	createShadow: function (oldIcon) {
		return this._createIcon('shadow', oldIcon);
	},

	_createIcon: function (name, oldIcon) {
		var src = this._getIconUrl(name);

		if (!src) {
			if (name === 'icon') {
				throw new Error('iconUrl not set in Icon options (see the docs).');
			}
			return null;
		}

		var img = this._createImg(src, oldIcon && oldIcon.tagName === 'IMG' ? oldIcon : null);
		this._setIconStyles(img, name);

		return img;
	},

	_setIconStyles: function (img, name) {
		var options = this.options;
		var sizeOption = options[name + 'Size'];

		if (typeof sizeOption === 'number') {
			sizeOption = [sizeOption, sizeOption];
		}

		var size = toPoint(sizeOption),
		    anchor = toPoint(name === 'shadow' && options.shadowAnchor || options.iconAnchor ||
		            size && size.divideBy(2, true));

		img.className = 'leaflet-marker-' + name + ' ' + (options.className || '');

		if (anchor) {
			img.style.marginLeft = (-anchor.x) + 'px';
			img.style.marginTop  = (-anchor.y) + 'px';
		}

		if (size) {
			img.style.width  = size.x + 'px';
			img.style.height = size.y + 'px';
		}
	},

	_createImg: function (src, el) {
		el = el || document.createElement('img');
		el.src = src;
		return el;
	},

	_getIconUrl: function (name) {
		return retina && this.options[name + 'RetinaUrl'] || this.options[name + 'Url'];
	}
});


// @factory L.icon(options: Icon options)
// Creates an icon instance with the given options.
function icon(options) {
	return new Icon(options);
}

/*
 * @miniclass Icon.Default (Icon)
 * @aka L.Icon.Default
 * @section
 *
 * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
 * no icon is specified. Points to the blue marker image distributed with Leaflet
 * releases.
 *
 * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
 * (which is a set of `Icon options`).
 *
 * If you want to _completely_ replace the default icon, override the
 * `L.Marker.prototype.options.icon` with your own icon instead.
 */

var IconDefault = Icon.extend({

	options: {
		iconUrl:       'marker-icon.png',
		iconRetinaUrl: 'marker-icon-2x.png',
		shadowUrl:     'marker-shadow.png',
		iconSize:    [25, 41],
		iconAnchor:  [12, 41],
		popupAnchor: [1, -34],
		tooltipAnchor: [16, -28],
		shadowSize:  [41, 41]
	},

	_getIconUrl: function (name) {
		if (!IconDefault.imagePath) {	// Deprecated, backwards-compatibility only
			IconDefault.imagePath = this._detectIconPath();
		}

		// @option imagePath: String
		// `Icon.Default` will try to auto-detect the absolute location of the
		// blue icon images. If you are placing these images in a non-standard
		// way, set this option to point to the right absolute path.
		return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
	},

	_detectIconPath: function () {
		var el = create$1('div',  'leaflet-default-icon-path', document.body);
		var path = getStyle(el, 'background-image') ||
		           getStyle(el, 'backgroundImage');	// IE8

		document.body.removeChild(el);

		if (path === null || path.indexOf('url') !== 0) {
			path = '';
		} else {
			path = path.replace(/^url\([\"\']?/, '').replace(/marker-icon\.png[\"\']?\)$/, '');
		}

		return path;
	}
});

/*
 * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
 */


/* @namespace Marker
 * @section Interaction handlers
 *
 * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
 *
 * ```js
 * marker.dragging.disable();
 * ```
 *
 * @property dragging: Handler
 * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
 */

var MarkerDrag = Handler.extend({
	initialize: function (marker) {
		this._marker = marker;
	},

	addHooks: function () {
		var icon = this._marker._icon;

		if (!this._draggable) {
			this._draggable = new Draggable(icon, icon, true);
		}

		this._draggable.on({
			dragstart: this._onDragStart,
			drag: this._onDrag,
			dragend: this._onDragEnd
		}, this).enable();

		addClass(icon, 'leaflet-marker-draggable');
	},

	removeHooks: function () {
		this._draggable.off({
			dragstart: this._onDragStart,
			drag: this._onDrag,
			dragend: this._onDragEnd
		}, this).disable();

		if (this._marker._icon) {
			removeClass(this._marker._icon, 'leaflet-marker-draggable');
		}
	},

	moved: function () {
		return this._draggable && this._draggable._moved;
	},

	_onDragStart: function () {
		// @section Dragging events
		// @event dragstart: Event
		// Fired when the user starts dragging the marker.

		// @event movestart: Event
		// Fired when the marker starts moving (because of dragging).

		this._oldLatLng = this._marker.getLatLng();
		this._marker
		    .closePopup()
		    .fire('movestart')
		    .fire('dragstart');
	},

	_onDrag: function (e) {
		var marker = this._marker,
		    shadow = marker._shadow,
		iconPos = getPosition(marker._icon),
		    latlng = marker._map.layerPointToLatLng(iconPos);

		// update shadow position
		if (shadow) {
			setPosition(shadow, iconPos);
		}

		marker._latlng = latlng;
		e.latlng = latlng;
		e.oldLatLng = this._oldLatLng;

		// @event drag: Event
		// Fired repeatedly while the user drags the marker.
		marker
		    .fire('move', e)
		    .fire('drag', e);
	},

	_onDragEnd: function (e) {
		// @event dragend: DragEndEvent
		// Fired when the user stops dragging the marker.

		// @event moveend: Event
		// Fired when the marker stops moving (because of dragging).
		delete this._oldLatLng;
		this._marker
		    .fire('moveend')
		    .fire('dragend', e);
	}
});

/*
 * @class Marker
 * @inherits Interactive layer
 * @aka L.Marker
 * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
 *
 * @example
 *
 * ```js
 * L.marker([50.5, 30.5]).addTo(map);
 * ```
 */

var Marker = Layer.extend({

	// @section
	// @aka Marker options
	options: {
		// @option icon: Icon = *
		// Icon instance to use for rendering the marker.
		// See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
		// If not specified, a common instance of `L.Icon.Default` is used.
		icon: new IconDefault(),

		// Option inherited from "Interactive layer" abstract class
		interactive: true,

		// @option draggable: Boolean = false
		// Whether the marker is draggable with mouse/touch or not.
		draggable: false,

		// @option keyboard: Boolean = true
		// Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
		keyboard: true,

		// @option title: String = ''
		// Text for the browser tooltip that appear on marker hover (no tooltip by default).
		title: '',

		// @option alt: String = ''
		// Text for the `alt` attribute of the icon image (useful for accessibility).
		alt: '',

		// @option zIndexOffset: Number = 0
		// By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
		zIndexOffset: 0,

		// @option opacity: Number = 1.0
		// The opacity of the marker.
		opacity: 1,

		// @option riseOnHover: Boolean = false
		// If `true`, the marker will get on top of others when you hover the mouse over it.
		riseOnHover: false,

		// @option riseOffset: Number = 250
		// The z-index offset used for the `riseOnHover` feature.
		riseOffset: 250,

		// @option pane: String = 'markerPane'
		// `Map pane` where the markers icon will be added.
		pane: 'markerPane',

		// @option bubblingMouseEvents: Boolean = false
		// When `true`, a mouse event on this marker will trigger the same event on the map
		// (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
		bubblingMouseEvents: false
	},

	/* @section
	 *
	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
	 */

	initialize: function (latlng, options) {
		setOptions(this, options);
		this._latlng = toLatLng(latlng);
	},

	onAdd: function (map) {
		this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;

		if (this._zoomAnimated) {
			map.on('zoomanim', this._animateZoom, this);
		}

		this._initIcon();
		this.update();
	},

	onRemove: function (map) {
		if (this.dragging && this.dragging.enabled()) {
			this.options.draggable = true;
			this.dragging.removeHooks();
		}
		delete this.dragging;

		if (this._zoomAnimated) {
			map.off('zoomanim', this._animateZoom, this);
		}

		this._removeIcon();
		this._removeShadow();
	},

	getEvents: function () {
		return {
			zoom: this.update,
			viewreset: this.update
		};
	},

	// @method getLatLng: LatLng
	// Returns the current geographical position of the marker.
	getLatLng: function () {
		return this._latlng;
	},

	// @method setLatLng(latlng: LatLng): this
	// Changes the marker position to the given point.
	setLatLng: function (latlng) {
		var oldLatLng = this._latlng;
		this._latlng = toLatLng(latlng);
		this.update();

		// @event move: Event
		// Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
		return this.fire('move', {oldLatLng: oldLatLng, latlng: this._latlng});
	},

	// @method setZIndexOffset(offset: Number): this
	// Changes the [zIndex offset](#marker-zindexoffset) of the marker.
	setZIndexOffset: function (offset) {
		this.options.zIndexOffset = offset;
		return this.update();
	},

	// @method setIcon(icon: Icon): this
	// Changes the marker icon.
	setIcon: function (icon) {

		this.options.icon = icon;

		if (this._map) {
			this._initIcon();
			this.update();
		}

		if (this._popup) {
			this.bindPopup(this._popup, this._popup.options);
		}

		return this;
	},

	getElement: function () {
		return this._icon;
	},

	update: function () {

		if (this._icon) {
			var pos = this._map.latLngToLayerPoint(this._latlng).round();
			this._setPos(pos);
		}

		return this;
	},

	_initIcon: function () {
		var options = this.options,
		    classToAdd = 'leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');

		var icon = options.icon.createIcon(this._icon),
		    addIcon = false;

		// if we're not reusing the icon, remove the old one and init new one
		if (icon !== this._icon) {
			if (this._icon) {
				this._removeIcon();
			}
			addIcon = true;

			if (options.title) {
				icon.title = options.title;
			}
			if (options.alt) {
				icon.alt = options.alt;
			}
		}

		addClass(icon, classToAdd);

		if (options.keyboard) {
			icon.tabIndex = '0';
		}

		this._icon = icon;

		if (options.riseOnHover) {
			this.on({
				mouseover: this._bringToFront,
				mouseout: this._resetZIndex
			});
		}

		var newShadow = options.icon.createShadow(this._shadow),
		    addShadow = false;

		if (newShadow !== this._shadow) {
			this._removeShadow();
			addShadow = true;
		}

		if (newShadow) {
			addClass(newShadow, classToAdd);
			newShadow.alt = '';
		}
		this._shadow = newShadow;


		if (options.opacity < 1) {
			this._updateOpacity();
		}


		if (addIcon) {
			this.getPane().appendChild(this._icon);
		}
		this._initInteraction();
		if (newShadow && addShadow) {
			this.getPane('shadowPane').appendChild(this._shadow);
		}
	},

	_removeIcon: function () {
		if (this.options.riseOnHover) {
			this.off({
				mouseover: this._bringToFront,
				mouseout: this._resetZIndex
			});
		}

		remove(this._icon);
		this.removeInteractiveTarget(this._icon);

		this._icon = null;
	},

	_removeShadow: function () {
		if (this._shadow) {
			remove(this._shadow);
		}
		this._shadow = null;
	},

	_setPos: function (pos) {
		setPosition(this._icon, pos);

		if (this._shadow) {
			setPosition(this._shadow, pos);
		}

		this._zIndex = pos.y + this.options.zIndexOffset;

		this._resetZIndex();
	},

	_updateZIndex: function (offset) {
		this._icon.style.zIndex = this._zIndex + offset;
	},

	_animateZoom: function (opt) {
		var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();

		this._setPos(pos);
	},

	_initInteraction: function () {

		if (!this.options.interactive) { return; }

		addClass(this._icon, 'leaflet-interactive');

		this.addInteractiveTarget(this._icon);

		if (MarkerDrag) {
			var draggable = this.options.draggable;
			if (this.dragging) {
				draggable = this.dragging.enabled();
				this.dragging.disable();
			}

			this.dragging = new MarkerDrag(this);

			if (draggable) {
				this.dragging.enable();
			}
		}
	},

	// @method setOpacity(opacity: Number): this
	// Changes the opacity of the marker.
	setOpacity: function (opacity) {
		this.options.opacity = opacity;
		if (this._map) {
			this._updateOpacity();
		}

		return this;
	},

	_updateOpacity: function () {
		var opacity = this.options.opacity;

		setOpacity(this._icon, opacity);

		if (this._shadow) {
			setOpacity(this._shadow, opacity);
		}
	},

	_bringToFront: function () {
		this._updateZIndex(this.options.riseOffset);
	},

	_resetZIndex: function () {
		this._updateZIndex(0);
	},

	_getPopupAnchor: function () {
		return this.options.icon.options.popupAnchor || [0, 0];
	},

	_getTooltipAnchor: function () {
		return this.options.icon.options.tooltipAnchor || [0, 0];
	}
});


// factory L.marker(latlng: LatLng, options? : Marker options)

// @factory L.marker(latlng: LatLng, options? : Marker options)
// Instantiates a Marker object given a geographical point and optionally an options object.
function marker(latlng, options) {
	return new Marker(latlng, options);
}

/*
 * @class Path
 * @aka L.Path
 * @inherits Interactive layer
 *
 * An abstract class that contains options and constants shared between vector
 * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
 */

var Path = Layer.extend({

	// @section
	// @aka Path options
	options: {
		// @option stroke: Boolean = true
		// Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
		stroke: true,

		// @option color: String = '#3388ff'
		// Stroke color
		color: '#3388ff',

		// @option weight: Number = 3
		// Stroke width in pixels
		weight: 3,

		// @option opacity: Number = 1.0
		// Stroke opacity
		opacity: 1,

		// @option lineCap: String= 'round'
		// A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
		lineCap: 'round',

		// @option lineJoin: String = 'round'
		// A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
		lineJoin: 'round',

		// @option dashArray: String = null
		// A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
		dashArray: null,

		// @option dashOffset: String = null
		// A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
		dashOffset: null,

		// @option fill: Boolean = depends
		// Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
		fill: false,

		// @option fillColor: String = *
		// Fill color. Defaults to the value of the [`color`](#path-color) option
		fillColor: null,

		// @option fillOpacity: Number = 0.2
		// Fill opacity.
		fillOpacity: 0.2,

		// @option fillRule: String = 'evenodd'
		// A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
		fillRule: 'evenodd',

		// className: '',

		// Option inherited from "Interactive layer" abstract class
		interactive: true,

		// @option bubblingMouseEvents: Boolean = true
		// When `true`, a mouse event on this path will trigger the same event on the map
		// (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
		bubblingMouseEvents: true
	},

	beforeAdd: function (map) {
		// Renderer is set here because we need to call renderer.getEvents
		// before this.getEvents.
		this._renderer = map.getRenderer(this);
	},

	onAdd: function () {
		this._renderer._initPath(this);
		this._reset();
		this._renderer._addPath(this);
	},

	onRemove: function () {
		this._renderer._removePath(this);
	},

	// @method redraw(): this
	// Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
	redraw: function () {
		if (this._map) {
			this._renderer._updatePath(this);
		}
		return this;
	},

	// @method setStyle(style: Path options): this
	// Changes the appearance of a Path based on the options in the `Path options` object.
	setStyle: function (style) {
		setOptions(this, style);
		if (this._renderer) {
			this._renderer._updateStyle(this);
		}
		return this;
	},

	// @method bringToFront(): this
	// Brings the layer to the top of all path layers.
	bringToFront: function () {
		if (this._renderer) {
			this._renderer._bringToFront(this);
		}
		return this;
	},

	// @method bringToBack(): this
	// Brings the layer to the bottom of all path layers.
	bringToBack: function () {
		if (this._renderer) {
			this._renderer._bringToBack(this);
		}
		return this;
	},

	getElement: function () {
		return this._path;
	},

	_reset: function () {
		// defined in child classes
		this._project();
		this._update();
	},

	_clickTolerance: function () {
		// used when doing hit detection for Canvas layers
		return (this.options.stroke ? this.options.weight / 2 : 0) + (touch ? 10 : 0);
	}
});

/*
 * @class CircleMarker
 * @aka L.CircleMarker
 * @inherits Path
 *
 * A circle of a fixed size with radius specified in pixels. Extends `Path`.
 */

var CircleMarker = Path.extend({

	// @section
	// @aka CircleMarker options
	options: {
		fill: true,

		// @option radius: Number = 10
		// Radius of the circle marker, in pixels
		radius: 10
	},

	initialize: function (latlng, options) {
		setOptions(this, options);
		this._latlng = toLatLng(latlng);
		this._radius = this.options.radius;
	},

	// @method setLatLng(latLng: LatLng): this
	// Sets the position of a circle marker to a new location.
	setLatLng: function (latlng) {
		this._latlng = toLatLng(latlng);
		this.redraw();
		return this.fire('move', {latlng: this._latlng});
	},

	// @method getLatLng(): LatLng
	// Returns the current geographical position of the circle marker
	getLatLng: function () {
		return this._latlng;
	},

	// @method setRadius(radius: Number): this
	// Sets the radius of a circle marker. Units are in pixels.
	setRadius: function (radius) {
		this.options.radius = this._radius = radius;
		return this.redraw();
	},

	// @method getRadius(): Number
	// Returns the current radius of the circle
	getRadius: function () {
		return this._radius;
	},

	setStyle : function (options) {
		var radius = options && options.radius || this._radius;
		Path.prototype.setStyle.call(this, options);
		this.setRadius(radius);
		return this;
	},

	_project: function () {
		this._point = this._map.latLngToLayerPoint(this._latlng);
		this._updateBounds();
	},

	_updateBounds: function () {
		var r = this._radius,
		    r2 = this._radiusY || r,
		    w = this._clickTolerance(),
		    p = [r + w, r2 + w];
		this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
	},

	_update: function () {
		if (this._map) {
			this._updatePath();
		}
	},

	_updatePath: function () {
		this._renderer._updateCircle(this);
	},

	_empty: function () {
		return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
	},

	// Needed by the `Canvas` renderer for interactivity
	_containsPoint: function (p) {
		return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
	}
});


// @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
// Instantiates a circle marker object given a geographical point, and an optional options object.
function circleMarker(latlng, options) {
	return new CircleMarker(latlng, options);
}

/*
 * @class Circle
 * @aka L.Circle
 * @inherits CircleMarker
 *
 * A class for drawing circle overlays on a map. Extends `CircleMarker`.
 *
 * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
 *
 * @example
 *
 * ```js
 * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
 * ```
 */

var Circle = CircleMarker.extend({

	initialize: function (latlng, options, legacyOptions) {
		if (typeof options === 'number') {
			// Backwards compatibility with 0.7.x factory (latlng, radius, options?)
			options = extend({}, legacyOptions, {radius: options});
		}
		setOptions(this, options);
		this._latlng = toLatLng(latlng);

		if (isNaN(this.options.radius)) { throw new Error('Circle radius cannot be NaN'); }

		// @section
		// @aka Circle options
		// @option radius: Number; Radius of the circle, in meters.
		this._mRadius = this.options.radius;
	},

	// @method setRadius(radius: Number): this
	// Sets the radius of a circle. Units are in meters.
	setRadius: function (radius) {
		this._mRadius = radius;
		return this.redraw();
	},

	// @method getRadius(): Number
	// Returns the current radius of a circle. Units are in meters.
	getRadius: function () {
		return this._mRadius;
	},

	// @method getBounds(): LatLngBounds
	// Returns the `LatLngBounds` of the path.
	getBounds: function () {
		var half = [this._radius, this._radiusY || this._radius];

		return new LatLngBounds(
			this._map.layerPointToLatLng(this._point.subtract(half)),
			this._map.layerPointToLatLng(this._point.add(half)));
	},

	setStyle: Path.prototype.setStyle,

	_project: function () {

		var lng = this._latlng.lng,
		    lat = this._latlng.lat,
		    map = this._map,
		    crs = map.options.crs;

		if (crs.distance === Earth.distance) {
			var d = Math.PI / 180,
			    latR = (this._mRadius / Earth.R) / d,
			    top = map.project([lat + latR, lng]),
			    bottom = map.project([lat - latR, lng]),
			    p = top.add(bottom).divideBy(2),
			    lat2 = map.unproject(p).lat,
			    lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) /
			            (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;

			if (isNaN(lngR) || lngR === 0) {
				lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
			}

			this._point = p.subtract(map.getPixelOrigin());
			this._radius = isNaN(lngR) ? 0 : Math.max(Math.round(p.x - map.project([lat2, lng - lngR]).x), 1);
			this._radiusY = Math.max(Math.round(p.y - top.y), 1);

		} else {
			var latlng2 = crs.unproject(crs.project(this._latlng).subtract([this._mRadius, 0]));

			this._point = map.latLngToLayerPoint(this._latlng);
			this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
		}

		this._updateBounds();
	}
});

// @factory L.circle(latlng: LatLng, options?: Circle options)
// Instantiates a circle object given a geographical point, and an options object
// which contains the circle radius.
// @alternative
// @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
// Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
// Do not use in new applications or plugins.
function circle(latlng, options, legacyOptions) {
	return new Circle(latlng, options, legacyOptions);
}

/*
 * @class Polyline
 * @aka L.Polyline
 * @inherits Path
 *
 * A class for drawing polyline overlays on a map. Extends `Path`.
 *
 * @example
 *
 * ```js
 * // create a red polyline from an array of LatLng points
 * var latlngs = [
 * 	[45.51, -122.68],
 * 	[37.77, -122.43],
 * 	[34.04, -118.2]
 * ];
 *
 * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
 *
 * // zoom the map to the polyline
 * map.fitBounds(polyline.getBounds());
 * ```
 *
 * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
 *
 * ```js
 * // create a red polyline from an array of arrays of LatLng points
 * var latlngs = [
 * 	[[45.51, -122.68],
 * 	 [37.77, -122.43],
 * 	 [34.04, -118.2]],
 * 	[[40.78, -73.91],
 * 	 [41.83, -87.62],
 * 	 [32.76, -96.72]]
 * ];
 * ```
 */


var Polyline = Path.extend({

	// @section
	// @aka Polyline options
	options: {
		// @option smoothFactor: Number = 1.0
		// How much to simplify the polyline on each zoom level. More means
		// better performance and smoother look, and less means more accurate representation.
		smoothFactor: 1.0,

		// @option noClip: Boolean = false
		// Disable polyline clipping.
		noClip: false
	},

	initialize: function (latlngs, options) {
		setOptions(this, options);
		this._setLatLngs(latlngs);
	},

	// @method getLatLngs(): LatLng[]
	// Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
	getLatLngs: function () {
		return this._latlngs;
	},

	// @method setLatLngs(latlngs: LatLng[]): this
	// Replaces all the points in the polyline with the given array of geographical points.
	setLatLngs: function (latlngs) {
		this._setLatLngs(latlngs);
		return this.redraw();
	},

	// @method isEmpty(): Boolean
	// Returns `true` if the Polyline has no LatLngs.
	isEmpty: function () {
		return !this._latlngs.length;
	},

	closestLayerPoint: function (p) {
		var minDistance = Infinity,
		    minPoint = null,
		    closest = _sqClosestPointOnSegment,
		    p1, p2;

		for (var j = 0, jLen = this._parts.length; j < jLen; j++) {
			var points = this._parts[j];

			for (var i = 1, len = points.length; i < len; i++) {
				p1 = points[i - 1];
				p2 = points[i];

				var sqDist = closest(p, p1, p2, true);

				if (sqDist < minDistance) {
					minDistance = sqDist;
					minPoint = closest(p, p1, p2);
				}
			}
		}
		if (minPoint) {
			minPoint.distance = Math.sqrt(minDistance);
		}
		return minPoint;
	},

	// @method getCenter(): LatLng
	// Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the polyline.
	getCenter: function () {
		// throws error when not yet added to map as this center calculation requires projected coordinates
		if (!this._map) {
			throw new Error('Must add layer to map before using getCenter()');
		}

		var i, halfDist, segDist, dist, p1, p2, ratio,
		    points = this._rings[0],
		    len = points.length;

		if (!len) { return null; }

		// polyline centroid algorithm; only uses the first ring if there are multiple

		for (i = 0, halfDist = 0; i < len - 1; i++) {
			halfDist += points[i].distanceTo(points[i + 1]) / 2;
		}

		// The line is so small in the current view that all points are on the same pixel.
		if (halfDist === 0) {
			return this._map.layerPointToLatLng(points[0]);
		}

		for (i = 0, dist = 0; i < len - 1; i++) {
			p1 = points[i];
			p2 = points[i + 1];
			segDist = p1.distanceTo(p2);
			dist += segDist;

			if (dist > halfDist) {
				ratio = (dist - halfDist) / segDist;
				return this._map.layerPointToLatLng([
					p2.x - ratio * (p2.x - p1.x),
					p2.y - ratio * (p2.y - p1.y)
				]);
			}
		}
	},

	// @method getBounds(): LatLngBounds
	// Returns the `LatLngBounds` of the path.
	getBounds: function () {
		return this._bounds;
	},

	// @method addLatLng(latlng: LatLng, latlngs? LatLng[]): this
	// Adds a given point to the polyline. By default, adds to the first ring of
	// the polyline in case of a multi-polyline, but can be overridden by passing
	// a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
	addLatLng: function (latlng, latlngs) {
		latlngs = latlngs || this._defaultShape();
		latlng = toLatLng(latlng);
		latlngs.push(latlng);
		this._bounds.extend(latlng);
		return this.redraw();
	},

	_setLatLngs: function (latlngs) {
		this._bounds = new LatLngBounds();
		this._latlngs = this._convertLatLngs(latlngs);
	},

	_defaultShape: function () {
		return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
	},

	// recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
	_convertLatLngs: function (latlngs) {
		var result = [],
		    flat = isFlat(latlngs);

		for (var i = 0, len = latlngs.length; i < len; i++) {
			if (flat) {
				result[i] = toLatLng(latlngs[i]);
				this._bounds.extend(result[i]);
			} else {
				result[i] = this._convertLatLngs(latlngs[i]);
			}
		}

		return result;
	},

	_project: function () {
		var pxBounds = new Bounds();
		this._rings = [];
		this._projectLatlngs(this._latlngs, this._rings, pxBounds);

		var w = this._clickTolerance(),
		    p = new Point(w, w);

		if (this._bounds.isValid() && pxBounds.isValid()) {
			pxBounds.min._subtract(p);
			pxBounds.max._add(p);
			this._pxBounds = pxBounds;
		}
	},

	// recursively turns latlngs into a set of rings with projected coordinates
	_projectLatlngs: function (latlngs, result, projectedBounds) {
		var flat = latlngs[0] instanceof LatLng,
		    len = latlngs.length,
		    i, ring;

		if (flat) {
			ring = [];
			for (i = 0; i < len; i++) {
				ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
				projectedBounds.extend(ring[i]);
			}
			result.push(ring);
		} else {
			for (i = 0; i < len; i++) {
				this._projectLatlngs(latlngs[i], result, projectedBounds);
			}
		}
	},

	// clip polyline by renderer bounds so that we have less to render for performance
	_clipPoints: function () {
		var bounds = this._renderer._bounds;

		this._parts = [];
		if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
			return;
		}

		if (this.options.noClip) {
			this._parts = this._rings;
			return;
		}

		var parts = this._parts,
		    i, j, k, len, len2, segment, points;

		for (i = 0, k = 0, len = this._rings.length; i < len; i++) {
			points = this._rings[i];

			for (j = 0, len2 = points.length; j < len2 - 1; j++) {
				segment = clipSegment(points[j], points[j + 1], bounds, j, true);

				if (!segment) { continue; }

				parts[k] = parts[k] || [];
				parts[k].push(segment[0]);

				// if segment goes out of screen, or it's the last one, it's the end of the line part
				if ((segment[1] !== points[j + 1]) || (j === len2 - 2)) {
					parts[k].push(segment[1]);
					k++;
				}
			}
		}
	},

	// simplify each clipped part of the polyline for performance
	_simplifyPoints: function () {
		var parts = this._parts,
		    tolerance = this.options.smoothFactor;

		for (var i = 0, len = parts.length; i < len; i++) {
			parts[i] = simplify(parts[i], tolerance);
		}
	},

	_update: function () {
		if (!this._map) { return; }

		this._clipPoints();
		this._simplifyPoints();
		this._updatePath();
	},

	_updatePath: function () {
		this._renderer._updatePoly(this);
	},

	// Needed by the `Canvas` renderer for interactivity
	_containsPoint: function (p, closed) {
		var i, j, k, len, len2, part,
		    w = this._clickTolerance();

		if (!this._pxBounds || !this._pxBounds.contains(p)) { return false; }

		// hit detection for polylines
		for (i = 0, len = this._parts.length; i < len; i++) {
			part = this._parts[i];

			for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
				if (!closed && (j === 0)) { continue; }

				if (pointToSegmentDistance(p, part[k], part[j]) <= w) {
					return true;
				}
			}
		}
		return false;
	}
});

// @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
// Instantiates a polyline object given an array of geographical points and
// optionally an options object. You can create a `Polyline` object with
// multiple separate lines (`MultiPolyline`) by passing an array of arrays
// of geographic points.
function polyline(latlngs, options) {
	return new Polyline(latlngs, options);
}

// Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
Polyline._flat = _flat;

/*
 * @class Polygon
 * @aka L.Polygon
 * @inherits Polyline
 *
 * A class for drawing polygon overlays on a map. Extends `Polyline`.
 *
 * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
 *
 *
 * @example
 *
 * ```js
 * // create a red polygon from an array of LatLng points
 * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
 *
 * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
 *
 * // zoom the map to the polygon
 * map.fitBounds(polygon.getBounds());
 * ```
 *
 * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
 *
 * ```js
 * var latlngs = [
 *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
 *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
 * ];
 * ```
 *
 * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
 *
 * ```js
 * var latlngs = [
 *   [ // first polygon
 *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
 *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
 *   ],
 *   [ // second polygon
 *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
 *   ]
 * ];
 * ```
 */

var Polygon = Polyline.extend({

	options: {
		fill: true
	},

	isEmpty: function () {
		return !this._latlngs.length || !this._latlngs[0].length;
	},

	getCenter: function () {
		// throws error when not yet added to map as this center calculation requires projected coordinates
		if (!this._map) {
			throw new Error('Must add layer to map before using getCenter()');
		}

		var i, j, p1, p2, f, area, x, y, center,
		    points = this._rings[0],
		    len = points.length;

		if (!len) { return null; }

		// polygon centroid algorithm; only uses the first ring if there are multiple

		area = x = y = 0;

		for (i = 0, j = len - 1; i < len; j = i++) {
			p1 = points[i];
			p2 = points[j];

			f = p1.y * p2.x - p2.y * p1.x;
			x += (p1.x + p2.x) * f;
			y += (p1.y + p2.y) * f;
			area += f * 3;
		}

		if (area === 0) {
			// Polygon is so small that all points are on same pixel.
			center = points[0];
		} else {
			center = [x / area, y / area];
		}
		return this._map.layerPointToLatLng(center);
	},

	_convertLatLngs: function (latlngs) {
		var result = Polyline.prototype._convertLatLngs.call(this, latlngs),
		    len = result.length;

		// remove last point if it equals first one
		if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) {
			result.pop();
		}
		return result;
	},

	_setLatLngs: function (latlngs) {
		Polyline.prototype._setLatLngs.call(this, latlngs);
		if (isFlat(this._latlngs)) {
			this._latlngs = [this._latlngs];
		}
	},

	_defaultShape: function () {
		return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
	},

	_clipPoints: function () {
		// polygons need a different clipping algorithm so we redefine that

		var bounds = this._renderer._bounds,
		    w = this.options.weight,
		    p = new Point(w, w);

		// increase clip padding by stroke width to avoid stroke on clip edges
		bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));

		this._parts = [];
		if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
			return;
		}

		if (this.options.noClip) {
			this._parts = this._rings;
			return;
		}

		for (var i = 0, len = this._rings.length, clipped; i < len; i++) {
			clipped = clipPolygon(this._rings[i], bounds, true);
			if (clipped.length) {
				this._parts.push(clipped);
			}
		}
	},

	_updatePath: function () {
		this._renderer._updatePoly(this, true);
	},

	// Needed by the `Canvas` renderer for interactivity
	_containsPoint: function (p) {
		var inside = false,
		    part, p1, p2, i, j, k, len, len2;

		if (!this._pxBounds.contains(p)) { return false; }

		// ray casting algorithm for detecting if point is in polygon
		for (i = 0, len = this._parts.length; i < len; i++) {
			part = this._parts[i];

			for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
				p1 = part[j];
				p2 = part[k];

				if (((p1.y > p.y) !== (p2.y > p.y)) && (p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x)) {
					inside = !inside;
				}
			}
		}

		// also check if it's on polygon stroke
		return inside || Polyline.prototype._containsPoint.call(this, p, true);
	}

});


// @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
function polygon(latlngs, options) {
	return new Polygon(latlngs, options);
}

/*
 * @class GeoJSON
 * @aka L.GeoJSON
 * @inherits FeatureGroup
 *
 * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
 * GeoJSON data and display it on the map. Extends `FeatureGroup`.
 *
 * @example
 *
 * ```js
 * L.geoJSON(data, {
 * 	style: function (feature) {
 * 		return {color: feature.properties.color};
 * 	}
 * }).bindPopup(function (layer) {
 * 	return layer.feature.properties.description;
 * }).addTo(map);
 * ```
 */

var GeoJSON = FeatureGroup.extend({

	/* @section
	 * @aka GeoJSON options
	 *
	 * @option pointToLayer: Function = *
	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
	 * The default is to spawn a default `Marker`:
	 * ```js
	 * function(geoJsonPoint, latlng) {
	 * 	return L.marker(latlng);
	 * }
	 * ```
	 *
	 * @option style: Function = *
	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
	 * called internally when data is added.
	 * The default value is to not override any defaults:
	 * ```js
	 * function (geoJsonFeature) {
	 * 	return {}
	 * }
	 * ```
	 *
	 * @option onEachFeature: Function = *
	 * A `Function` that will be called once for each created `Feature`, after it has
	 * been created and styled. Useful for attaching events and popups to features.
	 * The default is to do nothing with the newly created layers:
	 * ```js
	 * function (feature, layer) {}
	 * ```
	 *
	 * @option filter: Function = *
	 * A `Function` that will be used to decide whether to include a feature or not.
	 * The default is to include all features:
	 * ```js
	 * function (geoJsonFeature) {
	 * 	return true;
	 * }
	 * ```
	 * Note: dynamically changing the `filter` option will have effect only on newly
	 * added data. It will _not_ re-evaluate already included features.
	 *
	 * @option coordsToLatLng: Function = *
	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
	 * The default is the `coordsToLatLng` static method.
	 */

	initialize: function (geojson, options) {
		setOptions(this, options);

		this._layers = {};

		if (geojson) {
			this.addData(geojson);
		}
	},

	// @method addData( <GeoJSON> data ): this
	// Adds a GeoJSON object to the layer.
	addData: function (geojson) {
		var features = isArray(geojson) ? geojson : geojson.features,
		    i, len, feature;

		if (features) {
			for (i = 0, len = features.length; i < len; i++) {
				// only add this if geometry or geometries are set and not null
				feature = features[i];
				if (feature.geometries || feature.geometry || feature.features || feature.coordinates) {
					this.addData(feature);
				}
			}
			return this;
		}

		var options = this.options;

		if (options.filter && !options.filter(geojson)) { return this; }

		var layer = geometryToLayer(geojson, options);
		if (!layer) {
			return this;
		}
		layer.feature = asFeature(geojson);

		layer.defaultOptions = layer.options;
		this.resetStyle(layer);

		if (options.onEachFeature) {
			options.onEachFeature(geojson, layer);
		}

		return this.addLayer(layer);
	},

	// @method resetStyle( <Path> layer ): this
	// Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
	resetStyle: function (layer) {
		// reset any custom styles
		layer.options = extend({}, layer.defaultOptions);
		this._setLayerStyle(layer, this.options.style);
		return this;
	},

	// @method setStyle( <Function> style ): this
	// Changes styles of GeoJSON vector layers with the given style function.
	setStyle: function (style) {
		return this.eachLayer(function (layer) {
			this._setLayerStyle(layer, style);
		}, this);
	},

	_setLayerStyle: function (layer, style) {
		if (typeof style === 'function') {
			style = style(layer.feature);
		}
		if (layer.setStyle) {
			layer.setStyle(style);
		}
	}
});

// @section
// There are several static functions which can be called without instantiating L.GeoJSON:

// @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
// Creates a `Layer` from a given GeoJSON feature. Can use a custom
// [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
// functions if provided as options.
function geometryToLayer(geojson, options) {

	var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson,
	    coords = geometry ? geometry.coordinates : null,
	    layers = [],
	    pointToLayer = options && options.pointToLayer,
	    _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng,
	    latlng, latlngs, i, len;

	if (!coords && !geometry) {
		return null;
	}

	switch (geometry.type) {
	case 'Point':
		latlng = _coordsToLatLng(coords);
		return pointToLayer ? pointToLayer(geojson, latlng) : new Marker(latlng);

	case 'MultiPoint':
		for (i = 0, len = coords.length; i < len; i++) {
			latlng = _coordsToLatLng(coords[i]);
			layers.push(pointToLayer ? pointToLayer(geojson, latlng) : new Marker(latlng));
		}
		return new FeatureGroup(layers);

	case 'LineString':
	case 'MultiLineString':
		latlngs = coordsToLatLngs(coords, geometry.type === 'LineString' ? 0 : 1, _coordsToLatLng);
		return new Polyline(latlngs, options);

	case 'Polygon':
	case 'MultiPolygon':
		latlngs = coordsToLatLngs(coords, geometry.type === 'Polygon' ? 1 : 2, _coordsToLatLng);
		return new Polygon(latlngs, options);

	case 'GeometryCollection':
		for (i = 0, len = geometry.geometries.length; i < len; i++) {
			var layer = geometryToLayer({
				geometry: geometry.geometries[i],
				type: 'Feature',
				properties: geojson.properties
			}, options);

			if (layer) {
				layers.push(layer);
			}
		}
		return new FeatureGroup(layers);

	default:
		throw new Error('Invalid GeoJSON object.');
	}
}

// @function coordsToLatLng(coords: Array): LatLng
// Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
// or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
function coordsToLatLng(coords) {
	return new LatLng(coords[1], coords[0], coords[2]);
}

// @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
// Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
// `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
// Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
	var latlngs = [];

	for (var i = 0, len = coords.length, latlng; i < len; i++) {
		latlng = levelsDeep ?
				coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) :
				(_coordsToLatLng || coordsToLatLng)(coords[i]);

		latlngs.push(latlng);
	}

	return latlngs;
}

// @function latLngToCoords(latlng: LatLng, precision?: Number): Array
// Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
function latLngToCoords(latlng, precision) {
	precision = typeof precision === 'number' ? precision : 6;
	return latlng.alt !== undefined ?
			[formatNum(latlng.lng, precision), formatNum(latlng.lat, precision), formatNum(latlng.alt, precision)] :
			[formatNum(latlng.lng, precision), formatNum(latlng.lat, precision)];
}

// @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean): Array
// Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
// `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
	var coords = [];

	for (var i = 0, len = latlngs.length; i < len; i++) {
		coords.push(levelsDeep ?
			latLngsToCoords(latlngs[i], levelsDeep - 1, closed, precision) :
			latLngToCoords(latlngs[i], precision));
	}

	if (!levelsDeep && closed) {
		coords.push(coords[0]);
	}

	return coords;
}

function getFeature(layer, newGeometry) {
	return layer.feature ?
			extend({}, layer.feature, {geometry: newGeometry}) :
			asFeature(newGeometry);
}

// @function asFeature(geojson: Object): Object
// Normalize GeoJSON geometries/features into GeoJSON features.
function asFeature(geojson) {
	if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') {
		return geojson;
	}

	return {
		type: 'Feature',
		properties: {},
		geometry: geojson
	};
}

var PointToGeoJSON = {
	toGeoJSON: function (precision) {
		return getFeature(this, {
			type: 'Point',
			coordinates: latLngToCoords(this.getLatLng(), precision)
		});
	}
};

// @namespace Marker
// @method toGeoJSON(): Object
// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
Marker.include(PointToGeoJSON);

// @namespace CircleMarker
// @method toGeoJSON(): Object
// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
Circle.include(PointToGeoJSON);
CircleMarker.include(PointToGeoJSON);


// @namespace Polyline
// @method toGeoJSON(): Object
// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
Polyline.include({
	toGeoJSON: function (precision) {
		var multi = !isFlat(this._latlngs);

		var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);

		return getFeature(this, {
			type: (multi ? 'Multi' : '') + 'LineString',
			coordinates: coords
		});
	}
});

// @namespace Polygon
// @method toGeoJSON(): Object
// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
Polygon.include({
	toGeoJSON: function (precision) {
		var holes = !isFlat(this._latlngs),
		    multi = holes && !isFlat(this._latlngs[0]);

		var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);

		if (!holes) {
			coords = [coords];
		}

		return getFeature(this, {
			type: (multi ? 'Multi' : '') + 'Polygon',
			coordinates: coords
		});
	}
});


// @namespace LayerGroup
LayerGroup.include({
	toMultiPoint: function (precision) {
		var coords = [];

		this.eachLayer(function (layer) {
			coords.push(layer.toGeoJSON(precision).geometry.coordinates);
		});

		return getFeature(this, {
			type: 'MultiPoint',
			coordinates: coords
		});
	},

	// @method toGeoJSON(): Object
	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
	toGeoJSON: function (precision) {

		var type = this.feature && this.feature.geometry && this.feature.geometry.type;

		if (type === 'MultiPoint') {
			return this.toMultiPoint(precision);
		}

		var isGeometryCollection = type === 'GeometryCollection',
		    jsons = [];

		this.eachLayer(function (layer) {
			if (layer.toGeoJSON) {
				var json = layer.toGeoJSON(precision);
				if (isGeometryCollection) {
					jsons.push(json.geometry);
				} else {
					var feature = asFeature(json);
					// Squash nested feature collections
					if (feature.type === 'FeatureCollection') {
						jsons.push.apply(jsons, feature.features);
					} else {
						jsons.push(feature);
					}
				}
			}
		});

		if (isGeometryCollection) {
			return getFeature(this, {
				geometries: jsons,
				type: 'GeometryCollection'
			});
		}

		return {
			type: 'FeatureCollection',
			features: jsons
		};
	}
});

// @namespace GeoJSON
// @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
// Creates a GeoJSON layer. Optionally accepts an object in
// [GeoJSON format](http://geojson.org/geojson-spec.html) to display on the map
// (you can alternatively add it later with `addData` method) and an `options` object.
function geoJSON(geojson, options) {
	return new GeoJSON(geojson, options);
}

// Backward compatibility.
var geoJson = geoJSON;

/*
 * @class ImageOverlay
 * @aka L.ImageOverlay
 * @inherits Interactive layer
 *
 * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
 *
 * @example
 *
 * ```js
 * var imageUrl = 'http://www.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
 * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
 * L.imageOverlay(imageUrl, imageBounds).addTo(map);
 * ```
 */

var ImageOverlay = Layer.extend({

	// @section
	// @aka ImageOverlay options
	options: {
		// @option opacity: Number = 1.0
		// The opacity of the image overlay.
		opacity: 1,

		// @option alt: String = ''
		// Text for the `alt` attribute of the image (useful for accessibility).
		alt: '',

		// @option interactive: Boolean = false
		// If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
		interactive: false,

		// @option crossOrigin: Boolean = false
		// If true, the image will have its crossOrigin attribute set to ''. This is needed if you want to access image pixel data.
		crossOrigin: false,

		// @option errorOverlayUrl: String = ''
		// URL to the overlay image to show in place of the overlay that failed to load.
		errorOverlayUrl: '',

		// @option zIndex: Number = 1
		// The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the tile layer.
		zIndex: 1,

		// @option className: String = ''
		// A custom class name to assign to the image. Empty by default.
		className: '',
	},

	initialize: function (url, bounds, options) { // (String, LatLngBounds, Object)
		this._url = url;
		this._bounds = toLatLngBounds(bounds);

		setOptions(this, options);
	},

	onAdd: function () {
		if (!this._image) {
			this._initImage();

			if (this.options.opacity < 1) {
				this._updateOpacity();
			}
		}

		if (this.options.interactive) {
			addClass(this._image, 'leaflet-interactive');
			this.addInteractiveTarget(this._image);
		}

		this.getPane().appendChild(this._image);
		this._reset();
	},

	onRemove: function () {
		remove(this._image);
		if (this.options.interactive) {
			this.removeInteractiveTarget(this._image);
		}
	},

	// @method setOpacity(opacity: Number): this
	// Sets the opacity of the overlay.
	setOpacity: function (opacity) {
		this.options.opacity = opacity;

		if (this._image) {
			this._updateOpacity();
		}
		return this;
	},

	setStyle: function (styleOpts) {
		if (styleOpts.opacity) {
			this.setOpacity(styleOpts.opacity);
		}
		return this;
	},

	// @method bringToFront(): this
	// Brings the layer to the top of all overlays.
	bringToFront: function () {
		if (this._map) {
			toFront(this._image);
		}
		return this;
	},

	// @method bringToBack(): this
	// Brings the layer to the bottom of all overlays.
	bringToBack: function () {
		if (this._map) {
			toBack(this._image);
		}
		return this;
	},

	// @method setUrl(url: String): this
	// Changes the URL of the image.
	setUrl: function (url) {
		this._url = url;

		if (this._image) {
			this._image.src = url;
		}
		return this;
	},

	// @method setBounds(bounds: LatLngBounds): this
	// Update the bounds that this ImageOverlay covers
	setBounds: function (bounds) {
		this._bounds = toLatLngBounds(bounds);

		if (this._map) {
			this._reset();
		}
		return this;
	},

	getEvents: function () {
		var events = {
			zoom: this._reset,
			viewreset: this._reset
		};

		if (this._zoomAnimated) {
			events.zoomanim = this._animateZoom;
		}

		return events;
	},

	// @method: setZIndex(value: Number) : this
	// Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
	setZIndex: function (value) {
		this.options.zIndex = value;
		this._updateZIndex();
		return this;
	},

	// @method getBounds(): LatLngBounds
	// Get the bounds that this ImageOverlay covers
	getBounds: function () {
		return this._bounds;
	},

	// @method getElement(): HTMLElement
	// Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
	// used by this overlay.
	getElement: function () {
		return this._image;
	},

	_initImage: function () {
		var img = this._image = create$1('img',
				'leaflet-image-layer ' + (this._zoomAnimated ? 'leaflet-zoom-animated' : '') +
				 (this.options.className || ''));

		img.onselectstart = falseFn;
		img.onmousemove = falseFn;

		// @event load: Event
		// Fired when the ImageOverlay layer has loaded its image
		img.onload = bind(this.fire, this, 'load');
		img.onerror = bind(this._overlayOnError, this, 'error');

		if (this.options.crossOrigin) {
			img.crossOrigin = '';
		}

		if (this.options.zIndex) {
			this._updateZIndex();
		}

		img.src = this._url;
		img.alt = this.options.alt;
	},

	_animateZoom: function (e) {
		var scale = this._map.getZoomScale(e.zoom),
		    offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;

		setTransform(this._image, offset, scale);
	},

	_reset: function () {
		var image = this._image,
		    bounds = new Bounds(
		        this._map.latLngToLayerPoint(this._bounds.getNorthWest()),
		        this._map.latLngToLayerPoint(this._bounds.getSouthEast())),
		    size = bounds.getSize();

		setPosition(image, bounds.min);

		image.style.width  = size.x + 'px';
		image.style.height = size.y + 'px';
	},

	_updateOpacity: function () {
		setOpacity(this._image, this.options.opacity);
	},

	_updateZIndex: function () {
		if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) {
			this._image.style.zIndex = this.options.zIndex;
		}
	},

	_overlayOnError: function () {
		// @event error: Event
		// Fired when the ImageOverlay layer has loaded its image
		this.fire('error');

		var errorUrl = this.options.errorOverlayUrl;
		if (errorUrl && this._url !== errorUrl) {
			this._url = errorUrl;
			this._image.src = errorUrl;
		}
	}
});

// @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
// Instantiates an image overlay object given the URL of the image and the
// geographical bounds it is tied to.
var imageOverlay = function (url, bounds, options) {
	return new ImageOverlay(url, bounds, options);
};

/*
 * @class VideoOverlay
 * @aka L.VideoOverlay
 * @inherits ImageOverlay
 *
 * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
 *
 * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
 * HTML5 element.
 *
 * @example
 *
 * ```js
 * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
 * 	videoBounds = [[ 32, -130], [ 13, -100]];
 * L.VideoOverlay(videoUrl, videoBounds ).addTo(map);
 * ```
 */

var VideoOverlay = ImageOverlay.extend({

	// @section
	// @aka VideoOverlay options
	options: {
		// @option autoplay: Boolean = true
		// Whether the video starts playing automatically when loaded.
		autoplay: true,

		// @option loop: Boolean = true
		// Whether the video will loop back to the beginning when played.
		loop: true
	},

	_initImage: function () {
		var wasElementSupplied = this._url.tagName === 'VIDEO';
		var vid = this._image = wasElementSupplied ? this._url : create$1('video');

		vid.class = vid.class || '';
		vid.class += 'leaflet-image-layer ' + (this._zoomAnimated ? 'leaflet-zoom-animated' : '');

		vid.onselectstart = falseFn;
		vid.onmousemove = falseFn;

		// @event load: Event
		// Fired when the video has finished loading the first frame
		vid.onloadeddata = bind(this.fire, this, 'load');

		if (wasElementSupplied) { return; }

		if (!isArray(this._url)) { this._url = [this._url]; }

		vid.autoplay = !!this.options.autoplay;
		vid.loop = !!this.options.loop;
		for (var i = 0; i < this._url.length; i++) {
			var source = create$1('source');
			source.src = this._url[i];
			vid.appendChild(source);
		}
	}

	// @method getElement(): HTMLVideoElement
	// Returns the instance of [`HTMLVideoElement`](https://developer.mozilla.org/docs/Web/API/HTMLVideoElement)
	// used by this overlay.
});


// @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
// Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
// geographical bounds it is tied to.

function videoOverlay(video, bounds, options) {
	return new VideoOverlay(video, bounds, options);
}

/*
 * @class DivOverlay
 * @inherits Layer
 * @aka L.DivOverlay
 * Base model for L.Popup and L.Tooltip. Inherit from it for custom popup like plugins.
 */

// @namespace DivOverlay
var DivOverlay = Layer.extend({

	// @section
	// @aka DivOverlay options
	options: {
		// @option offset: Point = Point(0, 7)
		// The offset of the popup position. Useful to control the anchor
		// of the popup when opening it on some overlays.
		offset: [0, 7],

		// @option className: String = ''
		// A custom CSS class name to assign to the popup.
		className: '',

		// @option pane: String = 'popupPane'
		// `Map pane` where the popup will be added.
		pane: 'popupPane'
	},

	initialize: function (options, source) {
		setOptions(this, options);

		this._source = source;
	},

	onAdd: function (map) {
		this._zoomAnimated = map._zoomAnimated;

		if (!this._container) {
			this._initLayout();
		}

		if (map._fadeAnimated) {
			setOpacity(this._container, 0);
		}

		clearTimeout(this._removeTimeout);
		this.getPane().appendChild(this._container);
		this.update();

		if (map._fadeAnimated) {
			setOpacity(this._container, 1);
		}

		this.bringToFront();
	},

	onRemove: function (map) {
		if (map._fadeAnimated) {
			setOpacity(this._container, 0);
			this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
		} else {
			remove(this._container);
		}
	},

	// @namespace Popup
	// @method getLatLng: LatLng
	// Returns the geographical point of popup.
	getLatLng: function () {
		return this._latlng;
	},

	// @method setLatLng(latlng: LatLng): this
	// Sets the geographical point where the popup will open.
	setLatLng: function (latlng) {
		this._latlng = toLatLng(latlng);
		if (this._map) {
			this._updatePosition();
			this._adjustPan();
		}
		return this;
	},

	// @method getContent: String|HTMLElement
	// Returns the content of the popup.
	getContent: function () {
		return this._content;
	},

	// @method setContent(htmlContent: String|HTMLElement|Function): this
	// Sets the HTML content of the popup. If a function is passed the source layer will be passed to the function. The function should return a `String` or `HTMLElement` to be used in the popup.
	setContent: function (content) {
		this._content = content;
		this.update();
		return this;
	},

	// @method getElement: String|HTMLElement
	// Alias for [getContent()](#popup-getcontent)
	getElement: function () {
		return this._container;
	},

	// @method update: null
	// Updates the popup content, layout and position. Useful for updating the popup after something inside changed, e.g. image loaded.
	update: function () {
		if (!this._map) { return; }

		this._container.style.visibility = 'hidden';

		this._updateContent();
		this._updateLayout();
		this._updatePosition();

		this._container.style.visibility = '';

		this._adjustPan();
	},

	getEvents: function () {
		var events = {
			zoom: this._updatePosition,
			viewreset: this._updatePosition
		};

		if (this._zoomAnimated) {
			events.zoomanim = this._animateZoom;
		}
		return events;
	},

	// @method isOpen: Boolean
	// Returns `true` when the popup is visible on the map.
	isOpen: function () {
		return !!this._map && this._map.hasLayer(this);
	},

	// @method bringToFront: this
	// Brings this popup in front of other popups (in the same map pane).
	bringToFront: function () {
		if (this._map) {
			toFront(this._container);
		}
		return this;
	},

	// @method bringToBack: this
	// Brings this popup to the back of other popups (in the same map pane).
	bringToBack: function () {
		if (this._map) {
			toBack(this._container);
		}
		return this;
	},

	_updateContent: function () {
		if (!this._content) { return; }

		var node = this._contentNode;
		var content = (typeof this._content === 'function') ? this._content(this._source || this) : this._content;

		if (typeof content === 'string') {
			node.innerHTML = content;
		} else {
			while (node.hasChildNodes()) {
				node.removeChild(node.firstChild);
			}
			node.appendChild(content);
		}
		this.fire('contentupdate');
	},

	_updatePosition: function () {
		if (!this._map) { return; }

		var pos = this._map.latLngToLayerPoint(this._latlng),
		    offset = toPoint(this.options.offset),
		    anchor = this._getAnchor();

		if (this._zoomAnimated) {
			setPosition(this._container, pos.add(anchor));
		} else {
			offset = offset.add(pos).add(anchor);
		}

		var bottom = this._containerBottom = -offset.y,
		    left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;

		// bottom position the popup in case the height of the popup changes (images loading etc)
		this._container.style.bottom = bottom + 'px';
		this._container.style.left = left + 'px';
	},

	_getAnchor: function () {
		return [0, 0];
	}

});

/*
 * @class Popup
 * @inherits DivOverlay
 * @aka L.Popup
 * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
 * open popups while making sure that only one popup is open at one time
 * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
 *
 * @example
 *
 * If you want to just bind a popup to marker click and then open it, it's really easy:
 *
 * ```js
 * marker.bindPopup(popupContent).openPopup();
 * ```
 * Path overlays like polylines also have a `bindPopup` method.
 * Here's a more complicated way to open a popup on a map:
 *
 * ```js
 * var popup = L.popup()
 * 	.setLatLng(latlng)
 * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
 * 	.openOn(map);
 * ```
 */


// @namespace Popup
var Popup = DivOverlay.extend({

	// @section
	// @aka Popup options
	options: {
		// @option maxWidth: Number = 300
		// Max width of the popup, in pixels.
		maxWidth: 300,

		// @option minWidth: Number = 50
		// Min width of the popup, in pixels.
		minWidth: 50,

		// @option maxHeight: Number = null
		// If set, creates a scrollable container of the given height
		// inside a popup if its content exceeds it.
		maxHeight: null,

		// @option autoPan: Boolean = true
		// Set it to `false` if you don't want the map to do panning animation
		// to fit the opened popup.
		autoPan: true,

		// @option autoPanPaddingTopLeft: Point = null
		// The margin between the popup and the top left corner of the map
		// view after autopanning was performed.
		autoPanPaddingTopLeft: null,

		// @option autoPanPaddingBottomRight: Point = null
		// The margin between the popup and the bottom right corner of the map
		// view after autopanning was performed.
		autoPanPaddingBottomRight: null,

		// @option autoPanPadding: Point = Point(5, 5)
		// Equivalent of setting both top left and bottom right autopan padding to the same value.
		autoPanPadding: [5, 5],

		// @option keepInView: Boolean = false
		// Set it to `true` if you want to prevent users from panning the popup
		// off of the screen while it is open.
		keepInView: false,

		// @option closeButton: Boolean = true
		// Controls the presence of a close button in the popup.
		closeButton: true,

		// @option autoClose: Boolean = true
		// Set it to `false` if you want to override the default behavior of
		// the popup closing when another popup is opened.
		autoClose: true,

		// @option closeOnClick: Boolean = *
		// Set it if you want to override the default behavior of the popup closing when user clicks
		// on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.

		// @option className: String = ''
		// A custom CSS class name to assign to the popup.
		className: ''
	},

	// @namespace Popup
	// @method openOn(map: Map): this
	// Adds the popup to the map and closes the previous one. The same as `map.openPopup(popup)`.
	openOn: function (map) {
		map.openPopup(this);
		return this;
	},

	onAdd: function (map) {
		DivOverlay.prototype.onAdd.call(this, map);

		// @namespace Map
		// @section Popup events
		// @event popupopen: PopupEvent
		// Fired when a popup is opened in the map
		map.fire('popupopen', {popup: this});

		if (this._source) {
			// @namespace Layer
			// @section Popup events
			// @event popupopen: PopupEvent
			// Fired when a popup bound to this layer is opened
			this._source.fire('popupopen', {popup: this}, true);
			// For non-path layers, we toggle the popup when clicking
			// again the layer, so prevent the map to reopen it.
			if (!(this._source instanceof Path)) {
				this._source.on('preclick', stopPropagation);
			}
		}
	},

	onRemove: function (map) {
		DivOverlay.prototype.onRemove.call(this, map);

		// @namespace Map
		// @section Popup events
		// @event popupclose: PopupEvent
		// Fired when a popup in the map is closed
		map.fire('popupclose', {popup: this});

		if (this._source) {
			// @namespace Layer
			// @section Popup events
			// @event popupclose: PopupEvent
			// Fired when a popup bound to this layer is closed
			this._source.fire('popupclose', {popup: this}, true);
			if (!(this._source instanceof Path)) {
				this._source.off('preclick', stopPropagation);
			}
		}
	},

	getEvents: function () {
		var events = DivOverlay.prototype.getEvents.call(this);

		if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) {
			events.preclick = this._close;
		}

		if (this.options.keepInView) {
			events.moveend = this._adjustPan;
		}

		return events;
	},

	_close: function () {
		if (this._map) {
			this._map.closePopup(this);
		}
	},

	_initLayout: function () {
		var prefix = 'leaflet-popup',
		    container = this._container = create$1('div',
			prefix + ' ' + (this.options.className || '') +
			' leaflet-zoom-animated');

		var wrapper = this._wrapper = create$1('div', prefix + '-content-wrapper', container);
		this._contentNode = create$1('div', prefix + '-content', wrapper);

		disableClickPropagation(wrapper);
		disableScrollPropagation(this._contentNode);
		on(wrapper, 'contextmenu', stopPropagation);

		this._tipContainer = create$1('div', prefix + '-tip-container', container);
		this._tip = create$1('div', prefix + '-tip', this._tipContainer);

		if (this.options.closeButton) {
			var closeButton = this._closeButton = create$1('a', prefix + '-close-button', container);
			closeButton.href = '#close';
			closeButton.innerHTML = '&#215;';

			on(closeButton, 'click', this._onCloseButtonClick, this);
		}
	},

	_updateLayout: function () {
		var container = this._contentNode,
		    style = container.style;

		style.width = '';
		style.whiteSpace = 'nowrap';

		var width = container.offsetWidth;
		width = Math.min(width, this.options.maxWidth);
		width = Math.max(width, this.options.minWidth);

		style.width = (width + 1) + 'px';
		style.whiteSpace = '';

		style.height = '';

		var height = container.offsetHeight,
		    maxHeight = this.options.maxHeight,
		    scrolledClass = 'leaflet-popup-scrolled';

		if (maxHeight && height > maxHeight) {
			style.height = maxHeight + 'px';
			addClass(container, scrolledClass);
		} else {
			removeClass(container, scrolledClass);
		}

		this._containerWidth = this._container.offsetWidth;
	},

	_animateZoom: function (e) {
		var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center),
		    anchor = this._getAnchor();
		setPosition(this._container, pos.add(anchor));
	},

	_adjustPan: function () {
		if (!this.options.autoPan || (this._map._panAnim && this._map._panAnim._inProgress)) { return; }

		var map = this._map,
		    marginBottom = parseInt(getStyle(this._container, 'marginBottom'), 10) || 0,
		    containerHeight = this._container.offsetHeight + marginBottom,
		    containerWidth = this._containerWidth,
		    layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);

		layerPos._add(getPosition(this._container));

		var containerPos = map.layerPointToContainerPoint(layerPos),
		    padding = toPoint(this.options.autoPanPadding),
		    paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding),
		    paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding),
		    size = map.getSize(),
		    dx = 0,
		    dy = 0;

		if (containerPos.x + containerWidth + paddingBR.x > size.x) { // right
			dx = containerPos.x + containerWidth - size.x + paddingBR.x;
		}
		if (containerPos.x - dx - paddingTL.x < 0) { // left
			dx = containerPos.x - paddingTL.x;
		}
		if (containerPos.y + containerHeight + paddingBR.y > size.y) { // bottom
			dy = containerPos.y + containerHeight - size.y + paddingBR.y;
		}
		if (containerPos.y - dy - paddingTL.y < 0) { // top
			dy = containerPos.y - paddingTL.y;
		}

		// @namespace Map
		// @section Popup events
		// @event autopanstart: Event
		// Fired when the map starts autopanning when opening a popup.
		if (dx || dy) {
			map
			    .fire('autopanstart')
			    .panBy([dx, dy]);
		}
	},

	_onCloseButtonClick: function (e) {
		this._close();
		stop(e);
	},

	_getAnchor: function () {
		// Where should we anchor the popup on the source layer?
		return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [0, 0]);
	}

});

// @namespace Popup
// @factory L.popup(options?: Popup options, source?: Layer)
// Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
var popup = function (options, source) {
	return new Popup(options, source);
};


/* @namespace Map
 * @section Interaction Options
 * @option closePopupOnClick: Boolean = true
 * Set it to `false` if you don't want popups to close when user clicks the map.
 */
Map.mergeOptions({
	closePopupOnClick: true
});


// @namespace Map
// @section Methods for Layers and Controls
Map.include({
	// @method openPopup(popup: Popup): this
	// Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
	// @alternative
	// @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
	// Creates a popup with the specified content and options and opens it in the given point on a map.
	openPopup: function (popup, latlng, options) {
		if (!(popup instanceof Popup)) {
			popup = new Popup(options).setContent(popup);
		}

		if (latlng) {
			popup.setLatLng(latlng);
		}

		if (this.hasLayer(popup)) {
			return this;
		}

		if (this._popup && this._popup.options.autoClose) {
			this.closePopup();
		}

		this._popup = popup;
		return this.addLayer(popup);
	},

	// @method closePopup(popup?: Popup): this
	// Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
	closePopup: function (popup) {
		if (!popup || popup === this._popup) {
			popup = this._popup;
			this._popup = null;
		}
		if (popup) {
			this.removeLayer(popup);
		}
		return this;
	}
});

/*
 * @namespace Layer
 * @section Popup methods example
 *
 * All layers share a set of methods convenient for binding popups to it.
 *
 * ```js
 * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
 * layer.openPopup();
 * layer.closePopup();
 * ```
 *
 * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
 */

// @section Popup methods
Layer.include({

	// @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
	// Binds a popup to the layer with the passed `content` and sets up the
	// necessary event listeners. If a `Function` is passed it will receive
	// the layer as the first argument and should return a `String` or `HTMLElement`.
	bindPopup: function (content, options) {

		if (content instanceof Popup) {
			setOptions(content, options);
			this._popup = content;
			content._source = this;
		} else {
			if (!this._popup || options) {
				this._popup = new Popup(options, this);
			}
			this._popup.setContent(content);
		}

		if (!this._popupHandlersAdded) {
			this.on({
				click: this._openPopup,
				keypress: this._onKeyPress,
				remove: this.closePopup,
				move: this._movePopup
			});
			this._popupHandlersAdded = true;
		}

		return this;
	},

	// @method unbindPopup(): this
	// Removes the popup previously bound with `bindPopup`.
	unbindPopup: function () {
		if (this._popup) {
			this.off({
				click: this._openPopup,
				keypress: this._onKeyPress,
				remove: this.closePopup,
				move: this._movePopup
			});
			this._popupHandlersAdded = false;
			this._popup = null;
		}
		return this;
	},

	// @method openPopup(latlng?: LatLng): this
	// Opens the bound popup at the specificed `latlng` or at the default popup anchor if no `latlng` is passed.
	openPopup: function (layer, latlng) {
		if (!(layer instanceof Layer)) {
			latlng = layer;
			layer = this;
		}

		if (layer instanceof FeatureGroup) {
			for (var id in this._layers) {
				layer = this._layers[id];
				break;
			}
		}

		if (!latlng) {
			latlng = layer.getCenter ? layer.getCenter() : layer.getLatLng();
		}

		if (this._popup && this._map) {
			// set popup source to this layer
			this._popup._source = layer;

			// update the popup (content, layout, ect...)
			this._popup.update();

			// open the popup on the map
			this._map.openPopup(this._popup, latlng);
		}

		return this;
	},

	// @method closePopup(): this
	// Closes the popup bound to this layer if it is open.
	closePopup: function () {
		if (this._popup) {
			this._popup._close();
		}
		return this;
	},

	// @method togglePopup(): this
	// Opens or closes the popup bound to this layer depending on its current state.
	togglePopup: function (target) {
		if (this._popup) {
			if (this._popup._map) {
				this.closePopup();
			} else {
				this.openPopup(target);
			}
		}
		return this;
	},

	// @method isPopupOpen(): boolean
	// Returns `true` if the popup bound to this layer is currently open.
	isPopupOpen: function () {
		return (this._popup ? this._popup.isOpen() : false);
	},

	// @method setPopupContent(content: String|HTMLElement|Popup): this
	// Sets the content of the popup bound to this layer.
	setPopupContent: function (content) {
		if (this._popup) {
			this._popup.setContent(content);
		}
		return this;
	},

	// @method getPopup(): Popup
	// Returns the popup bound to this layer.
	getPopup: function () {
		return this._popup;
	},

	_openPopup: function (e) {
		var layer = e.layer || e.target;

		if (!this._popup) {
			return;
		}

		if (!this._map) {
			return;
		}

		// prevent map click
		stop(e);

		// if this inherits from Path its a vector and we can just
		// open the popup at the new location
		if (layer instanceof Path) {
			this.openPopup(e.layer || e.target, e.latlng);
			return;
		}

		// otherwise treat it like a marker and figure out
		// if we should toggle it open/closed
		if (this._map.hasLayer(this._popup) && this._popup._source === layer) {
			this.closePopup();
		} else {
			this.openPopup(layer, e.latlng);
		}
	},

	_movePopup: function (e) {
		this._popup.setLatLng(e.latlng);
	},

	_onKeyPress: function (e) {
		if (e.originalEvent.keyCode === 13) {
			this._openPopup(e);
		}
	}
});

/*
 * @class Tooltip
 * @inherits DivOverlay
 * @aka L.Tooltip
 * Used to display small texts on top of map layers.
 *
 * @example
 *
 * ```js
 * marker.bindTooltip("my tooltip text").openTooltip();
 * ```
 * Note about tooltip offset. Leaflet takes two options in consideration
 * for computing tooltip offseting:
 * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
 *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
 *   move it to the bottom. Negatives will move to the left and top.
 * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
 *   should adapt this value if you use a custom icon.
 */


// @namespace Tooltip
var Tooltip = DivOverlay.extend({

	// @section
	// @aka Tooltip options
	options: {
		// @option pane: String = 'tooltipPane'
		// `Map pane` where the tooltip will be added.
		pane: 'tooltipPane',

		// @option offset: Point = Point(0, 0)
		// Optional offset of the tooltip position.
		offset: [0, 0],

		// @option direction: String = 'auto'
		// Direction where to open the tooltip. Possible values are: `right`, `left`,
		// `top`, `bottom`, `center`, `auto`.
		// `auto` will dynamicaly switch between `right` and `left` according to the tooltip
		// position on the map.
		direction: 'auto',

		// @option permanent: Boolean = false
		// Whether to open the tooltip permanently or only on mouseover.
		permanent: false,

		// @option sticky: Boolean = false
		// If true, the tooltip will follow the mouse instead of being fixed at the feature center.
		sticky: false,

		// @option interactive: Boolean = false
		// If true, the tooltip will listen to the feature events.
		interactive: false,

		// @option opacity: Number = 0.9
		// Tooltip container opacity.
		opacity: 0.9
	},

	onAdd: function (map) {
		DivOverlay.prototype.onAdd.call(this, map);
		this.setOpacity(this.options.opacity);

		// @namespace Map
		// @section Tooltip events
		// @event tooltipopen: TooltipEvent
		// Fired when a tooltip is opened in the map.
		map.fire('tooltipopen', {tooltip: this});

		if (this._source) {
			// @namespace Layer
			// @section Tooltip events
			// @event tooltipopen: TooltipEvent
			// Fired when a tooltip bound to this layer is opened.
			this._source.fire('tooltipopen', {tooltip: this}, true);
		}
	},

	onRemove: function (map) {
		DivOverlay.prototype.onRemove.call(this, map);

		// @namespace Map
		// @section Tooltip events
		// @event tooltipclose: TooltipEvent
		// Fired when a tooltip in the map is closed.
		map.fire('tooltipclose', {tooltip: this});

		if (this._source) {
			// @namespace Layer
			// @section Tooltip events
			// @event tooltipclose: TooltipEvent
			// Fired when a tooltip bound to this layer is closed.
			this._source.fire('tooltipclose', {tooltip: this}, true);
		}
	},

	getEvents: function () {
		var events = DivOverlay.prototype.getEvents.call(this);

		if (touch && !this.options.permanent) {
			events.preclick = this._close;
		}

		return events;
	},

	_close: function () {
		if (this._map) {
			this._map.closeTooltip(this);
		}
	},

	_initLayout: function () {
		var prefix = 'leaflet-tooltip',
		    className = prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');

		this._contentNode = this._container = create$1('div', className);
	},

	_updateLayout: function () {},

	_adjustPan: function () {},

	_setPosition: function (pos) {
		var map = this._map,
		    container = this._container,
		    centerPoint = map.latLngToContainerPoint(map.getCenter()),
		    tooltipPoint = map.layerPointToContainerPoint(pos),
		    direction = this.options.direction,
		    tooltipWidth = container.offsetWidth,
		    tooltipHeight = container.offsetHeight,
		    offset = toPoint(this.options.offset),
		    anchor = this._getAnchor();

		if (direction === 'top') {
			pos = pos.add(toPoint(-tooltipWidth / 2 + offset.x, -tooltipHeight + offset.y + anchor.y, true));
		} else if (direction === 'bottom') {
			pos = pos.subtract(toPoint(tooltipWidth / 2 - offset.x, -offset.y, true));
		} else if (direction === 'center') {
			pos = pos.subtract(toPoint(tooltipWidth / 2 + offset.x, tooltipHeight / 2 - anchor.y + offset.y, true));
		} else if (direction === 'right' || direction === 'auto' && tooltipPoint.x < centerPoint.x) {
			direction = 'right';
			pos = pos.add(toPoint(offset.x + anchor.x, anchor.y - tooltipHeight / 2 + offset.y, true));
		} else {
			direction = 'left';
			pos = pos.subtract(toPoint(tooltipWidth + anchor.x - offset.x, tooltipHeight / 2 - anchor.y - offset.y, true));
		}

		removeClass(container, 'leaflet-tooltip-right');
		removeClass(container, 'leaflet-tooltip-left');
		removeClass(container, 'leaflet-tooltip-top');
		removeClass(container, 'leaflet-tooltip-bottom');
		addClass(container, 'leaflet-tooltip-' + direction);
		setPosition(container, pos);
	},

	_updatePosition: function () {
		var pos = this._map.latLngToLayerPoint(this._latlng);
		this._setPosition(pos);
	},

	setOpacity: function (opacity) {
		this.options.opacity = opacity;

		if (this._container) {
			setOpacity(this._container, opacity);
		}
	},

	_animateZoom: function (e) {
		var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
		this._setPosition(pos);
	},

	_getAnchor: function () {
		// Where should we anchor the tooltip on the source layer?
		return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [0, 0]);
	}

});

// @namespace Tooltip
// @factory L.tooltip(options?: Tooltip options, source?: Layer)
// Instantiates a Tooltip object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
var tooltip = function (options, source) {
	return new Tooltip(options, source);
};

// @namespace Map
// @section Methods for Layers and Controls
Map.include({

	// @method openTooltip(tooltip: Tooltip): this
	// Opens the specified tooltip.
	// @alternative
	// @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
	// Creates a tooltip with the specified content and options and open it.
	openTooltip: function (tooltip, latlng, options) {
		if (!(tooltip instanceof Tooltip)) {
			tooltip = new Tooltip(options).setContent(tooltip);
		}

		if (latlng) {
			tooltip.setLatLng(latlng);
		}

		if (this.hasLayer(tooltip)) {
			return this;
		}

		return this.addLayer(tooltip);
	},

	// @method closeTooltip(tooltip?: Tooltip): this
	// Closes the tooltip given as parameter.
	closeTooltip: function (tooltip) {
		if (tooltip) {
			this.removeLayer(tooltip);
		}
		return this;
	}

});

/*
 * @namespace Layer
 * @section Tooltip methods example
 *
 * All layers share a set of methods convenient for binding tooltips to it.
 *
 * ```js
 * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
 * layer.openTooltip();
 * layer.closeTooltip();
 * ```
 */

// @section Tooltip methods
Layer.include({

	// @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
	// Binds a tooltip to the layer with the passed `content` and sets up the
	// necessary event listeners. If a `Function` is passed it will receive
	// the layer as the first argument and should return a `String` or `HTMLElement`.
	bindTooltip: function (content, options) {

		if (content instanceof Tooltip) {
			setOptions(content, options);
			this._tooltip = content;
			content._source = this;
		} else {
			if (!this._tooltip || options) {
				this._tooltip = new Tooltip(options, this);
			}
			this._tooltip.setContent(content);

		}

		this._initTooltipInteractions();

		if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) {
			this.openTooltip();
		}

		return this;
	},

	// @method unbindTooltip(): this
	// Removes the tooltip previously bound with `bindTooltip`.
	unbindTooltip: function () {
		if (this._tooltip) {
			this._initTooltipInteractions(true);
			this.closeTooltip();
			this._tooltip = null;
		}
		return this;
	},

	_initTooltipInteractions: function (remove$$1) {
		if (!remove$$1 && this._tooltipHandlersAdded) { return; }
		var onOff = remove$$1 ? 'off' : 'on',
		    events = {
			remove: this.closeTooltip,
			move: this._moveTooltip
		    };
		if (!this._tooltip.options.permanent) {
			events.mouseover = this._openTooltip;
			events.mouseout = this.closeTooltip;
			if (this._tooltip.options.sticky) {
				events.mousemove = this._moveTooltip;
			}
			if (touch) {
				events.click = this._openTooltip;
			}
		} else {
			events.add = this._openTooltip;
		}
		this[onOff](events);
		this._tooltipHandlersAdded = !remove$$1;
	},

	// @method openTooltip(latlng?: LatLng): this
	// Opens the bound tooltip at the specificed `latlng` or at the default tooltip anchor if no `latlng` is passed.
	openTooltip: function (layer, latlng) {
		if (!(layer instanceof Layer)) {
			latlng = layer;
			layer = this;
		}

		if (layer instanceof FeatureGroup) {
			for (var id in this._layers) {
				layer = this._layers[id];
				break;
			}
		}

		if (!latlng) {
			latlng = layer.getCenter ? layer.getCenter() : layer.getLatLng();
		}

		if (this._tooltip && this._map) {

			// set tooltip source to this layer
			this._tooltip._source = layer;

			// update the tooltip (content, layout, ect...)
			this._tooltip.update();

			// open the tooltip on the map
			this._map.openTooltip(this._tooltip, latlng);

			// Tooltip container may not be defined if not permanent and never
			// opened.
			if (this._tooltip.options.interactive && this._tooltip._container) {
				addClass(this._tooltip._container, 'leaflet-clickable');
				this.addInteractiveTarget(this._tooltip._container);
			}
		}

		return this;
	},

	// @method closeTooltip(): this
	// Closes the tooltip bound to this layer if it is open.
	closeTooltip: function () {
		if (this._tooltip) {
			this._tooltip._close();
			if (this._tooltip.options.interactive && this._tooltip._container) {
				removeClass(this._tooltip._container, 'leaflet-clickable');
				this.removeInteractiveTarget(this._tooltip._container);
			}
		}
		return this;
	},

	// @method toggleTooltip(): this
	// Opens or closes the tooltip bound to this layer depending on its current state.
	toggleTooltip: function (target) {
		if (this._tooltip) {
			if (this._tooltip._map) {
				this.closeTooltip();
			} else {
				this.openTooltip(target);
			}
		}
		return this;
	},

	// @method isTooltipOpen(): boolean
	// Returns `true` if the tooltip bound to this layer is currently open.
	isTooltipOpen: function () {
		return this._tooltip.isOpen();
	},

	// @method setTooltipContent(content: String|HTMLElement|Tooltip): this
	// Sets the content of the tooltip bound to this layer.
	setTooltipContent: function (content) {
		if (this._tooltip) {
			this._tooltip.setContent(content);
		}
		return this;
	},

	// @method getTooltip(): Tooltip
	// Returns the tooltip bound to this layer.
	getTooltip: function () {
		return this._tooltip;
	},

	_openTooltip: function (e) {
		var layer = e.layer || e.target;

		if (!this._tooltip || !this._map) {
			return;
		}
		this.openTooltip(layer, this._tooltip.options.sticky ? e.latlng : undefined);
	},

	_moveTooltip: function (e) {
		var latlng = e.latlng, containerPoint, layerPoint;
		if (this._tooltip.options.sticky && e.originalEvent) {
			containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
			layerPoint = this._map.containerPointToLayerPoint(containerPoint);
			latlng = this._map.layerPointToLatLng(layerPoint);
		}
		this._tooltip.setLatLng(latlng);
	}
});

/*
 * @class DivIcon
 * @aka L.DivIcon
 * @inherits Icon
 *
 * Represents a lightweight icon for markers that uses a simple `<div>`
 * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
 *
 * @example
 * ```js
 * var myIcon = L.divIcon({className: 'my-div-icon'});
 * // you can set .my-div-icon styles in CSS
 *
 * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
 * ```
 *
 * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
 */

var DivIcon = Icon.extend({
	options: {
		// @section
		// @aka DivIcon options
		iconSize: [12, 12], // also can be set through CSS

		// iconAnchor: (Point),
		// popupAnchor: (Point),

		// @option html: String = ''
		// Custom HTML code to put inside the div element, empty by default.
		html: false,

		// @option bgPos: Point = [0, 0]
		// Optional relative position of the background, in pixels
		bgPos: null,

		className: 'leaflet-div-icon'
	},

	createIcon: function (oldIcon) {
		var div = (oldIcon && oldIcon.tagName === 'DIV') ? oldIcon : document.createElement('div'),
		    options = this.options;

		div.innerHTML = options.html !== false ? options.html : '';

		if (options.bgPos) {
			var bgPos = toPoint(options.bgPos);
			div.style.backgroundPosition = (-bgPos.x) + 'px ' + (-bgPos.y) + 'px';
		}
		this._setIconStyles(div, 'icon');

		return div;
	},

	createShadow: function () {
		return null;
	}
});

// @factory L.divIcon(options: DivIcon options)
// Creates a `DivIcon` instance with the given options.
function divIcon(options) {
	return new DivIcon(options);
}

Icon.Default = IconDefault;

/*
 * @class GridLayer
 * @inherits Layer
 * @aka L.GridLayer
 *
 * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
 * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
 *
 *
 * @section Synchronous usage
 * @example
 *
 * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
 *
 * ```js
 * var CanvasLayer = L.GridLayer.extend({
 *     createTile: function(coords){
 *         // create a <canvas> element for drawing
 *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
 *
 *         // setup tile width and height according to the options
 *         var size = this.getTileSize();
 *         tile.width = size.x;
 *         tile.height = size.y;
 *
 *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
 *         var ctx = tile.getContext('2d');
 *
 *         // return the tile so it can be rendered on screen
 *         return tile;
 *     }
 * });
 * ```
 *
 * @section Asynchronous usage
 * @example
 *
 * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
 *
 * ```js
 * var CanvasLayer = L.GridLayer.extend({
 *     createTile: function(coords, done){
 *         var error;
 *
 *         // create a <canvas> element for drawing
 *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
 *
 *         // setup tile width and height according to the options
 *         var size = this.getTileSize();
 *         tile.width = size.x;
 *         tile.height = size.y;
 *
 *         // draw something asynchronously and pass the tile to the done() callback
 *         setTimeout(function() {
 *             done(error, tile);
 *         }, 1000);
 *
 *         return tile;
 *     }
 * });
 * ```
 *
 * @section
 */


var GridLayer = Layer.extend({

	// @section
	// @aka GridLayer options
	options: {
		// @option tileSize: Number|Point = 256
		// Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
		tileSize: 256,

		// @option opacity: Number = 1.0
		// Opacity of the tiles. Can be used in the `createTile()` function.
		opacity: 1,

		// @option updateWhenIdle: Boolean = (depends)
		// Load new tiles only when panning ends.
		// `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
		// `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
		// [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
		updateWhenIdle: mobile,

		// @option updateWhenZooming: Boolean = true
		// By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
		updateWhenZooming: true,

		// @option updateInterval: Number = 200
		// Tiles will not update more than once every `updateInterval` milliseconds when panning.
		updateInterval: 200,

		// @option zIndex: Number = 1
		// The explicit zIndex of the tile layer.
		zIndex: 1,

		// @option bounds: LatLngBounds = undefined
		// If set, tiles will only be loaded inside the set `LatLngBounds`.
		bounds: null,

		// @option minZoom: Number = 0
		// The minimum zoom level down to which this layer will be displayed (inclusive).
		minZoom: 0,

		// @option maxZoom: Number = undefined
		// The maximum zoom level up to which this layer will be displayed (inclusive).
		maxZoom: undefined,

		// @option maxNativeZoom: Number = undefined
		// Maximum zoom number the tile source has available. If it is specified,
		// the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
		// from `maxNativeZoom` level and auto-scaled.
		maxNativeZoom: undefined,

		// @option minNativeZoom: Number = undefined
		// Minimum zoom number the tile source has available. If it is specified,
		// the tiles on all zoom levels lower than `minNativeZoom` will be loaded
		// from `minNativeZoom` level and auto-scaled.
		minNativeZoom: undefined,

		// @option noWrap: Boolean = false
		// Whether the layer is wrapped around the antimeridian. If `true`, the
		// GridLayer will only be displayed once at low zoom levels. Has no
		// effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
		// in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
		// tiles outside the CRS limits.
		noWrap: false,

		// @option pane: String = 'tilePane'
		// `Map pane` where the grid layer will be added.
		pane: 'tilePane',

		// @option className: String = ''
		// A custom class name to assign to the tile layer. Empty by default.
		className: '',

		// @option keepBuffer: Number = 2
		// When panning the map, keep this many rows and columns of tiles before unloading them.
		keepBuffer: 2
	},

	initialize: function (options) {
		setOptions(this, options);
	},

	onAdd: function () {
		this._initContainer();

		this._levels = {};
		this._tiles = {};

		this._resetView();
		this._update();
	},

	beforeAdd: function (map) {
		map._addZoomLimit(this);
	},

	onRemove: function (map) {
		this._removeAllTiles();
		remove(this._container);
		map._removeZoomLimit(this);
		this._container = null;
		this._tileZoom = null;
	},

	// @method bringToFront: this
	// Brings the tile layer to the top of all tile layers.
	bringToFront: function () {
		if (this._map) {
			toFront(this._container);
			this._setAutoZIndex(Math.max);
		}
		return this;
	},

	// @method bringToBack: this
	// Brings the tile layer to the bottom of all tile layers.
	bringToBack: function () {
		if (this._map) {
			toBack(this._container);
			this._setAutoZIndex(Math.min);
		}
		return this;
	},

	// @method getContainer: HTMLElement
	// Returns the HTML element that contains the tiles for this layer.
	getContainer: function () {
		return this._container;
	},

	// @method setOpacity(opacity: Number): this
	// Changes the [opacity](#gridlayer-opacity) of the grid layer.
	setOpacity: function (opacity) {
		this.options.opacity = opacity;
		this._updateOpacity();
		return this;
	},

	// @method setZIndex(zIndex: Number): this
	// Changes the [zIndex](#gridlayer-zindex) of the grid layer.
	setZIndex: function (zIndex) {
		this.options.zIndex = zIndex;
		this._updateZIndex();

		return this;
	},

	// @method isLoading: Boolean
	// Returns `true` if any tile in the grid layer has not finished loading.
	isLoading: function () {
		return this._loading;
	},

	// @method redraw: this
	// Causes the layer to clear all the tiles and request them again.
	redraw: function () {
		if (this._map) {
			this._removeAllTiles();
			this._update();
		}
		return this;
	},

	getEvents: function () {
		var events = {
			viewprereset: this._invalidateAll,
			viewreset: this._resetView,
			zoom: this._resetView,
			moveend: this._onMoveEnd
		};

		if (!this.options.updateWhenIdle) {
			// update tiles on move, but not more often than once per given interval
			if (!this._onMove) {
				this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
			}

			events.move = this._onMove;
		}

		if (this._zoomAnimated) {
			events.zoomanim = this._animateZoom;
		}

		return events;
	},

	// @section Extension methods
	// Layers extending `GridLayer` shall reimplement the following method.
	// @method createTile(coords: Object, done?: Function): HTMLElement
	// Called only internally, must be overriden by classes extending `GridLayer`.
	// Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
	// is specified, it must be called when the tile has finished loading and drawing.
	createTile: function () {
		return document.createElement('div');
	},

	// @section
	// @method getTileSize: Point
	// Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
	getTileSize: function () {
		var s = this.options.tileSize;
		return s instanceof Point ? s : new Point(s, s);
	},

	_updateZIndex: function () {
		if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) {
			this._container.style.zIndex = this.options.zIndex;
		}
	},

	_setAutoZIndex: function (compare) {
		// go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)

		var layers = this.getPane().children,
		    edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min

		for (var i = 0, len = layers.length, zIndex; i < len; i++) {

			zIndex = layers[i].style.zIndex;

			if (layers[i] !== this._container && zIndex) {
				edgeZIndex = compare(edgeZIndex, +zIndex);
			}
		}

		if (isFinite(edgeZIndex)) {
			this.options.zIndex = edgeZIndex + compare(-1, 1);
			this._updateZIndex();
		}
	},

	_updateOpacity: function () {
		if (!this._map) { return; }

		// IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
		if (ielt9) { return; }

		setOpacity(this._container, this.options.opacity);

		var now = +new Date(),
		    nextFrame = false,
		    willPrune = false;

		for (var key in this._tiles) {
			var tile = this._tiles[key];
			if (!tile.current || !tile.loaded) { continue; }

			var fade = Math.min(1, (now - tile.loaded) / 200);

			setOpacity(tile.el, fade);
			if (fade < 1) {
				nextFrame = true;
			} else {
				if (tile.active) {
					willPrune = true;
				} else {
					this._onOpaqueTile(tile);
				}
				tile.active = true;
			}
		}

		if (willPrune && !this._noPrune) { this._pruneTiles(); }

		if (nextFrame) {
			cancelAnimFrame(this._fadeFrame);
			this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
		}
	},

	_onOpaqueTile: falseFn,

	_initContainer: function () {
		if (this._container) { return; }

		this._container = create$1('div', 'leaflet-layer ' + (this.options.className || ''));
		this._updateZIndex();

		if (this.options.opacity < 1) {
			this._updateOpacity();
		}

		this.getPane().appendChild(this._container);
	},

	_updateLevels: function () {

		var zoom = this._tileZoom,
		    maxZoom = this.options.maxZoom;

		if (zoom === undefined) { return undefined; }

		for (var z in this._levels) {
			if (this._levels[z].el.children.length || z === zoom) {
				this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
				this._onUpdateLevel(z);
			} else {
				remove(this._levels[z].el);
				this._removeTilesAtZoom(z);
				this._onRemoveLevel(z);
				delete this._levels[z];
			}
		}

		var level = this._levels[zoom],
		    map = this._map;

		if (!level) {
			level = this._levels[zoom] = {};

			level.el = create$1('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
			level.el.style.zIndex = maxZoom;

			level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
			level.zoom = zoom;

			this._setZoomTransform(level, map.getCenter(), map.getZoom());

			// force the browser to consider the newly added element for transition
			falseFn(level.el.offsetWidth);

			this._onCreateLevel(level);
		}

		this._level = level;

		return level;
	},

	_onUpdateLevel: falseFn,

	_onRemoveLevel: falseFn,

	_onCreateLevel: falseFn,

	_pruneTiles: function () {
		if (!this._map) {
			return;
		}

		var key, tile;

		var zoom = this._map.getZoom();
		if (zoom > this.options.maxZoom ||
			zoom < this.options.minZoom) {
			this._removeAllTiles();
			return;
		}

		for (key in this._tiles) {
			tile = this._tiles[key];
			tile.retain = tile.current;
		}

		for (key in this._tiles) {
			tile = this._tiles[key];
			if (tile.current && !tile.active) {
				var coords = tile.coords;
				if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) {
					this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
				}
			}
		}

		for (key in this._tiles) {
			if (!this._tiles[key].retain) {
				this._removeTile(key);
			}
		}
	},

	_removeTilesAtZoom: function (zoom) {
		for (var key in this._tiles) {
			if (this._tiles[key].coords.z !== zoom) {
				continue;
			}
			this._removeTile(key);
		}
	},

	_removeAllTiles: function () {
		for (var key in this._tiles) {
			this._removeTile(key);
		}
	},

	_invalidateAll: function () {
		for (var z in this._levels) {
			remove(this._levels[z].el);
			this._onRemoveLevel(z);
			delete this._levels[z];
		}
		this._removeAllTiles();

		this._tileZoom = null;
	},

	_retainParent: function (x, y, z, minZoom) {
		var x2 = Math.floor(x / 2),
		    y2 = Math.floor(y / 2),
		    z2 = z - 1,
		    coords2 = new Point(+x2, +y2);
		coords2.z = +z2;

		var key = this._tileCoordsToKey(coords2),
		    tile = this._tiles[key];

		if (tile && tile.active) {
			tile.retain = true;
			return true;

		} else if (tile && tile.loaded) {
			tile.retain = true;
		}

		if (z2 > minZoom) {
			return this._retainParent(x2, y2, z2, minZoom);
		}

		return false;
	},

	_retainChildren: function (x, y, z, maxZoom) {

		for (var i = 2 * x; i < 2 * x + 2; i++) {
			for (var j = 2 * y; j < 2 * y + 2; j++) {

				var coords = new Point(i, j);
				coords.z = z + 1;

				var key = this._tileCoordsToKey(coords),
				    tile = this._tiles[key];

				if (tile && tile.active) {
					tile.retain = true;
					continue;

				} else if (tile && tile.loaded) {
					tile.retain = true;
				}

				if (z + 1 < maxZoom) {
					this._retainChildren(i, j, z + 1, maxZoom);
				}
			}
		}
	},

	_resetView: function (e) {
		var animating = e && (e.pinch || e.flyTo);
		this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
	},

	_animateZoom: function (e) {
		this._setView(e.center, e.zoom, true, e.noUpdate);
	},

	_clampZoom: function (zoom) {
		var options = this.options;

		if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) {
			return options.minNativeZoom;
		}

		if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) {
			return options.maxNativeZoom;
		}

		return zoom;
	},

	_setView: function (center, zoom, noPrune, noUpdate) {
		var tileZoom = this._clampZoom(Math.round(zoom));
		if ((this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom) ||
		    (this.options.minZoom !== undefined && tileZoom < this.options.minZoom)) {
			tileZoom = undefined;
		}

		var tileZoomChanged = this.options.updateWhenZooming && (tileZoom !== this._tileZoom);

		if (!noUpdate || tileZoomChanged) {

			this._tileZoom = tileZoom;

			if (this._abortLoading) {
				this._abortLoading();
			}

			this._updateLevels();
			this._resetGrid();

			if (tileZoom !== undefined) {
				this._update(center);
			}

			if (!noPrune) {
				this._pruneTiles();
			}

			// Flag to prevent _updateOpacity from pruning tiles during
			// a zoom anim or a pinch gesture
			this._noPrune = !!noPrune;
		}

		this._setZoomTransforms(center, zoom);
	},

	_setZoomTransforms: function (center, zoom) {
		for (var i in this._levels) {
			this._setZoomTransform(this._levels[i], center, zoom);
		}
	},

	_setZoomTransform: function (level, center, zoom) {
		var scale = this._map.getZoomScale(zoom, level.zoom),
		    translate = level.origin.multiplyBy(scale)
		        .subtract(this._map._getNewPixelOrigin(center, zoom)).round();

		if (any3d) {
			setTransform(level.el, translate, scale);
		} else {
			setPosition(level.el, translate);
		}
	},

	_resetGrid: function () {
		var map = this._map,
		    crs = map.options.crs,
		    tileSize = this._tileSize = this.getTileSize(),
		    tileZoom = this._tileZoom;

		var bounds = this._map.getPixelWorldBounds(this._tileZoom);
		if (bounds) {
			this._globalTileRange = this._pxBoundsToTileRange(bounds);
		}

		this._wrapX = crs.wrapLng && !this.options.noWrap && [
			Math.floor(map.project([0, crs.wrapLng[0]], tileZoom).x / tileSize.x),
			Math.ceil(map.project([0, crs.wrapLng[1]], tileZoom).x / tileSize.y)
		];
		this._wrapY = crs.wrapLat && !this.options.noWrap && [
			Math.floor(map.project([crs.wrapLat[0], 0], tileZoom).y / tileSize.x),
			Math.ceil(map.project([crs.wrapLat[1], 0], tileZoom).y / tileSize.y)
		];
	},

	_onMoveEnd: function () {
		if (!this._map || this._map._animatingZoom) { return; }

		this._update();
	},

	_getTiledPixelBounds: function (center) {
		var map = this._map,
		    mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(),
		    scale = map.getZoomScale(mapZoom, this._tileZoom),
		    pixelCenter = map.project(center, this._tileZoom).floor(),
		    halfSize = map.getSize().divideBy(scale * 2);

		return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
	},

	// Private method to load tiles in the grid's active zoom level according to map bounds
	_update: function (center) {
		var map = this._map;
		if (!map) { return; }
		var zoom = this._clampZoom(map.getZoom());

		if (center === undefined) { center = map.getCenter(); }
		if (this._tileZoom === undefined) { return; }	// if out of minzoom/maxzoom

		var pixelBounds = this._getTiledPixelBounds(center),
		    tileRange = this._pxBoundsToTileRange(pixelBounds),
		    tileCenter = tileRange.getCenter(),
		    queue = [],
		    margin = this.options.keepBuffer,
		    noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([margin, -margin]),
		                              tileRange.getTopRight().add([margin, -margin]));

		// Sanity check: panic if the tile range contains Infinity somewhere.
		if (!(isFinite(tileRange.min.x) &&
		      isFinite(tileRange.min.y) &&
		      isFinite(tileRange.max.x) &&
		      isFinite(tileRange.max.y))) { throw new Error('Attempted to load an infinite number of tiles'); }

		for (var key in this._tiles) {
			var c = this._tiles[key].coords;
			if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) {
				this._tiles[key].current = false;
			}
		}

		// _update just loads more tiles. If the tile zoom level differs too much
		// from the map's, let _setView reset levels and prune old tiles.
		if (Math.abs(zoom - this._tileZoom) > 1) { this._setView(center, zoom); return; }

		// create a queue of coordinates to load tiles from
		for (var j = tileRange.min.y; j <= tileRange.max.y; j++) {
			for (var i = tileRange.min.x; i <= tileRange.max.x; i++) {
				var coords = new Point(i, j);
				coords.z = this._tileZoom;

				if (!this._isValidTile(coords)) { continue; }

				if (!this._tiles[this._tileCoordsToKey(coords)]) {
					queue.push(coords);
				}
			}
		}

		// sort tile queue to load tiles in order of their distance to center
		queue.sort(function (a, b) {
			return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
		});

		if (queue.length !== 0) {
			// if it's the first batch of tiles to load
			if (!this._loading) {
				this._loading = true;
				// @event loading: Event
				// Fired when the grid layer starts loading tiles.
				this.fire('loading');
			}

			// create DOM fragment to append tiles in one batch
			var fragment = document.createDocumentFragment();

			for (i = 0; i < queue.length; i++) {
				this._addTile(queue[i], fragment);
			}

			this._level.el.appendChild(fragment);
		}
	},

	_isValidTile: function (coords) {
		var crs = this._map.options.crs;

		if (!crs.infinite) {
			// don't load tile if it's out of bounds and not wrapped
			var bounds = this._globalTileRange;
			if ((!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x)) ||
			    (!crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y))) { return false; }
		}

		if (!this.options.bounds) { return true; }

		// don't load tile if it doesn't intersect the bounds in options
		var tileBounds = this._tileCoordsToBounds(coords);
		return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
	},

	_keyToBounds: function (key) {
		return this._tileCoordsToBounds(this._keyToTileCoords(key));
	},

	// converts tile coordinates to its geographical bounds
	_tileCoordsToBounds: function (coords) {

		var map = this._map,
		    tileSize = this.getTileSize(),

		    nwPoint = coords.scaleBy(tileSize),
		    sePoint = nwPoint.add(tileSize),

		    nw = map.unproject(nwPoint, coords.z),
		    se = map.unproject(sePoint, coords.z),
		    bounds = new LatLngBounds(nw, se);

		if (!this.options.noWrap) {
			map.wrapLatLngBounds(bounds);
		}

		return bounds;
	},

	// converts tile coordinates to key for the tile cache
	_tileCoordsToKey: function (coords) {
		return coords.x + ':' + coords.y + ':' + coords.z;
	},

	// converts tile cache key to coordinates
	_keyToTileCoords: function (key) {
		var k = key.split(':'),
		    coords = new Point(+k[0], +k[1]);
		coords.z = +k[2];
		return coords;
	},

	_removeTile: function (key) {
		var tile = this._tiles[key];
		if (!tile) { return; }

		remove(tile.el);

		delete this._tiles[key];

		// @event tileunload: TileEvent
		// Fired when a tile is removed (e.g. when a tile goes off the screen).
		this.fire('tileunload', {
			tile: tile.el,
			coords: this._keyToTileCoords(key)
		});
	},

	_initTile: function (tile) {
		addClass(tile, 'leaflet-tile');

		var tileSize = this.getTileSize();
		tile.style.width = tileSize.x + 'px';
		tile.style.height = tileSize.y + 'px';

		tile.onselectstart = falseFn;
		tile.onmousemove = falseFn;

		// update opacity on tiles in IE7-8 because of filter inheritance problems
		if (ielt9 && this.options.opacity < 1) {
			setOpacity(tile, this.options.opacity);
		}

		// without this hack, tiles disappear after zoom on Chrome for Android
		// https://github.com/Leaflet/Leaflet/issues/2078
		if (android && !android23) {
			tile.style.WebkitBackfaceVisibility = 'hidden';
		}
	},

	_addTile: function (coords, container) {
		var tilePos = this._getTilePos(coords),
		    key = this._tileCoordsToKey(coords);

		var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));

		this._initTile(tile);

		// if createTile is defined with a second argument ("done" callback),
		// we know that tile is async and will be ready later; otherwise
		if (this.createTile.length < 2) {
			// mark tile as ready, but delay one frame for opacity animation to happen
			requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
		}

		setPosition(tile, tilePos);

		// save tile in cache
		this._tiles[key] = {
			el: tile,
			coords: coords,
			current: true
		};

		container.appendChild(tile);
		// @event tileloadstart: TileEvent
		// Fired when a tile is requested and starts loading.
		this.fire('tileloadstart', {
			tile: tile,
			coords: coords
		});
	},

	_tileReady: function (coords, err, tile) {
		if (!this._map) { return; }

		if (err) {
			// @event tileerror: TileErrorEvent
			// Fired when there is an error loading a tile.
			this.fire('tileerror', {
				error: err,
				tile: tile,
				coords: coords
			});
		}

		var key = this._tileCoordsToKey(coords);

		tile = this._tiles[key];
		if (!tile) { return; }

		tile.loaded = +new Date();
		if (this._map._fadeAnimated) {
			setOpacity(tile.el, 0);
			cancelAnimFrame(this._fadeFrame);
			this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
		} else {
			tile.active = true;
			this._pruneTiles();
		}

		if (!err) {
			addClass(tile.el, 'leaflet-tile-loaded');

			// @event tileload: TileEvent
			// Fired when a tile loads.
			this.fire('tileload', {
				tile: tile.el,
				coords: coords
			});
		}

		if (this._noTilesToLoad()) {
			this._loading = false;
			// @event load: Event
			// Fired when the grid layer loaded all visible tiles.
			this.fire('load');

			if (ielt9 || !this._map._fadeAnimated) {
				requestAnimFrame(this._pruneTiles, this);
			} else {
				// Wait a bit more than 0.2 secs (the duration of the tile fade-in)
				// to trigger a pruning.
				setTimeout(bind(this._pruneTiles, this), 250);
			}
		}
	},

	_getTilePos: function (coords) {
		return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
	},

	_wrapCoords: function (coords) {
		var newCoords = new Point(
			this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x,
			this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
		newCoords.z = coords.z;
		return newCoords;
	},

	_pxBoundsToTileRange: function (bounds) {
		var tileSize = this.getTileSize();
		return new Bounds(
			bounds.min.unscaleBy(tileSize).floor(),
			bounds.max.unscaleBy(tileSize).ceil().subtract([1, 1]));
	},

	_noTilesToLoad: function () {
		for (var key in this._tiles) {
			if (!this._tiles[key].loaded) { return false; }
		}
		return true;
	}
});

// @factory L.gridLayer(options?: GridLayer options)
// Creates a new instance of GridLayer with the supplied options.
function gridLayer(options) {
	return new GridLayer(options);
}

/*
 * @class TileLayer
 * @inherits GridLayer
 * @aka L.TileLayer
 * Used to load and display tile layers on the map. Extends `GridLayer`.
 *
 * @example
 *
 * ```js
 * L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar'}).addTo(map);
 * ```
 *
 * @section URL template
 * @example
 *
 * A string of the following form:
 *
 * ```
 * 'http://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
 * ```
 *
 * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
 *
 * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
 *
 * ```
 * L.tileLayer('http://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
 * ```
 */


var TileLayer = GridLayer.extend({

	// @section
	// @aka TileLayer options
	options: {
		// @option minZoom: Number = 0
		// The minimum zoom level down to which this layer will be displayed (inclusive).
		minZoom: 0,

		// @option maxZoom: Number = 18
		// The maximum zoom level up to which this layer will be displayed (inclusive).
		maxZoom: 18,

		// @option subdomains: String|String[] = 'abc'
		// Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
		subdomains: 'abc',

		// @option errorTileUrl: String = ''
		// URL to the tile image to show in place of the tile that failed to load.
		errorTileUrl: '',

		// @option zoomOffset: Number = 0
		// The zoom number used in tile URLs will be offset with this value.
		zoomOffset: 0,

		// @option tms: Boolean = false
		// If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
		tms: false,

		// @option zoomReverse: Boolean = false
		// If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
		zoomReverse: false,

		// @option detectRetina: Boolean = false
		// If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
		detectRetina: false,

		// @option crossOrigin: Boolean = false
		// If true, all tiles will have their crossOrigin attribute set to ''. This is needed if you want to access tile pixel data.
		crossOrigin: false
	},

	initialize: function (url, options) {

		this._url = url;

		options = setOptions(this, options);

		// detecting retina displays, adjusting tileSize and zoom levels
		if (options.detectRetina && retina && options.maxZoom > 0) {

			options.tileSize = Math.floor(options.tileSize / 2);

			if (!options.zoomReverse) {
				options.zoomOffset++;
				options.maxZoom--;
			} else {
				options.zoomOffset--;
				options.minZoom++;
			}

			options.minZoom = Math.max(0, options.minZoom);
		}

		if (typeof options.subdomains === 'string') {
			options.subdomains = options.subdomains.split('');
		}

		// for https://github.com/Leaflet/Leaflet/issues/137
		if (!android) {
			this.on('tileunload', this._onTileRemove);
		}
	},

	// @method setUrl(url: String, noRedraw?: Boolean): this
	// Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
	setUrl: function (url, noRedraw) {
		this._url = url;

		if (!noRedraw) {
			this.redraw();
		}
		return this;
	},

	// @method createTile(coords: Object, done?: Function): HTMLElement
	// Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
	// to return an `<img>` HTML element with the appropiate image URL given `coords`. The `done`
	// callback is called when the tile has been loaded.
	createTile: function (coords, done) {
		var tile = document.createElement('img');

		on(tile, 'load', bind(this._tileOnLoad, this, done, tile));
		on(tile, 'error', bind(this._tileOnError, this, done, tile));

		if (this.options.crossOrigin) {
			tile.crossOrigin = '';
		}

		/*
		 Alt tag is set to empty string to keep screen readers from reading URL and for compliance reasons
		 http://www.w3.org/TR/WCAG20-TECHS/H67
		*/
		tile.alt = '';

		/*
		 Set role="presentation" to force screen readers to ignore this
		 https://www.w3.org/TR/wai-aria/roles#textalternativecomputation
		*/
		tile.setAttribute('role', 'presentation');

		tile.src = this.getTileUrl(coords);

		return tile;
	},

	// @section Extension methods
	// @uninheritable
	// Layers extending `TileLayer` might reimplement the following method.
	// @method getTileUrl(coords: Object): String
	// Called only internally, returns the URL for a tile given its coordinates.
	// Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
	getTileUrl: function (coords) {
		var data = {
			r: retina ? '@2x' : '',
			s: this._getSubdomain(coords),
			x: coords.x,
			y: coords.y,
			z: this._getZoomForUrl()
		};
		if (this._map && !this._map.options.crs.infinite) {
			var invertedY = this._globalTileRange.max.y - coords.y;
			if (this.options.tms) {
				data['y'] = invertedY;
			}
			data['-y'] = invertedY;
		}

		return template(this._url, extend(data, this.options));
	},

	_tileOnLoad: function (done, tile) {
		// For https://github.com/Leaflet/Leaflet/issues/3332
		if (ielt9) {
			setTimeout(bind(done, this, null, tile), 0);
		} else {
			done(null, tile);
		}
	},

	_tileOnError: function (done, tile, e) {
		var errorUrl = this.options.errorTileUrl;
		if (errorUrl && tile.src !== errorUrl) {
			tile.src = errorUrl;
		}
		done(e, tile);
	},

	_onTileRemove: function (e) {
		e.tile.onload = null;
	},

	_getZoomForUrl: function () {
		var zoom = this._tileZoom,
		maxZoom = this.options.maxZoom,
		zoomReverse = this.options.zoomReverse,
		zoomOffset = this.options.zoomOffset;

		if (zoomReverse) {
			zoom = maxZoom - zoom;
		}

		return zoom + zoomOffset;
	},

	_getSubdomain: function (tilePoint) {
		var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
		return this.options.subdomains[index];
	},

	// stops loading all tiles in the background layer
	_abortLoading: function () {
		var i, tile;
		for (i in this._tiles) {
			if (this._tiles[i].coords.z !== this._tileZoom) {
				tile = this._tiles[i].el;

				tile.onload = falseFn;
				tile.onerror = falseFn;

				if (!tile.complete) {
					tile.src = emptyImageUrl;
					remove(tile);
				}
			}
		}
	}
});


// @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
// Instantiates a tile layer object given a `URL template` and optionally an options object.

function tileLayer(url, options) {
	return new TileLayer(url, options);
}

/*
 * @class TileLayer.WMS
 * @inherits TileLayer
 * @aka L.TileLayer.WMS
 * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
 *
 * @example
 *
 * ```js
 * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
 * 	layers: 'nexrad-n0r-900913',
 * 	format: 'image/png',
 * 	transparent: true,
 * 	attribution: "Weather data © 2012 IEM Nexrad"
 * });
 * ```
 */

var TileLayerWMS = TileLayer.extend({

	// @section
	// @aka TileLayer.WMS options
	// If any custom options not documented here are used, they will be sent to the
	// WMS server as extra parameters in each request URL. This can be useful for
	// [non-standard vendor WMS parameters](http://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
	defaultWmsParams: {
		service: 'WMS',
		request: 'GetMap',

		// @option layers: String = ''
		// **(required)** Comma-separated list of WMS layers to show.
		layers: '',

		// @option styles: String = ''
		// Comma-separated list of WMS styles.
		styles: '',

		// @option format: String = 'image/jpeg'
		// WMS image format (use `'image/png'` for layers with transparency).
		format: 'image/jpeg',

		// @option transparent: Boolean = false
		// If `true`, the WMS service will return images with transparency.
		transparent: false,

		// @option version: String = '1.1.1'
		// Version of the WMS service to use
		version: '1.1.1'
	},

	options: {
		// @option crs: CRS = null
		// Coordinate Reference System to use for the WMS requests, defaults to
		// map CRS. Don't change this if you're not sure what it means.
		crs: null,

		// @option uppercase: Boolean = false
		// If `true`, WMS request parameter keys will be uppercase.
		uppercase: false
	},

	initialize: function (url, options) {

		this._url = url;

		var wmsParams = extend({}, this.defaultWmsParams);

		// all keys that are not TileLayer options go to WMS params
		for (var i in options) {
			if (!(i in this.options)) {
				wmsParams[i] = options[i];
			}
		}

		options = setOptions(this, options);

		wmsParams.width = wmsParams.height = options.tileSize * (options.detectRetina && retina ? 2 : 1);

		this.wmsParams = wmsParams;
	},

	onAdd: function (map) {

		this._crs = this.options.crs || map.options.crs;
		this._wmsVersion = parseFloat(this.wmsParams.version);

		var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
		this.wmsParams[projectionKey] = this._crs.code;

		TileLayer.prototype.onAdd.call(this, map);
	},

	getTileUrl: function (coords) {

		var tileBounds = this._tileCoordsToBounds(coords),
		    nw = this._crs.project(tileBounds.getNorthWest()),
		    se = this._crs.project(tileBounds.getSouthEast()),

		    bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ?
			    [se.y, nw.x, nw.y, se.x] :
			    [nw.x, se.y, se.x, nw.y]).join(','),

		    url = TileLayer.prototype.getTileUrl.call(this, coords);

		return url +
			getParamString(this.wmsParams, url, this.options.uppercase) +
			(this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
	},

	// @method setParams(params: Object, noRedraw?: Boolean): this
	// Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
	setParams: function (params, noRedraw) {

		extend(this.wmsParams, params);

		if (!noRedraw) {
			this.redraw();
		}

		return this;
	}
});


// @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
// Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
function tileLayerWMS(url, options) {
	return new TileLayerWMS(url, options);
}

TileLayer.WMS = TileLayerWMS;
tileLayer.wms = tileLayerWMS;

/*
 * @class Renderer
 * @inherits Layer
 * @aka L.Renderer
 *
 * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
 * DOM container of the renderer, its bounds, and its zoom animation.
 *
 * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
 * itself can be added or removed to the map. All paths use a renderer, which can
 * be implicit (the map will decide the type of renderer and use it automatically)
 * or explicit (using the [`renderer`](#path-renderer) option of the path).
 *
 * Do not use this class directly, use `SVG` and `Canvas` instead.
 *
 * @event update: Event
 * Fired when the renderer updates its bounds, center and zoom, for example when
 * its map has moved
 */

var Renderer = Layer.extend({

	// @section
	// @aka Renderer options
	options: {
		// @option padding: Number = 0.1
		// How much to extend the clip area around the map view (relative to its size)
		// e.g. 0.1 would be 10% of map view in each direction
		padding: 0.1
	},

	initialize: function (options) {
		setOptions(this, options);
		stamp(this);
		this._layers = this._layers || {};
	},

	onAdd: function () {
		if (!this._container) {
			this._initContainer(); // defined by renderer implementations

			if (this._zoomAnimated) {
				addClass(this._container, 'leaflet-zoom-animated');
			}
		}

		this.getPane().appendChild(this._container);
		this._update();
		this.on('update', this._updatePaths, this);
	},

	onRemove: function () {
		this.off('update', this._updatePaths, this);
		this._destroyContainer();
	},

	getEvents: function () {
		var events = {
			viewreset: this._reset,
			zoom: this._onZoom,
			moveend: this._update,
			zoomend: this._onZoomEnd
		};
		if (this._zoomAnimated) {
			events.zoomanim = this._onAnimZoom;
		}
		return events;
	},

	_onAnimZoom: function (ev) {
		this._updateTransform(ev.center, ev.zoom);
	},

	_onZoom: function () {
		this._updateTransform(this._map.getCenter(), this._map.getZoom());
	},

	_updateTransform: function (center, zoom) {
		var scale = this._map.getZoomScale(zoom, this._zoom),
		    position = getPosition(this._container),
		    viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding),
		    currentCenterPoint = this._map.project(this._center, zoom),
		    destCenterPoint = this._map.project(center, zoom),
		    centerOffset = destCenterPoint.subtract(currentCenterPoint),

		    topLeftOffset = viewHalf.multiplyBy(-scale).add(position).add(viewHalf).subtract(centerOffset);

		if (any3d) {
			setTransform(this._container, topLeftOffset, scale);
		} else {
			setPosition(this._container, topLeftOffset);
		}
	},

	_reset: function () {
		this._update();
		this._updateTransform(this._center, this._zoom);

		for (var id in this._layers) {
			this._layers[id]._reset();
		}
	},

	_onZoomEnd: function () {
		for (var id in this._layers) {
			this._layers[id]._project();
		}
	},

	_updatePaths: function () {
		for (var id in this._layers) {
			this._layers[id]._update();
		}
	},

	_update: function () {
		// Update pixel bounds of renderer container (for positioning/sizing/clipping later)
		// Subclasses are responsible of firing the 'update' event.
		var p = this.options.padding,
		    size = this._map.getSize(),
		    min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();

		this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());

		this._center = this._map.getCenter();
		this._zoom = this._map.getZoom();
	}
});

/*
 * @class Canvas
 * @inherits Renderer
 * @aka L.Canvas
 *
 * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
 * Inherits `Renderer`.
 *
 * Due to [technical limitations](http://caniuse.com/#search=canvas), Canvas is not
 * available in all web browsers, notably IE8, and overlapping geometries might
 * not display properly in some edge cases.
 *
 * @example
 *
 * Use Canvas by default for all paths in the map:
 *
 * ```js
 * var map = L.map('map', {
 * 	renderer: L.canvas()
 * });
 * ```
 *
 * Use a Canvas renderer with extra padding for specific vector geometries:
 *
 * ```js
 * var map = L.map('map');
 * var myRenderer = L.canvas({ padding: 0.5 });
 * var line = L.polyline( coordinates, { renderer: myRenderer } );
 * var circle = L.circle( center, { renderer: myRenderer } );
 * ```
 */

var Canvas = Renderer.extend({
	getEvents: function () {
		var events = Renderer.prototype.getEvents.call(this);
		events.viewprereset = this._onViewPreReset;
		return events;
	},

	_onViewPreReset: function () {
		// Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
		this._postponeUpdatePaths = true;
	},

	onAdd: function () {
		Renderer.prototype.onAdd.call(this);

		// Redraw vectors since canvas is cleared upon removal,
		// in case of removing the renderer itself from the map.
		this._draw();
	},

	_initContainer: function () {
		var container = this._container = document.createElement('canvas');

		on(container, 'mousemove', throttle(this._onMouseMove, 32, this), this);
		on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this);
		on(container, 'mouseout', this._handleMouseOut, this);

		this._ctx = container.getContext('2d');
	},

	_destroyContainer: function () {
		delete this._ctx;
		remove(this._container);
		off(this._container);
		delete this._container;
	},

	_updatePaths: function () {
		if (this._postponeUpdatePaths) { return; }

		var layer;
		this._redrawBounds = null;
		for (var id in this._layers) {
			layer = this._layers[id];
			layer._update();
		}
		this._redraw();
	},

	_update: function () {
		if (this._map._animatingZoom && this._bounds) { return; }

		this._drawnLayers = {};

		Renderer.prototype._update.call(this);

		var b = this._bounds,
		    container = this._container,
		    size = b.getSize(),
		    m = retina ? 2 : 1;

		setPosition(container, b.min);

		// set canvas size (also clearing it); use double size on retina
		container.width = m * size.x;
		container.height = m * size.y;
		container.style.width = size.x + 'px';
		container.style.height = size.y + 'px';

		if (retina) {
			this._ctx.scale(2, 2);
		}

		// translate so we use the same path coordinates after canvas element moves
		this._ctx.translate(-b.min.x, -b.min.y);

		// Tell paths to redraw themselves
		this.fire('update');
	},

	_reset: function () {
		Renderer.prototype._reset.call(this);

		if (this._postponeUpdatePaths) {
			this._postponeUpdatePaths = false;
			this._updatePaths();
		}
	},

	_initPath: function (layer) {
		this._updateDashArray(layer);
		this._layers[stamp(layer)] = layer;

		var order = layer._order = {
			layer: layer,
			prev: this._drawLast,
			next: null
		};
		if (this._drawLast) { this._drawLast.next = order; }
		this._drawLast = order;
		this._drawFirst = this._drawFirst || this._drawLast;
	},

	_addPath: function (layer) {
		this._requestRedraw(layer);
	},

	_removePath: function (layer) {
		var order = layer._order;
		var next = order.next;
		var prev = order.prev;

		if (next) {
			next.prev = prev;
		} else {
			this._drawLast = prev;
		}
		if (prev) {
			prev.next = next;
		} else {
			this._drawFirst = next;
		}

		delete layer._order;

		delete this._layers[L.stamp(layer)];

		this._requestRedraw(layer);
	},

	_updatePath: function (layer) {
		// Redraw the union of the layer's old pixel
		// bounds and the new pixel bounds.
		this._extendRedrawBounds(layer);
		layer._project();
		layer._update();
		// The redraw will extend the redraw bounds
		// with the new pixel bounds.
		this._requestRedraw(layer);
	},

	_updateStyle: function (layer) {
		this._updateDashArray(layer);
		this._requestRedraw(layer);
	},

	_updateDashArray: function (layer) {
		if (layer.options.dashArray) {
			var parts = layer.options.dashArray.split(','),
			    dashArray = [],
			    i;
			for (i = 0; i < parts.length; i++) {
				dashArray.push(Number(parts[i]));
			}
			layer.options._dashArray = dashArray;
		}
	},

	_requestRedraw: function (layer) {
		if (!this._map) { return; }

		this._extendRedrawBounds(layer);
		this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
	},

	_extendRedrawBounds: function (layer) {
		if (layer._pxBounds) {
			var padding = (layer.options.weight || 0) + 1;
			this._redrawBounds = this._redrawBounds || new Bounds();
			this._redrawBounds.extend(layer._pxBounds.min.subtract([padding, padding]));
			this._redrawBounds.extend(layer._pxBounds.max.add([padding, padding]));
		}
	},

	_redraw: function () {
		this._redrawRequest = null;

		if (this._redrawBounds) {
			this._redrawBounds.min._floor();
			this._redrawBounds.max._ceil();
		}

		this._clear(); // clear layers in redraw bounds
		this._draw(); // draw layers

		this._redrawBounds = null;
	},

	_clear: function () {
		var bounds = this._redrawBounds;
		if (bounds) {
			var size = bounds.getSize();
			this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
		} else {
			this._ctx.clearRect(0, 0, this._container.width, this._container.height);
		}
	},

	_draw: function () {
		var layer, bounds = this._redrawBounds;
		this._ctx.save();
		if (bounds) {
			var size = bounds.getSize();
			this._ctx.beginPath();
			this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
			this._ctx.clip();
		}

		this._drawing = true;

		for (var order = this._drawFirst; order; order = order.next) {
			layer = order.layer;
			if (!bounds || (layer._pxBounds && layer._pxBounds.intersects(bounds))) {
				layer._updatePath();
			}
		}

		this._drawing = false;

		this._ctx.restore();  // Restore state before clipping.
	},

	_updatePoly: function (layer, closed) {
		if (!this._drawing) { return; }

		var i, j, len2, p,
		    parts = layer._parts,
		    len = parts.length,
		    ctx = this._ctx;

		if (!len) { return; }

		this._drawnLayers[layer._leaflet_id] = layer;

		ctx.beginPath();

		for (i = 0; i < len; i++) {
			for (j = 0, len2 = parts[i].length; j < len2; j++) {
				p = parts[i][j];
				ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
			}
			if (closed) {
				ctx.closePath();
			}
		}

		this._fillStroke(ctx, layer);

		// TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
	},

	_updateCircle: function (layer) {

		if (!this._drawing || layer._empty()) { return; }

		var p = layer._point,
		    ctx = this._ctx,
		    r = layer._radius,
		    s = (layer._radiusY || r) / r;

		this._drawnLayers[layer._leaflet_id] = layer;

		if (s !== 1) {
			ctx.save();
			ctx.scale(1, s);
		}

		ctx.beginPath();
		ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);

		if (s !== 1) {
			ctx.restore();
		}

		this._fillStroke(ctx, layer);
	},

	_fillStroke: function (ctx, layer) {
		var options = layer.options;

		if (options.fill) {
			ctx.globalAlpha = options.fillOpacity;
			ctx.fillStyle = options.fillColor || options.color;
			ctx.fill(options.fillRule || 'evenodd');
		}

		if (options.stroke && options.weight !== 0) {
			if (ctx.setLineDash) {
				ctx.setLineDash(layer.options && layer.options._dashArray || []);
			}
			ctx.globalAlpha = options.opacity;
			ctx.lineWidth = options.weight;
			ctx.strokeStyle = options.color;
			ctx.lineCap = options.lineCap;
			ctx.lineJoin = options.lineJoin;
			ctx.stroke();
		}
	},

	// Canvas obviously doesn't have mouse events for individual drawn objects,
	// so we emulate that by calculating what's under the mouse on mousemove/click manually

	_onClick: function (e) {
		var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;

		for (var order = this._drawFirst; order; order = order.next) {
			layer = order.layer;
			if (layer.options.interactive && layer._containsPoint(point) && !this._map._draggableMoved(layer)) {
				clickedLayer = layer;
			}
		}
		if (clickedLayer)  {
			fakeStop(e);
			this._fireEvent([clickedLayer], e);
		}
	},

	_onMouseMove: function (e) {
		if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) { return; }

		var point = this._map.mouseEventToLayerPoint(e);
		this._handleMouseHover(e, point);
	},


	_handleMouseOut: function (e) {
		var layer = this._hoveredLayer;
		if (layer) {
			// if we're leaving the layer, fire mouseout
			removeClass(this._container, 'leaflet-interactive');
			this._fireEvent([layer], e, 'mouseout');
			this._hoveredLayer = null;
		}
	},

	_handleMouseHover: function (e, point) {
		var layer, candidateHoveredLayer;

		for (var order = this._drawFirst; order; order = order.next) {
			layer = order.layer;
			if (layer.options.interactive && layer._containsPoint(point)) {
				candidateHoveredLayer = layer;
			}
		}

		if (candidateHoveredLayer !== this._hoveredLayer) {
			this._handleMouseOut(e);

			if (candidateHoveredLayer) {
				addClass(this._container, 'leaflet-interactive'); // change cursor
				this._fireEvent([candidateHoveredLayer], e, 'mouseover');
				this._hoveredLayer = candidateHoveredLayer;
			}
		}

		if (this._hoveredLayer) {
			this._fireEvent([this._hoveredLayer], e);
		}
	},

	_fireEvent: function (layers, e, type) {
		this._map._fireDOMEvent(e, type || e.type, layers);
	},

	_bringToFront: function (layer) {
		var order = layer._order;
		var next = order.next;
		var prev = order.prev;

		if (next) {
			next.prev = prev;
		} else {
			// Already last
			return;
		}
		if (prev) {
			prev.next = next;
		} else if (next) {
			// Update first entry unless this is the
			// signle entry
			this._drawFirst = next;
		}

		order.prev = this._drawLast;
		this._drawLast.next = order;

		order.next = null;
		this._drawLast = order;

		this._requestRedraw(layer);
	},

	_bringToBack: function (layer) {
		var order = layer._order;
		var next = order.next;
		var prev = order.prev;

		if (prev) {
			prev.next = next;
		} else {
			// Already first
			return;
		}
		if (next) {
			next.prev = prev;
		} else if (prev) {
			// Update last entry unless this is the
			// signle entry
			this._drawLast = prev;
		}

		order.prev = null;

		order.next = this._drawFirst;
		this._drawFirst.prev = order;
		this._drawFirst = order;

		this._requestRedraw(layer);
	}
});

// @factory L.canvas(options?: Renderer options)
// Creates a Canvas renderer with the given options.
function canvas$1(options) {
	return canvas ? new Canvas(options) : null;
}

/*
 * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
 */


var vmlCreate = (function () {
	try {
		document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
		return function (name) {
			return document.createElement('<lvml:' + name + ' class="lvml">');
		};
	} catch (e) {
		return function (name) {
			return document.createElement('<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
		};
	}
})();


/*
 * @class SVG
 *
 * Although SVG is not available on IE7 and IE8, these browsers support [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language), and the SVG renderer will fall back to VML in this case.
 *
 * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
 * with old versions of Internet Explorer.
 */

// mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
var vmlMixin = {

	_initContainer: function () {
		this._container = create$1('div', 'leaflet-vml-container');
	},

	_update: function () {
		if (this._map._animatingZoom) { return; }
		Renderer.prototype._update.call(this);
		this.fire('update');
	},

	_initPath: function (layer) {
		var container = layer._container = vmlCreate('shape');

		addClass(container, 'leaflet-vml-shape ' + (this.options.className || ''));

		container.coordsize = '1 1';

		layer._path = vmlCreate('path');
		container.appendChild(layer._path);

		this._updateStyle(layer);
		this._layers[stamp(layer)] = layer;
	},

	_addPath: function (layer) {
		var container = layer._container;
		this._container.appendChild(container);

		if (layer.options.interactive) {
			layer.addInteractiveTarget(container);
		}
	},

	_removePath: function (layer) {
		var container = layer._container;
		remove(container);
		layer.removeInteractiveTarget(container);
		delete this._layers[stamp(layer)];
	},

	_updateStyle: function (layer) {
		var stroke = layer._stroke,
		    fill = layer._fill,
		    options = layer.options,
		    container = layer._container;

		container.stroked = !!options.stroke;
		container.filled = !!options.fill;

		if (options.stroke) {
			if (!stroke) {
				stroke = layer._stroke = vmlCreate('stroke');
			}
			container.appendChild(stroke);
			stroke.weight = options.weight + 'px';
			stroke.color = options.color;
			stroke.opacity = options.opacity;

			if (options.dashArray) {
				stroke.dashStyle = isArray(options.dashArray) ?
				    options.dashArray.join(' ') :
				    options.dashArray.replace(/( *, *)/g, ' ');
			} else {
				stroke.dashStyle = '';
			}
			stroke.endcap = options.lineCap.replace('butt', 'flat');
			stroke.joinstyle = options.lineJoin;

		} else if (stroke) {
			container.removeChild(stroke);
			layer._stroke = null;
		}

		if (options.fill) {
			if (!fill) {
				fill = layer._fill = vmlCreate('fill');
			}
			container.appendChild(fill);
			fill.color = options.fillColor || options.color;
			fill.opacity = options.fillOpacity;

		} else if (fill) {
			container.removeChild(fill);
			layer._fill = null;
		}
	},

	_updateCircle: function (layer) {
		var p = layer._point.round(),
		    r = Math.round(layer._radius),
		    r2 = Math.round(layer._radiusY || r);

		this._setPath(layer, layer._empty() ? 'M0 0' :
				'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r2 + ' 0,' + (65535 * 360));
	},

	_setPath: function (layer, path) {
		layer._path.v = path;
	},

	_bringToFront: function (layer) {
		toFront(layer._container);
	},

	_bringToBack: function (layer) {
		toBack(layer._container);
	}
};

var create$2 = vml ? vmlCreate : svgCreate;

/*
 * @class SVG
 * @inherits Renderer
 * @aka L.SVG
 *
 * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
 * Inherits `Renderer`.
 *
 * Due to [technical limitations](http://caniuse.com/#search=svg), SVG is not
 * available in all web browsers, notably Android 2.x and 3.x.
 *
 * Although SVG is not available on IE7 and IE8, these browsers support
 * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
 * (a now deprecated technology), and the SVG renderer will fall back to VML in
 * this case.
 *
 * @example
 *
 * Use SVG by default for all paths in the map:
 *
 * ```js
 * var map = L.map('map', {
 * 	renderer: L.svg()
 * });
 * ```
 *
 * Use a SVG renderer with extra padding for specific vector geometries:
 *
 * ```js
 * var map = L.map('map');
 * var myRenderer = L.svg({ padding: 0.5 });
 * var line = L.polyline( coordinates, { renderer: myRenderer } );
 * var circle = L.circle( center, { renderer: myRenderer } );
 * ```
 */

var SVG = Renderer.extend({

	getEvents: function () {
		var events = Renderer.prototype.getEvents.call(this);
		events.zoomstart = this._onZoomStart;
		return events;
	},

	_initContainer: function () {
		this._container = create$2('svg');

		// makes it possible to click through svg root; we'll reset it back in individual paths
		this._container.setAttribute('pointer-events', 'none');

		this._rootGroup = create$2('g');
		this._container.appendChild(this._rootGroup);
	},

	_destroyContainer: function () {
		remove(this._container);
		off(this._container);
		delete this._container;
		delete this._rootGroup;
	},

	_onZoomStart: function () {
		// Drag-then-pinch interactions might mess up the center and zoom.
		// In this case, the easiest way to prevent this is re-do the renderer
		//   bounds and padding when the zooming starts.
		this._update();
	},

	_update: function () {
		if (this._map._animatingZoom && this._bounds) { return; }

		Renderer.prototype._update.call(this);

		var b = this._bounds,
		    size = b.getSize(),
		    container = this._container;

		// set size of svg-container if changed
		if (!this._svgSize || !this._svgSize.equals(size)) {
			this._svgSize = size;
			container.setAttribute('width', size.x);
			container.setAttribute('height', size.y);
		}

		// movement: update container viewBox so that we don't have to change coordinates of individual layers
		setPosition(container, b.min);
		container.setAttribute('viewBox', [b.min.x, b.min.y, size.x, size.y].join(' '));

		this.fire('update');
	},

	// methods below are called by vector layers implementations

	_initPath: function (layer) {
		var path = layer._path = create$2('path');

		// @namespace Path
		// @option className: String = null
		// Custom class name set on an element. Only for SVG renderer.
		if (layer.options.className) {
			addClass(path, layer.options.className);
		}

		if (layer.options.interactive) {
			addClass(path, 'leaflet-interactive');
		}

		this._updateStyle(layer);
		this._layers[stamp(layer)] = layer;
	},

	_addPath: function (layer) {
		if (!this._rootGroup) { this._initContainer(); }
		this._rootGroup.appendChild(layer._path);
		layer.addInteractiveTarget(layer._path);
	},

	_removePath: function (layer) {
		remove(layer._path);
		layer.removeInteractiveTarget(layer._path);
		delete this._layers[stamp(layer)];
	},

	_updatePath: function (layer) {
		layer._project();
		layer._update();
	},

	_updateStyle: function (layer) {
		var path = layer._path,
		    options = layer.options;

		if (!path) { return; }

		if (options.stroke) {
			path.setAttribute('stroke', options.color);
			path.setAttribute('stroke-opacity', options.opacity);
			path.setAttribute('stroke-width', options.weight);
			path.setAttribute('stroke-linecap', options.lineCap);
			path.setAttribute('stroke-linejoin', options.lineJoin);

			if (options.dashArray) {
				path.setAttribute('stroke-dasharray', options.dashArray);
			} else {
				path.removeAttribute('stroke-dasharray');
			}

			if (options.dashOffset) {
				path.setAttribute('stroke-dashoffset', options.dashOffset);
			} else {
				path.removeAttribute('stroke-dashoffset');
			}
		} else {
			path.setAttribute('stroke', 'none');
		}

		if (options.fill) {
			path.setAttribute('fill', options.fillColor || options.color);
			path.setAttribute('fill-opacity', options.fillOpacity);
			path.setAttribute('fill-rule', options.fillRule || 'evenodd');
		} else {
			path.setAttribute('fill', 'none');
		}
	},

	_updatePoly: function (layer, closed) {
		this._setPath(layer, pointsToPath(layer._parts, closed));
	},

	_updateCircle: function (layer) {
		var p = layer._point,
		    r = layer._radius,
		    r2 = layer._radiusY || r,
		    arc = 'a' + r + ',' + r2 + ' 0 1,0 ';

		// drawing a circle with two half-arcs
		var d = layer._empty() ? 'M0 0' :
				'M' + (p.x - r) + ',' + p.y +
				arc + (r * 2) + ',0 ' +
				arc + (-r * 2) + ',0 ';

		this._setPath(layer, d);
	},

	_setPath: function (layer, path) {
		layer._path.setAttribute('d', path);
	},

	// SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
	_bringToFront: function (layer) {
		toFront(layer._path);
	},

	_bringToBack: function (layer) {
		toBack(layer._path);
	}
});

if (vml) {
	SVG.include(vmlMixin);
}

// @factory L.svg(options?: Renderer options)
// Creates a SVG renderer with the given options.
function svg$1(options) {
	return svg || vml ? new SVG(options) : null;
}

Map.include({
	// @namespace Map; @method getRenderer(layer: Path): Renderer
	// Returns the instance of `Renderer` that should be used to render the given
	// `Path`. It will ensure that the `renderer` options of the map and paths
	// are respected, and that the renderers do exist on the map.
	getRenderer: function (layer) {
		// @namespace Path; @option renderer: Renderer
		// Use this specific instance of `Renderer` for this path. Takes
		// precedence over the map's [default renderer](#map-renderer).
		var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;

		if (!renderer) {
			// @namespace Map; @option preferCanvas: Boolean = false
			// Whether `Path`s should be rendered on a `Canvas` renderer.
			// By default, all `Path`s are rendered in a `SVG` renderer.
			renderer = this._renderer = (this.options.preferCanvas && canvas$1()) || svg$1();
		}

		if (!this.hasLayer(renderer)) {
			this.addLayer(renderer);
		}
		return renderer;
	},

	_getPaneRenderer: function (name) {
		if (name === 'overlayPane' || name === undefined) {
			return false;
		}

		var renderer = this._paneRenderers[name];
		if (renderer === undefined) {
			renderer = (SVG && svg$1({pane: name})) || (Canvas && canvas$1({pane: name}));
			this._paneRenderers[name] = renderer;
		}
		return renderer;
	}
});

/*
 * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
 */

/*
 * @class Rectangle
 * @aka L.Retangle
 * @inherits Polygon
 *
 * A class for drawing rectangle overlays on a map. Extends `Polygon`.
 *
 * @example
 *
 * ```js
 * // define rectangle geographical bounds
 * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
 *
 * // create an orange rectangle
 * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
 *
 * // zoom the map to the rectangle bounds
 * map.fitBounds(bounds);
 * ```
 *
 */


var Rectangle = Polygon.extend({
	initialize: function (latLngBounds, options) {
		Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
	},

	// @method setBounds(latLngBounds: LatLngBounds): this
	// Redraws the rectangle with the passed bounds.
	setBounds: function (latLngBounds) {
		return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
	},

	_boundsToLatLngs: function (latLngBounds) {
		latLngBounds = toLatLngBounds(latLngBounds);
		return [
			latLngBounds.getSouthWest(),
			latLngBounds.getNorthWest(),
			latLngBounds.getNorthEast(),
			latLngBounds.getSouthEast()
		];
	}
});


// @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
function rectangle(latLngBounds, options) {
	return new Rectangle(latLngBounds, options);
}

SVG.create = create$2;
SVG.pointsToPath = pointsToPath;

GeoJSON.geometryToLayer = geometryToLayer;
GeoJSON.coordsToLatLng = coordsToLatLng;
GeoJSON.coordsToLatLngs = coordsToLatLngs;
GeoJSON.latLngToCoords = latLngToCoords;
GeoJSON.latLngsToCoords = latLngsToCoords;
GeoJSON.getFeature = getFeature;
GeoJSON.asFeature = asFeature;

/*
 * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
 * (zoom to a selected bounding box), enabled by default.
 */

// @namespace Map
// @section Interaction Options
Map.mergeOptions({
	// @option boxZoom: Boolean = true
	// Whether the map can be zoomed to a rectangular area specified by
	// dragging the mouse while pressing the shift key.
	boxZoom: true
});

var BoxZoom = Handler.extend({
	initialize: function (map) {
		this._map = map;
		this._container = map._container;
		this._pane = map._panes.overlayPane;
		this._resetStateTimeout = 0;
		map.on('unload', this._destroy, this);
	},

	addHooks: function () {
		on(this._container, 'mousedown', this._onMouseDown, this);
	},

	removeHooks: function () {
		off(this._container, 'mousedown', this._onMouseDown, this);
	},

	moved: function () {
		return this._moved;
	},

	_destroy: function () {
		remove(this._pane);
		delete this._pane;
	},

	_resetState: function () {
		this._resetStateTimeout = 0;
		this._moved = false;
	},

	_clearDeferredResetState: function () {
		if (this._resetStateTimeout !== 0) {
			clearTimeout(this._resetStateTimeout);
			this._resetStateTimeout = 0;
		}
	},

	_onMouseDown: function (e) {
		if (!e.shiftKey || ((e.which !== 1) && (e.button !== 1))) { return false; }

		// Clear the deferred resetState if it hasn't executed yet, otherwise it
		// will interrupt the interaction and orphan a box element in the container.
		this._clearDeferredResetState();
		this._resetState();

		disableTextSelection();
		disableImageDrag();

		this._startPoint = this._map.mouseEventToContainerPoint(e);

		on(document, {
			contextmenu: stop,
			mousemove: this._onMouseMove,
			mouseup: this._onMouseUp,
			keydown: this._onKeyDown
		}, this);
	},

	_onMouseMove: function (e) {
		if (!this._moved) {
			this._moved = true;

			this._box = create$1('div', 'leaflet-zoom-box', this._container);
			addClass(this._container, 'leaflet-crosshair');

			this._map.fire('boxzoomstart');
		}

		this._point = this._map.mouseEventToContainerPoint(e);

		var bounds = new Bounds(this._point, this._startPoint),
		    size = bounds.getSize();

		setPosition(this._box, bounds.min);

		this._box.style.width  = size.x + 'px';
		this._box.style.height = size.y + 'px';
	},

	_finish: function () {
		if (this._moved) {
			remove(this._box);
			removeClass(this._container, 'leaflet-crosshair');
		}

		enableTextSelection();
		enableImageDrag();

		off(document, {
			contextmenu: stop,
			mousemove: this._onMouseMove,
			mouseup: this._onMouseUp,
			keydown: this._onKeyDown
		}, this);
	},

	_onMouseUp: function (e) {
		if ((e.which !== 1) && (e.button !== 1)) { return; }

		this._finish();

		if (!this._moved) { return; }
		// Postpone to next JS tick so internal click event handling
		// still see it as "moved".
		this._clearDeferredResetState();
		this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);

		var bounds = new LatLngBounds(
		        this._map.containerPointToLatLng(this._startPoint),
		        this._map.containerPointToLatLng(this._point));

		this._map
			.fitBounds(bounds)
			.fire('boxzoomend', {boxZoomBounds: bounds});
	},

	_onKeyDown: function (e) {
		if (e.keyCode === 27) {
			this._finish();
		}
	}
});

// @section Handlers
// @property boxZoom: Handler
// Box (shift-drag with mouse) zoom handler.
Map.addInitHook('addHandler', 'boxZoom', BoxZoom);

/*
 * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
 */

// @namespace Map
// @section Interaction Options

Map.mergeOptions({
	// @option doubleClickZoom: Boolean|String = true
	// Whether the map can be zoomed in by double clicking on it and
	// zoomed out by double clicking while holding shift. If passed
	// `'center'`, double-click zoom will zoom to the center of the
	//  view regardless of where the mouse was.
	doubleClickZoom: true
});

var DoubleClickZoom = Handler.extend({
	addHooks: function () {
		this._map.on('dblclick', this._onDoubleClick, this);
	},

	removeHooks: function () {
		this._map.off('dblclick', this._onDoubleClick, this);
	},

	_onDoubleClick: function (e) {
		var map = this._map,
		    oldZoom = map.getZoom(),
		    delta = map.options.zoomDelta,
		    zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;

		if (map.options.doubleClickZoom === 'center') {
			map.setZoom(zoom);
		} else {
			map.setZoomAround(e.containerPoint, zoom);
		}
	}
});

// @section Handlers
//
// Map properties include interaction handlers that allow you to control
// interaction behavior in runtime, enabling or disabling certain features such
// as dragging or touch zoom (see `Handler` methods). For example:
//
// ```js
// map.doubleClickZoom.disable();
// ```
//
// @property doubleClickZoom: Handler
// Double click zoom handler.
Map.addInitHook('addHandler', 'doubleClickZoom', DoubleClickZoom);

/*
 * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
 */

// @namespace Map
// @section Interaction Options
Map.mergeOptions({
	// @option dragging: Boolean = true
	// Whether the map be draggable with mouse/touch or not.
	dragging: true,

	// @section Panning Inertia Options
	// @option inertia: Boolean = *
	// If enabled, panning of the map will have an inertia effect where
	// the map builds momentum while dragging and continues moving in
	// the same direction for some time. Feels especially nice on touch
	// devices. Enabled by default unless running on old Android devices.
	inertia: !android23,

	// @option inertiaDeceleration: Number = 3000
	// The rate with which the inertial movement slows down, in pixels/second².
	inertiaDeceleration: 3400, // px/s^2

	// @option inertiaMaxSpeed: Number = Infinity
	// Max speed of the inertial movement, in pixels/second.
	inertiaMaxSpeed: Infinity, // px/s

	// @option easeLinearity: Number = 0.2
	easeLinearity: 0.2,

	// TODO refactor, move to CRS
	// @option worldCopyJump: Boolean = false
	// With this option enabled, the map tracks when you pan to another "copy"
	// of the world and seamlessly jumps to the original one so that all overlays
	// like markers and vector layers are still visible.
	worldCopyJump: false,

	// @option maxBoundsViscosity: Number = 0.0
	// If `maxBounds` is set, this option will control how solid the bounds
	// are when dragging the map around. The default value of `0.0` allows the
	// user to drag outside the bounds at normal speed, higher values will
	// slow down map dragging outside bounds, and `1.0` makes the bounds fully
	// solid, preventing the user from dragging outside the bounds.
	maxBoundsViscosity: 0.0
});

var Drag = Handler.extend({
	addHooks: function () {
		if (!this._draggable) {
			var map = this._map;

			this._draggable = new Draggable(map._mapPane, map._container);

			this._draggable.on({
				dragstart: this._onDragStart,
				drag: this._onDrag,
				dragend: this._onDragEnd
			}, this);

			this._draggable.on('predrag', this._onPreDragLimit, this);
			if (map.options.worldCopyJump) {
				this._draggable.on('predrag', this._onPreDragWrap, this);
				map.on('zoomend', this._onZoomEnd, this);

				map.whenReady(this._onZoomEnd, this);
			}
		}
		addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
		this._draggable.enable();
		this._positions = [];
		this._times = [];
	},

	removeHooks: function () {
		removeClass(this._map._container, 'leaflet-grab');
		removeClass(this._map._container, 'leaflet-touch-drag');
		this._draggable.disable();
	},

	moved: function () {
		return this._draggable && this._draggable._moved;
	},

	moving: function () {
		return this._draggable && this._draggable._moving;
	},

	_onDragStart: function () {
		var map = this._map;

		map._stop();
		if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
			var bounds = toLatLngBounds(this._map.options.maxBounds);

			this._offsetLimit = toBounds(
				this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1),
				this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1)
					.add(this._map.getSize()));

			this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
		} else {
			this._offsetLimit = null;
		}

		map
		    .fire('movestart')
		    .fire('dragstart');

		if (map.options.inertia) {
			this._positions = [];
			this._times = [];
		}
	},

	_onDrag: function (e) {
		if (this._map.options.inertia) {
			var time = this._lastTime = +new Date(),
			    pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;

			this._positions.push(pos);
			this._times.push(time);

			if (time - this._times[0] > 50) {
				this._positions.shift();
				this._times.shift();
			}
		}

		this._map
		    .fire('move', e)
		    .fire('drag', e);
	},

	_onZoomEnd: function () {
		var pxCenter = this._map.getSize().divideBy(2),
		    pxWorldCenter = this._map.latLngToLayerPoint([0, 0]);

		this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
		this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
	},

	_viscousLimit: function (value, threshold) {
		return value - (value - threshold) * this._viscosity;
	},

	_onPreDragLimit: function () {
		if (!this._viscosity || !this._offsetLimit) { return; }

		var offset = this._draggable._newPos.subtract(this._draggable._startPos);

		var limit = this._offsetLimit;
		if (offset.x < limit.min.x) { offset.x = this._viscousLimit(offset.x, limit.min.x); }
		if (offset.y < limit.min.y) { offset.y = this._viscousLimit(offset.y, limit.min.y); }
		if (offset.x > limit.max.x) { offset.x = this._viscousLimit(offset.x, limit.max.x); }
		if (offset.y > limit.max.y) { offset.y = this._viscousLimit(offset.y, limit.max.y); }

		this._draggable._newPos = this._draggable._startPos.add(offset);
	},

	_onPreDragWrap: function () {
		// TODO refactor to be able to adjust map pane position after zoom
		var worldWidth = this._worldWidth,
		    halfWidth = Math.round(worldWidth / 2),
		    dx = this._initialWorldOffset,
		    x = this._draggable._newPos.x,
		    newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx,
		    newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx,
		    newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;

		this._draggable._absPos = this._draggable._newPos.clone();
		this._draggable._newPos.x = newX;
	},

	_onDragEnd: function (e) {
		var map = this._map,
		    options = map.options,

		    noInertia = !options.inertia || this._times.length < 2;

		map.fire('dragend', e);

		if (noInertia) {
			map.fire('moveend');

		} else {

			var direction = this._lastPos.subtract(this._positions[0]),
			    duration = (this._lastTime - this._times[0]) / 1000,
			    ease = options.easeLinearity,

			    speedVector = direction.multiplyBy(ease / duration),
			    speed = speedVector.distanceTo([0, 0]),

			    limitedSpeed = Math.min(options.inertiaMaxSpeed, speed),
			    limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed),

			    decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease),
			    offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();

			if (!offset.x && !offset.y) {
				map.fire('moveend');

			} else {
				offset = map._limitOffset(offset, map.options.maxBounds);

				requestAnimFrame(function () {
					map.panBy(offset, {
						duration: decelerationDuration,
						easeLinearity: ease,
						noMoveStart: true,
						animate: true
					});
				});
			}
		}
	}
});

// @section Handlers
// @property dragging: Handler
// Map dragging handler (by both mouse and touch).
Map.addInitHook('addHandler', 'dragging', Drag);

/*
 * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
 */

// @namespace Map
// @section Keyboard Navigation Options
Map.mergeOptions({
	// @option keyboard: Boolean = true
	// Makes the map focusable and allows users to navigate the map with keyboard
	// arrows and `+`/`-` keys.
	keyboard: true,

	// @option keyboardPanDelta: Number = 80
	// Amount of pixels to pan when pressing an arrow key.
	keyboardPanDelta: 80
});

var Keyboard = Handler.extend({

	keyCodes: {
		left:    [37],
		right:   [39],
		down:    [40],
		up:      [38],
		zoomIn:  [187, 107, 61, 171],
		zoomOut: [189, 109, 54, 173]
	},

	initialize: function (map) {
		this._map = map;

		this._setPanDelta(map.options.keyboardPanDelta);
		this._setZoomDelta(map.options.zoomDelta);
	},

	addHooks: function () {
		var container = this._map._container;

		// make the container focusable by tabbing
		if (container.tabIndex <= 0) {
			container.tabIndex = '0';
		}

		on(container, {
			focus: this._onFocus,
			blur: this._onBlur,
			mousedown: this._onMouseDown
		}, this);

		this._map.on({
			focus: this._addHooks,
			blur: this._removeHooks
		}, this);
	},

	removeHooks: function () {
		this._removeHooks();

		off(this._map._container, {
			focus: this._onFocus,
			blur: this._onBlur,
			mousedown: this._onMouseDown
		}, this);

		this._map.off({
			focus: this._addHooks,
			blur: this._removeHooks
		}, this);
	},

	_onMouseDown: function () {
		if (this._focused) { return; }

		var body = document.body,
		    docEl = document.documentElement,
		    top = body.scrollTop || docEl.scrollTop,
		    left = body.scrollLeft || docEl.scrollLeft;

		this._map._container.focus();

		window.scrollTo(left, top);
	},

	_onFocus: function () {
		this._focused = true;
		this._map.fire('focus');
	},

	_onBlur: function () {
		this._focused = false;
		this._map.fire('blur');
	},

	_setPanDelta: function (panDelta) {
		var keys = this._panKeys = {},
		    codes = this.keyCodes,
		    i, len;

		for (i = 0, len = codes.left.length; i < len; i++) {
			keys[codes.left[i]] = [-1 * panDelta, 0];
		}
		for (i = 0, len = codes.right.length; i < len; i++) {
			keys[codes.right[i]] = [panDelta, 0];
		}
		for (i = 0, len = codes.down.length; i < len; i++) {
			keys[codes.down[i]] = [0, panDelta];
		}
		for (i = 0, len = codes.up.length; i < len; i++) {
			keys[codes.up[i]] = [0, -1 * panDelta];
		}
	},

	_setZoomDelta: function (zoomDelta) {
		var keys = this._zoomKeys = {},
		    codes = this.keyCodes,
		    i, len;

		for (i = 0, len = codes.zoomIn.length; i < len; i++) {
			keys[codes.zoomIn[i]] = zoomDelta;
		}
		for (i = 0, len = codes.zoomOut.length; i < len; i++) {
			keys[codes.zoomOut[i]] = -zoomDelta;
		}
	},

	_addHooks: function () {
		on(document, 'keydown', this._onKeyDown, this);
	},

	_removeHooks: function () {
		off(document, 'keydown', this._onKeyDown, this);
	},

	_onKeyDown: function (e) {
		if (e.altKey || e.ctrlKey || e.metaKey) { return; }

		var key = e.keyCode,
		    map = this._map,
		    offset;

		if (key in this._panKeys) {

			if (map._panAnim && map._panAnim._inProgress) { return; }

			offset = this._panKeys[key];
			if (e.shiftKey) {
				offset = toPoint(offset).multiplyBy(3);
			}

			map.panBy(offset);

			if (map.options.maxBounds) {
				map.panInsideBounds(map.options.maxBounds);
			}

		} else if (key in this._zoomKeys) {
			map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);

		} else if (key === 27 && map._popup) {
			map.closePopup();

		} else {
			return;
		}

		stop(e);
	}
});

// @section Handlers
// @section Handlers
// @property keyboard: Handler
// Keyboard navigation handler.
Map.addInitHook('addHandler', 'keyboard', Keyboard);

/*
 * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
 */

// @namespace Map
// @section Interaction Options
Map.mergeOptions({
	// @section Mousewheel options
	// @option scrollWheelZoom: Boolean|String = true
	// Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
	// it will zoom to the center of the view regardless of where the mouse was.
	scrollWheelZoom: true,

	// @option wheelDebounceTime: Number = 40
	// Limits the rate at which a wheel can fire (in milliseconds). By default
	// user can't zoom via wheel more often than once per 40 ms.
	wheelDebounceTime: 40,

	// @option wheelPxPerZoomLevel: Number = 60
	// How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
	// mean a change of one full zoom level. Smaller values will make wheel-zooming
	// faster (and vice versa).
	wheelPxPerZoomLevel: 60
});

var ScrollWheelZoom = Handler.extend({
	addHooks: function () {
		on(this._map._container, 'mousewheel', this._onWheelScroll, this);

		this._delta = 0;
	},

	removeHooks: function () {
		off(this._map._container, 'mousewheel', this._onWheelScroll, this);
	},

	_onWheelScroll: function (e) {
		var delta = getWheelDelta(e);

		var debounce = this._map.options.wheelDebounceTime;

		this._delta += delta;
		this._lastMousePos = this._map.mouseEventToContainerPoint(e);

		if (!this._startTime) {
			this._startTime = +new Date();
		}

		var left = Math.max(debounce - (+new Date() - this._startTime), 0);

		clearTimeout(this._timer);
		this._timer = setTimeout(bind(this._performZoom, this), left);

		stop(e);
	},

	_performZoom: function () {
		var map = this._map,
		    zoom = map.getZoom(),
		    snap = this._map.options.zoomSnap || 0;

		map._stop(); // stop panning and fly animations if any

		// map the delta with a sigmoid function to -4..4 range leaning on -1..1
		var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4),
		    d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2,
		    d4 = snap ? Math.ceil(d3 / snap) * snap : d3,
		    delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;

		this._delta = 0;
		this._startTime = null;

		if (!delta) { return; }

		if (map.options.scrollWheelZoom === 'center') {
			map.setZoom(zoom + delta);
		} else {
			map.setZoomAround(this._lastMousePos, zoom + delta);
		}
	}
});

// @section Handlers
// @property scrollWheelZoom: Handler
// Scroll wheel zoom handler.
Map.addInitHook('addHandler', 'scrollWheelZoom', ScrollWheelZoom);

/*
 * L.Map.Tap is used to enable mobile hacks like quick taps and long hold.
 */

// @namespace Map
// @section Interaction Options
Map.mergeOptions({
	// @section Touch interaction options
	// @option tap: Boolean = true
	// Enables mobile hacks for supporting instant taps (fixing 200ms click
	// delay on iOS/Android) and touch holds (fired as `contextmenu` events).
	tap: true,

	// @option tapTolerance: Number = 15
	// The max number of pixels a user can shift his finger during touch
	// for it to be considered a valid tap.
	tapTolerance: 15
});

var Tap = Handler.extend({
	addHooks: function () {
		on(this._map._container, 'touchstart', this._onDown, this);
	},

	removeHooks: function () {
		off(this._map._container, 'touchstart', this._onDown, this);
	},

	_onDown: function (e) {
		if (!e.touches) { return; }

		preventDefault(e);

		this._fireClick = true;

		// don't simulate click or track longpress if more than 1 touch
		if (e.touches.length > 1) {
			this._fireClick = false;
			clearTimeout(this._holdTimeout);
			return;
		}

		var first = e.touches[0],
		    el = first.target;

		this._startPos = this._newPos = new Point(first.clientX, first.clientY);

		// if touching a link, highlight it
		if (el.tagName && el.tagName.toLowerCase() === 'a') {
			addClass(el, 'leaflet-active');
		}

		// simulate long hold but setting a timeout
		this._holdTimeout = setTimeout(bind(function () {
			if (this._isTapValid()) {
				this._fireClick = false;
				this._onUp();
				this._simulateEvent('contextmenu', first);
			}
		}, this), 1000);

		this._simulateEvent('mousedown', first);

		on(document, {
			touchmove: this._onMove,
			touchend: this._onUp
		}, this);
	},

	_onUp: function (e) {
		clearTimeout(this._holdTimeout);

		off(document, {
			touchmove: this._onMove,
			touchend: this._onUp
		}, this);

		if (this._fireClick && e && e.changedTouches) {

			var first = e.changedTouches[0],
			    el = first.target;

			if (el && el.tagName && el.tagName.toLowerCase() === 'a') {
				removeClass(el, 'leaflet-active');
			}

			this._simulateEvent('mouseup', first);

			// simulate click if the touch didn't move too much
			if (this._isTapValid()) {
				this._simulateEvent('click', first);
			}
		}
	},

	_isTapValid: function () {
		return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
	},

	_onMove: function (e) {
		var first = e.touches[0];
		this._newPos = new Point(first.clientX, first.clientY);
		this._simulateEvent('mousemove', first);
	},

	_simulateEvent: function (type, e) {
		var simulatedEvent = document.createEvent('MouseEvents');

		simulatedEvent._simulated = true;
		e.target._simulatedClick = true;

		simulatedEvent.initMouseEvent(
		        type, true, true, window, 1,
		        e.screenX, e.screenY,
		        e.clientX, e.clientY,
		        false, false, false, false, 0, null);

		e.target.dispatchEvent(simulatedEvent);
	}
});

// @section Handlers
// @property tap: Handler
// Mobile touch hacks (quick tap and touch hold) handler.
if (touch && !pointer) {
	Map.addInitHook('addHandler', 'tap', Tap);
}

/*
 * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
 */

// @namespace Map
// @section Interaction Options
Map.mergeOptions({
	// @section Touch interaction options
	// @option touchZoom: Boolean|String = *
	// Whether the map can be zoomed by touch-dragging with two fingers. If
	// passed `'center'`, it will zoom to the center of the view regardless of
	// where the touch events (fingers) were. Enabled for touch-capable web
	// browsers except for old Androids.
	touchZoom: touch && !android23,

	// @option bounceAtZoomLimits: Boolean = true
	// Set it to false if you don't want the map to zoom beyond min/max zoom
	// and then bounce back when pinch-zooming.
	bounceAtZoomLimits: true
});

var TouchZoom = Handler.extend({
	addHooks: function () {
		addClass(this._map._container, 'leaflet-touch-zoom');
		on(this._map._container, 'touchstart', this._onTouchStart, this);
	},

	removeHooks: function () {
		removeClass(this._map._container, 'leaflet-touch-zoom');
		off(this._map._container, 'touchstart', this._onTouchStart, this);
	},

	_onTouchStart: function (e) {
		var map = this._map;
		if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) { return; }

		var p1 = map.mouseEventToContainerPoint(e.touches[0]),
		    p2 = map.mouseEventToContainerPoint(e.touches[1]);

		this._centerPoint = map.getSize()._divideBy(2);
		this._startLatLng = map.containerPointToLatLng(this._centerPoint);
		if (map.options.touchZoom !== 'center') {
			this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
		}

		this._startDist = p1.distanceTo(p2);
		this._startZoom = map.getZoom();

		this._moved = false;
		this._zooming = true;

		map._stop();

		on(document, 'touchmove', this._onTouchMove, this);
		on(document, 'touchend', this._onTouchEnd, this);

		preventDefault(e);
	},

	_onTouchMove: function (e) {
		if (!e.touches || e.touches.length !== 2 || !this._zooming) { return; }

		var map = this._map,
		    p1 = map.mouseEventToContainerPoint(e.touches[0]),
		    p2 = map.mouseEventToContainerPoint(e.touches[1]),
		    scale = p1.distanceTo(p2) / this._startDist;

		this._zoom = map.getScaleZoom(scale, this._startZoom);

		if (!map.options.bounceAtZoomLimits && (
			(this._zoom < map.getMinZoom() && scale < 1) ||
			(this._zoom > map.getMaxZoom() && scale > 1))) {
			this._zoom = map._limitZoom(this._zoom);
		}

		if (map.options.touchZoom === 'center') {
			this._center = this._startLatLng;
			if (scale === 1) { return; }
		} else {
			// Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
			var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
			if (scale === 1 && delta.x === 0 && delta.y === 0) { return; }
			this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
		}

		if (!this._moved) {
			map._moveStart(true);
			this._moved = true;
		}

		cancelAnimFrame(this._animRequest);

		var moveFn = bind(map._move, map, this._center, this._zoom, {pinch: true, round: false});
		this._animRequest = requestAnimFrame(moveFn, this, true);

		preventDefault(e);
	},

	_onTouchEnd: function () {
		if (!this._moved || !this._zooming) {
			this._zooming = false;
			return;
		}

		this._zooming = false;
		cancelAnimFrame(this._animRequest);

		off(document, 'touchmove', this._onTouchMove);
		off(document, 'touchend', this._onTouchEnd);

		// Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
		if (this._map.options.zoomAnimation) {
			this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
		} else {
			this._map._resetView(this._center, this._map._limitZoom(this._zoom));
		}
	}
});

// @section Handlers
// @property touchZoom: Handler
// Touch zoom handler.
Map.addInitHook('addHandler', 'touchZoom', TouchZoom);

Map.BoxZoom = BoxZoom;
Map.DoubleClickZoom = DoubleClickZoom;
Map.Drag = Drag;
Map.Keyboard = Keyboard;
Map.ScrollWheelZoom = ScrollWheelZoom;
Map.Tap = Tap;
Map.TouchZoom = TouchZoom;

// misc

var oldL = window.L;
function noConflict() {
	window.L = oldL;
	return this;
}

// Always export us to window global (see #2364)
window.L = exports;

Object.freeze = freeze;

exports.version = version;
exports.noConflict = noConflict;
exports.Control = Control;
exports.control = control;
exports.Browser = Browser;
exports.Evented = Evented;
exports.Mixin = Mixin;
exports.Util = Util;
exports.Class = Class;
exports.Handler = Handler;
exports.extend = extend;
exports.bind = bind;
exports.stamp = stamp;
exports.setOptions = setOptions;
exports.DomEvent = DomEvent;
exports.DomUtil = DomUtil;
exports.PosAnimation = PosAnimation;
exports.Draggable = Draggable;
exports.LineUtil = LineUtil;
exports.PolyUtil = PolyUtil;
exports.Point = Point;
exports.point = toPoint;
exports.Bounds = Bounds;
exports.bounds = toBounds;
exports.Transformation = Transformation;
exports.transformation = toTransformation;
exports.Projection = index;
exports.LatLng = LatLng;
exports.latLng = toLatLng;
exports.LatLngBounds = LatLngBounds;
exports.latLngBounds = toLatLngBounds;
exports.CRS = CRS;
exports.GeoJSON = GeoJSON;
exports.geoJSON = geoJSON;
exports.geoJson = geoJson;
exports.Layer = Layer;
exports.LayerGroup = LayerGroup;
exports.layerGroup = layerGroup;
exports.FeatureGroup = FeatureGroup;
exports.featureGroup = featureGroup;
exports.ImageOverlay = ImageOverlay;
exports.imageOverlay = imageOverlay;
exports.VideoOverlay = VideoOverlay;
exports.videoOverlay = videoOverlay;
exports.DivOverlay = DivOverlay;
exports.Popup = Popup;
exports.popup = popup;
exports.Tooltip = Tooltip;
exports.tooltip = tooltip;
exports.Icon = Icon;
exports.icon = icon;
exports.DivIcon = DivIcon;
exports.divIcon = divIcon;
exports.Marker = Marker;
exports.marker = marker;
exports.TileLayer = TileLayer;
exports.tileLayer = tileLayer;
exports.GridLayer = GridLayer;
exports.gridLayer = gridLayer;
exports.SVG = SVG;
exports.svg = svg$1;
exports.Renderer = Renderer;
exports.Canvas = Canvas;
exports.canvas = canvas$1;
exports.Path = Path;
exports.CircleMarker = CircleMarker;
exports.circleMarker = circleMarker;
exports.Circle = Circle;
exports.circle = circle;
exports.Polyline = Polyline;
exports.polyline = polyline;
exports.Polygon = Polygon;
exports.polygon = polygon;
exports.Rectangle = Rectangle;
exports.rectangle = rectangle;
exports.Map = Map;
exports.map = createMap;

})));
//# sourceMappingURL=leaflet-src.js.map


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30), __webpack_require__(64)))

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(160);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, x) {
  var lo = 0, hi = a.length;
  while (lo < hi) {
    var mid = lo + hi >>> 1;
    if (a[mid] < x) lo = mid + 1;
    else hi = mid;
  }
  return lo;
});


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mergeArcs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__feature__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stitch__ = __webpack_require__(67);



function planarRingArea(ring) {
  var i = -1, n = ring.length, a, b = ring[n - 1], area = 0;
  while (++i < n) a = b, b = ring[i], area += a[0] * b[1] - a[1] * b[0];
  return Math.abs(area); // Note: doubled area!
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(topology) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__feature__["b" /* object */])(topology, mergeArcs.apply(this, arguments));
});

function mergeArcs(topology, objects) {
  var polygonsByArc = {},
      polygons = [],
      groups = [];

  objects.forEach(geometry);

  function geometry(o) {
    switch (o.type) {
      case "GeometryCollection": o.geometries.forEach(geometry); break;
      case "Polygon": extract(o.arcs); break;
      case "MultiPolygon": o.arcs.forEach(extract); break;
    }
  }

  function extract(polygon) {
    polygon.forEach(function(ring) {
      ring.forEach(function(arc) {
        (polygonsByArc[arc = arc < 0 ? ~arc : arc] || (polygonsByArc[arc] = [])).push(polygon);
      });
    });
    polygons.push(polygon);
  }

  function area(ring) {
    return planarRingArea(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__feature__["b" /* object */])(topology, {type: "Polygon", arcs: [ring]}).coordinates[0]);
  }

  polygons.forEach(function(polygon) {
    if (!polygon._) {
      var group = [],
          neighbors = [polygon];
      polygon._ = 1;
      groups.push(group);
      while (polygon = neighbors.pop()) {
        group.push(polygon);
        polygon.forEach(function(ring) {
          ring.forEach(function(arc) {
            polygonsByArc[arc < 0 ? ~arc : arc].forEach(function(polygon) {
              if (!polygon._) {
                polygon._ = 1;
                neighbors.push(polygon);
              }
            });
          });
        });
      }
    }
  });

  polygons.forEach(function(polygon) {
    delete polygon._;
  });

  return {
    type: "MultiPolygon",
    arcs: groups.map(function(polygons) {
      var arcs = [], n;

      // Extract the exterior (unique) arcs.
      polygons.forEach(function(polygon) {
        polygon.forEach(function(ring) {
          ring.forEach(function(arc) {
            if (polygonsByArc[arc < 0 ? ~arc : arc].length < 2) {
              arcs.push(arc);
            }
          });
        });
      });

      // Stitch the arcs into one or more rings.
      arcs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__stitch__["a" /* default */])(topology, arcs);

      // If more than one ring is returned,
      // at most one of these rings can be the exterior;
      // choose the one with the greatest absolute area.
      if ((n = arcs.length) > 1) {
        for (var i = 1, k = area(arcs[0]), ki, t; i < n; ++i) {
          if ((ki = area(arcs[i])) > k) {
            t = arcs[0], arcs[0] = arcs[i], arcs[i] = t, k = ki;
          }
        }
      }

      return arcs;
    })
  };
}


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export meshArcs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__feature__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stitch__ = __webpack_require__(67);



/* unused harmony default export */ var _unused_webpack_default_export = (function(topology) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__feature__["b" /* object */])(topology, meshArcs.apply(this, arguments));
});

function meshArcs(topology, object, filter) {
  var arcs, i, n;
  if (arguments.length > 1) arcs = extractArcs(topology, object, filter);
  else for (i = 0, arcs = new Array(n = topology.arcs.length); i < n; ++i) arcs[i] = i;
  return {type: "MultiLineString", arcs: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__stitch__["a" /* default */])(topology, arcs)};
}

function extractArcs(topology, object, filter) {
  var arcs = [],
      geomsByArc = [],
      geom;

  function extract0(i) {
    var j = i < 0 ? ~i : i;
    (geomsByArc[j] || (geomsByArc[j] = [])).push({i: i, g: geom});
  }

  function extract1(arcs) {
    arcs.forEach(extract0);
  }

  function extract2(arcs) {
    arcs.forEach(extract1);
  }

  function extract3(arcs) {
    arcs.forEach(extract2);
  }

  function geometry(o) {
    switch (geom = o, o.type) {
      case "GeometryCollection": o.geometries.forEach(geometry); break;
      case "LineString": extract1(o.arcs); break;
      case "MultiLineString": case "Polygon": extract2(o.arcs); break;
      case "MultiPolygon": extract3(o.arcs); break;
    }
  }

  geometry(object);

  geomsByArc.forEach(filter == null
      ? function(geoms) { arcs.push(geoms[0].i); }
      : function(geoms) { if (filter(geoms[0].g, geoms[geoms.length - 1].g)) arcs.push(geoms[0].i); });

  return arcs;
}


/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bisect__ = __webpack_require__(162);


/* unused harmony default export */ var _unused_webpack_default_export = (function(objects) {
  var indexesByArc = {}, // arc index -> array of object indexes
      neighbors = objects.map(function() { return []; });

  function line(arcs, i) {
    arcs.forEach(function(a) {
      if (a < 0) a = ~a;
      var o = indexesByArc[a];
      if (o) o.push(i);
      else indexesByArc[a] = [i];
    });
  }

  function polygon(arcs, i) {
    arcs.forEach(function(arc) { line(arc, i); });
  }

  function geometry(o, i) {
    if (o.type === "GeometryCollection") o.geometries.forEach(function(o) { geometry(o, i); });
    else if (o.type in geometryType) geometryType[o.type](o.arcs, i);
  }

  var geometryType = {
    LineString: line,
    MultiLineString: polygon,
    Polygon: polygon,
    MultiPolygon: function(arcs, i) { arcs.forEach(function(arc) { polygon(arc, i); }); }
  };

  objects.forEach(geometry);

  for (var i in indexesByArc) {
    for (var indexes = indexesByArc[i], m = indexes.length, j = 0; j < m; ++j) {
      for (var k = j + 1; k < m; ++k) {
        var ij = indexes[j], ik = indexes[k], n;
        if ((n = neighbors[ij])[i = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__bisect__["a" /* default */])(n, ik)] !== ik) n.splice(i, 0, ik);
        if ((n = neighbors[ik])[i = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__bisect__["a" /* default */])(n, ij)] !== ij) n.splice(i, 0, ij);
      }
    }
  }

  return neighbors;
});


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bbox__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__untransform__ = __webpack_require__(68);



/* unused harmony default export */ var _unused_webpack_default_export = (function(topology, transform) {
  if (topology.transform) throw new Error("already quantized");

  if (!transform || !transform.scale) {
    if (!((n = Math.floor(transform)) >= 2)) throw new Error("n must be ≥2");
    box = topology.bbox || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__bbox__["a" /* default */])(topology);
    var x0 = box[0], y0 = box[1], x1 = box[2], y1 = box[3], n;
    transform = {scale: [x1 - x0 ? (x1 - x0) / (n - 1) : 1, y1 - y0 ? (y1 - y0) / (n - 1) : 1], translate: [x0, y0]};
  } else {
    box = topology.bbox;
  }

  var t = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__untransform__["a" /* default */])(transform), box, key, inputs = topology.objects, outputs = {};

  function quantizePoint(point) {
    return t(point);
  }

  function quantizeGeometry(input) {
    var output;
    switch (input.type) {
      case "GeometryCollection": output = {type: "GeometryCollection", geometries: input.geometries.map(quantizeGeometry)}; break;
      case "Point": output = {type: "Point", coordinates: quantizePoint(input.coordinates)}; break;
      case "MultiPoint": output = {type: "MultiPoint", coordinates: input.coordinates.map(quantizePoint)}; break;
      default: return input;
    }
    if (input.id != null) output.id = input.id;
    if (input.bbox != null) output.bbox = input.bbox;
    if (input.properties != null) output.properties = input.properties;
    return output;
  }

  function quantizeArc(input) {
    var i = 0, j = 1, n = input.length, p, output = new Array(n); // pessimistic
    output[0] = t(input[0], 0);
    while (++i < n) if ((p = t(input[i], i))[0] || p[1]) output[j++] = p; // non-coincident points
    if (j === 1) output[j++] = [0, 0]; // an arc must have at least two points
    output.length = j;
    return output;
  }

  for (key in inputs) outputs[key] = quantizeGeometry(inputs[key]);

  return {
    type: "Topology",
    bbox: box,
    transform: transform,
    objects: outputs,
    arcs: topology.arcs.map(quantizeArc)
  };
});


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(array, n) {
  var t, j = array.length, i = j - n;
  while (i < --j) t = array[i], array[i++] = array[j], array[j] = t;
});


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_topology__ = __webpack_require__(178);
/* unused harmony reexport topology */



/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Computes the bounding box of the specified hash of GeoJSON objects.
/* harmony default export */ __webpack_exports__["a"] = (function(objects) {
  var x0 = Infinity,
      y0 = Infinity,
      x1 = -Infinity,
      y1 = -Infinity;

  function boundGeometry(geometry) {
    if (geometry != null && boundGeometryType.hasOwnProperty(geometry.type)) boundGeometryType[geometry.type](geometry);
  }

  var boundGeometryType = {
    GeometryCollection: function(o) { o.geometries.forEach(boundGeometry); },
    Point: function(o) { boundPoint(o.coordinates); },
    MultiPoint: function(o) { o.coordinates.forEach(boundPoint); },
    LineString: function(o) { boundLine(o.arcs); },
    MultiLineString: function(o) { o.arcs.forEach(boundLine); },
    Polygon: function(o) { o.arcs.forEach(boundLine); },
    MultiPolygon: function(o) { o.arcs.forEach(boundMultiLine); }
  };

  function boundPoint(coordinates) {
    var x = coordinates[0],
        y = coordinates[1];
    if (x < x0) x0 = x;
    if (x > x1) x1 = x;
    if (y < y0) y0 = y;
    if (y > y1) y1 = y;
  }

  function boundLine(coordinates) {
    coordinates.forEach(boundPoint);
  }

  function boundMultiLine(coordinates) {
    coordinates.forEach(boundLine);
  }

  for (var key in objects) {
    boundGeometry(objects[key]);
  }

  return x1 >= x0 && y1 >= y0 ? [x0, y0, x1, y1] : undefined;
});


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__join__ = __webpack_require__(176);


// Given an extracted (pre-)topology, cuts (or rotates) arcs so that all shared
// point sequences are identified. The topology can then be subsequently deduped
// to remove exact duplicate arcs.
/* harmony default export */ __webpack_exports__["a"] = (function(topology) {
  var junctions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__join__["a" /* default */])(topology),
      coordinates = topology.coordinates,
      lines = topology.lines,
      rings = topology.rings,
      next,
      i, n;

  for (i = 0, n = lines.length; i < n; ++i) {
    var line = lines[i],
        lineMid = line[0],
        lineEnd = line[1];
    while (++lineMid < lineEnd) {
      if (junctions.has(coordinates[lineMid])) {
        next = {0: lineMid, 1: line[1]};
        line[1] = lineMid;
        line = line.next = next;
      }
    }
  }

  for (i = 0, n = rings.length; i < n; ++i) {
    var ring = rings[i],
        ringStart = ring[0],
        ringMid = ringStart,
        ringEnd = ring[1],
        ringFixed = junctions.has(coordinates[ringStart]);
    while (++ringMid < ringEnd) {
      if (junctions.has(coordinates[ringMid])) {
        if (ringFixed) {
          next = {0: ringMid, 1: ring[1]};
          ring[1] = ringMid;
          ring = ring.next = next;
        } else { // For the first junction, we can rotate rather than cut.
          rotateArray(coordinates, ringStart, ringEnd, ringEnd - ringMid);
          coordinates[ringEnd] = coordinates[ringStart];
          ringFixed = true;
          ringMid = ringStart; // restart; we may have skipped junctions
        }
      }
    }
  }

  return topology;
});

function rotateArray(array, start, end, offset) {
  reverse(array, start, end);
  reverse(array, start, start + offset);
  reverse(array, start + offset, end);
}

function reverse(array, start, end) {
  for (var mid = start + ((end-- - start) >> 1), t; start < mid; ++start, --end) {
    t = array[start], array[start] = array[end], array[end] = t;
  }
}


/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hash_hashmap__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hash_point_equal__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hash_point_hash__ = __webpack_require__(70);




// Given a cut topology, combines duplicate arcs.
/* harmony default export */ __webpack_exports__["a"] = (function(topology) {
  var coordinates = topology.coordinates,
      lines = topology.lines, line,
      rings = topology.rings, ring,
      arcCount = lines.length + rings.length,
      i, n;

  delete topology.lines;
  delete topology.rings;

  // Count the number of (non-unique) arcs to initialize the hashmap safely.
  for (i = 0, n = lines.length; i < n; ++i) {
    line = lines[i]; while (line = line.next) ++arcCount;
  }
  for (i = 0, n = rings.length; i < n; ++i) {
    ring = rings[i]; while (ring = ring.next) ++arcCount;
  }

  var arcsByEnd = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__hash_hashmap__["a" /* default */])(arcCount * 2 * 1.4, __WEBPACK_IMPORTED_MODULE_2__hash_point_hash__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__hash_point_equal__["a" /* default */]),
      arcs = topology.arcs = [];

  for (i = 0, n = lines.length; i < n; ++i) {
    line = lines[i];
    do {
      dedupLine(line);
    } while (line = line.next);
  }

  for (i = 0, n = rings.length; i < n; ++i) {
    ring = rings[i];
    if (ring.next) { // arc is no longer closed
      do {
        dedupLine(ring);
      } while (ring = ring.next);
    } else {
      dedupRing(ring);
    }
  }

  function dedupLine(arc) {
    var startPoint,
        endPoint,
        startArcs, startArc,
        endArcs, endArc,
        i, n;

    // Does this arc match an existing arc in order?
    if (startArcs = arcsByEnd.get(startPoint = coordinates[arc[0]])) {
      for (i = 0, n = startArcs.length; i < n; ++i) {
        startArc = startArcs[i];
        if (equalLine(startArc, arc)) {
          arc[0] = startArc[0];
          arc[1] = startArc[1];
          return;
        }
      }
    }

    // Does this arc match an existing arc in reverse order?
    if (endArcs = arcsByEnd.get(endPoint = coordinates[arc[1]])) {
      for (i = 0, n = endArcs.length; i < n; ++i) {
        endArc = endArcs[i];
        if (reverseEqualLine(endArc, arc)) {
          arc[1] = endArc[0];
          arc[0] = endArc[1];
          return;
        }
      }
    }

    if (startArcs) startArcs.push(arc); else arcsByEnd.set(startPoint, [arc]);
    if (endArcs) endArcs.push(arc); else arcsByEnd.set(endPoint, [arc]);
    arcs.push(arc);
  }

  function dedupRing(arc) {
    var endPoint,
        endArcs,
        endArc,
        i, n;

    // Does this arc match an existing line in order, or reverse order?
    // Rings are closed, so their start point and end point is the same.
    if (endArcs = arcsByEnd.get(endPoint = coordinates[arc[0]])) {
      for (i = 0, n = endArcs.length; i < n; ++i) {
        endArc = endArcs[i];
        if (equalRing(endArc, arc)) {
          arc[0] = endArc[0];
          arc[1] = endArc[1];
          return;
        }
        if (reverseEqualRing(endArc, arc)) {
          arc[0] = endArc[1];
          arc[1] = endArc[0];
          return;
        }
      }
    }

    // Otherwise, does this arc match an existing ring in order, or reverse order?
    if (endArcs = arcsByEnd.get(endPoint = coordinates[arc[0] + findMinimumOffset(arc)])) {
      for (i = 0, n = endArcs.length; i < n; ++i) {
        endArc = endArcs[i];
        if (equalRing(endArc, arc)) {
          arc[0] = endArc[0];
          arc[1] = endArc[1];
          return;
        }
        if (reverseEqualRing(endArc, arc)) {
          arc[0] = endArc[1];
          arc[1] = endArc[0];
          return;
        }
      }
    }

    if (endArcs) endArcs.push(arc); else arcsByEnd.set(endPoint, [arc]);
    arcs.push(arc);
  }

  function equalLine(arcA, arcB) {
    var ia = arcA[0], ib = arcB[0],
        ja = arcA[1], jb = arcB[1];
    if (ia - ja !== ib - jb) return false;
    for (; ia <= ja; ++ia, ++ib) if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__hash_point_equal__["a" /* default */])(coordinates[ia], coordinates[ib])) return false;
    return true;
  }

  function reverseEqualLine(arcA, arcB) {
    var ia = arcA[0], ib = arcB[0],
        ja = arcA[1], jb = arcB[1];
    if (ia - ja !== ib - jb) return false;
    for (; ia <= ja; ++ia, --jb) if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__hash_point_equal__["a" /* default */])(coordinates[ia], coordinates[jb])) return false;
    return true;
  }

  function equalRing(arcA, arcB) {
    var ia = arcA[0], ib = arcB[0],
        ja = arcA[1], jb = arcB[1],
        n = ja - ia;
    if (n !== jb - ib) return false;
    var ka = findMinimumOffset(arcA),
        kb = findMinimumOffset(arcB);
    for (var i = 0; i < n; ++i) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__hash_point_equal__["a" /* default */])(coordinates[ia + (i + ka) % n], coordinates[ib + (i + kb) % n])) return false;
    }
    return true;
  }

  function reverseEqualRing(arcA, arcB) {
    var ia = arcA[0], ib = arcB[0],
        ja = arcA[1], jb = arcB[1],
        n = ja - ia;
    if (n !== jb - ib) return false;
    var ka = findMinimumOffset(arcA),
        kb = n - findMinimumOffset(arcB);
    for (var i = 0; i < n; ++i) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__hash_point_equal__["a" /* default */])(coordinates[ia + (i + ka) % n], coordinates[jb - (i + kb) % n])) return false;
    }
    return true;
  }

  // Rings are rotated to a consistent, but arbitrary, start point.
  // This is necessary to detect when a ring and a rotated copy are dupes.
  function findMinimumOffset(arc) {
    var start = arc[0],
        end = arc[1],
        mid = start,
        minimum = mid,
        minimumPoint = coordinates[mid];
    while (++mid < end) {
      var point = coordinates[mid];
      if (point[0] < minimumPoint[0] || point[0] === minimumPoint[0] && point[1] < minimumPoint[1]) {
        minimum = mid;
        minimumPoint = point;
      }
    }
    return minimum - start;
  }

  return topology;
});


/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Given an array of arcs in absolute (but already quantized!) coordinates,
// converts to fixed-point delta encoding.
// This is a destructive operation that modifies the given arcs!
/* harmony default export */ __webpack_exports__["a"] = (function(arcs) {
  var i = -1,
      n = arcs.length;

  while (++i < n) {
    var arc = arcs[i],
        j = 0,
        k = 1,
        m = arc.length,
        point = arc[0],
        x0 = point[0],
        y0 = point[1],
        x1,
        y1;

    while (++j < m) {
      point = arc[j], x1 = point[0], y1 = point[1];
      if (x1 !== x0 || y1 !== y0) arc[k++] = [x1 - x0, y1 - y0], x0 = x1, y0 = y1;
    }

    if (k === 1) arc[k++] = [0, 0]; // Each arc must be an array of two or more positions.

    arc.length = k;
  }

  return arcs;
});


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Extracts the lines and rings from the specified hash of geometry objects.
//
// Returns an object with three properties:
//
// * coordinates - shared buffer of [x, y] coordinates
// * lines - lines extracted from the hash, of the form [start, end]
// * rings - rings extracted from the hash, of the form [start, end]
//
// For each ring or line, start and end represent inclusive indexes into the
// coordinates buffer. For rings (and closed lines), coordinates[start] equals
// coordinates[end].
//
// For each line or polygon geometry in the input hash, including nested
// geometries as in geometry collections, the `coordinates` array is replaced
// with an equivalent `arcs` array that, for each line (for line string
// geometries) or ring (for polygon geometries), points to one of the above
// lines or rings.
/* harmony default export */ __webpack_exports__["a"] = (function(objects) {
  var index = -1,
      lines = [],
      rings = [],
      coordinates = [];

  function extractGeometry(geometry) {
    if (geometry && extractGeometryType.hasOwnProperty(geometry.type)) extractGeometryType[geometry.type](geometry);
  }

  var extractGeometryType = {
    GeometryCollection: function(o) { o.geometries.forEach(extractGeometry); },
    LineString: function(o) { o.arcs = extractLine(o.arcs); },
    MultiLineString: function(o) { o.arcs = o.arcs.map(extractLine); },
    Polygon: function(o) { o.arcs = o.arcs.map(extractRing); },
    MultiPolygon: function(o) { o.arcs = o.arcs.map(extractMultiRing); }
  };

  function extractLine(line) {
    for (var i = 0, n = line.length; i < n; ++i) coordinates[++index] = line[i];
    var arc = {0: index - n + 1, 1: index};
    lines.push(arc);
    return arc;
  }

  function extractRing(ring) {
    for (var i = 0, n = ring.length; i < n; ++i) coordinates[++index] = ring[i];
    var arc = {0: index - n + 1, 1: index};
    rings.push(arc);
    return arc;
  }

  function extractMultiRing(rings) {
    return rings.map(extractRing);
  }

  for (var key in objects) {
    extractGeometry(objects[key]);
  }

  return {
    type: "Topology",
    coordinates: coordinates,
    lines: lines,
    rings: rings,
    objects: objects
  };
});


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Given a hash of GeoJSON objects, returns a hash of GeoJSON geometry objects.
// Any null input geometry objects are represented as {type: null} in the output.
// Any feature.{id,properties,bbox} are transferred to the output geometry object.
// Each output geometry object is a shallow copy of the input (e.g., properties, coordinates)!
/* harmony default export */ __webpack_exports__["a"] = (function(inputs) {
  var outputs = {}, key;
  for (key in inputs) outputs[key] = geomifyObject(inputs[key]);
  return outputs;
});

function geomifyObject(input) {
  return input == null ? {type: null}
      : (input.type === "FeatureCollection" ? geomifyFeatureCollection
      : input.type === "Feature" ? geomifyFeature
      : geomifyGeometry)(input);
}

function geomifyFeatureCollection(input) {
  var output = {type: "GeometryCollection", geometries: input.features.map(geomifyFeature)};
  if (input.bbox != null) output.bbox = input.bbox;
  return output;
}

function geomifyFeature(input) {
  var output = geomifyGeometry(input.geometry), key; // eslint-disable-line no-unused-vars
  if (input.id != null) output.id = input.id;
  if (input.bbox != null) output.bbox = input.bbox;
  for (key in input.properties) { output.properties = input.properties; break; }
  return output;
}

function geomifyGeometry(input) {
  if (input == null) return {type: null};
  var output = input.type === "GeometryCollection" ? {type: "GeometryCollection", geometries: input.geometries.map(geomifyGeometry)}
      : input.type === "Point" || input.type === "MultiPoint" ? {type: input.type, coordinates: input.coordinates}
      : {type: input.type, arcs: input.coordinates}; // TODO Check for unknown types?
  if (input.bbox != null) output.bbox = input.bbox;
  return output;
}


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(size, hash, equal, type, empty) {
  if (arguments.length === 3) {
    type = Array;
    empty = null;
  }

  var store = new type(size = 1 << Math.max(4, Math.ceil(Math.log(size) / Math.LN2))),
      mask = size - 1;

  for (var i = 0; i < size; ++i) {
    store[i] = empty;
  }

  function add(value) {
    var index = hash(value) & mask,
        match = store[index],
        collisions = 0;
    while (match != empty) {
      if (equal(match, value)) return true;
      if (++collisions >= size) throw new Error("full hashset");
      match = store[index = (index + 1) & mask];
    }
    store[index] = value;
    return true;
  }

  function has(value) {
    var index = hash(value) & mask,
        match = store[index],
        collisions = 0;
    while (match != empty) {
      if (equal(match, value)) return true;
      if (++collisions >= size) break;
      match = store[index = (index + 1) & mask];
    }
    return false;
  }

  function values() {
    var values = [];
    for (var i = 0, n = store.length; i < n; ++i) {
      var match = store[i];
      if (match != empty) values.push(match);
    }
    return values;
  }

  return {
    add: add,
    has: has,
    values: values
  };
});


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hash_hashset__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hash_hashmap__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hash_point_equal__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hash_point_hash__ = __webpack_require__(70);





// Given an extracted (pre-)topology, identifies all of the junctions. These are
// the points at which arcs (lines or rings) will need to be cut so that each
// arc is represented uniquely.
//
// A junction is a point where at least one arc deviates from another arc going
// through the same point. For example, consider the point B. If there is a arc
// through ABC and another arc through CBA, then B is not a junction because in
// both cases the adjacent point pairs are {A,C}. However, if there is an
// additional arc ABD, then {A,D} != {A,C}, and thus B becomes a junction.
//
// For a closed ring ABCA, the first point A’s adjacent points are the second
// and last point {B,C}. For a line, the first and last point are always
// considered junctions, even if the line is closed; this ensures that a closed
// line is never rotated.
/* harmony default export */ __webpack_exports__["a"] = (function(topology) {
  var coordinates = topology.coordinates,
      lines = topology.lines,
      rings = topology.rings,
      indexes = index(),
      visitedByIndex = new Int32Array(coordinates.length),
      leftByIndex = new Int32Array(coordinates.length),
      rightByIndex = new Int32Array(coordinates.length),
      junctionByIndex = new Int8Array(coordinates.length),
      junctionCount = 0, // upper bound on number of junctions
      i, n,
      previousIndex,
      currentIndex,
      nextIndex;

  for (i = 0, n = coordinates.length; i < n; ++i) {
    visitedByIndex[i] = leftByIndex[i] = rightByIndex[i] = -1;
  }

  for (i = 0, n = lines.length; i < n; ++i) {
    var line = lines[i],
        lineStart = line[0],
        lineEnd = line[1];
    currentIndex = indexes[lineStart];
    nextIndex = indexes[++lineStart];
    ++junctionCount, junctionByIndex[currentIndex] = 1; // start
    while (++lineStart <= lineEnd) {
      sequence(i, previousIndex = currentIndex, currentIndex = nextIndex, nextIndex = indexes[lineStart]);
    }
    ++junctionCount, junctionByIndex[nextIndex] = 1; // end
  }

  for (i = 0, n = coordinates.length; i < n; ++i) {
    visitedByIndex[i] = -1;
  }

  for (i = 0, n = rings.length; i < n; ++i) {
    var ring = rings[i],
        ringStart = ring[0] + 1,
        ringEnd = ring[1];
    previousIndex = indexes[ringEnd - 1];
    currentIndex = indexes[ringStart - 1];
    nextIndex = indexes[ringStart];
    sequence(i, previousIndex, currentIndex, nextIndex);
    while (++ringStart <= ringEnd) {
      sequence(i, previousIndex = currentIndex, currentIndex = nextIndex, nextIndex = indexes[ringStart]);
    }
  }

  function sequence(i, previousIndex, currentIndex, nextIndex) {
    if (visitedByIndex[currentIndex] === i) return; // ignore self-intersection
    visitedByIndex[currentIndex] = i;
    var leftIndex = leftByIndex[currentIndex];
    if (leftIndex >= 0) {
      var rightIndex = rightByIndex[currentIndex];
      if ((leftIndex !== previousIndex || rightIndex !== nextIndex)
        && (leftIndex !== nextIndex || rightIndex !== previousIndex)) {
        ++junctionCount, junctionByIndex[currentIndex] = 1;
      }
    } else {
      leftByIndex[currentIndex] = previousIndex;
      rightByIndex[currentIndex] = nextIndex;
    }
  }

  function index() {
    var indexByPoint = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__hash_hashmap__["a" /* default */])(coordinates.length * 1.4, hashIndex, equalIndex, Int32Array, -1, Int32Array),
        indexes = new Int32Array(coordinates.length);

    for (var i = 0, n = coordinates.length; i < n; ++i) {
      indexes[i] = indexByPoint.maybeSet(i, i);
    }

    return indexes;
  }

  function hashIndex(i) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__hash_point_hash__["a" /* default */])(coordinates[i]);
  }

  function equalIndex(i, j) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__hash_point_equal__["a" /* default */])(coordinates[i], coordinates[j]);
  }

  visitedByIndex = leftByIndex = rightByIndex = null;

  var junctionByPoint = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__hash_hashset__["a" /* default */])(junctionCount * 1.4, __WEBPACK_IMPORTED_MODULE_3__hash_point_hash__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__hash_point_equal__["a" /* default */]), j;

  // Convert back to a standard hashset by point for caller convenience.
  for (i = 0, n = coordinates.length; i < n; ++i) {
    if (junctionByIndex[j = indexes[i]]) {
      junctionByPoint.add(coordinates[j]);
    }
  }

  return junctionByPoint;
});


/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(objects, bbox, n) {
  var x0 = bbox[0],
      y0 = bbox[1],
      x1 = bbox[2],
      y1 = bbox[3],
      kx = x1 - x0 ? (n - 1) / (x1 - x0) : 1,
      ky = y1 - y0 ? (n - 1) / (y1 - y0) : 1;

  function quantizePoint(input) {
    return [Math.round((input[0] - x0) * kx), Math.round((input[1] - y0) * ky)];
  }

  function quantizePoints(input, m) {
    var i = -1,
        j = 0,
        n = input.length,
        output = new Array(n), // pessimistic
        pi,
        px,
        py,
        x,
        y;

    while (++i < n) {
      pi = input[i];
      x = Math.round((pi[0] - x0) * kx);
      y = Math.round((pi[1] - y0) * ky);
      if (x !== px || y !== py) output[j++] = [px = x, py = y]; // non-coincident points
    }

    output.length = j;
    while (j < m) j = output.push([output[0][0], output[0][1]]);
    return output;
  }

  function quantizeLine(input) {
    return quantizePoints(input, 2);
  }

  function quantizeRing(input) {
    return quantizePoints(input, 4);
  }

  function quantizePolygon(input) {
    return input.map(quantizeRing);
  }

  function quantizeGeometry(o) {
    if (o != null && quantizeGeometryType.hasOwnProperty(o.type)) quantizeGeometryType[o.type](o);
  }

  var quantizeGeometryType = {
    GeometryCollection: function(o) { o.geometries.forEach(quantizeGeometry); },
    Point: function(o) { o.coordinates = quantizePoint(o.coordinates); },
    MultiPoint: function(o) { o.coordinates = o.coordinates.map(quantizePoint); },
    LineString: function(o) { o.arcs = quantizeLine(o.arcs); },
    MultiLineString: function(o) { o.arcs = o.arcs.map(quantizeLine); },
    Polygon: function(o) { o.arcs = quantizePolygon(o.arcs); },
    MultiPolygon: function(o) { o.arcs = o.arcs.map(quantizePolygon); }
  };

  for (var key in objects) {
    quantizeGeometry(objects[key]);
  }

  return {
    scale: [1 / kx, 1 / ky],
    translate: [x0, y0]
  };
});


/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bounds__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cut__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dedup__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__delta__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__extract__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__geometry__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hash_hashmap__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prequantize__ = __webpack_require__(177);









// Constructs the TopoJSON Topology for the specified hash of features.
// Each object in the specified hash must be a GeoJSON object,
// meaning FeatureCollection, a Feature or a geometry object.
/* unused harmony default export */ var _unused_webpack_default_export = (function(objects, quantization) {
  var bbox = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__bounds__["a" /* default */])(objects = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__geometry__["a" /* default */])(objects)),
      transform = quantization > 0 && bbox && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__prequantize__["a" /* default */])(objects, bbox, quantization),
      topology = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dedup__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cut__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__extract__["a" /* default */])(objects))),
      coordinates = topology.coordinates,
      indexByArc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__hash_hashmap__["a" /* default */])(topology.arcs.length * 1.4, hashArc, equalArc);

  objects = topology.objects; // for garbage collection
  topology.bbox = bbox;
  topology.arcs = topology.arcs.map(function(arc, i) {
    indexByArc.set(arc, i);
    return coordinates.slice(arc[0], arc[1] + 1);
  });

  delete topology.coordinates;
  coordinates = null;

  function indexGeometry(geometry) {
    if (geometry && indexGeometryType.hasOwnProperty(geometry.type)) indexGeometryType[geometry.type](geometry);
  }

  var indexGeometryType = {
    GeometryCollection: function(o) { o.geometries.forEach(indexGeometry); },
    LineString: function(o) { o.arcs = indexArcs(o.arcs); },
    MultiLineString: function(o) { o.arcs = o.arcs.map(indexArcs); },
    Polygon: function(o) { o.arcs = o.arcs.map(indexArcs); },
    MultiPolygon: function(o) { o.arcs = o.arcs.map(indexMultiArcs); }
  };

  function indexArcs(arc) {
    var indexes = [];
    do {
      var index = indexByArc.get(arc);
      indexes.push(arc[0] < arc[1] ? index : ~index);
    } while (arc = arc.next);
    return indexes;
  }

  function indexMultiArcs(arcs) {
    return arcs.map(indexArcs);
  }

  for (var key in objects) {
    indexGeometry(objects[key]);
  }

  if (transform) {
    topology.transform = transform;
    topology.arcs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__delta__["a" /* default */])(topology.arcs);
  }

  return topology;
});

function hashArc(arc) {
  var i = arc[0], j = arc[1], t;
  if (j < i) t = i, i = j, j = t;
  return i + 31 * j;
}

function equalArc(arcA, arcB) {
  var ia = arcA[0], ja = arcA[1],
      ib = arcB[0], jb = arcB[1], t;
  if (ja < ia) t = ia, ia = ja, ja = t;
  if (jb < ib) t = ib, ib = jb, jb = t;
  return ia === ib && ja === jb;
}


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_filter__ = __webpack_require__(180);
/* unused harmony reexport filter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_filterAttached__ = __webpack_require__(71);
/* unused harmony reexport filterAttached */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_filterAttachedWeight__ = __webpack_require__(181);
/* unused harmony reexport filterAttachedWeight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_filterWeight__ = __webpack_require__(72);
/* unused harmony reexport filterWeight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_planar__ = __webpack_require__(29);
/* unused harmony reexport planarRingArea */
/* unused harmony reexport planarTriangleArea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_presimplify__ = __webpack_require__(183);
/* unused harmony reexport presimplify */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_quantile__ = __webpack_require__(185);
/* unused harmony reexport quantile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_simplify__ = __webpack_require__(186);
/* unused harmony reexport simplify */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_spherical__ = __webpack_require__(187);
/* unused harmony reexport sphericalRingArea */
/* unused harmony reexport sphericalTriangleArea */











/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__prune__ = __webpack_require__(184);


/* unused harmony default export */ var _unused_webpack_default_export = (function(topology, filter) {
  var oldObjects = topology.objects,
      newObjects = {},
      key;

  if (filter == null) filter = filterTrue;

  function filterGeometry(input) {
    var output, arcs;
    switch (input.type) {
      case "Polygon": {
        arcs = filterRings(input.arcs);
        output = arcs ? {type: "Polygon", arcs: arcs} : {type: null};
        break;
      }
      case "MultiPolygon": {
        arcs = input.arcs.map(filterRings).filter(filterIdentity);
        output = arcs.length ? {type: "MultiPolygon", arcs: arcs} : {type: null};
        break;
      }
      case "GeometryCollection": {
        arcs = input.geometries.map(filterGeometry).filter(filterNotNull);
        output = arcs.length ? {type: "GeometryCollection", geometries: arcs} : {type: null};
        break;
      }
      default: return input;
    }
    if (input.id != null) output.id = input.id;
    if (input.bbox != null) output.bbox = input.bbox;
    if (input.properties != null) output.properties = input.properties;
    return output;
  }

  function filterRings(arcs) {
    return arcs.length && filterExteriorRing(arcs[0]) // if the exterior is small, ignore any holes
        ? [arcs[0]].concat(arcs.slice(1).filter(filterInteriorRing))
        : null;
  }

  function filterExteriorRing(ring) {
    return filter(ring, false);
  }

  function filterInteriorRing(ring) {
    return filter(ring, true);
  }

  for (key in oldObjects) {
    newObjects[key] = filterGeometry(oldObjects[key]);
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__prune__["a" /* default */])({
    type: "Topology",
    bbox: topology.bbox,
    transform: topology.transform,
    objects: newObjects,
    arcs: topology.arcs
  });
});

function filterTrue() {
  return true;
}

function filterIdentity(x) {
  return x;
}

function filterNotNull(geometry) {
  return geometry.type != null;
}


/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filterAttached__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filterWeight__ = __webpack_require__(72);



/* unused harmony default export */ var _unused_webpack_default_export = (function(topology, minWeight, weight) {
  var a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__filterAttached__["a" /* default */])(topology),
      w = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__filterWeight__["a" /* default */])(topology, minWeight, weight);
  return function(ring, interior) {
    return a(ring, interior) || w(ring, interior);
  };
});


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function compare(a, b) {
  return a[1][2] - b[1][2];
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var heap = {},
      array = [],
      size = 0;

  heap.push = function(object) {
    up(array[object._ = size] = object, size++);
    return size;
  };

  heap.pop = function() {
    if (size <= 0) return;
    var removed = array[0], object;
    if (--size > 0) object = array[size], down(array[object._ = 0] = object, 0);
    return removed;
  };

  heap.remove = function(removed) {
    var i = removed._, object;
    if (array[i] !== removed) return; // invalid request
    if (i !== --size) object = array[size], (compare(object, removed) < 0 ? up : down)(array[object._ = i] = object, i);
    return i;
  };

  function up(object, i) {
    while (i > 0) {
      var j = ((i + 1) >> 1) - 1,
          parent = array[j];
      if (compare(object, parent) >= 0) break;
      array[parent._ = i] = parent;
      array[object._ = i = j] = object;
    }
  }

  function down(object, i) {
    while (true) {
      var r = (i + 1) << 1,
          l = r - 1,
          j = i,
          child = array[j];
      if (l < size && compare(array[l], child) < 0) child = array[j = l];
      if (r < size && compare(array[r], child) < 0) child = array[j = r];
      if (j === i) break;
      array[child._ = i] = child;
      array[object._ = i = j] = object;
    }
  }

  return heap;
});


/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_topojson_client__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__heap__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__planar__ = __webpack_require__(29);




function copy(point) {
  return [point[0], point[1], 0];
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(topology, weight) {
  var point = topology.transform ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_topojson_client__["b" /* transform */])(topology.transform) : copy,
      heap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__heap__["a" /* default */])();

  if (weight == null) weight = __WEBPACK_IMPORTED_MODULE_2__planar__["a" /* planarTriangleArea */];

  var arcs = topology.arcs.map(function(arc) {
    var triangles = [],
        maxWeight = 0,
        triangle,
        i,
        n;

    arc = arc.map(point);

    for (i = 1, n = arc.length - 1; i < n; ++i) {
      triangle = [arc[i - 1], arc[i], arc[i + 1]];
      triangle[1][2] = weight(triangle);
      triangles.push(triangle);
      heap.push(triangle);
    }

    // Always keep the arc endpoints!
    arc[0][2] = arc[n][2] = Infinity;

    for (i = 0, n = triangles.length; i < n; ++i) {
      triangle = triangles[i];
      triangle.previous = triangles[i - 1];
      triangle.next = triangles[i + 1];
    }

    while (triangle = heap.pop()) {
      var previous = triangle.previous,
          next = triangle.next;

      // If the weight of the current point is less than that of the previous
      // point to be eliminated, use the latter’s weight instead. This ensures
      // that the current point cannot be eliminated without eliminating
      // previously- eliminated points.
      if (triangle[1][2] < maxWeight) triangle[1][2] = maxWeight;
      else maxWeight = triangle[1][2];

      if (previous) {
        previous.next = next;
        previous[2] = triangle[2];
        update(previous);
      }

      if (next) {
        next.previous = previous;
        next[0] = triangle[0];
        update(next);
      }
    }

    return arc;
  });

  function update(triangle) {
    heap.remove(triangle);
    triangle[1][2] = weight(triangle);
    heap.push(triangle);
  }

  return {
    type: "Topology",
    bbox: topology.bbox,
    objects: topology.objects,
    arcs: arcs
  };
});


/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(topology) {
  var oldObjects = topology.objects,
      newObjects = {},
      oldArcs = topology.arcs,
      oldArcsLength = oldArcs.length,
      oldIndex = -1,
      newIndexByOldIndex = new Array(oldArcsLength),
      newArcsLength = 0,
      newArcs,
      newIndex = -1,
      key;

  function scanGeometry(input) {
    switch (input.type) {
      case "GeometryCollection": input.geometries.forEach(scanGeometry); break;
      case "LineString": scanArcs(input.arcs); break;
      case "MultiLineString": input.arcs.forEach(scanArcs); break;
      case "Polygon": input.arcs.forEach(scanArcs); break;
      case "MultiPolygon": input.arcs.forEach(scanMultiArcs); break;
    }
  }

  function scanArc(index) {
    if (index < 0) index = ~index;
    if (!newIndexByOldIndex[index]) newIndexByOldIndex[index] = 1, ++newArcsLength;
  }

  function scanArcs(arcs) {
    arcs.forEach(scanArc);
  }

  function scanMultiArcs(arcs) {
    arcs.forEach(scanArcs);
  }

  function reindexGeometry(input) {
    var output;
    switch (input.type) {
      case "GeometryCollection": output = {type: "GeometryCollection", geometries: input.geometries.map(reindexGeometry)}; break;
      case "LineString": output = {type: "LineString", arcs: reindexArcs(input.arcs)}; break;
      case "MultiLineString": output = {type: "MultiLineString", arcs: input.arcs.map(reindexArcs)}; break;
      case "Polygon": output = {type: "Polygon", arcs: input.arcs.map(reindexArcs)}; break;
      case "MultiPolygon": output = {type: "MultiPolygon", arcs: input.arcs.map(reindexMultiArcs)}; break;
      default: return input;
    }
    if (input.id != null) output.id = input.id;
    if (input.bbox != null) output.bbox = input.bbox;
    if (input.properties != null) output.properties = input.properties;
    return output;
  }

  function reindexArc(oldIndex) {
    return oldIndex < 0 ? ~newIndexByOldIndex[~oldIndex] : newIndexByOldIndex[oldIndex];
  }

  function reindexArcs(arcs) {
    return arcs.map(reindexArc);
  }

  function reindexMultiArcs(arcs) {
    return arcs.map(reindexArcs);
  }

  for (key in oldObjects) {
    scanGeometry(oldObjects[key]);
  }

  newArcs = new Array(newArcsLength);

  while (++oldIndex < oldArcsLength) {
    if (newIndexByOldIndex[oldIndex]) {
      newIndexByOldIndex[oldIndex] = ++newIndex;
      newArcs[newIndex] = oldArcs[oldIndex];
    }
  }

  for (key in oldObjects) {
    newObjects[key] = reindexGeometry(oldObjects[key]);
  }

  return {
    type: "Topology",
    bbox: topology.bbox,
    transform: topology.transform,
    objects: newObjects,
    arcs: newArcs
  };
});


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(topology, p) {
  var array = [];

  topology.arcs.forEach(function(arc) {
    arc.forEach(function(point) {
      if (isFinite(point[2])) { // Ignore endpoints, whose weight is Infinity.
        array.push(point[2]);
      }
    });
  });

  return array.length && quantile(array.sort(descending), p);
});

function quantile(array, p) {
  if (!(n = array.length)) return;
  if ((p = +p) <= 0 || n < 2) return array[0];
  if (p >= 1) return array[n - 1];
  var n,
      h = (n - 1) * p,
      i = Math.floor(h),
      a = array[i],
      b = array[i + 1];
  return a + (b - a) * (h - i);
}

function descending(a, b) {
  return b - a;
}


/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(topology, minWeight) {
  minWeight = minWeight == null ? Number.MIN_VALUE : +minWeight;

  // Remove points whose weight is less than the minimum weight.
  var arcs = topology.arcs.map(function(input) {
    var i = -1,
        j = 0,
        n = input.length,
        output = new Array(n), // pessimistic
        point;

    while (++i < n) {
      if ((point = input[i])[2] >= minWeight) {
        output[j++] = [point[0], point[1]];
      }
    }

    output.length = j;
    return output;
  });

  return {
    type: "Topology",
    transform: topology.transform,
    bbox: topology.bbox,
    objects: topology.objects,
    arcs: arcs
  };
});


/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sphericalRingArea */
/* unused harmony export sphericalTriangleArea */
var pi = Math.PI,
    tau = 2 * pi,
    quarterPi = pi / 4,
    radians = pi / 180,
    abs = Math.abs,
    atan2 = Math.atan2,
    cos = Math.cos,
    sin = Math.sin;

function halfArea(ring, closed) {
  var i = 0,
      n = ring.length,
      sum = 0,
      point = ring[closed ? i++ : n - 1],
      lambda0, lambda1 = point[0] * radians,
      phi1 = (point[1] * radians) / 2 + quarterPi,
      cosPhi0, cosPhi1 = cos(phi1),
      sinPhi0, sinPhi1 = sin(phi1);

  for (; i < n; ++i) {
    point = ring[i];
    lambda0 = lambda1, lambda1 = point[0] * radians;
    phi1 = (point[1] * radians) / 2 + quarterPi;
    cosPhi0 = cosPhi1, cosPhi1 = cos(phi1);
    sinPhi0 = sinPhi1, sinPhi1 = sin(phi1);

    // Spherical excess E for a spherical triangle with vertices: south pole,
    // previous point, current point.  Uses a formula derived from Cagnoli’s
    // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
    // See https://github.com/d3/d3-geo/blob/master/README.md#geoArea
    var dLambda = lambda1 - lambda0,
        sdLambda = dLambda >= 0 ? 1 : -1,
        adLambda = sdLambda * dLambda,
        k = sinPhi0 * sinPhi1,
        u = cosPhi0 * cosPhi1 + k * cos(adLambda),
        v = k * sdLambda * sin(adLambda);
    sum += atan2(v, u);
  }

  return sum;
}

function sphericalRingArea(ring, interior) {
  var sum = halfArea(ring, true);
  if (interior) sum *= -1;
  return (sum < 0 ? tau + sum : sum) * 2;
}

function sphericalTriangleArea(t) {
  return abs(halfArea(t, false)) * 2;
}


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_topojson_client__ = __webpack_require__(25);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_topojson_client__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_topojson_server__ = __webpack_require__(168);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_topojson_simplify__ = __webpack_require__(179);
/* unused harmony namespace reexport */





/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    'production' !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          'production' !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  'production' !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 190 */
/***/ (function(module, exports) {


    module.exports = {
      render: function(){with(this){return _c('div',{staticClass:"app refineryGraphics"},[_c('overview')],1)}},
      staticRenderFns: []
    };
  

/***/ }),
/* 191 */
/***/ (function(module, exports) {


    module.exports = {
      render: function(){with(this){return _c('div')}},
      staticRenderFns: []
    };
  

/***/ }),
/* 192 */
/***/ (function(module, exports) {


    module.exports = {
      render: function(){with(this){return _c('div',{staticClass:"overview"},[_c('div',{staticClass:"overviewContainer"},[_c('router-view')],1)])}},
      staticRenderFns: []
    };
  

/***/ }),
/* 193 */
/***/ (function(module, exports) {


    module.exports = {
      render: function(){with(this){return _m(0)}},
      staticRenderFns: [function(){with(this){return _c('div',{staticClass:"californiaPollutionMap"},[_c('p',{staticClass:"chatter"},[_v("This map shows “pollution burden” scores calculated for selected Los Angeles-area census tracts by the California Environmental Protection Agency. Pollution burden reflects an average of exposures and environmental effects. Darker-colored areas, such as Wilmington, have higher scores, meaning they are more polluted and have higher prevalence of diseases such as asthma. Lighter-colored areas — such as more affluent Rancho Palos Verdes, about five miles away — are cleaner and healthier. Tap on an area of the map to see data for individual tracts.")]),_v(" "),_c('div',{staticClass:"map"}),_v(" "),_c('p',{staticClass:"source"},[_v("Source: "),_c('a',{attrs:{"href":"https://oehha.ca.gov/calenviroscreen","target":"_top"}},[_v("California EPA's Office of Environmental Health Hazard Assessment")]),_v(", map data © "),_c('a',{attrs:{"href":"http://www.openstreetmap.org/copyright","target":"_top"}},[_v("OpenStreetMap")]),_v(" contributors, "),_c('a',{attrs:{"href":"https://carto.com/attribution","target":"_top"}},[_v("CARTO")]),_v(". Graphic by Iuliia Alieva")])])}}]
    };
  

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.5.2
 * (c) 2014-2017 Evan You
 * Released under the MIT License.
 */
/*  */

// these helpers produces better vm code in JS engines due to their
// explicitness and function inlining
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value e.g. [object Object]
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : typeof val === 'object'
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert a input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if a attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether the object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind, faster than native
 */
function bind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }
  // record original fn length
  boundFn._length = fn.length;
  return boundFn
}

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/)
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/**
 * Return same value
 */
var identity = function (_) { return _; };

/**
 * Generate a static keys string from compiler modules.
 */


/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured'
];

/*  */

var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: 'production' !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: 'production' !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

var emptyObject = Object.freeze({});

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = /[^\w.$]/;
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = UA && UA.indexOf('android') > 0;
var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA);
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = (function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm || {};
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */


var uid$1 = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid$1++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// the current target watcher being evaluated.
// this is globally unique because there could be only one
// watcher being evaluated at any time.
Dep.target = null;
var targetStack = [];

function pushTarget (_target) {
  if (Dep.target) { targetStack.push(Dep.target); }
  Dep.target = _target;
}

function popTarget () {
  Dep.target = targetStack.pop();
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.functionalContext = undefined;
  this.functionalOptions = undefined;
  this.functionalScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode, deep) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    vnode.children,
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.isCloned = true;
  if (deep && vnode.children) {
    cloned.children = cloneVNodes(vnode.children);
  }
  return cloned
}

function cloneVNodes (vnodes, deep) {
  var len = vnodes.length;
  var res = new Array(len);
  for (var i = 0; i < len; i++) {
    res[i] = cloneVNode(vnodes[i], deep);
  }
  return res
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);[
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
]
.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * By default, when a reactive property is set, the new value is
 * also converted to become reactive. However when passing down props,
 * we don't want to force conversion because the value may be a nested value
 * under a frozen data structure. Converting it would defeat the optimization.
 */
var observerState = {
  shouldConvert: true
};

/**
 * Observer class that are attached to each observed
 * object. Once attached, the observer converts target
 * object's property keys into getter/setters that
 * collect dependencies and dispatches updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    var augment = hasProto
      ? protoAugment
      : copyAugment;
    augment(value, arrayMethods, arrayKeys);
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through each property and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive(obj, keys[i], obj[keys[i]]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment an target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src, keys) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment an target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    observerState.shouldConvert &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (hasOwn(target, key)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    'production' !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    'production' !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;
  var keys = Object.keys(from);
  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this) : parentVal
      )
    }
  } else if (parentVal || childVal) {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      'production' !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn.call(this, parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  return childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    'production' !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && 'production' !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    var lower = key.toLowerCase();
    if (isBuiltInTag(lower) || config.isReservedTag(lower)) {
      warn(
        'Do not use built-in or reserved HTML elements as component ' +
        'id: ' + key
      );
    }
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def = dirs[key];
      if (typeof def === 'function') {
        dirs[key] = { bind: def, update: def };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);
  var extendsFrom = child.extends;
  if (extendsFrom) {
    parent = mergeOptions(parent, extendsFrom, vm);
  }
  if (child.mixins) {
    for (var i = 0, l = child.mixins.length; i < l; i++) {
      parent = mergeOptions(parent, child.mixins[i], vm);
    }
  }
  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */

function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // handle boolean props
  if (isType(Boolean, prop.type)) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (!isType(String, prop.type) && (value === '' || value === hyphenate(key))) {
      value = true;
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldConvert = observerState.shouldConvert;
    observerState.shouldConvert = true;
    observe(value);
    observerState.shouldConvert = prevShouldConvert;
  }
  if (false) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }
  if (!valid) {
    warn(
      "Invalid prop: type check failed for prop \"" + name + "\"." +
      " Expected " + (expectedTypes.map(capitalize).join(', ')) +
      ", got " + (toRawType(value)) + ".",
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isType (type, fn) {
  if (!Array.isArray(fn)) {
    return getType(fn) === getType(type)
  }
  for (var i = 0, len = fn.length; i < len; i++) {
    if (getType(fn[i]) === getType(type)) {
      return true
    }
  }
  /* istanbul ignore next */
  return false
}

/*  */

function handleError (err, vm, info) {
  if (vm) {
    var cur = vm;
    while ((cur = cur.$parent)) {
      var hooks = cur.$options.errorCaptured;
      if (hooks) {
        for (var i = 0; i < hooks.length; i++) {
          try {
            var capture = hooks[i].call(cur, err, vm, info) === false;
            if (capture) { return }
          } catch (e) {
            globalHandleError(e, cur, 'errorCaptured hook');
          }
        }
      }
    }
  }
  globalHandleError(err, vm, info);
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      logError(e, null, 'config.errorHandler');
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if (inBrowser && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */
/* globals MessageChannel */

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using both micro and macro tasks.
// In < 2.4 we used micro tasks everywhere, but there are some scenarios where
// micro tasks have too high a priority and fires in between supposedly
// sequential events (e.g. #4521, #6690) or even between bubbling of the same
// event (#6566). However, using macro tasks everywhere also has subtle problems
// when state is changed right before repaint (e.g. #6813, out-in transitions).
// Here we use micro task by default, but expose a way to force macro task when
// needed (e.g. in event handlers attached by v-on).
var microTimerFunc;
var macroTimerFunc;
var useMacroTask = false;

// Determine (macro) Task defer implementation.
// Technically setImmediate should be the ideal choice, but it's only available
// in IE. The only polyfill that consistently queues the callback after all DOM
// events triggered in the same loop is by using MessageChannel.
/* istanbul ignore if */
if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  macroTimerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else if (typeof MessageChannel !== 'undefined' && (
  isNative(MessageChannel) ||
  // PhantomJS
  MessageChannel.toString() === '[object MessageChannelConstructor]'
)) {
  var channel = new MessageChannel();
  var port = channel.port2;
  channel.port1.onmessage = flushCallbacks;
  macroTimerFunc = function () {
    port.postMessage(1);
  };
} else {
  /* istanbul ignore next */
  macroTimerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

// Determine MicroTask defer implementation.
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  microTimerFunc = function () {
    p.then(flushCallbacks);
    // in problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
} else {
  // fallback to macro
  microTimerFunc = macroTimerFunc;
}

/**
 * Wrap a function so that if any code inside triggers state change,
 * the changes are queued using a Task instead of a MicroTask.
 */
function withMacroTask (fn) {
  return fn._withTask || (fn._withTask = function () {
    useMacroTask = true;
    var res = fn.apply(null, arguments);
    useMacroTask = false;
    return res
  })
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    if (useMacroTask) {
      macroTimerFunc();
    } else {
      microTimerFunc();
    }
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' &&
    Proxy.toString().match(/native code/);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) || key.charAt(0) === '_';
      if (!has && !isAllowed) {
        warnNonPresent(target, key);
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        warnNonPresent(target, key);
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      perf.clearMeasures(name);
    };
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        cloned[i].apply(null, arguments$1);
      }
    } else {
      // return handler return value for single handlers
      return fns.apply(null, arguments)
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  vm
) {
  var name, cur, old, event;
  for (name in on) {
    cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      'production' !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur);
      }
      add(event.name, cur, event.once, event.capture, event.passive);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor,
  context
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (isDef(factory.contexts)) {
    // already pending
    factory.contexts.push(context);
  } else {
    var contexts = factory.contexts = [context];
    var sync = true;

    var forceRender = function () {
      for (var i = 0, l = contexts.length; i < l; i++) {
        contexts[i].$forceUpdate();
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender();
      }
    });

    var reject = once(function (reason) {
      'production' !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender();
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (typeof res.then === 'function') {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isDef(res.component) && typeof res.component.then === 'function') {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            setTimeout(function () {
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender();
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          setTimeout(function () {
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn, once) {
  if (once) {
    target.$once(event, fn);
  } else {
    target.$on(event, fn);
  }
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, vm);
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var this$1 = this;

    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var this$1 = this;

    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$off(event[i], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (arguments.length === 1) {
      vm._events[event] = null;
      return vm
    }
    if (fn) {
      // specific handler
      var cb;
      var i$1 = cbs.length;
      while (i$1--) {
        cb = cbs[i$1];
        if (cb === fn || cb.fn === fn) {
          cbs.splice(i$1, 1);
          break
        }
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      for (var i = 0, l = cbs.length; i < l; i++) {
        try {
          cbs[i].apply(vm, args);
        } catch (e) {
          handleError(e, vm, ("event handler for \"" + event + "\""));
        }
      }
    }
    return vm
  };
}

/*  */

/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  var slots = {};
  if (!children) {
    return slots
  }
  var defaultSlot = [];
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.functionalContext === context) &&
      data && data.slot != null
    ) {
      var name = child.data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children);
      } else {
        slot.push(child);
      }
    } else {
      defaultSlot.push(child);
    }
  }
  // ignore whitespace
  if (!defaultSlot.every(isWhitespace)) {
    slots.default = defaultSlot;
  }
  return slots
}

function isWhitespace (node) {
  return node.isComment || node.text === ' '
}

function resolveScopedSlots (
  fns, // see flow/vnode
  res
) {
  res = res || {};
  for (var i = 0; i < fns.length; i++) {
    if (Array.isArray(fns[i])) {
      resolveScopedSlots(fns[i], res);
    } else {
      res[fns[i].key] = fns[i].fn;
    }
  }
  return res
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    if (vm._isMounted) {
      callHook(vm, 'beforeUpdate');
    }
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(
        vm.$el, vnode, hydrating, false /* removeOnly */,
        vm.$options._parentElm,
        vm.$options._refElm
      );
      // no need for the ref nodes after initial patch
      // this prevents keeping a detached DOM tree in memory (#5851)
      vm.$options._parentElm = vm.$options._refElm = null;
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    activeInstance = prevActiveInstance;
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  vm._watcher = new Watcher(vm, updateComponent, noop);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren
  var hasChildren = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    parentVnode.data.scopedSlots || // has new scoped slots
    vm.$scopedSlots !== emptyObject // has old scoped slots
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = (parentVnode.data && parentVnode.data.attrs) || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    observerState.shouldConvert = false;
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      props[key] = validateProp(key, vm.$options.props, propsData, vm);
    }
    observerState.shouldConvert = true;
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  if (listeners) {
    var oldListeners = vm.$options._parentListeners;
    vm.$options._parentListeners = listeners;
    updateComponentListeners(vm, listeners, oldListeners);
  }
  // resolve slots + force update if has children
  if (hasChildren) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  var handlers = vm.$options[hook];
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      try {
        handlers[i].call(vm);
      } catch (e) {
        handleError(e, vm, (hook + " hook"));
      }
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
}

/*  */


var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */

var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options
) {
  this.vm = vm;
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = function () {};
      'production' !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    var dep = this$1.deps[i];
    if (!this$1.newDepIds.has(dep.id)) {
      dep.removeSub(this$1);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    this$1.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
    var this$1 = this;

  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this$1.deps[i].removeSub(this$1);
    }
    this.active = false;
  }
};

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
var seenObjects = new _Set();
function traverse (val) {
  seenObjects.clear();
  _traverse(val, seenObjects);
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || !Object.isExtensible(val)) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  observerState.shouldConvert = isRoot;
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive(props, key, value, function () {
        if (vm.$parent && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  observerState.shouldConvert = true;
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    'production' !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      'production' !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : userDef;
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : userDef.get
      : noop;
    sharedPropertyDefinition.set = userDef.set
      ? userDef.set
      : noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (methods[key] == null) {
        warn(
          "Method \"" + key + "\" has an undefined value in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = methods[key] == null ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  keyOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(keyOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function (newData) {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      cb.call(vm, watcher.value);
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    observerState.shouldConvert = false;
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive(vm, key, result[key]);
      }
    });
    observerState.shouldConvert = true;
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
        ? Reflect.ownKeys(inject).filter(function (key) {
          /* istanbul ignore next */
          return Object.getOwnPropertyDescriptor(inject, key).enumerable
        })
        : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && provideKey in source._provided) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    keys = Object.keys(val);
    ret = new Array(keys.length);
    for (i = 0, l = keys.length; i < l; i++) {
      key = keys[i];
      ret[i] = render(val[key], key, i);
    }
  }
  if (isDef(ret)) {
    (ret)._isVList = true;
  }
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    return scopedSlotFn(props) || fallback
  } else {
    var slotNodes = this.$slots[name];
    // warn duplicate slot usage
    if (slotNodes && 'production' !== 'production') {
      slotNodes._rendered && warn(
        "Duplicate presence of slot \"" + name + "\" found in the same render tree " +
        "- this will likely cause render errors.",
        this
      );
      slotNodes._rendered = true;
    }
    return slotNodes || fallback
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInAlias,
  eventKeyName
) {
  var keyCodes = config.keyCodes[key] || builtInAlias;
  if (keyCodes) {
    if (Array.isArray(keyCodes)) {
      return keyCodes.indexOf(eventKeyCode) === -1
    } else {
      return keyCodes !== eventKeyCode
    }
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      'production' !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        if (!(key in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  // static trees can be rendered once and cached on the contructor options
  // so every instance shares the same cached trees
  var renderFns = this.$options.staticRenderFns;
  var cached = renderFns.cached || (renderFns.cached = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree by doing a shallow clone.
  if (tree && !isInFor) {
    return Array.isArray(tree)
      ? cloneVNodes(tree)
      : cloneVNode(tree)
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = renderFns[index].call(this._renderProxy, null, this);
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      'production' !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var options = Ctor.options;
  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () { return resolveSlots(children, parent); };

  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm = Object.create(parent);
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = data.scopedSlots || emptyObject;
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode) {
        vnode.functionalScopeId = options._scopeId;
        vnode.functionalContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    vnode.functionalContext = contextVm;
    vnode.functionalOptions = options;
    if (data.slot) {
      (vnode.data || (vnode.data = {})).slot = data.slot;
    }
  }

  return vnode
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

// hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (
    vnode,
    hydrating,
    parentElm,
    refElm
  ) {
    if (!vnode.componentInstance || vnode.componentInstance._isDestroyed) {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance,
        parentElm,
        refElm
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    } else if (vnode.data.keepAlive) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor, context);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // merge component management hooks onto the placeholder node
  mergeHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );
  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent, // activeInstance in lifecycle state
  parentElm,
  refElm
) {
  var vnodeComponentOptions = vnode.componentOptions;
  var options = {
    _isComponent: true,
    parent: parent,
    propsData: vnodeComponentOptions.propsData,
    _componentTag: vnodeComponentOptions.tag,
    _parentVnode: vnode,
    _parentListeners: vnodeComponentOptions.listeners,
    _renderChildren: vnodeComponentOptions.children,
    _parentElm: parentElm || null,
    _refElm: refElm || null
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnodeComponentOptions.Ctor(options)
}

function mergeHooks (data) {
  if (!data.hook) {
    data.hook = {};
  }
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var fromParent = data.hook[key];
    var ours = componentVNodeHooks[key];
    data.hook[key] = fromParent ? mergeHook$1(ours, fromParent) : ours;
  }
}

function mergeHook$1 (one, two) {
  return function (a, b, c, d) {
    one(a, b, c, d);
    two(a, b, c, d);
  }
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input';(data.props || (data.props = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  if (isDef(on[event])) {
    on[event] = [data.model.callback].concat(on[event]);
  } else {
    on[event] = data.model.callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    'production' !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    warn(
      'Avoid using non-primitive value as key, ' +
      'use string/number value instead.',
      context
    );
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if (isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (isDef(vnode)) {
    if (ns) { applyNS(vnode, ns); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (isUndef(child.ns) || isTrue(force))) {
        applyNS(child, ns, force);
      }
    }
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (vm._isMounted) {
      // if the parent didn't update, the slot nodes will be the ones from
      // last render. They need to be cloned to ensure "freshness" for this render.
      for (var key in vm.$slots) {
        var slot = vm.$slots[key];
        if (slot._rendered) {
          vm.$slots[key] = cloneVNodes(slot, true /* deep */);
        }
      }
    }

    vm.$scopedSlots = (_parentVnode && _parentVnode.data.scopedSlots) || emptyObject;

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        if (vm.$options.renderError) {
          try {
            vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
          } catch (e) {
            handleError(e, vm, "renderError");
            vnode = vm._vnode;
          }
        } else {
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

var uid = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  opts.parent = options.parent;
  opts.propsData = options.propsData;
  opts._parentVnode = options._parentVnode;
  opts._parentListeners = options._parentListeners;
  opts._renderChildren = options._renderChildren;
  opts._componentTag = options._componentTag;
  opts._parentElm = options._parentElm;
  opts._refElm = options._refElm;
  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var extended = Ctor.extendOptions;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = dedupe(latest[key], extended[key], sealed[key]);
    }
  }
  return modified
}

function dedupe (latest, extended, sealed) {
  // compare latest and sealed to ensure lifecycle hooks won't be duplicated
  // between merges
  if (Array.isArray(latest)) {
    var res = [];
    sealed = Array.isArray(sealed) ? sealed : [sealed];
    extended = Array.isArray(extended) ? extended : [extended];
    for (var i = 0; i < latest.length; i++) {
      // push original options and not sealed options to exclude duplicated options
      if (extended.indexOf(latest[i]) >= 0 || sealed.indexOf(latest[i]) < 0) {
        res.push(latest[i]);
      }
    }
    return res
  } else {
    return latest
  }
}

function Vue$3 (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue$3);
stateMixin(Vue$3);
eventsMixin(Vue$3);
lifecycleMixin(Vue$3);
renderMixin(Vue$3);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      if (!/^[a-zA-Z][\w-]*$/.test(name)) {
        warn(
          'Invalid component name: "' + name + '". Component names ' +
          'can only contain alphanumeric characters and the hyphen, ' +
          'and must start with a letter.'
        );
      }
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          if (type === 'component' && config.isReservedTag(id)) {
            warn(
              'Do not use built-in or reserved HTML elements as component ' +
              'id: ' + id
            );
          }
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */

function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && cached$$1 !== current) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    var this$1 = this;

    for (var key in this$1.cache) {
      pruneCacheEntry(this$1.cache, key, this$1.keys);
    }
  },

  watch: {
    include: function include (val) {
      pruneCache(this, function (name) { return matches(val, name); });
    },
    exclude: function exclude (val) {
      pruneCache(this, function (name) { return !matches(val, name); });
    }
  },

  render: function render () {
    var vnode = getFirstComponentChild(this.$slots.default);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      if (name && (
        (this.include && !matches(this.include, name)) ||
        (this.exclude && matches(this.exclude, name))
      )) {
        return vnode
      }

      var ref = this;
      var cache = ref.cache;
      var keys = ref.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue$3);

Object.defineProperty(Vue$3.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue$3.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

Vue$3.version = '2.5.2';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);



var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      'production' !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setAttribute (node, key, val) {
  node.setAttribute(key, val);
}


var nodeOps = Object.freeze({
	createElement: createElement$1,
	createElementNS: createElementNS,
	createTextNode: createTextNode,
	createComment: createComment,
	insertBefore: insertBefore,
	removeChild: removeChild,
	appendChild: appendChild,
	parentNode: parentNode,
	nextSibling: nextSibling,
	tagName: tagName,
	setTextContent: setTextContent,
	setAttribute: setAttribute
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!key) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove () {
      if (--remove.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove.listeners = listeners;
    return remove
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  var inPre = 0;
  function createElm (vnode, insertedVnodeQueue, parentElm, refElm, nested) {
    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          inPre++;
        }
        if (
          !inPre &&
          !vnode.ns &&
          !(
            config.ignoredElements.length &&
            config.ignoredElements.some(function (ignore) {
              return isRegExp(ignore)
                ? ignore.test(tag)
                : ignore === tag
            })
          ) &&
          config.isUnknownElement(tag)
        ) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }
      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        inPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */, parentElm, refElm);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (ref$$1.parentNode === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(vnode.text));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.functionalScopeId)) {
      nodeOps.setAttribute(vnode.elm, i, '');
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setAttribute(vnode.elm, i, '');
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.functionalContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setAttribute(vnode.elm, i, '');
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
        } else {
          vnodeToMove = oldCh[idxInOld];
          /* istanbul ignore if */
          if (false) {
            warn(
              'It seems there are duplicate keys that is causing an update error. ' +
              'Make sure each v-for item has a unique key.'
            );
          }
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (oldVnode, vnode, insertedVnodeQueue, removeOnly) {
    if (oldVnode === vnode) {
      return
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var bailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  var isRenderedModule = makeMap('attrs,style,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue) {
    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.elm = elm;
      vnode.isAsyncPlaceholder = true;
      return true
    }
    if (false) {
      if (!assertNodeMatch(elm, vnode)) {
        return false
      }
    }
    vnode.elm = elm;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                bailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                bailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        for (var key in data) {
          if (!isRenderedModule(key)) {
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode) {
    if (isDef(vnode.tag)) {
      return (
        vnode.tag.indexOf('vue-component') === 0 ||
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue, parentElm, refElm);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }
        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm$1 = nodeOps.parentNode(oldElm);
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm$1,
          nodeOps.nextSibling(oldElm)
        );

        if (isDef(vnode.parent)) {
          // component root element replaced.
          // update parent placeholder node element, recursively
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        if (isDef(parentElm$1)) {
          removeVnodes(parentElm$1, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode.data.hook || (vnode.data.hook = {}), 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode.data.hook || (vnode.data.hook = {}), 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE9 || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, isFalsyAttrValue(value) || value === 'false' ? 'false' : 'true');
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      el.setAttribute(key, value);
    }
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

/*  */















// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.

/*  */

/**
 * Cross-platform code generation for component v-model
 */


/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */

/*  */

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler (handler, event, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

function add$1 (
  event,
  handler,
  once$$1,
  capture,
  passive
) {
  handler = withMacroTask(handler);
  if (once$$1) { handler = createOnceHandler(handler, event, capture); }
  target$1.addEventListener(
    event,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  event,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    event,
    handler._withTask || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, vnode.context);
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (isUndef(props[key])) {
      elm[key] = '';
    }
  }
  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else {
      elm[key] = cur;
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isDirty(elm, checkVal) ||
    isInputChanged(elm, checkVal)
  ))
}

function isDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isInputChanged (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers) && modifiers.number) {
    return toNumber(value) !== toNumber(newVal)
  }
  if (isDef(modifiers) && modifiers.trim) {
    return value.trim() !== newVal.trim()
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (childNode.data && (styleData = normalizeStyleData(childNode.data))) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(name, val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def) {
  if (!def) {
    return
  }
  /* istanbul ignore else */
  if (typeof def === 'object') {
    var res = {};
    if (def.css !== false) {
      extend(res, autoCssTransition(def.name || 'v'));
    }
    extend(res, def);
    return res
  } else if (typeof def === 'string') {
    return autoCssTransition(def)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  var transitionDelays = styles[transitionProp + 'Delay'].split(', ');
  var transitionDurations = styles[transitionProp + 'Duration'].split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = styles[animationProp + 'Delay'].split(', ');
  var animationDurations = styles[animationProp + 'Duration'].split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

function toMs (s) {
  return Number(s.slice(0, -1)) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    transitionNode = transitionNode.parent;
    context = transitionNode.context;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode.data.hook || (vnode.data.hook = {}), 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      addTransitionClass(el, toClass);
      removeTransitionClass(el, startClass);
      if (!cb.cancelled && !userWantsControl) {
        if (isValidDuration(explicitEnterDuration)) {
          setTimeout(cb, explicitEnterDuration);
        } else {
          whenTransitionEnds(el, type, cb);
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        addTransitionClass(el, leaveToClass);
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled && !userWantsControl) {
          if (isValidDuration(explicitLeaveDuration)) {
            setTimeout(cb, explicitLeaveDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var model$1 = {
  inserted: function inserted (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        if (!isAndroid) {
          el.addEventListener('compositionstart', onCompositionStart);
          el.addEventListener('compositionend', onCompositionEnd);
        }
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },
  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    'production' !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (value === oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: model$1,
  show: show
};

/*  */

// Provides transition support for a single element/component.
// supports transition mode (out-in / in-out)

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$options._renderChildren;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(function (c) { return c.tag || isAsyncPlaceholder(c); });
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(function (d) { return d.name === 'show'; })) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

// Provides transition support for list items.
// supports move transitions using the FLIP technique.

// Because the vdom's children update algorithm is "unstable" - i.e.
// it doesn't guarantee the relative positioning of removed elements,
// we force transition-group to update its children into two passes:
// in the first pass, we remove all nodes that need to be removed,
// triggering their leaving transition; in the second pass, we insert/move
// into the final desired state. This way in the second pass removed
// nodes will remain where they should be.

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  beforeUpdate: function beforeUpdate () {
    // force removing pass
    this.__patch__(
      this._vnode,
      this.kept,
      false, // hydrating
      true // removeOnly (!important, avoids unnecessary moves)
    );
    this._vnode = this.kept;
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue$3.config.mustUseProp = mustUseProp;
Vue$3.config.isReservedTag = isReservedTag;
Vue$3.config.isReservedAttr = isReservedAttr;
Vue$3.config.getTagNamespace = getTagNamespace;
Vue$3.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue$3.options.directives, platformDirectives);
extend(Vue$3.options.components, platformComponents);

// install platform patch function
Vue$3.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue$3.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
Vue$3.nextTick(function () {
  if (config.devtools) {
    if (devtools) {
      devtools.emit('init', Vue$3);
    } else if (false) {
      console[console.info ? 'info' : 'log'](
        'Download the Vue Devtools extension for a better development experience:\n' +
        'https://github.com/vuejs/vue-devtools'
      );
    }
  }
  if (false
  ) {
    console[console.info ? 'info' : 'log'](
      "You are running Vue in development mode.\n" +
      "Make sure to turn on production mode when deploying for production.\n" +
      "See more tips at https://vuejs.org/guide/deployment.html"
    );
  }
}, 0);

/*  */

/* harmony default export */ __webpack_exports__["a"] = (Vue$3);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(30), __webpack_require__(161).setImmediate))

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Vuex v1.0.1
 * (c) 2017 Evan You
 * Released under the MIT License.
 */
(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.Vuex = factory());
}(this, (function () { 'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();









































var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/**
 * Merge an array of objects into one.
 *
 * @param {Array<Object>} arr
 * @return {Object}
 */

function mergeObjects(arr) {
  return arr.reduce(function (prev, obj) {
    Object.keys(obj).forEach(function (key) {
      var existing = prev[key];
      if (existing) {
        // allow multiple mutation objects to contain duplicate
        // handlers for the same mutation type
        if (Array.isArray(existing)) {
          prev[key] = existing.concat(obj[key]);
        } else {
          prev[key] = [existing].concat(obj[key]);
        }
      } else {
        prev[key] = obj[key];
      }
    });
    return prev;
  }, {});
}

/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */


/**
 * Check whether the given value is Object or not
 *
 * @param {*} obj
 * @return {Boolean}
 */

function isObject(obj) {
  return obj !== null && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
}

/**
 * Get state sub tree by given keys.
 *
 * @param {Object} state
 * @param {Array<String>} nestedKeys
 * @return {Object}
 */
function getNestedState(state, nestedKeys) {
  return nestedKeys.reduce(function (state, key) {
    return state[key];
  }, state);
}

/**
 * Hacks to get access to Vue internals.
 * Maybe we should expose these...
 */

var Watcher = void 0;
function getWatcher(vm) {
  if (!Watcher) {
    var noop = function noop() {};
    var unwatch = vm.$watch(noop, noop);
    Watcher = vm._watchers[0].constructor;
    unwatch();
  }
  return Watcher;
}

var Dep = void 0;
function getDep(vm) {
  if (!Dep) {
    Dep = vm._data.__ob__.dep.constructor;
  }
  return Dep;
}

var hook = typeof window !== 'undefined' && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin(store) {
  if (!hook) return;

  hook.emit('vuex:init', store);

  hook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    hook.emit('vuex:mutation', mutation, state);
  });
}

var override = function (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    var usesInit = Vue.config._lifecycleHooks.indexOf('init') > -1;
    Vue.mixin(usesInit ? { init: vuexInit } : { beforeCreate: vuexInit });
  } else {
    (function () {
      // override init and inject vuex init procedure
      // for 1.x backwards compatibility.
      var _init = Vue.prototype._init;
      Vue.prototype._init = function () {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        options.init = options.init ? [vuexInit].concat(options.init) : vuexInit;
        _init.call(this, options);
      };
    })();
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit() {
    var options = this.$options;
    var store = options.store,
        vuex = options.vuex;
    // store injection

    if (store) {
      this.$store = store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
    // vuex option handling
    if (vuex) {
      if (!this.$store) {
        console.warn('[vuex] store not injected. make sure to ' + 'provide the store option in your root component.');
      }
      var state = vuex.state,
          actions = vuex.actions;
      var getters = vuex.getters;
      // handle deprecated state option

      if (state && !getters) {
        console.warn('[vuex] vuex.state option will been deprecated in 1.0. ' + 'Use vuex.getters instead.');
        getters = state;
      }
      // getters
      if (getters) {
        options.computed = options.computed || {};
        for (var key in getters) {
          defineVuexGetter(this, key, getters[key]);
        }
      }
      // actions
      if (actions) {
        options.methods = options.methods || {};
        for (var _key in actions) {
          options.methods[_key] = makeBoundAction(this.$store, actions[_key], _key);
        }
      }
    }
  }

  /**
   * Setter for all getter properties.
   */

  function setter() {
    throw new Error('vuex getter properties are read-only.');
  }

  /**
   * Define a Vuex getter on an instance.
   *
   * @param {Vue} vm
   * @param {String} key
   * @param {Function} getter
   */

  function defineVuexGetter(vm, key, getter) {
    if (typeof getter !== 'function') {
      console.warn('[vuex] Getter bound to key \'vuex.getters.' + key + '\' is not a function.');
    } else {
      Object.defineProperty(vm, key, {
        enumerable: true,
        configurable: true,
        get: makeComputedGetter(vm.$store, getter),
        set: setter
      });
    }
  }

  /**
   * Make a computed getter, using the same caching mechanism of computed
   * properties. In addition, it is cached on the raw getter function using
   * the store's unique cache id. This makes the same getter shared
   * across all components use the same underlying watcher, and makes
   * the getter evaluated only once during every flush.
   *
   * @param {Store} store
   * @param {Function} getter
   */

  function makeComputedGetter(store, getter) {
    var id = store._getterCacheId;

    // cached
    if (getter[id]) {
      return getter[id];
    }
    var vm = store._vm;
    var Watcher = getWatcher(vm);
    var Dep = getDep(vm);
    var watcher = new Watcher(vm, function (vm) {
      return getter(vm.state);
    }, null, { lazy: true });
    var computedGetter = function computedGetter() {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value;
    };
    getter[id] = computedGetter;
    return computedGetter;
  }

  /**
   * Make a bound-to-store version of a raw action function.
   *
   * @param {Store} store
   * @param {Function} action
   * @param {String} key
   */

  function makeBoundAction(store, action, key) {
    if (typeof action !== 'function') {
      console.warn('[vuex] Action bound to key \'vuex.actions.' + key + '\' is not a function.');
    }
    return function vuexBoundAction() {
      for (var _len = arguments.length, args = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return action.call.apply(action, [this, store].concat(args));
    };
  }

  // option merging
  var merge = Vue.config.optionMergeStrategies.computed;
  Vue.config.optionMergeStrategies.vuex = function (toVal, fromVal) {
    if (!toVal) return fromVal;
    if (!fromVal) return toVal;
    return {
      getters: merge(toVal.getters, fromVal.getters),
      state: merge(toVal.state, fromVal.state),
      actions: merge(toVal.actions, fromVal.actions)
    };
  };
};

var Vue = void 0;
var uid = 0;

var Store = function () {

  /**
   * @param {Object} options
   *        - {Object} state
   *        - {Object} actions
   *        - {Object} mutations
   *        - {Array} plugins
   *        - {Boolean} strict
   */

  function Store() {
    var _this = this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$state = _ref.state,
        state = _ref$state === undefined ? {} : _ref$state,
        _ref$mutations = _ref.mutations,
        mutations = _ref$mutations === undefined ? {} : _ref$mutations,
        _ref$modules = _ref.modules,
        modules = _ref$modules === undefined ? {} : _ref$modules,
        _ref$plugins = _ref.plugins,
        plugins = _ref$plugins === undefined ? [] : _ref$plugins,
        _ref$strict = _ref.strict,
        strict = _ref$strict === undefined ? false : _ref$strict;

    classCallCheck(this, Store);

    this._getterCacheId = 'vuex_store_' + uid++;
    this._dispatching = false;
    this._rootMutations = this._mutations = mutations;
    this._modules = modules;
    this._subscribers = [];
    // bind dispatch to self
    var dispatch = this.dispatch;
    this.dispatch = function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      dispatch.apply(_this, args);
    };
    // use a Vue instance to store the state tree
    // suppress warnings just in case the user has added
    // some funky global mixins
    if (!Vue) {
      throw new Error('[vuex] must call Vue.use(Vuex) before creating a store instance.');
    }
    var silent = Vue.config.silent;
    Vue.config.silent = true;
    this._vm = new Vue({
      data: {
        state: state
      }
    });
    Vue.config.silent = silent;
    this._setupModuleState(state, modules);
    this._setupModuleMutations(modules);
    // add extra warnings in strict mode
    if (strict) {
      this._setupMutationCheck();
    }
    // apply plugins
    devtoolPlugin(this);
    plugins.forEach(function (plugin) {
      return plugin(_this);
    });
  }

  /**
   * Getter for the entire state tree.
   * Read only.
   *
   * @return {Object}
   */

  createClass(Store, [{
    key: 'replaceState',


    /**
     * Replace root state.
     *
     * @param {Object} state
     */

    value: function replaceState(state) {
      this._dispatching = true;
      this._vm.state = state;
      this._dispatching = false;
    }

    /**
     * Dispatch an action.
     *
     * @param {String} type
     */

  }, {
    key: 'dispatch',
    value: function dispatch(type) {
      var _this2 = this;

      for (var _len2 = arguments.length, payload = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        payload[_key2 - 1] = arguments[_key2];
      }

      var silent = false;
      var isObjectStyleDispatch = false;
      // compatibility for object actions, e.g. FSA
      if ((typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'object' && type.type && arguments.length === 1) {
        isObjectStyleDispatch = true;
        payload = type;
        if (type.silent) silent = true;
        type = type.type;
      }
      var handler = this._mutations[type];
      var state = this.state;
      if (handler) {
        this._dispatching = true;
        // apply the mutation
        if (Array.isArray(handler)) {
          handler.forEach(function (h) {
            isObjectStyleDispatch ? h(state, payload) : h.apply(undefined, [state].concat(toConsumableArray(payload)));
          });
        } else {
          isObjectStyleDispatch ? handler(state, payload) : handler.apply(undefined, [state].concat(toConsumableArray(payload)));
        }
        this._dispatching = false;
        if (!silent) {
          (function () {
            var mutation = isObjectStyleDispatch ? payload : { type: type, payload: payload };
            _this2._subscribers.forEach(function (sub) {
              return sub(mutation, state);
            });
          })();
        }
      } else {
        console.warn('[vuex] Unknown mutation: ' + type);
      }
    }

    /**
     * Watch state changes on the store.
     * Same API as Vue's $watch, except when watching a function,
     * the function gets the state as the first argument.
     *
     * @param {Function} fn
     * @param {Function} cb
     * @param {Object} [options]
     */

  }, {
    key: 'watch',
    value: function watch(fn, cb, options) {
      var _this3 = this;

      if (typeof fn !== 'function') {
        console.error('Vuex store.watch only accepts function.');
        return;
      }
      return this._vm.$watch(function () {
        return fn(_this3.state);
      }, cb, options);
    }

    /**
     * Subscribe to state changes. Fires after every mutation.
     */

  }, {
    key: 'subscribe',
    value: function subscribe(fn) {
      var subs = this._subscribers;
      if (subs.indexOf(fn) < 0) {
        subs.push(fn);
      }
      return function () {
        var i = subs.indexOf(fn);
        if (i > -1) {
          subs.splice(i, 1);
        }
      };
    }

    /**
     * Hot update mutations & modules.
     *
     * @param {Object} options
     *        - {Object} [mutations]
     *        - {Object} [modules]
     */

  }, {
    key: 'hotUpdate',
    value: function hotUpdate() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          mutations = _ref2.mutations,
          modules = _ref2.modules;

      this._rootMutations = this._mutations = mutations || this._rootMutations;
      this._setupModuleMutations(modules || this._modules);
    }

    /**
     * Attach sub state tree of each module to the root tree.
     *
     * @param {Object} state
     * @param {Object} modules
     */

  }, {
    key: '_setupModuleState',
    value: function _setupModuleState(state, modules) {
      var _this4 = this;

      if (!isObject(modules)) return;

      Object.keys(modules).forEach(function (key) {
        var module = modules[key];

        // set this module's state
        Vue.set(state, key, module.state || {});

        // retrieve nested modules
        _this4._setupModuleState(state[key], module.modules);
      });
    }

    /**
     * Bind mutations for each module to its sub tree and
     * merge them all into one final mutations map.
     *
     * @param {Object} updatedModules
     */

  }, {
    key: '_setupModuleMutations',
    value: function _setupModuleMutations(updatedModules) {
      var modules = this._modules;
      Object.keys(updatedModules).forEach(function (key) {
        modules[key] = updatedModules[key];
      });
      var updatedMutations = this._createModuleMutations(modules, []);
      this._mutations = mergeObjects([this._rootMutations].concat(toConsumableArray(updatedMutations)));
    }

    /**
     * Helper method for _setupModuleMutations.
     * The method retrieve nested sub modules and
     * bind each mutations to its sub tree recursively.
     *
     * @param {Object} modules
     * @param {Array<String>} nestedKeys
     * @return {Array<Object>}
     */

  }, {
    key: '_createModuleMutations',
    value: function _createModuleMutations(modules, nestedKeys) {
      var _this5 = this;

      if (!isObject(modules)) return [];

      return Object.keys(modules).map(function (key) {
        var module = modules[key];
        var newNestedKeys = nestedKeys.concat(key);

        // retrieve nested modules
        var nestedMutations = _this5._createModuleMutations(module.modules, newNestedKeys);

        if (!module || !module.mutations) {
          return mergeObjects(nestedMutations);
        }

        // bind mutations to sub state tree
        var mutations = {};
        Object.keys(module.mutations).forEach(function (name) {
          var original = module.mutations[name];
          mutations[name] = function (state) {
            for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
              args[_key3 - 1] = arguments[_key3];
            }

            original.apply(undefined, [getNestedState(state, newNestedKeys)].concat(args));
          };
        });

        // merge mutations of this module and nested modules
        return mergeObjects([mutations].concat(toConsumableArray(nestedMutations)));
      });
    }

    /**
     * Setup mutation check: if the Vuex instance's state is mutated
     * outside of a mutation handler, we throw en error. This effectively
     * enforces all mutations to the state to be trackable and hot-reloadable.
     * However, this comes at a run time cost since we are doing a deep
     * watch on the entire state tree, so it is only enabled if the
     * strict option is set to true.
     */

  }, {
    key: '_setupMutationCheck',
    value: function _setupMutationCheck() {
      var _this6 = this;

      var Watcher = getWatcher(this._vm);
      /* eslint-disable no-new */
      new Watcher(this._vm, 'state', function () {
        if (!_this6._dispatching) {
          throw new Error('[vuex] Do not mutate vuex store state outside mutation handlers.');
        }
      }, { deep: true, sync: true });
      /* eslint-enable no-new */
    }
  }, {
    key: 'state',
    get: function get$$1() {
      return this._vm.state;
    },
    set: function set$$1(v) {
      throw new Error('[vuex] Use store.replaceState() to explicit replace store state.');
    }
  }]);
  return Store;
}();

function install(_Vue) {
  if (Vue) {
    console.warn('[vuex] already installed. Vue.use(Vuex) should be called only once.');
    return;
  }
  Vue = _Vue;
  override(Vue);
}

// auto install in dist mode
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

var index = {
  Store: Store,
  install: install
};

return index;

})));


/***/ }),
/* 196 */
/***/ (function(module, exports) {

module.exports = {"type":"Topology","arcs":[[[3051,1425],[-68,5]],[[2983,1430],[-16,0]],[[2967,1430],[6,87],[-4,31]],[[2969,1548],[82,-3],[0,-120]],[[3241,2502],[0,-64]],[[3241,2438],[10,18],[26,-35],[-36,-15],[-1,-36]],[[3240,2370],[-63,-27]],[[3177,2343],[-1,159]],[[3176,2502],[65,0]],[[3033,2954],[1,-118]],[[3034,2836],[-88,0]],[[2946,2836],[-12,11]],[[2934,2847],[-7,-3]],[[2927,2844],[1,101],[-5,8]],[[2923,2953],[110,1]],[[3714,3495],[-43,-80]],[[3671,3415],[-81,41]],[[3590,3456],[10,37]],[[3600,3493],[21,57]],[[3621,3550],[93,-55]],[[4982,3306],[-9,0]],[[4973,3306],[-93,-2]],[[4880,3304],[-43,44]],[[4837,3348],[-2,78],[123,0]],[[4958,3426],[1,43]],[[4959,3469],[56,-40],[0,-63],[-24,0],[1,-45],[-10,-15]],[[5208,3620],[-24,-71]],[[5184,3549],[-111,-1]],[[5073,3548],[3,52]],[[5076,3600],[0,94]],[[5076,3694],[55,-51],[59,-28],[18,5]],[[4608,3595],[1,-44]],[[4609,3551],[-232,-1]],[[4377,3550],[0,57],[41,-3],[42,83]],[[4460,3687],[57,71]],[[4517,3758],[91,-163]],[[4517,3758],[81,97],[10,0],[0,-260]],[[2821,2138],[-3,-14],[106,1]],[[2924,2125],[7,-40]],[[2931,2085],[-5,-5]],[[2926,2080],[-25,-44]],[[2901,2036],[-92,-20]],[[2809,2016],[-100,3]],[[2709,2019],[-21,68],[14,50]],[[2702,2137],[119,1]],[[2939,2252],[5,1]],[[2944,2253],[-19,-89],[-1,-39]],[[2821,2138],[-119,-1]],[[2702,2137],[71,236]],[[2773,2373],[190,0]],[[2963,2373],[-24,-121]],[[2216,1671],[0,-1]],[[2216,1670],[-23,3]],[[2193,1673],[-2,59]],[[2191,1732],[7,218],[0,48]],[[2198,1998],[283,1]],[[2481,1999],[-165,-253],[-23,-72],[-77,-3]],[[1876,84],[-66,0]],[[1810,84],[0,31]],[[1810,115],[0,31]],[[1810,146],[1,134],[34,14]],[[1845,294],[30,11]],[[1875,305],[1,-221]],[[2019,55],[-1,-13],[-208,16],[0,26]],[[1876,84],[-1,216]],[[1875,300],[47,18]],[[1922,318],[4,-22]],[[1926,296],[14,-33],[-32,-62],[-8,-87],[10,-19],[35,-23],[74,-17]],[[4960,3796],[0,-244],[-114,-1]],[[4846,3551],[-2,214],[-58,0],[1,-30],[-58,0]],[[4729,3735],[-1,60]],[[4728,3795],[-120,0]],[[4608,3795],[0,189],[13,36],[108,-55],[150,-1],[0,-169],[81,1]],[[3934,811],[6,33],[27,52]],[[3967,896],[9,-2]],[[3976,894],[-16,-48],[27,-46],[85,-41],[63,-16]],[[4135,743],[33,-54]],[[4168,689],[-23,-38],[-211,160]],[[3672,1243],[-116,0]],[[3556,1243],[0,60]],[[3556,1303],[116,0]],[[3672,1303],[0,-60]],[[3239,1182],[0,121]],[[3239,1303],[58,0]],[[3297,1303],[0,-121]],[[3297,1182],[-58,0]],[[3239,1182],[-97,0]],[[3142,1182],[0,121]],[[3142,1303],[97,0]],[[3278,1079],[-12,-51]],[[3266,1028],[-19,-59]],[[3247,969],[8,6]],[[3255,975],[25,-36],[-19,-47]],[[3261,892],[-28,-12],[-35,-89]],[[3198,791],[-5,2]],[[3193,793],[-97,46],[-23,16],[-3,24],[-30,23]],[[3040,902],[-40,26],[-41,66]],[[2959,994],[-1,91]],[[2958,1085],[44,0]],[[3002,1085],[15,-4]],[[3017,1081],[257,0]],[[3274,1081],[4,-2]],[[1598,2042],[-2,0]],[[1596,2042],[1,-67]],[[1597,1975],[-55,18],[1,127],[-206,-2]],[[1337,2118],[-2,266]],[[1335,2384],[132,1],[21,3]],[[1488,2388],[106,-2]],[[1594,2386],[1,-183],[3,-161]],[[1023,2566],[189,-176]],[[1212,2390],[18,-5],[105,-1]],[[1337,2118],[-216,-3]],[[1121,2115],[3,128]],[[1124,2243],[0,107],[-6,55]],[[1118,2405],[-113,1]],[[1005,2406],[2,160]],[[1007,2566],[16,0]],[[1250,2811],[0,121]],[[1250,2932],[115,46]],[[1365,2978],[0,-167]],[[1365,2811],[-115,0]],[[1122,2878],[128,54]],[[1250,2811],[-90,0],[-38,67]],[[582,2076],[-2,-11],[7,-139]],[[587,1926],[-5,-33]],[[582,1893],[2,-27],[-33,-27],[-48,14]],[[503,1853],[-4,224]],[[499,2077],[83,-1]],[[499,2077],[-3,162]],[[496,2239],[26,6],[27,-12],[-6,62],[36,2]],[[579,2297],[11,-166],[-8,-55]],[[496,2239],[-1,39],[-73,191]],[[422,2469],[97,42]],[[519,2511],[38,-159],[22,-55]],[[422,2469],[-60,159],[32,7],[28,31],[47,12],[15,-9]],[[484,2669],[35,-158]],[[349,2892],[18,-9]],[[367,2883],[15,-44],[25,-29],[20,-41],[26,-95]],[[453,2674],[-36,-10],[-21,-28],[-28,-7]],[[368,2629],[-7,25],[24,6],[-18,58],[-47,65],[-29,69],[2,12]],[[293,2864],[56,28]],[[349,2892],[-23,3]],[[326,2895],[-59,-17]],[[267,2878],[-45,118]],[[222,2996],[66,33]],[[288,3029],[44,-56],[25,-43],[10,-47]],[[285,3139],[-14,-10],[-13,-36],[30,-64]],[[222,2996],[-124,296]],[[98,3292],[14,-28]],[[112,3264],[81,33],[32,0]],[[225,3297],[2,-46],[14,-52],[44,-60]],[[2256,2375],[76,0]],[[2332,2375],[8,-30],[0,-73],[-56,-2],[0,-84],[172,0],[0,63],[37,2],[244,-2]],[[2737,2249],[-69,-226],[-71,5]],[[2597,2028],[-187,0]],[[2410,2028],[-22,5],[-36,26],[-150,195]],[[2202,2254],[8,32],[-4,33],[-23,48]],[[2183,2367],[-2,21]],[[2181,2388],[75,-13]],[[3275,3202],[10,-60],[22,2],[-33,-61]],[[3274,3083],[-23,1]],[[3251,3084],[-2,57],[-35,0]],[[3214,3141],[-7,-56]],[[3207,3085],[-40,-6],[-61,-1]],[[3106,3078],[-7,123]],[[3099,3201],[176,1]],[[3053,3256],[3,-56]],[[3056,3200],[43,1]],[[3106,3078],[-93,-1]],[[3013,3077],[-7,123]],[[3006,3200],[14,0]],[[3020,3200],[-3,55]],[[3017,3255],[36,1]],[[4147,2136],[0,-227]],[[4147,1909],[-230,0]],[[3917,1909],[0,104]],[[3917,2013],[-227,0],[1,42]],[[3691,2055],[-42,0]],[[3649,2055],[0,21],[45,11],[16,48]],[[3710,2135],[323,-1]],[[4033,2134],[2,2]],[[4035,2136],[112,0]],[[3355,2136],[0,152]],[[3355,2288],[116,79],[45,14]],[[3516,2381],[0,-245]],[[3516,2136],[-161,0]],[[3355,2288],[-10,128]],[[3345,2416],[101,44],[24,0],[-1,41]],[[3469,2501],[45,2]],[[3514,2503],[2,0]],[[3516,2503],[0,-122]],[[3183,2876],[-65,-12],[2,-15],[-52,-28],[-41,-12],[-59,5]],[[2968,2814],[0,22]],[[2968,2836],[66,0]],[[3034,2836],[-1,119],[162,1]],[[3195,2956],[-12,-80]],[[1641,1253],[-29,-4]],[[1612,1249],[-22,-5]],[[1590,1244],[-6,49]],[[1584,1293],[16,4]],[[1600,1297],[0,78],[59,-1]],[[1659,1374],[0,-23]],[[1659,1351],[46,-25],[44,-31]],[[1749,1295],[-10,-21]],[[1739,1274],[-18,-12],[-80,-9]],[[990,2812],[-87,0]],[[903,2812],[0,121]],[[903,2933],[119,1]],[[1022,2934],[0,-96]],[[1022,2838],[-32,-26]],[[903,2933],[0,122]],[[903,3055],[119,-1]],[[1022,3054],[0,-120]],[[1127,3176],[8,-21]],[[1135,3155],[0,-100]],[[1135,3055],[-113,-1]],[[1022,3054],[0,122]],[[1022,3176],[105,0]],[[1022,3176],[4,111]],[[1026,3287],[8,19],[101,0]],[[1135,3306],[0,-108]],[[1135,3198],[-8,-22]],[[1595,3055],[0,122]],[[1595,3177],[115,-1]],[[1710,3176],[1,-49],[14,-32]],[[1725,3095],[-2,-40],[-128,0]],[[1595,3177],[0,121]],[[1595,3298],[116,0]],[[1711,3298],[-1,-122]],[[1828,3661],[-1,-121]],[[1827,3540],[-231,0]],[[1596,3540],[0,127]],[[1596,3667],[155,-1],[77,-5]],[[1828,3742],[0,-81]],[[1596,3667],[1,115]],[[1597,3782],[231,1]],[[1828,3783],[0,-41]],[[1255,3680],[110,3]],[[1365,3683],[-1,-264]],[[1364,3419],[-114,0]],[[1250,3419],[0,122],[-116,-1]],[[1134,3540],[0,121]],[[1134,3661],[109,7]],[[1243,3668],[-8,18]],[[1235,3686],[20,-6]],[[1250,3419],[-115,0],[-1,121]],[[673,3514],[4,25]],[[677,3539],[110,-1]],[[787,3538],[-3,-61]],[[784,3477],[2,-232],[16,-36],[36,-33]],[[838,3176],[-165,0],[0,338]],[[1760,3782],[6,62],[0,91]],[[1766,3935],[60,-3]],[[1826,3932],[2,-149]],[[1828,3783],[-68,-1]],[[4253,2810],[1,-120]],[[4254,2690],[-77,0],[0,57]],[[4177,2747],[-39,0]],[[4138,2747],[-1,157]],[[4137,2904],[31,0]],[[4168,2904],[0,35],[74,-56]],[[4242,2883],[18,-5]],[[4260,2878],[15,-69]],[[4275,2809],[-22,1]],[[4138,2747],[-3,0]],[[4135,2747],[-102,1]],[[4033,2748],[-1,157]],[[4032,2905],[105,1]],[[4137,2906],[1,-159]],[[3687,2747],[-1,133],[116,2]],[[3802,2882],[-1,-135],[-114,0]],[[3686,2928],[58,0]],[[3744,2928],[0,159]],[[3744,3087],[56,0]],[[3800,3087],[2,-205]],[[3802,2882],[-115,-2],[-1,48]],[[1861,913],[16,-13]],[[1877,900],[-35,-55]],[[1842,845],[-1,-23]],[[1841,822],[-23,0]],[[1818,822],[-1,66],[-61,2],[-52,-5]],[[1704,885],[-13,49]],[[1691,934],[-95,0],[0,37],[-34,6]],[[1562,977],[12,53]],[[1574,1030],[224,1],[-1,8],[156,-1]],[[1953,1038],[-14,-36]],[[1939,1002],[-26,-37],[-52,-52]],[[3916,3087],[25,0]],[[3941,3087],[184,-120]],[[4125,2967],[-208,-1],[-1,121]],[[4137,2904],[0,2]],[[4137,2906],[-220,-1]],[[3917,2905],[-1,61],[209,1]],[[4125,2967],[43,-28],[0,-35]],[[4136,3088],[1,-128]],[[4137,2960],[-106,68]],[[4031,3028],[0,14]],[[4031,3042],[44,-27]],[[4075,3015],[0,73]],[[4075,3088],[61,0]],[[4075,3088],[-1,121]],[[4074,3209],[72,1]],[[4146,3210],[-2,-31]],[[4144,3179],[-8,-30],[0,-61]],[[3671,3415],[-14,-26]],[[3657,3389],[101,-60]],[[3758,3329],[-188,-3]],[[3570,3326],[-1,115]],[[3569,3441],[15,-9]],[[3584,3432],[6,24]],[[1984,3966],[-1,-61]],[[1983,3905],[-157,-1]],[[1826,3904],[0,69],[120,0],[38,-7]],[[2332,2375],[441,-2]],[[2773,2373],[-36,-124]],[[1931,1421],[22,-11],[14,-141],[-19,-20]],[[1948,1249],[9,-30]],[[1957,1219],[2,-42],[24,-6]],[[1983,1171],[-5,-66],[-25,-67]],[[1574,1030],[25,113],[-9,101]],[[1612,1249],[29,4]],[[1641,1253],[77,8],[21,13]],[[1749,1295],[24,-18]],[[1773,1277],[-20,33],[-4,25]],[[1749,1335],[11,35]],[[1760,1370],[66,74]],[[1826,1444],[96,-4],[9,-19]],[[837,961],[23,-44],[37,-11],[81,-46],[12,-70],[14,-16],[-47,-64],[4,-23],[21,-33],[30,34],[33,-36],[56,-22],[18,46],[67,-38],[23,47],[0,34],[21,3]],[[1230,722],[50,-1]],[[1280,721],[3,-25]],[[1283,696],[11,-36],[-15,-34],[-38,9]],[[1241,635],[-8,-6]],[[1233,629],[6,-20]],[[1239,609],[30,-3],[38,-22],[-1,-16],[-33,-32],[-34,-8]],[[1239,528],[-5,-27]],[[1234,501],[26,-21],[-3,-23],[33,-27],[10,-30],[-48,-8],[-32,26]],[[1220,418],[35,-36]],[[1255,382],[68,0]],[[1323,382],[-46,-94]],[[1277,288],[-3,-11]],[[1274,277],[-283,186],[-77,75],[-325,77],[-154,-92],[-193,102],[-40,95]],[[202,720],[95,31],[22,-5]],[[319,746],[18,-25]],[[337,721],[-1,-26],[21,-18],[63,16],[27,17]],[[447,710],[43,46],[-5,24],[-37,18],[-11,23],[25,89]],[[462,910],[16,32]],[[478,942],[33,-22],[21,-38]],[[532,882],[25,-3],[32,23]],[[589,902],[18,8],[100,8],[59,45]],[[766,963],[55,19]],[[821,982],[23,-15]],[[844,967],[-7,-6]],[[377,1010],[8,0]],[[385,1010],[23,-5],[38,-39],[43,-3]],[[489,963],[-27,-53]],[[462,910],[-25,-85],[15,-30],[29,-12],[9,-30],[-43,-43]],[[447,710],[-68,-29],[-33,1],[-9,39]],[[337,721],[-18,25]],[[202,720],[-97,233]],[[105,953],[48,12],[189,32]],[[342,997],[0,26]],[[342,1023],[35,-13]],[[5305,3550],[3,184]],[[5308,3734],[62,-54],[130,-103]],[[5500,3577],[-5,-8]],[[5495,3569],[0,-17]],[[5495,3552],[-190,-2]],[[5207,3550],[-23,-1]],[[5184,3549],[31,92]],[[5215,3641],[2,38],[-28,129]],[[5189,3808],[1,30]],[[5190,3838],[118,-104]],[[5305,3550],[-98,0]],[[5076,3694],[0,102],[59,0],[4,85],[51,-43]],[[5189,3808],[29,-140],[-3,-27]],[[5215,3641],[-7,-21]],[[268,1185],[59,-17],[6,19]],[[333,1187],[0,43]],[[333,1230],[-7,42],[13,20]],[[339,1292],[2,-9]],[[341,1283],[1,-286]],[[105,953],[-91,219],[66,122],[42,52]],[[122,1346],[17,-13],[-27,-42],[44,-6],[56,-23],[12,-17],[61,23],[9,-19],[-6,-48],[-20,-16]],[[380,1498],[21,-4],[94,35],[9,-31],[39,-16],[34,-32]],[[577,1450],[15,-5],[-31,-155]],[[561,1290],[-220,-1]],[[341,1289],[0,-6]],[[341,1283],[-2,9]],[[339,1292],[-14,-15],[8,-47]],[[333,1187],[-9,-20],[-56,18]],[[122,1346],[116,141]],[[238,1487],[60,-2],[31,13],[12,-19]],[[341,1479],[9,41],[51,10]],[[401,1530],[-24,-26]],[[377,1504],[-8,-13]],[[369,1491],[11,7]],[[898,1664],[141,-150],[-213,0]],[[826,1514],[-3,-11]],[[823,1503],[-20,-6]],[[803,1497],[-14,11],[-103,1],[-43,-24],[-43,-1]],[[600,1484],[-8,-39],[-15,5]],[[380,1498],[-11,-7]],[[377,1504],[24,26]],[[401,1530],[-34,0],[-19,-14],[-7,-37]],[[238,1487],[86,111],[141,68],[215,-3],[218,1]],[[995,1700],[83,-43],[14,-11]],[[1092,1646],[130,-134]],[[1222,1512],[54,-50]],[[1276,1462],[-33,-25],[-40,-16],[-44,-34]],[[1159,1387],[-177,188]],[[982,1575],[43,11],[-64,87],[33,-4],[1,31]],[[1368,1420],[0,-18]],[[1368,1402],[-21,-21]],[[1347,1381],[0,-34]],[[1347,1347],[-25,0],[-1,-80],[-50,1],[-112,119]],[[1276,1462],[42,-36],[50,-6]],[[794,1818],[-41,-17],[-52,-33],[-85,10],[-40,-23],[-20,-30],[-16,2],[-20,-34],[-4,-28]],[[516,1665],[-50,1],[37,187]],[[582,1893],[2,22]],[[584,1915],[31,-11]],[[615,1904],[41,-31],[73,-17]],[[729,1856],[65,-38]],[[4602,3429],[-52,4]],[[4550,3433],[-3,-7]],[[4547,3426],[-64,-19]],[[4483,3407],[0,80],[9,4],[0,60]],[[4492,3551],[117,0]],[[4609,3551],[0,-98],[-7,-24]],[[4373,3375],[4,28]],[[4377,3403],[0,147]],[[4377,3550],[115,1]],[[4483,3407],[-110,-32]],[[3610,3556],[-57,34]],[[3553,3590],[11,38],[22,37],[34,40]],[[3620,3705],[110,179]],[[3730,3884],[56,-37]],[[3786,3847],[-176,-291]],[[3730,3884],[-82,-133]],[[3648,3751],[-78,50]],[[3570,3801],[-19,-53],[-13,5]],[[3538,3753],[-13,62],[-21,2],[-14,40],[2,53],[48,60],[96,-59],[14,27],[80,-54]],[[4219,3655],[-7,-20],[4,-85]],[[4216,3550],[-70,0],[-1,122]],[[4145,3672],[-115,0],[-1,152]],[[4029,3824],[21,37]],[[4050,3861],[162,-103],[38,-30],[-31,-73]],[[4145,3672],[1,-121],[-279,-1]],[[3867,3550],[162,274]],[[5768,3330],[-2,-19]],[[5766,3311],[-230,-1]],[[5536,3310],[-1,242]],[[5535,3552],[38,-2]],[[5573,3550],[24,21],[36,13],[14,15]],[[5647,3599],[-2,52]],[[5645,3651],[81,24]],[[5726,3675],[40,0]],[[5766,3675],[2,-345]],[[2563,2824],[16,-259]],[[2579,2565],[-209,-8]],[[2370,2557],[-37,10],[-167,0],[-2,-5]],[[2164,2562],[-1,236]],[[2163,2798],[3,19]],[[2166,2817],[158,8]],[[2324,2825],[86,-6],[153,5]],[[2722,3596],[22,-183]],[[2744,3413],[-4,-2]],[[2740,3411],[-28,5],[-34,-9]],[[2678,3407],[-78,190],[122,-1]],[[4303,3801],[187,0],[9,-6]],[[4499,3795],[20,-36],[-59,-72]],[[4377,3550],[-161,0]],[[4219,3655],[55,134],[29,12]],[[2791,3075],[-15,124]],[[2776,3199],[230,1]],[[3013,3077],[-222,-2]],[[2041,1910],[156,6]],[[2197,1916],[-6,-184],[-151,-6],[1,184]],[[2127,3298],[31,0]],[[2158,3298],[57,8],[115,6],[24,-116]],[[2354,3196],[-62,-2],[-37,-6],[-59,-35]],[[2196,3153],[-43,-1],[-26,146]],[[1479,3298],[-115,0]],[[1364,3298],[0,242]],[[1364,3540],[231,0]],[[1595,3540],[1,-121],[-116,0],[-1,-121]],[[1595,3298],[0,-16]],[[1595,3282],[-58,0]],[[1537,3282],[0,16]],[[1537,3298],[-58,0]],[[1595,3540],[232,0]],[[1827,3540],[0,-121]],[[1827,3419],[-63,0]],[[1764,3419],[4,-61],[-57,0]],[[1711,3358],[0,-60]],[[787,3538],[117,2]],[[904,3540],[-1,-324]],[[903,3216],[-104,-2],[-15,48],[0,215]],[[1364,3177],[-115,-1]],[[1249,3176],[0,122]],[[1249,3298],[115,0]],[[1364,3298],[0,-121]],[[442,3782],[-2,-31]],[[440,3751],[0,-91]],[[440,3660],[-198,0]],[[242,3660],[-3,131]],[[239,3791],[124,1],[79,-10]],[[1712,3782],[-115,0]],[[1597,3782],[-1,152]],[[1596,3934],[116,1]],[[1712,3935],[0,-153]],[[1249,3176],[-122,0]],[[1135,3198],[0,100]],[[1135,3298],[114,0]],[[1021,3292],[1,-238]],[[903,3055],[0,121]],[[903,3176],[-65,0]],[[838,3176],[-39,38],[104,2]],[[903,3216],[1,74]],[[904,3290],[30,0],[6,15],[65,-1],[16,-12]],[[1479,3024],[-114,-46]],[[1365,2978],[-1,199]],[[1364,3177],[115,0],[0,-153]],[[3127,3860],[-11,-3]],[[3116,3857],[-112,15]],[[3004,3872],[11,126]],[[3015,3998],[175,-24],[-11,-122],[-52,8]],[[3804,3440],[63,110]],[[3867,3550],[349,0]],[[4216,3550],[5,-58],[15,-62]],[[4236,3430],[-328,-2],[-46,-12],[-21,3],[-37,21]],[[1031,2841],[-9,-6]],[[1022,2835],[0,219]],[[1135,3055],[0,-171]],[[1135,2884],[-104,-43]],[[961,3965],[0,-61]],[[961,3904],[-174,0]],[[787,3904],[0,82]],[[787,3986],[12,-22],[162,1]],[[1719,2954],[7,174]],[[1726,3128],[24,9],[75,3]],[[1825,3140],[6,-182]],[[1831,2958],[-112,-4]],[[1836,2809],[-106,2]],[[1730,2811],[0,29],[-12,64]],[[1718,2904],[1,50]],[[1719,2954],[112,4]],[[1831,2958],[5,-149]],[[1836,2809],[5,-105],[-19,-14],[-81,0],[0,14],[47,1],[2,68],[-64,0],[-2,-81],[-130,-1]],[[1594,2691],[1,120]],[[1595,2811],[241,-2]],[[1594,3074],[1,-19]],[[1595,3055],[129,0],[-6,-121]],[[1718,2934],[-124,-1],[0,31],[-57,0]],[[1537,2964],[0,88]],[[1537,3052],[57,22]],[[1718,2934],[0,-30]],[[1730,2811],[-193,0]],[[1537,2811],[0,153]],[[1365,2978],[-230,-94]],[[1135,2884],[0,271]],[[1127,3176],[237,1]],[[1365,2811],[0,-135]],[[1365,2676],[-128,48]],[[1237,2724],[-52,43]],[[1185,2767],[-26,44],[206,0]],[[1594,2569],[-457,0]],[[1137,2569],[-2,258],[-7,22]],[[1128,2849],[57,-82]],[[1237,2724],[306,-116]],[[1543,2608],[51,-12]],[[1594,2596],[0,-27]],[[774,2223],[0,39]],[[774,2262],[94,-1],[1,24]],[[869,2285],[20,31],[1,91]],[[890,2407],[115,-1]],[[1005,2406],[1,-184]],[[1006,2222],[-232,1]],[[890,2407],[-197,-1]],[[693,2406],[-16,107],[44,16]],[[721,2529],[-6,39]],[[715,2568],[134,0]],[[849,2568],[0,-23]],[[849,2545],[13,-36]],[[862,2509],[24,-38]],[[886,2471],[4,-64]],[[886,2471],[-24,38]],[[862,2509],[-13,36]],[[849,2568],[156,1]],[[1005,2569],[-1,-3]],[[1004,2566],[3,0]],[[1007,2566],[-2,-160]],[[1787,283],[-117,1]],[[1670,284],[0,106]],[[1670,390],[117,-1]],[[1787,389],[0,-106]],[[1845,294],[-29,-11]],[[1816,283],[-29,0]],[[1787,389],[88,0]],[[1875,389],[0,-84]],[[1759,556],[0,-45]],[[1759,511],[117,-1]],[[1876,510],[-1,-45]],[[1875,465],[-175,0]],[[1700,465],[0,90]],[[1700,555],[59,1]],[[1700,390],[0,75]],[[1875,465],[0,-76]],[[1875,389],[-175,1]],[[1659,617],[-58,0],[0,31]],[[1601,648],[-14,0]],[[1587,648],[6,103]],[[1593,751],[34,1],[3,34],[130,1]],[[1760,787],[0,-28]],[[1760,759],[-30,0],[0,-98]],[[1730,661],[-37,-14],[-5,-67],[-29,11],[0,26]],[[1588,705],[-1,-57]],[[1601,648],[-6,-29]],[[1595,619],[-1,-62]],[[1594,557],[-29,-1],[-6,-19]],[[1559,537],[-33,-3]],[[1526,534],[-41,-1]],[[1485,533],[-8,8]],[[1477,541],[-10,41]],[[1467,582],[-17,34],[21,19]],[[1471,635],[0,71]],[[1471,706],[117,-1]],[[2303,1120],[-28,-14],[-41,-38]],[[2234,1068],[-11,45]],[[2223,1113],[-13,195]],[[2210,1308],[61,1]],[[2271,1309],[176,15]],[[2447,1324],[20,15]],[[2467,1339],[-31,-75],[-51,-73],[-43,-43],[-39,-28]],[[1770,1557],[-1,-114]],[[1769,1443],[57,1]],[[1760,1370],[-11,-35]],[[1773,1277],[-57,41]],[[1716,1318],[1,239]],[[1717,1557],[53,0]],[[2047,1436],[11,-187]],[[2058,1249],[-110,-8]],[[1948,1241],[0,8]],[[1931,1421],[-10,20],[63,-8],[63,3]],[[3004,3872],[-31,4]],[[2973,3876],[0,-2]],[[2973,3874],[-76,11]],[[2897,3885],[4,46],[-43,6],[9,81]],[[2867,4018],[148,-20]],[[3061,3865],[55,-8]],[[3127,3860],[156,-20],[-14,-60],[-10,-1]],[[3259,3779],[-40,-122]],[[3219,3657],[-53,21],[18,44],[-122,44]],[[3062,3766],[11,33]],[[3073,3799],[-18,2]],[[3055,3801],[6,64]],[[4818,1997],[-9,-31],[-30,-1]],[[4779,1965],[2,31],[-41,-1]],[[4740,1995],[-2,124]],[[4738,2119],[112,2]],[[4850,2121],[3,-122]],[[4853,1999],[-35,-2]],[[4907,2241],[-170,1]],[[4737,2242],[-1,122]],[[4736,2364],[175,1],[-4,-124]],[[4738,2119],[-131,1]],[[4607,2120],[-2,243]],[[4605,2363],[131,1]],[[4736,2364],[2,-245]],[[2600,3597],[78,-190]],[[2678,3407],[-9,-6]],[[2669,3401],[-34,-11]],[[2635,3390],[-73,-25]],[[2562,3365],[0,130],[-22,0],[-17,42]],[[2523,3537],[0,60]],[[2523,3597],[77,0]],[[4380,2361],[167,2]],[[4547,2363],[0,61],[57,0]],[[4604,2424],[2,-183]],[[4606,2241],[-145,-1]],[[4461,2240],[-28,-5],[-53,126]],[[3750,2730],[-1,-128]],[[3749,2602],[-176,-2]],[[3573,2600],[-1,143]],[[3572,2743],[28,-7],[87,6]],[[3687,2742],[0,5]],[[3687,2747],[61,1]],[[3748,2748],[2,-18]],[[4034,2602],[-116,0]],[[3918,2602],[-1,145]],[[3917,2747],[116,1]],[[4033,2748],[1,-146]],[[869,2285],[0,-23],[-95,0]],[[774,2223],[-13,0]],[[761,2223],[-15,6]],[[746,2229],[-27,15]],[[719,2244],[-26,162]],[[761,2223],[128,-1]],[[889,2222],[14,-117],[20,-72]],[[923,2033],[-148,14]],[[775,2047],[-26,10]],[[749,2057],[-30,187]],[[719,2244],[27,-15]],[[1337,2118],[2,-157]],[[1339,1961],[-180,45],[-38,7]],[[1121,2013],[0,102]],[[1121,2013],[-198,20]],[[889,2222],[233,-1]],[[1122,2221],[-1,-208]],[[1599,1631],[1,-73]],[[1600,1558],[-23,6]],[[1577,1564],[-39,24],[-193,105],[0,16]],[[1345,1709],[107,1]],[[1452,1710],[0,12]],[[1452,1722],[108,0],[0,-91],[39,0]],[[1040,1859],[-117,77]],[[923,1936],[1,96]],[[924,2032],[111,-10]],[[1035,2022],[6,-36],[-1,-127]],[[1597,1975],[0,-96]],[[1597,1879],[-76,35]],[[1521,1914],[-182,47]],[[775,2047],[149,-15]],[[924,2032],[-1,-153]],[[923,1879],[-23,-1],[-106,-60]],[[794,1818],[-65,36],[0,198]],[[729,2052],[20,5]],[[2047,1436],[-92,0]],[[1955,1436],[-47,99]],[[1908,1535],[-14,20]],[[1894,1555],[47,10],[102,6]],[[2043,1571],[4,-135]],[[1717,1418],[-1,-100]],[[1716,1318],[-57,33]],[[1659,1374],[-59,1],[0,22]],[[1600,1397],[0,21]],[[1600,1418],[117,0]],[[4271,822],[-87,118],[-18,37]],[[4166,977],[20,27],[113,37]],[[4299,1041],[13,13]],[[4312,1054],[5,109]],[[4317,1163],[84,0]],[[4401,1163],[49,-98],[18,-63],[4,-82]],[[4472,920],[-89,-1],[-28,-48],[-73,-71],[-11,22]],[[4453,1352],[-13,14],[55,137],[1,22]],[[4496,1525],[-14,365],[-26,227]],[[4456,2117],[151,0],[0,-7]],[[4607,2110],[-13,-18],[13,-68]],[[4607,2024],[5,-64]],[[4612,1960],[0,-259]],[[4612,1701],[-42,-53],[-24,-109],[-93,-187]],[[1023,2566],[18,3]],[[1041,2569],[553,0]],[[1594,2569],[0,-183]],[[1488,2388],[-58,-4],[-205,2],[-13,4]],[[1955,3652],[-3,-112]],[[1952,3540],[-125,0]],[[1828,3661],[137,1]],[[1965,3662],[-10,-10]],[[1951,3419],[-124,0]],[[1952,3540],[-1,-121]],[[1831,3171],[-5,-6]],[[1826,3165],[0,254],[125,0]],[[1951,3419],[0,-198]],[[1951,3221],[-120,-50]],[[2686,3886],[16,-129]],[[2702,3757],[-63,-7]],[[2639,3750],[-8,45]],[[2631,3795],[23,94]],[[2654,3889],[32,-3]],[[2907,3568],[10,0]],[[2917,3568],[5,-110]],[[2922,3458],[-65,26]],[[2857,3484],[-1,-7]],[[2856,3477],[-40,-6],[-16,136]],[[2800,3607],[20,7],[29,-22],[30,-10]],[[2879,3582],[28,-14]],[[2904,3884],[69,-10]],[[2973,3876],[88,-11]],[[3055,3801],[-31,1],[-52,-27],[-65,5]],[[2907,3780],[-18,-4]],[[2889,3776],[-27,105]],[[2862,3881],[41,-5]],[[2903,3876],[1,8]],[[2910,3684],[7,-116]],[[2907,3568],[-28,14]],[[2800,3607],[-2,15]],[[2798,3622],[-21,16],[-60,0],[-2,14],[-56,-7]],[[2659,3645],[-20,105]],[[2702,3757],[-1,4]],[[2701,3761],[39,2]],[[2740,3763],[63,-19]],[[2803,3744],[107,-60]],[[2897,3885],[7,-1]],[[2903,3876],[-50,7],[-13,64],[-15,35],[-6,43],[48,-7]],[[4135,2747],[42,0]],[[4254,2690],[2,-122]],[[4256,2568],[-122,1],[-62,32]],[[4072,2601],[-38,1]],[[4033,2748],[102,-1]],[[4036,2381],[-2,0]],[[4034,2381],[0,221]],[[4072,2601],[68,-33]],[[4140,2568],[1,-64],[8,-124]],[[4149,2380],[-113,1]],[[3641,2381],[-125,0]],[[3516,2503],[57,0]],[[3573,2503],[0,-10],[67,1],[1,-113]],[[3803,2601],[0,-219]],[[3803,2382],[-162,-1]],[[3573,2503],[58,0]],[[3631,2503],[-1,52],[-19,0]],[[3611,2555],[0,45],[192,1]],[[4036,2255],[0,126]],[[4036,2381],[228,-1]],[[4264,2380],[0,-125],[-228,0]],[[3609,2136],[1,77],[9,19],[0,69],[20,51],[2,29]],[[3803,2382],[-1,-247]],[[3802,2135],[-193,1]],[[3803,2601],[-54,1]],[[3750,2730],[-2,18]],[[3748,2748],[169,-1]],[[3918,2602],[-115,-1]],[[4035,2136],[1,119]],[[4036,2255],[228,0],[-1,-119]],[[4263,2136],[-228,0]],[[4740,1982],[-38,-3]],[[4702,1979],[-95,35]],[[4607,2014],[0,10]],[[4607,2110],[0,10]],[[4738,2119],[2,-137]],[[3340,3021],[0,-59]],[[3340,2962],[116,2]],[[3456,2964],[0,-122],[-205,-1]],[[3251,2841],[-27,-4]],[[3224,2837],[2,92],[-20,47]],[[3206,2976],[5,46]],[[3211,3022],[129,-1]],[[5666,3115],[-88,64],[-29,54],[-13,77]],[[5766,3311],[-6,-18],[-70,-142],[-24,-36]],[[5703,3067],[-19,29]],[[5684,3096],[-18,19]],[[5766,3311],[116,0]],[[5882,3311],[4,-122],[-115,0],[-1,-122],[-67,0]],[[5311,2818],[-1,3],[-4,487]],[[5306,3308],[75,-4]],[[5381,3304],[31,-13],[49,-32]],[[5461,3259],[49,-20],[27,-1]],[[5537,3238],[1,-163],[-10,-9]],[[5528,3066],[129,-92],[0,-28],[-117,1],[0,-127],[-229,-2]],[[5436,3275],[-55,29]],[[5306,3308],[-1,242]],[[5305,3550],[135,1]],[[5440,3551],[0,-22],[-18,-40],[0,-35],[30,-99],[0,-48],[-16,-32]],[[5537,3238],[11,1]],[[5548,3239],[7,-27],[31,-40],[83,-59],[15,-17]],[[5703,3067],[-47,0],[1,-92],[-129,91]],[[5306,3308],[-68,-1],[-20,20],[-28,10],[-1,183],[19,0]],[[5208,3520],[-1,30],[98,0]],[[2717,1671],[-36,-75],[-38,-126]],[[2643,1470],[-99,132],[-278,-17]],[[2266,1585],[44,151],[171,264],[9,27]],[[2490,2027],[107,1]],[[2597,2028],[72,-5],[-6,-21]],[[2663,2002],[6,-3],[35,-221]],[[2704,1778],[17,-50],[-4,-57]],[[443,3591],[1,-51]],[[444,3540],[-202,-1]],[[242,3539],[0,51],[-31,0],[0,47],[31,0],[0,23]],[[440,3660],[3,-69]],[[2650,3074],[-43,67],[-45,56]],[[2562,3197],[214,2]],[[2791,3075],[-141,-1]],[[2184,1580],[-141,-9]],[[2043,1571],[-3,155],[151,6]],[[2193,1673],[-8,0]],[[2185,1673],[-1,-93]],[[4447,2190],[7,-61]],[[4454,2129],[-54,6],[-137,1]],[[4263,2136],[1,244]],[[4264,2380],[44,-1],[72,-18]],[[4380,2361],[46,-104],[21,-67]],[[3572,2743],[-1,99],[116,0]],[[3687,2842],[0,-100]],[[3154,2625],[86,4]],[[3240,2629],[0,-64]],[[3240,2565],[-13,-8],[-156,-1],[-10,41]],[[3061,2597],[32,64],[61,-36]],[[4738,2119],[-1,123]],[[4907,2241],[3,-58],[-23,-11],[-37,-51]],[[3573,2600],[-116,-1]],[[3457,2599],[0,31]],[[3457,2630],[-90,-1]],[[3367,2629],[0,91],[32,0],[-1,121]],[[3398,2841],[173,1],[2,-242]],[[3183,2876],[-8,-39]],[[3175,2837],[-18,-48]],[[3157,2789],[-96,-192]],[[3061,2597],[-10,44],[-38,-59]],[[3013,2582],[13,30]],[[3026,2612],[-32,4],[-37,154],[11,1]],[[2968,2771],[0,43]],[[3367,2629],[-127,0]],[[3240,2629],[0,60]],[[3240,2689],[-16,148]],[[3251,2841],[147,0]],[[3631,2503],[-117,0]],[[3469,2501],[-11,30]],[[3458,2531],[-1,68]],[[3457,2599],[154,1],[0,-45]],[[3154,2625],[-61,36],[64,128]],[[3175,2837],[20,119]],[[3195,2956],[7,0]],[[3202,2956],[4,20]],[[3206,2976],[20,-51],[-2,-99],[16,-137]],[[3345,2416],[-2,27],[-1,186]],[[3342,2629],[115,1]],[[3457,2630],[1,-99]],[[3240,2565],[1,-63]],[[3241,2502],[-203,-1]],[[3038,2501],[-22,2],[45,94]],[[5207,3550],[1,-30]],[[5306,3308],[3,-333]],[[5309,2975],[-129,86],[-223,-2]],[[4957,3059],[1,124]],[[4958,3183],[-103,0],[-11,6]],[[4844,3189],[0,115]],[[4844,3304],[36,0]],[[4880,3304],[52,-46],[143,-96],[0,23],[56,0],[1,61],[-29,-1]],[[5103,3245],[0,62],[-121,-1]],[[4959,3469],[-3,7]],[[4956,3476],[0,-5]],[[4956,3471],[-24,17],[-44,63]],[[4888,3551],[54,2],[62,-5],[203,2]],[[242,3539],[-146,-1],[0,61],[-29,0],[0,30],[-29,0],[0,31],[204,0]],[[1729,1651],[-2,29],[-39,36]],[[1688,1716],[-73,-2]],[[1615,1714],[-17,69],[-1,96]],[[1597,1879],[141,-67]],[[1738,1812],[-9,-161]],[[2832,3199],[-56,0]],[[2776,3199],[-14,123]],[[2762,3322],[63,0]],[[2825,3322],[7,-123]],[[1020,3661],[1,-121]],[[1021,3540],[-117,0]],[[904,3540],[-1,61],[-57,-1],[0,61]],[[846,3661],[174,0]],[[1134,3661],[0,122]],[[1134,3783],[101,0]],[[1235,3783],[-15,-25]],[[1220,3758],[2,-41],[21,-49]],[[1825,3169],[-3,7],[-112,0]],[[1710,3176],[1,182]],[[1764,3419],[62,0],[-1,-250]],[[1022,3428],[113,0]],[[1135,3428],[0,-122]],[[1026,3287],[-5,0],[1,141]],[[1022,3428],[-1,112]],[[1021,3540],[113,0]],[[1134,3540],[1,-112]],[[1135,3428],[-113,0]],[[1021,3540],[0,-248]],[[904,3290],[0,250]],[[1253,3896],[-3,24],[0,106]],[[1250,4026],[116,0]],[[1366,4026],[-1,-129]],[[1365,3897],[-112,-1]],[[2927,2844],[8,-9]],[[2935,2835],[-87,0],[-20,-15]],[[2828,2820],[-7,0]],[[2821,2820],[-4,46],[-26,209]],[[2791,3075],[156,2]],[[2947,3077],[30,-124]],[[2977,2953],[-54,0]],[[2395,2938],[2,-119]],[[2397,2819],[-73,6]],[[2166,2817],[14,100]],[[2180,2917],[6,51],[-10,63]],[[2176,3031],[102,4],[39,5]],[[2317,3040],[65,32],[116,1]],[[2498,3073],[6,-131]],[[2504,2942],[-109,-4]],[[3914,3429],[1,-95]],[[3915,3334],[-24,-1]],[[3891,3333],[-65,-125]],[[3826,3208],[-27,-1]],[[3799,3207],[-2,100]],[[3797,3307],[3,0]],[[3800,3307],[-2,92],[6,41]],[[3804,3440],[41,-22],[21,-2],[48,13]],[[4760,2694],[-274,-2]],[[4486,2692],[0,122]],[[4486,2814],[273,2]],[[4759,2816],[1,-122]],[[4760,2694],[1,-91],[-13,-30],[29,0],[1,-86],[-20,0],[-24,18]],[[4734,2505],[-1,41]],[[4733,2546],[-37,-12],[-93,71]],[[4603,2605],[-8,-20]],[[4595,2585],[0,-12]],[[4595,2573],[8,0]],[[4603,2573],[1,-42]],[[4604,2531],[-58,-1]],[[4546,2530],[-1,71]],[[4545,2601],[-46,0],[-12,18]],[[4487,2619],[-1,73]],[[3800,3307],[-34,17]],[[3766,3324],[0,5]],[[3766,3329],[-8,0]],[[3657,3389],[57,106]],[[3714,3495],[90,-55]],[[3804,3440],[-6,-37],[2,-96]],[[4031,3208],[0,-180]],[[4031,3028],[-90,59]],[[3941,3087],[-141,-2],[-1,122]],[[3799,3207],[116,1]],[[3915,3208],[1,-68],[49,0],[0,68],[66,0]],[[3343,2444],[-38,16]],[[3305,2460],[-44,15]],[[3261,2475],[-20,-4]],[[3241,2471],[-1,158]],[[3240,2629],[102,0]],[[3342,2629],[1,-185]],[[4361,2407],[16,-46]],[[4377,2361],[-73,18],[-155,1]],[[4140,2568],[116,0]],[[4256,2568],[61,7]],[[4317,2575],[0,-4]],[[4317,2571],[8,-1],[36,-163]],[[4034,2381],[-96,0]],[[3938,2381],[-20,-7]],[[3918,2374],[-115,1],[0,226],[231,1]],[[4033,2134],[-231,1]],[[3802,2135],[1,240],[115,-1]],[[3938,2381],[98,0]],[[4036,2381],[-1,-245]],[[3609,2136],[101,-1]],[[3649,2055],[-25,0]],[[3624,2055],[1,-41],[-26,0],[-39,41],[-43,0],[0,-76],[-8,-50]],[[3509,1929],[-36,0],[0,128]],[[3473,2057],[43,0]],[[3516,2057],[0,324]],[[3412,1905],[0,-55]],[[3412,1850],[-29,0],[1,-31],[-58,0],[0,-30],[-29,0],[0,-124]],[[3297,1665],[-52,2]],[[3245,1667],[-1,200]],[[3244,1867],[3,12]],[[3247,1879],[-3,26],[125,1]],[[3369,1906],[43,-1]],[[2758,1892],[25,69],[53,0]],[[2836,1961],[0,-172]],[[2836,1789],[-78,0],[0,103]],[[3355,2288],[-173,-117]],[[3182,2171],[-45,155]],[[3137,2326],[208,90]],[[3343,2444],[2,-28]],[[3345,2416],[-105,-46]],[[3241,2438],[0,33]],[[3261,2475],[44,-15]],[[1670,284],[-86,0]],[[1584,284],[-2,-50],[8,-27],[-22,-39],[-16,-49]],[[1552,119],[-64,18],[-75,49]],[[1413,186],[32,50],[60,48],[19,3]],[[1524,287],[41,49],[2,39]],[[1567,375],[20,15]],[[1587,390],[83,0]],[[1920,331],[2,-13]],[[1875,300],[0,149],[99,0]],[[1974,449],[0,-41]],[[1974,408],[-30,-19],[-24,-31],[0,-27]],[[242,3660],[-218,0],[0,60],[-15,0],[0,63],[44,7],[186,1]],[[181,3293],[-69,-29]],[[98,3292],[-21,53]],[[77,3345],[53,23],[29,-73],[22,-2]],[[2862,3881],[48,-197]],[[2803,3744],[-63,19]],[[2740,3763],[-39,-2]],[[2701,3761],[-15,125]],[[2654,3889],[7,28]],[[2661,3917],[-11,69]],[[2650,3986],[27,0],[7,-49],[52,-7],[-3,-32],[129,-17]],[[3073,3799],[-45,-140]],[[3028,3659],[-14,-32]],[[3014,3627],[-104,57]],[[2910,3684],[-21,92]],[[2907,3780],[62,-6],[58,29],[46,-4]],[[2163,2798],[-1,-85]],[[2162,2713],[-83,-5],[-119,-64]],[[1960,2644],[0,171]],[[1960,2815],[-10,18]],[[1950,2833],[-6,190],[232,8]],[[2180,2917],[-17,-119]],[[2041,1910],[-156,1]],[[1885,1911],[0,91]],[[1885,2002],[148,-2]],[[2033,2000],[8,-90]],[[3802,2904],[-1,181],[115,2]],[[3916,3087],[1,-182]],[[3917,2905],[-115,-1]],[[3917,2747],[0,158]],[[3917,2905],[115,0]],[[3917,2747],[-116,-1],[1,158]],[[3802,2904],[115,1]],[[4851,2366],[-3,207],[231,3]],[[5079,2576],[2,-86],[-57,-1],[0,-60],[-58,-2],[1,-60],[-116,-1]],[[5075,3060],[104,1],[130,-86]],[[5309,2975],[2,-157]],[[5311,2818],[-234,1],[-2,241]],[[5079,2576],[-3,243],[235,-1]],[[5311,2818],[2,-117],[-120,-3],[1,-61],[-58,-1],[2,-60],[-59,0]],[[4844,2938],[-116,0]],[[4728,2938],[-2,91],[58,1]],[[4784,3030],[0,28],[55,0]],[[4839,3058],[1,-7]],[[4840,3051],[2,-1]],[[4842,3050],[2,-112]],[[4545,2571],[1,-41]],[[4604,2531],[0,-107]],[[4547,2363],[-170,-2]],[[4361,2407],[-35,162]],[[4326,2569],[219,2]],[[1876,662],[-58,0],[-59,7]],[[1759,669],[0,-22]],[[1759,647],[-29,14]],[[1760,759],[0,47]],[[1760,806],[53,0]],[[1813,806],[36,-2]],[[1849,804],[33,-23],[6,-18],[-11,-28],[-1,-73]],[[1876,556],[99,-1]],[[1975,555],[-1,-106]],[[1974,449],[-99,0],[1,107]],[[1413,186],[-139,91]],[[1277,288],[61,127]],[[1338,415],[99,-1]],[[1437,414],[0,26],[16,18]],[[1453,458],[17,0]],[[1470,458],[0,48]],[[1470,506],[31,-32],[29,-45]],[[1530,429],[29,-31],[8,-29],[-3,-36],[-40,-46]],[[1810,115],[0,-57],[-56,4],[-202,57]],[[1584,284],[232,-1]],[[1816,283],[-5,-3],[-1,-134]],[[1759,647],[0,-91]],[[1759,556],[-165,1]],[[1595,619],[64,-2]],[[1983,556],[-107,0]],[[1876,556],[0,106]],[[1876,662],[110,-1]],[[1986,661],[0,-56]],[[1986,605],[-3,-49]],[[385,1010],[-8,0]],[[342,1023],[-1,266]],[[341,1289],[151,1]],[[492,1290],[17,-46]],[[509,1244],[-9,-6]],[[500,1238],[-12,-36]],[[488,1202],[10,-107],[15,-63],[-4,-30],[-20,-39]],[[4317,1163],[1,122]],[[4318,1285],[-58,1]],[[4260,1286],[1,232]],[[4261,1518],[115,2],[1,6],[119,-1]],[[4453,1352],[-75,-150],[23,-39]],[[4140,1527],[0,-83],[12,-38]],[[4152,1406],[-64,0]],[[4088,1406],[-6,-39],[-27,13]],[[4055,1380],[-12,22]],[[4043,1402],[-35,-5],[-35,5],[-58,22]],[[3915,1424],[1,104],[224,-1]],[[3816,1030],[-173,0]],[[3643,1030],[0,152],[173,0]],[[3816,1182],[0,-152]],[[3700,1303],[0,121],[94,1]],[[3794,1425],[16,-6]],[[3810,1419],[125,-116],[-235,0]],[[3242,1910],[5,-31]],[[3244,1867],[1,-78]],[[3245,1789],[-277,0]],[[2968,1789],[1,121]],[[2969,1910],[273,0]],[[2216,1211],[-86,-6]],[[2130,1205],[-3,98]],[[2127,1303],[83,5]],[[2210,1308],[6,-97]],[[1250,3783],[3,19],[0,94]],[[1253,3896],[112,1]],[[1365,3897],[-1,-115],[-114,1]],[[1134,3783],[0,113],[119,0]],[[1250,3783],[-116,0]],[[903,3661],[0,136]],[[903,3797],[90,28]],[[993,3825],[27,-1]],[[1020,3824],[0,-163]],[[1020,3661],[-117,0]],[[5077,2697],[-13,0]],[[5064,2697],[-43,9],[-40,-10]],[[4981,2696],[-134,-1]],[[4847,2695],[-5,355]],[[4842,3050],[116,2]],[[4958,3052],[-1,7]],[[4957,3059],[118,1]],[[5075,3060],[2,-363]],[[4849,2573],[-2,122]],[[4981,2696],[48,10],[35,-9]],[[5077,2697],[2,-121]],[[5079,2576],[-230,-3]],[[4733,2546],[3,-182]],[[4605,2363],[-2,210]],[[4595,2573],[0,12]],[[4595,2585],[8,20]],[[4050,3861],[-74,-126]],[[3976,3735],[-32,22]],[[3944,3757],[-88,43],[-70,47]],[[3786,3847],[78,133],[75,-52],[111,-67]],[[4368,3178],[-1,122]],[[4367,3300],[231,1]],[[4598,3301],[1,-121]],[[4599,3180],[-231,-2]],[[4368,3055],[0,123]],[[4368,3178],[231,2]],[[4599,3180],[0,-121]],[[4599,3059],[-174,-1]],[[4425,3058],[0,-3]],[[4425,3055],[-57,0]],[[4973,3306],[129,1],[1,-62]],[[4368,3055],[0,-7]],[[4368,3048],[-9,7],[-49,-7]],[[4310,3048],[-52,-1]],[[4258,3047],[0,253]],[[4258,3300],[109,0]],[[4367,3300],[1,-245]],[[1600,1418],[0,106]],[[1600,1524],[117,-1]],[[1717,1523],[0,-105]],[[1118,2405],[6,-89]],[[1124,2316],[-118,0],[-1,90]],[[1006,2222],[-1,94],[119,0]],[[1124,2316],[0,-73]],[[1124,2243],[-2,-22]],[[1122,2221],[-116,1]],[[1828,3742],[-2,162]],[[1983,3905],[-2,-119],[-8,-44]],[[1973,3742],[-145,0]],[[1688,1716],[39,-37],[-6,-28]],[[1721,1651],[6,-10],[0,-84]],[[1727,1557],[-10,0]],[[1717,1557],[0,-34]],[[1600,1524],[-1,184]],[[1599,1708],[-7,33]],[[1592,1741],[23,-27]],[[887,1188],[34,-39],[-28,-30]],[[893,1119],[-23,-47]],[[870,1072],[-13,-7]],[[857,1065],[-26,-9]],[[831,1056],[-37,11]],[[794,1067],[-22,13]],[[772,1080],[-58,46],[-20,22],[-19,49]],[[675,1197],[3,8]],[[678,1205],[20,-7]],[[698,1198],[11,0]],[[709,1198],[34,11],[32,28],[16,34]],[[791,1271],[5,33],[20,30],[30,20]],[[846,1354],[7,-7]],[[853,1347],[5,-53],[17,-45]],[[875,1249],[-1,-13]],[[874,1236],[13,-48]],[[3917,1909],[326,0]],[[4243,1909],[-62,-86],[3,-53]],[[4184,1770],[-268,1],[1,138]],[[4261,1518],[0,25]],[[4261,1543],[-89,82],[1,145]],[[4173,1770],[314,-1]],[[4487,1769],[9,-244]],[[3643,1061],[-80,0]],[[3563,1061],[-7,60],[0,61]],[[3556,1182],[87,0],[0,-121]],[[3563,1061],[-64,0]],[[3499,1061],[-2,-9]],[[3497,1052],[-29,6]],[[3468,1058],[2,124]],[[3470,1182],[86,0]],[[3643,1061],[0,-59]],[[3643,1002],[-9,3],[-17,-55]],[[3617,950],[-4,-19],[-130,29]],[[3483,960],[0,36]],[[3483,996],[16,65]],[[3499,1061],[144,0]],[[3373,1073],[-17,-88],[-35,6]],[[3321,991],[-44,-22]],[[3277,969],[8,-17]],[[3285,952],[-21,29]],[[3264,981],[-17,-12]],[[3266,1028],[15,61]],[[3281,1089],[92,-16]],[[3261,892],[-57,-146],[53,-219],[11,-111]],[[3268,416],[-95,335],[25,18]],[[3198,769],[0,22]],[[3255,975],[9,6]],[[3285,952],[-30,23]],[[3483,960],[-117,26],[-71,-9],[-18,-8]],[[3277,969],[44,22]],[[3373,1073],[124,-21]],[[3497,1052],[-14,-56]],[[3350,1077],[-69,12]],[[3281,1089],[16,65]],[[3297,1154],[0,28]],[[3297,1182],[57,0]],[[3354,1182],[-4,-105]],[[3468,1058],[-47,7]],[[3421,1065],[-9,20],[0,97]],[[3412,1182],[58,0]],[[3274,1081],[-132,0]],[[3142,1081],[0,101]],[[3142,1182],[155,0]],[[3297,1154],[-19,-75]],[[3297,1303],[58,1]],[[3355,1304],[0,-121],[-58,-1]],[[3412,1182],[0,122]],[[3412,1304],[58,0]],[[3470,1304],[0,-122]],[[2266,1585],[22,1]],[[2288,1586],[7,-124],[31,-11]],[[2326,1451],[-25,3],[-99,-8]],[[2202,1446],[-8,134]],[[2194,1580],[-10,0]],[[2185,1673],[31,-3]],[[2216,1671],[76,3],[-26,-89]],[[2331,1314],[-60,-5]],[[2210,1308],[-8,138]],[[2202,1446],[103,8],[33,-6]],[[2338,1448],[-9,-63],[2,-71]],[[1894,1555],[-30,57]],[[1864,1612],[-1,31],[21,123]],[[1884,1766],[1,145]],[[2041,1910],[-1,-176],[3,-163]],[[3421,1065],[-71,12]],[[3350,1077],[5,34],[-1,71]],[[3354,1182],[58,0]],[[2500,1449],[-33,-110]],[[2447,1324],[-116,-10]],[[2338,1448],[39,-7],[123,8]],[[1955,1436],[-57,7],[-129,0]],[[1770,1557],[121,1]],[[1891,1558],[17,-23]],[[2129,1442],[-82,-6]],[[2043,1571],[151,9]],[[2202,1446],[-73,-4]],[[2410,2028],[80,-1]],[[2490,2027],[-9,-28]],[[2481,1999],[-282,-1]],[[2199,1998],[-1,222],[4,34]],[[2202,2254],[157,-202],[51,-24]],[[3245,1789],[0,-122]],[[3245,1667],[-20,1]],[[3225,1668],[-255,0]],[[2970,1668],[-2,121]],[[2033,2000],[165,-2]],[[2198,1998],[-1,-82]],[[1020,3661],[114,0]],[[961,3904],[1,-86]],[[962,3818],[-59,-21]],[[903,3797],[0,-14]],[[903,3783],[-116,-1],[0,122]],[[1134,3896],[0,-113]],[[1134,3783],[-28,0],[-21,14],[-65,23]],[[1020,3820],[0,4]],[[993,3825],[-31,-7]],[[961,3904],[173,0]],[[1134,3904],[0,-8]],[[1134,3965],[-173,0]],[[961,3965],[0,60]],[[961,4025],[173,0]],[[1134,4025],[0,-60]],[[1134,3965],[0,-61]],[[1134,3904],[-173,0]],[[1134,3896],[0,129]],[[1134,4025],[116,1]],[[1253,3896],[-119,0]],[[1020,3661],[0,159]],[[1597,3782],[-1,-242]],[[1596,3540],[-232,0]],[[1364,3540],[1,173]],[[1365,3713],[12,34],[46,4],[0,31]],[[1423,3782],[174,0]],[[1365,3904],[1,122]],[[1366,4026],[115,-1]],[[1481,4025],[0,-121]],[[1481,3904],[-116,0]],[[1040,1859],[0,136],[-5,27]],[[1035,2022],[102,-11],[51,-12]],[[1188,1999],[-4,-49],[-12,-49],[-88,2],[-2,-68],[-42,24]],[[4958,3183],[0,-131]],[[4958,3052],[-118,-1]],[[4839,3058],[-113,2]],[[4726,3060],[-1,122]],[[4725,3182],[119,0]],[[4844,3182],[0,7]],[[4598,3301],[246,3]],[[4844,3304],[0,-122]],[[4844,3182],[-245,-2]],[[4726,3060],[-127,-1]],[[4599,3180],[126,2]],[[4242,2883],[-105,77]],[[4137,2960],[-2,185],[9,34]],[[4144,3179],[2,121]],[[4146,3300],[112,0]],[[4258,3047],[-5,0]],[[4253,3047],[2,-140],[5,-29]],[[4847,2695],[-87,-1]],[[4759,2816],[-128,-1]],[[4631,2815],[5,62],[64,0],[-1,61]],[[4699,2938],[145,0]],[[4844,2938],[3,-243]],[[4849,2573],[2,-207]],[[4851,2366],[-115,-2]],[[4736,2364],[-2,141]],[[4600,2937],[-116,0]],[[4484,2937],[1,-25],[-58,-5]],[[4427,2907],[-2,151]],[[4599,3059],[1,-122]],[[4425,3055],[2,-148]],[[4484,2937],[44,0]],[[4528,2937],[0,-60],[-43,-2]],[[4485,2875],[2,-256]],[[4545,2601],[0,-30]],[[4326,2569],[-9,2]],[[4317,2575],[-61,-5],[-3,240]],[[4275,2809],[-21,105],[-1,133]],[[4253,3047],[57,1]],[[4368,3048],[57,7]],[[3038,2501],[87,1]],[[3125,2502],[0,-108],[12,-68]],[[3137,2326],[-156,-70],[-40,-16]],[[2941,2240],[3,13]],[[2939,2252],[24,121]],[[2963,2373],[-9,0]],[[2954,2373],[10,37]],[[2964,2410],[7,59],[16,60],[26,53]],[[2969,1910],[-8,36],[0,73]],[[2961,2019],[12,106]],[[2973,2125],[17,2]],[[2990,2127],[23,-50],[88,-166]],[[3101,1911],[-132,-1]],[[2833,2019],[3,-18]],[[2836,2001],[58,-9]],[[2894,1992],[0,-82]],[[2894,1910],[-58,0]],[[2836,1910],[0,51]],[[2758,1892],[-1,-103],[-14,4]],[[2743,1793],[0,9]],[[2743,1802],[-4,5],[-24,148],[0,47]],[[2715,2002],[-6,17]],[[2809,2016],[24,3]],[[2968,1789],[-132,0]],[[2836,1789],[0,121]],[[2836,1910],[133,0]],[[2328,3733],[0,-11]],[[2328,3722],[3,0]],[[2331,3722],[0,-70]],[[2331,3652],[-212,0]],[[2119,3652],[0,70]],[[2119,3722],[131,0],[78,11]],[[2120,3787],[30,-3],[172,-1]],[[2322,3783],[10,-39]],[[2332,3744],[-4,-11]],[[2328,3733],[-82,-11],[-140,1],[-77,17],[-56,2]],[[1973,3742],[7,42]],[[1980,3784],[125,0]],[[2105,3784],[15,3]],[[1249,3298],[0,60],[115,1]],[[1364,3359],[0,-61]],[[1364,3419],[0,-60]],[[1364,3359],[-115,-1],[1,61]],[[1192,3298],[-57,0]],[[1135,3298],[-1,121],[58,0]],[[1192,3419],[0,-121]],[[1249,3298],[-57,0]],[[1192,3419],[58,0]],[[1250,3419],[-1,-121]],[[1760,3782],[-48,0]],[[1712,3935],[54,0]],[[1599,1708],[0,-77]],[[1452,1722],[0,197]],[[1452,1919],[2,12]],[[1454,1931],[67,-17]],[[1597,1879],[0,-84],[9,-50],[-14,-4]],[[1691,934],[11,-46]],[[1702,888],[-107,0],[0,-126]],[[1595,762],[-7,-57]],[[1471,706],[-1,81]],[[1470,787],[3,67],[0,327]],[[1473,1181],[42,15],[32,27],[43,19]],[[1590,1242],[9,-101],[-37,-164]],[[1487,1419],[1,195]],[[1488,1614],[89,-50]],[[1600,1558],[0,-140]],[[1600,1418],[-113,1]],[[2210,1308],[-76,-5]],[[2134,1303],[-6,105],[1,34]],[[1876,662],[0,-152]],[[1759,511],[0,158]],[[3614,1424],[86,0],[0,-121]],[[3700,1303],[-85,0],[-1,121]],[[3354,1182],[1,122]],[[3355,1304],[57,0]],[[3067,1081],[0,101]],[[3067,1182],[75,0]],[[3142,1081],[-75,0]],[[2983,1430],[35,-5],[106,0]],[[3124,1425],[0,-122]],[[3124,1303],[-156,1]],[[2968,1304],[-1,126]],[[2968,1210],[49,-28]],[[3017,1182],[50,0]],[[3067,1081],[-50,0]],[[3002,1085],[-35,0]],[[2967,1085],[1,125]],[[3470,1304],[0,60]],[[3470,1364],[144,0],[0,-61],[-144,1]],[[3142,1182],[-36,0]],[[3106,1182],[0,121]],[[3106,1303],[36,0]],[[1700,555],[0,-165]],[[1700,390],[-113,0]],[[1567,375],[-11,29],[-26,25]],[[1470,506],[0,6]],[[1470,512],[0,18]],[[1470,530],[7,11]],[[1485,533],[41,1]],[[1559,537],[7,20],[134,-2]],[[3049,1182],[-32,0]],[[2968,1210],[0,94]],[[2968,1304],[81,-1]],[[3049,1303],[0,-121]],[[2234,1068],[-27,-17],[-51,18],[-2,40]],[[2154,1109],[-87,-6]],[[2067,1103],[-6,97],[155,11]],[[2216,1211],[7,-98]],[[2134,1303],[-79,-5],[-8,138]],[[2061,1200],[6,-97]],[[2067,1103],[-69,-4]],[[1998,1099],[-37,-40]],[[1961,1059],[20,55],[2,57]],[[1957,1219],[-9,22]],[[2058,1249],[3,-49]],[[1876,662],[0,72],[9,43]],[[1885,777],[35,16],[26,-7],[16,-27]],[[1962,759],[24,-51],[0,-47]],[[1986,661],[-110,1]],[[2061,1200],[-6,98],[72,5]],[[2130,1205],[-69,-5]],[[4091,934],[111,-124],[-67,-67]],[[3976,894],[-8,2]],[[3968,896],[36,37]],[[4004,933],[54,-7],[33,8]],[[3297,1303],[0,122]],[[3297,1425],[115,0]],[[3412,1425],[0,-61],[-29,0],[0,-60]],[[3383,1304],[-86,-1]],[[3412,1425],[58,0]],[[3470,1425],[0,-121]],[[3470,1304],[-87,0]],[[1826,3932],[-12,2],[-218,0]],[[1596,3934],[0,31],[51,0],[0,60],[180,1],[-1,-94]],[[1365,3904],[116,0]],[[1481,3904],[-1,-122]],[[1480,3782],[-115,0],[0,122]],[[1597,3782],[-117,0]],[[1480,3782],[1,243]],[[1481,4025],[57,0],[0,-121],[58,0],[1,-122]],[[1818,822],[16,0]],[[1834,822],[1,-17]],[[1835,805],[-22,1]],[[1760,806],[0,-19]],[[1593,751],[2,11]],[[1702,888],[2,-3]],[[5273,3880],[-8,0],[-51,-64]],[[5214,3816],[-113,99],[175,113],[49,-46],[-32,-19],[55,-49]],[[5348,3914],[-25,-17]],[[5323,3897],[-50,-17]],[[6002,3736],[-40,0],[-44,10],[-34,19]],[[5884,3765],[0,-4]],[[5884,3761],[-60,37]],[[5824,3798],[4,1]],[[5828,3799],[-45,27],[0,150],[10,24],[137,-65],[73,1],[-1,-200]],[[4031,3299],[-72,30]],[[3959,3329],[-44,5]],[[3914,3429],[328,0]],[[4242,3429],[13,-53],[3,-76]],[[4258,3300],[-227,-1]],[[4728,2938],[-128,-1]],[[4599,3059],[185,1],[0,-30]],[[4486,2814],[-1,61]],[[4528,2937],[171,1]],[[4631,2815],[-145,-1]],[[3339,3463],[-3,-14]],[[3336,3449],[44,-9],[3,-15],[2,-221]],[[3385,3204],[-75,-1]],[[3310,3203],[-1,123]],[[3309,3326],[-104,3]],[[3205,3329],[8,4]],[[3213,3333],[22,11]],[[3235,3344],[51,50],[16,34],[8,47]],[[3310,3475],[29,-12]],[[3517,3082],[-176,1]],[[3341,3083],[-2,120]],[[3339,3203],[231,2]],[[3570,3205],[1,-121]],[[3571,3084],[-54,-2]],[[3799,3207],[-229,-2]],[[3570,3205],[0,121]],[[3570,3326],[196,3]],[[3766,3324],[31,-17]],[[3446,3497],[-9,-4]],[[3437,3493],[2,-7]],[[3439,3486],[-39,-1],[-5,-22],[39,0]],[[3434,3463],[20,8]],[[3454,3471],[0,-80],[116,-65]],[[3570,3205],[-185,-1]],[[3336,3449],[7,37]],[[3343,3486],[7,83]],[[3350,3569],[98,-57]],[[3448,3512],[-2,-15]],[[3799,3207],[1,-120]],[[3744,3087],[0,-2]],[[3744,3085],[-173,-1]],[[1921,2572],[-1,-26],[57,-61]],[[1977,2485],[-3,-23],[12,-235]],[[1986,2227],[47,-227]],[[2033,2000],[-148,2]],[[1885,2002],[1,213]],[[1886,2215],[29,152]],[[1915,2367],[-14,0]],[[1901,2367],[0,100],[10,32],[-70,1],[0,75]],[[1841,2575],[65,39]],[[1906,2614],[4,2]],[[1910,2616],[11,-44]],[[4456,2117],[-9,73]],[[4447,2190],[-14,45],[28,5]],[[4606,2241],[1,-124],[-151,0]],[[3355,2136],[161,0]],[[3516,2136],[0,-79]],[[3473,2057],[0,-17]],[[3473,2040],[-233,1]],[[3240,2041],[0,84],[-29,0],[-29,46]],[[2969,1910],[-75,0]],[[2894,1992],[-58,9]],[[2833,2019],[68,17]],[[2926,2080],[10,14]],[[2936,2094],[29,-43]],[[2965,2051],[-4,-32]],[[3101,1911],[-69,128]],[[3032,2039],[208,2]],[[3240,2041],[-1,-131]],[[3239,1910],[-138,1]],[[3412,1910],[0,-5]],[[3369,1906],[-127,-1],[0,5]],[[3242,1910],[-3,0]],[[3473,2040],[-2,-109]],[[3471,1931],[-1,-21],[-58,0]],[[4243,1909],[-96,0]],[[4147,2136],[234,-1]],[[4381,2135],[-18,-54],[-120,-172]],[[4381,2135],[73,-6]],[[4454,2129],[26,-220],[-237,0]],[[4612,1701],[1,188]],[[4613,1889],[182,-2]],[[4795,1887],[-66,-40],[-117,-146]],[[3193,793],[5,-24]],[[3268,416],[11,-108],[-321,2],[-339,-136]],[[2619,174],[-227,683],[109,40],[-62,94]],[[2439,991],[328,311]],[[2767,1302],[-1,2]],[[2766,1304],[24,2],[178,-2]],[[2968,1304],[-1,-219]],[[2967,1085],[-9,0]],[[2959,994],[36,-60],[45,-32]],[[2234,1068],[10,-124],[16,-10],[72,10],[107,47]],[[2619,174],[-419,-174],[-151,34],[-30,21]],[[1926,296],[-6,35]],[[1974,408],[1,147]],[[1975,555],[8,1]],[[1986,605],[0,101],[-24,53]],[[1962,759],[-14,25],[-27,9],[-36,-16]],[[1885,777],[-36,27]],[[1849,804],[-14,1]],[[1834,822],[7,0]],[[1842,845],[35,55]],[[1861,913],[63,65],[15,24]],[[1939,1002],[22,57]],[[1998,1099],[156,10]],[[444,3540],[1,-151]],[[445,3389],[-4,-92]],[[441,3297],[-32,1],[-210,-1],[-18,-4]],[[77,3345],[-77,193],[444,2]],[[3917,2013],[-1,-372]],[[3916,1641],[-60,15],[-52,34],[-118,23]],[[3686,1713],[0,-45]],[[3686,1668],[-59,0],[-41,-39]],[[3586,1629],[-1,130]],[[3585,1759],[-30,0],[-27,-12],[0,42]],[[3528,1789],[-173,0]],[[3355,1789],[0,-124]],[[3355,1665],[-58,0]],[[3412,1850],[0,60]],[[3471,1931],[38,-2]],[[3624,2055],[67,0]],[[787,3986],[0,39],[174,0]],[[675,1197],[21,-52],[76,-65]],[[794,1067],[37,-11]],[[857,1065],[-14,-23]],[[843,1042],[16,-24],[-13,-49]],[[846,969],[-2,-2]],[[844,967],[-23,15]],[[766,963],[-54,-43],[-40,-6]],[[672,914],[1,39]],[[673,953],[-44,193]],[[629,1146],[32,61]],[[661,1207],[17,-2]],[[1470,787],[1,-152]],[[1467,582],[3,-52]],[[1470,512],[0,-54]],[[1453,458],[-15,-16],[-1,-28]],[[1338,415],[-15,-33]],[[1323,382],[-68,0]],[[1255,382],[-35,36]],[[1234,501],[5,27]],[[1239,609],[-6,20]],[[1241,635],[40,-9],[13,25],[-11,45]],[[1280,721],[-46,5]],[[1234,726],[33,50],[24,12],[25,-4],[-22,70],[1,43],[23,11]],[[1318,908],[-5,16],[-58,20]],[[1255,944],[-56,79],[40,45],[27,7]],[[1266,1075],[17,53]],[[1283,1128],[34,-1],[37,8],[32,17],[87,29]],[[1255,944],[60,-22],[3,-14]],[[1234,726],[-4,-4]],[[837,961],[9,8]],[[843,1042],[27,30]],[[870,1072],[5,8]],[[875,1080],[49,-22],[42,47],[51,45],[30,43],[26,57],[131,-117],[20,-8]],[[1224,1125],[58,-2],[-16,-48]],[[1040,1859],[0,-181]],[[1040,1678],[-187,92]],[[853,1770],[-59,48]],[[923,1879],[0,57]],[[853,1770],[142,-70]],[[982,1575],[-84,89]],[[898,1664],[-382,1]],[[1452,1919],[0,-209]],[[1345,1709],[-1,217]],[[1344,1926],[-5,35]],[[1339,1961],[115,-30]],[[3124,1425],[58,0]],[[3182,1425],[0,-122]],[[3182,1303],[-58,0]],[[3124,1425],[0,121]],[[3124,1546],[58,0]],[[3182,1546],[0,-121]],[[3816,1030],[-1,-74]],[[3815,956],[-57,-19]],[[3758,937],[2,-6]],[[3760,931],[-11,-50],[-136,50],[4,19]],[[3643,1002],[0,28]],[[3585,1759],[0,-91]],[[3585,1668],[-115,-2],[0,-150],[64,-1],[18,-8],[34,8],[0,-22],[28,-8],[0,-61]],[[3614,1424],[-116,1]],[[3498,1425],[-21,17]],[[3477,1442],[2,3]],[[3479,1445],[-196,160]],[[3283,1605],[0,60]],[[3283,1665],[72,0]],[[3355,1789],[173,0]],[[3032,2039],[-42,88]],[[2973,2125],[-8,-74]],[[2936,2094],[-5,-9]],[[2931,2085],[-6,34],[2,59],[14,62]],[[3049,1182],[0,121]],[[3049,1303],[57,0]],[[3106,1182],[-57,0]],[[3686,1668],[-1,-122]],[[3685,1546],[-42,0],[0,-61],[29,0]],[[3672,1485],[10,-29],[26,-32]],[[3708,1424],[-94,0]],[[3585,1668],[1,-39]],[[2766,1304],[-92,122]],[[2674,1426],[2,7]],[[2676,1433],[31,-8],[223,0]],[[2930,1425],[37,5]],[[2967,1430],[1,-126]],[[3235,3344],[-22,-11]],[[3205,3329],[-25,-4]],[[3180,3325],[-1,37]],[[3179,3362],[-55,6]],[[3124,3368],[55,169]],[[3179,3537],[79,-26],[22,-24]],[[3280,3487],[30,-12]],[[2523,3758],[0,-161]],[[2523,3597],[-94,0],[-1,65],[-97,0]],[[2331,3662],[0,60]],[[2328,3722],[4,22]],[[2332,3744],[-10,14]],[[2322,3758],[201,0]],[[2070,3652],[107,0]],[[2177,3652],[-1,-112]],[[2176,3540],[-224,0]],[[1955,3652],[47,0]],[[2002,3652],[11,-12]],[[2013,3640],[3,15]],[[2016,3655],[54,-3]],[[2523,3597],[1,-34]],[[2524,3563],[-80,0],[0,-8]],[[2444,3555],[-123,0]],[[2321,3555],[-2,-75],[-86,-1],[1,-60],[-58,0]],[[2176,3419],[1,233]],[[2177,3652],[154,0]],[[2331,3652],[0,10]],[[1951,3297],[1,243]],[[2176,3540],[0,-239]],[[2176,3301],[-18,-3]],[[2158,3298],[-207,-1]],[[2947,3323],[4,-69]],[[2951,3254],[66,1]],[[3020,3200],[-188,-1]],[[2825,3322],[122,1]],[[6002,3736],[1,-180],[-237,-3]],[[5766,3553],[0,122]],[[5766,3675],[81,2]],[[5847,3677],[17,11]],[[5864,3688],[20,11]],[[5884,3699],[0,66]],[[5681,3887],[-1,-33],[-143,0],[-2,-141]],[[5535,3713],[-151,-44]],[[5384,3669],[-18,14]],[[5366,3683],[173,286],[142,-82]],[[5681,3887],[147,-88]],[[5828,3799],[-293,-86]],[[5495,3552],[0,17]],[[5500,3577],[-116,92]],[[5384,3669],[238,69]],[[5622,3738],[36,-137],[-11,-2]],[[5647,3599],[-16,-16],[-37,-14],[-21,-19]],[[5573,3550],[-78,2]],[[3310,3203],[29,0]],[[3341,3083],[-67,0]],[[3275,3202],[-68,0]],[[3207,3202],[8,55],[-1,61]],[[3214,3318],[95,8]],[[4031,3042],[0,230]],[[4031,3272],[54,-34],[-6,-28]],[[4079,3210],[-5,-1]],[[4074,3209],[1,-194]],[[3251,3084],[266,-2]],[[3571,3084],[0,-120]],[[3571,2964],[-231,-2]],[[3340,3021],[-142,1]],[[3198,3022],[16,119]],[[3915,3208],[-89,0]],[[3891,3333],[68,-4]],[[4031,3299],[0,-91]],[[903,3783],[0,-122]],[[903,3661],[-57,0]],[[904,3540],[-174,-2]],[[730,3538],[-29,15],[0,47],[-24,0],[-1,150]],[[676,3750],[133,1],[0,32],[94,0]],[[1537,3049],[-58,-25]],[[1479,3024],[0,213]],[[1479,3237],[58,6]],[[1537,3243],[0,39]],[[1595,3282],[-1,-208]],[[1537,3052],[0,-3]],[[1726,3128],[-1,-33]],[[1725,3095],[-15,35],[0,46]],[[1710,3176],[113,0],[2,-7]],[[1825,3169],[0,-29]],[[3916,1641],[0,-109]],[[3916,1532],[-4,-4]],[[3912,1528],[-90,0]],[[3822,1528],[0,61],[-96,1],[0,-61],[-41,0]],[[3685,1529],[1,184]],[[3916,1528],[0,243],[115,-1]],[[4031,1770],[0,-242]],[[4031,1528],[-115,0]],[[4261,1405],[-1,-119]],[[4260,1286],[-51,-1]],[[4209,1285],[5,-21],[-3,-87]],[[4211,1177],[-18,4]],[[4193,1181],[-29,1]],[[4164,1182],[3,102],[-97,-2]],[[4070,1282],[-1,57]],[[4069,1339],[-14,41]],[[4088,1406],[173,-1]],[[1938,3215],[8,-253]],[[1946,2962],[-115,-4]],[[1831,2958],[-6,211]],[[1825,3169],[1,-4]],[[1831,3171],[107,44]],[[3456,2964],[230,1]],[[3686,2965],[1,-123]],[[3687,2842],[-230,0],[-1,122]],[[1960,2815],[-1,-7]],[[1959,2808],[-46,1]],[[1913,2809],[-28,-5],[-49,5]],[[1946,2962],[4,-129]],[[1959,2808],[1,-164]],[[1960,2644],[-50,-28]],[[1906,2614],[-50,-31]],[[1856,2583],[-47,12],[-215,1]],[[1594,2596],[0,95]],[[1836,2809],[46,-5],[31,5]],[[645,1082],[28,-129]],[[672,914],[-69,-5],[-14,-7]],[[589,902],[-28,-20],[-29,0]],[[478,942],[34,75]],[[512,1017],[30,14],[30,35],[73,16]],[[1159,1387],[-50,-42],[-55,-11],[-27,-20],[-31,5],[-31,-7],[-12,-21]],[[953,1291],[-26,-11]],[[927,1280],[-22,-5],[-20,-29]],[[885,1246],[-11,-10]],[[874,1236],[1,13]],[[853,1347],[-8,8]],[[845,1355],[-25,-14],[-67,11],[8,38],[43,55],[15,43]],[[819,1488],[4,15]],[[826,1514],[211,0],[25,-23],[97,-104]],[[1487,1419],[-122,1]],[[1365,1420],[-23,12],[1,177],[29,0],[0,41],[-27,0]],[[1345,1650],[0,43],[143,-79]],[[803,1497],[16,-9]],[[845,1355],[1,-1]],[[791,1271],[-22,-40],[-18,-18],[-42,-15]],[[698,1198],[-18,6],[-46,34],[-108,10]],[[526,1248],[-17,-4]],[[492,1290],[69,0]],[[561,1290],[39,194]],[[2970,1668],[-220,-1],[-6,2]],[[2744,1669],[-1,124]],[[2743,1793],[16,-4],[209,0]],[[3297,1425],[0,168]],[[3297,1593],[173,-140]],[[3470,1453],[0,-28]],[[3470,1425],[-173,0]],[[3182,1425],[115,0]],[[3297,1303],[-115,0]],[[2930,1425],[-108,0]],[[2822,1425],[14,31],[0,90]],[[2836,1546],[133,2]],[[3297,1546],[-115,0]],[[3182,1546],[0,122]],[[3182,1668],[43,0]],[[3225,1668],[58,-3]],[[3283,1605],[14,-12]],[[3297,1593],[0,-47]],[[3182,1546],[-213,2]],[[2969,1548],[1,120]],[[2970,1668],[212,0]],[[2969,1548],[-190,-2]],[[2779,1546],[0,121],[191,1]],[[2779,1546],[57,0]],[[2822,1425],[-119,0],[-27,8]],[[2676,1433],[4,10]],[[2680,1443],[6,20]],[[2686,1463],[58,206]],[[2744,1669],[35,-2],[0,-121]],[[3672,1182],[0,121]],[[3672,1303],[263,0],[130,-121]],[[4065,1182],[-393,0]],[[3033,2954],[-56,-1]],[[2947,3077],[214,1],[46,7]],[[3207,3085],[-9,-63]],[[3198,3022],[13,0]],[[3211,3022],[-9,-66]],[[3202,2956],[-169,-2]],[[3297,1546],[0,-121]],[[2798,3622],[29,-220]],[[2827,3402],[-2,-80]],[[2762,3322],[-13,94]],[[2749,3416],[-5,-3]],[[2722,3596],[-53,1]],[[2669,3597],[-10,48]],[[3648,3751],[-28,-46]],[[3553,3590],[-120,70]],[[3433,3660],[54,65],[29,-17]],[[3516,3708],[32,34],[22,59]],[[4303,3801],[-10,11],[70,104],[23,87],[59,-111],[54,-97]],[[3854,3802],[-108,-178]],[[3746,3624],[-69,44]],[[3677,3668],[109,179]],[[3786,3847],[68,-45]],[[3976,3735],[-109,-185]],[[3867,3550],[-18,3]],[[3849,3553],[-103,71]],[[3854,3802],[90,-45]],[[3804,3440],[-194,116]],[[3610,3556],[67,112]],[[3677,3668],[79,-51],[93,-64]],[[3454,3471],[1,-2]],[[3455,3469],[10,33]],[[3465,3502],[104,-61]],[[5882,3311],[-116,0]],[[5768,3330],[-2,223]],[[5766,3553],[216,4],[21,-2],[-3,-112],[2,-130],[-120,-2]],[[3433,3660],[188,-110]],[[3600,3493],[-16,-61]],[[3584,3432],[-119,70]],[[3455,3469],[-21,-6]],[[3439,3486],[-2,7]],[[3446,3497],[2,15]],[[3350,3569],[18,209]],[[3368,3778],[118,-15],[52,-10]],[[3538,3753],[2,-26],[-24,-19]],[[2951,3254],[-7,136]],[[2944,3390],[20,87]],[[2964,3477],[98,-35]],[[3062,3442],[-21,-65]],[[3041,3377],[7,-1]],[[3048,3376],[5,-120]],[[3053,3256],[-102,-2]],[[3219,3657],[-40,-120]],[[3179,3537],[-165,90]],[[3028,3659],[34,107]],[[1864,1612],[27,-54]],[[1891,1558],[-164,-1]],[[1721,1651],[8,0]],[[1729,1651],[9,161]],[[1738,1812],[53,-23]],[[1791,1789],[90,-45]],[[1881,1744],[-16,-92],[-1,-40]],[[1938,3215],[13,6]],[[1951,3221],[0,76]],[[1951,3297],[176,1]],[[2127,3298],[41,-229],[3,-5]],[[2171,3064],[5,-33]],[[2176,3031],[-232,-8],[-6,192]],[[1365,3713],[0,-30]],[[1365,3683],[-110,-3]],[[1235,3686],[-13,32],[-2,40]],[[1235,3783],[188,-1]],[[1364,3298],[173,0]],[[1537,3298],[0,-55]],[[1479,3237],[0,-60],[-115,0]],[[1598,2042],[-3,176]],[[1595,2218],[55,-17],[76,-12]],[[1726,2189],[0,-165]],[[1726,2024],[-130,-1],[0,19]],[[1901,2367],[-175,1]],[[1726,2368],[0,-179]],[[1595,2218],[-1,378]],[[1856,2583],[-15,-8]],[[1736,1818],[-139,61]],[[1597,1879],[-1,144],[130,1]],[[1726,2024],[2,-78],[-3,-124]],[[1725,1822],[11,-4]],[[2500,1449],[-126,-8],[-48,10]],[[2288,1586],[256,16]],[[2544,1602],[-44,-153]],[[670,2565],[39,-258]],[[709,2307],[-130,-10]],[[519,2511],[72,30]],[[591,2541],[3,-8],[76,32]],[[225,3297],[216,0]],[[441,3297],[1,-26]],[[442,3271],[-72,-84]],[[370,3187],[-50,-17],[-35,-31]],[[443,3260],[1,-206]],[[444,3054],[-97,0],[-59,-25]],[[370,3187],[72,84]],[[442,3271],[1,-11]],[[443,3260],[-2,37]],[[441,3297],[232,0]],[[673,3297],[0,-242],[-229,-1]],[[444,3054],[-1,-171],[-76,0]],[[443,2813],[1,241]],[[444,3054],[230,1],[-1,-122]],[[673,2933],[-17,0]],[[656,2933],[0,-121]],[[656,2812],[-213,1]],[[2743,1802],[1,-138],[-58,-201]],[[2680,1443],[-6,-17]],[[2674,1426],[93,-124]],[[2303,1120],[59,47],[37,39],[34,52],[32,72],[79,272]],[[2544,1602],[99,-132]],[[2717,1671],[5,55],[-18,52]],[[2663,2002],[25,86],[27,-86]],[[730,3538],[-53,1]],[[673,3514],[0,-217]],[[445,3389],[-2,202]],[[443,3591],[-3,37],[0,123]],[[442,3782],[230,0],[4,-32]],[[1344,1926],[1,-276]],[[1365,1420],[-37,1],[-19,11],[-87,80]],[[1092,1646],[-52,32]],[[1188,1999],[151,-38]],[[1600,1397],[0,-100]],[[1584,1293],[6,-51]],[[1473,1181],[20,36],[21,22],[-38,50],[20,32],[-67,34],[-82,7]],[[1347,1362],[0,19]],[[1368,1402],[0,18]],[[1368,1420],[232,-2]],[[629,1146],[16,-64]],[[512,1017],[0,30],[-15,57],[-9,98]],[[488,1202],[12,36]],[[500,1238],[26,10]],[[526,1248],[97,-8],[20,-5],[18,-28]],[[1347,1347],[0,15]],[[1283,1128],[-59,-3]],[[875,1080],[18,39]],[[887,1188],[-13,48]],[[885,1246],[12,22],[30,12]],[[927,1280],[26,11]],[[4243,1909],[237,0],[7,-140]],[[4487,1769],[-303,1]],[[4846,3551],[-64,0]],[[4782,3551],[-1,116],[-51,2]],[[4730,3669],[-1,66]],[[4782,3551],[-173,0]],[[4609,3551],[-1,244]],[[4728,3795],[2,-126]],[[4683,3380],[-70,45]],[[4613,3425],[-11,4]],[[4609,3551],[122,0]],[[4731,3551],[0,-55],[-12,-26],[40,-31]],[[4759,3439],[72,-88],[49,-47]],[[4880,3304],[-246,-2],[49,78]],[[4367,3300],[0,48]],[[4367,3348],[6,27]],[[4373,3375],[174,51]],[[4550,3433],[63,-8]],[[4683,3380],[-47,-77],[-38,-2],[-231,-1]],[[4377,3403],[-10,-55]],[[4258,3300],[-2,69],[-14,60]],[[4242,3429],[-6,1]],[[3744,3085],[0,-157]],[[3686,2928],[0,37]],[[3686,2965],[-115,-1]],[[3571,3084],[173,1]],[[2188,3898],[84,-1]],[[2272,3897],[17,-3]],[[2289,3894],[20,-18]],[[2309,3876],[14,-21]],[[2323,3855],[-1,-72]],[[2120,3787],[0,127]],[[2120,3914],[45,0]],[[2165,3914],[23,-16]],[[2309,3876],[-20,18]],[[2272,3897],[-84,1]],[[2188,3898],[-23,16]],[[2120,3914],[0,52]],[[2120,3966],[204,-1],[-1,-110]],[[2105,3784],[-43,0]],[[2062,3784],[0,182]],[[2062,3966],[58,0]],[[2120,3966],[0,-179]],[[1828,3661],[0,81],[145,0]],[[1973,3742],[-8,-80]],[[1965,3662],[-137,-1]],[[1980,3784],[5,83],[-1,99]],[[1984,3966],[78,0]],[[2062,3784],[-82,0]],[[2119,3652],[-49,0]],[[2016,3655],[-3,-15]],[[2002,3652],[-38,1],[9,89]],[[1973,3742],[52,-2],[94,-18]],[[2323,3855],[1,134],[104,-1]],[[2428,3988],[-1,-129]],[[2427,3859],[-16,-4],[-88,0]],[[5461,3259],[-25,16]],[[5440,3551],[95,1]],[[5535,3552],[1,-233],[12,-80]],[[5548,3239],[-54,3],[-33,17]],[[5884,3699],[-20,-11]],[[5847,3677],[-121,-2]],[[5645,3651],[-23,87]],[[5622,3738],[202,60]],[[5884,3761],[0,-62]],[[2370,2557],[28,2]],[[2398,2559],[1,-184]],[[2399,2375],[-143,0]],[[2181,2388],[-17,174]],[[1884,1766],[-3,-22]],[[1791,1789],[-55,29]],[[1725,1822],[3,143],[-2,39]],[[1726,2004],[159,-2]],[[1885,2002],[-1,-236]],[[1977,2485],[105,-90],[35,-34]],[[2117,2361],[85,-107]],[[2202,2254],[-4,-68]],[[2198,2186],[-116,-1],[0,-63]],[[2082,2122],[-74,-1],[-22,106]],[[2033,2000],[-26,121],[75,1]],[[2198,2186],[1,-188]],[[2199,1998],[-166,2]],[[2562,3365],[-3,0]],[[2559,3365],[-25,-11]],[[2534,3354],[-52,-16]],[[2482,3338],[-79,119],[-25,98]],[[2378,3555],[66,0]],[[2524,3563],[-1,-26]],[[2176,3301],[0,118]],[[2321,3555],[57,0]],[[2482,3338],[-9,-4]],[[2473,3334],[6,-13]],[[2479,3321],[-35,-1]],[[2444,3320],[-40,-5],[-200,-11],[-28,-3]],[[2827,3402],[-9,70],[38,5]],[[2857,3484],[99,-41]],[[2956,3443],[-12,-53]],[[2944,3390],[3,-67]],[[903,2812],[-114,0]],[[789,2812],[-1,121]],[[788,2933],[115,0]],[[656,2812],[0,121]],[[656,2933],[132,0]],[[789,2812],[-133,0]],[[752,2716],[-148,-1],[-36,-26]],[[568,2689],[-63,122]],[[505,2811],[247,1]],[[752,2812],[0,-96]],[[905,2689],[29,1]],[[934,2690],[0,-31],[20,-32],[55,-50]],[[1009,2577],[-4,-8]],[[1005,2569],[-254,-1]],[[751,2568],[1,148]],[[752,2716],[84,0],[0,-32],[69,54],[0,-49]],[[326,2895],[4,-12],[-37,-19]],[[368,2629],[-6,-2],[-95,251]],[[1020,2689],[-115,0]],[[752,2812],[238,0]],[[1022,2838],[0,-3]],[[1022,2835],[-2,0]],[[1020,2835],[0,-146]],[[568,2689],[-33,-31]],[[535,2658],[-31,-7]],[[504,2651],[-18,13]],[[486,2664],[-2,5]],[[484,2669],[-31,5]],[[367,2883],[77,0],[-1,-70]],[[443,2813],[62,-2]],[[673,2933],[-1,243],[231,0]],[[903,3176],[0,-243]],[[903,2933],[-230,0]],[[583,2610],[10,-69]],[[593,2541],[-74,-30]],[[519,2511],[-33,153]],[[504,2651],[31,7]],[[568,2689],[10,-18],[5,-61]],[[751,2568],[-36,0]],[[721,2529],[-42,-16],[-9,52]],[[591,2541],[2,0]],[[593,2541],[-10,69]],[[749,2057],[-27,5],[-140,14]],[[709,2307],[40,-250]],[[4164,1182],[-80,0]],[[4084,1182],[-13,51],[-1,49]],[[4317,1163],[-76,1],[-30,13]],[[4209,1285],[109,0]],[[4043,1402],[26,-63]],[[4069,1339],[1,-97],[14,-60]],[[4084,1182],[-19,0]],[[4065,1182],[-150,141]],[[3915,1323],[0,101]],[[4166,977],[-42,-18],[-33,-25]],[[4004,933],[-17,-9]],[[3987,924],[-17,50],[-39,26],[0,30],[-115,0]],[[3816,1182],[249,0]],[[4065,1182],[53,-55],[48,-150]],[[3987,924],[-19,-28]],[[3968,896],[-123,66]],[[3845,962],[-1,4]],[[3844,966],[-29,-10]],[[4312,1054],[-13,-13]],[[4065,1182],[128,-1]],[[4193,1181],[50,-17],[74,-1]],[[3934,811],[-185,70],[11,50]],[[3758,937],[86,29]],[[3845,962],[122,-66]],[[4740,1982],[0,13]],[[4779,1965],[29,0],[10,32]],[[4853,1999],[1,-77],[-59,-35]],[[4613,1889],[-1,71]],[[4612,1960],[-5,54]],[[4607,2014],[95,-35]],[[2428,3758],[-106,0]],[[2322,3758],[1,97]],[[2427,3859],[1,-101]],[[2524,3987],[-1,-229]],[[2523,3758],[-95,0]],[[2428,3758],[0,230]],[[2428,3988],[96,-1]],[[2642,3838],[-118,61]],[[2524,3899],[0,88]],[[2524,3987],[126,-1]],[[2661,3917],[-19,-79]],[[2639,3750],[-116,8]],[[2523,3758],[1,141]],[[2642,3838],[-11,-43]],[[3368,3778],[-25,-292]],[[3343,3486],[-4,-23]],[[3339,3463],[-59,24]],[[3179,3537],[80,242]],[[3259,3779],[37,5],[72,-6]],[[3115,3570],[-19,-23]],[[3096,3547],[-34,-105]],[[2964,3477],[-8,-34]],[[2956,3443],[-34,15]],[[2922,3458],[-12,226]],[[2910,3684],[205,-114]],[[3124,3368],[-83,9]],[[3041,3377],[55,170]],[[3115,3570],[64,-33]],[[2946,2836],[22,0]],[[2968,2836],[0,-65]],[[3026,2612],[-46,-103],[-16,-99]],[[2954,2373],[-363,1]],[[2591,2374],[-28,450]],[[2563,2824],[162,6],[103,-10]],[[2935,2835],[-1,12]],[[1902,2297],[-54,0],[-18,-18],[-2,-80],[-16,-10],[-86,0]],[[1726,2368],[189,-1]],[[1915,2367],[-13,-70]],[[2762,3322],[-149,-1]],[[2613,3321],[-3,60]],[[2610,3381],[25,9]],[[2669,3401],[40,15],[31,-5]],[[2740,3411],[9,5]],[[2619,3197],[-6,124]],[[2776,3199],[-157,-2]],[[2485,3197],[-131,-1]],[[2354,3196],[-23,115],[113,9]],[[2479,3321],[6,-124]],[[2485,3197],[-5,121],[-7,16]],[[2473,3334],[61,20]],[[2559,3365],[51,16]],[[2610,3381],[9,-184]],[[2619,3197],[-134,0]],[[2489,3132],[0,-13],[58,0],[2,-45]],[[2549,3074],[-171,-3]],[[2378,3071],[-24,125]],[[2485,3197],[2,-39]],[[2487,3158],[2,-26]],[[729,2052],[0,-196]],[[729,1856],[-68,15],[-46,33]],[[584,1915],[3,11]],[[1537,2811],[-172,0]],[[1537,3049],[0,-238]],[[1041,2569],[-37,-3]],[[1004,2566],[5,11]],[[934,2690],[86,-1]],[[1020,2689],[0,146]],[[1020,2835],[11,6]],[[1031,2841],[91,37]],[[1122,2878],[6,-29]],[[1137,2569],[-96,0]],[[1543,2608],[-178,68]],[[1365,2811],[230,0]],[[1595,2811],[-1,-215]],[[4472,920],[1,-20],[-293,-199],[-12,-12]],[[4166,977],[16,-33],[89,-122]],[[3542,1182],[-1,61]],[[3541,1243],[131,0]],[[3672,1243],[0,-61]],[[3672,1182],[-130,0]],[[3124,1425],[-73,0]],[[3051,1425],[0,120],[73,1]],[[3177,2343],[-40,-17]],[[3125,2502],[51,0]],[[3470,1304],[86,-1]],[[3556,1243],[-15,0]],[[3542,1182],[-72,0]],[[3614,1424],[0,-60],[-144,0]],[[3470,1364],[0,89]],[[3470,1453],[9,-8]],[[3477,1442],[21,-17]],[[3800,1528],[0,-94]],[[3800,1434],[-6,-9]],[[3794,1425],[-86,-1]],[[3708,1424],[-24,28],[-12,33]],[[3685,1546],[0,-17]],[[3822,1528],[-22,0]],[[3916,1528],[-1,-205]],[[3915,1323],[-105,96]],[[3810,1419],[-10,15]],[[3800,1528],[112,0]],[[3916,1532],[0,-4]],[[4261,1543],[0,-138]],[[4261,1405],[-109,1]],[[4140,1527],[-109,1]],[[4031,1770],[142,0]],[[5073,3548],[-113,2],[0,246]],[[4960,3796],[116,0],[0,-196]],[[5348,3914],[104,-89],[-86,-142]],[[5366,3683],[-152,133]],[[5273,3880],[50,17]],[[2639,3750],[30,-153]],[[2669,3597],[-69,0]],[[2650,3074],[-101,0]],[[2489,3132],[-2,26]],[[2485,3197],[77,0]],[[2171,3064],[-18,88],[43,1]],[[2378,3071],[-61,-31]],[[2317,3040],[-39,-5],[-102,-4]],[[1902,2297],[-16,-82]],[[1726,2004],[0,185]],[[2821,2820],[-105,10],[-319,-11]],[[2395,2938],[278,10]],[[2673,2948],[-6,127]],[[2667,3075],[124,0]],[[2117,2361],[-140,124]],[[1921,2572],[-5,48],[155,85],[91,8]],[[2162,2713],[2,-152],[19,-194]],[[2591,2374],[-192,1]],[[2398,2559],[181,6]],[[2579,2565],[12,-191]],[[2673,2948],[-169,-6]],[[2498,3073],[169,2]],[[4146,3210],[-67,0]],[[4031,3272],[0,27]],[[4031,3299],[115,1]],[[4146,3300],[0,-90]],[[4956,3476],[2,-50]],[[4837,3348],[-19,18],[-59,73]],[[4731,3551],[157,0]],[[4888,3551],[31,-50],[37,-30]],[[3180,3325],[34,-7]],[[3207,3202],[-79,-1]],[[3128,3201],[-6,117]],[[3122,3318],[-2,-7]],[[3120,3311],[1,52]],[[3121,3363],[2,0]],[[3123,3363],[56,-1]],[[3121,3363],[-1,-52]],[[3122,3318],[6,-117]],[[3128,3201],[-72,-1]],[[3056,3200],[-8,176]],[[3048,3376],[75,-13]]],"transform":{"scale":[0.00007545427288195671,0.000059834343399504386],"translate":[-118.42944700025993,33.70460726551726]},"objects":{"cali":{"type":"GeometryCollection","geometries":[{"arcs":[[0,1,2,3]],"type":"Polygon","properties":{"Tract_1":6037573003,"Percentile":"91-95%","Population":1802,"County":"Los Angeles","ZIP":90806,"City":"Long Beach","CIscore":52.24,"CIscoreP":"91","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":29.12,"DPM_pctl":84,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":15151.88,"TR_pctl":97,"Traffic":1062.94,"Traff_Pctl":"70","Cleanups":0,"Clean_Pctl":0,"Groundwate":19.5,"GW_pctl":70,"Haz_Waste":1.03,"Haz_pctl":87,"Imp__Water":11,"IWB_pctl":90,"Solid_Wast":1,"Solid_pctl":33,"PollutionS":6.6,"Poll_pctl":81,"Asthma":87.72,"Asthma_Pct":88,"Low_Birth_":6.45,"LBW_pctl":"84","Cardiovasc":9.81,"CVD_pctl":73,"Education":28.2,"Edu_pctl":"74","Linguistic":18.3,"Ling_pctl":"81","Poverty":42.8,"Pov_pctl":"64","Unemployme":7.6,"Unem_pctl":"35","Housing_Bu":47.6,"HB_pctl":"100","PopCharSco":7.92,"Pop_Pctl":"89","Children__":13.5,"Pop_11_64_":78.7,"Elderly___":7.8,"Hispanic__":"46.6","White____":"18.7","African_Am":"14.8","Native_Ame":"0.4","Asian_Amer":"16.9","Other____":"2.6","Shape_Leng":2746.79381367,"Shape_Area":449705.24952}},{"arcs":[[4,5,6,7,8]],"type":"Polygon","properties":{"Tract_1":6037571704,"Percentile":"66-70%","Population":4107,"County":"Los Angeles","ZIP":90805,"City":"Long Beach","CIscore":35.48,"CIscoreP":"69","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":21.64,"DPM_pctl":66,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5732.62,"TR_pctl":83,"Traffic":538.42,"Traff_Pctl":"35","Cleanups":0,"Clean_Pctl":0,"Groundwate":2,"GW_pctl":14,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":12,"IWB_pctl":91,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.39,"Poll_pctl":34,"Asthma":71.39,"Asthma_Pct":80,"Low_Birth_":6.2,"LBW_pctl":"80","Cardiovasc":8.8,"CVD_pctl":61,"Education":33.4,"Edu_pctl":"80","Linguistic":14.9,"Ling_pctl":"74","Poverty":57.6,"Pov_pctl":"82","Unemployme":14.2,"Unem_pctl":"81","Housing_Bu":35.9,"HB_pctl":"95","PopCharSco":8.09,"Pop_Pctl":"91","Children__":17.7,"Pop_11_64_":76.9,"Elderly___":5.4,"Hispanic__":"59.6","White____":"7","African_Am":"16.2","Native_Ame":"0.3","Asian_Amer":"15","Other____":"1.9","Shape_Leng":3409.73429538,"Shape_Area":481164.376322}},{"arcs":[[9,10,11,12,13,14]],"type":"Polygon","properties":{"Tract_1":6037570403,"Percentile":"96-100%","Population":4587,"County":"Los Angeles","ZIP":90805,"City":"Long Beach","CIscore":58.76,"CIscoreP":"96","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":29.03,"DPM_pctl":83,"DrinkingWa":447.31,"DW_pctl":"46","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6310.94,"TR_pctl":86,"Traffic":1372.36,"Traff_Pctl":"80","Cleanups":2.1,"Clean_Pctl":28,"Groundwate":9.75,"GW_pctl":48,"Haz_Waste":0.32,"Haz_pctl":70,"Imp__Water":9,"IWB_pctl":81,"Solid_Wast":1.25,"Solid_pctl":37,"PollutionS":6.96,"Poll_pctl":86,"Asthma":75.7,"Asthma_Pct":82,"Low_Birth_":5.59,"LBW_pctl":"68","Cardiovasc":9.45,"CVD_pctl":68,"Education":47.2,"Edu_pctl":"92","Linguistic":19.6,"Ling_pctl":"84","Poverty":64.9,"Pov_pctl":"89","Unemployme":16.7,"Unem_pctl":"90","Housing_Bu":35.2,"HB_pctl":"95","PopCharSco":8.44,"Pop_Pctl":"94","Children__":20,"Pop_11_64_":75.3,"Elderly___":4.7,"Hispanic__":"76.8","White____":"2.5","African_Am":"15.3","Native_Ame":"0.1","Asian_Amer":"4.4","Other____":"0.9","Shape_Leng":3222.65443977,"Shape_Area":571871.004719}},{"arcs":[[15,16,17,18,19]],"type":"Polygon","properties":{"Tract_1":6037553503,"Percentile":"71-75%","Population":2768,"County":"Los Angeles","ZIP":90723,"City":"Paramount","CIscore":36.81,"CIscoreP":"71","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":20.99,"DPM_pctl":65,"DrinkingWa":375.24,"DW_pctl":"39","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6032.26,"TR_pctl":85,"Traffic":2848.92,"Traff_Pctl":"97","Cleanups":0,"Clean_Pctl":0,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.1,"Haz_pctl":43,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":1.25,"Solid_pctl":37,"PollutionS":6.02,"Poll_pctl":69,"Asthma":33.98,"Asthma_Pct":32,"Low_Birth_":5.9,"LBW_pctl":"74","Cardiovasc":6.53,"CVD_pctl":31,"Education":33.6,"Edu_pctl":"80","Linguistic":13.4,"Ling_pctl":"71","Poverty":45.4,"Pov_pctl":"67","Unemployme":13,"Unem_pctl":"76","Housing_Bu":22,"HB_pctl":"67","PopCharSco":6.11,"Pop_Pctl":"63","Children__":17.9,"Pop_11_64_":76.4,"Elderly___":5.7,"Hispanic__":"78.7","White____":"4.5","African_Am":"13.6","Native_Ame":"0.1","Asian_Amer":"2","Other____":"1.2","Shape_Leng":2897.28470438,"Shape_Area":424001.275557}},{"arcs":[[20,21,22,23,24,25]],"type":"Polygon","properties":{"Tract_1":6037552302,"Percentile":"91-95%","Population":3648,"County":"Los Angeles","ZIP":90650,"City":"Norwalk","CIscore":53.02,"CIscoreP":"92","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":29.85,"DPM_pctl":85,"DrinkingWa":481.92,"DW_pctl":"51","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5287.99,"TR_pctl":81,"Traffic":1274.82,"Traff_Pctl":"77","Cleanups":17.55,"Clean_Pctl":81,"Groundwate":22.25,"GW_pctl":74,"Haz_Waste":0.34,"Haz_pctl":71,"Imp__Water":2,"IWB_pctl":29,"Solid_Wast":3.25,"Solid_pctl":63,"PollutionS":7.51,"Poll_pctl":93,"Asthma":58.84,"Asthma_Pct":68,"Low_Birth_":6.06,"LBW_pctl":"78","Cardiovasc":12.55,"CVD_pctl":91,"Education":14.6,"Edu_pctl":"51","Linguistic":14.8,"Ling_pctl":"74","Poverty":25.4,"Pov_pctl":"37","Unemployme":8.9,"Unem_pctl":"47","Housing_Bu":25.6,"HB_pctl":"78","PopCharSco":7.06,"Pop_Pctl":"77","Children__":12.7,"Pop_11_64_":68.7,"Elderly___":18.6,"Hispanic__":"60.6","White____":"18.7","African_Am":"5.4","Native_Ame":"0.2","Asian_Amer":"13.4","Other____":"1.7","Shape_Leng":4583.17441535,"Shape_Area":955186.134683}},{"arcs":[[26,27,28,29,30]],"type":"Polygon","properties":{"Tract_1":6037503104,"Percentile":"76-80%","Population":2719,"County":"Los Angeles","ZIP":90605,"City":"Whittier","CIscore":42.43,"CIscoreP":"79","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":29.02,"DPM_pctl":83,"DrinkingWa":491.78,"DW_pctl":"52","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5350.56,"TR_pctl":82,"Traffic":466.05,"Traff_Pctl":"27","Cleanups":15.6,"Clean_Pctl":78,"Groundwate":6.85,"GW_pctl":39,"Haz_Waste":0.08,"Haz_pctl":31,"Imp__Water":2,"IWB_pctl":29,"Solid_Wast":9,"Solid_pctl":87,"PollutionS":6.62,"Poll_pctl":81,"Asthma":46.81,"Asthma_Pct":52,"Low_Birth_":4.67,"LBW_pctl":"43","Cardiovasc":8.82,"CVD_pctl":61,"Education":38.5,"Edu_pctl":"86","Linguistic":11.7,"Ling_pctl":"65","Poverty":44.2,"Pov_pctl":"66","Unemployme":13.1,"Unem_pctl":"76","Housing_Bu":21.5,"HB_pctl":"65","PopCharSco":6.41,"Pop_Pctl":"68","Children__":18.7,"Pop_11_64_":74.6,"Elderly___":6.7,"Hispanic__":"88.6","White____":"7.9","African_Am":"0.1","Native_Ame":"0.1","Asian_Amer":"2.3","Other____":"1","Shape_Leng":3332.53325699,"Shape_Area":546867.702129}},{"arcs":[[31,32,33,34,35]],"type":"Polygon","properties":{"Tract_1":6037550202,"Percentile":"76-80%","Population":5496,"County":"Los Angeles","ZIP":90650,"City":"Norwalk","CIscore":39.52,"CIscoreP":"75","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":26.94,"DPM_pctl":80,"DrinkingWa":570.73,"DW_pctl":"60","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5527.73,"TR_pctl":83,"Traffic":1434.71,"Traff_Pctl":"82","Cleanups":4.4,"Clean_Pctl":40,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.12,"Haz_pctl":47,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":5.94,"Poll_pctl":67,"Asthma":62.88,"Asthma_Pct":72,"Low_Birth_":4.59,"LBW_pctl":"41","Cardiovasc":13.42,"CVD_pctl":94,"Education":26.5,"Edu_pctl":"72","Linguistic":12.4,"Ling_pctl":"67","Poverty":44.9,"Pov_pctl":"67","Unemployme":7.9,"Unem_pctl":"38","Housing_Bu":18.3,"HB_pctl":"52","PopCharSco":6.66,"Pop_Pctl":"72","Children__":12.8,"Pop_11_64_":77,"Elderly___":10.2,"Hispanic__":"71.5","White____":"15.5","African_Am":"3.9","Native_Ame":"0.4","Asian_Amer":"6.9","Other____":"1.7","Shape_Leng":5090.76363158,"Shape_Area":1265811.92101}},{"arcs":[[-36,36]],"type":"Polygon","properties":{"Tract_1":6037550201,"Percentile":"76-80%","Population":2941,"County":"Los Angeles","ZIP":90650,"City":"Norwalk","CIscore":42.03,"CIscoreP":"79","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":26.99,"DPM_pctl":80,"DrinkingWa":507.71,"DW_pctl":"54","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5613.48,"TR_pctl":83,"Traffic":2159.22,"Traff_Pctl":"92","Cleanups":7,"Clean_Pctl":52,"Groundwate":6.75,"GW_pctl":38,"Haz_Waste":0.07,"Haz_pctl":29,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":6.27,"Poll_pctl":75,"Asthma":53.16,"Asthma_Pct":60,"Low_Birth_":5.77,"LBW_pctl":"72","Cardiovasc":11.33,"CVD_pctl":85,"Education":28.8,"Edu_pctl":"75","Linguistic":13.8,"Ling_pctl":"72","Poverty":37.9,"Pov_pctl":"57","Unemployme":5.9,"Unem_pctl":"20","Housing_Bu":20.4,"HB_pctl":"61","PopCharSco":6.71,"Pop_Pctl":"72","Children__":15.5,"Pop_11_64_":76.1,"Elderly___":8.4,"Hispanic__":"81.3","White____":"9.6","African_Am":"2.3","Native_Ame":"0.2","Asian_Amer":"5.6","Other____":"1","Shape_Leng":3903.98270056,"Shape_Area":568906.126825}},{"arcs":[[37,38,39,40,41,42,43,44]],"type":"Polygon","properties":{"Tract_1":6037544002,"Percentile":"76-80%","Population":3142,"County":"Los Angeles","ZIP":90810,"City":"Long Beach","CIscore":39.98,"CIscoreP":"76","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":26.67,"DPM_pctl":80,"DrinkingWa":182.06,"DW_pctl":"14","Pesticides":5.027,"Pest_pctl":53,"Tox_Releas":7854.7,"TR_pctl":90,"Traffic":2605.85,"Traff_Pctl":"96","Cleanups":7.75,"Clean_Pctl":55,"Groundwate":21.75,"GW_pctl":73,"Haz_Waste":1.94,"Haz_pctl":91,"Imp__Water":12,"IWB_pctl":91,"Solid_Wast":6,"Solid_pctl":79,"PollutionS":8.24,"Poll_pctl":97,"Asthma":72.09,"Asthma_Pct":80,"Low_Birth_":4.07,"LBW_pctl":"28","Cardiovasc":9.55,"CVD_pctl":70,"Education":28.9,"Edu_pctl":"75","Linguistic":7.6,"Ling_pctl":"49","Poverty":17.2,"Pov_pctl":"21","Unemployme":6.4,"Unem_pctl":"24","Housing_Bu":6.3,"HB_pctl":"3","PopCharSco":4.85,"Pop_Pctl":"45","Children__":14,"Pop_11_64_":76.1,"Elderly___":9.9,"Hispanic__":"62.2","White____":"12.3","African_Am":"4.5","Native_Ame":"0.1","Asian_Amer":"18.7","Other____":"2.3","Shape_Leng":4537.84543347,"Shape_Area":1146103.8946}},{"arcs":[[45,46,-38,47,48,49,50]],"type":"Polygon","properties":{"Tract_1":6037544001,"Percentile":"81-85%","Population":4791,"County":"Los Angeles","ZIP":90810,"City":"Long Beach","CIscore":46.63,"CIscoreP":"85","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":26.01,"DPM_pctl":78,"DrinkingWa":182.06,"DW_pctl":"14","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8128.07,"TR_pctl":91,"Traffic":1040.5,"Traff_Pctl":"69","Cleanups":8.05,"Clean_Pctl":56,"Groundwate":28,"GW_pctl":80,"Haz_Waste":1.32,"Haz_pctl":89,"Imp__Water":13,"IWB_pctl":93,"Solid_Wast":2.75,"Solid_pctl":59,"PollutionS":7.2,"Poll_pctl":89,"Asthma":72.09,"Asthma_Pct":80,"Low_Birth_":4.02,"LBW_pctl":"27","Cardiovasc":9.55,"CVD_pctl":70,"Education":31.1,"Edu_pctl":"78","Linguistic":9.4,"Ling_pctl":"57","Poverty":40.3,"Pov_pctl":"60","Unemployme":13.3,"Unem_pctl":"77","Housing_Bu":20.1,"HB_pctl":"59","PopCharSco":6.48,"Pop_Pctl":"69","Children__":15.1,"Pop_11_64_":76.6,"Elderly___":8.3,"Hispanic__":"69.2","White____":"7.1","African_Am":"7.3","Native_Ame":"0.1","Asian_Amer":"14.8","Other____":"1.6","Shape_Leng":6349.76050614,"Shape_Area":2285664.55985}},{"arcs":[[51,52,53,54,55,56]],"type":"Polygon","properties":{"Tract_1":6037543905,"Percentile":"86-90%","Population":4510,"County":"Los Angeles","ZIP":90745,"City":"Carson","CIscore":49.87,"CIscoreP":"89","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":24.32,"DPM_pctl":74,"DrinkingWa":213.96,"DW_pctl":"17","Pesticides":0,"Pest_pctl":0,"Tox_Releas":9443.82,"TR_pctl":93,"Traffic":468.98,"Traff_Pctl":"28","Cleanups":1.9,"Clean_Pctl":25,"Groundwate":24.6,"GW_pctl":76,"Haz_Waste":11.57,"Haz_pctl":100,"Imp__Water":11,"IWB_pctl":90,"Solid_Wast":0.9,"Solid_pctl":24,"PollutionS":6.21,"Poll_pctl":74,"Asthma":56.61,"Asthma_Pct":65,"Low_Birth_":7.79,"LBW_pctl":"96","Cardiovasc":9.31,"CVD_pctl":67,"Education":38.7,"Edu_pctl":"86","Linguistic":14.1,"Ling_pctl":"72","Poverty":45.5,"Pov_pctl":"68","Unemployme":18.9,"Unem_pctl":"94","Housing_Bu":24.6,"HB_pctl":"76","PopCharSco":8.03,"Pop_Pctl":"90","Children__":16,"Pop_11_64_":76.6,"Elderly___":7.4,"Hispanic__":"76.3","White____":"3.4","African_Am":"9.7","Native_Ame":"0.2","Asian_Amer":"9.3","Other____":"1.2","Shape_Leng":7389.0097677,"Shape_Area":2748144.06886}},{"arcs":[[57,58,59,60,61,62]],"type":"Polygon","properties":{"Tract_1":6037297602,"Percentile":"56-60%","Population":3503,"County":"Los Angeles","ZIP":90731,"City":"San Pedro","CIscore":27.6,"CIscoreP":"55","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":51.22,"DPM_pctl":96,"DrinkingWa":198.88,"DW_pctl":"15","Pesticides":0,"Pest_pctl":0,"Tox_Releas":4734.63,"TR_pctl":79,"Traffic":369.17,"Traff_Pctl":"18","Cleanups":14.25,"Clean_Pctl":76,"Groundwate":122.5,"GW_pctl":98,"Haz_Waste":0.05,"Haz_pctl":26,"Imp__Water":9,"IWB_pctl":81,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.9,"Poll_pctl":67,"Asthma":84.98,"Asthma_Pct":88,"Low_Birth_":2.26,"LBW_pctl":"3","Cardiovasc":9.68,"CVD_pctl":71,"Education":11.6,"Edu_pctl":"44","Linguistic":2.2,"Ling_pctl":"16","Poverty":22.4,"Pov_pctl":"31","Unemployme":11.9,"Unem_pctl":"69","Housing_Bu":11.8,"HB_pctl":"20","PopCharSco":4.68,"Pop_Pctl":"42","Children__":10.3,"Pop_11_64_":77.1,"Elderly___":12.6,"Hispanic__":"32.3","White____":"53.4","African_Am":"5.9","Native_Ame":"0.7","Asian_Amer":"4.5","Other____":"3.3","Shape_Leng":3741.78545406,"Shape_Area":618096.584351}},{"arcs":[[63,-58,64,65,66,67]],"type":"Polygon","properties":{"Tract_1":6037297601,"Percentile":"61-65%","Population":2594,"County":"Los Angeles","ZIP":90731,"City":"San Pedro","CIscore":32.13,"CIscoreP":"63","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":26.52,"DPM_pctl":80,"DrinkingWa":417.79,"DW_pctl":"43","Pesticides":0,"Pest_pctl":0,"Tox_Releas":4588.15,"TR_pctl":79,"Traffic":277.22,"Traff_Pctl":"10","Cleanups":16.35,"Clean_Pctl":79,"Groundwate":68.5,"GW_pctl":95,"Haz_Waste":0.1,"Haz_pctl":43,"Imp__Water":13,"IWB_pctl":93,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":6.18,"Poll_pctl":73,"Asthma":84.98,"Asthma_Pct":88,"Low_Birth_":4.29,"LBW_pctl":"33","Cardiovasc":9.68,"CVD_pctl":71,"Education":4.2,"Edu_pctl":"16","Linguistic":2.8,"Ling_pctl":"21","Poverty":24,"Pov_pctl":"34","Unemployme":9.7,"Unem_pctl":"54","Housing_Bu":19.4,"HB_pctl":"56","PopCharSco":5.2,"Pop_Pctl":"50","Children__":15.8,"Pop_11_64_":76.3,"Elderly___":7.9,"Hispanic__":"26.9","White____":"50.1","African_Am":"11.1","Native_Ame":"0.5","Asian_Amer":"5.8","Other____":"5.4","Shape_Leng":7315.09459086,"Shape_Area":694022.814005}},{"arcs":[[68,69,70,71,72]],"type":"Polygon","properties":{"Tract_1":6037502802,"Percentile":"91-95%","Population":1380,"County":"Los Angeles","ZIP":90670,"City":"Santa Fe Springs","CIscore":53.72,"CIscoreP":"92","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":20.49,"DPM_pctl":63,"DrinkingWa":579.71,"DW_pctl":"61","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5721.32,"TR_pctl":83,"Traffic":711.31,"Traff_Pctl":"51","Cleanups":65.4,"Clean_Pctl":98,"Groundwate":113.85,"GW_pctl":98,"Haz_Waste":1.28,"Haz_pctl":89,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":7.75,"Solid_pctl":85,"PollutionS":7.64,"Poll_pctl":94,"Asthma":52.41,"Asthma_Pct":59,"Low_Birth_":4.9,"LBW_pctl":"50","Cardiovasc":11.03,"CVD_pctl":83,"Education":25.7,"Edu_pctl":"71","Linguistic":29.7,"Ling_pctl":"94","Poverty":55.1,"Pov_pctl":"79","Unemployme":7.4,"Unem_pctl":"33","Housing_Bu":26.4,"HB_pctl":"80","PopCharSco":7.03,"Pop_Pctl":"77","Children__":10.3,"Pop_11_64_":55.7,"Elderly___":34,"Hispanic__":"65.8","White____":"13.5","African_Am":"8.6","Native_Ame":"0.4","Asian_Amer":"11.1","Other____":"0.7","Shape_Leng":11156.2588864,"Shape_Area":3821273.08328}},{"arcs":[[73,74,75,76,77]],"type":"Polygon","properties":{"Tract_1":6037577504,"Percentile":"16-20%","Population":1448,"County":"Los Angeles","ZIP":90803,"City":"Long Beach","CIscore":11.68,"CIscoreP":"17","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":12.78,"DPM_pctl":38,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8896.46,"TR_pctl":92,"Traffic":567.56,"Traff_Pctl":"38","Cleanups":0.9,"Clean_Pctl":13,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":11,"IWB_pctl":90,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.18,"Poll_pctl":29,"Asthma":28.26,"Asthma_Pct":22,"Low_Birth_":0,"LBW_pctl":"NA","Cardiovasc":7.63,"CVD_pctl":46,"Education":3.8,"Edu_pctl":"14","Linguistic":3.9,"Ling_pctl":"29","Poverty":16.2,"Pov_pctl":"19","Unemployme":4,"Unem_pctl":"6","Housing_Bu":16.7,"HB_pctl":"44","PopCharSco":2.79,"Pop_Pctl":"16","Children__":5.1,"Pop_11_64_":76.9,"Elderly___":18,"Hispanic__":"10.7","White____":"81.3","African_Am":"1","Native_Ame":"0.3","Asian_Amer":"3.7","Other____":"2.9","Shape_Leng":5052.76808154,"Shape_Area":569748.725438}},{"arcs":[[78,79,80,81]],"type":"Polygon","properties":{"Tract_1":6037576903,"Percentile":"76-80%","Population":3802,"County":"Los Angeles","ZIP":90804,"City":"Long Beach","CIscore":40.16,"CIscoreP":"76","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":23.31,"DPM_pctl":71,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8088.67,"TR_pctl":90,"Traffic":1181.92,"Traff_Pctl":"75","Cleanups":0,"Clean_Pctl":0,"Groundwate":23,"GW_pctl":75,"Haz_Waste":2.04,"Haz_pctl":92,"Imp__Water":4,"IWB_pctl":49,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.91,"Poll_pctl":67,"Asthma":86.52,"Asthma_Pct":88,"Low_Birth_":5.15,"LBW_pctl":"57","Cardiovasc":10.65,"CVD_pctl":80,"Education":28.8,"Edu_pctl":"75","Linguistic":5.6,"Ling_pctl":"40","Poverty":60.4,"Pov_pctl":"85","Unemployme":3.9,"Unem_pctl":"6","Housing_Bu":24.6,"HB_pctl":"76","PopCharSco":6.8,"Pop_Pctl":"73","Children__":16.5,"Pop_11_64_":80.3,"Elderly___":3.2,"Hispanic__":"58.2","White____":"12.9","African_Am":"16.4","Native_Ame":"0.3","Asian_Amer":"9.1","Other____":"3","Shape_Leng":2419.3622066,"Shape_Area":324662.512121}},{"arcs":[[82,83,84,85]],"type":"Polygon","properties":{"Tract_1":6037576302,"Percentile":"91-95%","Population":4101,"County":"Los Angeles","ZIP":90813,"City":"Long Beach","CIscore":53.03,"CIscoreP":"92","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":150.68,"DPM_pctl":100,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":9687.78,"TR_pctl":93,"Traffic":816.87,"Traff_Pctl":"58","Cleanups":0.25,"Clean_Pctl":5,"Groundwate":8,"GW_pctl":43,"Haz_Waste":0.11,"Haz_pctl":46,"Imp__Water":4,"IWB_pctl":49,"Solid_Wast":1.1,"Solid_pctl":33,"PollutionS":5.75,"Poll_pctl":63,"Asthma":130.75,"Asthma_Pct":98,"Low_Birth_":8.56,"LBW_pctl":"98","Cardiovasc":12.73,"CVD_pctl":92,"Education":39.6,"Edu_pctl":"86","Linguistic":14.2,"Ling_pctl":"73","Poverty":62.6,"Pov_pctl":"87","Unemployme":15.4,"Unem_pctl":"86","Housing_Bu":25.4,"HB_pctl":"78","PopCharSco":9.22,"Pop_Pctl":"99","Children__":17.5,"Pop_11_64_":78.6,"Elderly___":3.9,"Hispanic__":"59.4","White____":"7.8","African_Am":"16.6","Native_Ame":"0.1","Asian_Amer":"14.1","Other____":"2.1","Shape_Leng":2413.13069885,"Shape_Area":323449.3877}},{"arcs":[[86,87,88,-83]],"type":"Polygon","properties":{"Tract_1":6037576301,"Percentile":"91-95%","Population":4176,"County":"Los Angeles","ZIP":90813,"City":"Long Beach","CIscore":53.26,"CIscoreP":"92","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":146.4,"DPM_pctl":100,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":2.366,"Pest_pctl":46,"Tox_Releas":10441.3,"TR_pctl":94,"Traffic":638.29,"Traff_Pctl":"45","Cleanups":0.5,"Clean_Pctl":8,"Groundwate":6.85,"GW_pctl":39,"Haz_Waste":0.16,"Haz_pctl":55,"Imp__Water":15,"IWB_pctl":96,"Solid_Wast":1.1,"Solid_pctl":33,"PollutionS":6.61,"Poll_pctl":81,"Asthma":122.65,"Asthma_Pct":97,"Low_Birth_":5.24,"LBW_pctl":"59","Cardiovasc":11.97,"CVD_pctl":88,"Education":25.5,"Edu_pctl":"71","Linguistic":13.5,"Ling_pctl":"71","Poverty":62.5,"Pov_pctl":"87","Unemployme":10,"Unem_pctl":"56","Housing_Bu":28.7,"HB_pctl":"85","PopCharSco":8.06,"Pop_Pctl":"90","Children__":14.3,"Pop_11_64_":77,"Elderly___":8.7,"Hispanic__":"51.2","White____":"14.7","African_Am":"19.7","Native_Ame":"0.2","Asian_Amer":"11.6","Other____":"2.6","Shape_Leng":2972.29092079,"Shape_Area":548426.279493}},{"arcs":[[89,90,91,92,93,94,95,96,97,98,99,100,101]],"type":"Polygon","properties":{"Tract_1":6037576001,"Percentile":"81-85%","Population":4969,"County":"Los Angeles","ZIP":90802,"City":"Long Beach","CIscore":43.36,"CIscoreP":"81","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":208.4,"DPM_pctl":100,"DrinkingWa":251.9,"DW_pctl":"25","Pesticides":0,"Pest_pctl":0,"Tox_Releas":9179.63,"TR_pctl":93,"Traffic":699.76,"Traff_Pctl":"50","Cleanups":7.25,"Clean_Pctl":53,"Groundwate":14.75,"GW_pctl":59,"Haz_Waste":0.72,"Haz_pctl":83,"Imp__Water":11,"IWB_pctl":90,"Solid_Wast":11,"Solid_pctl":91,"PollutionS":7.38,"Poll_pctl":91,"Asthma":83.08,"Asthma_Pct":87,"Low_Birth_":6.97,"LBW_pctl":"90","Cardiovasc":9.29,"CVD_pctl":66,"Education":4.6,"Edu_pctl":"18","Linguistic":5.9,"Ling_pctl":"41","Poverty":21.8,"Pov_pctl":"30","Unemployme":4.4,"Unem_pctl":"9","Housing_Bu":20.8,"HB_pctl":"62","PopCharSco":5.87,"Pop_Pctl":"60","Children__":4.1,"Pop_11_64_":85.4,"Elderly___":10.5,"Hispanic__":"18.4","White____":"48.3","African_Am":"13","Native_Ame":"0.4","Asian_Amer":"15.4","Other____":"4.6","Shape_Leng":7516.58279041,"Shape_Area":3047267.5548}},{"arcs":[[102,103,104,105,106,107,108]],"type":"Polygon","properties":{"Tract_1":6037650901,"Percentile":"76-80%","Population":5928,"County":"Los Angeles","ZIP":90501,"City":"Torrance","CIscore":39.42,"CIscoreP":"75","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":17.03,"DPM_pctl":52,"DrinkingWa":412.29,"DW_pctl":"43","Pesticides":0,"Pest_pctl":0,"Tox_Releas":13418.99,"TR_pctl":96,"Traffic":872.87,"Traff_Pctl":"61","Cleanups":90.75,"Clean_Pctl":99,"Groundwate":51.05,"GW_pctl":91,"Haz_Waste":6.5,"Haz_pctl":98,"Imp__Water":3,"IWB_pctl":41,"Solid_Wast":6.75,"Solid_pctl":81,"PollutionS":7.66,"Poll_pctl":94,"Asthma":59.34,"Asthma_Pct":68,"Low_Birth_":5.09,"LBW_pctl":"55","Cardiovasc":7.14,"CVD_pctl":39,"Education":11.1,"Edu_pctl":"43","Linguistic":7.8,"Ling_pctl":"50","Poverty":21.7,"Pov_pctl":"30","Unemployme":9.9,"Unem_pctl":"55","Housing_Bu":17.5,"HB_pctl":"48","PopCharSco":5.15,"Pop_Pctl":"49","Children__":11.5,"Pop_11_64_":77.9,"Elderly___":10.6,"Hispanic__":"31.7","White____":"42.9","African_Am":"2.5","Native_Ame":"0.2","Asian_Amer":"18.6","Other____":"4.1","Shape_Leng":9005.14349712,"Shape_Area":3535501.28182}},{"arcs":[[109,110,-106,111,112,113,114,115,116]],"type":"Polygon","properties":{"Tract_1":6037650401,"Percentile":"41-45%","Population":4472,"County":"Los Angeles","ZIP":90503,"City":"Torrance","CIscore":22.87,"CIscoreP":"45","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":17.03,"DPM_pctl":52,"DrinkingWa":221.81,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":33202.06,"TR_pctl":99,"Traffic":759.01,"Traff_Pctl":"54","Cleanups":21.8,"Clean_Pctl":85,"Groundwate":47,"GW_pctl":90,"Haz_Waste":2.58,"Haz_pctl":93,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":7.65,"Solid_pctl":85,"PollutionS":6.86,"Poll_pctl":85,"Asthma":27.69,"Asthma_Pct":21,"Low_Birth_":6.21,"LBW_pctl":"80","Cardiovasc":6.12,"CVD_pctl":25,"Education":4.5,"Edu_pctl":"17","Linguistic":6.7,"Ling_pctl":"45","Poverty":15.8,"Pov_pctl":"18","Unemployme":7.1,"Unem_pctl":"30","Housing_Bu":3.6,"HB_pctl":"1","PopCharSco":3.34,"Pop_Pctl":"23","Children__":12.3,"Pop_11_64_":74.2,"Elderly___":13.5,"Hispanic__":"14.6","White____":"46.3","African_Am":"1","Native_Ame":"0.3","Asian_Amer":"32.7","Other____":"5","Shape_Leng":9798.79375178,"Shape_Area":3512793.06683}},{"arcs":[[117,118,119,120]],"type":"Polygon","properties":{"Tract_1":6037650004,"Percentile":"51-55%","Population":4005,"County":"Los Angeles","ZIP":90504,"City":"Torrance","CIscore":26.27,"CIscoreP":"52","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":22.51,"DPM_pctl":68,"DrinkingWa":188.14,"DW_pctl":"14","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8923.52,"TR_pctl":92,"Traffic":707.39,"Traff_Pctl":"51","Cleanups":0,"Clean_Pctl":0,"Groundwate":2,"GW_pctl":14,"Haz_Waste":0.08,"Haz_pctl":32,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0.1,"Solid_pctl":1,"PollutionS":5.05,"Poll_pctl":47,"Asthma":48.03,"Asthma_Pct":54,"Low_Birth_":4.69,"LBW_pctl":"44","Cardiovasc":7.49,"CVD_pctl":44,"Education":5.9,"Edu_pctl":"24","Linguistic":9.1,"Ling_pctl":"56","Poverty":33,"Pov_pctl":"49","Unemployme":13.2,"Unem_pctl":"77","Housing_Bu":20.6,"HB_pctl":"62","PopCharSco":5.2,"Pop_Pctl":"50","Children__":10.4,"Pop_11_64_":80.1,"Elderly___":9.5,"Hispanic__":"20.6","White____":"27","African_Am":"6.4","Native_Ame":"0.1","Asian_Amer":"41.2","Other____":"4.6","Shape_Leng":3574.9288274,"Shape_Area":766464.67294}},{"arcs":[[121,-118,122]],"type":"Polygon","properties":{"Tract_1":6037650003,"Percentile":"61-65%","Population":3158,"County":"Los Angeles","ZIP":90504,"City":"Torrance","CIscore":31.93,"CIscoreP":"63","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":22.51,"DPM_pctl":68,"DrinkingWa":219.87,"DW_pctl":"17","Pesticides":0,"Pest_pctl":0,"Tox_Releas":9591.45,"TR_pctl":93,"Traffic":1984.85,"Traff_Pctl":"91","Cleanups":2,"Clean_Pctl":27,"Groundwate":3,"GW_pctl":22,"Haz_Waste":0.07,"Haz_pctl":29,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":5.9,"Poll_pctl":67,"Asthma":48.03,"Asthma_Pct":54,"Low_Birth_":4.92,"LBW_pctl":"50","Cardiovasc":7.49,"CVD_pctl":44,"Education":18.9,"Edu_pctl":"60","Linguistic":10.9,"Ling_pctl":"62","Poverty":31.9,"Pov_pctl":"48","Unemployme":7.6,"Unem_pctl":"35","Housing_Bu":23.2,"HB_pctl":"71","PopCharSco":5.41,"Pop_Pctl":"53","Children__":11.3,"Pop_11_64_":78.9,"Elderly___":9.8,"Hispanic__":"27.8","White____":"27","African_Am":"7.5","Native_Ame":"0.1","Asian_Amer":"33","Other____":"4.6","Shape_Leng":2915.97715115,"Shape_Area":500016.355547}},{"arcs":[[123,124,125,126,127]],"type":"Polygon","properties":{"Tract_1":6037621326,"Percentile":"21-25%","Population":3260,"County":"Los Angeles","ZIP":90277,"City":"Redondo Beach","CIscore":14.5,"CIscoreP":"24","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":11.82,"DPM_pctl":34,"DrinkingWa":237.22,"DW_pctl":"24","Pesticides":0,"Pest_pctl":0,"Tox_Releas":4783.22,"TR_pctl":79,"Traffic":784.48,"Traff_Pctl":"56","Cleanups":0,"Clean_Pctl":0,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":8,"IWB_pctl":76,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.33,"Poll_pctl":32,"Asthma":26.64,"Asthma_Pct":19,"Low_Birth_":6.57,"LBW_pctl":"86","Cardiovasc":7.32,"CVD_pctl":42,"Education":0.6,"Edu_pctl":"1","Linguistic":2.6,"Ling_pctl":"19","Poverty":9.9,"Pov_pctl":"7","Unemployme":5,"Unem_pctl":"13","Housing_Bu":16,"HB_pctl":"40","PopCharSco":3.35,"Pop_Pctl":"23","Children__":6.7,"Pop_11_64_":81.7,"Elderly___":11.6,"Hispanic__":"9","White____":"77.1","African_Am":"2.3","Native_Ame":"0.2","Asian_Amer":"8.6","Other____":"2.9","Shape_Leng":4259.59039623,"Shape_Area":876669.448325}},{"arcs":[[-128,128,129,130]],"type":"Polygon","properties":{"Tract_1":6037621324,"Percentile":"16-20%","Population":3842,"County":"Los Angeles","ZIP":90277,"City":"Redondo Beach","CIscore":11.67,"CIscoreP":"17","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":13.92,"DPM_pctl":42,"DrinkingWa":237.22,"DW_pctl":"24","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5886.03,"TR_pctl":84,"Traffic":866.16,"Traff_Pctl":"61","Cleanups":0,"Clean_Pctl":0,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.1,"Haz_pctl":43,"Imp__Water":8,"IWB_pctl":76,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.89,"Poll_pctl":44,"Asthma":26.64,"Asthma_Pct":19,"Low_Birth_":4.66,"LBW_pctl":"43","Cardiovasc":7.32,"CVD_pctl":42,"Education":3,"Edu_pctl":"10","Linguistic":1.3,"Ling_pctl":"8","Poverty":18.6,"Pov_pctl":"24","Unemployme":4.2,"Unem_pctl":"8","Housing_Bu":8.5,"HB_pctl":"8","PopCharSco":2.39,"Pop_Pctl":"11","Children__":6.1,"Pop_11_64_":81,"Elderly___":12.9,"Hispanic__":"11.5","White____":"71.2","African_Am":"2.8","Native_Ame":"0.2","Asian_Amer":"10.5","Other____":"3.8","Shape_Leng":4191.97329101,"Shape_Area":765864.15237}},{"arcs":[[-130,131,132,133]],"type":"Polygon","properties":{"Tract_1":6037621204,"Percentile":"46-50%","Population":3230,"County":"Los Angeles","ZIP":90277,"City":"Redondo Beach","CIscore":24.37,"CIscoreP":"49","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":5.06,"DPM_pctl":14,"DrinkingWa":273.08,"DW_pctl":"28","Pesticides":0.204,"Pest_pctl":26,"Tox_Releas":5692.32,"TR_pctl":83,"Traffic":545.03,"Traff_Pctl":"36","Cleanups":9,"Clean_Pctl":60,"Groundwate":10,"GW_pctl":50,"Haz_Waste":0.35,"Haz_pctl":71,"Imp__Water":8,"IWB_pctl":76,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.74,"Poll_pctl":63,"Asthma":24.11,"Asthma_Pct":14,"Low_Birth_":8.24,"LBW_pctl":"97","Cardiovasc":6.7,"CVD_pctl":33,"Education":5.5,"Edu_pctl":"22","Linguistic":12.5,"Ling_pctl":"68","Poverty":15.2,"Pov_pctl":"17","Unemployme":6.2,"Unem_pctl":"22","Housing_Bu":15.8,"HB_pctl":"39","PopCharSco":4.25,"Pop_Pctl":"36","Children__":4.3,"Pop_11_64_":77.5,"Elderly___":18.2,"Hispanic__":"9.8","White____":"71.2","African_Am":"2.2","Native_Ame":"0.3","Asian_Amer":"13.7","Other____":"2.7","Shape_Leng":4894.36591146,"Shape_Area":1008588.5133}},{"arcs":[[-133,134,135]],"type":"Polygon","properties":{"Tract_1":6037621104,"Percentile":"6-10%","Population":6649,"County":"Los Angeles","ZIP":90254,"City":"Hermosa Beach","CIscore":7.73,"CIscoreP":"8","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":5.62,"DPM_pctl":15,"DrinkingWa":237.22,"DW_pctl":"24","Pesticides":0.072,"Pest_pctl":18,"Tox_Releas":5004.6,"TR_pctl":80,"Traffic":554.15,"Traff_Pctl":"37","Cleanups":4.5,"Clean_Pctl":42,"Groundwate":10,"GW_pctl":50,"Haz_Waste":0.05,"Haz_pctl":26,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.96,"Poll_pctl":46,"Asthma":13.46,"Asthma_Pct":2,"Low_Birth_":4.78,"LBW_pctl":"46","Cardiovasc":5.79,"CVD_pctl":21,"Education":0.2,"Edu_pctl":"0","Linguistic":0.4,"Ling_pctl":"1","Poverty":8.7,"Pov_pctl":"5","Unemployme":3.6,"Unem_pctl":"5","Housing_Bu":12.6,"HB_pctl":"24","PopCharSco":1.56,"Pop_Pctl":"4","Children__":8.1,"Pop_11_64_":86.1,"Elderly___":5.8,"Hispanic__":"8.9","White____":"80.3","African_Am":"1.6","Native_Ame":"0.2","Asian_Amer":"6.2","Other____":"2.9","Shape_Leng":3921.1861107,"Shape_Area":944611.148761}},{"arcs":[[136,137,138,139,140]],"type":"Polygon","properties":{"Tract_1":6037621004,"Percentile":"1-5%","Population":4762,"County":"Los Angeles","ZIP":90254,"City":"Hermosa Beach","CIscore":5.84,"CIscoreP":"4","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":8.3,"DPM_pctl":23,"DrinkingWa":236.67,"DW_pctl":"23","Pesticides":0,"Pest_pctl":0,"Tox_Releas":4273.13,"TR_pctl":78,"Traffic":386.16,"Traff_Pctl":"20","Cleanups":0,"Clean_Pctl":0,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":3.64,"Poll_pctl":19,"Asthma":13.5,"Asthma_Pct":2,"Low_Birth_":3.46,"LBW_pctl":"16","Cardiovasc":5.87,"CVD_pctl":22,"Education":2.6,"Edu_pctl":"8","Linguistic":2.2,"Ling_pctl":"16","Poverty":11.6,"Pov_pctl":"10","Unemployme":8,"Unem_pctl":"39","Housing_Bu":10.6,"HB_pctl":"15","PopCharSco":1.6,"Pop_Pctl":"4","Children__":11,"Pop_11_64_":79,"Elderly___":10,"Hispanic__":"7.5","White____":"84.6","African_Am":"0.6","Native_Ame":"0.2","Asian_Amer":"3.9","Other____":"3.3","Shape_Leng":4809.68004259,"Shape_Area":876871.961137}},{"arcs":[[-137,141,142,143,144,145]],"type":"Polygon","properties":{"Tract_1":6037620904,"Percentile":"1-5%","Population":2888,"County":"Los Angeles","ZIP":90266,"City":"Manhattan Beach","CIscore":3.14,"CIscoreP":"1","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":8.3,"DPM_pctl":23,"DrinkingWa":142.76,"DW_pctl":"9","Pesticides":0,"Pest_pctl":0,"Tox_Releas":3732.67,"TR_pctl":76,"Traffic":429.68,"Traff_Pctl":"24","Cleanups":2.1,"Clean_Pctl":28,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":3.73,"Poll_pctl":20,"Asthma":15.85,"Asthma_Pct":4,"Low_Birth_":1.89,"LBW_pctl":"2","Cardiovasc":4.96,"CVD_pctl":12,"Education":0,"Edu_pctl":"0","Linguistic":0,"Ling_pctl":"0","Poverty":9.5,"Pov_pctl":"6","Unemployme":7.3,"Unem_pctl":"32","Housing_Bu":10.2,"HB_pctl":"13","PopCharSco":0.84,"Pop_Pctl":"1","Children__":12.5,"Pop_11_64_":74.2,"Elderly___":13.3,"Hispanic__":"6.1","White____":"86.5","African_Am":"0.8","Native_Ame":"0","Asian_Amer":"3.9","Other____":"2.8","Shape_Leng":3427.67202017,"Shape_Area":593712.082679}},{"arcs":[[146,-145,147,148,149,150]],"type":"Polygon","properties":{"Tract_1":6037620305,"Percentile":"1-5%","Population":6227,"County":"Los Angeles","ZIP":90266,"City":"Manhattan Beach","CIscore":4.28,"CIscoreP":"2","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":20.42,"DPM_pctl":63,"DrinkingWa":142.35,"DW_pctl":"9","Pesticides":0,"Pest_pctl":0,"Tox_Releas":4604.14,"TR_pctl":79,"Traffic":479.81,"Traff_Pctl":"29","Cleanups":14.25,"Clean_Pctl":76,"Groundwate":0,"GW_pctl":0,"Haz_Waste":6,"Haz_pctl":98,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.48,"Poll_pctl":57,"Asthma":16.77,"Asthma_Pct":5,"Low_Birth_":3.13,"LBW_pctl":"11","Cardiovasc":5.2,"CVD_pctl":14,"Education":0,"Edu_pctl":"0","Linguistic":0,"Ling_pctl":"0","Poverty":7.7,"Pov_pctl":"4","Unemployme":3.7,"Unem_pctl":"5","Housing_Bu":11,"HB_pctl":"17","PopCharSco":0.78,"Pop_Pctl":"1","Children__":11.3,"Pop_11_64_":78.5,"Elderly___":10.2,"Hispanic__":"5.9","White____":"85.3","African_Am":"0.5","Native_Ame":"0.1","Asian_Amer":"4.8","Other____":"3.2","Shape_Leng":5782.97677987,"Shape_Area":1260250.28099}},{"arcs":[[151,152,153,154,155,156,157,158]],"type":"Polygon","properties":{"Tract_1":6037543306,"Percentile":"91-95%","Population":7214,"County":"Los Angeles","ZIP":90745,"City":"Carson","CIscore":52.69,"CIscoreP":"91","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":26.62,"DPM_pctl":80,"DrinkingWa":182.06,"DW_pctl":"14","Pesticides":0.077,"Pest_pctl":19,"Tox_Releas":8580.61,"TR_pctl":91,"Traffic":1985.15,"Traff_Pctl":"91","Cleanups":60.2,"Clean_Pctl":97,"Groundwate":71.95,"GW_pctl":95,"Haz_Waste":7.58,"Haz_pctl":99,"Imp__Water":14,"IWB_pctl":94,"Solid_Wast":6.35,"Solid_pctl":79,"PollutionS":8.46,"Poll_pctl":98,"Asthma":59.74,"Asthma_Pct":69,"Low_Birth_":6.28,"LBW_pctl":"82","Cardiovasc":9.33,"CVD_pctl":67,"Education":19.8,"Edu_pctl":"62","Linguistic":7.7,"Ling_pctl":"50","Poverty":22.4,"Pov_pctl":"31","Unemployme":11.3,"Unem_pctl":"66","Housing_Bu":13.9,"HB_pctl":"30","PopCharSco":6.23,"Pop_Pctl":"65","Children__":11.4,"Pop_11_64_":74.4,"Elderly___":14.2,"Hispanic__":"32.3","White____":"7.7","African_Am":"20.2","Native_Ame":"0.3","Asian_Amer":"36.9","Other____":"2.6","Shape_Leng":12785.4037777,"Shape_Area":4507924.78039}},{"arcs":[[159,160,161,162,163,164,165]],"type":"Polygon","properties":{"Tract_1":6037542106,"Percentile":"96-100%","Population":3373,"County":"Los Angeles","ZIP":90221,"City":"Compton","CIscore":58.64,"CIscoreP":"96","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":27.22,"DPM_pctl":81,"DrinkingWa":168.23,"DW_pctl":"11","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6507.4,"TR_pctl":87,"Traffic":1631.88,"Traff_Pctl":"85","Cleanups":4.4,"Clean_Pctl":40,"Groundwate":23,"GW_pctl":75,"Haz_Waste":0.07,"Haz_pctl":29,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":2,"Solid_pctl":50,"PollutionS":6.71,"Poll_pctl":83,"Asthma":87.57,"Asthma_Pct":88,"Low_Birth_":5.28,"LBW_pctl":"60","Cardiovasc":13.56,"CVD_pctl":95,"Education":51.5,"Edu_pctl":"95","Linguistic":17.7,"Ling_pctl":"80","Poverty":68.8,"Pov_pctl":"92","Unemployme":14.7,"Unem_pctl":"83","Housing_Bu":29.8,"HB_pctl":"87","PopCharSco":8.74,"Pop_Pctl":"96","Children__":21.3,"Pop_11_64_":73.8,"Elderly___":4.9,"Hispanic__":"85.2","White____":"1.4","African_Am":"12","Native_Ame":"0.1","Asian_Amer":"0.8","Other____":"0.5","Shape_Leng":4975.83130517,"Shape_Area":912485.454591}},{"arcs":[[166,167,-165,168,169,170,171,172]],"type":"Polygon","properties":{"Tract_1":6037542105,"Percentile":"86-90%","Population":5200,"County":"Los Angeles","ZIP":90221,"City":"Compton","CIscore":50.85,"CIscoreP":"90","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":27.29,"DPM_pctl":81,"DrinkingWa":424.64,"DW_pctl":"44","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6258.51,"TR_pctl":86,"Traffic":694.46,"Traff_Pctl":"50","Cleanups":0,"Clean_Pctl":0,"Groundwate":14.75,"GW_pctl":59,"Haz_Waste":0.06,"Haz_pctl":28,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0.3,"Solid_pctl":11,"PollutionS":5.88,"Poll_pctl":66,"Asthma":87.61,"Asthma_Pct":88,"Low_Birth_":5.08,"LBW_pctl":"54","Cardiovasc":13.56,"CVD_pctl":95,"Education":56.7,"Edu_pctl":"97","Linguistic":11.4,"Ling_pctl":"64","Poverty":70.5,"Pov_pctl":"93","Unemployme":16.7,"Unem_pctl":"90","Housing_Bu":33.8,"HB_pctl":"93","PopCharSco":8.64,"Pop_Pctl":"96","Children__":20,"Pop_11_64_":74.9,"Elderly___":5.1,"Hispanic__":"80.6","White____":"1.1","African_Am":"16.9","Native_Ame":"0.2","Asian_Amer":"0.4","Other____":"0.7","Shape_Leng":3664.70824354,"Shape_Area":624259.710887}},{"arcs":[[173,174,175,176,177,178,179,180,181]],"type":"Polygon","properties":{"Tract_1":6037573601,"Percentile":"16-20%","Population":6114,"County":"Los Angeles","ZIP":90808,"City":"Long Beach","CIscore":11.33,"CIscoreP":"16","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":15.39,"DPM_pctl":47,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5545.85,"TR_pctl":83,"Traffic":550.67,"Traff_Pctl":"36","Cleanups":1.3,"Clean_Pctl":20,"Groundwate":4.5,"GW_pctl":29,"Haz_Waste":0.08,"Haz_pctl":31,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":3.97,"Poll_pctl":25,"Asthma":30.62,"Asthma_Pct":26,"Low_Birth_":5.5,"LBW_pctl":"66","Cardiovasc":8.08,"CVD_pctl":52,"Education":3.4,"Edu_pctl":"12","Linguistic":0.5,"Ling_pctl":"2","Poverty":10.8,"Pov_pctl":"8","Unemployme":4.8,"Unem_pctl":"11","Housing_Bu":6,"HB_pctl":"3","PopCharSco":2.86,"Pop_Pctl":"17","Children__":11.9,"Pop_11_64_":75.3,"Elderly___":12.8,"Hispanic__":"20.1","White____":"65.9","African_Am":"2.3","Native_Ame":"0.3","Asian_Amer":"7.1","Other____":"4.4","Shape_Leng":9835.65863613,"Shape_Area":3710673.5108}},{"arcs":[[182,183,184,185]],"type":"Polygon","properties":{"Tract_1":6037571504,"Percentile":"46-50%","Population":4699,"County":"Los Angeles","ZIP":90807,"City":"Long Beach","CIscore":23.97,"CIscoreP":"48","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":19.6,"DPM_pctl":60,"DrinkingWa":279.64,"DW_pctl":"29","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5787.02,"TR_pctl":84,"Traffic":644.22,"Traff_Pctl":"46","Cleanups":7,"Clean_Pctl":52,"Groundwate":20,"GW_pctl":71,"Haz_Waste":0.02,"Haz_pctl":16,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":1,"Solid_pctl":33,"PollutionS":5.13,"Poll_pctl":50,"Asthma":40.93,"Asthma_Pct":43,"Low_Birth_":7.16,"LBW_pctl":"92","Cardiovasc":5.89,"CVD_pctl":22,"Education":11,"Edu_pctl":"42","Linguistic":3.1,"Ling_pctl":"23","Poverty":28,"Pov_pctl":"41","Unemployme":10.5,"Unem_pctl":"60","Housing_Bu":11.9,"HB_pctl":"21","PopCharSco":4.67,"Pop_Pctl":"42","Children__":11.9,"Pop_11_64_":79.3,"Elderly___":8.8,"Hispanic__":"28.9","White____":"27.9","African_Am":"21.2","Native_Ame":"0.2","Asian_Amer":"18","Other____":"3.7","Shape_Leng":5114.121039,"Shape_Area":1536188.55149}},{"arcs":[[-184,186,187,188,189,190]],"type":"Polygon","properties":{"Tract_1":6037571503,"Percentile":"31-35%","Population":3700,"County":"Los Angeles","ZIP":90807,"City":"Long Beach","CIscore":18.26,"CIscoreP":"34","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":19.99,"DPM_pctl":62,"DrinkingWa":289.59,"DW_pctl":"31","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5467.6,"TR_pctl":82,"Traffic":566.94,"Traff_Pctl":"38","Cleanups":1.75,"Clean_Pctl":24,"Groundwate":3.5,"GW_pctl":24,"Haz_Waste":0.2,"Haz_pctl":57,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":2.5,"Solid_pctl":57,"PollutionS":4.98,"Poll_pctl":46,"Asthma":38.3,"Asthma_Pct":39,"Low_Birth_":4.49,"LBW_pctl":"39","Cardiovasc":5.33,"CVD_pctl":16,"Education":10,"Edu_pctl":"39","Linguistic":2.1,"Ling_pctl":"15","Poverty":33,"Pov_pctl":"49","Unemployme":9.8,"Unem_pctl":"54","Housing_Bu":16,"HB_pctl":"40","PopCharSco":3.67,"Pop_Pctl":"28","Children__":12.7,"Pop_11_64_":76,"Elderly___":11.3,"Hispanic__":"31.5","White____":"22.4","African_Am":"17.4","Native_Ame":"0.6","Asian_Amer":"24.5","Other____":"3.6","Shape_Leng":4599.88702426,"Shape_Area":910194.668114}},{"arcs":[[191,192,193,194,195]],"type":"Polygon","properties":{"Tract_1":6037570404,"Percentile":"91-95%","Population":3501,"County":"Los Angeles","ZIP":90805,"City":"Long Beach","CIscore":54.04,"CIscoreP":"92","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":29.03,"DPM_pctl":83,"DrinkingWa":250.03,"DW_pctl":"25","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6271.28,"TR_pctl":86,"Traffic":3045.76,"Traff_Pctl":"98","Cleanups":1,"Clean_Pctl":18,"Groundwate":3,"GW_pctl":22,"Haz_Waste":0.6,"Haz_pctl":81,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":6.41,"Poll_pctl":77,"Asthma":78.88,"Asthma_Pct":84,"Low_Birth_":8.21,"LBW_pctl":"97","Cardiovasc":9.79,"CVD_pctl":73,"Education":38.6,"Edu_pctl":"86","Linguistic":11.8,"Ling_pctl":"65","Poverty":48,"Pov_pctl":"71","Unemployme":14.5,"Unem_pctl":"82","Housing_Bu":28.7,"HB_pctl":"85","PopCharSco":8.43,"Pop_Pctl":"94","Children__":17.2,"Pop_11_64_":77.5,"Elderly___":5.3,"Hispanic__":"66.6","White____":"3.6","African_Am":"22.7","Native_Ame":"0.7","Asian_Amer":"5.2","Other____":"1.3","Shape_Leng":4741.49600271,"Shape_Area":860171.09496}},{"arcs":[[196,197,198,199,200,201,202,203,204]],"type":"Polygon","properties":{"Tract_1":6037293306,"Percentile":"61-65%","Population":2189,"County":"Los Angeles","ZIP":90710,"City":"Harbor City","CIscore":32.37,"CIscoreP":"64","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":24.33,"DPM_pctl":74,"DrinkingWa":422.25,"DW_pctl":"44","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8690.75,"TR_pctl":92,"Traffic":610.74,"Traff_Pctl":"43","Cleanups":6,"Clean_Pctl":48,"Groundwate":21.5,"GW_pctl":73,"Haz_Waste":5.32,"Haz_pctl":97,"Imp__Water":9,"IWB_pctl":81,"Solid_Wast":4.5,"Solid_pctl":70,"PollutionS":7.14,"Poll_pctl":88,"Asthma":48.39,"Asthma_Pct":54,"Low_Birth_":3.7,"LBW_pctl":"20","Cardiovasc":8.82,"CVD_pctl":61,"Education":13.8,"Edu_pctl":"49","Linguistic":6.5,"Ling_pctl":"44","Poverty":17.3,"Pov_pctl":"21","Unemployme":10.8,"Unem_pctl":"62","Housing_Bu":14.9,"HB_pctl":"35","PopCharSco":4.53,"Pop_Pctl":"40","Children__":13.1,"Pop_11_64_":73.4,"Elderly___":13.5,"Hispanic__":"37.7","White____":"45","African_Am":"5","Native_Ame":"0.5","Asian_Amer":"9.1","Other____":"2.7","Shape_Leng":3522.66786301,"Shape_Area":625649.832087}},{"arcs":[[205,206,207,208,209]],"type":"Polygon","properties":{"Tract_1":6037604002,"Percentile":"61-65%","Population":5078,"County":"Los Angeles","ZIP":90260,"City":"Lawndale","CIscore":32.57,"CIscoreP":"64","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":20.89,"DPM_pctl":64,"DrinkingWa":255.67,"DW_pctl":"26","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8581.44,"TR_pctl":91,"Traffic":789.34,"Traff_Pctl":"56","Cleanups":1,"Clean_Pctl":18,"Groundwate":7.5,"GW_pctl":41,"Haz_Waste":0.02,"Haz_pctl":16,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":4.91,"Poll_pctl":45,"Asthma":65.98,"Asthma_Pct":75,"Low_Birth_":4.87,"LBW_pctl":"49","Cardiovasc":9.37,"CVD_pctl":68,"Education":24.7,"Edu_pctl":"70","Linguistic":14.4,"Ling_pctl":"73","Poverty":47.3,"Pov_pctl":"70","Unemployme":6.9,"Unem_pctl":"28","Housing_Bu":26.2,"HB_pctl":"80","PopCharSco":6.63,"Pop_Pctl":"71","Children__":14.8,"Pop_11_64_":79.9,"Elderly___":5.3,"Hispanic__":"58.4","White____":"21.3","African_Am":"7.5","Native_Ame":"0.2","Asian_Amer":"9.5","Other____":"3.1","Shape_Leng":3157.65951024,"Shape_Area":649687.008032}},{"arcs":[[-208,210,211,212]],"type":"Polygon","properties":{"Tract_1":6037604001,"Percentile":"71-75%","Population":4470,"County":"Los Angeles","ZIP":90260,"City":"Lawndale","CIscore":38.1,"CIscoreP":"73","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":20.89,"DPM_pctl":64,"DrinkingWa":256.01,"DW_pctl":"26","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6761.57,"TR_pctl":88,"Traffic":1817.77,"Traff_Pctl":"89","Cleanups":0.4,"Clean_Pctl":6,"Groundwate":17.6,"GW_pctl":67,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":2,"Solid_pctl":50,"PollutionS":5.57,"Poll_pctl":59,"Asthma":63.37,"Asthma_Pct":73,"Low_Birth_":4.96,"LBW_pctl":"51","Cardiovasc":9.03,"CVD_pctl":64,"Education":26.3,"Edu_pctl":"72","Linguistic":14.2,"Ling_pctl":"73","Poverty":58.2,"Pov_pctl":"82","Unemployme":6.9,"Unem_pctl":"28","Housing_Bu":32,"HB_pctl":"91","PopCharSco":6.84,"Pop_Pctl":"74","Children__":15.1,"Pop_11_64_":78.6,"Elderly___":6.3,"Hispanic__":"64.7","White____":"17.6","African_Am":"8.6","Native_Ame":"0.2","Asian_Amer":"7","Other____":"1.9","Shape_Leng":3257.18166266,"Shape_Area":662856.772016}},{"arcs":[[213,214,215,216,217]],"type":"Polygon","properties":{"Tract_1":6037603802,"Percentile":"76-80%","Population":4153,"County":"Los Angeles","ZIP":90260,"City":"Lawndale","CIscore":41.74,"CIscoreP":"78","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":22.2,"DPM_pctl":67,"DrinkingWa":255.67,"DW_pctl":"26","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5768.77,"TR_pctl":84,"Traffic":735.73,"Traff_Pctl":"53","Cleanups":0.1,"Clean_Pctl":2,"Groundwate":2.35,"GW_pctl":14,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":2.2,"Solid_pctl":52,"PollutionS":5.27,"Poll_pctl":53,"Asthma":68.28,"Asthma_Pct":77,"Low_Birth_":6.76,"LBW_pctl":"88","Cardiovasc":9.67,"CVD_pctl":71,"Education":36.3,"Edu_pctl":"83","Linguistic":16.6,"Ling_pctl":"78","Poverty":56.5,"Pov_pctl":"81","Unemployme":7.7,"Unem_pctl":"36","Housing_Bu":31.9,"HB_pctl":"91","PopCharSco":7.91,"Pop_Pctl":"89","Children__":14.4,"Pop_11_64_":78.3,"Elderly___":7.3,"Hispanic__":"60.3","White____":"12.9","African_Am":"7.6","Native_Ame":"0.2","Asian_Amer":"16.6","Other____":"2.3","Shape_Leng":3198.62240825,"Shape_Area":632028.655973}},{"arcs":[[-218,218,219,220,221]],"type":"Polygon","properties":{"Tract_1":6037603801,"Percentile":"71-75%","Population":4483,"County":"Los Angeles","ZIP":90260,"City":"Lawndale","CIscore":39.16,"CIscoreP":"75","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":30.76,"DPM_pctl":86,"DrinkingWa":384.38,"DW_pctl":"41","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5050.18,"TR_pctl":80,"Traffic":996.96,"Traff_Pctl":"68","Cleanups":0.1,"Clean_Pctl":2,"Groundwate":1.9,"GW_pctl":9,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":2,"Solid_pctl":50,"PollutionS":5.75,"Poll_pctl":63,"Asthma":52.2,"Asthma_Pct":59,"Low_Birth_":6.72,"LBW_pctl":"88","Cardiovasc":7.3,"CVD_pctl":41,"Education":29.5,"Edu_pctl":"76","Linguistic":17.3,"Ling_pctl":"79","Poverty":42.9,"Pov_pctl":"64","Unemployme":10.3,"Unem_pctl":"58","Housing_Bu":21.4,"HB_pctl":"65","PopCharSco":6.81,"Pop_Pctl":"74","Children__":15.7,"Pop_11_64_":78.6,"Elderly___":5.7,"Hispanic__":"54.7","White____":"9.7","African_Am":"19.5","Native_Ame":"0.2","Asian_Amer":"13.8","Other____":"2.2","Shape_Leng":3296.28977711,"Shape_Area":666076.614028}},{"arcs":[[222,223,224,225]],"type":"Polygon","properties":{"Tract_1":6037603006,"Percentile":"61-65%","Population":2035,"County":"Los Angeles","ZIP":90247,"City":"Gardena","CIscore":32.5,"CIscoreP":"64","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":22.88,"DPM_pctl":70,"DrinkingWa":255.67,"DW_pctl":"26","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6881.89,"TR_pctl":88,"Traffic":1083.37,"Traff_Pctl":"71","Cleanups":0.1,"Clean_Pctl":2,"Groundwate":5,"GW_pctl":32,"Haz_Waste":0.04,"Haz_pctl":19,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.9,"Solid_pctl":24,"PollutionS":5.05,"Poll_pctl":48,"Asthma":79.41,"Asthma_Pct":85,"Low_Birth_":4.26,"LBW_pctl":"32","Cardiovasc":10.07,"CVD_pctl":75,"Education":11.7,"Edu_pctl":"44","Linguistic":10.4,"Ling_pctl":"60","Poverty":43.5,"Pov_pctl":"65","Unemployme":11.2,"Unem_pctl":"65","Housing_Bu":21.7,"HB_pctl":"66","PopCharSco":6.44,"Pop_Pctl":"68","Children__":10.5,"Pop_11_64_":68.5,"Elderly___":21,"Hispanic__":"30.7","White____":"9.5","African_Am":"10.3","Native_Ame":"0.1","Asian_Amer":"46.5","Other____":"2.9","Shape_Leng":3336.0198183,"Shape_Area":686716.420098}},{"arcs":[[-224,226,227,228]],"type":"Polygon","properties":{"Tract_1":6037603005,"Percentile":"91-95%","Population":5591,"County":"Los Angeles","ZIP":90247,"City":"Gardena","CIscore":54.26,"CIscoreP":"93","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":23.4,"DPM_pctl":72,"DrinkingWa":255.67,"DW_pctl":"26","Pesticides":0.116,"Pest_pctl":22,"Tox_Releas":5967.3,"TR_pctl":85,"Traffic":1106.95,"Traff_Pctl":"72","Cleanups":4.5,"Clean_Pctl":42,"Groundwate":23.4,"GW_pctl":75,"Haz_Waste":0.26,"Haz_pctl":66,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":7.7,"Solid_pctl":85,"PollutionS":6.87,"Poll_pctl":85,"Asthma":73.5,"Asthma_Pct":81,"Low_Birth_":6.91,"LBW_pctl":"90","Cardiovasc":9.3,"CVD_pctl":67,"Education":24.3,"Edu_pctl":"69","Linguistic":13.9,"Ling_pctl":"72","Poverty":48.4,"Pov_pctl":"71","Unemployme":10.2,"Unem_pctl":"58","Housing_Bu":36.6,"HB_pctl":"96","PopCharSco":7.9,"Pop_Pctl":"88","Children__":15.5,"Pop_11_64_":77.8,"Elderly___":6.7,"Hispanic__":"46.3","White____":"4.8","African_Am":"32.4","Native_Ame":"0.1","Asian_Amer":"13.8","Other____":"2.5","Shape_Leng":3226.08522665,"Shape_Area":650473.662735}},{"arcs":[[229,230,231,232]],"type":"Polygon","properties":{"Tract_1":6037602802,"Percentile":"91-95%","Population":4304,"County":"Los Angeles","ZIP":90044,"City":"Los Angeles","CIscore":54.5,"CIscoreP":"93","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":25.38,"DPM_pctl":77,"DrinkingWa":290.27,"DW_pctl":"31","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5001.48,"TR_pctl":80,"Traffic":697.49,"Traff_Pctl":"50","Cleanups":28.4,"Clean_Pctl":90,"Groundwate":12.3,"GW_pctl":55,"Haz_Waste":0.31,"Haz_pctl":70,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":6.2,"Solid_pctl":79,"PollutionS":6.63,"Poll_pctl":81,"Asthma":111.11,"Asthma_Pct":95,"Low_Birth_":9.92,"LBW_pctl":"100","Cardiovasc":10.37,"CVD_pctl":77,"Education":20.6,"Edu_pctl":"63","Linguistic":7.6,"Ling_pctl":"49","Poverty":40.9,"Pov_pctl":"61","Unemployme":15.1,"Unem_pctl":"85","Housing_Bu":26.7,"HB_pctl":"81","PopCharSco":8.22,"Pop_Pctl":"92","Children__":12.8,"Pop_11_64_":73.5,"Elderly___":13.7,"Hispanic__":"32.6","White____":"1.5","African_Am":"62","Native_Ame":"0.1","Asian_Amer":"1.8","Other____":"1.9","Shape_Leng":4881.11791857,"Shape_Area":1339261.68225}},{"arcs":[[233,-233,234,235,236]],"type":"Polygon","properties":{"Tract_1":6037602801,"Percentile":"96-100%","Population":3819,"County":"Los Angeles","ZIP":90044,"City":"Los Angeles","CIscore":62.42,"CIscoreP":"97","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":24.69,"DPM_pctl":75,"DrinkingWa":288.19,"DW_pctl":"30","Pesticides":0,"Pest_pctl":0,"Tox_Releas":4938.23,"TR_pctl":80,"Traffic":2860.99,"Traff_Pctl":"97","Cleanups":27.4,"Clean_Pctl":89,"Groundwate":5.5,"GW_pctl":33,"Haz_Waste":0.13,"Haz_pctl":50,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":8.1,"Solid_pctl":86,"PollutionS":6.86,"Poll_pctl":85,"Asthma":114.99,"Asthma_Pct":96,"Low_Birth_":7.05,"LBW_pctl":"91","Cardiovasc":11.94,"CVD_pctl":88,"Education":36,"Edu_pctl":"83","Linguistic":14.5,"Ling_pctl":"73","Poverty":67.2,"Pov_pctl":"91","Unemployme":14.6,"Unem_pctl":"83","Housing_Bu":30.7,"HB_pctl":"89","PopCharSco":9.1,"Pop_Pctl":"98","Children__":18.8,"Pop_11_64_":75.4,"Elderly___":5.8,"Hispanic__":"62.2","White____":"1.1","African_Am":"34.1","Native_Ame":"0.1","Asian_Amer":"0.7","Other____":"1.7","Shape_Leng":4804.07523407,"Shape_Area":1258937.74415}},{"arcs":[[237,238,239,240,241,242,243,244]],"type":"Polygon","properties":{"Tract_1":6037602509,"Percentile":"96-100%","Population":4118,"County":"Los Angeles","ZIP":90250,"City":"Hawthorne","CIscore":63.43,"CIscoreP":"98","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":23.51,"DPM_pctl":72,"DrinkingWa":364.42,"DW_pctl":"38","Pesticides":4.13,"Pest_pctl":51,"Tox_Releas":4943.75,"TR_pctl":80,"Traffic":2309.13,"Traff_Pctl":"94","Cleanups":47.85,"Clean_Pctl":96,"Groundwate":106.85,"GW_pctl":97,"Haz_Waste":1.37,"Haz_pctl":89,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":2.5,"Solid_pctl":57,"PollutionS":8.74,"Poll_pctl":99,"Asthma":73.29,"Asthma_Pct":81,"Low_Birth_":5.39,"LBW_pctl":"63","Cardiovasc":9.96,"CVD_pctl":74,"Education":33.9,"Edu_pctl":"81","Linguistic":15.7,"Ling_pctl":"76","Poverty":45.9,"Pov_pctl":"68","Unemployme":6.1,"Unem_pctl":"21","Housing_Bu":31.2,"HB_pctl":"90","PopCharSco":7.26,"Pop_Pctl":"80","Children__":17.8,"Pop_11_64_":76.7,"Elderly___":5.5,"Hispanic__":"63.8","White____":"4.1","African_Am":"20","Native_Ame":"0.2","Asian_Amer":"10.3","Other____":"1.7","Shape_Leng":6896.24730883,"Shape_Area":2047772.07256}},{"arcs":[[-241,245]],"type":"Polygon","properties":{"Tract_1":6037602508,"Percentile":"91-95%","Population":7022,"County":"Los Angeles","ZIP":90250,"City":"Hawthorne","CIscore":53.55,"CIscoreP":"92","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":23.84,"DPM_pctl":73,"DrinkingWa":378.8,"DW_pctl":"40","Pesticides":0.025,"Pest_pctl":12,"Tox_Releas":4956.7,"TR_pctl":80,"Traffic":1466.66,"Traff_Pctl":"82","Cleanups":22.7,"Clean_Pctl":86,"Groundwate":40.25,"GW_pctl":88,"Haz_Waste":0.46,"Haz_pctl":75,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":7.43,"Poll_pctl":92,"Asthma":78.54,"Asthma_Pct":84,"Low_Birth_":5.99,"LBW_pctl":"76","Cardiovasc":10.73,"CVD_pctl":81,"Education":25.3,"Edu_pctl":"70","Linguistic":13.9,"Ling_pctl":"72","Poverty":43.1,"Pov_pctl":"64","Unemployme":5.7,"Unem_pctl":"18","Housing_Bu":22.4,"HB_pctl":"68","PopCharSco":7.21,"Pop_Pctl":"79","Children__":17.2,"Pop_11_64_":76.9,"Elderly___":5.9,"Hispanic__":"52.5","White____":"5.3","African_Am":"34.8","Native_Ame":"0.1","Asian_Amer":"5","Other____":"2.2","Shape_Leng":3219.08322726,"Shape_Area":647655.326701}},{"arcs":[[246,247,248,249,250]],"type":"Polygon","properties":{"Tract_1":6037602302,"Percentile":"61-65%","Population":3477,"County":"Los Angeles","ZIP":90250,"City":"Hawthorne","CIscore":30.6,"CIscoreP":"61","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":30.76,"DPM_pctl":86,"DrinkingWa":255.6,"DW_pctl":"26","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5640.64,"TR_pctl":83,"Traffic":2623.07,"Traff_Pctl":"96","Cleanups":13.75,"Clean_Pctl":74,"Groundwate":67.25,"GW_pctl":95,"Haz_Waste":2.54,"Haz_pctl":93,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":7.07,"Poll_pctl":88,"Asthma":73.86,"Asthma_Pct":81,"Low_Birth_":4.05,"LBW_pctl":"27","Cardiovasc":10.16,"CVD_pctl":76,"Education":7.7,"Edu_pctl":"31","Linguistic":2.8,"Ling_pctl":"21","Poverty":14.1,"Pov_pctl":"14","Unemployme":6.6,"Unem_pctl":"25","Housing_Bu":11.3,"HB_pctl":"18","PopCharSco":4.33,"Pop_Pctl":"37","Children__":12.4,"Pop_11_64_":73.3,"Elderly___":14.3,"Hispanic__":"20.4","White____":"61.3","African_Am":"2.4","Native_Ame":"0.2","Asian_Amer":"11.3","Other____":"4.4","Shape_Leng":6876.17020129,"Shape_Area":1949901.79028}},{"arcs":[[251,252,253,254]],"type":"Polygon","properties":{"Tract_1":6037600304,"Percentile":"86-90%","Population":3424,"County":"Los Angeles","ZIP":90044,"City":"Los Angeles","CIscore":50.61,"CIscoreP":"89","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":24.76,"DPM_pctl":76,"DrinkingWa":290.49,"DW_pctl":"31","Pesticides":0,"Pest_pctl":0,"Tox_Releas":4888.74,"TR_pctl":80,"Traffic":759.37,"Traff_Pctl":"54","Cleanups":6.75,"Clean_Pctl":50,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.02,"Haz_pctl":16,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":4.2,"Solid_pctl":69,"PollutionS":5.36,"Poll_pctl":54,"Asthma":115.42,"Asthma_Pct":96,"Low_Birth_":9.32,"LBW_pctl":"99","Cardiovasc":12.3,"CVD_pctl":90,"Education":42.5,"Edu_pctl":"89","Linguistic":13.5,"Ling_pctl":"71","Poverty":75.3,"Pov_pctl":"96","Unemployme":14.3,"Unem_pctl":"82","Housing_Bu":39,"HB_pctl":"97","PopCharSco":9.44,"Pop_Pctl":"100","Children__":19.7,"Pop_11_64_":75.7,"Elderly___":4.6,"Hispanic__":"58","White____":"1.5","African_Am":"38.8","Native_Ame":"0.1","Asian_Amer":"0.2","Other____":"1.4","Shape_Leng":2940.85196194,"Shape_Area":448701.31693}},{"arcs":[[255,256,257,258,259,260,261,262,263]],"type":"Polygon","properties":{"Tract_1":6037554406,"Percentile":"56-60%","Population":4875,"County":"Los Angeles","ZIP":90706,"City":"Bellflower","CIscore":28.97,"CIscoreP":"58","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":28.51,"DPM_pctl":83,"DrinkingWa":743.81,"DW_pctl":"86","Pesticides":0.322,"Pest_pctl":29,"Tox_Releas":6309.09,"TR_pctl":86,"Traffic":3722.96,"Traff_Pctl":"99","Cleanups":0,"Clean_Pctl":0,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.04,"Haz_pctl":18,"Imp__Water":4,"IWB_pctl":49,"Solid_Wast":1.5,"Solid_pctl":39,"PollutionS":6.65,"Poll_pctl":82,"Asthma":41.15,"Asthma_Pct":44,"Low_Birth_":6.11,"LBW_pctl":"78","Cardiovasc":6.48,"CVD_pctl":30,"Education":9.4,"Edu_pctl":"37","Linguistic":4.1,"Ling_pctl":"31","Poverty":34.4,"Pov_pctl":"51","Unemployme":4.6,"Unem_pctl":"10","Housing_Bu":15.3,"HB_pctl":"36","PopCharSco":4.36,"Pop_Pctl":"38","Children__":11.2,"Pop_11_64_":75.5,"Elderly___":13.3,"Hispanic__":"26.4","White____":"39.1","African_Am":"11.7","Native_Ame":"0.1","Asian_Amer":"19.1","Other____":"3.6","Shape_Leng":4852.9182231,"Shape_Area":1101134.70346}},{"arcs":[[264,265,266,267,268]],"type":"Polygon","properties":{"Tract_1":6037554405,"Percentile":"81-85%","Population":3040,"County":"Los Angeles","ZIP":90706,"City":"Bellflower","CIscore":43.44,"CIscoreP":"81","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":27.98,"DPM_pctl":82,"DrinkingWa":298.9,"DW_pctl":"32","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6593.11,"TR_pctl":87,"Traffic":2860.38,"Traff_Pctl":"97","Cleanups":0,"Clean_Pctl":0,"Groundwate":4.5,"GW_pctl":29,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":4,"IWB_pctl":49,"Solid_Wast":1,"Solid_pctl":33,"PollutionS":5.68,"Poll_pctl":62,"Asthma":77.92,"Asthma_Pct":84,"Low_Birth_":6.32,"LBW_pctl":"82","Cardiovasc":11,"CVD_pctl":83,"Education":16.5,"Edu_pctl":"55","Linguistic":12,"Ling_pctl":"66","Poverty":42.1,"Pov_pctl":"63","Unemployme":10.5,"Unem_pctl":"60","Housing_Bu":26,"HB_pctl":"79","PopCharSco":7.65,"Pop_Pctl":"85","Children__":13.2,"Pop_11_64_":74.7,"Elderly___":12.1,"Hispanic__":"36","White____":"23.2","African_Am":"22.3","Native_Ame":"0.7","Asian_Amer":"16.2","Other____":"1.6","Shape_Leng":3578.0172731,"Shape_Area":765624.845294}},{"arcs":[[269,270]],"type":"Polygon","properties":{"Tract_1":6037554302,"Percentile":"81-85%","Population":3916,"County":"Los Angeles","ZIP":90706,"City":"Bellflower","CIscore":46.62,"CIscoreP":"85","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":21.73,"DPM_pctl":66,"DrinkingWa":227.02,"DW_pctl":"19","Pesticides":2.605,"Pest_pctl":47,"Tox_Releas":7216.41,"TR_pctl":89,"Traffic":2248.25,"Traff_Pctl":"93","Cleanups":0.7,"Clean_Pctl":11,"Groundwate":36,"GW_pctl":86,"Haz_Waste":0.15,"Haz_pctl":54,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":6.36,"Poll_pctl":76,"Asthma":56.18,"Asthma_Pct":64,"Low_Birth_":6.29,"LBW_pctl":"82","Cardiovasc":7.8,"CVD_pctl":48,"Education":23.3,"Edu_pctl":"68","Linguistic":12.9,"Ling_pctl":"69","Poverty":54.1,"Pov_pctl":"78","Unemployme":15.6,"Unem_pctl":"87","Housing_Bu":27.1,"HB_pctl":"82","PopCharSco":7.33,"Pop_Pctl":"81","Children__":16.5,"Pop_11_64_":78.1,"Elderly___":5.4,"Hispanic__":"53.8","White____":"11.6","African_Am":"19.5","Native_Ame":"0.3","Asian_Amer":"12.8","Other____":"2","Shape_Leng":3377.75403925,"Shape_Area":711150.69644}},{"arcs":[[271,272,273,274,275]],"type":"Polygon","properties":{"Tract_1":6037554301,"Percentile":"91-95%","Population":3554,"County":"Los Angeles","ZIP":90706,"City":"Bellflower","CIscore":51.52,"CIscoreP":"90","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":21.72,"DPM_pctl":66,"DrinkingWa":746.84,"DW_pctl":"86","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8843.83,"TR_pctl":92,"Traffic":2023.75,"Traff_Pctl":"91","Cleanups":0,"Clean_Pctl":0,"Groundwate":42.3,"GW_pctl":89,"Haz_Waste":0.1,"Haz_pctl":43,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":6.45,"Poll_pctl":78,"Asthma":65.24,"Asthma_Pct":74,"Low_Birth_":6.91,"LBW_pctl":"90","Cardiovasc":9.41,"CVD_pctl":68,"Education":34.4,"Edu_pctl":"81","Linguistic":13,"Ling_pctl":"69","Poverty":48.7,"Pov_pctl":"72","Unemployme":13.3,"Unem_pctl":"77","Housing_Bu":28.1,"HB_pctl":"84","PopCharSco":7.99,"Pop_Pctl":"90","Children__":16.4,"Pop_11_64_":78.1,"Elderly___":5.5,"Hispanic__":"62","White____":"11.4","African_Am":"18.1","Native_Ame":"0.1","Asian_Amer":"6.6","Other____":"1.9","Shape_Leng":4331.85634883,"Shape_Area":669228.880025}},{"arcs":[[276,277,278,279,280,281,282,283,284,285,286]],"type":"Polygon","properties":{"Tract_1":6037295103,"Percentile":"41-45%","Population":4875,"County":"Los Angeles","ZIP":90731,"City":"San Pedro","CIscore":21.22,"CIscoreP":"41","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":37.81,"DPM_pctl":92,"DrinkingWa":423.68,"DW_pctl":"44","Pesticides":0,"Pest_pctl":0,"Tox_Releas":10394.59,"TR_pctl":94,"Traffic":1069.13,"Traff_Pctl":"71","Cleanups":12.5,"Clean_Pctl":71,"Groundwate":3,"GW_pctl":22,"Haz_Waste":5.25,"Haz_pctl":97,"Imp__Water":8,"IWB_pctl":76,"Solid_Wast":5,"Solid_pctl":74,"PollutionS":7.46,"Poll_pctl":92,"Asthma":37.24,"Asthma_Pct":37,"Low_Birth_":4.33,"LBW_pctl":"34","Cardiovasc":4.94,"CVD_pctl":12,"Education":4,"Edu_pctl":"15","Linguistic":5.3,"Ling_pctl":"38","Poverty":11.5,"Pov_pctl":"9","Unemployme":7,"Unem_pctl":"29","Housing_Bu":16.7,"HB_pctl":"44","PopCharSco":2.84,"Pop_Pctl":"17","Children__":10.4,"Pop_11_64_":69.4,"Elderly___":20.2,"Hispanic__":"21.7","White____":"61.3","African_Am":"3","Native_Ame":"0.2","Asian_Amer":"10.4","Other____":"3.4","Shape_Leng":7776.87857955,"Shape_Area":2059245.61952}},{"arcs":[[287,288,289]],"type":"Polygon","properties":{"Tract_1":6037554204,"Percentile":"81-85%","Population":4391,"County":"Los Angeles","ZIP":90706,"City":"Bellflower","CIscore":44.99,"CIscoreP":"83","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":22.79,"DPM_pctl":69,"DrinkingWa":237.1,"DW_pctl":"23","Pesticides":0,"Pest_pctl":0,"Tox_Releas":7115.5,"TR_pctl":88,"Traffic":787.73,"Traff_Pctl":"56","Cleanups":0,"Clean_Pctl":0,"Groundwate":12.3,"GW_pctl":55,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":3,"IWB_pctl":41,"Solid_Wast":2,"Solid_pctl":50,"PollutionS":5.42,"Poll_pctl":56,"Asthma":79.03,"Asthma_Pct":85,"Low_Birth_":6.07,"LBW_pctl":"78","Cardiovasc":11.13,"CVD_pctl":84,"Education":26.6,"Edu_pctl":"72","Linguistic":9.7,"Ling_pctl":"58","Poverty":60.7,"Pov_pctl":"85","Unemployme":14.8,"Unem_pctl":"84","Housing_Bu":32.4,"HB_pctl":"92","PopCharSco":8.31,"Pop_Pctl":"93","Children__":16,"Pop_11_64_":72.5,"Elderly___":11.5,"Hispanic__":"58","White____":"14.9","African_Am":"15.6","Native_Ame":"0.4","Asian_Amer":"8.7","Other____":"2.4","Shape_Leng":3947.95151142,"Shape_Area":653848.231556}},{"arcs":[[-260,290,291,292,293]],"type":"Polygon","properties":{"Tract_1":6037554203,"Percentile":"81-85%","Population":3689,"County":"Los Angeles","ZIP":90706,"City":"Bellflower","CIscore":45.27,"CIscoreP":"83","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":25.1,"DPM_pctl":77,"DrinkingWa":237.1,"DW_pctl":"23","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6874.66,"TR_pctl":88,"Traffic":1168.69,"Traff_Pctl":"74","Cleanups":0,"Clean_Pctl":0,"Groundwate":8.55,"GW_pctl":44,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":4,"IWB_pctl":49,"Solid_Wast":2,"Solid_pctl":50,"PollutionS":5.68,"Poll_pctl":62,"Asthma":79.03,"Asthma_Pct":85,"Low_Birth_":7.63,"LBW_pctl":"95","Cardiovasc":11.13,"CVD_pctl":84,"Education":20.8,"Edu_pctl":"64","Linguistic":18.2,"Ling_pctl":"81","Poverty":29.7,"Pov_pctl":"44","Unemployme":10,"Unem_pctl":"56","Housing_Bu":28.1,"HB_pctl":"84","PopCharSco":7.97,"Pop_Pctl":"89","Children__":14.3,"Pop_11_64_":76.2,"Elderly___":9.5,"Hispanic__":"51.5","White____":"25","African_Am":"10.8","Native_Ame":"0.5","Asian_Amer":"10.8","Other____":"1.4","Shape_Leng":4210.64936177,"Shape_Area":687003.558172}},{"arcs":[[294,295,296,297,298,299]],"type":"Polygon","properties":{"Tract_1":6037554105,"Percentile":"81-85%","Population":4569,"County":"Los Angeles","ZIP":90706,"City":"Bellflower","CIscore":44.42,"CIscoreP":"82","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":28.08,"DPM_pctl":82,"DrinkingWa":237.1,"DW_pctl":"23","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6225.58,"TR_pctl":86,"Traffic":891.55,"Traff_Pctl":"62","Cleanups":0,"Clean_Pctl":0,"Groundwate":9,"GW_pctl":46,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":3,"IWB_pctl":41,"Solid_Wast":2,"Solid_pctl":50,"PollutionS":5.54,"Poll_pctl":58,"Asthma":79.03,"Asthma_Pct":85,"Low_Birth_":7.9,"LBW_pctl":"96","Cardiovasc":11.13,"CVD_pctl":84,"Education":19.2,"Edu_pctl":"60","Linguistic":15.2,"Ling_pctl":"75","Poverty":55.1,"Pov_pctl":"79","Unemployme":7.4,"Unem_pctl":"33","Housing_Bu":28.8,"HB_pctl":"85","PopCharSco":8.02,"Pop_Pctl":"90","Children__":19.4,"Pop_11_64_":74.1,"Elderly___":6.5,"Hispanic__":"54.7","White____":"13.3","African_Am":"19.9","Native_Ame":"0.1","Asian_Amer":"10","Other____":"2","Shape_Leng":3077.91661187,"Shape_Area":337965.362012}},{"arcs":[[-300,300,301,302,303]],"type":"Polygon","properties":{"Tract_1":6037554104,"Percentile":"76-80%","Population":2600,"County":"Los Angeles","ZIP":90706,"City":"Bellflower","CIscore":41.59,"CIscoreP":"78","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":26.92,"DPM_pctl":80,"DrinkingWa":276.64,"DW_pctl":"29","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5909.03,"TR_pctl":84,"Traffic":957.51,"Traff_Pctl":"66","Cleanups":0,"Clean_Pctl":0,"Groundwate":4.5,"GW_pctl":29,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":3,"IWB_pctl":41,"Solid_Wast":0.5,"Solid_pctl":20,"PollutionS":5.21,"Poll_pctl":51,"Asthma":79.03,"Asthma_Pct":85,"Low_Birth_":5.76,"LBW_pctl":"72","Cardiovasc":11.13,"CVD_pctl":84,"Education":24,"Edu_pctl":"68","Linguistic":4.8,"Ling_pctl":"35","Poverty":54.6,"Pov_pctl":"79","Unemployme":16.1,"Unem_pctl":"88","Housing_Bu":47.9,"HB_pctl":"100","PopCharSco":7.99,"Pop_Pctl":"90","Children__":17.1,"Pop_11_64_":75.6,"Elderly___":7.3,"Hispanic__":"55.3","White____":"16","African_Am":"14.3","Native_Ame":"0.2","Asian_Amer":"12.5","Other____":"1.7","Shape_Leng":2554.17229275,"Shape_Area":364743.383912}},{"arcs":[[304,305,306,307,308,309,-17]],"type":"Polygon","properties":{"Tract_1":6037553504,"Percentile":"91-95%","Population":5368,"County":"Los Angeles","ZIP":90723,"City":"Paramount","CIscore":51.46,"CIscoreP":"90","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":20.99,"DPM_pctl":65,"DrinkingWa":354.26,"DW_pctl":"37","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6134.84,"TR_pctl":85,"Traffic":1336.16,"Traff_Pctl":"79","Cleanups":1.35,"Clean_Pctl":21,"Groundwate":14.5,"GW_pctl":59,"Haz_Waste":0.2,"Haz_pctl":57,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":3.25,"Solid_pctl":63,"PollutionS":6.79,"Poll_pctl":84,"Asthma":51.34,"Asthma_Pct":58,"Low_Birth_":7.13,"LBW_pctl":"92","Cardiovasc":9.52,"CVD_pctl":69,"Education":45,"Edu_pctl":"91","Linguistic":14.4,"Ling_pctl":"73","Poverty":54.3,"Pov_pctl":"78","Unemployme":8.5,"Unem_pctl":"43","Housing_Bu":26.6,"HB_pctl":"81","PopCharSco":7.58,"Pop_Pctl":"84","Children__":17,"Pop_11_64_":77.6,"Elderly___":5.4,"Hispanic__":"81.4","White____":"3.9","African_Am":"9.1","Native_Ame":"0.1","Asian_Amer":"4.9","Other____":"0.6","Shape_Leng":4202.21871018,"Shape_Area":636619.929194}},{"arcs":[[310,311,312]],"type":"Polygon","properties":{"Tract_1":6037241201,"Percentile":"86-90%","Population":2898,"County":"Los Angeles","ZIP":90044,"City":"Los Angeles","CIscore":47.18,"CIscoreP":"86","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":24.76,"DPM_pctl":76,"DrinkingWa":664.07,"DW_pctl":"79","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5019.84,"TR_pctl":80,"Traffic":3651.92,"Traff_Pctl":"99","Cleanups":0,"Clean_Pctl":0,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.86,"Poll_pctl":66,"Asthma":84,"Asthma_Pct":87,"Low_Birth_":5.03,"LBW_pctl":"53","Cardiovasc":9.63,"CVD_pctl":71,"Education":36.2,"Edu_pctl":"83","Linguistic":14.2,"Ling_pctl":"73","Poverty":51.5,"Pov_pctl":"75","Unemployme":20.3,"Unem_pctl":"96","Housing_Bu":40.5,"HB_pctl":"98","PopCharSco":8.05,"Pop_Pctl":"90","Children__":16.6,"Pop_11_64_":74.8,"Elderly___":8.6,"Hispanic__":"51.8","White____":"0.7","African_Am":"46.3","Native_Ame":"0.1","Asian_Amer":"0.2","Other____":"0.9","Shape_Leng":3102.98803911,"Shape_Area":486047.179506}},{"arcs":[[313,314,-153]],"type":"Polygon","properties":{"Tract_1":6037980025,"Percentile":"NA","Population":0,"County":"Los Angeles","ZIP":90745,"City":"Carson","CIscore":0,"CIscoreP":"NA","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":26.67,"DPM_pctl":80,"DrinkingWa":0,"DW_pctl":"NA","Pesticides":0.092,"Pest_pctl":20,"Tox_Releas":9630.39,"TR_pctl":93,"Traffic":381.64,"Traff_Pctl":"19","Cleanups":75.75,"Clean_Pctl":98,"Groundwate":75.15,"GW_pctl":96,"Haz_Waste":4.18,"Haz_pctl":96,"Imp__Water":24,"IWB_pctl":100,"Solid_Wast":11.45,"Solid_pctl":91,"PollutionS":8.43,"Poll_pctl":98,"Asthma":0,"Asthma_Pct":0,"Low_Birth_":0,"LBW_pctl":"NA","Cardiovasc":0,"CVD_pctl":0,"Education":0,"Edu_pctl":"NA","Linguistic":0,"Ling_pctl":"NA","Poverty":0,"Pov_pctl":"NA","Unemployme":0,"Unem_pctl":"NA","Housing_Bu":0,"HB_pctl":"NA","PopCharSco":0,"Pop_Pctl":"NA","Children__":0,"Pop_11_64_":100,"Elderly___":0,"Hispanic__":"NA","White____":"NA","African_Am":"NA","Native_Ame":"NA","Asian_Amer":"NA","Other____":"NA","Shape_Leng":9188.74390364,"Shape_Area":2951914.86819}},{"arcs":[[315,316,317,318,-285,319,-198,320,321,-204,322,323,324,325,326]],"type":"Polygon","properties":{"Tract_1":6037980015,"Percentile":"NA","Population":554,"County":"Los Angeles","ZIP":90731,"City":"San Pedro","CIscore":0,"CIscoreP":"NA","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":41.31,"DPM_pctl":94,"DrinkingWa":198.88,"DW_pctl":"15","Pesticides":0,"Pest_pctl":0,"Tox_Releas":19144.58,"TR_pctl":98,"Traffic":1208.16,"Traff_Pctl":"75","Cleanups":33.1,"Clean_Pctl":92,"Groundwate":52.6,"GW_pctl":92,"Haz_Waste":6.67,"Haz_pctl":98,"Imp__Water":18,"IWB_pctl":98,"Solid_Wast":7.2,"Solid_pctl":83,"PollutionS":8.27,"Poll_pctl":97,"Asthma":56.06,"Asthma_Pct":64,"Low_Birth_":0,"LBW_pctl":"NA","Cardiovasc":8.16,"CVD_pctl":53,"Education":0,"Edu_pctl":"NA","Linguistic":0,"Ling_pctl":"NA","Poverty":52,"Pov_pctl":"76","Unemployme":0,"Unem_pctl":"NA","Housing_Bu":0,"HB_pctl":"NA","PopCharSco":0,"Pop_Pctl":"NA","Children__":14.9,"Pop_11_64_":83.3,"Elderly___":1.8,"Hispanic__":"48.9","White____":"19.7","African_Am":"17.3","Native_Ame":"0.5","Asian_Amer":"10.5","Other____":"3.1","Shape_Leng":10828.966647,"Shape_Area":5496150.58295}},{"arcs":[[327,328,329,330,331,332,333,334,335,336,337,338,339,340,341,342,343,344,345,346,347,348,349,350,351]],"type":"Polygon","properties":{"Tract_1":6037670602,"Percentile":"1-5%","Population":7345,"County":"Los Angeles","ZIP":90275,"City":"Rancho Palos Verdes","CIscore":4.65,"CIscoreP":"3","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":4.59,"DPM_pctl":13,"DrinkingWa":405.43,"DW_pctl":"42","Pesticides":0.045,"Pest_pctl":15,"Tox_Releas":2876.38,"TR_pctl":73,"Traffic":235.3,"Traff_Pctl":"7","Cleanups":50.4,"Clean_Pctl":96,"Groundwate":9,"GW_pctl":46,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":9,"IWB_pctl":81,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.77,"Poll_pctl":42,"Asthma":11.13,"Asthma_Pct":1,"Low_Birth_":3.23,"LBW_pctl":"12","Cardiovasc":3.89,"CVD_pctl":4,"Education":3.2,"Edu_pctl":"11","Linguistic":4,"Ling_pctl":"30","Poverty":9.9,"Pov_pctl":"7","Unemployme":4.1,"Unem_pctl":"7","Housing_Bu":9.2,"HB_pctl":"10","PopCharSco":0.97,"Pop_Pctl":"1","Children__":8.7,"Pop_11_64_":67.2,"Elderly___":24.1,"Hispanic__":"8.1","White____":"62.5","African_Am":"3","Native_Ame":"0.1","Asian_Amer":"22.4","Other____":"3.9","Shape_Leng":28857.0212266,"Shape_Area":14261781.03}},{"arcs":[[352,353,354,355,356,357,-342,358,359,360,361]],"type":"Polygon","properties":{"Tract_1":6037670416,"Percentile":"11-15%","Population":4139,"County":"Los Angeles","ZIP":90275,"City":"Rancho Palos Verdes","CIscore":10.07,"CIscoreP":"13","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":3.13,"DPM_pctl":9,"DrinkingWa":217.71,"DW_pctl":"17","Pesticides":0,"Pest_pctl":0,"Tox_Releas":1612.58,"TR_pctl":65,"Traffic":233.75,"Traff_Pctl":"7","Cleanups":19,"Clean_Pctl":83,"Groundwate":0.9,"GW_pctl":4,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":8,"IWB_pctl":76,"Solid_Wast":0.25,"Solid_pctl":10,"PollutionS":4.01,"Poll_pctl":26,"Asthma":12.04,"Asthma_Pct":1,"Low_Birth_":5.52,"LBW_pctl":"66","Cardiovasc":4.66,"CVD_pctl":9,"Education":1.4,"Edu_pctl":"3","Linguistic":5.7,"Ling_pctl":"40","Poverty":16.1,"Pov_pctl":"18","Unemployme":5.8,"Unem_pctl":"19","Housing_Bu":14.5,"HB_pctl":"33","PopCharSco":2.51,"Pop_Pctl":"13","Children__":9.3,"Pop_11_64_":67.6,"Elderly___":23.1,"Hispanic__":"5.9","White____":"50.2","African_Am":"2.7","Native_Ame":"0.1","Asian_Amer":"36.1","Other____":"5","Shape_Leng":8972.69493976,"Shape_Area":3908287.00906}},{"arcs":[[362,363,364,365,366]],"type":"Polygon","properties":{"Tract_1":6037503106,"Percentile":"71-75%","Population":3795,"County":"Los Angeles","ZIP":90604,"City":"Whittier","CIscore":36.72,"CIscoreP":"71","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":20.88,"DPM_pctl":64,"DrinkingWa":396.59,"DW_pctl":"42","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5515.58,"TR_pctl":82,"Traffic":535.97,"Traff_Pctl":"34","Cleanups":1,"Clean_Pctl":18,"Groundwate":3,"GW_pctl":22,"Haz_Waste":0.11,"Haz_pctl":46,"Imp__Water":2,"IWB_pctl":29,"Solid_Wast":1.25,"Solid_pctl":37,"PollutionS":5.29,"Poll_pctl":53,"Asthma":58.45,"Asthma_Pct":67,"Low_Birth_":4.75,"LBW_pctl":"45","Cardiovasc":12.73,"CVD_pctl":92,"Education":23.9,"Edu_pctl":"68","Linguistic":13.1,"Ling_pctl":"70","Poverty":43.6,"Pov_pctl":"65","Unemployme":12.5,"Unem_pctl":"73","Housing_Bu":18.7,"HB_pctl":"53","PopCharSco":6.94,"Pop_Pctl":"76","Children__":15.4,"Pop_11_64_":75,"Elderly___":9.6,"Hispanic__":"73.1","White____":"20.7","African_Am":"0.9","Native_Ame":"0.3","Asian_Amer":"4.1","Other____":"0.9","Shape_Leng":4424.30998883,"Shape_Area":922239.458489}},{"arcs":[[367,368,369,370,371,-363,372]],"type":"Polygon","properties":{"Tract_1":6037503105,"Percentile":"76-80%","Population":3634,"County":"Los Angeles","ZIP":90604,"City":"Whittier","CIscore":40.11,"CIscoreP":"76","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":18.69,"DPM_pctl":58,"DrinkingWa":568.28,"DW_pctl":"60","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5475.85,"TR_pctl":82,"Traffic":507.01,"Traff_Pctl":"31","Cleanups":12,"Clean_Pctl":69,"Groundwate":0.3,"GW_pctl":2,"Haz_Waste":0.08,"Haz_pctl":32,"Imp__Water":2,"IWB_pctl":29,"Solid_Wast":9.2,"Solid_pctl":88,"PollutionS":6.1,"Poll_pctl":71,"Asthma":55.51,"Asthma_Pct":64,"Low_Birth_":6.11,"LBW_pctl":"78","Cardiovasc":12.01,"CVD_pctl":89,"Education":25.8,"Edu_pctl":"71","Linguistic":9.9,"Ling_pctl":"59","Poverty":31.3,"Pov_pctl":"47","Unemployme":8.4,"Unem_pctl":"42","Housing_Bu":14,"HB_pctl":"30","PopCharSco":6.57,"Pop_Pctl":"70","Children__":15.5,"Pop_11_64_":77.9,"Elderly___":6.6,"Hispanic__":"75.6","White____":"14.4","African_Am":"2.3","Native_Ame":"0.2","Asian_Amer":"6.1","Other____":"1.3","Shape_Leng":5113.929948,"Shape_Area":1112891.92381}},{"arcs":[[-31,373,-371,374,375]],"type":"Polygon","properties":{"Tract_1":6037503103,"Percentile":"71-75%","Population":5004,"County":"Los Angeles","ZIP":90605,"City":"Whittier","CIscore":36.39,"CIscoreP":"71","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":19.34,"DPM_pctl":60,"DrinkingWa":572.36,"DW_pctl":"60","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5482.16,"TR_pctl":82,"Traffic":508.23,"Traff_Pctl":"32","Cleanups":6.3,"Clean_Pctl":49,"Groundwate":7.55,"GW_pctl":41,"Haz_Waste":0.04,"Haz_pctl":18,"Imp__Water":2,"IWB_pctl":29,"Solid_Wast":6.2,"Solid_pctl":79,"PollutionS":6.1,"Poll_pctl":71,"Asthma":50.44,"Asthma_Pct":57,"Low_Birth_":4.48,"LBW_pctl":"38","Cardiovasc":9.61,"CVD_pctl":70,"Education":22.4,"Edu_pctl":"66","Linguistic":14.3,"Ling_pctl":"73","Poverty":39.5,"Pov_pctl":"59","Unemployme":11.1,"Unem_pctl":"64","Housing_Bu":15.5,"HB_pctl":"37","PopCharSco":5.96,"Pop_Pctl":"61","Children__":14.7,"Pop_11_64_":78.1,"Elderly___":7.2,"Hispanic__":"85.1","White____":"9.7","African_Am":"1","Native_Ame":"0.2","Asian_Amer":"3.5","Other____":"0.6","Shape_Leng":4714.81434781,"Shape_Area":1085815.8959}},{"arcs":[[376,377,378,379,380,-360,381,382]],"type":"Polygon","properties":{"Tract_1":6037670328,"Percentile":"1-5%","Population":4504,"County":"Los Angeles","ZIP":90274,"City":"Palos Verdes Peninsula","CIscore":3.93,"CIscoreP":"2","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":3.26,"DPM_pctl":9,"DrinkingWa":219.86,"DW_pctl":"17","Pesticides":0,"Pest_pctl":0,"Tox_Releas":1740.58,"TR_pctl":66,"Traffic":241.53,"Traff_Pctl":"8","Cleanups":0,"Clean_Pctl":0,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":1,"Solid_pctl":33,"PollutionS":3.41,"Poll_pctl":15,"Asthma":18.94,"Asthma_Pct":7,"Low_Birth_":3.51,"LBW_pctl":"17","Cardiovasc":5.65,"CVD_pctl":20,"Education":0.7,"Edu_pctl":"1","Linguistic":3,"Ling_pctl":"23","Poverty":7.9,"Pov_pctl":"4","Unemployme":2.4,"Unem_pctl":"1","Housing_Bu":9.5,"HB_pctl":"11","PopCharSco":1.15,"Pop_Pctl":"2","Children__":9.3,"Pop_11_64_":68.9,"Elderly___":21.8,"Hispanic__":"5.6","White____":"70.4","African_Am":"1","Native_Ame":"0.1","Asian_Amer":"19","Other____":"3.8","Shape_Leng":10636.3820016,"Shape_Area":3913548.36826}},{"arcs":[[383,384,385,386,387,388,-378,389,-383,390,391,392,393,394,395]],"type":"Polygon","properties":{"Tract_1":6037670326,"Percentile":"6-10%","Population":3807,"County":"Los Angeles","ZIP":90274,"City":"Palos Verdes Peninsula","CIscore":8.3,"CIscoreP":"9","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":3.42,"DPM_pctl":10,"DrinkingWa":187.24,"DW_pctl":"14","Pesticides":0,"Pest_pctl":0,"Tox_Releas":2505.37,"TR_pctl":71,"Traffic":312.36,"Traff_Pctl":"13","Cleanups":4,"Clean_Pctl":39,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":8,"IWB_pctl":76,"Solid_Wast":0.6,"Solid_pctl":21,"PollutionS":3.82,"Poll_pctl":22,"Asthma":21.15,"Asthma_Pct":9,"Low_Birth_":5.61,"LBW_pctl":"68","Cardiovasc":6.25,"CVD_pctl":27,"Education":1.9,"Edu_pctl":"5","Linguistic":3.7,"Ling_pctl":"28","Poverty":3.4,"Pov_pctl":"0","Unemployme":0.2,"Unem_pctl":"0","Housing_Bu":5.3,"HB_pctl":"2","PopCharSco":2.17,"Pop_Pctl":"9","Children__":8.5,"Pop_11_64_":64.7,"Elderly___":26.8,"Hispanic__":"4.9","White____":"68","African_Am":"1.7","Native_Ame":"0.1","Asian_Amer":"22.5","Other____":"2.9","Shape_Leng":11974.7031691,"Shape_Area":4325130.64442}},{"arcs":[[396,397,398,399,400,-384,401,-395,402,403,-392,404]],"type":"Polygon","properties":{"Tract_1":6037670324,"Percentile":"1-5%","Population":5127,"County":"Los Angeles","ZIP":90274,"City":"Palos Verdes Peninsula","CIscore":5.37,"CIscoreP":"4","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":7,"DPM_pctl":19,"DrinkingWa":221.81,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":4140.64,"TR_pctl":77,"Traffic":360.51,"Traff_Pctl":"17","Cleanups":2.3,"Clean_Pctl":29,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.04,"Haz_pctl":18,"Imp__Water":8,"IWB_pctl":76,"Solid_Wast":3.5,"Solid_pctl":65,"PollutionS":4.53,"Poll_pctl":37,"Asthma":18.54,"Asthma_Pct":6,"Low_Birth_":3.74,"LBW_pctl":"21","Cardiovasc":5.44,"CVD_pctl":17,"Education":1.8,"Edu_pctl":"5","Linguistic":0.7,"Ling_pctl":"3","Poverty":11.9,"Pov_pctl":"10","Unemployme":3.3,"Unem_pctl":"4","Housing_Bu":11.5,"HB_pctl":"19","PopCharSco":1.19,"Pop_Pctl":"2","Children__":10.8,"Pop_11_64_":64.9,"Elderly___":24.3,"Hispanic__":"3.8","White____":"80.2","African_Am":"0.8","Native_Ame":"0.1","Asian_Amer":"11.7","Other____":"3.4","Shape_Leng":14083.1418768,"Shape_Area":4847672.57177}},{"arcs":[[405,406,407,408,409,410]],"type":"Polygon","properties":{"Tract_1":6037651402,"Percentile":"21-25%","Population":6050,"County":"Los Angeles","ZIP":90505,"City":"Torrance","CIscore":13.76,"CIscoreP":"22","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":14.7,"DPM_pctl":45,"DrinkingWa":188.12,"DW_pctl":"14","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5833.26,"TR_pctl":84,"Traffic":814.82,"Traff_Pctl":"58","Cleanups":7.7,"Clean_Pctl":54,"Groundwate":0.75,"GW_pctl":4,"Haz_Waste":0.7,"Haz_pctl":83,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":4.5,"Solid_pctl":70,"PollutionS":5.42,"Poll_pctl":56,"Asthma":26.83,"Asthma_Pct":19,"Low_Birth_":3.95,"LBW_pctl":"25","Cardiovasc":6.41,"CVD_pctl":29,"Education":2.9,"Edu_pctl":"10","Linguistic":11.4,"Ling_pctl":"64","Poverty":16.2,"Pov_pctl":"19","Unemployme":4.8,"Unem_pctl":"11","Housing_Bu":11.5,"HB_pctl":"19","PopCharSco":2.54,"Pop_Pctl":"13","Children__":11.8,"Pop_11_64_":75.5,"Elderly___":12.7,"Hispanic__":"10.7","White____":"45.1","African_Am":"1.6","Native_Ame":"0.1","Asian_Amer":"37.9","Other____":"4.6","Shape_Leng":7211.83928332,"Shape_Area":1826183.08762}},{"arcs":[[411,412,413,414,-409,415]],"type":"Polygon","properties":{"Tract_1":6037651401,"Percentile":"6-10%","Population":2614,"County":"Los Angeles","ZIP":90505,"City":"Torrance","CIscore":7.9,"CIscoreP":"8","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":16.66,"DPM_pctl":51,"DrinkingWa":186,"DW_pctl":"14","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5730.05,"TR_pctl":83,"Traffic":938.8,"Traff_Pctl":"64","Cleanups":6.5,"Clean_Pctl":50,"Groundwate":3,"GW_pctl":22,"Haz_Waste":0.14,"Haz_pctl":51,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":1.7,"Solid_pctl":40,"PollutionS":5.16,"Poll_pctl":50,"Asthma":21.88,"Asthma_Pct":11,"Low_Birth_":2.21,"LBW_pctl":"3","Cardiovasc":5.14,"CVD_pctl":14,"Education":4.2,"Edu_pctl":"16","Linguistic":2.2,"Ling_pctl":"16","Poverty":23.4,"Pov_pctl":"33","Unemployme":4.8,"Unem_pctl":"11","Housing_Bu":13,"HB_pctl":"26","PopCharSco":1.53,"Pop_Pctl":"4","Children__":9.8,"Pop_11_64_":67.5,"Elderly___":22.7,"Hispanic__":"9.6","White____":"60.5","African_Am":"1.8","Native_Ame":"0.2","Asian_Amer":"24.3","Other____":"3.6","Shape_Leng":4772.27605459,"Shape_Area":1008496.24837}},{"arcs":[[416,417,-126,418,419,420,421]],"type":"Polygon","properties":{"Tract_1":6037651304,"Percentile":"16-20%","Population":5114,"County":"Los Angeles","ZIP":90277,"City":"Redondo Beach","CIscore":12.07,"CIscoreP":"18","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":7.8,"DPM_pctl":22,"DrinkingWa":237.63,"DW_pctl":"24","Pesticides":0,"Pest_pctl":0,"Tox_Releas":4571.84,"TR_pctl":79,"Traffic":539.15,"Traff_Pctl":"35","Cleanups":0,"Clean_Pctl":0,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.05,"Haz_pctl":26,"Imp__Water":8,"IWB_pctl":76,"Solid_Wast":0.25,"Solid_pctl":10,"PollutionS":4.22,"Poll_pctl":30,"Asthma":23.54,"Asthma_Pct":13,"Low_Birth_":6.05,"LBW_pctl":"77","Cardiovasc":6.37,"CVD_pctl":29,"Education":0.9,"Edu_pctl":"1","Linguistic":2.3,"Ling_pctl":"17","Poverty":9.8,"Pov_pctl":"7","Unemployme":6.2,"Unem_pctl":"22","Housing_Bu":13.9,"HB_pctl":"30","PopCharSco":2.86,"Pop_Pctl":"17","Children__":9.1,"Pop_11_64_":74.2,"Elderly___":16.7,"Hispanic__":"10.2","White____":"77.4","African_Am":"1","Native_Ame":"0.2","Asian_Amer":"7.5","Other____":"3.8","Shape_Leng":6868.84565009,"Shape_Area":1499423.71781}},{"arcs":[[422,423,424,425,426,427]],"type":"Polygon","properties":{"Tract_1":6037552002,"Percentile":"76-80%","Population":3721,"County":"Los Angeles","ZIP":90650,"City":"Norwalk","CIscore":40.75,"CIscoreP":"77","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":26.92,"DPM_pctl":80,"DrinkingWa":586.74,"DW_pctl":"62","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5340.14,"TR_pctl":82,"Traffic":436.39,"Traff_Pctl":"24","Cleanups":4.4,"Clean_Pctl":40,"Groundwate":7.5,"GW_pctl":41,"Haz_Waste":0.01,"Haz_pctl":9,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":5.3,"Poll_pctl":53,"Asthma":62.88,"Asthma_Pct":72,"Low_Birth_":5.32,"LBW_pctl":"61","Cardiovasc":13.42,"CVD_pctl":94,"Education":25.2,"Edu_pctl":"70","Linguistic":16,"Ling_pctl":"77","Poverty":36.9,"Pov_pctl":"55","Unemployme":16.5,"Unem_pctl":"89","Housing_Bu":22.8,"HB_pctl":"70","PopCharSco":7.69,"Pop_Pctl":"86","Children__":14.7,"Pop_11_64_":77.3,"Elderly___":8,"Hispanic__":"70.2","White____":"9.2","African_Am":"6.3","Native_Ame":"0.4","Asian_Amer":"12.3","Other____":"1.6","Shape_Leng":3524.33592994,"Shape_Area":706598.643412}},{"arcs":[[428,429,430,-426,431]],"type":"Polygon","properties":{"Tract_1":6037552001,"Percentile":"66-70%","Population":4105,"County":"Los Angeles","ZIP":90650,"City":"Norwalk","CIscore":35.89,"CIscoreP":"70","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":26.92,"DPM_pctl":80,"DrinkingWa":489.69,"DW_pctl":"52","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5400.38,"TR_pctl":82,"Traffic":487.6,"Traff_Pctl":"29","Cleanups":8,"Clean_Pctl":56,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.05,"Haz_pctl":26,"Imp__Water":3,"IWB_pctl":41,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.44,"Poll_pctl":56,"Asthma":62.88,"Asthma_Pct":72,"Low_Birth_":6.03,"LBW_pctl":"77","Cardiovasc":13.42,"CVD_pctl":94,"Education":16.5,"Edu_pctl":"55","Linguistic":7.4,"Ling_pctl":"48","Poverty":39.6,"Pov_pctl":"59","Unemployme":10.2,"Unem_pctl":"58","Housing_Bu":9,"HB_pctl":"9","PopCharSco":6.6,"Pop_Pctl":"71","Children__":13.1,"Pop_11_64_":76.3,"Elderly___":10.6,"Hispanic__":"73.3","White____":"12.1","African_Am":"2.9","Native_Ame":"0.4","Asian_Amer":"10.2","Other____":"1.1","Shape_Leng":3772.84648527,"Shape_Area":802645.665594}},{"arcs":[[432,433,434,435,436]],"type":"Polygon","properties":{"Tract_1":6037551502,"Percentile":"61-65%","Population":4250,"County":"Los Angeles","ZIP":90242,"City":"Downey","CIscore":31.65,"CIscoreP":"62","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":18.34,"DPM_pctl":56,"DrinkingWa":595.65,"DW_pctl":"64","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6368.28,"TR_pctl":86,"Traffic":784.56,"Traff_Pctl":"56","Cleanups":0,"Clean_Pctl":0,"Groundwate":0.3,"GW_pctl":2,"Haz_Waste":0.01,"Haz_pctl":9,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":1.55,"Solid_pctl":39,"PollutionS":5.51,"Poll_pctl":58,"Asthma":49.21,"Asthma_Pct":55,"Low_Birth_":3.9,"LBW_pctl":"24","Cardiovasc":8.75,"CVD_pctl":60,"Education":19.8,"Edu_pctl":"62","Linguistic":6.1,"Ling_pctl":"42","Poverty":42.9,"Pov_pctl":"64","Unemployme":14.1,"Unem_pctl":"81","Housing_Bu":23.9,"HB_pctl":"74","PopCharSco":5.75,"Pop_Pctl":"58","Children__":13.7,"Pop_11_64_":75.1,"Elderly___":11.2,"Hispanic__":"69.1","White____":"18.9","African_Am":"3.2","Native_Ame":"0.1","Asian_Amer":"7.4","Other____":"1.3","Shape_Leng":5595.27012068,"Shape_Area":1102703.57874}},{"arcs":[[437,438,439,440]],"type":"Polygon","properties":{"Tract_1":6037551501,"Percentile":"61-65%","Population":4869,"County":"Los Angeles","ZIP":90242,"City":"Downey","CIscore":32.52,"CIscoreP":"64","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":16.41,"DPM_pctl":50,"DrinkingWa":630.41,"DW_pctl":"71","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6740.32,"TR_pctl":87,"Traffic":1077.2,"Traff_Pctl":"71","Cleanups":6.4,"Clean_Pctl":49,"Groundwate":24.05,"GW_pctl":76,"Haz_Waste":0.35,"Haz_pctl":71,"Imp__Water":10,"IWB_pctl":86,"Solid_Wast":5.5,"Solid_pctl":76,"PollutionS":7.65,"Poll_pctl":94,"Asthma":45.76,"Asthma_Pct":51,"Low_Birth_":3.37,"LBW_pctl":"14","Cardiovasc":8.26,"CVD_pctl":54,"Education":13.9,"Edu_pctl":"50","Linguistic":10,"Ling_pctl":"59","Poverty":33.4,"Pov_pctl":"50","Unemployme":7.7,"Unem_pctl":"36","Housing_Bu":10.9,"HB_pctl":"16","PopCharSco":4.25,"Pop_Pctl":"36","Children__":13,"Pop_11_64_":77.3,"Elderly___":9.7,"Hispanic__":"65.6","White____":"21.2","African_Am":"4.6","Native_Ame":"0.1","Asian_Amer":"7.2","Other____":"1.2","Shape_Leng":5561.98897514,"Shape_Area":1463921.21607}},{"arcs":[[441,442,443,444,445]],"type":"Polygon","properties":{"Tract_1":6037551102,"Percentile":"86-90%","Population":5503,"County":"Los Angeles","ZIP":90242,"City":"Downey","CIscore":47.06,"CIscoreP":"86","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":24.08,"DPM_pctl":73,"DrinkingWa":677.47,"DW_pctl":"80","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5929.04,"TR_pctl":84,"Traffic":802.47,"Traff_Pctl":"57","Cleanups":11.1,"Clean_Pctl":65,"Groundwate":38.5,"GW_pctl":87,"Haz_Waste":0.26,"Haz_pctl":67,"Imp__Water":3,"IWB_pctl":41,"Solid_Wast":5.75,"Solid_pctl":76,"PollutionS":7.65,"Poll_pctl":94,"Asthma":32.94,"Asthma_Pct":30,"Low_Birth_":6.22,"LBW_pctl":"81","Cardiovasc":6.1,"CVD_pctl":25,"Education":35.1,"Edu_pctl":"82","Linguistic":14.2,"Ling_pctl":"73","Poverty":53.2,"Pov_pctl":"77","Unemployme":9.4,"Unem_pctl":"51","Housing_Bu":28,"HB_pctl":"84","PopCharSco":6.15,"Pop_Pctl":"64","Children__":18.6,"Pop_11_64_":77.5,"Elderly___":3.9,"Hispanic__":"79","White____":"8.3","African_Am":"7.4","Native_Ame":"0.3","Asian_Amer":"3.8","Other____":"1.1","Shape_Leng":6287.76481043,"Shape_Area":1684872.14315}},{"arcs":[[-444,446,447]],"type":"Polygon","properties":{"Tract_1":6037551101,"Percentile":"86-90%","Population":3926,"County":"Los Angeles","ZIP":90242,"City":"Downey","CIscore":49.4,"CIscoreP":"88","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":23.54,"DPM_pctl":72,"DrinkingWa":639.07,"DW_pctl":"72","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5868.27,"TR_pctl":84,"Traffic":654.81,"Traff_Pctl":"47","Cleanups":13,"Clean_Pctl":72,"Groundwate":57,"GW_pctl":93,"Haz_Waste":0.21,"Haz_pctl":62,"Imp__Water":3,"IWB_pctl":41,"Solid_Wast":3.45,"Solid_pctl":63,"PollutionS":7.38,"Poll_pctl":91,"Asthma":43.7,"Asthma_Pct":47,"Low_Birth_":5.37,"LBW_pctl":"63","Cardiovasc":7.88,"CVD_pctl":49,"Education":30.9,"Edu_pctl":"78","Linguistic":22,"Ling_pctl":"87","Poverty":55.5,"Pov_pctl":"80","Unemployme":12.8,"Unem_pctl":"75","Housing_Bu":20.6,"HB_pctl":"62","PopCharSco":6.7,"Pop_Pctl":"72","Children__":16.8,"Pop_11_64_":77.7,"Elderly___":5.5,"Hispanic__":"76.1","White____":"10.7","African_Am":"5.3","Native_Ame":"0.2","Asian_Amer":"6.5","Other____":"1.2","Shape_Leng":6705.86921972,"Shape_Area":1684498.09659}},{"arcs":[[448,449,450,451,452,453,454,455,456]],"type":"Polygon","properties":{"Tract_1":6037503602,"Percentile":"21-25%","Population":3793,"County":"Los Angeles","ZIP":90638,"City":"La Mirada","CIscore":13.87,"CIscoreP":"22","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":22.93,"DPM_pctl":70,"DrinkingWa":507.72,"DW_pctl":"54","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5755.33,"TR_pctl":83,"Traffic":651.82,"Traff_Pctl":"46","Cleanups":1,"Clean_Pctl":18,"Groundwate":6,"GW_pctl":36,"Haz_Waste":0.08,"Haz_pctl":31,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.07,"Poll_pctl":48,"Asthma":37.26,"Asthma_Pct":37,"Low_Birth_":2.39,"LBW_pctl":"4","Cardiovasc":9.99,"CVD_pctl":75,"Education":5.7,"Edu_pctl":"23","Linguistic":2.3,"Ling_pctl":"17","Poverty":15.1,"Pov_pctl":"16","Unemployme":3,"Unem_pctl":"2","Housing_Bu":10,"HB_pctl":"12","PopCharSco":2.74,"Pop_Pctl":"15","Children__":9.2,"Pop_11_64_":72.4,"Elderly___":18.4,"Hispanic__":"36.6","White____":"48.8","African_Am":"1.4","Native_Ame":"0.2","Asian_Amer":"11.3","Other____":"1.7","Shape_Leng":7797.24270781,"Shape_Area":3296738.26945}},{"arcs":[[457,458,459,460,461,462,463]],"type":"Polygon","properties":{"Tract_1":6037543321,"Percentile":"76-80%","Population":5418,"County":"Los Angeles","ZIP":90747,"City":"Carson","CIscore":40.27,"CIscoreP":"76","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":30.86,"DPM_pctl":86,"DrinkingWa":256.46,"DW_pctl":"26","Pesticides":12.983,"Pest_pctl":61,"Tox_Releas":7397.73,"TR_pctl":89,"Traffic":1347.32,"Traff_Pctl":"79","Cleanups":11.4,"Clean_Pctl":66,"Groundwate":12.8,"GW_pctl":56,"Haz_Waste":1.19,"Haz_pctl":88,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":1.9,"Solid_pctl":41,"PollutionS":7.4,"Poll_pctl":92,"Asthma":61.08,"Asthma_Pct":70,"Low_Birth_":9.38,"LBW_pctl":"99","Cardiovasc":6.86,"CVD_pctl":35,"Education":10,"Edu_pctl":"39","Linguistic":5.2,"Ling_pctl":"38","Poverty":17.2,"Pov_pctl":"21","Unemployme":11.8,"Unem_pctl":"69","Housing_Bu":10.9,"HB_pctl":"16","PopCharSco":5.45,"Pop_Pctl":"54","Children__":10.7,"Pop_11_64_":74.3,"Elderly___":15,"Hispanic__":"13.8","White____":"8.8","African_Am":"61.4","Native_Ame":"0.1","Asian_Amer":"12.6","Other____":"3.4","Shape_Leng":9131.08897327,"Shape_Area":4876296.71285}},{"arcs":[[464,465,466,467]],"type":"Polygon","properties":{"Tract_1":6037541500,"Percentile":"96-100%","Population":5836,"County":"Los Angeles","ZIP":90222,"City":"Compton","CIscore":59.74,"CIscoreP":"96","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":18.7,"DPM_pctl":58,"DrinkingWa":675.24,"DW_pctl":"80","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6003.65,"TR_pctl":85,"Traffic":725.69,"Traff_Pctl":"52","Cleanups":33.2,"Clean_Pctl":92,"Groundwate":28.75,"GW_pctl":81,"Haz_Waste":12.53,"Haz_pctl":100,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":16.1,"Solid_pctl":96,"PollutionS":7.67,"Poll_pctl":94,"Asthma":102.03,"Asthma_Pct":93,"Low_Birth_":4.18,"LBW_pctl":"30","Cardiovasc":12,"CVD_pctl":89,"Education":55.4,"Edu_pctl":"97","Linguistic":13.8,"Ling_pctl":"72","Poverty":61.6,"Pov_pctl":"86","Unemployme":12.2,"Unem_pctl":"71","Housing_Bu":23.4,"HB_pctl":"72","PopCharSco":7.79,"Pop_Pctl":"87","Children__":19.8,"Pop_11_64_":75.5,"Elderly___":4.7,"Hispanic__":"85.9","White____":"0.4","African_Am":"12.7","Native_Ame":"0","Asian_Amer":"0.6","Other____":"0.3","Shape_Leng":3931.97898565,"Shape_Area":812556.02923}},{"arcs":[[468,469,-34,470,-442,471]],"type":"Polygon","properties":{"Tract_1":6037550300,"Percentile":"86-90%","Population":7727,"County":"Los Angeles","ZIP":90650,"City":"Norwalk","CIscore":46.87,"CIscoreP":"85","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":26.97,"DPM_pctl":80,"DrinkingWa":579.1,"DW_pctl":"61","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5704.51,"TR_pctl":83,"Traffic":2337.72,"Traff_Pctl":"94","Cleanups":5.4,"Clean_Pctl":45,"Groundwate":2,"GW_pctl":14,"Haz_Waste":0.38,"Haz_pctl":72,"Imp__Water":3,"IWB_pctl":41,"Solid_Wast":7.3,"Solid_pctl":84,"PollutionS":7.41,"Poll_pctl":92,"Asthma":56.44,"Asthma_Pct":65,"Low_Birth_":4.45,"LBW_pctl":"37","Cardiovasc":11.99,"CVD_pctl":89,"Education":23.4,"Edu_pctl":"68","Linguistic":9.6,"Ling_pctl":"58","Poverty":33.4,"Pov_pctl":"50","Unemployme":11,"Unem_pctl":"63","Housing_Bu":18.8,"HB_pctl":"54","PopCharSco":6.32,"Pop_Pctl":"67","Children__":13.6,"Pop_11_64_":76.7,"Elderly___":9.7,"Hispanic__":"70.4","White____":"16","African_Am":"3.4","Native_Ame":"0.3","Asian_Amer":"8.6","Other____":"1.3","Shape_Leng":6761.1057652,"Shape_Area":2533234.90249}},{"arcs":[[472,473,-170,474]],"type":"Polygon","properties":{"Tract_1":6037542401,"Percentile":"96-100%","Population":4912,"County":"Los Angeles","ZIP":90221,"City":"Compton","CIscore":61.23,"CIscoreP":"97","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":25.9,"DPM_pctl":78,"DrinkingWa":444.63,"DW_pctl":"46","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6118.97,"TR_pctl":85,"Traffic":611.28,"Traff_Pctl":"43","Cleanups":9,"Clean_Pctl":60,"Groundwate":32.75,"GW_pctl":84,"Haz_Waste":1.11,"Haz_pctl":88,"Imp__Water":9,"IWB_pctl":81,"Solid_Wast":3.5,"Solid_pctl":65,"PollutionS":7.48,"Poll_pctl":93,"Asthma":87.61,"Asthma_Pct":88,"Low_Birth_":5.95,"LBW_pctl":"76","Cardiovasc":13.56,"CVD_pctl":95,"Education":31.1,"Edu_pctl":"78","Linguistic":8.1,"Ling_pctl":"52","Poverty":51.8,"Pov_pctl":"75","Unemployme":17.7,"Unem_pctl":"92","Housing_Bu":20.6,"HB_pctl":"62","PopCharSco":8.19,"Pop_Pctl":"92","Children__":16.8,"Pop_11_64_":74.1,"Elderly___":9.1,"Hispanic__":"56.1","White____":"0.8","African_Am":"40","Native_Ame":"0.1","Asian_Amer":"1.7","Other____":"1.4","Shape_Leng":4798.3362139,"Shape_Area":1291174.71064}},{"arcs":[[475,476]],"type":"Polygon","properties":{"Tract_1":6037543702,"Percentile":"76-80%","Population":7083,"County":"Los Angeles","ZIP":90745,"City":"Carson","CIscore":39.85,"CIscoreP":"76","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":20.09,"DPM_pctl":62,"DrinkingWa":182.06,"DW_pctl":"14","Pesticides":12.808,"Pest_pctl":60,"Tox_Releas":8167.02,"TR_pctl":91,"Traffic":443.7,"Traff_Pctl":"25","Cleanups":2.75,"Clean_Pctl":31,"Groundwate":16.3,"GW_pctl":64,"Haz_Waste":1.46,"Haz_pctl":90,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.5,"Solid_pctl":20,"PollutionS":5.79,"Poll_pctl":64,"Asthma":60.31,"Asthma_Pct":70,"Low_Birth_":5.64,"LBW_pctl":"69","Cardiovasc":9.96,"CVD_pctl":74,"Education":25.7,"Edu_pctl":"71","Linguistic":14.6,"Ling_pctl":"73","Poverty":38.4,"Pov_pctl":"57","Unemployme":15.5,"Unem_pctl":"86","Housing_Bu":11.8,"HB_pctl":"20","PopCharSco":6.88,"Pop_Pctl":"75","Children__":13.9,"Pop_11_64_":76.4,"Elderly___":9.7,"Hispanic__":"52","White____":"10","African_Am":"4.7","Native_Ame":"0.3","Asian_Amer":"30.8","Other____":"2.2","Shape_Leng":4595.61940041,"Shape_Area":1309217.29678}},{"arcs":[[477,478,479,480]],"type":"Polygon","properties":{"Tract_1":6037541100,"Percentile":"96-100%","Population":3321,"County":"Los Angeles","ZIP":90220,"City":"Compton","CIscore":61.88,"CIscoreP":"97","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":26.06,"DPM_pctl":78,"DrinkingWa":286.76,"DW_pctl":"30","Pesticides":0.275,"Pest_pctl":28,"Tox_Releas":6067.43,"TR_pctl":85,"Traffic":573.16,"Traff_Pctl":"39","Cleanups":13.6,"Clean_Pctl":74,"Groundwate":39.25,"GW_pctl":87,"Haz_Waste":1.44,"Haz_pctl":90,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":12,"Solid_pctl":92,"PollutionS":7.83,"Poll_pctl":95,"Asthma":96.77,"Asthma_Pct":92,"Low_Birth_":6.37,"LBW_pctl":"83","Cardiovasc":11.22,"CVD_pctl":84,"Education":32.6,"Edu_pctl":"79","Linguistic":5.2,"Ling_pctl":"38","Poverty":52.4,"Pov_pctl":"76","Unemployme":13.8,"Unem_pctl":"79","Housing_Bu":19.5,"HB_pctl":"57","PopCharSco":7.9,"Pop_Pctl":"89","Children__":15.6,"Pop_11_64_":74.9,"Elderly___":9.5,"Hispanic__":"49.8","White____":"0.8","African_Am":"47.9","Native_Ame":"0.2","Asian_Amer":"0.5","Other____":"0.8","Shape_Leng":4681.03978426,"Shape_Area":1241365.67573}},{"arcs":[[481,482,483,484]],"type":"Polygon","properties":{"Tract_1":6037602600,"Percentile":"96-100%","Population":7910,"County":"Los Angeles","ZIP":90249,"City":"Gardena","CIscore":62.19,"CIscoreP":"97","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":23.4,"DPM_pctl":72,"DrinkingWa":365.2,"DW_pctl":"38","Pesticides":4.228,"Pest_pctl":51,"Tox_Releas":4942.79,"TR_pctl":80,"Traffic":829.31,"Traff_Pctl":"59","Cleanups":55.35,"Clean_Pctl":97,"Groundwate":201.5,"GW_pctl":99,"Haz_Waste":1.73,"Haz_pctl":91,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":8.3,"Solid_pctl":86,"PollutionS":8.6,"Poll_pctl":99,"Asthma":86.69,"Asthma_Pct":88,"Low_Birth_":7.61,"LBW_pctl":"95","Cardiovasc":10.4,"CVD_pctl":78,"Education":12.6,"Edu_pctl":"47","Linguistic":2.2,"Ling_pctl":"16","Poverty":36.6,"Pov_pctl":"55","Unemployme":12.9,"Unem_pctl":"76","Housing_Bu":22.9,"HB_pctl":"70","PopCharSco":7.23,"Pop_Pctl":"80","Children__":10.8,"Pop_11_64_":72.8,"Elderly___":16.4,"Hispanic__":"16.7","White____":"3.1","African_Am":"74.3","Native_Ame":"0.2","Asian_Amer":"3.6","Other____":"2.2","Shape_Leng":6445.72401263,"Shape_Area":1946229.00247}},{"arcs":[[485,486,487,488,-485,489,490,491,492,493,-228]],"type":"Polygon","properties":{"Tract_1":6037602900,"Percentile":"96-100%","Population":4427,"County":"Los Angeles","ZIP":90249,"City":"Gardena","CIscore":58.13,"CIscoreP":"95","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":24.79,"DPM_pctl":76,"DrinkingWa":290.9,"DW_pctl":"31","Pesticides":20.72,"Pest_pctl":64,"Tox_Releas":5231.3,"TR_pctl":81,"Traffic":878.43,"Traff_Pctl":"62","Cleanups":37.7,"Clean_Pctl":94,"Groundwate":72.3,"GW_pctl":95,"Haz_Waste":1.15,"Haz_pctl":88,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":15.3,"Solid_pctl":95,"PollutionS":8.75,"Poll_pctl":99,"Asthma":64.76,"Asthma_Pct":74,"Low_Birth_":4.36,"LBW_pctl":"35","Cardiovasc":7.88,"CVD_pctl":49,"Education":30.6,"Edu_pctl":"77","Linguistic":22.6,"Ling_pctl":"88","Poverty":55.4,"Pov_pctl":"79","Unemployme":12.7,"Unem_pctl":"74","Housing_Bu":19.8,"HB_pctl":"58","PopCharSco":6.64,"Pop_Pctl":"71","Children__":14.9,"Pop_11_64_":75.7,"Elderly___":9.4,"Hispanic__":"66.8","White____":"6.6","African_Am":"18.8","Native_Ame":"0.4","Asian_Amer":"5.6","Other____":"1.9","Shape_Leng":8312.61704701,"Shape_Area":2798646.17581}},{"arcs":[[-249,494,495,496]],"type":"Polygon","properties":{"Tract_1":6037602301,"Percentile":"71-75%","Population":6265,"County":"Los Angeles","ZIP":90250,"City":"Hawthorne","CIscore":39,"CIscoreP":"74","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":30.76,"DPM_pctl":86,"DrinkingWa":374.29,"DW_pctl":"39","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5409.42,"TR_pctl":82,"Traffic":3181.11,"Traff_Pctl":"98","Cleanups":4.5,"Clean_Pctl":42,"Groundwate":13.65,"GW_pctl":58,"Haz_Waste":0.11,"Haz_pctl":46,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":6.2,"Poll_pctl":74,"Asthma":78.54,"Asthma_Pct":84,"Low_Birth_":5.05,"LBW_pctl":"54","Cardiovasc":10.73,"CVD_pctl":81,"Education":19.4,"Edu_pctl":"61","Linguistic":11.1,"Ling_pctl":"63","Poverty":20.9,"Pov_pctl":"29","Unemployme":9.3,"Unem_pctl":"50","Housing_Bu":15.9,"HB_pctl":"40","PopCharSco":6.29,"Pop_Pctl":"66","Children__":12.7,"Pop_11_64_":76.4,"Elderly___":10.9,"Hispanic__":"54.8","White____":"29.4","African_Am":"3.6","Native_Ame":"0.2","Asian_Amer":"8.7","Other____":"3.3","Shape_Leng":5869.28146824,"Shape_Area":1780451.23977}},{"arcs":[[497,498,499,500]],"type":"Polygon","properties":{"Tract_1":6037603704,"Percentile":"91-95%","Population":6348,"County":"Los Angeles","ZIP":90250,"City":"Hawthorne","CIscore":53.57,"CIscoreP":"92","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":23.4,"DPM_pctl":72,"DrinkingWa":255.67,"DW_pctl":"26","Pesticides":84.243,"Pest_pctl":75,"Tox_Releas":5217.83,"TR_pctl":81,"Traffic":1068.79,"Traff_Pctl":"71","Cleanups":0,"Clean_Pctl":0,"Groundwate":19.5,"GW_pctl":70,"Haz_Waste":0.02,"Haz_pctl":10,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":6.56,"Poll_pctl":80,"Asthma":80.75,"Asthma_Pct":85,"Low_Birth_":6.23,"LBW_pctl":"81","Cardiovasc":10.29,"CVD_pctl":77,"Education":33.8,"Edu_pctl":"81","Linguistic":19.8,"Ling_pctl":"84","Poverty":55.9,"Pov_pctl":"80","Unemployme":10.8,"Unem_pctl":"62","Housing_Bu":24.8,"HB_pctl":"76","PopCharSco":8.17,"Pop_Pctl":"91","Children__":18.7,"Pop_11_64_":77.5,"Elderly___":3.8,"Hispanic__":"58","White____":"5.1","African_Am":"28.9","Native_Ame":"0.1","Asian_Amer":"6.2","Other____":"1.6","Shape_Leng":3213.97033936,"Shape_Area":645595.897172}},{"arcs":[[501,502,503,504,505]],"type":"Polygon","properties":{"Tract_1":6037620001,"Percentile":"21-25%","Population":3943,"County":"Los Angeles","ZIP":90245,"City":"El Segundo","CIscore":13.71,"CIscoreP":"22","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":36.63,"DPM_pctl":91,"DrinkingWa":388.86,"DW_pctl":"41","Pesticides":0.002,"Pest_pctl":4,"Tox_Releas":3171.88,"TR_pctl":74,"Traffic":1057.7,"Traff_Pctl":"70","Cleanups":30.6,"Clean_Pctl":91,"Groundwate":8.05,"GW_pctl":43,"Haz_Waste":1.52,"Haz_pctl":90,"Imp__Water":5,"IWB_pctl":55,"Solid_Wast":1,"Solid_pctl":33,"PollutionS":7.28,"Poll_pctl":90,"Asthma":27.04,"Asthma_Pct":20,"Low_Birth_":2.25,"LBW_pctl":"3","Cardiovasc":7.48,"CVD_pctl":44,"Education":4.8,"Edu_pctl":"19","Linguistic":1.5,"Ling_pctl":"10","Poverty":12,"Pov_pctl":"11","Unemployme":6.4,"Unem_pctl":"24","Housing_Bu":8.4,"HB_pctl":"8","PopCharSco":1.88,"Pop_Pctl":"7","Children__":10,"Pop_11_64_":78.7,"Elderly___":11.3,"Hispanic__":"15.4","White____":"70.3","African_Am":"1.8","Native_Ame":"0.2","Asian_Amer":"8.2","Other____":"4.1","Shape_Leng":4483.41360317,"Shape_Area":1185164.54568}},{"arcs":[[506,507,508,509]],"type":"Polygon","properties":{"Tract_1":6037600302,"Percentile":"81-85%","Population":3317,"County":"Los Angeles","ZIP":90047,"City":"Los Angeles","CIscore":43.93,"CIscoreP":"81","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":18.08,"DPM_pctl":55,"DrinkingWa":255.67,"DW_pctl":"26","Pesticides":0,"Pest_pctl":0,"Tox_Releas":4836.56,"TR_pctl":80,"Traffic":651.54,"Traff_Pctl":"46","Cleanups":18,"Clean_Pctl":82,"Groundwate":5,"GW_pctl":32,"Haz_Waste":0.1,"Haz_pctl":43,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":4.35,"Solid_pctl":69,"PollutionS":5.72,"Poll_pctl":62,"Asthma":92.95,"Asthma_Pct":90,"Low_Birth_":7.83,"LBW_pctl":"96","Cardiovasc":7.86,"CVD_pctl":49,"Education":19,"Edu_pctl":"60","Linguistic":0,"Ling_pctl":"NA","Poverty":50.5,"Pov_pctl":"74","Unemployme":20.9,"Unem_pctl":"96","Housing_Bu":16.9,"HB_pctl":"45","PopCharSco":7.69,"Pop_Pctl":"86","Children__":11.7,"Pop_11_64_":73.7,"Elderly___":14.6,"Hispanic__":"27.1","White____":"0.8","African_Am":"69.2","Native_Ame":"0.2","Asian_Amer":"0.3","Other____":"2.4","Shape_Leng":3632.71716,"Shape_Area":813943.773113}},{"arcs":[[510,-222,511,512,-499]],"type":"Polygon","properties":{"Tract_1":6037603703,"Percentile":"76-80%","Population":2703,"County":"Los Angeles","ZIP":90250,"City":"Hawthorne","CIscore":39.8,"CIscoreP":"76","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":23.51,"DPM_pctl":72,"DrinkingWa":360.4,"DW_pctl":"37","Pesticides":80.437,"Pest_pctl":75,"Tox_Releas":5163.58,"TR_pctl":81,"Traffic":1319.97,"Traff_Pctl":"79","Cleanups":0,"Clean_Pctl":0,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.01,"Haz_pctl":9,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":2,"Solid_pctl":50,"PollutionS":6.54,"Poll_pctl":80,"Asthma":77.2,"Asthma_Pct":83,"Low_Birth_":6.03,"LBW_pctl":"77","Cardiovasc":10.55,"CVD_pctl":79,"Education":19.8,"Edu_pctl":"62","Linguistic":13.6,"Ling_pctl":"71","Poverty":11.9,"Pov_pctl":"10","Unemployme":5.8,"Unem_pctl":"19","Housing_Bu":13.1,"HB_pctl":"26","PopCharSco":6.09,"Pop_Pctl":"63","Children__":12.9,"Pop_11_64_":76.1,"Elderly___":11,"Hispanic__":"42.8","White____":"26.4","African_Am":"7.8","Native_Ame":"0.1","Asian_Amer":"19.8","Other____":"3.1","Shape_Leng":3315.01930137,"Shape_Area":652282.29872}},{"arcs":[[513,-212,514,515,516,517,518]],"type":"Polygon","properties":{"Tract_1":6037603900,"Percentile":"86-90%","Population":7527,"County":"Los Angeles","ZIP":90260,"City":"Lawndale","CIscore":47.83,"CIscoreP":"87","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":27.18,"DPM_pctl":81,"DrinkingWa":368.57,"DW_pctl":"38","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5151.48,"TR_pctl":81,"Traffic":2160.69,"Traff_Pctl":"92","Cleanups":4.6,"Clean_Pctl":43,"Groundwate":30.8,"GW_pctl":82,"Haz_Waste":0.15,"Haz_pctl":54,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":2.5,"Solid_pctl":57,"PollutionS":6.79,"Poll_pctl":84,"Asthma":62.52,"Asthma_Pct":72,"Low_Birth_":5.56,"LBW_pctl":"67","Cardiovasc":8.84,"CVD_pctl":61,"Education":30.5,"Edu_pctl":"77","Linguistic":15.7,"Ling_pctl":"76","Poverty":54,"Pov_pctl":"78","Unemployme":7.8,"Unem_pctl":"37","Housing_Bu":25.2,"HB_pctl":"77","PopCharSco":7.04,"Pop_Pctl":"77","Children__":14.6,"Pop_11_64_":76.8,"Elderly___":8.6,"Hispanic__":"61.9","White____":"17.4","African_Am":"8","Native_Ame":"0.4","Asian_Amer":"9.9","Other____":"2.4","Shape_Leng":6467.33802707,"Shape_Area":1491288.27429}},{"arcs":[[519,520,521]],"type":"Polygon","properties":{"Tract_1":6037603600,"Percentile":"66-70%","Population":4037,"County":"Los Angeles","ZIP":90249,"City":"Gardena","CIscore":35.56,"CIscoreP":"69","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":22.64,"DPM_pctl":69,"DrinkingWa":287.68,"DW_pctl":"30","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6628.1,"TR_pctl":87,"Traffic":1003.27,"Traff_Pctl":"68","Cleanups":0,"Clean_Pctl":0,"Groundwate":8.4,"GW_pctl":43,"Haz_Waste":0.14,"Haz_pctl":51,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.77,"Poll_pctl":64,"Asthma":79.39,"Asthma_Pct":85,"Low_Birth_":5.19,"LBW_pctl":"58","Cardiovasc":9.75,"CVD_pctl":72,"Education":15.1,"Edu_pctl":"52","Linguistic":11,"Ling_pctl":"62","Poverty":29.6,"Pov_pctl":"44","Unemployme":8.5,"Unem_pctl":"43","Housing_Bu":14.8,"HB_pctl":"34","PopCharSco":6.16,"Pop_Pctl":"64","Children__":11.1,"Pop_11_64_":76.8,"Elderly___":12.1,"Hispanic__":"32.4","White____":"25.5","African_Am":"6.9","Native_Ame":"0.2","Asian_Amer":"31.7","Other____":"3.4","Shape_Leng":3991.754511,"Shape_Area":936364.995403}},{"arcs":[[522,523,524,525]],"type":"Polygon","properties":{"Tract_1":6037535902,"Percentile":"81-85%","Population":6519,"County":"Los Angeles","ZIP":90280,"City":"South Gate","CIscore":44.36,"CIscoreP":"82","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":18.53,"DPM_pctl":57,"DrinkingWa":533.8,"DW_pctl":"56","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6646.14,"TR_pctl":87,"Traffic":910.07,"Traff_Pctl":"63","Cleanups":4.5,"Clean_Pctl":42,"Groundwate":3,"GW_pctl":22,"Haz_Waste":0.2,"Haz_pctl":61,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0.4,"Solid_pctl":12,"PollutionS":6.24,"Poll_pctl":74,"Asthma":46.23,"Asthma_Pct":51,"Low_Birth_":6.06,"LBW_pctl":"78","Cardiovasc":11.83,"CVD_pctl":88,"Education":38.4,"Edu_pctl":"85","Linguistic":12.6,"Ling_pctl":"68","Poverty":31.5,"Pov_pctl":"47","Unemployme":15.4,"Unem_pctl":"86","Housing_Bu":15.6,"HB_pctl":"38","PopCharSco":7.11,"Pop_Pctl":"78","Children__":14.9,"Pop_11_64_":76.6,"Elderly___":8.5,"Hispanic__":"94.9","White____":"3.8","African_Am":"0.2","Native_Ame":"0.1","Asian_Amer":"0.8","Other____":"0.2","Shape_Leng":4117.73776259,"Shape_Area":1014332.20277}},{"arcs":[[526,527,528,529]],"type":"Polygon","properties":{"Tract_1":6037551800,"Percentile":"91-95%","Population":7533,"County":"Los Angeles","ZIP":90242,"City":"Downey","CIscore":53.4,"CIscoreP":"92","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":23.78,"DPM_pctl":73,"DrinkingWa":722.03,"DW_pctl":"84","Pesticides":14.749,"Pest_pctl":62,"Tox_Releas":5646.31,"TR_pctl":83,"Traffic":2171.23,"Traff_Pctl":"92","Cleanups":5.2,"Clean_Pctl":45,"Groundwate":19.5,"GW_pctl":70,"Haz_Waste":0.18,"Haz_pctl":56,"Imp__Water":3,"IWB_pctl":41,"Solid_Wast":0.5,"Solid_pctl":20,"PollutionS":7.97,"Poll_pctl":96,"Asthma":52.53,"Asthma_Pct":60,"Low_Birth_":5.49,"LBW_pctl":"66","Cardiovasc":9.14,"CVD_pctl":65,"Education":27.2,"Edu_pctl":"73","Linguistic":13.2,"Ling_pctl":"70","Poverty":30.1,"Pov_pctl":"45","Unemployme":12.2,"Unem_pctl":"71","Housing_Bu":22.9,"HB_pctl":"70","PopCharSco":6.7,"Pop_Pctl":"72","Children__":13.9,"Pop_11_64_":77.4,"Elderly___":8.7,"Hispanic__":"64.8","White____":"17.4","African_Am":"7.3","Native_Ame":"0.3","Asian_Amer":"8.8","Other____":"1.4","Shape_Leng":7158.65421903,"Shape_Area":2218782.89553}},{"arcs":[[530,531,-216,532,533]],"type":"Polygon","properties":{"Tract_1":6037604100,"Percentile":"76-80%","Population":7058,"County":"Los Angeles","ZIP":90260,"City":"Lawndale","CIscore":42.1,"CIscoreP":"79","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":20.98,"DPM_pctl":65,"DrinkingWa":255.67,"DW_pctl":"26","Pesticides":0,"Pest_pctl":0,"Tox_Releas":7565.03,"TR_pctl":89,"Traffic":1925.47,"Traff_Pctl":"90","Cleanups":2,"Clean_Pctl":27,"Groundwate":7.05,"GW_pctl":40,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0.4,"Solid_pctl":12,"PollutionS":5.84,"Poll_pctl":65,"Asthma":66.98,"Asthma_Pct":76,"Low_Birth_":5.76,"LBW_pctl":"72","Cardiovasc":9.49,"CVD_pctl":69,"Education":31.9,"Edu_pctl":"79","Linguistic":13.1,"Ling_pctl":"70","Poverty":51.6,"Pov_pctl":"75","Unemployme":7.6,"Unem_pctl":"35","Housing_Bu":24.8,"HB_pctl":"76","PopCharSco":7.21,"Pop_Pctl":"79","Children__":15,"Pop_11_64_":77.9,"Elderly___":7.1,"Hispanic__":"64.2","White____":"16.5","African_Am":"7","Native_Ame":"0.4","Asian_Amer":"9.1","Other____":"2.9","Shape_Leng":4240.06943692,"Shape_Area":1018098.18781}},{"arcs":[[534,535,536,537]],"type":"Polygon","properties":{"Tract_1":6037601502,"Percentile":"96-100%","Population":3963,"County":"Los Angeles","ZIP":90304,"City":"Inglewood","CIscore":63.03,"CIscoreP":"98","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":38.92,"DPM_pctl":93,"DrinkingWa":287.37,"DW_pctl":"30","Pesticides":5.511,"Pest_pctl":53,"Tox_Releas":3822.37,"TR_pctl":76,"Traffic":3005.12,"Traff_Pctl":"97","Cleanups":20.4,"Clean_Pctl":84,"Groundwate":29.25,"GW_pctl":81,"Haz_Waste":0.05,"Haz_pctl":26,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":7.18,"Poll_pctl":89,"Asthma":68.69,"Asthma_Pct":78,"Low_Birth_":8.66,"LBW_pctl":"99","Cardiovasc":11.11,"CVD_pctl":84,"Education":50.1,"Edu_pctl":"94","Linguistic":14.9,"Ling_pctl":"74","Poverty":70.5,"Pov_pctl":"93","Unemployme":10,"Unem_pctl":"56","Housing_Bu":37.1,"HB_pctl":"96","PopCharSco":8.78,"Pop_Pctl":"97","Children__":18.7,"Pop_11_64_":76,"Elderly___":5.3,"Hispanic__":"94.4","White____":"1.9","African_Am":"1.9","Native_Ame":"0.1","Asian_Amer":"1.4","Other____":"0.3","Shape_Leng":3503.38240557,"Shape_Area":492235.236695}},{"arcs":[[538,539,540,541]],"type":"Polygon","properties":{"Tract_1":6037603101,"Percentile":"71-75%","Population":4244,"County":"Los Angeles","ZIP":90247,"City":"Gardena","CIscore":37.43,"CIscoreP":"72","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":27.16,"DPM_pctl":81,"DrinkingWa":255.67,"DW_pctl":"26","Pesticides":0,"Pest_pctl":0,"Tox_Releas":7429.55,"TR_pctl":89,"Traffic":719.26,"Traff_Pctl":"52","Cleanups":6.6,"Clean_Pctl":50,"Groundwate":8.8,"GW_pctl":45,"Haz_Waste":0.04,"Haz_pctl":19,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":3,"Solid_pctl":62,"PollutionS":5.77,"Poll_pctl":64,"Asthma":79.41,"Asthma_Pct":85,"Low_Birth_":4.77,"LBW_pctl":"46","Cardiovasc":10.07,"CVD_pctl":75,"Education":12.8,"Edu_pctl":"47","Linguistic":10.5,"Ling_pctl":"61","Poverty":39.5,"Pov_pctl":"59","Unemployme":8.1,"Unem_pctl":"40","Housing_Bu":24.9,"HB_pctl":"76","PopCharSco":6.49,"Pop_Pctl":"69","Children__":12.2,"Pop_11_64_":74.7,"Elderly___":13.1,"Hispanic__":"40.2","White____":"10.1","African_Am":"16","Native_Ame":"0.1","Asian_Amer":"30.8","Other____":"2.8","Shape_Leng":3845.71351151,"Shape_Area":884015.049719}},{"arcs":[[542,543,544,545,546]],"type":"Polygon","properties":{"Tract_1":6037603102,"Percentile":"96-100%","Population":4084,"County":"Los Angeles","ZIP":90247,"City":"Gardena","CIscore":57.73,"CIscoreP":"95","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":27.16,"DPM_pctl":81,"DrinkingWa":474.97,"DW_pctl":"49","Pesticides":0.513,"Pest_pctl":33,"Tox_Releas":9128.34,"TR_pctl":92,"Traffic":912.95,"Traff_Pctl":"63","Cleanups":15.65,"Clean_Pctl":78,"Groundwate":22.75,"GW_pctl":75,"Haz_Waste":0.12,"Haz_pctl":47,"Imp__Water":18,"IWB_pctl":98,"Solid_Wast":2.7,"Solid_pctl":58,"PollutionS":8.08,"Poll_pctl":97,"Asthma":63.55,"Asthma_Pct":73,"Low_Birth_":6.25,"LBW_pctl":"81","Cardiovasc":8.21,"CVD_pctl":54,"Education":16.7,"Edu_pctl":"56","Linguistic":22.1,"Ling_pctl":"87","Poverty":46.1,"Pov_pctl":"68","Unemployme":10.1,"Unem_pctl":"57","Housing_Bu":24.1,"HB_pctl":"74","PopCharSco":7.15,"Pop_Pctl":"78","Children__":12.1,"Pop_11_64_":71.1,"Elderly___":16.8,"Hispanic__":"45.1","White____":"6.5","African_Am":"11.8","Native_Ame":"0.1","Asian_Amer":"34.6","Other____":"2","Shape_Leng":3465.63543445,"Shape_Area":745288.232688}},{"arcs":[[547,548,549]],"type":"Polygon","properties":{"Tract_1":6037603200,"Percentile":"86-90%","Population":2777,"County":"Los Angeles","ZIP":90248,"City":"Gardena","CIscore":48.83,"CIscoreP":"88","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":24.54,"DPM_pctl":75,"DrinkingWa":492.73,"DW_pctl":"52","Pesticides":0.016,"Pest_pctl":10,"Tox_Releas":11610.3,"TR_pctl":95,"Traffic":809.27,"Traff_Pctl":"57","Cleanups":31.3,"Clean_Pctl":91,"Groundwate":55.6,"GW_pctl":92,"Haz_Waste":0.67,"Haz_pctl":82,"Imp__Water":18,"IWB_pctl":98,"Solid_Wast":7.2,"Solid_pctl":83,"PollutionS":8.4,"Poll_pctl":98,"Asthma":68.29,"Asthma_Pct":77,"Low_Birth_":5.5,"LBW_pctl":"66","Cardiovasc":10.27,"CVD_pctl":77,"Education":17.7,"Edu_pctl":"58","Linguistic":21.2,"Ling_pctl":"86","Poverty":19.4,"Pov_pctl":"26","Unemployme":5.8,"Unem_pctl":"19","Housing_Bu":7.7,"HB_pctl":"6","PopCharSco":5.81,"Pop_Pctl":"59","Children__":9,"Pop_11_64_":69.1,"Elderly___":21.9,"Hispanic__":"27.2","White____":"14.9","African_Am":"8","Native_Ame":"0.3","Asian_Amer":"46.9","Other____":"2.8","Shape_Leng":6682.61345669,"Shape_Area":1132852.40673}},{"arcs":[[550,551,552,553,554]],"type":"Polygon","properties":{"Tract_1":6037603301,"Percentile":"66-70%","Population":3828,"County":"Los Angeles","ZIP":90247,"City":"Gardena","CIscore":35.92,"CIscoreP":"70","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":22.57,"DPM_pctl":69,"DrinkingWa":288.59,"DW_pctl":"31","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8021.77,"TR_pctl":90,"Traffic":1028.05,"Traff_Pctl":"69","Cleanups":4.55,"Clean_Pctl":42,"Groundwate":2.55,"GW_pctl":15,"Haz_Waste":0.1,"Haz_pctl":43,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0.9,"Solid_pctl":24,"PollutionS":6.08,"Poll_pctl":71,"Asthma":72.59,"Asthma_Pct":80,"Low_Birth_":4.35,"LBW_pctl":"35","Cardiovasc":9.21,"CVD_pctl":66,"Education":8.6,"Edu_pctl":"35","Linguistic":22.9,"Ling_pctl":"88","Poverty":35.2,"Pov_pctl":"53","Unemployme":5.4,"Unem_pctl":"16","Housing_Bu":25.4,"HB_pctl":"78","PopCharSco":5.91,"Pop_Pctl":"60","Children__":11.4,"Pop_11_64_":70,"Elderly___":18.6,"Hispanic__":"25.9","White____":"9","African_Am":"6.6","Native_Ame":"0.1","Asian_Amer":"54.7","Other____":"3.8","Shape_Leng":4313.56599124,"Shape_Area":974877.558728}},{"arcs":[[555,-544,556,557,-553]],"type":"Polygon","properties":{"Tract_1":6037603302,"Percentile":"91-95%","Population":3804,"County":"Los Angeles","ZIP":90247,"City":"Gardena","CIscore":56.4,"CIscoreP":"94","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":22.8,"DPM_pctl":69,"DrinkingWa":288.45,"DW_pctl":"30","Pesticides":0,"Pest_pctl":0,"Tox_Releas":10118.03,"TR_pctl":94,"Traffic":881.38,"Traff_Pctl":"62","Cleanups":47,"Clean_Pctl":96,"Groundwate":30.6,"GW_pctl":82,"Haz_Waste":0.04,"Haz_pctl":18,"Imp__Water":18,"IWB_pctl":98,"Solid_Wast":4.5,"Solid_pctl":70,"PollutionS":7.42,"Poll_pctl":92,"Asthma":66.5,"Asthma_Pct":76,"Low_Birth_":6.36,"LBW_pctl":"83","Cardiovasc":8.55,"CVD_pctl":57,"Education":21.5,"Edu_pctl":"65","Linguistic":18.2,"Ling_pctl":"81","Poverty":48.1,"Pov_pctl":"71","Unemployme":14.9,"Unem_pctl":"84","Housing_Bu":23.5,"HB_pctl":"72","PopCharSco":7.6,"Pop_Pctl":"85","Children__":11,"Pop_11_64_":71.6,"Elderly___":17.4,"Hispanic__":"33.9","White____":"10.6","African_Am":"5.8","Native_Ame":"0.2","Asian_Amer":"46.5","Other____":"3","Shape_Leng":4650.32847636,"Shape_Area":1139414.16209}},{"arcs":[[-521,558,559,-214,560]],"type":"Polygon","properties":{"Tract_1":6037603702,"Percentile":"86-90%","Population":5087,"County":"Los Angeles","ZIP":90506,"City":"Torrance","CIscore":48.86,"CIscoreP":"88","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":22.62,"DPM_pctl":69,"DrinkingWa":290.17,"DW_pctl":"31","Pesticides":41.708,"Pest_pctl":70,"Tox_Releas":6546.25,"TR_pctl":87,"Traffic":1014.39,"Traff_Pctl":"68","Cleanups":1,"Clean_Pctl":18,"Groundwate":4.5,"GW_pctl":29,"Haz_Waste":0.11,"Haz_pctl":46,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":2,"Solid_pctl":50,"PollutionS":7,"Poll_pctl":87,"Asthma":74.07,"Asthma_Pct":81,"Low_Birth_":7.26,"LBW_pctl":"93","Cardiovasc":9.64,"CVD_pctl":71,"Education":12.3,"Edu_pctl":"46","Linguistic":12,"Ling_pctl":"66","Poverty":28.7,"Pov_pctl":"43","Unemployme":12.1,"Unem_pctl":"71","Housing_Bu":15.9,"HB_pctl":"40","PopCharSco":6.98,"Pop_Pctl":"76","Children__":12.6,"Pop_11_64_":73.8,"Elderly___":13.6,"Hispanic__":"33","White____":"34.6","African_Am":"5.1","Native_Ame":"0.2","Asian_Amer":"23.5","Other____":"3.5","Shape_Leng":6678.64694975,"Shape_Area":2613578.1227}},{"arcs":[[561,562,563,564]],"type":"Polygon","properties":{"Tract_1":6037650102,"Percentile":"36-40%","Population":2248,"County":"Los Angeles","ZIP":90504,"City":"Torrance","CIscore":20.6,"CIscoreP":"40","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":22.51,"DPM_pctl":68,"DrinkingWa":188.14,"DW_pctl":"14","Pesticides":41.946,"Pest_pctl":70,"Tox_Releas":17200.8,"TR_pctl":97,"Traffic":2364.18,"Traff_Pctl":"94","Cleanups":1,"Clean_Pctl":18,"Groundwate":10.85,"GW_pctl":51,"Haz_Waste":0.46,"Haz_pctl":75,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0.3,"Solid_pctl":11,"PollutionS":7.33,"Poll_pctl":91,"Asthma":48.03,"Asthma_Pct":54,"Low_Birth_":1.52,"LBW_pctl":"1","Cardiovasc":7.49,"CVD_pctl":44,"Education":7.2,"Edu_pctl":"29","Linguistic":4,"Ling_pctl":"30","Poverty":12.5,"Pov_pctl":"11","Unemployme":4.8,"Unem_pctl":"11","Housing_Bu":13,"HB_pctl":"26","PopCharSco":2.81,"Pop_Pctl":"16","Children__":9.2,"Pop_11_64_":79.6,"Elderly___":11.2,"Hispanic__":"20.3","White____":"41.8","African_Am":"2.6","Native_Ame":"0","Asian_Amer":"29.8","Other____":"5.4","Shape_Leng":4094.17464003,"Shape_Area":850315.136562}},{"arcs":[[565,566,567,-564,568,569,570]],"type":"Polygon","properties":{"Tract_1":6037650200,"Percentile":"61-65%","Population":5783,"County":"Los Angeles","ZIP":90504,"City":"Torrance","CIscore":32.87,"CIscoreP":"65","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":22.51,"DPM_pctl":68,"DrinkingWa":188.14,"DW_pctl":"14","Pesticides":30.209,"Pest_pctl":68,"Tox_Releas":52329.43,"TR_pctl":100,"Traffic":2502.11,"Traff_Pctl":"95","Cleanups":12.15,"Clean_Pctl":70,"Groundwate":35.9,"GW_pctl":85,"Haz_Waste":7.68,"Haz_pctl":99,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":1,"Solid_pctl":33,"PollutionS":7.84,"Poll_pctl":95,"Asthma":46.65,"Asthma_Pct":52,"Low_Birth_":5.23,"LBW_pctl":"59","Cardiovasc":7.3,"CVD_pctl":41,"Education":12.5,"Edu_pctl":"47","Linguistic":8.2,"Ling_pctl":"52","Poverty":16.3,"Pov_pctl":"19","Unemployme":4.8,"Unem_pctl":"11","Housing_Bu":12.2,"HB_pctl":"22","PopCharSco":4.2,"Pop_Pctl":"35","Children__":10.8,"Pop_11_64_":76.1,"Elderly___":13.1,"Hispanic__":"24.8","White____":"41.3","African_Am":"2.8","Native_Ame":"0.2","Asian_Amer":"25.5","Other____":"5.4","Shape_Leng":9178.51526434,"Shape_Area":2420988.47582}},{"arcs":[[571,572,573,574,575,576]],"type":"Polygon","properties":{"Tract_1":6037650602,"Percentile":"51-55%","Population":7161,"County":"Los Angeles","ZIP":90503,"City":"Torrance","CIscore":25.67,"CIscoreP":"51","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":15.61,"DPM_pctl":48,"DrinkingWa":237.22,"DW_pctl":"24","Pesticides":0,"Pest_pctl":0,"Tox_Releas":16107.78,"TR_pctl":97,"Traffic":922.76,"Traff_Pctl":"64","Cleanups":3.4,"Clean_Pctl":34,"Groundwate":1,"GW_pctl":6,"Haz_Waste":0.08,"Haz_pctl":31,"Imp__Water":5,"IWB_pctl":55,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":5.26,"Poll_pctl":52,"Asthma":28.34,"Asthma_Pct":22,"Low_Birth_":5.54,"LBW_pctl":"67","Cardiovasc":6.44,"CVD_pctl":30,"Education":7.7,"Edu_pctl":"31","Linguistic":16.9,"Ling_pctl":"79","Poverty":27.8,"Pov_pctl":"41","Unemployme":8,"Unem_pctl":"39","Housing_Bu":28.4,"HB_pctl":"85","PopCharSco":4.88,"Pop_Pctl":"46","Children__":10.9,"Pop_11_64_":76.4,"Elderly___":12.7,"Hispanic__":"11.1","White____":"29.3","African_Am":"4.2","Native_Ame":"0.2","Asian_Amer":"50.6","Other____":"4.6","Shape_Leng":5677.32724077,"Shape_Area":1244345.20892}},{"arcs":[[577,578,579,580,581,582,583,584]],"type":"Polygon","properties":{"Tract_1":6037650502,"Percentile":"11-15%","Population":4294,"County":"Los Angeles","ZIP":90503,"City":"Torrance","CIscore":8.87,"CIscoreP":"11","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":15.86,"DPM_pctl":48,"DrinkingWa":237.22,"DW_pctl":"24","Pesticides":0,"Pest_pctl":0,"Tox_Releas":15123.8,"TR_pctl":97,"Traffic":466.37,"Traff_Pctl":"27","Cleanups":11.9,"Clean_Pctl":67,"Groundwate":1,"GW_pctl":6,"Haz_Waste":0.01,"Haz_pctl":9,"Imp__Water":5,"IWB_pctl":55,"Solid_Wast":5,"Solid_pctl":74,"PollutionS":5.45,"Poll_pctl":57,"Asthma":22.3,"Asthma_Pct":11,"Low_Birth_":2.75,"LBW_pctl":"6","Cardiovasc":5.2,"CVD_pctl":14,"Education":4.7,"Edu_pctl":"18","Linguistic":6.1,"Ling_pctl":"42","Poverty":12.8,"Pov_pctl":"12","Unemployme":6.2,"Unem_pctl":"22","Housing_Bu":8.7,"HB_pctl":"9","PopCharSco":1.63,"Pop_Pctl":"5","Children__":10,"Pop_11_64_":72.6,"Elderly___":17.4,"Hispanic__":"11.6","White____":"55.6","African_Am":"1.7","Native_Ame":"0.3","Asian_Amer":"26.3","Other____":"4.4","Shape_Leng":4763.01715411,"Shape_Area":1335961.03904}},{"arcs":[[-575,-585,585,586,-582,587,588,589,590]],"type":"Polygon","properties":{"Tract_1":6037650501,"Percentile":"16-20%","Population":3063,"County":"Los Angeles","ZIP":90503,"City":"Torrance","CIscore":11.09,"CIscoreP":"15","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":16.1,"DPM_pctl":49,"DrinkingWa":237.22,"DW_pctl":"24","Pesticides":0,"Pest_pctl":0,"Tox_Releas":35232.83,"TR_pctl":99,"Traffic":750.76,"Traff_Pctl":"54","Cleanups":14.1,"Clean_Pctl":75,"Groundwate":10,"GW_pctl":50,"Haz_Waste":0.12,"Haz_pctl":47,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.4,"Solid_pctl":12,"PollutionS":5.59,"Poll_pctl":60,"Asthma":26.92,"Asthma_Pct":19,"Low_Birth_":2.96,"LBW_pctl":"8","Cardiovasc":6.09,"CVD_pctl":25,"Education":7.2,"Edu_pctl":"29","Linguistic":3.4,"Ling_pctl":"26","Poverty":13.7,"Pov_pctl":"14","Unemployme":7.1,"Unem_pctl":"30","Housing_Bu":7.4,"HB_pctl":"6","PopCharSco":1.99,"Pop_Pctl":"7","Children__":10.7,"Pop_11_64_":75.1,"Elderly___":14.2,"Hispanic__":"13.2","White____":"57.9","African_Am":"0.8","Native_Ame":"0.3","Asian_Amer":"24.4","Other____":"3.5","Shape_Leng":4146.27719821,"Shape_Area":998749.667051}},{"arcs":[[591,592,593,594]],"type":"Polygon","properties":{"Tract_1":6037297202,"Percentile":"66-70%","Population":3423,"County":"Los Angeles","ZIP":90731,"City":"San Pedro","CIscore":33.27,"CIscoreP":"65","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":51.9,"DPM_pctl":96,"DrinkingWa":198.88,"DW_pctl":"15","Pesticides":0,"Pest_pctl":0,"Tox_Releas":4751.51,"TR_pctl":79,"Traffic":633.99,"Traff_Pctl":"45","Cleanups":8.45,"Clean_Pctl":56,"Groundwate":30.3,"GW_pctl":82,"Haz_Waste":0.01,"Haz_pctl":9,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.12,"Poll_pctl":49,"Asthma":84.98,"Asthma_Pct":88,"Low_Birth_":5.45,"LBW_pctl":"65","Cardiovasc":9.68,"CVD_pctl":71,"Education":11.5,"Edu_pctl":"44","Linguistic":4.8,"Ling_pctl":"35","Poverty":30.3,"Pov_pctl":"45","Unemployme":13.4,"Unem_pctl":"78","Housing_Bu":18.3,"HB_pctl":"52","PopCharSco":6.5,"Pop_Pctl":"69","Children__":13.6,"Pop_11_64_":73.2,"Elderly___":13.2,"Hispanic__":"37.6","White____":"50.3","African_Am":"3.7","Native_Ame":"0.3","Asian_Amer":"4.2","Other____":"3.9","Shape_Leng":3043.91951161,"Shape_Area":575859.506684}},{"arcs":[[-62,595,596,-595,597,598]],"type":"Polygon","properties":{"Tract_1":6037297201,"Percentile":"76-80%","Population":3475,"County":"Los Angeles","ZIP":90731,"City":"San Pedro","CIscore":42.65,"CIscoreP":"80","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":51.9,"DPM_pctl":96,"DrinkingWa":198.88,"DW_pctl":"15","Pesticides":0,"Pest_pctl":0,"Tox_Releas":4939,"TR_pctl":80,"Traffic":654.23,"Traff_Pctl":"47","Cleanups":6.75,"Clean_Pctl":50,"Groundwate":32.8,"GW_pctl":84,"Haz_Waste":0.06,"Haz_pctl":28,"Imp__Water":9,"IWB_pctl":81,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.93,"Poll_pctl":67,"Asthma":84.98,"Asthma_Pct":88,"Low_Birth_":4.7,"LBW_pctl":"44","Cardiovasc":9.68,"CVD_pctl":71,"Education":21.6,"Edu_pctl":"65","Linguistic":10.1,"Ling_pctl":"59","Poverty":39.9,"Pov_pctl":"60","Unemployme":14.8,"Unem_pctl":"84","Housing_Bu":29.8,"HB_pctl":"87","PopCharSco":7.19,"Pop_Pctl":"79","Children__":14.9,"Pop_11_64_":76.9,"Elderly___":8.2,"Hispanic__":"55.5","White____":"28.5","African_Am":"7.3","Native_Ame":"0.5","Asian_Amer":"4.7","Other____":"3.5","Shape_Leng":2521.56038823,"Shape_Area":403858.702889}},{"arcs":[[599,600,601,602,603,604]],"type":"Polygon","properties":{"Tract_1":6037296902,"Percentile":"76-80%","Population":3851,"County":"Los Angeles","ZIP":90731,"City":"San Pedro","CIscore":39.89,"CIscoreP":"76","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":51.9,"DPM_pctl":96,"DrinkingWa":198.88,"DW_pctl":"15","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5071.8,"TR_pctl":80,"Traffic":770.32,"Traff_Pctl":"55","Cleanups":11.5,"Clean_Pctl":66,"Groundwate":13.55,"GW_pctl":58,"Haz_Waste":0.47,"Haz_pctl":75,"Imp__Water":8,"IWB_pctl":76,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":6.3,"Poll_pctl":75,"Asthma":84.98,"Asthma_Pct":88,"Low_Birth_":4.46,"LBW_pctl":"38","Cardiovasc":9.68,"CVD_pctl":71,"Education":18.2,"Edu_pctl":"59","Linguistic":16.6,"Ling_pctl":"78","Poverty":35.1,"Pov_pctl":"53","Unemployme":6.4,"Unem_pctl":"24","Housing_Bu":22.5,"HB_pctl":"69","PopCharSco":6.33,"Pop_Pctl":"67","Children__":14.1,"Pop_11_64_":75.3,"Elderly___":10.6,"Hispanic__":"54","White____":"32.8","African_Am":"6.6","Native_Ame":"0.2","Asian_Amer":"4.2","Other____":"2.1","Shape_Leng":3652.31353028,"Shape_Area":491630.658389}},{"arcs":[[605,-603,606,607]],"type":"Polygon","properties":{"Tract_1":6037296901,"Percentile":"81-85%","Population":4127,"County":"Los Angeles","ZIP":90731,"City":"San Pedro","CIscore":44.19,"CIscoreP":"82","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":51.9,"DPM_pctl":96,"DrinkingWa":198.88,"DW_pctl":"15","Pesticides":0,"Pest_pctl":0,"Tox_Releas":4976.16,"TR_pctl":80,"Traffic":881.31,"Traff_Pctl":"62","Cleanups":11.2,"Clean_Pctl":66,"Groundwate":5.8,"GW_pctl":34,"Haz_Waste":0.15,"Haz_pctl":54,"Imp__Water":8,"IWB_pctl":76,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":6.01,"Poll_pctl":69,"Asthma":84.98,"Asthma_Pct":88,"Low_Birth_":5.25,"LBW_pctl":"59","Cardiovasc":9.68,"CVD_pctl":71,"Education":30,"Edu_pctl":"77","Linguistic":12,"Ling_pctl":"66","Poverty":41.3,"Pov_pctl":"61","Unemployme":11.6,"Unem_pctl":"67","Housing_Bu":23.9,"HB_pctl":"74","PopCharSco":7.35,"Pop_Pctl":"81","Children__":14.8,"Pop_11_64_":77.7,"Elderly___":7.5,"Hispanic__":"60.4","White____":"24.4","African_Am":"6.4","Native_Ame":"0.3","Asian_Amer":"5.1","Other____":"3.4","Shape_Leng":3460.99345191,"Shape_Area":617426.021943}},{"arcs":[[608,609,610,611,612,613,614]],"type":"Polygon","properties":{"Tract_1":6037296402,"Percentile":"41-45%","Population":3091,"County":"Los Angeles","ZIP":90732,"City":"San Pedro","CIscore":20.89,"CIscoreP":"40","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":34.2,"DPM_pctl":89,"DrinkingWa":419.71,"DW_pctl":"44","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5506,"TR_pctl":82,"Traffic":667.5,"Traff_Pctl":"47","Cleanups":0.65,"Clean_Pctl":9,"Groundwate":4.5,"GW_pctl":29,"Haz_Waste":0.14,"Haz_pctl":51,"Imp__Water":8,"IWB_pctl":76,"Solid_Wast":1.2,"Solid_pctl":34,"PollutionS":5.87,"Poll_pctl":66,"Asthma":40.39,"Asthma_Pct":43,"Low_Birth_":3.69,"LBW_pctl":"20","Cardiovasc":5.14,"CVD_pctl":14,"Education":13.9,"Edu_pctl":"50","Linguistic":5,"Ling_pctl":"36","Poverty":23.5,"Pov_pctl":"34","Unemployme":11.2,"Unem_pctl":"65","Housing_Bu":14.3,"HB_pctl":"32","PopCharSco":3.56,"Pop_Pctl":"26","Children__":11.4,"Pop_11_64_":73.7,"Elderly___":14.9,"Hispanic__":"52","White____":"38.2","African_Am":"2.9","Native_Ame":"0.4","Asian_Amer":"3.4","Other____":"3.1","Shape_Leng":5186.05179076,"Shape_Area":1046090.63854}},{"arcs":[[615,-610,616,617,618,619,620,621,622,623,624,625]],"type":"Polygon","properties":{"Tract_1":6037296401,"Percentile":"21-25%","Population":3191,"County":"Los Angeles","ZIP":90732,"City":"San Pedro","CIscore":13.09,"CIscoreP":"20","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":7.85,"DPM_pctl":22,"DrinkingWa":228.45,"DW_pctl":"22","Pesticides":0,"Pest_pctl":0,"Tox_Releas":4948.29,"TR_pctl":80,"Traffic":526.08,"Traff_Pctl":"33","Cleanups":0,"Clean_Pctl":0,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.1,"Haz_pctl":43,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":3.35,"Poll_pctl":14,"Asthma":27.31,"Asthma_Pct":20,"Low_Birth_":6.02,"LBW_pctl":"77","Cardiovasc":4.13,"CVD_pctl":6,"Education":7.5,"Edu_pctl":"30","Linguistic":12.6,"Ling_pctl":"68","Poverty":18.9,"Pov_pctl":"24","Unemployme":6.8,"Unem_pctl":"27","Housing_Bu":19.2,"HB_pctl":"56","PopCharSco":3.9,"Pop_Pctl":"31","Children__":10.5,"Pop_11_64_":67.5,"Elderly___":22,"Hispanic__":"24.3","White____":"59.1","African_Am":"3.8","Native_Ame":"0.3","Asian_Amer":"8.2","Other____":"4.2","Shape_Leng":4286.09388396,"Shape_Area":985200.544315}},{"arcs":[[626,627,628,629,630,631,632]],"type":"Polygon","properties":{"Tract_1":6037294701,"Percentile":"96-100%","Population":3019,"County":"Los Angeles","ZIP":90744,"City":"Wilmington","CIscore":58.93,"CIscoreP":"96","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":132.23,"DPM_pctl":100,"DrinkingWa":198.88,"DW_pctl":"15","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8270.03,"TR_pctl":91,"Traffic":654.45,"Traff_Pctl":"47","Cleanups":54.8,"Clean_Pctl":97,"Groundwate":52.1,"GW_pctl":92,"Haz_Waste":5.3,"Haz_pctl":97,"Imp__Water":17,"IWB_pctl":98,"Solid_Wast":19.5,"Solid_pctl":97,"PollutionS":8.05,"Poll_pctl":96,"Asthma":70.22,"Asthma_Pct":79,"Low_Birth_":3.75,"LBW_pctl":"21","Cardiovasc":10.57,"CVD_pctl":79,"Education":51.2,"Edu_pctl":"95","Linguistic":20.4,"Ling_pctl":"85","Poverty":64.9,"Pov_pctl":"89","Unemployme":9.5,"Unem_pctl":"52","Housing_Bu":29.9,"HB_pctl":"88","PopCharSco":7.32,"Pop_Pctl":"81","Children__":17.8,"Pop_11_64_":75.5,"Elderly___":6.7,"Hispanic__":"87.1","White____":"4.2","African_Am":"6.1","Native_Ame":"0.4","Asian_Amer":"1.5","Other____":"0.8","Shape_Leng":6025.79763455,"Shape_Area":1747035.06054}},{"arcs":[[633,634,-326,635,-324,636,637,638]],"type":"Polygon","properties":{"Tract_1":6037294421,"Percentile":"86-90%","Population":2950,"County":"Los Angeles","ZIP":90710,"City":"Harbor City","CIscore":47.6,"CIscoreP":"86","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":20.4,"DPM_pctl":63,"DrinkingWa":442.05,"DW_pctl":"45","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8249.54,"TR_pctl":91,"Traffic":955.34,"Traff_Pctl":"65","Cleanups":15,"Clean_Pctl":77,"Groundwate":6.5,"GW_pctl":38,"Haz_Waste":5.78,"Haz_pctl":98,"Imp__Water":12,"IWB_pctl":91,"Solid_Wast":4.5,"Solid_pctl":70,"PollutionS":7.32,"Poll_pctl":91,"Asthma":52.31,"Asthma_Pct":59,"Low_Birth_":3.44,"LBW_pctl":"16","Cardiovasc":9.61,"CVD_pctl":70,"Education":35.3,"Edu_pctl":"82","Linguistic":21.3,"Ling_pctl":"86","Poverty":60.9,"Pov_pctl":"85","Unemployme":11.3,"Unem_pctl":"66","Housing_Bu":21.7,"HB_pctl":"66","PopCharSco":6.5,"Pop_Pctl":"69","Children__":16.6,"Pop_11_64_":75.1,"Elderly___":8.3,"Hispanic__":"70.9","White____":"8.7","African_Am":"6.6","Native_Ame":"0.1","Asian_Amer":"12","Other____":"1.6","Shape_Leng":5007.3114535,"Shape_Area":666271.592538}},{"arcs":[[639,640,641,-316,642]],"type":"Polygon","properties":{"Tract_1":6037294302,"Percentile":"81-85%","Population":4754,"County":"Los Angeles","ZIP":90744,"City":"Wilmington","CIscore":45.88,"CIscoreP":"84","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":28.7,"DPM_pctl":83,"DrinkingWa":198.88,"DW_pctl":"15","Pesticides":0,"Pest_pctl":0,"Tox_Releas":7509.28,"TR_pctl":89,"Traffic":1594.16,"Traff_Pctl":"85","Cleanups":3.55,"Clean_Pctl":35,"Groundwate":17.4,"GW_pctl":66,"Haz_Waste":5.28,"Haz_pctl":97,"Imp__Water":12,"IWB_pctl":91,"Solid_Wast":0.5,"Solid_pctl":20,"PollutionS":6.89,"Poll_pctl":85,"Asthma":70.22,"Asthma_Pct":79,"Low_Birth_":2.81,"LBW_pctl":"7","Cardiovasc":10.57,"CVD_pctl":79,"Education":33.8,"Edu_pctl":"81","Linguistic":13,"Ling_pctl":"69","Poverty":56.7,"Pov_pctl":"81","Unemployme":9.4,"Unem_pctl":"51","Housing_Bu":28.9,"HB_pctl":"86","PopCharSco":6.66,"Pop_Pctl":"72","Children__":17.1,"Pop_11_64_":75.9,"Elderly___":7,"Hispanic__":"87.9","White____":"6","African_Am":"1.9","Native_Ame":"0.1","Asian_Amer":"3.1","Other____":"1","Shape_Leng":4458.62252406,"Shape_Area":848326.643711}},{"arcs":[[-525,643,644,645,646,647]],"type":"Polygon","properties":{"Tract_1":6037535802,"Percentile":"66-70%","Population":6814,"County":"Los Angeles","ZIP":90280,"City":"South Gate","CIscore":35.93,"CIscoreP":"70","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":19.95,"DPM_pctl":61,"DrinkingWa":533.13,"DW_pctl":"56","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6425.78,"TR_pctl":86,"Traffic":831.07,"Traff_Pctl":"59","Cleanups":3.95,"Clean_Pctl":36,"Groundwate":4,"GW_pctl":27,"Haz_Waste":0.01,"Haz_pctl":9,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":5.18,"Poll_pctl":51,"Asthma":45.49,"Asthma_Pct":50,"Low_Birth_":3.68,"LBW_pctl":"20","Cardiovasc":11.61,"CVD_pctl":86,"Education":45.1,"Edu_pctl":"91","Linguistic":25.1,"Ling_pctl":"90","Poverty":56,"Pov_pctl":"80","Unemployme":9.9,"Unem_pctl":"55","Housing_Bu":31.9,"HB_pctl":"91","PopCharSco":6.93,"Pop_Pctl":"76","Children__":15,"Pop_11_64_":77.5,"Elderly___":7.5,"Hispanic__":"96.2","White____":"2.5","African_Am":"0.5","Native_Ame":"0.3","Asian_Amer":"0.2","Other____":"0.2","Shape_Leng":3798.71222214,"Shape_Area":795779.12219}},{"arcs":[[648,-523,649,650,651,652,653,654]],"type":"Polygon","properties":{"Tract_1":6037540101,"Percentile":"81-85%","Population":6483,"County":"Los Angeles","ZIP":90262,"City":"Lynwood","CIscore":43.57,"CIscoreP":"81","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":19.3,"DPM_pctl":59,"DrinkingWa":455.87,"DW_pctl":"47","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6493.86,"TR_pctl":87,"Traffic":693.12,"Traff_Pctl":"49","Cleanups":8.95,"Clean_Pctl":57,"Groundwate":4.75,"GW_pctl":29,"Haz_Waste":0.22,"Haz_pctl":63,"Imp__Water":10,"IWB_pctl":86,"Solid_Wast":2.9,"Solid_pctl":59,"PollutionS":6.7,"Poll_pctl":83,"Asthma":44.6,"Asthma_Pct":49,"Low_Birth_":5.65,"LBW_pctl":"69","Cardiovasc":8.84,"CVD_pctl":61,"Education":39.6,"Edu_pctl":"86","Linguistic":11.4,"Ling_pctl":"64","Poverty":42.2,"Pov_pctl":"63","Unemployme":7,"Unem_pctl":"29","Housing_Bu":29.4,"HB_pctl":"87","PopCharSco":6.51,"Pop_Pctl":"69","Children__":15.8,"Pop_11_64_":77.5,"Elderly___":6.7,"Hispanic__":"89.4","White____":"1.9","African_Am":"7.5","Native_Ame":"0.2","Asian_Amer":"0.7","Other____":"0.3","Shape_Leng":5300.1395257,"Shape_Area":1260077.92299}},{"arcs":[[655,656,657,658,659,660]],"type":"Polygon","properties":{"Tract_1":6037555212,"Percentile":"61-65%","Population":4561,"County":"Los Angeles","ZIP":90716,"City":"Hawaiian Gardens","CIscore":31.2,"CIscoreP":"62","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":12.6,"DPM_pctl":37,"DrinkingWa":332.79,"DW_pctl":"35","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6015.98,"TR_pctl":85,"Traffic":525.11,"Traff_Pctl":"33","Cleanups":1,"Clean_Pctl":18,"Groundwate":19.75,"GW_pctl":70,"Haz_Waste":0.05,"Haz_pctl":26,"Imp__Water":8,"IWB_pctl":76,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.05,"Poll_pctl":48,"Asthma":53.07,"Asthma_Pct":60,"Low_Birth_":3.61,"LBW_pctl":"18","Cardiovasc":8.56,"CVD_pctl":58,"Education":44.3,"Edu_pctl":"91","Linguistic":19.1,"Ling_pctl":"83","Poverty":62.5,"Pov_pctl":"87","Unemployme":7.5,"Unem_pctl":"34","Housing_Bu":24.3,"HB_pctl":"75","PopCharSco":6.18,"Pop_Pctl":"64","Children__":18.5,"Pop_11_64_":73.3,"Elderly___":8.2,"Hispanic__":"77.4","White____":"10.1","African_Am":"2.1","Native_Ame":"0.2","Asian_Amer":"9","Other____":"1.2","Shape_Leng":3583.78409928,"Shape_Area":696229.735484}},{"arcs":[[661,662,663]],"type":"Polygon","properties":{"Tract_1":6037555103,"Percentile":"66-70%","Population":4727,"County":"Los Angeles","ZIP":90715,"City":"Lakewood","CIscore":35.9,"CIscoreP":"70","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":12.6,"DPM_pctl":37,"DrinkingWa":365.11,"DW_pctl":"38","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5846.37,"TR_pctl":84,"Traffic":436.75,"Traff_Pctl":"24","Cleanups":0.1,"Clean_Pctl":2,"Groundwate":3,"GW_pctl":22,"Haz_Waste":0.5,"Haz_pctl":77,"Imp__Water":8,"IWB_pctl":76,"Solid_Wast":5.9,"Solid_pctl":76,"PollutionS":5.49,"Poll_pctl":58,"Asthma":83.12,"Asthma_Pct":87,"Low_Birth_":5.97,"LBW_pctl":"76","Cardiovasc":12.37,"CVD_pctl":90,"Education":15.6,"Edu_pctl":"54","Linguistic":7.2,"Ling_pctl":"47","Poverty":29.9,"Pov_pctl":"45","Unemployme":7.3,"Unem_pctl":"32","Housing_Bu":14.1,"HB_pctl":"31","PopCharSco":6.54,"Pop_Pctl":"70","Children__":13.5,"Pop_11_64_":76.7,"Elderly___":9.8,"Hispanic__":"29.4","White____":"23.4","African_Am":"14.6","Native_Ame":"0.1","Asian_Amer":"29","Other____":"3.5","Shape_Leng":4070.25006078,"Shape_Area":983989.83792}},{"arcs":[[664,665,666,667]],"type":"Polygon","properties":{"Tract_1":6037555102,"Percentile":"81-85%","Population":6526,"County":"Los Angeles","ZIP":90715,"City":"Lakewood","CIscore":43.4,"CIscoreP":"81","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":12.6,"DPM_pctl":37,"DrinkingWa":330.07,"DW_pctl":"35","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5683.65,"TR_pctl":83,"Traffic":501.32,"Traff_Pctl":"31","Cleanups":1,"Clean_Pctl":18,"Groundwate":7,"GW_pctl":39,"Haz_Waste":0.5,"Haz_pctl":77,"Imp__Water":14,"IWB_pctl":94,"Solid_Wast":1.65,"Solid_pctl":40,"PollutionS":5.64,"Poll_pctl":61,"Asthma":68.56,"Asthma_Pct":77,"Low_Birth_":6.11,"LBW_pctl":"78","Cardiovasc":10.29,"CVD_pctl":77,"Education":26.1,"Edu_pctl":"72","Linguistic":22.9,"Ling_pctl":"88","Poverty":52,"Pov_pctl":"76","Unemployme":10.3,"Unem_pctl":"58","Housing_Bu":20.4,"HB_pctl":"61","PopCharSco":7.7,"Pop_Pctl":"86","Children__":14.4,"Pop_11_64_":77.1,"Elderly___":8.5,"Hispanic__":"49","White____":"9.9","African_Am":"10.3","Native_Ame":"0.3","Asian_Amer":"28.4","Other____":"2.1","Shape_Leng":5068.50080066,"Shape_Area":1480751.5983}},{"arcs":[[668,669,670,671,672,673,674]],"type":"Polygon","properties":{"Tract_1":6037541400,"Percentile":"96-100%","Population":7312,"County":"Los Angeles","ZIP":90222,"City":"Compton","CIscore":61.5,"CIscoreP":"97","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":18.7,"DPM_pctl":58,"DrinkingWa":471.4,"DW_pctl":"48","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5852.68,"TR_pctl":84,"Traffic":447.04,"Traff_Pctl":"26","Cleanups":11.05,"Clean_Pctl":65,"Groundwate":15.85,"GW_pctl":63,"Haz_Waste":3.1,"Haz_pctl":95,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":3,"Solid_pctl":62,"PollutionS":6.82,"Poll_pctl":84,"Asthma":102.03,"Asthma_Pct":93,"Low_Birth_":5.45,"LBW_pctl":"65","Cardiovasc":12,"CVD_pctl":89,"Education":58.6,"Edu_pctl":"98","Linguistic":27,"Ling_pctl":"92","Poverty":69.4,"Pov_pctl":"93","Unemployme":17.8,"Unem_pctl":"92","Housing_Bu":28.2,"HB_pctl":"84","PopCharSco":9.02,"Pop_Pctl":"98","Children__":20,"Pop_11_64_":74.6,"Elderly___":5.4,"Hispanic__":"79.6","White____":"0.8","African_Am":"18.6","Native_Ame":"0.1","Asian_Amer":"0.4","Other____":"0.5","Shape_Leng":4703.1061573,"Shape_Area":953852.296823}},{"arcs":[[675,676,677,678,679]],"type":"Polygon","properties":{"Tract_1":6037555001,"Percentile":"81-85%","Population":5411,"County":"Los Angeles","ZIP":90715,"City":"Lakewood","CIscore":46.1,"CIscoreP":"84","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":12.89,"DPM_pctl":38,"DrinkingWa":367.06,"DW_pctl":"38","Pesticides":11.706,"Pest_pctl":60,"Tox_Releas":5649.41,"TR_pctl":83,"Traffic":1530.98,"Traff_Pctl":"84","Cleanups":0,"Clean_Pctl":0,"Groundwate":1,"GW_pctl":6,"Haz_Waste":0.12,"Haz_pctl":49,"Imp__Water":3,"IWB_pctl":41,"Solid_Wast":3.2,"Solid_pctl":63,"PollutionS":6.11,"Poll_pctl":72,"Asthma":81.75,"Asthma_Pct":86,"Low_Birth_":6.02,"LBW_pctl":"77","Cardiovasc":12.17,"CVD_pctl":89,"Education":23.7,"Edu_pctl":"68","Linguistic":9.7,"Ling_pctl":"58","Poverty":35.9,"Pov_pctl":"54","Unemployme":9.8,"Unem_pctl":"54","Housing_Bu":23.6,"HB_pctl":"72","PopCharSco":7.54,"Pop_Pctl":"84","Children__":13.3,"Pop_11_64_":76.9,"Elderly___":9.8,"Hispanic__":"46.1","White____":"17.7","African_Am":"8.5","Native_Ame":"0.5","Asian_Amer":"25.2","Other____":"2.1","Shape_Leng":5311.07048778,"Shape_Area":1289023.69394}},{"arcs":[[680,681,682,683,684,685,686]],"type":"Polygon","properties":{"Tract_1":6037570100,"Percentile":"86-90%","Population":2837,"County":"Los Angeles","ZIP":90805,"City":"Long Beach","CIscore":49.59,"CIscoreP":"88","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":21.73,"DPM_pctl":66,"DrinkingWa":283.19,"DW_pctl":"30","Pesticides":2.519,"Pest_pctl":47,"Tox_Releas":6693.62,"TR_pctl":87,"Traffic":922.5,"Traff_Pctl":"64","Cleanups":10.5,"Clean_Pctl":64,"Groundwate":57.35,"GW_pctl":93,"Haz_Waste":0.96,"Haz_pctl":86,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":4.5,"Solid_pctl":70,"PollutionS":7.2,"Poll_pctl":89,"Asthma":72.45,"Asthma_Pct":80,"Low_Birth_":6.82,"LBW_pctl":"89","Cardiovasc":9.01,"CVD_pctl":64,"Education":19,"Edu_pctl":"60","Linguistic":1.9,"Ling_pctl":"13","Poverty":37.1,"Pov_pctl":"55","Unemployme":17.1,"Unem_pctl":"91","Housing_Bu":19.5,"HB_pctl":"57","PopCharSco":6.89,"Pop_Pctl":"75","Children__":10.9,"Pop_11_64_":77.1,"Elderly___":12,"Hispanic__":"31.4","White____":"24.3","African_Am":"20.1","Native_Ame":"0.1","Asian_Amer":"21.1","Other____":"2.9","Shape_Leng":4479.0930872,"Shape_Area":1156021.92071}},{"arcs":[[687,688,689,690]],"type":"Polygon","properties":{"Tract_1":6037570002,"Percentile":"16-20%","Population":2699,"County":"Los Angeles","ZIP":90712,"City":"Lakewood","CIscore":11.03,"CIscoreP":"15","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":21.73,"DPM_pctl":66,"DrinkingWa":280.91,"DW_pctl":"29","Pesticides":0.094,"Pest_pctl":20,"Tox_Releas":6443.08,"TR_pctl":86,"Traffic":533.6,"Traff_Pctl":"34","Cleanups":0,"Clean_Pctl":0,"Groundwate":3,"GW_pctl":22,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.24,"Poll_pctl":31,"Asthma":44.1,"Asthma_Pct":48,"Low_Birth_":3.03,"LBW_pctl":"9","Cardiovasc":7.31,"CVD_pctl":42,"Education":12.3,"Edu_pctl":"46","Linguistic":0.6,"Ling_pctl":"3","Poverty":18,"Pov_pctl":"23","Unemployme":4.9,"Unem_pctl":"12","Housing_Bu":6.5,"HB_pctl":"4","PopCharSco":2.6,"Pop_Pctl":"14","Children__":13.2,"Pop_11_64_":77.1,"Elderly___":9.7,"Hispanic__":"30.3","White____":"48.6","African_Am":"5.4","Native_Ame":"0.5","Asian_Amer":"10.6","Other____":"4.6","Shape_Leng":3539.39117955,"Shape_Area":776750.042831}},{"arcs":[[-574,691,-572,692,693,694,695,-578]],"type":"Polygon","properties":{"Tract_1":6037650603,"Percentile":"41-45%","Population":3958,"County":"Los Angeles","ZIP":90503,"City":"Torrance","CIscore":20.71,"CIscoreP":"40","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":15.61,"DPM_pctl":48,"DrinkingWa":237.22,"DW_pctl":"24","Pesticides":0,"Pest_pctl":0,"Tox_Releas":12953.78,"TR_pctl":96,"Traffic":610.08,"Traff_Pctl":"43","Cleanups":2.75,"Clean_Pctl":31,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.01,"Haz_pctl":9,"Imp__Water":5,"IWB_pctl":55,"Solid_Wast":2.2,"Solid_pctl":52,"PollutionS":5.09,"Poll_pctl":49,"Asthma":24.55,"Asthma_Pct":15,"Low_Birth_":5.73,"LBW_pctl":"71","Cardiovasc":5.66,"CVD_pctl":20,"Education":5.5,"Edu_pctl":"22","Linguistic":10.9,"Ling_pctl":"62","Poverty":23,"Pov_pctl":"32","Unemployme":6.9,"Unem_pctl":"28","Housing_Bu":23.1,"HB_pctl":"71","PopCharSco":4.07,"Pop_Pctl":"33","Children__":8.9,"Pop_11_64_":70.4,"Elderly___":20.7,"Hispanic__":"9.3","White____":"48.7","African_Am":"1.3","Native_Ame":"0.3","Asian_Amer":"36.1","Other____":"4.3","Shape_Leng":4914.72700787,"Shape_Area":1275997.03754}},{"arcs":[[696,697,698,699,700,701,-694]],"type":"Polygon","properties":{"Tract_1":6037650702,"Percentile":"6-10%","Population":4590,"County":"Los Angeles","ZIP":90503,"City":"Torrance","CIscore":7.38,"CIscoreP":"7","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":15.61,"DPM_pctl":48,"DrinkingWa":237.48,"DW_pctl":"24","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8704.53,"TR_pctl":92,"Traffic":752.26,"Traff_Pctl":"54","Cleanups":4,"Clean_Pctl":39,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.02,"Haz_pctl":16,"Imp__Water":5,"IWB_pctl":55,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":4.95,"Poll_pctl":45,"Asthma":22.9,"Asthma_Pct":12,"Low_Birth_":2.61,"LBW_pctl":"5","Cardiovasc":5.29,"CVD_pctl":15,"Education":2.6,"Edu_pctl":"8","Linguistic":5.2,"Ling_pctl":"38","Poverty":7,"Pov_pctl":"3","Unemployme":7.7,"Unem_pctl":"36","Housing_Bu":6.6,"HB_pctl":"4","PopCharSco":1.49,"Pop_Pctl":"3","Children__":11.7,"Pop_11_64_":73.8,"Elderly___":14.5,"Hispanic__":"11.9","White____":"60.3","African_Am":"0.5","Native_Ame":"0.1","Asian_Amer":"22.5","Other____":"4.7","Shape_Leng":5011.83735792,"Shape_Area":1398213.10463}},{"arcs":[[702,703,704,-112]],"type":"Polygon","properties":{"Tract_1":6037650800,"Percentile":"31-35%","Population":7074,"County":"Los Angeles","ZIP":90503,"City":"Torrance","CIscore":17.12,"CIscoreP":"31","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":17.03,"DPM_pctl":52,"DrinkingWa":220.21,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":10103.69,"TR_pctl":94,"Traffic":862.9,"Traff_Pctl":"61","Cleanups":3.9,"Clean_Pctl":36,"Groundwate":11.75,"GW_pctl":53,"Haz_Waste":0.41,"Haz_pctl":73,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":6.5,"Solid_pctl":80,"PollutionS":5.97,"Poll_pctl":68,"Asthma":22.94,"Asthma_Pct":12,"Low_Birth_":4.67,"LBW_pctl":"43","Cardiovasc":4.85,"CVD_pctl":11,"Education":2.8,"Edu_pctl":"9","Linguistic":21.4,"Ling_pctl":"86","Poverty":10.3,"Pov_pctl":"8","Unemployme":5.9,"Unem_pctl":"20","Housing_Bu":16.5,"HB_pctl":"43","PopCharSco":2.87,"Pop_Pctl":"17","Children__":12.7,"Pop_11_64_":73.4,"Elderly___":13.9,"Hispanic__":"5.8","White____":"24.5","African_Am":"1.8","Native_Ame":"0.1","Asian_Amer":"64.7","Other____":"3.2","Shape_Leng":4794.75784899,"Shape_Area":1291751.91147}},{"arcs":[[705,-698,706,707]],"type":"Polygon","properties":{"Tract_1":6037650701,"Percentile":"31-35%","Population":2521,"County":"Los Angeles","ZIP":90503,"City":"Torrance","CIscore":17.91,"CIscoreP":"33","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":15.64,"DPM_pctl":48,"DrinkingWa":237.25,"DW_pctl":"24","Pesticides":0,"Pest_pctl":0,"Tox_Releas":10648.62,"TR_pctl":94,"Traffic":808.85,"Traff_Pctl":"57","Cleanups":0,"Clean_Pctl":0,"Groundwate":10.35,"GW_pctl":50,"Haz_Waste":0.46,"Haz_pctl":75,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":2.2,"Solid_pctl":52,"PollutionS":5.4,"Poll_pctl":55,"Asthma":26.13,"Asthma_Pct":18,"Low_Birth_":5.33,"LBW_pctl":"62","Cardiovasc":5.95,"CVD_pctl":23,"Education":7.4,"Edu_pctl":"30","Linguistic":12,"Ling_pctl":"66","Poverty":17.3,"Pov_pctl":"21","Unemployme":5.3,"Unem_pctl":"15","Housing_Bu":11,"HB_pctl":"17","PopCharSco":3.32,"Pop_Pctl":"23","Children__":9.6,"Pop_11_64_":70.8,"Elderly___":19.6,"Hispanic__":"11.3","White____":"50.6","African_Am":"1.6","Native_Ame":"0","Asian_Amer":"33","Other____":"3.4","Shape_Leng":5686.76275352,"Shape_Area":2007425.37336}},{"arcs":[[708,709,710,711,712,713]],"type":"Polygon","properties":{"Tract_1":6037670001,"Percentile":"51-55%","Population":3311,"County":"Los Angeles","ZIP":90717,"City":"Lomita","CIscore":25.35,"CIscoreP":"51","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":18.53,"DPM_pctl":57,"DrinkingWa":376.65,"DW_pctl":"39","Pesticides":0,"Pest_pctl":0,"Tox_Releas":7220.91,"TR_pctl":89,"Traffic":1154.08,"Traff_Pctl":"74","Cleanups":8.75,"Clean_Pctl":57,"Groundwate":19,"GW_pctl":69,"Haz_Waste":1.42,"Haz_pctl":90,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":2.2,"Solid_pctl":52,"PollutionS":6.42,"Poll_pctl":77,"Asthma":39.67,"Asthma_Pct":41,"Low_Birth_":4.88,"LBW_pctl":"49","Cardiovasc":5.58,"CVD_pctl":19,"Education":15,"Edu_pctl":"52","Linguistic":11.9,"Ling_pctl":"66","Poverty":27.7,"Pov_pctl":"41","Unemployme":7.6,"Unem_pctl":"35","Housing_Bu":7.2,"HB_pctl":"5","PopCharSco":3.95,"Pop_Pctl":"32","Children__":11.3,"Pop_11_64_":73.5,"Elderly___":15.2,"Hispanic__":"31.7","White____":"46.7","African_Am":"1.8","Native_Ame":"0.2","Asian_Amer":"15.4","Other____":"4.1","Shape_Leng":5048.67098899,"Shape_Area":935120.0489}},{"arcs":[[714,715,716,717]],"type":"Polygon","properties":{"Tract_1":6037651221,"Percentile":"41-45%","Population":3291,"County":"Los Angeles","ZIP":90505,"City":"Torrance","CIscore":21.78,"CIscoreP":"43","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":13.29,"DPM_pctl":40,"DrinkingWa":188.14,"DW_pctl":"14","Pesticides":0,"Pest_pctl":0,"Tox_Releas":7431.98,"TR_pctl":89,"Traffic":875.51,"Traff_Pctl":"61","Cleanups":0.9,"Clean_Pctl":13,"Groundwate":11.25,"GW_pctl":52,"Haz_Waste":0.14,"Haz_pctl":51,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":2,"Solid_pctl":50,"PollutionS":5.1,"Poll_pctl":49,"Asthma":27.94,"Asthma_Pct":21,"Low_Birth_":3.7,"LBW_pctl":"20","Cardiovasc":6.63,"CVD_pctl":32,"Education":8.7,"Edu_pctl":"35","Linguistic":23.2,"Ling_pctl":"89","Poverty":23.3,"Pov_pctl":"33","Unemployme":9.6,"Unem_pctl":"53","Housing_Bu":26.1,"HB_pctl":"80","PopCharSco":4.27,"Pop_Pctl":"36","Children__":10.5,"Pop_11_64_":74,"Elderly___":15.5,"Hispanic__":"11.3","White____":"39","African_Am":"4","Native_Ame":"0.2","Asian_Amer":"41.8","Other____":"3.7","Shape_Leng":3464.44664825,"Shape_Area":696912.833727}},{"arcs":[[718,719,720,-703,-105]],"type":"Polygon","properties":{"Tract_1":6037650902,"Percentile":"61-65%","Population":7103,"County":"Los Angeles","ZIP":90501,"City":"Torrance","CIscore":31.71,"CIscoreP":"63","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":17.13,"DPM_pctl":52,"DrinkingWa":403.48,"DW_pctl":"42","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8649.73,"TR_pctl":92,"Traffic":923.45,"Traff_Pctl":"64","Cleanups":22.5,"Clean_Pctl":85,"Groundwate":37.25,"GW_pctl":86,"Haz_Waste":0.27,"Haz_pctl":67,"Imp__Water":3,"IWB_pctl":41,"Solid_Wast":4,"Solid_pctl":68,"PollutionS":7.12,"Poll_pctl":88,"Asthma":57.63,"Asthma_Pct":66,"Low_Birth_":5.32,"LBW_pctl":"61","Cardiovasc":6.98,"CVD_pctl":37,"Education":7.9,"Edu_pctl":"32","Linguistic":11.2,"Ling_pctl":"63","Poverty":16.9,"Pov_pctl":"20","Unemployme":5.1,"Unem_pctl":"13","Housing_Bu":13.3,"HB_pctl":"27","PopCharSco":4.46,"Pop_Pctl":"39","Children__":12.1,"Pop_11_64_":78.6,"Elderly___":9.3,"Hispanic__":"28.8","White____":"30.5","African_Am":"2.4","Native_Ame":"0.3","Asian_Amer":"34.6","Other____":"3.5","Shape_Leng":6249.02956054,"Shape_Area":1981947.53716}},{"arcs":[[-700,721,722,723,724,725]],"type":"Polygon","properties":{"Tract_1":6037651201,"Percentile":"1-5%","Population":5056,"County":"Los Angeles","ZIP":90505,"City":"Torrance","CIscore":5.34,"CIscoreP":"4","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":12.16,"DPM_pctl":35,"DrinkingWa":211.46,"DW_pctl":"17","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6477.38,"TR_pctl":87,"Traffic":518.11,"Traff_Pctl":"33","Cleanups":4,"Clean_Pctl":39,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.06,"Haz_pctl":28,"Imp__Water":5,"IWB_pctl":55,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":4.52,"Poll_pctl":36,"Asthma":24.66,"Asthma_Pct":15,"Low_Birth_":3,"LBW_pctl":"9","Cardiovasc":5.87,"CVD_pctl":22,"Education":3.5,"Edu_pctl":"13","Linguistic":1.4,"Ling_pctl":"9","Poverty":5.6,"Pov_pctl":"2","Unemployme":4.4,"Unem_pctl":"9","Housing_Bu":7,"HB_pctl":"5","PopCharSco":1.18,"Pop_Pctl":"2","Children__":10.9,"Pop_11_64_":75.3,"Elderly___":13.8,"Hispanic__":"11.4","White____":"67.5","African_Am":"0.7","Native_Ame":"0.4","Asian_Amer":"15.9","Other____":"4","Shape_Leng":5271.70841365,"Shape_Area":1747964.69698}},{"arcs":[[726,727,728,729,730]],"type":"Polygon","properties":{"Tract_1":6037294301,"Percentile":"76-80%","Population":2448,"County":"Los Angeles","ZIP":90744,"City":"Wilmington","CIscore":41.17,"CIscoreP":"78","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":20.01,"DPM_pctl":62,"DrinkingWa":436.3,"DW_pctl":"45","Pesticides":0,"Pest_pctl":0,"Tox_Releas":10033.96,"TR_pctl":94,"Traffic":1266.03,"Traff_Pctl":"77","Cleanups":4.5,"Clean_Pctl":42,"Groundwate":35.5,"GW_pctl":85,"Haz_Waste":0.18,"Haz_pctl":57,"Imp__Water":12,"IWB_pctl":91,"Solid_Wast":2,"Solid_pctl":50,"PollutionS":7.09,"Poll_pctl":88,"Asthma":63.92,"Asthma_Pct":73,"Low_Birth_":4.48,"LBW_pctl":"38","Cardiovasc":9.66,"CVD_pctl":71,"Education":37.5,"Edu_pctl":"85","Linguistic":10.2,"Ling_pctl":"60","Poverty":31.2,"Pov_pctl":"47","Unemployme":7.2,"Unem_pctl":"31","Housing_Bu":14.7,"HB_pctl":"34","PopCharSco":5.81,"Pop_Pctl":"59","Children__":13.9,"Pop_11_64_":75.6,"Elderly___":10.5,"Hispanic__":"81.7","White____":"8.9","African_Am":"1.3","Native_Ame":"0","Asian_Amer":"6.8","Other____":"1.2","Shape_Leng":3557.23577775,"Shape_Area":713664.364971}},{"arcs":[[731,732,-202,733,734,735]],"type":"Polygon","properties":{"Tract_1":6037293307,"Percentile":"76-80%","Population":2306,"County":"Los Angeles","ZIP":90710,"City":"Harbor City","CIscore":41.47,"CIscoreP":"78","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":19.31,"DPM_pctl":59,"DrinkingWa":195.07,"DW_pctl":"15","Pesticides":0,"Pest_pctl":0,"Tox_Releas":7994.99,"TR_pctl":90,"Traffic":1055.26,"Traff_Pctl":"70","Cleanups":3.9,"Clean_Pctl":36,"Groundwate":5,"GW_pctl":32,"Haz_Waste":2.79,"Haz_pctl":94,"Imp__Water":9,"IWB_pctl":81,"Solid_Wast":3.2,"Solid_pctl":63,"PollutionS":6.41,"Poll_pctl":77,"Asthma":38.99,"Asthma_Pct":40,"Low_Birth_":5.24,"LBW_pctl":"59","Cardiovasc":6.87,"CVD_pctl":35,"Education":30.5,"Edu_pctl":"77","Linguistic":21.1,"Ling_pctl":"86","Poverty":48.2,"Pov_pctl":"71","Unemployme":14.6,"Unem_pctl":"83","Housing_Bu":27.2,"HB_pctl":"82","PopCharSco":6.47,"Pop_Pctl":"69","Children__":15.7,"Pop_11_64_":77.6,"Elderly___":6.7,"Hispanic__":"56","White____":"15.4","African_Am":"13.1","Native_Ame":"0.1","Asian_Amer":"12.8","Other____":"2.5","Shape_Leng":2791.32238734,"Shape_Area":339996.646227}},{"arcs":[[736,737,738,739,740,741,742]],"type":"Polygon","properties":{"Tract_1":6037980007,"Percentile":"NA","Population":0,"County":"Los Angeles","ZIP":90803,"City":"Long Beach","CIscore":0,"CIscoreP":"NA","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":12.66,"DPM_pctl":38,"DrinkingWa":0,"DW_pctl":"NA","Pesticides":0.004,"Pest_pctl":5,"Tox_Releas":9154.76,"TR_pctl":92,"Traffic":925.45,"Traff_Pctl":"64","Cleanups":33.75,"Clean_Pctl":92,"Groundwate":18.6,"GW_pctl":68,"Haz_Waste":1,"Haz_pctl":87,"Imp__Water":16,"IWB_pctl":97,"Solid_Wast":12.75,"Solid_pctl":93,"PollutionS":7.82,"Poll_pctl":95,"Asthma":0,"Asthma_Pct":0,"Low_Birth_":0,"LBW_pctl":"NA","Cardiovasc":0,"CVD_pctl":0,"Education":0,"Edu_pctl":"NA","Linguistic":0,"Ling_pctl":"NA","Poverty":0,"Pov_pctl":"NA","Unemployme":0,"Unem_pctl":"NA","Housing_Bu":0,"HB_pctl":"NA","PopCharSco":0,"Pop_Pctl":"NA","Children__":0,"Pop_11_64_":100,"Elderly___":0,"Hispanic__":"NA","White____":"NA","African_Am":"NA","Native_Ame":"NA","Asian_Amer":"NA","Other____":"NA","Shape_Leng":7332.5856527,"Shape_Area":2701084.17522}},{"arcs":[[743,744,745,746,747,748,749]],"type":"Polygon","properties":{"Tract_1":6037980006,"Percentile":"NA","Population":0,"County":"Los Angeles","ZIP":90808,"City":"Long Beach","CIscore":0,"CIscoreP":"NA","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":15.43,"DPM_pctl":47,"DrinkingWa":0,"DW_pctl":"NA","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6917.14,"TR_pctl":88,"Traffic":2350.06,"Traff_Pctl":"94","Cleanups":4.9,"Clean_Pctl":43,"Groundwate":7.75,"GW_pctl":41,"Haz_Waste":0.1,"Haz_pctl":43,"Imp__Water":22,"IWB_pctl":99,"Solid_Wast":2.25,"Solid_pctl":53,"PollutionS":6.89,"Poll_pctl":85,"Asthma":0,"Asthma_Pct":0,"Low_Birth_":0,"LBW_pctl":"NA","Cardiovasc":0,"CVD_pctl":0,"Education":0,"Edu_pctl":"NA","Linguistic":0,"Ling_pctl":"NA","Poverty":0,"Pov_pctl":"NA","Unemployme":0,"Unem_pctl":"NA","Housing_Bu":0,"HB_pctl":"NA","PopCharSco":0,"Pop_Pctl":"NA","Children__":0,"Pop_11_64_":100,"Elderly___":0,"Hispanic__":"NA","White____":"NA","African_Am":"NA","Native_Ame":"NA","Asian_Amer":"NA","Other____":"NA","Shape_Leng":11674.36328,"Shape_Area":3370730.69681}},{"arcs":[[-110,750,751,752,-108,753]],"type":"Polygon","properties":{"Tract_1":6037980005,"Percentile":"NA","Population":0,"County":"Los Angeles","ZIP":90501,"City":"Torrance","CIscore":0,"CIscoreP":"NA","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":17.87,"DPM_pctl":54,"DrinkingWa":0,"DW_pctl":"NA","Pesticides":0.353,"Pest_pctl":30,"Tox_Releas":77200.69,"TR_pctl":100,"Traffic":979.89,"Traff_Pctl":"67","Cleanups":67.8,"Clean_Pctl":98,"Groundwate":71.45,"GW_pctl":95,"Haz_Waste":12.62,"Haz_pctl":100,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":6.7,"Solid_pctl":81,"PollutionS":8.11,"Poll_pctl":97,"Asthma":0,"Asthma_Pct":0,"Low_Birth_":0,"LBW_pctl":"NA","Cardiovasc":0,"CVD_pctl":0,"Education":0,"Edu_pctl":"NA","Linguistic":0,"Ling_pctl":"NA","Poverty":0,"Pov_pctl":"NA","Unemployme":0,"Unem_pctl":"NA","Housing_Bu":0,"HB_pctl":"NA","PopCharSco":0,"Pop_Pctl":"NA","Children__":0,"Pop_11_64_":100,"Elderly___":0,"Hispanic__":"NA","White____":"NA","African_Am":"NA","Native_Ame":"NA","Asian_Amer":"NA","Other____":"NA","Shape_Leng":9649.25491924,"Shape_Area":4053929.58466}},{"arcs":[[754,755,-230,756,757]],"type":"Polygon","properties":{"Tract_1":6037291110,"Percentile":"91-95%","Population":3510,"County":"Los Angeles","ZIP":90044,"City":"Los Angeles","CIscore":53.94,"CIscoreP":"92","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":27.84,"DPM_pctl":82,"DrinkingWa":689.3,"DW_pctl":"81","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5246.26,"TR_pctl":81,"Traffic":3309.97,"Traff_Pctl":"98","Cleanups":5.95,"Clean_Pctl":47,"Groundwate":20.05,"GW_pctl":71,"Haz_Waste":0.18,"Haz_pctl":56,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":8.15,"Solid_pctl":86,"PollutionS":7.59,"Poll_pctl":93,"Asthma":69.17,"Asthma_Pct":78,"Low_Birth_":6.28,"LBW_pctl":"82","Cardiovasc":7.77,"CVD_pctl":48,"Education":24,"Edu_pctl":"68","Linguistic":8.2,"Ling_pctl":"52","Poverty":56.1,"Pov_pctl":"80","Unemployme":10.6,"Unem_pctl":"61","Housing_Bu":25.8,"HB_pctl":"79","PopCharSco":7.11,"Pop_Pctl":"78","Children__":17.2,"Pop_11_64_":74.5,"Elderly___":8.3,"Hispanic__":"42.1","White____":"0.8","African_Am":"54","Native_Ame":"0.1","Asian_Amer":"0.7","Other____":"2.4","Shape_Leng":3522.05937161,"Shape_Area":708715.365454}},{"arcs":[[758,-491,-756,759]],"type":"Polygon","properties":{"Tract_1":6037291120,"Percentile":"91-95%","Population":2210,"County":"Los Angeles","ZIP":90248,"City":"Gardena","CIscore":56.2,"CIscoreP":"94","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":27.84,"DPM_pctl":82,"DrinkingWa":664.07,"DW_pctl":"79","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5867.42,"TR_pctl":84,"Traffic":2920.44,"Traff_Pctl":"97","Cleanups":6.75,"Clean_Pctl":50,"Groundwate":21.6,"GW_pctl":73,"Haz_Waste":0.17,"Haz_pctl":55,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":5.3,"Solid_pctl":74,"PollutionS":7.51,"Poll_pctl":93,"Asthma":47.62,"Asthma_Pct":53,"Low_Birth_":8.22,"LBW_pctl":"97","Cardiovasc":6.02,"CVD_pctl":24,"Education":44.2,"Edu_pctl":"90","Linguistic":15.6,"Ling_pctl":"76","Poverty":61.1,"Pov_pctl":"85","Unemployme":16.4,"Unem_pctl":"89","Housing_Bu":31,"HB_pctl":"89","PopCharSco":7.48,"Pop_Pctl":"83","Children__":16.7,"Pop_11_64_":76.5,"Elderly___":6.8,"Hispanic__":"66.3","White____":"1.9","African_Am":"28.6","Native_Ame":"0","Asian_Amer":"2.6","Other____":"0.5","Shape_Leng":3346.85526738,"Shape_Area":699064.940244}},{"arcs":[[760,761,762,763]],"type":"Polygon","properties":{"Tract_1":6037291130,"Percentile":"96-100%","Population":3582,"County":"Los Angeles","ZIP":90248,"City":"Gardena","CIscore":64.33,"CIscoreP":"98","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":27.84,"DPM_pctl":82,"DrinkingWa":695.76,"DW_pctl":"82","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6327.44,"TR_pctl":86,"Traffic":2924.53,"Traff_Pctl":"97","Cleanups":16.05,"Clean_Pctl":79,"Groundwate":50.55,"GW_pctl":91,"Haz_Waste":1.02,"Haz_pctl":87,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":13.95,"Solid_pctl":94,"PollutionS":8.38,"Poll_pctl":98,"Asthma":66.08,"Asthma_Pct":75,"Low_Birth_":6.35,"LBW_pctl":"83","Cardiovasc":8.71,"CVD_pctl":59,"Education":33.8,"Edu_pctl":"81","Linguistic":19.1,"Ling_pctl":"83","Poverty":40.7,"Pov_pctl":"61","Unemployme":12.4,"Unem_pctl":"72","Housing_Bu":27.1,"HB_pctl":"82","PopCharSco":7.68,"Pop_Pctl":"86","Children__":14.5,"Pop_11_64_":74.6,"Elderly___":10.9,"Hispanic__":"64","White____":"4.8","African_Am":"18.6","Native_Ame":"0","Asian_Amer":"11.1","Other____":"1.5","Shape_Leng":4823.70655208,"Shape_Area":1294790.49202}},{"arcs":[[764,765,766,767,768]],"type":"Polygon","properties":{"Tract_1":6037540400,"Percentile":"96-100%","Population":2384,"County":"Los Angeles","ZIP":90059,"City":"Los Angeles","CIscore":69.24,"CIscoreP":"99","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":25.04,"DPM_pctl":76,"DrinkingWa":671.58,"DW_pctl":"79","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5968.05,"TR_pctl":85,"Traffic":2333.93,"Traff_Pctl":"94","Cleanups":67.85,"Clean_Pctl":98,"Groundwate":18.3,"GW_pctl":68,"Haz_Waste":0.98,"Haz_pctl":86,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":9,"Solid_pctl":87,"PollutionS":8.14,"Poll_pctl":97,"Asthma":90.58,"Asthma_Pct":90,"Low_Birth_":4.68,"LBW_pctl":"43","Cardiovasc":10.34,"CVD_pctl":77,"Education":56.1,"Edu_pctl":"97","Linguistic":22.9,"Ling_pctl":"88","Poverty":80.2,"Pov_pctl":"98","Unemployme":18.3,"Unem_pctl":"93","Housing_Bu":33.8,"HB_pctl":"93","PopCharSco":8.51,"Pop_Pctl":"95","Children__":20.3,"Pop_11_64_":75.8,"Elderly___":3.9,"Hispanic__":"80.8","White____":"0.9","African_Am":"16.4","Native_Ame":"0.3","Asian_Amer":"0.9","Other____":"0.8","Shape_Leng":2519.88592953,"Shape_Area":337628.527395}},{"arcs":[[769,770,771,772,773,774,775]],"type":"Polygon","properties":{"Tract_1":6037540502,"Percentile":"91-95%","Population":6552,"County":"Los Angeles","ZIP":90262,"City":"Lynwood","CIscore":54.13,"CIscoreP":"93","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":20.48,"DPM_pctl":63,"DrinkingWa":458.12,"DW_pctl":"47","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6042.42,"TR_pctl":85,"Traffic":752.77,"Traff_Pctl":"54","Cleanups":17.6,"Clean_Pctl":81,"Groundwate":22.55,"GW_pctl":74,"Haz_Waste":6.41,"Haz_pctl":98,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":8.25,"Solid_pctl":86,"PollutionS":7.14,"Poll_pctl":88,"Asthma":45.85,"Asthma_Pct":51,"Low_Birth_":6.46,"LBW_pctl":"84","Cardiovasc":8.26,"CVD_pctl":54,"Education":49.3,"Edu_pctl":"94","Linguistic":22.6,"Ling_pctl":"88","Poverty":61.5,"Pov_pctl":"86","Unemployme":10.7,"Unem_pctl":"61","Housing_Bu":29.8,"HB_pctl":"87","PopCharSco":7.58,"Pop_Pctl":"84","Children__":23.1,"Pop_11_64_":74.2,"Elderly___":2.7,"Hispanic__":"84.1","White____":"1.8","African_Am":"13","Native_Ame":"0.1","Asian_Amer":"0.5","Other____":"0.6","Shape_Leng":3383.90078969,"Shape_Area":598685.220355}},{"arcs":[[776,-645,777,-655,778,779,780,781,782]],"type":"Polygon","properties":{"Tract_1":6037540202,"Percentile":"76-80%","Population":6845,"County":"Los Angeles","ZIP":90262,"City":"Lynwood","CIscore":40.26,"CIscoreP":"76","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":19.65,"DPM_pctl":61,"DrinkingWa":463.13,"DW_pctl":"47","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6313.25,"TR_pctl":86,"Traffic":933.09,"Traff_Pctl":"64","Cleanups":7.9,"Clean_Pctl":55,"Groundwate":2.6,"GW_pctl":16,"Haz_Waste":0.04,"Haz_pctl":18,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":5.26,"Poll_pctl":52,"Asthma":46.22,"Asthma_Pct":51,"Low_Birth_":4.85,"LBW_pctl":"48","Cardiovasc":9.09,"CVD_pctl":64,"Education":53.1,"Edu_pctl":"96","Linguistic":24.2,"Ling_pctl":"90","Poverty":77.2,"Pov_pctl":"97","Unemployme":14.8,"Unem_pctl":"84","Housing_Bu":41.4,"HB_pctl":"98","PopCharSco":7.65,"Pop_Pctl":"85","Children__":17.6,"Pop_11_64_":74,"Elderly___":8.4,"Hispanic__":"87.3","White____":"3.5","African_Am":"7.5","Native_Ame":"0.1","Asian_Amer":"1.2","Other____":"0.5","Shape_Leng":3820.29539429,"Shape_Area":757149.719396}},{"arcs":[[783,-770,784,-775,785,786,787,-766,788,789,790,791]],"type":"Polygon","properties":{"Tract_1":6037540501,"Percentile":"91-95%","Population":6943,"County":"Los Angeles","ZIP":90262,"City":"Lynwood","CIscore":52.07,"CIscoreP":"91","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":20.54,"DPM_pctl":63,"DrinkingWa":328.66,"DW_pctl":"35","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6045.72,"TR_pctl":85,"Traffic":2648.62,"Traff_Pctl":"96","Cleanups":96.05,"Clean_Pctl":99,"Groundwate":32.8,"GW_pctl":84,"Haz_Waste":1.9,"Haz_pctl":91,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":6.25,"Solid_pctl":79,"PollutionS":7.6,"Poll_pctl":94,"Asthma":48.59,"Asthma_Pct":55,"Low_Birth_":4.29,"LBW_pctl":"33","Cardiovasc":8.29,"CVD_pctl":55,"Education":43.7,"Edu_pctl":"90","Linguistic":12,"Ling_pctl":"66","Poverty":66.6,"Pov_pctl":"90","Unemployme":13.3,"Unem_pctl":"77","Housing_Bu":46.9,"HB_pctl":"100","PopCharSco":6.85,"Pop_Pctl":"74","Children__":13.6,"Pop_11_64_":82.2,"Elderly___":4.2,"Hispanic__":"75.3","White____":"6.2","African_Am":"16.9","Native_Ame":"0","Asian_Amer":"0.7","Other____":"0.9","Shape_Leng":5799.81474048,"Shape_Area":1453274.18626}},{"arcs":[[-647,792,-783,793]],"type":"Polygon","properties":{"Tract_1":6037540201,"Percentile":"66-70%","Population":2370,"County":"Los Angeles","ZIP":90280,"City":"South Gate","CIscore":35.36,"CIscoreP":"69","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":25.03,"DPM_pctl":76,"DrinkingWa":486.36,"DW_pctl":"52","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6212.3,"TR_pctl":86,"Traffic":924.08,"Traff_Pctl":"64","Cleanups":3.35,"Clean_Pctl":34,"Groundwate":5,"GW_pctl":32,"Haz_Waste":0.01,"Haz_pctl":9,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.5,"Solid_pctl":20,"PollutionS":5.47,"Poll_pctl":57,"Asthma":28.53,"Asthma_Pct":23,"Low_Birth_":4.49,"LBW_pctl":"39","Cardiovasc":6.52,"CVD_pctl":31,"Education":55,"Edu_pctl":"96","Linguistic":31.8,"Ling_pctl":"96","Poverty":70.9,"Pov_pctl":"94","Unemployme":15.4,"Unem_pctl":"86","Housing_Bu":44.3,"HB_pctl":"99","PopCharSco":6.47,"Pop_Pctl":"69","Children__":20.2,"Pop_11_64_":76.6,"Elderly___":3.2,"Hispanic__":"96.7","White____":"1.3","African_Am":"0.9","Native_Ame":"0.4","Asian_Amer":"0.4","Other____":"0.3","Shape_Leng":3148.90788979,"Shape_Area":261798.655985}},{"arcs":[[794,-257,795,796,797,-691,798]],"type":"Polygon","properties":{"Tract_1":6037570001,"Percentile":"36-40%","Population":4463,"County":"Los Angeles","ZIP":90713,"City":"Lakewood","CIscore":20.09,"CIscoreP":"38","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":28.46,"DPM_pctl":82,"DrinkingWa":315.93,"DW_pctl":"34","Pesticides":0.309,"Pest_pctl":29,"Tox_Releas":6277.42,"TR_pctl":86,"Traffic":689.26,"Traff_Pctl":"49","Cleanups":0,"Clean_Pctl":0,"Groundwate":3,"GW_pctl":22,"Haz_Waste":0.05,"Haz_pctl":26,"Imp__Water":4,"IWB_pctl":49,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.37,"Poll_pctl":55,"Asthma":33.89,"Asthma_Pct":31,"Low_Birth_":5.1,"LBW_pctl":"55","Cardiovasc":7.54,"CVD_pctl":44,"Education":10.6,"Edu_pctl":"41","Linguistic":4.8,"Ling_pctl":"35","Poverty":16,"Pov_pctl":"18","Unemployme":8.9,"Unem_pctl":"47","Housing_Bu":4.6,"HB_pctl":"1","PopCharSco":3.74,"Pop_Pctl":"29","Children__":11.5,"Pop_11_64_":77.7,"Elderly___":10.8,"Hispanic__":"27.3","White____":"45.4","African_Am":"6.1","Native_Ame":"0.2","Asian_Amer":"17.6","Other____":"3.3","Shape_Leng":5306.1236517,"Shape_Area":1533012.49118}},{"arcs":[[799,800,-798,801,802,803]],"type":"Polygon","properties":{"Tract_1":6037570902,"Percentile":"46-50%","Population":3616,"County":"Los Angeles","ZIP":90713,"City":"Lakewood","CIscore":23.3,"CIscoreP":"46","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":22.52,"DPM_pctl":68,"DrinkingWa":281,"DW_pctl":"29","Pesticides":0.06,"Pest_pctl":17,"Tox_Releas":5808.22,"TR_pctl":84,"Traffic":604.17,"Traff_Pctl":"42","Cleanups":0,"Clean_Pctl":0,"Groundwate":3,"GW_pctl":22,"Haz_Waste":0.51,"Haz_pctl":77,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":4.96,"Poll_pctl":46,"Asthma":41.17,"Asthma_Pct":44,"Low_Birth_":5.84,"LBW_pctl":"73","Cardiovasc":9.9,"CVD_pctl":74,"Education":15.1,"Edu_pctl":"52","Linguistic":0.5,"Ling_pctl":"2","Poverty":16.5,"Pov_pctl":"19","Unemployme":6.9,"Unem_pctl":"28","Housing_Bu":14.5,"HB_pctl":"33","PopCharSco":4.69,"Pop_Pctl":"43","Children__":12.9,"Pop_11_64_":76.2,"Elderly___":10.9,"Hispanic__":"26.4","White____":"53.8","African_Am":"6.2","Native_Ame":"0.5","Asian_Amer":"9.4","Other____":"3.7","Shape_Leng":4316.36666647,"Shape_Area":1056779.31727}},{"arcs":[[804,-191,805,806]],"type":"Polygon","properties":{"Tract_1":6037570702,"Percentile":"51-55%","Population":2433,"County":"Los Angeles","ZIP":90712,"City":"Lakewood","CIscore":26.73,"CIscoreP":"53","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":18.98,"DPM_pctl":59,"DrinkingWa":280.68,"DW_pctl":"29","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5301.61,"TR_pctl":81,"Traffic":508.08,"Traff_Pctl":"32","Cleanups":1.75,"Clean_Pctl":24,"Groundwate":10.55,"GW_pctl":51,"Haz_Waste":0.24,"Haz_pctl":64,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":8.5,"Solid_pctl":86,"PollutionS":5.36,"Poll_pctl":54,"Asthma":54.2,"Asthma_Pct":62,"Low_Birth_":6.29,"LBW_pctl":"82","Cardiovasc":8.76,"CVD_pctl":60,"Education":8.4,"Edu_pctl":"34","Linguistic":0.7,"Ling_pctl":"3","Poverty":14.1,"Pov_pctl":"14","Unemployme":8.2,"Unem_pctl":"41","Housing_Bu":17.7,"HB_pctl":"49","PopCharSco":4.99,"Pop_Pctl":"47","Children__":10.7,"Pop_11_64_":76.7,"Elderly___":12.6,"Hispanic__":"30.2","White____":"38.8","African_Am":"9.2","Native_Ame":"0.2","Asian_Amer":"17.4","Other____":"4.1","Shape_Leng":3364.59792532,"Shape_Area":676501.217097}},{"arcs":[[807,808,-807,809,810,811]],"type":"Polygon","properties":{"Tract_1":6037570701,"Percentile":"61-65%","Population":6569,"County":"Los Angeles","ZIP":90712,"City":"Lakewood","CIscore":30.97,"CIscoreP":"61","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":20.51,"DPM_pctl":63,"DrinkingWa":280.66,"DW_pctl":"29","Pesticides":0.731,"Pest_pctl":36,"Tox_Releas":5656.35,"TR_pctl":83,"Traffic":679.81,"Traff_Pctl":"48","Cleanups":1.75,"Clean_Pctl":24,"Groundwate":45.75,"GW_pctl":90,"Haz_Waste":0.4,"Haz_pctl":73,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":8.2,"Solid_pctl":86,"PollutionS":6.44,"Poll_pctl":78,"Asthma":49.91,"Asthma_Pct":56,"Low_Birth_":7.13,"LBW_pctl":"92","Cardiovasc":7.87,"CVD_pctl":49,"Education":6.4,"Edu_pctl":"25","Linguistic":4.8,"Ling_pctl":"35","Poverty":19.2,"Pov_pctl":"25","Unemployme":4.1,"Unem_pctl":"7","Housing_Bu":16.6,"HB_pctl":"43","PopCharSco":4.81,"Pop_Pctl":"45","Children__":11.9,"Pop_11_64_":74.7,"Elderly___":13.4,"Hispanic__":"25.3","White____":"30.9","African_Am":"20","Native_Ame":"0.2","Asian_Amer":"20","Other____":"3.6","Shape_Leng":6404.53702702,"Shape_Area":1771192.77486}},{"arcs":[[812,813,814]],"type":"Polygon","properties":{"Tract_1":6037571101,"Percentile":"31-35%","Population":4574,"County":"Los Angeles","ZIP":90713,"City":"Lakewood","CIscore":18.67,"CIscoreP":"35","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":12.89,"DPM_pctl":38,"DrinkingWa":281,"DW_pctl":"29","Pesticides":0.639,"Pest_pctl":35,"Tox_Releas":5438.25,"TR_pctl":82,"Traffic":588.48,"Traff_Pctl":"40","Cleanups":0,"Clean_Pctl":0,"Groundwate":3,"GW_pctl":22,"Haz_Waste":0.5,"Haz_pctl":77,"Imp__Water":2,"IWB_pctl":29,"Solid_Wast":2.3,"Solid_pctl":53,"PollutionS":5.38,"Poll_pctl":55,"Asthma":41.17,"Asthma_Pct":44,"Low_Birth_":4.4,"LBW_pctl":"36","Cardiovasc":9.9,"CVD_pctl":74,"Education":8.2,"Edu_pctl":"33","Linguistic":0.9,"Ling_pctl":"5","Poverty":12.3,"Pov_pctl":"11","Unemployme":6.9,"Unem_pctl":"28","Housing_Bu":5.1,"HB_pctl":"2","PopCharSco":3.47,"Pop_Pctl":"24","Children__":12.2,"Pop_11_64_":77.1,"Elderly___":10.7,"Hispanic__":"26.8","White____":"56.9","African_Am":"3.8","Native_Ame":"0.2","Asian_Amer":"8.7","Other____":"3.6","Shape_Leng":4846.10424235,"Shape_Area":1321845.68343}},{"arcs":[[815,-809,816,817]],"type":"Polygon","properties":{"Tract_1":6037571300,"Percentile":"26-30%","Population":4414,"County":"Los Angeles","ZIP":90712,"City":"Lakewood","CIscore":16.1,"CIscoreP":"28","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":18.4,"DPM_pctl":56,"DrinkingWa":280.73,"DW_pctl":"29","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5167.11,"TR_pctl":81,"Traffic":629.28,"Traff_Pctl":"44","Cleanups":10.7,"Clean_Pctl":64,"Groundwate":54.3,"GW_pctl":92,"Haz_Waste":0.08,"Haz_pctl":31,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":5.24,"Poll_pctl":52,"Asthma":48.24,"Asthma_Pct":54,"Low_Birth_":1.44,"LBW_pctl":"1","Cardiovasc":7.94,"CVD_pctl":50,"Education":7.2,"Edu_pctl":"29","Linguistic":1.6,"Ling_pctl":"11","Poverty":10,"Pov_pctl":"7","Unemployme":8.2,"Unem_pctl":"41","Housing_Bu":14.9,"HB_pctl":"35","PopCharSco":3.08,"Pop_Pctl":"20","Children__":11.1,"Pop_11_64_":73.1,"Elderly___":15.8,"Hispanic__":"26.5","White____":"48.9","African_Am":"7.6","Native_Ame":"0.5","Asian_Amer":"12.7","Other____":"3.8","Shape_Leng":5797.09919802,"Shape_Area":2085145.80793}},{"arcs":[[818,-681,819,820,-689,821]],"type":"Polygon","properties":{"Tract_1":6037570003,"Percentile":"41-45%","Population":4447,"County":"Los Angeles","ZIP":90712,"City":"Lakewood","CIscore":22.1,"CIscoreP":"43","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":21.73,"DPM_pctl":66,"DrinkingWa":280.77,"DW_pctl":"29","Pesticides":5.346,"Pest_pctl":53,"Tox_Releas":6504.98,"TR_pctl":87,"Traffic":729.84,"Traff_Pctl":"52","Cleanups":0,"Clean_Pctl":0,"Groundwate":6.2,"GW_pctl":37,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.97,"Poll_pctl":46,"Asthma":52.35,"Asthma_Pct":59,"Low_Birth_":4.45,"LBW_pctl":"37","Cardiovasc":8.41,"CVD_pctl":56,"Education":14,"Edu_pctl":"50","Linguistic":5.6,"Ling_pctl":"40","Poverty":20.5,"Pov_pctl":"28","Unemployme":4.8,"Unem_pctl":"11","Housing_Bu":17,"HB_pctl":"45","PopCharSco":4.45,"Pop_Pctl":"39","Children__":12.8,"Pop_11_64_":76.5,"Elderly___":10.7,"Hispanic__":"32.3","White____":"41.1","African_Am":"8.5","Native_Ame":"0.3","Asian_Amer":"14.5","Other____":"3.4","Shape_Leng":4334.65255456,"Shape_Area":1144402.11354}},{"arcs":[[822,823,824]],"type":"Polygon","properties":{"Tract_1":6037571102,"Percentile":"26-30%","Population":3877,"County":"Los Angeles","ZIP":90713,"City":"Lakewood","CIscore":15.4,"CIscoreP":"26","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":12.89,"DPM_pctl":38,"DrinkingWa":281,"DW_pctl":"29","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5338.79,"TR_pctl":82,"Traffic":583.95,"Traff_Pctl":"40","Cleanups":0,"Clean_Pctl":0,"Groundwate":3,"GW_pctl":22,"Haz_Waste":0.05,"Haz_pctl":26,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.5,"Solid_pctl":20,"PollutionS":3.93,"Poll_pctl":24,"Asthma":41.17,"Asthma_Pct":44,"Low_Birth_":5.09,"LBW_pctl":"55","Cardiovasc":9.9,"CVD_pctl":74,"Education":6.5,"Edu_pctl":"26","Linguistic":2.7,"Ling_pctl":"20","Poverty":21.8,"Pov_pctl":"30","Unemployme":3.1,"Unem_pctl":"3","Housing_Bu":9.6,"HB_pctl":"11","PopCharSco":3.92,"Pop_Pctl":"31","Children__":12.7,"Pop_11_64_":75.3,"Elderly___":12,"Hispanic__":"25.4","White____":"58.5","African_Am":"4.6","Native_Ame":"0.3","Asian_Amer":"7.2","Other____":"3.9","Shape_Leng":4765.21436688,"Shape_Area":1258603.73046}},{"arcs":[[825,826,827,-747,828,-665,829]],"type":"Polygon","properties":{"Tract_1":6037555211,"Percentile":"81-85%","Population":5818,"County":"Los Angeles","ZIP":90716,"City":"Hawaiian Gardens","CIscore":43.76,"CIscoreP":"81","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":12.6,"DPM_pctl":37,"DrinkingWa":366.49,"DW_pctl":"38","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5872.33,"TR_pctl":84,"Traffic":1547.07,"Traff_Pctl":"84","Cleanups":1.4,"Clean_Pctl":21,"Groundwate":19.75,"GW_pctl":70,"Haz_Waste":0.06,"Haz_pctl":28,"Imp__Water":14,"IWB_pctl":94,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.87,"Poll_pctl":66,"Asthma":53.12,"Asthma_Pct":60,"Low_Birth_":5.33,"LBW_pctl":"62","Cardiovasc":8.57,"CVD_pctl":58,"Education":49.2,"Edu_pctl":"94","Linguistic":31.8,"Ling_pctl":"96","Poverty":65.5,"Pov_pctl":"89","Unemployme":10.7,"Unem_pctl":"61","Housing_Bu":26.1,"HB_pctl":"80","PopCharSco":7.46,"Pop_Pctl":"82","Children__":17.1,"Pop_11_64_":75.7,"Elderly___":7.2,"Hispanic__":"89","White____":"4.4","African_Am":"0.8","Native_Ame":"0.4","Asian_Amer":"5","Other____":"0.3","Shape_Leng":3600.17944991,"Shape_Area":797063.150273}},{"arcs":[[830,831,832,833,834,835,836]],"type":"Polygon","properties":{"Tract_1":6037570202,"Percentile":"96-100%","Population":6415,"County":"Los Angeles","ZIP":90805,"City":"Long Beach","CIscore":63.99,"CIscoreP":"98","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":29.03,"DPM_pctl":83,"DrinkingWa":219.19,"DW_pctl":"17","Pesticides":61.009,"Pest_pctl":73,"Tox_Releas":6196.24,"TR_pctl":86,"Traffic":2358.67,"Traff_Pctl":"94","Cleanups":11.4,"Clean_Pctl":66,"Groundwate":21.3,"GW_pctl":73,"Haz_Waste":3.17,"Haz_pctl":95,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":2.25,"Solid_pctl":53,"PollutionS":8.41,"Poll_pctl":98,"Asthma":62.76,"Asthma_Pct":72,"Low_Birth_":6.99,"LBW_pctl":"90","Cardiovasc":8.16,"CVD_pctl":53,"Education":33.9,"Edu_pctl":"81","Linguistic":9.4,"Ling_pctl":"57","Poverty":44.8,"Pov_pctl":"67","Unemployme":19.9,"Unem_pctl":"95","Housing_Bu":24.3,"HB_pctl":"75","PopCharSco":7.61,"Pop_Pctl":"85","Children__":16.2,"Pop_11_64_":78.2,"Elderly___":5.6,"Hispanic__":"62.5","White____":"8.2","African_Am":"16.8","Native_Ame":"0.2","Asian_Amer":"10.2","Other____":"2.1","Shape_Leng":5783.52331123,"Shape_Area":1668522.31024}},{"arcs":[[837,-450,838]],"type":"Polygon","properties":{"Tract_1":6037503802,"Percentile":"46-50%","Population":5054,"County":"Los Angeles","ZIP":90638,"City":"La Mirada","CIscore":24.2,"CIscoreP":"48","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":23.95,"DPM_pctl":73,"DrinkingWa":201.73,"DW_pctl":"15","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5916.82,"TR_pctl":84,"Traffic":502.13,"Traff_Pctl":"31","Cleanups":0.5,"Clean_Pctl":8,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.12,"Haz_pctl":49,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0.1,"Solid_pctl":1,"PollutionS":4.86,"Poll_pctl":44,"Asthma":40.81,"Asthma_Pct":43,"Low_Birth_":5.53,"LBW_pctl":"66","Cardiovasc":11.28,"CVD_pctl":85,"Education":11.4,"Edu_pctl":"43","Linguistic":3.2,"Ling_pctl":"24","Poverty":25.1,"Pov_pctl":"36","Unemployme":6.7,"Unem_pctl":"26","Housing_Bu":12.9,"HB_pctl":"26","PopCharSco":4.98,"Pop_Pctl":"47","Children__":11.6,"Pop_11_64_":77,"Elderly___":11.4,"Hispanic__":"39.6","White____":"33.1","African_Am":"1.2","Native_Ame":"0.3","Asian_Amer":"23.7","Other____":"2.1","Shape_Leng":4764.11480109,"Shape_Area":1320131.4669}},{"arcs":[[839,840,-839,841,842]],"type":"Polygon","properties":{"Tract_1":6037503801,"Percentile":"36-40%","Population":4080,"County":"Los Angeles","ZIP":90638,"City":"La Mirada","CIscore":19.96,"CIscoreP":"38","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":18.51,"DPM_pctl":57,"DrinkingWa":235.45,"DW_pctl":"23","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6052.93,"TR_pctl":85,"Traffic":703.79,"Traff_Pctl":"50","Cleanups":12,"Clean_Pctl":69,"Groundwate":2,"GW_pctl":14,"Haz_Waste":0.02,"Haz_pctl":10,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":1,"Solid_pctl":33,"PollutionS":5.55,"Poll_pctl":59,"Asthma":34.27,"Asthma_Pct":32,"Low_Birth_":2.91,"LBW_pctl":"8","Cardiovasc":8.78,"CVD_pctl":61,"Education":11.1,"Edu_pctl":"43","Linguistic":2,"Ling_pctl":"14","Poverty":24,"Pov_pctl":"34","Unemployme":6.3,"Unem_pctl":"23","Housing_Bu":21.6,"HB_pctl":"66","PopCharSco":3.6,"Pop_Pctl":"26","Children__":12.3,"Pop_11_64_":76.4,"Elderly___":11.3,"Hispanic__":"41.2","White____":"38","African_Am":"1.5","Native_Ame":"0.4","Asian_Amer":"16.5","Other____":"2.5","Shape_Leng":5605.64990083,"Shape_Area":1298759.50518}},{"arcs":[[843,844,845,846,847,848]],"type":"Polygon","properties":{"Tract_1":6037503902,"Percentile":"76-80%","Population":4636,"County":"Los Angeles","ZIP":90638,"City":"La Mirada","CIscore":39.52,"CIscoreP":"75","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":24.62,"DPM_pctl":75,"DrinkingWa":201.73,"DW_pctl":"15","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5794.65,"TR_pctl":84,"Traffic":1289.34,"Traff_Pctl":"78","Cleanups":13.5,"Clean_Pctl":74,"Groundwate":74,"GW_pctl":95,"Haz_Waste":4.75,"Haz_pctl":96,"Imp__Water":8,"IWB_pctl":76,"Solid_Wast":0.3,"Solid_pctl":11,"PollutionS":7.25,"Poll_pctl":90,"Asthma":39.74,"Asthma_Pct":41,"Low_Birth_":6.8,"LBW_pctl":"89","Cardiovasc":10.93,"CVD_pctl":82,"Education":9.9,"Edu_pctl":"39","Linguistic":8.5,"Ling_pctl":"53","Poverty":19.9,"Pov_pctl":"26","Unemployme":8.1,"Unem_pctl":"40","Housing_Bu":10.3,"HB_pctl":"14","PopCharSco":5.45,"Pop_Pctl":"54","Children__":12.5,"Pop_11_64_":74,"Elderly___":13.5,"Hispanic__":"44.7","White____":"39.9","African_Am":"2.2","Native_Ame":"0.2","Asian_Amer":"11","Other____":"2","Shape_Leng":10730.4564276,"Shape_Area":5287437.8623}},{"arcs":[[849,-845,850,851,852]],"type":"Polygon","properties":{"Tract_1":6037504002,"Percentile":"56-60%","Population":5383,"County":"Los Angeles","ZIP":90638,"City":"La Mirada","CIscore":30.13,"CIscoreP":"60","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":23.95,"DPM_pctl":73,"DrinkingWa":344.04,"DW_pctl":"36","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5577.83,"TR_pctl":83,"Traffic":586.19,"Traff_Pctl":"40","Cleanups":1.25,"Clean_Pctl":20,"Groundwate":2.8,"GW_pctl":16,"Haz_Waste":0.26,"Haz_pctl":66,"Imp__Water":2,"IWB_pctl":29,"Solid_Wast":1.25,"Solid_pctl":37,"PollutionS":5.53,"Poll_pctl":58,"Asthma":40.72,"Asthma_Pct":43,"Low_Birth_":5.81,"LBW_pctl":"73","Cardiovasc":11.25,"CVD_pctl":85,"Education":10.2,"Edu_pctl":"40","Linguistic":8.2,"Ling_pctl":"52","Poverty":12.4,"Pov_pctl":"11","Unemployme":6.5,"Unem_pctl":"25","Housing_Bu":21,"HB_pctl":"63","PopCharSco":5.45,"Pop_Pctl":"54","Children__":11.6,"Pop_11_64_":75.9,"Elderly___":12.5,"Hispanic__":"43.1","White____":"41.5","African_Am":"2.1","Native_Ame":"0.4","Asian_Amer":"10.6","Other____":"2.3","Shape_Leng":5435.3912489,"Shape_Area":1544055.46461}},{"arcs":[[-848,853,854,-840,855]],"type":"Polygon","properties":{"Tract_1":6037503901,"Percentile":"41-45%","Population":2702,"County":"Los Angeles","ZIP":90638,"City":"La Mirada","CIscore":21.6,"CIscoreP":"42","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":24.51,"DPM_pctl":75,"DrinkingWa":201.92,"DW_pctl":"15","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5947.49,"TR_pctl":84,"Traffic":547.71,"Traff_Pctl":"36","Cleanups":0.8,"Clean_Pctl":11,"Groundwate":6.5,"GW_pctl":38,"Haz_Waste":0.74,"Haz_pctl":83,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.54,"Poll_pctl":59,"Asthma":38.62,"Asthma_Pct":40,"Low_Birth_":2.58,"LBW_pctl":"5","Cardiovasc":10.42,"CVD_pctl":78,"Education":10.9,"Edu_pctl":"42","Linguistic":5.8,"Ling_pctl":"41","Poverty":15,"Pov_pctl":"16","Unemployme":10.3,"Unem_pctl":"58","Housing_Bu":10.4,"HB_pctl":"14","PopCharSco":3.9,"Pop_Pctl":"31","Children__":11.7,"Pop_11_64_":74.1,"Elderly___":14.2,"Hispanic__":"42.6","White____":"38.2","African_Am":"1.9","Native_Ame":"0.5","Asian_Amer":"14.3","Other____":"2.4","Shape_Leng":4931.4649204,"Shape_Area":911351.8001}},{"arcs":[[-851,856,857]],"type":"Polygon","properties":{"Tract_1":6037504101,"Percentile":"86-90%","Population":5126,"County":"Los Angeles","ZIP":90638,"City":"La Mirada","CIscore":47.96,"CIscoreP":"87","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":25.56,"DPM_pctl":77,"DrinkingWa":490.84,"DW_pctl":"52","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5476.35,"TR_pctl":82,"Traffic":609.88,"Traff_Pctl":"43","Cleanups":14,"Clean_Pctl":75,"Groundwate":6.1,"GW_pctl":37,"Haz_Waste":0.88,"Haz_pctl":85,"Imp__Water":2,"IWB_pctl":29,"Solid_Wast":8.5,"Solid_pctl":86,"PollutionS":6.98,"Poll_pctl":86,"Asthma":39.28,"Asthma_Pct":41,"Low_Birth_":7.23,"LBW_pctl":"92","Cardiovasc":10.78,"CVD_pctl":81,"Education":26.3,"Edu_pctl":"72","Linguistic":18.2,"Ling_pctl":"81","Poverty":30.6,"Pov_pctl":"46","Unemployme":8.2,"Unem_pctl":"41","Housing_Bu":21.5,"HB_pctl":"65","PopCharSco":6.87,"Pop_Pctl":"75","Children__":12.2,"Pop_11_64_":74.4,"Elderly___":13.4,"Hispanic__":"67.9","White____":"19.8","African_Am":"1.5","Native_Ame":"0.3","Asian_Amer":"9.3","Other____":"1.2","Shape_Leng":4826.9767526,"Shape_Area":1218779.35822}},{"arcs":[[858,859,860,861,862,863,864]],"type":"Polygon","properties":{"Tract_1":6037980002,"Percentile":"NA","Population":0,"County":"Los Angeles","ZIP":90745,"City":"Carson","CIscore":0,"CIscoreP":"NA","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":34.77,"DPM_pctl":90,"DrinkingWa":0,"DW_pctl":"NA","Pesticides":0.027,"Pest_pctl":12,"Tox_Releas":27288,"TR_pctl":99,"Traffic":1021.83,"Traff_Pctl":"69","Cleanups":105.45,"Clean_Pctl":99,"Groundwate":153.55,"GW_pctl":99,"Haz_Waste":19.27,"Haz_pctl":100,"Imp__Water":22,"IWB_pctl":99,"Solid_Wast":31.3,"Solid_pctl":100,"PollutionS":9.27,"Poll_pctl":100,"Asthma":0,"Asthma_Pct":0,"Low_Birth_":0,"LBW_pctl":"NA","Cardiovasc":0,"CVD_pctl":0,"Education":0,"Edu_pctl":"NA","Linguistic":0,"Ling_pctl":"NA","Poverty":0,"Pov_pctl":"NA","Unemployme":0,"Unem_pctl":"NA","Housing_Bu":0,"HB_pctl":"NA","PopCharSco":0,"Pop_Pctl":"NA","Children__":0,"Pop_11_64_":100,"Elderly___":0,"Hispanic__":"NA","White____":"NA","African_Am":"NA","Native_Ame":"NA","Asian_Amer":"NA","Other____":"NA","Shape_Leng":11525.1985958,"Shape_Area":6970973.46338}},{"arcs":[[865,866,867,-504,868]],"type":"Polygon","properties":{"Tract_1":6037620002,"Percentile":"41-45%","Population":3609,"County":"Los Angeles","ZIP":90245,"City":"El Segundo","CIscore":21.77,"CIscoreP":"43","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":36.63,"DPM_pctl":91,"DrinkingWa":178.41,"DW_pctl":"13","Pesticides":0.029,"Pest_pctl":13,"Tox_Releas":3739.38,"TR_pctl":76,"Traffic":815.59,"Traff_Pctl":"58","Cleanups":36.65,"Clean_Pctl":93,"Groundwate":17.35,"GW_pctl":66,"Haz_Waste":7.47,"Haz_pctl":98,"Imp__Water":5,"IWB_pctl":55,"Solid_Wast":1,"Solid_pctl":33,"PollutionS":7.22,"Poll_pctl":90,"Asthma":27.04,"Asthma_Pct":20,"Low_Birth_":5.04,"LBW_pctl":"53","Cardiovasc":7.48,"CVD_pctl":44,"Education":3.4,"Edu_pctl":"12","Linguistic":2.8,"Ling_pctl":"21","Poverty":14.9,"Pov_pctl":"16","Unemployme":4.8,"Unem_pctl":"11","Housing_Bu":15.3,"HB_pctl":"36","PopCharSco":3.02,"Pop_Pctl":"19","Children__":10.7,"Pop_11_64_":79.1,"Elderly___":10.2,"Hispanic__":"15.6","White____":"66.1","African_Am":"1.9","Native_Ame":"0.3","Asian_Amer":"11.4","Other____":"4.6","Shape_Leng":4823.47695393,"Shape_Area":1184971.02313}},{"arcs":[[869,870,-473,871]],"type":"Polygon","properties":{"Tract_1":6037542502,"Percentile":"96-100%","Population":4284,"County":"Los Angeles","ZIP":90220,"City":"Compton","CIscore":63.75,"CIscoreP":"98","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":22.48,"DPM_pctl":68,"DrinkingWa":444.63,"DW_pctl":"46","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6050.66,"TR_pctl":85,"Traffic":622.21,"Traff_Pctl":"44","Cleanups":4.5,"Clean_Pctl":42,"Groundwate":18.5,"GW_pctl":68,"Haz_Waste":0.55,"Haz_pctl":78,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":2.75,"Solid_pctl":59,"PollutionS":6.83,"Poll_pctl":84,"Asthma":110.81,"Asthma_Pct":95,"Low_Birth_":9.17,"LBW_pctl":"99","Cardiovasc":12.82,"CVD_pctl":92,"Education":40.9,"Edu_pctl":"88","Linguistic":10.7,"Ling_pctl":"61","Poverty":60.7,"Pov_pctl":"85","Unemployme":20,"Unem_pctl":"95","Housing_Bu":33.5,"HB_pctl":"93","PopCharSco":9.33,"Pop_Pctl":"99","Children__":18.4,"Pop_11_64_":75.1,"Elderly___":6.5,"Hispanic__":"57.1","White____":"0.6","African_Am":"40.4","Native_Ame":"0.6","Asian_Amer":"0.7","Other____":"0.6","Shape_Leng":4328.95688456,"Shape_Area":1002003.72331}},{"arcs":[[872,873,-54,874,875]],"type":"Polygon","properties":{"Tract_1":6037543703,"Percentile":"61-65%","Population":3472,"County":"Los Angeles","ZIP":90745,"City":"Carson","CIscore":32.49,"CIscoreP":"64","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":20.01,"DPM_pctl":62,"DrinkingWa":398.96,"DW_pctl":"42","Pesticides":16.925,"Pest_pctl":63,"Tox_Releas":9579.81,"TR_pctl":93,"Traffic":548.74,"Traff_Pctl":"36","Cleanups":9,"Clean_Pctl":60,"Groundwate":56.5,"GW_pctl":93,"Haz_Waste":2.19,"Haz_pctl":92,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":1.4,"Solid_pctl":37,"PollutionS":6.93,"Poll_pctl":86,"Asthma":45.95,"Asthma_Pct":51,"Low_Birth_":2.56,"LBW_pctl":"5","Cardiovasc":7.46,"CVD_pctl":43,"Education":23.4,"Edu_pctl":"68","Linguistic":7.3,"Ling_pctl":"48","Poverty":28.8,"Pov_pctl":"43","Unemployme":14.4,"Unem_pctl":"82","Housing_Bu":17.2,"HB_pctl":"46","PopCharSco":4.69,"Pop_Pctl":"43","Children__":11.5,"Pop_11_64_":76.6,"Elderly___":11.9,"Hispanic__":"57.7","White____":"10.1","African_Am":"5","Native_Ame":"0.1","Asian_Amer":"24.6","Other____":"2.5","Shape_Leng":4139.3413396,"Shape_Area":1036758.77153}},{"arcs":[[876,877,878,879,880]],"type":"Polygon","properties":{"Tract_1":6037571000,"Percentile":"36-40%","Population":5747,"County":"Los Angeles","ZIP":90713,"City":"Lakewood","CIscore":19.25,"CIscoreP":"36","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":12.89,"DPM_pctl":38,"DrinkingWa":314.99,"DW_pctl":"34","Pesticides":0.82,"Pest_pctl":37,"Tox_Releas":5507.27,"TR_pctl":82,"Traffic":643.4,"Traff_Pctl":"46","Cleanups":2,"Clean_Pctl":27,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":3,"IWB_pctl":41,"Solid_Wast":5,"Solid_pctl":74,"PollutionS":5.2,"Poll_pctl":51,"Asthma":39.47,"Asthma_Pct":41,"Low_Birth_":4.19,"LBW_pctl":"31","Cardiovasc":9.13,"CVD_pctl":65,"Education":9.5,"Edu_pctl":"37","Linguistic":0,"Ling_pctl":"0","Poverty":11.1,"Pov_pctl":"9","Unemployme":10.2,"Unem_pctl":"58","Housing_Bu":12.9,"HB_pctl":"26","PopCharSco":3.7,"Pop_Pctl":"28","Children__":12.1,"Pop_11_64_":75.6,"Elderly___":12.3,"Hispanic__":"23.8","White____":"61.6","African_Am":"2.5","Native_Ame":"0.2","Asian_Amer":"8.2","Other____":"3.6","Shape_Leng":5413.28693646,"Shape_Area":1749056.78716}},{"arcs":[[881,882,-684]],"type":"Polygon","properties":{"Tract_1":6037570204,"Percentile":"91-95%","Population":4130,"County":"Los Angeles","ZIP":90805,"City":"Long Beach","CIscore":55.93,"CIscoreP":"94","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":21.73,"DPM_pctl":66,"DrinkingWa":218.25,"DW_pctl":"17","Pesticides":0.663,"Pest_pctl":35,"Tox_Releas":6767.33,"TR_pctl":88,"Traffic":861.93,"Traff_Pctl":"61","Cleanups":7.7,"Clean_Pctl":54,"Groundwate":46.8,"GW_pctl":90,"Haz_Waste":0.76,"Haz_pctl":84,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":2.5,"Solid_pctl":57,"PollutionS":6.81,"Poll_pctl":84,"Asthma":79.52,"Asthma_Pct":85,"Low_Birth_":6.95,"LBW_pctl":"90","Cardiovasc":9.79,"CVD_pctl":73,"Education":26,"Edu_pctl":"71","Linguistic":10.6,"Ling_pctl":"61","Poverty":49.8,"Pov_pctl":"73","Unemployme":19.3,"Unem_pctl":"95","Housing_Bu":25.8,"HB_pctl":"79","PopCharSco":8.21,"Pop_Pctl":"92","Children__":15.7,"Pop_11_64_":73.7,"Elderly___":10.6,"Hispanic__":"53.6","White____":"15.2","African_Am":"16.1","Native_Ame":"0.4","Asian_Amer":"13.4","Other____":"1.2","Shape_Leng":3003.39558526,"Shape_Area":545463.454368}},{"arcs":[[883,884,885,886]],"type":"Polygon","properties":{"Tract_1":6037570303,"Percentile":"81-85%","Population":4247,"County":"Los Angeles","ZIP":90805,"City":"Long Beach","CIscore":46.38,"CIscoreP":"85","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":29.03,"DPM_pctl":83,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":2.268,"Pest_pctl":46,"Tox_Releas":5841.7,"TR_pctl":84,"Traffic":539.62,"Traff_Pctl":"35","Cleanups":0.8,"Clean_Pctl":11,"Groundwate":11.05,"GW_pctl":52,"Haz_Waste":0.01,"Haz_pctl":9,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":1.75,"Solid_pctl":41,"PollutionS":5.83,"Poll_pctl":65,"Asthma":87.58,"Asthma_Pct":88,"Low_Birth_":6.02,"LBW_pctl":"77","Cardiovasc":10.71,"CVD_pctl":81,"Education":31.9,"Edu_pctl":"79","Linguistic":10.2,"Ling_pctl":"60","Poverty":65.2,"Pov_pctl":"89","Unemployme":10.3,"Unem_pctl":"58","Housing_Bu":23.3,"HB_pctl":"72","PopCharSco":7.96,"Pop_Pctl":"89","Children__":18.2,"Pop_11_64_":77,"Elderly___":4.8,"Hispanic__":"62.8","White____":"8.5","African_Am":"15.2","Native_Ame":"0.3","Asian_Amer":"11.4","Other____":"1.8","Shape_Leng":3523.04407734,"Shape_Area":615911.053052}},{"arcs":[[-659,887,-662,888]],"type":"Polygon","properties":{"Tract_1":6037555104,"Percentile":"56-60%","Population":4239,"County":"Los Angeles","ZIP":90715,"City":"Lakewood","CIscore":28.55,"CIscoreP":"57","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":12.6,"DPM_pctl":37,"DrinkingWa":335.54,"DW_pctl":"35","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5873.21,"TR_pctl":84,"Traffic":490.31,"Traff_Pctl":"30","Cleanups":1,"Clean_Pctl":18,"Groundwate":14,"GW_pctl":59,"Haz_Waste":0.51,"Haz_pctl":77,"Imp__Water":8,"IWB_pctl":76,"Solid_Wast":0.4,"Solid_pctl":12,"PollutionS":5.43,"Poll_pctl":56,"Asthma":41,"Asthma_Pct":44,"Low_Birth_":5.08,"LBW_pctl":"54","Cardiovasc":6.36,"CVD_pctl":28,"Education":22.5,"Edu_pctl":"66","Linguistic":11.6,"Ling_pctl":"65","Poverty":35.5,"Pov_pctl":"53","Unemployme":11,"Unem_pctl":"63","Housing_Bu":17.6,"HB_pctl":"49","PopCharSco":5.26,"Pop_Pctl":"51","Children__":13.4,"Pop_11_64_":76.8,"Elderly___":9.8,"Hispanic__":"46.4","White____":"17.6","African_Am":"5","Native_Ame":"0.3","Asian_Amer":"29","Other____":"1.8","Shape_Leng":3841.02083307,"Shape_Area":879262.070317}},{"arcs":[[889,890,891,892,893]],"type":"Polygon","properties":{"Tract_1":6037570502,"Percentile":"96-100%","Population":6616,"County":"Los Angeles","ZIP":90805,"City":"Long Beach","CIscore":69.77,"CIscoreP":"99","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":24.22,"DPM_pctl":74,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":6.995,"Pest_pctl":55,"Tox_Releas":6181.98,"TR_pctl":86,"Traffic":1191.12,"Traff_Pctl":"75","Cleanups":14,"Clean_Pctl":75,"Groundwate":78,"GW_pctl":96,"Haz_Waste":1.75,"Haz_pctl":91,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":8.5,"Solid_pctl":86,"PollutionS":8.25,"Poll_pctl":97,"Asthma":87.58,"Asthma_Pct":88,"Low_Birth_":7.45,"LBW_pctl":"94","Cardiovasc":10.71,"CVD_pctl":81,"Education":37.1,"Edu_pctl":"84","Linguistic":13.3,"Ling_pctl":"70","Poverty":45.2,"Pov_pctl":"67","Unemployme":15.8,"Unem_pctl":"87","Housing_Bu":22.4,"HB_pctl":"68","PopCharSco":8.46,"Pop_Pctl":"94","Children__":17,"Pop_11_64_":76.9,"Elderly___":6.1,"Hispanic__":"54.8","White____":"11","African_Am":"13.9","Native_Ame":"0.3","Asian_Amer":"17.7","Other____":"2.3","Shape_Leng":6077.96475461,"Shape_Area":1995466.12375}},{"arcs":[[894,895,896,897,898,899,900,-192]],"type":"Polygon","properties":{"Tract_1":6037570402,"Percentile":"96-100%","Population":3496,"County":"Los Angeles","ZIP":90805,"City":"Long Beach","CIscore":62.14,"CIscoreP":"97","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":29.03,"DPM_pctl":83,"DrinkingWa":208.03,"DW_pctl":"16","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6219.14,"TR_pctl":86,"Traffic":2895.06,"Traff_Pctl":"97","Cleanups":11.1,"Clean_Pctl":65,"Groundwate":25.3,"GW_pctl":78,"Haz_Waste":1.23,"Haz_pctl":88,"Imp__Water":9,"IWB_pctl":81,"Solid_Wast":6.25,"Solid_pctl":79,"PollutionS":7.86,"Poll_pctl":95,"Asthma":79.96,"Asthma_Pct":85,"Low_Birth_":7.28,"LBW_pctl":"93","Cardiovasc":9.9,"CVD_pctl":74,"Education":22.7,"Edu_pctl":"67","Linguistic":9.5,"Ling_pctl":"57","Poverty":43.3,"Pov_pctl":"65","Unemployme":14.3,"Unem_pctl":"82","Housing_Bu":23.7,"HB_pctl":"73","PopCharSco":7.91,"Pop_Pctl":"89","Children__":13.1,"Pop_11_64_":78.6,"Elderly___":8.3,"Hispanic__":"44.7","White____":"6.8","African_Am":"37.8","Native_Ame":"0.2","Asian_Amer":"8.1","Other____":"2.4","Shape_Leng":6416.72150321,"Shape_Area":1529806.9391}},{"arcs":[[901,902,903,-834,904,-893]],"type":"Polygon","properties":{"Tract_1":6037570501,"Percentile":"91-95%","Population":7419,"County":"Los Angeles","ZIP":90805,"City":"Long Beach","CIscore":53.62,"CIscoreP":"92","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":29.03,"DPM_pctl":83,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":22.294,"Pest_pctl":65,"Tox_Releas":5972.48,"TR_pctl":85,"Traffic":555.96,"Traff_Pctl":"37","Cleanups":9,"Clean_Pctl":60,"Groundwate":21.75,"GW_pctl":73,"Haz_Waste":2.12,"Haz_pctl":92,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":7.08,"Poll_pctl":88,"Asthma":87.58,"Asthma_Pct":88,"Low_Birth_":7.56,"LBW_pctl":"95","Cardiovasc":10.71,"CVD_pctl":81,"Education":26.7,"Edu_pctl":"72","Linguistic":14.2,"Ling_pctl":"73","Poverty":37.7,"Pov_pctl":"56","Unemployme":7.8,"Unem_pctl":"37","Housing_Bu":18.6,"HB_pctl":"53","PopCharSco":7.57,"Pop_Pctl":"84","Children__":15.5,"Pop_11_64_":78.3,"Elderly___":6.2,"Hispanic__":"55.3","White____":"11.7","African_Am":"16","Native_Ame":"0.2","Asian_Amer":"14.4","Other____":"2.5","Shape_Leng":5128.39552536,"Shape_Area":1481858.04054}},{"arcs":[[-811,905,-189,906,907,908]],"type":"Polygon","properties":{"Tract_1":6037570603,"Percentile":"91-95%","Population":4435,"County":"Los Angeles","ZIP":90805,"City":"Long Beach","CIscore":53.43,"CIscoreP":"92","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":21.73,"DPM_pctl":66,"DrinkingWa":282.6,"DW_pctl":"29","Pesticides":0.37,"Pest_pctl":30,"Tox_Releas":5509.62,"TR_pctl":82,"Traffic":659.54,"Traff_Pctl":"47","Cleanups":7,"Clean_Pctl":52,"Groundwate":38.5,"GW_pctl":87,"Haz_Waste":0.85,"Haz_pctl":85,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":10,"Solid_pctl":89,"PollutionS":6.73,"Poll_pctl":83,"Asthma":72.65,"Asthma_Pct":80,"Low_Birth_":7.73,"LBW_pctl":"95","Cardiovasc":9.04,"CVD_pctl":64,"Education":18,"Edu_pctl":"58","Linguistic":6.2,"Ling_pctl":"43","Poverty":63.6,"Pov_pctl":"88","Unemployme":15.5,"Unem_pctl":"86","Housing_Bu":32.2,"HB_pctl":"91","PopCharSco":7.94,"Pop_Pctl":"89","Children__":19.8,"Pop_11_64_":73.5,"Elderly___":6.7,"Hispanic__":"23.6","White____":"9.7","African_Am":"54.8","Native_Ame":"0.2","Asian_Amer":"8.5","Other____":"3.3","Shape_Leng":3811.11376539,"Shape_Area":734085.039441}},{"arcs":[[909,-896,910,911,912,913,-903,-884]],"type":"Polygon","properties":{"Tract_1":6037570301,"Percentile":"96-100%","Population":7330,"County":"Los Angeles","ZIP":90805,"City":"Long Beach","CIscore":67.72,"CIscoreP":"99","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":29.03,"DPM_pctl":83,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":4.419,"Pest_pctl":52,"Tox_Releas":6085.24,"TR_pctl":85,"Traffic":1554.95,"Traff_Pctl":"84","Cleanups":9.1,"Clean_Pctl":60,"Groundwate":8.55,"GW_pctl":44,"Haz_Waste":2.04,"Haz_pctl":92,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":1.75,"Solid_pctl":41,"PollutionS":7.65,"Poll_pctl":94,"Asthma":87.56,"Asthma_Pct":88,"Low_Birth_":7.08,"LBW_pctl":"91","Cardiovasc":10.71,"CVD_pctl":81,"Education":49.9,"Edu_pctl":"94","Linguistic":15.9,"Ling_pctl":"77","Poverty":52.6,"Pov_pctl":"76","Unemployme":14.8,"Unem_pctl":"84","Housing_Bu":30.7,"HB_pctl":"89","PopCharSco":8.85,"Pop_Pctl":"97","Children__":17.5,"Pop_11_64_":78,"Elderly___":4.5,"Hispanic__":"64.5","White____":"7.1","African_Am":"17.7","Native_Ame":"0.2","Asian_Amer":"8.9","Other____":"1.6","Shape_Leng":5754.19565644,"Shape_Area":1198512.27856}},{"arcs":[[-907,-188,914,915,916]],"type":"Polygon","properties":{"Tract_1":6037570602,"Percentile":"91-95%","Population":6356,"County":"Los Angeles","ZIP":90805,"City":"Long Beach","CIscore":56.26,"CIscoreP":"94","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":26.67,"DPM_pctl":80,"DrinkingWa":279.74,"DW_pctl":"29","Pesticides":7.037,"Pest_pctl":55,"Tox_Releas":5525.23,"TR_pctl":82,"Traffic":622.83,"Traff_Pctl":"44","Cleanups":1.75,"Clean_Pctl":24,"Groundwate":13.5,"GW_pctl":58,"Haz_Waste":0.46,"Haz_pctl":75,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":2.8,"Solid_pctl":59,"PollutionS":6.95,"Poll_pctl":86,"Asthma":87.58,"Asthma_Pct":88,"Low_Birth_":6.7,"LBW_pctl":"87","Cardiovasc":10.71,"CVD_pctl":81,"Education":29.7,"Edu_pctl":"76","Linguistic":11.4,"Ling_pctl":"64","Poverty":45.5,"Pov_pctl":"68","Unemployme":13.5,"Unem_pctl":"78","Housing_Bu":22,"HB_pctl":"67","PopCharSco":8.1,"Pop_Pctl":"91","Children__":14.8,"Pop_11_64_":78,"Elderly___":7.2,"Hispanic__":"45.8","White____":"11.2","African_Am":"11.5","Native_Ame":"0.2","Asian_Amer":"28.9","Other____":"2.3","Shape_Leng":4408.23097076,"Shape_Area":1042216.69473}},{"arcs":[[-886,917,918,919]],"type":"Polygon","properties":{"Tract_1":6037570304,"Percentile":"86-90%","Population":5171,"County":"Los Angeles","ZIP":90805,"City":"Long Beach","CIscore":49.41,"CIscoreP":"88","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":29.03,"DPM_pctl":83,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0.085,"Pest_pctl":20,"Tox_Releas":5808.79,"TR_pctl":84,"Traffic":597.82,"Traff_Pctl":"41","Cleanups":4.2,"Clean_Pctl":40,"Groundwate":20.25,"GW_pctl":71,"Haz_Waste":0.08,"Haz_pctl":31,"Imp__Water":12,"IWB_pctl":91,"Solid_Wast":1.75,"Solid_pctl":41,"PollutionS":6.32,"Poll_pctl":76,"Asthma":87.58,"Asthma_Pct":88,"Low_Birth_":4.48,"LBW_pctl":"38","Cardiovasc":10.71,"CVD_pctl":81,"Education":36.9,"Edu_pctl":"84","Linguistic":11.9,"Ling_pctl":"66","Poverty":58.7,"Pov_pctl":"83","Unemployme":14.4,"Unem_pctl":"82","Housing_Bu":33.4,"HB_pctl":"93","PopCharSco":7.81,"Pop_Pctl":"87","Children__":19.8,"Pop_11_64_":75.8,"Elderly___":4.4,"Hispanic__":"63.4","White____":"7.3","African_Am":"18.4","Native_Ame":"0.3","Asian_Amer":"8.4","Other____":"2.3","Shape_Leng":4200.78278601,"Shape_Area":567840.021863}},{"arcs":[[920,-857,921,922,923,924,925,926,927,928,-26,929,930,931,932]],"type":"Polygon","properties":{"Tract_1":6037504102,"Percentile":"NA","Population":22,"County":"Los Angeles","ZIP":90670,"City":"Santa Fe Springs","CIscore":0,"CIscoreP":"NA","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":28.73,"DPM_pctl":83,"DrinkingWa":594.5,"DW_pctl":"64","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5630.1,"TR_pctl":83,"Traffic":1126.24,"Traff_Pctl":"73","Cleanups":57.2,"Clean_Pctl":97,"Groundwate":56,"GW_pctl":93,"Haz_Waste":4.68,"Haz_pctl":96,"Imp__Water":2,"IWB_pctl":29,"Solid_Wast":18.5,"Solid_pctl":97,"PollutionS":8.37,"Poll_pctl":98,"Asthma":33.6,"Asthma_Pct":31,"Low_Birth_":0,"LBW_pctl":"NA","Cardiovasc":7.11,"CVD_pctl":39,"Education":0,"Edu_pctl":"NA","Linguistic":0,"Ling_pctl":"NA","Poverty":0,"Pov_pctl":"NA","Unemployme":0,"Unem_pctl":"NA","Housing_Bu":0,"HB_pctl":"NA","PopCharSco":0,"Pop_Pctl":"NA","Children__":9,"Pop_11_64_":91,"Elderly___":0,"Hispanic__":"31.8","White____":"22.7","African_Am":"27.3","Native_Ame":"0","Asian_Amer":"18.2","Other____":"0","Shape_Leng":18666.2736091,"Shape_Area":6470621.30051}},{"arcs":[[933,-868]],"type":"Polygon","properties":{"Tract_1":6037620102,"Percentile":"21-25%","Population":3617,"County":"Los Angeles","ZIP":90245,"City":"El Segundo","CIscore":14.4,"CIscoreP":"23","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":36.63,"DPM_pctl":91,"DrinkingWa":397.55,"DW_pctl":"42","Pesticides":0,"Pest_pctl":0,"Tox_Releas":3241.77,"TR_pctl":74,"Traffic":624.32,"Traff_Pctl":"44","Cleanups":9.15,"Clean_Pctl":60,"Groundwate":20.8,"GW_pctl":72,"Haz_Waste":7.71,"Haz_pctl":99,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":1.25,"Solid_pctl":37,"PollutionS":7.08,"Poll_pctl":88,"Asthma":24.63,"Asthma_Pct":15,"Low_Birth_":3.66,"LBW_pctl":"19","Cardiovasc":6.81,"CVD_pctl":35,"Education":4.6,"Edu_pctl":"18","Linguistic":2.6,"Ling_pctl":"19","Poverty":15.4,"Pov_pctl":"17","Unemployme":6.3,"Unem_pctl":"23","Housing_Bu":6.5,"HB_pctl":"4","PopCharSco":2.03,"Pop_Pctl":"8","Children__":9.9,"Pop_11_64_":80.9,"Elderly___":9.2,"Hispanic__":"14.1","White____":"71.5","African_Am":"1.9","Native_Ame":"0.3","Asian_Amer":"7.8","Other____":"4.5","Shape_Leng":4880.10769081,"Shape_Area":873432.456911}},{"arcs":[[934,935,936,937,938]],"type":"Polygon","properties":{"Tract_1":6037293301,"Percentile":"26-30%","Population":2805,"County":"Los Angeles","ZIP":90710,"City":"Harbor City","CIscore":16.28,"CIscoreP":"28","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":19.1,"DPM_pctl":59,"DrinkingWa":195.26,"DW_pctl":"15","Pesticides":0,"Pest_pctl":0,"Tox_Releas":7739.1,"TR_pctl":90,"Traffic":677.97,"Traff_Pctl":"48","Cleanups":9.8,"Clean_Pctl":62,"Groundwate":8,"GW_pctl":43,"Haz_Waste":0.55,"Haz_pctl":79,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":1.7,"Solid_pctl":40,"PollutionS":5.5,"Poll_pctl":58,"Asthma":36.22,"Asthma_Pct":36,"Low_Birth_":3.17,"LBW_pctl":"11","Cardiovasc":6.05,"CVD_pctl":25,"Education":7.5,"Edu_pctl":"30","Linguistic":5,"Ling_pctl":"36","Poverty":20.8,"Pov_pctl":"28","Unemployme":7.8,"Unem_pctl":"37","Housing_Bu":14.8,"HB_pctl":"34","PopCharSco":2.96,"Pop_Pctl":"18","Children__":9.3,"Pop_11_64_":70.6,"Elderly___":20.1,"Hispanic__":"20.6","White____":"28","African_Am":"7.5","Native_Ame":"0.1","Asian_Amer":"40.4","Other____":"3.4","Shape_Leng":4328.25196891,"Shape_Area":837072.266461}},{"arcs":[[939,940,941,942]],"type":"Polygon","properties":{"Tract_1":6037541606,"Percentile":"96-100%","Population":2506,"County":"Los Angeles","ZIP":90221,"City":"Compton","CIscore":58.18,"CIscoreP":"96","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":18.7,"DPM_pctl":58,"DrinkingWa":444.63,"DW_pctl":"46","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5913.24,"TR_pctl":84,"Traffic":564.74,"Traff_Pctl":"38","Cleanups":1.6,"Clean_Pctl":23,"Groundwate":29.6,"GW_pctl":81,"Haz_Waste":2.61,"Haz_pctl":94,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":5,"Solid_pctl":74,"PollutionS":6.31,"Poll_pctl":75,"Asthma":87.61,"Asthma_Pct":88,"Low_Birth_":5.48,"LBW_pctl":"65","Cardiovasc":13.56,"CVD_pctl":95,"Education":49.7,"Edu_pctl":"94","Linguistic":30.8,"Ling_pctl":"95","Poverty":68.2,"Pov_pctl":"92","Unemployme":21.5,"Unem_pctl":"97","Housing_Bu":40.9,"HB_pctl":"98","PopCharSco":9.23,"Pop_Pctl":"99","Children__":22.3,"Pop_11_64_":73.4,"Elderly___":4.3,"Hispanic__":"84","White____":"1","African_Am":"14.9","Native_Ame":"0","Asian_Amer":"0","Other____":"0.2","Shape_Leng":2467.10322683,"Shape_Area":337532.168087}},{"arcs":[[943,944,945,946]],"type":"Polygon","properties":{"Tract_1":6037602106,"Percentile":"71-75%","Population":5702,"County":"Los Angeles","ZIP":90250,"City":"Hawthorne","CIscore":39.25,"CIscoreP":"75","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":30.76,"DPM_pctl":86,"DrinkingWa":402.69,"DW_pctl":"42","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5103.6,"TR_pctl":81,"Traffic":850.35,"Traff_Pctl":"60","Cleanups":6.9,"Clean_Pctl":50,"Groundwate":6.6,"GW_pctl":38,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.5,"Solid_pctl":20,"PollutionS":5.48,"Poll_pctl":57,"Asthma":78.54,"Asthma_Pct":84,"Low_Birth_":6.39,"LBW_pctl":"83","Cardiovasc":10.73,"CVD_pctl":81,"Education":18.4,"Edu_pctl":"59","Linguistic":17.7,"Ling_pctl":"80","Poverty":38.6,"Pov_pctl":"58","Unemployme":10,"Unem_pctl":"56","Housing_Bu":12.6,"HB_pctl":"24","PopCharSco":7.16,"Pop_Pctl":"79","Children__":13.7,"Pop_11_64_":78.4,"Elderly___":7.9,"Hispanic__":"55","White____":"11.2","African_Am":"20.2","Native_Ame":"0.3","Asian_Amer":"10.6","Other____":"2.8","Shape_Leng":4046.29989715,"Shape_Area":818587.657507}},{"arcs":[[947,948,949,950,-243]],"type":"Polygon","properties":{"Tract_1":6037602002,"Percentile":"96-100%","Population":3195,"County":"Los Angeles","ZIP":90250,"City":"Hawthorne","CIscore":60.64,"CIscoreP":"97","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":23.9,"DPM_pctl":73,"DrinkingWa":365.26,"DW_pctl":"38","Pesticides":6.279,"Pest_pctl":55,"Tox_Releas":4851.91,"TR_pctl":80,"Traffic":2995.35,"Traff_Pctl":"97","Cleanups":8.85,"Clean_Pctl":57,"Groundwate":20,"GW_pctl":71,"Haz_Waste":0.31,"Haz_pctl":70,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":7.67,"Poll_pctl":94,"Asthma":59.18,"Asthma_Pct":68,"Low_Birth_":6.99,"LBW_pctl":"90","Cardiovasc":7.71,"CVD_pctl":47,"Education":36.4,"Edu_pctl":"83","Linguistic":26.6,"Ling_pctl":"92","Poverty":50.8,"Pov_pctl":"74","Unemployme":15.6,"Unem_pctl":"87","Housing_Bu":28.1,"HB_pctl":"84","PopCharSco":7.91,"Pop_Pctl":"89","Children__":16.2,"Pop_11_64_":78.4,"Elderly___":5.4,"Hispanic__":"76.8","White____":"3.8","African_Am":"14.1","Native_Ame":"0.1","Asian_Amer":"4.2","Other____":"1.1","Shape_Leng":3279.62945854,"Shape_Area":537080.42379}},{"arcs":[[951,952,-493,953]],"type":"Polygon","properties":{"Tract_1":6037603001,"Percentile":"96-100%","Population":7139,"County":"Los Angeles","ZIP":90247,"City":"Gardena","CIscore":58.13,"CIscoreP":"95","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":27.56,"DPM_pctl":81,"DrinkingWa":288.96,"DW_pctl":"31","Pesticides":11.291,"Pest_pctl":59,"Tox_Releas":5896.15,"TR_pctl":84,"Traffic":672.27,"Traff_Pctl":"48","Cleanups":7.65,"Clean_Pctl":54,"Groundwate":25.3,"GW_pctl":78,"Haz_Waste":0.32,"Haz_pctl":70,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":12.6,"Solid_pctl":93,"PollutionS":7.41,"Poll_pctl":92,"Asthma":79.41,"Asthma_Pct":85,"Low_Birth_":5.82,"LBW_pctl":"73","Cardiovasc":10.07,"CVD_pctl":75,"Education":26.6,"Edu_pctl":"72","Linguistic":16,"Ling_pctl":"77","Poverty":50.2,"Pov_pctl":"73","Unemployme":9.9,"Unem_pctl":"55","Housing_Bu":31.4,"HB_pctl":"90","PopCharSco":7.84,"Pop_Pctl":"88","Children__":14.1,"Pop_11_64_":73.9,"Elderly___":12,"Hispanic__":"45.1","White____":"5","African_Am":"27.4","Native_Ame":"0.2","Asian_Amer":"20.2","Other____":"2.1","Shape_Leng":4942.00876397,"Shape_Area":1131655.84633}},{"arcs":[[954,955,-220,956]],"type":"Polygon","properties":{"Tract_1":6037602404,"Percentile":"66-70%","Population":5863,"County":"Los Angeles","ZIP":90250,"City":"Hawthorne","CIscore":35.36,"CIscoreP":"69","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":30.76,"DPM_pctl":86,"DrinkingWa":320,"DW_pctl":"34","Pesticides":0,"Pest_pctl":0,"Tox_Releas":4998.2,"TR_pctl":80,"Traffic":1019.47,"Traff_Pctl":"69","Cleanups":2.1,"Clean_Pctl":28,"Groundwate":0.3,"GW_pctl":2,"Haz_Waste":0.01,"Haz_pctl":9,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":4.98,"Poll_pctl":46,"Asthma":78.54,"Asthma_Pct":84,"Low_Birth_":4.55,"LBW_pctl":"40","Cardiovasc":10.73,"CVD_pctl":81,"Education":25.5,"Edu_pctl":"71","Linguistic":15,"Ling_pctl":"74","Poverty":44.5,"Pov_pctl":"66","Unemployme":9.9,"Unem_pctl":"55","Housing_Bu":24.7,"HB_pctl":"76","PopCharSco":7.1,"Pop_Pctl":"78","Children__":15.2,"Pop_11_64_":77.4,"Elderly___":7.4,"Hispanic__":"58.2","White____":"9.8","African_Am":"18.5","Native_Ame":"0.1","Asian_Amer":"11.3","Other____":"2.1","Shape_Leng":3440.85930871,"Shape_Area":645928.873769}},{"arcs":[[957,958,959,960]],"type":"Polygon","properties":{"Tract_1":6037602403,"Percentile":"86-90%","Population":5230,"County":"Los Angeles","ZIP":90250,"City":"Hawthorne","CIscore":47.36,"CIscoreP":"86","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":30.76,"DPM_pctl":86,"DrinkingWa":320.15,"DW_pctl":"34","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5079.94,"TR_pctl":81,"Traffic":1025.09,"Traff_Pctl":"69","Cleanups":9,"Clean_Pctl":60,"Groundwate":15.75,"GW_pctl":63,"Haz_Waste":0.08,"Haz_pctl":31,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.86,"Poll_pctl":66,"Asthma":78.54,"Asthma_Pct":84,"Low_Birth_":6.64,"LBW_pctl":"87","Cardiovasc":10.73,"CVD_pctl":81,"Education":24.5,"Edu_pctl":"69","Linguistic":19.1,"Ling_pctl":"83","Poverty":52.3,"Pov_pctl":"76","Unemployme":11.2,"Unem_pctl":"65","Housing_Bu":22,"HB_pctl":"67","PopCharSco":8.08,"Pop_Pctl":"90","Children__":15.7,"Pop_11_64_":77.4,"Elderly___":6.9,"Hispanic__":"59.7","White____":"8.5","African_Am":"20.8","Native_Ame":"0.2","Asian_Amer":"8.6","Other____":"2.1","Shape_Leng":3066.60507282,"Shape_Area":587435.052982}},{"arcs":[[961,-519,962,-945]],"type":"Polygon","properties":{"Tract_1":6037602402,"Percentile":"71-75%","Population":6769,"County":"Los Angeles","ZIP":90250,"City":"Hawthorne","CIscore":36.55,"CIscoreP":"71","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":30.76,"DPM_pctl":86,"DrinkingWa":319.98,"DW_pctl":"34","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5168.11,"TR_pctl":81,"Traffic":907.43,"Traff_Pctl":"63","Cleanups":3.55,"Clean_Pctl":35,"Groundwate":4.9,"GW_pctl":29,"Haz_Waste":0.02,"Haz_pctl":16,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.19,"Poll_pctl":51,"Asthma":78.37,"Asthma_Pct":84,"Low_Birth_":5.02,"LBW_pctl":"53","Cardiovasc":10.71,"CVD_pctl":81,"Education":29,"Edu_pctl":"75","Linguistic":16.3,"Ling_pctl":"78","Poverty":45.5,"Pov_pctl":"68","Unemployme":9.3,"Unem_pctl":"50","Housing_Bu":17.2,"HB_pctl":"46","PopCharSco":7.04,"Pop_Pctl":"77","Children__":13.5,"Pop_11_64_":76.6,"Elderly___":9.9,"Hispanic__":"58.5","White____":"19.6","African_Am":"10.1","Native_Ame":"0.2","Asian_Amer":"9","Other____":"2.5","Shape_Leng":5329.48572919,"Shape_Area":1318119.34956}},{"arcs":[[963,964,965,966]],"type":"Polygon","properties":{"Tract_1":6037600602,"Percentile":"71-75%","Population":2551,"County":"Los Angeles","ZIP":90303,"City":"Inglewood","CIscore":39.21,"CIscoreP":"75","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":18.08,"DPM_pctl":55,"DrinkingWa":203.35,"DW_pctl":"15","Pesticides":0.069,"Pest_pctl":18,"Tox_Releas":4751.91,"TR_pctl":79,"Traffic":836.81,"Traff_Pctl":"59","Cleanups":0.25,"Clean_Pctl":5,"Groundwate":3,"GW_pctl":22,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.31,"Poll_pctl":32,"Asthma":103.72,"Asthma_Pct":93,"Low_Birth_":8.79,"LBW_pctl":"99","Cardiovasc":12.12,"CVD_pctl":89,"Education":38.6,"Edu_pctl":"86","Linguistic":14,"Ling_pctl":"72","Poverty":75,"Pov_pctl":"96","Unemployme":9.8,"Unem_pctl":"54","Housing_Bu":44.1,"HB_pctl":"99","PopCharSco":9.09,"Pop_Pctl":"98","Children__":19.8,"Pop_11_64_":75.8,"Elderly___":4.4,"Hispanic__":"62.9","White____":"0.6","African_Am":"33.7","Native_Ame":"0.2","Asian_Amer":"0.5","Other____":"2","Shape_Leng":3309.93224337,"Shape_Area":690939.044882}},{"arcs":[[-14,967,968,969,970,971,972,973]],"type":"Polygon","properties":{"Tract_1":6037542402,"Percentile":"96-100%","Population":3152,"County":"Los Angeles","ZIP":90221,"City":"Compton","CIscore":61.84,"CIscoreP":"97","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":32.55,"DPM_pctl":88,"DrinkingWa":444.29,"DW_pctl":"46","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6332.77,"TR_pctl":86,"Traffic":1290.68,"Traff_Pctl":"78","Cleanups":18.45,"Clean_Pctl":82,"Groundwate":53.3,"GW_pctl":92,"Haz_Waste":2.23,"Haz_pctl":93,"Imp__Water":9,"IWB_pctl":81,"Solid_Wast":6.75,"Solid_pctl":81,"PollutionS":8.34,"Poll_pctl":98,"Asthma":79.51,"Asthma_Pct":85,"Low_Birth_":4.77,"LBW_pctl":"46","Cardiovasc":12.17,"CVD_pctl":89,"Education":37.5,"Edu_pctl":"85","Linguistic":9.9,"Ling_pctl":"59","Poverty":40.7,"Pov_pctl":"61","Unemployme":16.3,"Unem_pctl":"88","Housing_Bu":19.3,"HB_pctl":"56","PopCharSco":7.42,"Pop_Pctl":"82","Children__":16.2,"Pop_11_64_":75.6,"Elderly___":8.2,"Hispanic__":"55.4","White____":"1.5","African_Am":"39.6","Native_Ame":"0","Asian_Amer":"2","Other____":"1.5","Shape_Leng":5760.12580233,"Shape_Area":1565171.81275}},{"arcs":[[974,975,-463,976,977,978,979,980,981]],"type":"Polygon","properties":{"Tract_1":6037543100,"Percentile":"96-100%","Population":6759,"County":"Los Angeles","ZIP":90220,"City":"Compton","CIscore":64.64,"CIscoreP":"98","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":32.85,"DPM_pctl":88,"DrinkingWa":502.09,"DW_pctl":"53","Pesticides":0.076,"Pest_pctl":19,"Tox_Releas":6899.51,"TR_pctl":88,"Traffic":1102.68,"Traff_Pctl":"72","Cleanups":22.5,"Clean_Pctl":85,"Groundwate":11.35,"GW_pctl":53,"Haz_Waste":12.79,"Haz_pctl":100,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":13.5,"Solid_pctl":94,"PollutionS":8.32,"Poll_pctl":98,"Asthma":90.19,"Asthma_Pct":89,"Low_Birth_":6.11,"LBW_pctl":"78","Cardiovasc":10.33,"CVD_pctl":77,"Education":29.5,"Edu_pctl":"76","Linguistic":11,"Ling_pctl":"62","Poverty":35.5,"Pov_pctl":"53","Unemployme":11.7,"Unem_pctl":"68","Housing_Bu":26.6,"HB_pctl":"81","PopCharSco":7.77,"Pop_Pctl":"87","Children__":15.1,"Pop_11_64_":73.5,"Elderly___":11.4,"Hispanic__":"49.6","White____":"0.7","African_Am":"47.9","Native_Ame":"0.2","Asian_Amer":"0.6","Other____":"1","Shape_Leng":7787.83453024,"Shape_Area":2891017.58674}},{"arcs":[[982,983,984,985,986,987,988,989]],"type":"Polygon","properties":{"Tract_1":6037553300,"Percentile":"56-60%","Population":3390,"County":"Los Angeles","ZIP":90706,"City":"Bellflower","CIscore":28.45,"CIscoreP":"57","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":20.99,"DPM_pctl":65,"DrinkingWa":364.52,"DW_pctl":"38","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5816.57,"TR_pctl":84,"Traffic":678.79,"Traff_Pctl":"48","Cleanups":0.1,"Clean_Pctl":2,"Groundwate":5.25,"GW_pctl":32,"Haz_Waste":0.57,"Haz_pctl":80,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.12,"Poll_pctl":50,"Asthma":71.62,"Asthma_Pct":80,"Low_Birth_":4.07,"LBW_pctl":"28","Cardiovasc":10.17,"CVD_pctl":76,"Education":27,"Edu_pctl":"73","Linguistic":9.4,"Ling_pctl":"57","Poverty":42.8,"Pov_pctl":"64","Unemployme":7.1,"Unem_pctl":"30","Housing_Bu":7.8,"HB_pctl":"6","PopCharSco":5.55,"Pop_Pctl":"55","Children__":12.2,"Pop_11_64_":76.3,"Elderly___":11.5,"Hispanic__":"59.2","White____":"19.8","African_Am":"6.7","Native_Ame":"0.2","Asian_Amer":"12.5","Other____":"1.6","Shape_Leng":4324.05762333,"Shape_Area":839675.267162}},{"arcs":[[990,991,992,993]],"type":"Polygon","properties":{"Tract_1":6037554802,"Percentile":"51-55%","Population":6165,"County":"Los Angeles","ZIP":90701,"City":"Artesia","CIscore":25.95,"CIscoreP":"52","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":23.17,"DPM_pctl":71,"DrinkingWa":364.81,"DW_pctl":"38","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5812.93,"TR_pctl":84,"Traffic":530.28,"Traff_Pctl":"34","Cleanups":0.9,"Clean_Pctl":13,"Groundwate":6.5,"GW_pctl":38,"Haz_Waste":0.02,"Haz_pctl":16,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":4.53,"Poll_pctl":37,"Asthma":36.06,"Asthma_Pct":35,"Low_Birth_":5.41,"LBW_pctl":"64","Cardiovasc":9.49,"CVD_pctl":69,"Education":17.7,"Edu_pctl":"58","Linguistic":13.9,"Ling_pctl":"72","Poverty":31.7,"Pov_pctl":"48","Unemployme":7.6,"Unem_pctl":"35","Housing_Bu":20.4,"HB_pctl":"61","PopCharSco":5.73,"Pop_Pctl":"58","Children__":9.5,"Pop_11_64_":75.5,"Elderly___":15,"Hispanic__":"24.1","White____":"25.4","African_Am":"3.5","Native_Ame":"0.2","Asian_Amer":"44.2","Other____":"2.5","Shape_Leng":5842.15315678,"Shape_Area":1538836.69119}},{"arcs":[[994,995,996,997,998,999,1000,1001,1002,1003,1004,-991]],"type":"Polygon","properties":{"Tract_1":6037554900,"Percentile":"66-70%","Population":6991,"County":"Los Angeles","ZIP":90701,"City":"Artesia","CIscore":35.61,"CIscoreP":"69","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":22.22,"DPM_pctl":67,"DrinkingWa":372.6,"DW_pctl":"39","Pesticides":3.463,"Pest_pctl":50,"Tox_Releas":5850.03,"TR_pctl":84,"Traffic":702.32,"Traff_Pctl":"50","Cleanups":4.5,"Clean_Pctl":42,"Groundwate":13,"GW_pctl":57,"Haz_Waste":0.02,"Haz_pctl":10,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":3.2,"Solid_pctl":63,"PollutionS":6.06,"Poll_pctl":71,"Asthma":34.01,"Asthma_Pct":32,"Low_Birth_":5.53,"LBW_pctl":"66","Cardiovasc":8.88,"CVD_pctl":62,"Education":21.3,"Edu_pctl":"64","Linguistic":20.8,"Ling_pctl":"86","Poverty":29.9,"Pov_pctl":"45","Unemployme":7.1,"Unem_pctl":"30","Housing_Bu":24.3,"HB_pctl":"75","PopCharSco":5.87,"Pop_Pctl":"60","Children__":10.6,"Pop_11_64_":74.5,"Elderly___":14.9,"Hispanic__":"26.6","White____":"24.2","African_Am":"3.5","Native_Ame":"0.3","Asian_Amer":"42.9","Other____":"2.5","Shape_Leng":7853.1645186,"Shape_Area":1756821.09764}},{"arcs":[[1005,1006,1007,-306,1008,1009,1010]],"type":"Polygon","properties":{"Tract_1":6037553400,"Percentile":"56-60%","Population":3861,"County":"Los Angeles","ZIP":90242,"City":"Downey","CIscore":30.12,"CIscoreP":"60","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":20.99,"DPM_pctl":65,"DrinkingWa":363.57,"DW_pctl":"38","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5846.58,"TR_pctl":84,"Traffic":1808.8,"Traff_Pctl":"89","Cleanups":0,"Clean_Pctl":0,"Groundwate":3.75,"GW_pctl":25,"Haz_Waste":0.28,"Haz_pctl":68,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.42,"Poll_pctl":56,"Asthma":38.66,"Asthma_Pct":40,"Low_Birth_":6.38,"LBW_pctl":"83","Cardiovasc":6.72,"CVD_pctl":33,"Education":27.2,"Edu_pctl":"73","Linguistic":5.4,"Ling_pctl":"39","Poverty":40.8,"Pov_pctl":"61","Unemployme":7.8,"Unem_pctl":"37","Housing_Bu":21.6,"HB_pctl":"66","PopCharSco":5.56,"Pop_Pctl":"55","Children__":13.9,"Pop_11_64_":77.5,"Elderly___":8.6,"Hispanic__":"82.6","White____":"9.1","African_Am":"2.3","Native_Ame":"0.4","Asian_Amer":"4.3","Other____":"1.4","Shape_Leng":3579.99911455,"Shape_Area":730169.928331}},{"arcs":[[1011,1012,1013,1014,1015]],"type":"Polygon","properties":{"Tract_1":6037554002,"Percentile":"81-85%","Population":5659,"County":"Los Angeles","ZIP":90706,"City":"Bellflower","CIscore":45.33,"CIscoreP":"83","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":21.03,"DPM_pctl":65,"DrinkingWa":722.86,"DW_pctl":"84","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6942.48,"TR_pctl":88,"Traffic":692.77,"Traff_Pctl":"49","Cleanups":0,"Clean_Pctl":0,"Groundwate":18.75,"GW_pctl":69,"Haz_Waste":0.1,"Haz_pctl":43,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":5.79,"Poll_pctl":64,"Asthma":79.01,"Asthma_Pct":84,"Low_Birth_":6.25,"LBW_pctl":"81","Cardiovasc":11.13,"CVD_pctl":84,"Education":27.8,"Edu_pctl":"74","Linguistic":14.9,"Ling_pctl":"74","Poverty":50.7,"Pov_pctl":"74","Unemployme":7.7,"Unem_pctl":"36","Housing_Bu":27,"HB_pctl":"82","PopCharSco":7.84,"Pop_Pctl":"88","Children__":15.4,"Pop_11_64_":77.2,"Elderly___":7.4,"Hispanic__":"58.3","White____":"16.9","African_Am":"9.7","Native_Ame":"0.1","Asian_Amer":"13.4","Other____":"1.6","Shape_Leng":6255.53764862,"Shape_Area":1272401.22419}},{"arcs":[[1016,1017,1018,1019,1020,1021]],"type":"Polygon","properties":{"Tract_1":6037570601,"Percentile":"81-85%","Population":5421,"County":"Los Angeles","ZIP":90805,"City":"Long Beach","CIscore":45.35,"CIscoreP":"83","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":27.94,"DPM_pctl":82,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":8.816,"Pest_pctl":57,"Tox_Releas":5625.35,"TR_pctl":83,"Traffic":532.05,"Traff_Pctl":"34","Cleanups":0,"Clean_Pctl":0,"Groundwate":4.05,"GW_pctl":27,"Haz_Waste":0.03,"Haz_pctl":16,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":5.42,"Poll_pctl":56,"Asthma":87.58,"Asthma_Pct":88,"Low_Birth_":6.26,"LBW_pctl":"81","Cardiovasc":10.71,"CVD_pctl":81,"Education":37.1,"Edu_pctl":"84","Linguistic":9.7,"Ling_pctl":"58","Poverty":49,"Pov_pctl":"72","Unemployme":15.4,"Unem_pctl":"86","Housing_Bu":30.8,"HB_pctl":"89","PopCharSco":8.36,"Pop_Pctl":"93","Children__":16.4,"Pop_11_64_":78.1,"Elderly___":5.5,"Hispanic__":"57.3","White____":"8.6","African_Am":"17.9","Native_Ame":"0.1","Asian_Amer":"14","Other____":"2.1","Shape_Leng":3758.52254008,"Shape_Area":780289.159513}},{"arcs":[[1022,1023,-803,1024,1025,1026,1027]],"type":"Polygon","properties":{"Tract_1":6037570901,"Percentile":"36-40%","Population":5647,"County":"Los Angeles","ZIP":90713,"City":"Lakewood","CIscore":20.22,"CIscoreP":"39","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":21.84,"DPM_pctl":67,"DrinkingWa":281,"DW_pctl":"29","Pesticides":5.299,"Pest_pctl":53,"Tox_Releas":5821.07,"TR_pctl":84,"Traffic":711.45,"Traff_Pctl":"51","Cleanups":0.9,"Clean_Pctl":13,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.15,"Haz_pctl":54,"Imp__Water":2,"IWB_pctl":29,"Solid_Wast":3.5,"Solid_pctl":65,"PollutionS":5.91,"Poll_pctl":67,"Asthma":37.48,"Asthma_Pct":38,"Low_Birth_":3.64,"LBW_pctl":"19","Cardiovasc":8.95,"CVD_pctl":63,"Education":6.4,"Edu_pctl":"25","Linguistic":5.1,"Ling_pctl":"37","Poverty":14.3,"Pov_pctl":"15","Unemployme":6.5,"Unem_pctl":"25","Housing_Bu":13.6,"HB_pctl":"29","PopCharSco":3.42,"Pop_Pctl":"24","Children__":11.7,"Pop_11_64_":75.4,"Elderly___":12.9,"Hispanic__":"23.9","White____":"56","African_Am":"4","Native_Ame":"0.2","Asian_Amer":"12.4","Other____":"3.5","Shape_Leng":5616.32292657,"Shape_Area":1816387.06558}},{"arcs":[[-801,1028,1029,1030]],"type":"Polygon","properties":{"Tract_1":6037570800,"Percentile":"41-45%","Population":5540,"County":"Los Angeles","ZIP":90712,"City":"Lakewood","CIscore":20.79,"CIscoreP":"40","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":20.98,"DPM_pctl":65,"DrinkingWa":280.77,"DW_pctl":"29","Pesticides":0.469,"Pest_pctl":32,"Tox_Releas":5764.88,"TR_pctl":83,"Traffic":610.2,"Traff_Pctl":"43","Cleanups":0,"Clean_Pctl":0,"Groundwate":13,"GW_pctl":57,"Haz_Waste":0.55,"Haz_pctl":79,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.22,"Poll_pctl":51,"Asthma":48.05,"Asthma_Pct":54,"Low_Birth_":2.7,"LBW_pctl":"6","Cardiovasc":7.93,"CVD_pctl":50,"Education":10.1,"Edu_pctl":"40","Linguistic":2.8,"Ling_pctl":"21","Poverty":24.4,"Pov_pctl":"35","Unemployme":9.5,"Unem_pctl":"52","Housing_Bu":18.8,"HB_pctl":"54","PopCharSco":3.98,"Pop_Pctl":"32","Children__":12.9,"Pop_11_64_":76.7,"Elderly___":10.4,"Hispanic__":"28.3","White____":"50.1","African_Am":"5","Native_Ame":"0.2","Asian_Amer":"12.1","Other____":"4.4","Shape_Leng":6245.459013,"Shape_Area":2401500.92745}},{"arcs":[[1031,1032,-1030,1033,1034,-181]],"type":"Polygon","properties":{"Tract_1":6037571200,"Percentile":"21-25%","Population":7828,"County":"Los Angeles","ZIP":90808,"City":"Long Beach","CIscore":13.93,"CIscoreP":"22","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":18.13,"DPM_pctl":55,"DrinkingWa":282.79,"DW_pctl":"30","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5253.28,"TR_pctl":81,"Traffic":615.95,"Traff_Pctl":"43","Cleanups":6,"Clean_Pctl":48,"Groundwate":37.75,"GW_pctl":87,"Haz_Waste":0.58,"Haz_pctl":80,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.37,"Poll_pctl":55,"Asthma":25.88,"Asthma_Pct":18,"Low_Birth_":4.73,"LBW_pctl":"45","Cardiovasc":6.51,"CVD_pctl":31,"Education":5.4,"Edu_pctl":"21","Linguistic":1.3,"Ling_pctl":"8","Poverty":22,"Pov_pctl":"31","Unemployme":4.5,"Unem_pctl":"9","Housing_Bu":13,"HB_pctl":"26","PopCharSco":2.59,"Pop_Pctl":"14","Children__":9.9,"Pop_11_64_":77.2,"Elderly___":12.9,"Hispanic__":"25","White____":"54.2","African_Am":"6","Native_Ame":"0.3","Asian_Amer":"11.1","Other____":"3.5","Shape_Leng":6520.76455468,"Shape_Area":2618888.09972}},{"arcs":[[1035,-179,1036,1037,1038,1039,1040,-805,-816]],"type":"Polygon","properties":{"Tract_1":6037571400,"Percentile":"36-40%","Population":4770,"County":"Los Angeles","ZIP":90712,"City":"Lakewood","CIscore":20.5,"CIscoreP":"40","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":18.4,"DPM_pctl":56,"DrinkingWa":280.81,"DW_pctl":"29","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5582.17,"TR_pctl":83,"Traffic":647.65,"Traff_Pctl":"46","Cleanups":8.4,"Clean_Pctl":56,"Groundwate":27.75,"GW_pctl":80,"Haz_Waste":0.04,"Haz_pctl":18,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":1.8,"Solid_pctl":41,"PollutionS":5.27,"Poll_pctl":52,"Asthma":54.2,"Asthma_Pct":62,"Low_Birth_":2.86,"LBW_pctl":"7","Cardiovasc":8.76,"CVD_pctl":60,"Education":12.6,"Edu_pctl":"47","Linguistic":4.1,"Ling_pctl":"31","Poverty":22,"Pov_pctl":"31","Unemployme":7.7,"Unem_pctl":"36","Housing_Bu":10.6,"HB_pctl":"15","PopCharSco":3.89,"Pop_Pctl":"31","Children__":12.2,"Pop_11_64_":75.5,"Elderly___":12.3,"Hispanic__":"27.3","White____":"43.2","African_Am":"10.1","Native_Ame":"0.4","Asian_Amer":"15.3","Other____":"3.6","Shape_Leng":9760.87560848,"Shape_Area":2159383.26961}},{"arcs":[[1041,1042,1043,1044,1045,1046,1047]],"type":"Polygon","properties":{"Tract_1":6037573401,"Percentile":"71-75%","Population":1439,"County":"Los Angeles","ZIP":90755,"City":"Signal Hill","CIscore":38.94,"CIscoreP":"74","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":24.26,"DPM_pctl":74,"DrinkingWa":296.74,"DW_pctl":"32","Pesticides":0,"Pest_pctl":0,"Tox_Releas":16622.73,"TR_pctl":97,"Traffic":2106.79,"Traff_Pctl":"92","Cleanups":11,"Clean_Pctl":65,"Groundwate":30.6,"GW_pctl":82,"Haz_Waste":0.44,"Haz_pctl":74,"Imp__Water":11,"IWB_pctl":90,"Solid_Wast":11,"Solid_pctl":91,"PollutionS":7.91,"Poll_pctl":96,"Asthma":40.65,"Asthma_Pct":43,"Low_Birth_":4.72,"LBW_pctl":"44","Cardiovasc":7.73,"CVD_pctl":47,"Education":16.8,"Edu_pctl":"56","Linguistic":8.4,"Ling_pctl":"53","Poverty":33.5,"Pov_pctl":"50","Unemployme":8.3,"Unem_pctl":"41","Housing_Bu":18,"HB_pctl":"50","PopCharSco":4.92,"Pop_Pctl":"46","Children__":14.9,"Pop_11_64_":76.3,"Elderly___":8.8,"Hispanic__":"38.2","White____":"27.4","African_Am":"10.8","Native_Ame":"0.4","Asian_Amer":"19.2","Other____":"4","Shape_Leng":5671.94079126,"Shape_Area":1041536.36178}},{"arcs":[[1048,1049,1050]],"type":"Polygon","properties":{"Tract_1":6037572500,"Percentile":"96-100%","Population":3365,"County":"Los Angeles","ZIP":90810,"City":"Long Beach","CIscore":59.69,"CIscoreP":"96","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":32.7,"DPM_pctl":88,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":11.552,"Pest_pctl":60,"Tox_Releas":9676.11,"TR_pctl":93,"Traffic":467.94,"Traff_Pctl":"28","Cleanups":5.4,"Clean_Pctl":45,"Groundwate":5.5,"GW_pctl":33,"Haz_Waste":2.27,"Haz_pctl":93,"Imp__Water":22,"IWB_pctl":99,"Solid_Wast":2.5,"Solid_pctl":57,"PollutionS":7.21,"Poll_pctl":89,"Asthma":72.09,"Asthma_Pct":80,"Low_Birth_":6.89,"LBW_pctl":"89","Cardiovasc":9.55,"CVD_pctl":70,"Education":28.4,"Edu_pctl":"75","Linguistic":12.4,"Ling_pctl":"67","Poverty":65.5,"Pov_pctl":"89","Unemployme":25.3,"Unem_pctl":"99","Housing_Bu":22.7,"HB_pctl":"70","PopCharSco":8.28,"Pop_Pctl":"93","Children__":15.9,"Pop_11_64_":64.6,"Elderly___":19.5,"Hispanic__":"39.5","White____":"11.1","African_Am":"26.9","Native_Ame":"0.5","Asian_Amer":"18.5","Other____":"3.5","Shape_Leng":3238.74837727,"Shape_Area":588149.874784}},{"arcs":[[1051,1052,1053,-187]],"type":"Polygon","properties":{"Tract_1":6037571502,"Percentile":"41-45%","Population":4661,"County":"Los Angeles","ZIP":90807,"City":"Long Beach","CIscore":22.63,"CIscoreP":"44","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":20.9,"DPM_pctl":64,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6111.94,"TR_pctl":85,"Traffic":630.75,"Traff_Pctl":"44","Cleanups":0,"Clean_Pctl":0,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":12,"IWB_pctl":91,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.39,"Poll_pctl":34,"Asthma":44.04,"Asthma_Pct":48,"Low_Birth_":5.78,"LBW_pctl":"72","Cardiovasc":6.01,"CVD_pctl":24,"Education":19.1,"Edu_pctl":"60","Linguistic":6.2,"Ling_pctl":"43","Poverty":31.7,"Pov_pctl":"48","Unemployme":12.1,"Unem_pctl":"71","Housing_Bu":15.1,"HB_pctl":"36","PopCharSco":5.15,"Pop_Pctl":"50","Children__":12.4,"Pop_11_64_":76.1,"Elderly___":11.5,"Hispanic__":"32.7","White____":"23.1","African_Am":"17.9","Native_Ame":"0.3","Asian_Amer":"21.6","Other____":"4.5","Shape_Leng":4926.26037636,"Shape_Area":1377069.01226}},{"arcs":[[-1017,1054,1055,-6,1056,-1019,1057]],"type":"Polygon","properties":{"Tract_1":6037571600,"Percentile":"66-70%","Population":2039,"County":"Los Angeles","ZIP":90805,"City":"Long Beach","CIscore":35.65,"CIscoreP":"70","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":20.9,"DPM_pctl":64,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5644.32,"TR_pctl":83,"Traffic":536.66,"Traff_Pctl":"35","Cleanups":0,"Clean_Pctl":0,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":12,"IWB_pctl":91,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.25,"Poll_pctl":31,"Asthma":73.74,"Asthma_Pct":81,"Low_Birth_":13.38,"LBW_pctl":"100","Cardiovasc":9.08,"CVD_pctl":64,"Education":25.6,"Edu_pctl":"71","Linguistic":15.2,"Ling_pctl":"75","Poverty":85.9,"Pov_pctl":"99","Unemployme":36.5,"Unem_pctl":"100","Housing_Bu":19,"HB_pctl":"55","PopCharSco":8.39,"Pop_Pctl":"94","Children__":25.9,"Pop_11_64_":66.5,"Elderly___":7.6,"Hispanic__":"37.4","White____":"4.5","African_Am":"52.5","Native_Ame":"0.1","Asian_Amer":"2.8","Other____":"2.7","Shape_Leng":2949.64406879,"Shape_Area":289982.190457}},{"arcs":[[1058,1059,1060,1061,1062,1063,1064,-593]],"type":"Polygon","properties":{"Tract_1":6037297300,"Percentile":"26-30%","Population":2374,"County":"Los Angeles","ZIP":90732,"City":"San Pedro","CIscore":15.24,"CIscoreP":"26","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":13.46,"DPM_pctl":41,"DrinkingWa":198.88,"DW_pctl":"15","Pesticides":0,"Pest_pctl":0,"Tox_Releas":4273.31,"TR_pctl":78,"Traffic":468.78,"Traff_Pctl":"28","Cleanups":31.95,"Clean_Pctl":91,"Groundwate":3,"GW_pctl":22,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":3,"IWB_pctl":41,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.31,"Poll_pctl":32,"Asthma":51.19,"Asthma_Pct":58,"Low_Birth_":3.24,"LBW_pctl":"12","Cardiovasc":6.2,"CVD_pctl":26,"Education":8.4,"Edu_pctl":"34","Linguistic":3.4,"Ling_pctl":"26","Poverty":23.2,"Pov_pctl":"33","Unemployme":6.5,"Unem_pctl":"25","Housing_Bu":21.1,"HB_pctl":"64","PopCharSco":3.53,"Pop_Pctl":"25","Children__":17.9,"Pop_11_64_":66.1,"Elderly___":16,"Hispanic__":"21.7","White____":"64.4","African_Am":"4.5","Native_Ame":"0.1","Asian_Amer":"5.4","Other____":"3.9","Shape_Leng":6152.10747885,"Shape_Area":1439463.00396}},{"arcs":[[1065,-66,1066,1067,1068]],"type":"Polygon","properties":{"Tract_1":6037297120,"Percentile":"86-90%","Population":3315,"County":"Los Angeles","ZIP":90731,"City":"San Pedro","CIscore":47.32,"CIscoreP":"86","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":51.9,"DPM_pctl":96,"DrinkingWa":198.88,"DW_pctl":"15","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5118.46,"TR_pctl":81,"Traffic":470.43,"Traff_Pctl":"28","Cleanups":13.6,"Clean_Pctl":74,"Groundwate":46.25,"GW_pctl":90,"Haz_Waste":0.4,"Haz_pctl":73,"Imp__Water":9,"IWB_pctl":81,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":6.34,"Poll_pctl":76,"Asthma":84.98,"Asthma_Pct":88,"Low_Birth_":4.36,"LBW_pctl":"35","Cardiovasc":9.68,"CVD_pctl":71,"Education":42.8,"Edu_pctl":"89","Linguistic":12,"Ling_pctl":"66","Poverty":47.1,"Pov_pctl":"70","Unemployme":17.9,"Unem_pctl":"92","Housing_Bu":25.9,"HB_pctl":"79","PopCharSco":7.46,"Pop_Pctl":"82","Children__":16.3,"Pop_11_64_":75.7,"Elderly___":8,"Hispanic__":"69.5","White____":"18.4","African_Am":"5.5","Native_Ame":"0.4","Asian_Amer":"4.5","Other____":"1.8","Shape_Leng":3118.45701915,"Shape_Area":443261.44609}},{"arcs":[[1069,-505]],"type":"Polygon","properties":{"Tract_1":6037620101,"Percentile":"26-30%","Population":5426,"County":"Los Angeles","ZIP":90245,"City":"El Segundo","CIscore":16.73,"CIscoreP":"30","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":36.63,"DPM_pctl":91,"DrinkingWa":399.83,"DW_pctl":"42","Pesticides":0,"Pest_pctl":0,"Tox_Releas":2927.43,"TR_pctl":73,"Traffic":509.51,"Traff_Pctl":"32","Cleanups":1.7,"Clean_Pctl":23,"Groundwate":5.8,"GW_pctl":34,"Haz_Waste":2.67,"Haz_pctl":94,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":1.5,"Solid_pctl":39,"PollutionS":6.3,"Poll_pctl":75,"Asthma":25.04,"Asthma_Pct":16,"Low_Birth_":3.86,"LBW_pctl":"23","Cardiovasc":6.82,"CVD_pctl":35,"Education":4.6,"Edu_pctl":"18","Linguistic":0.9,"Ling_pctl":"5","Poverty":20.2,"Pov_pctl":"27","Unemployme":8.2,"Unem_pctl":"41","Housing_Bu":16.5,"HB_pctl":"43","PopCharSco":2.66,"Pop_Pctl":"15","Children__":10.7,"Pop_11_64_":79.5,"Elderly___":9.8,"Hispanic__":"16.2","White____":"69.4","African_Am":"2.1","Native_Ame":"0.2","Asian_Amer":"8","Other____":"4.1","Shape_Leng":4921.08766656,"Shape_Area":1354872.44482}},{"arcs":[[1070,-149,1071,1072]],"type":"Polygon","properties":{"Tract_1":6037620201,"Percentile":"6-10%","Population":1530,"County":"Los Angeles","ZIP":90266,"City":"Manhattan Beach","CIscore":6.22,"CIscoreP":"5","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":36.63,"DPM_pctl":91,"DrinkingWa":173.98,"DW_pctl":"13","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6022,"TR_pctl":85,"Traffic":597.23,"Traff_Pctl":"41","Cleanups":9,"Clean_Pctl":60,"Groundwate":0,"GW_pctl":0,"Haz_Waste":6.05,"Haz_pctl":98,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.95,"Poll_pctl":68,"Asthma":16.77,"Asthma_Pct":5,"Low_Birth_":3.85,"LBW_pctl":"23","Cardiovasc":5.2,"CVD_pctl":14,"Education":0,"Edu_pctl":"0","Linguistic":0,"Ling_pctl":"0","Poverty":15.4,"Pov_pctl":"17","Unemployme":3.3,"Unem_pctl":"4","Housing_Bu":0,"HB_pctl":"NA","PopCharSco":1.05,"Pop_Pctl":"1","Children__":5.3,"Pop_11_64_":87.6,"Elderly___":7.1,"Hispanic__":"8","White____":"80.9","African_Am":"0.7","Native_Ame":"0.1","Asian_Amer":"5.9","Other____":"4.3","Shape_Leng":2226.06381291,"Shape_Area":239229.98704}},{"arcs":[[1073,-792,1074,1075,1076,-769,1077,1078,1079]],"type":"Polygon","properties":{"Tract_1":6037540300,"Percentile":"91-95%","Population":5267,"County":"Los Angeles","ZIP":90262,"City":"Lynwood","CIscore":54.54,"CIscoreP":"93","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":25.03,"DPM_pctl":76,"DrinkingWa":523.96,"DW_pctl":"55","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6104.63,"TR_pctl":85,"Traffic":1994.94,"Traff_Pctl":"91","Cleanups":101.95,"Clean_Pctl":99,"Groundwate":24.9,"GW_pctl":77,"Haz_Waste":1.27,"Haz_pctl":89,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":22.2,"Solid_pctl":98,"PollutionS":8.02,"Poll_pctl":96,"Asthma":46.97,"Asthma_Pct":53,"Low_Birth_":4.92,"LBW_pctl":"50","Cardiovasc":9.2,"CVD_pctl":66,"Education":60.6,"Edu_pctl":"98","Linguistic":12.4,"Ling_pctl":"67","Poverty":66.3,"Pov_pctl":"90","Unemployme":10.6,"Unem_pctl":"61","Housing_Bu":19.9,"HB_pctl":"59","PopCharSco":6.8,"Pop_Pctl":"74","Children__":16.5,"Pop_11_64_":77.6,"Elderly___":5.9,"Hispanic__":"95.3","White____":"1.3","African_Am":"2.4","Native_Ame":"0.2","Asian_Amer":"0.2","Other____":"0.5","Shape_Leng":6680.69004093,"Shape_Area":1524450.10527}},{"arcs":[[1080,1081,1082,1083,-780,1084]],"type":"Polygon","properties":{"Tract_1":6037540203,"Percentile":"91-95%","Population":5594,"County":"Los Angeles","ZIP":90262,"City":"Lynwood","CIscore":52.38,"CIscoreP":"91","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":21.76,"DPM_pctl":66,"DrinkingWa":291.72,"DW_pctl":"31","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6249.39,"TR_pctl":86,"Traffic":2361.42,"Traff_Pctl":"94","Cleanups":19.25,"Clean_Pctl":83,"Groundwate":6.5,"GW_pctl":38,"Haz_Waste":0.12,"Haz_pctl":49,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":6.09,"Poll_pctl":71,"Asthma":56.52,"Asthma_Pct":65,"Low_Birth_":6.38,"LBW_pctl":"83","Cardiovasc":10.81,"CVD_pctl":82,"Education":47,"Edu_pctl":"92","Linguistic":23.4,"Ling_pctl":"89","Poverty":70.2,"Pov_pctl":"93","Unemployme":16.6,"Unem_pctl":"89","Housing_Bu":27.9,"HB_pctl":"84","PopCharSco":8.61,"Pop_Pctl":"96","Children__":20.3,"Pop_11_64_":75.2,"Elderly___":4.5,"Hispanic__":"89.5","White____":"1.6","African_Am":"7.9","Native_Ame":"0.1","Asian_Amer":"0.6","Other____":"0.4","Shape_Leng":3993.75006129,"Shape_Area":901629.758759}},{"arcs":[[1085,1086,1087,1088,1089,-978,1090]],"type":"Polygon","properties":{"Tract_1":6037541002,"Percentile":"96-100%","Population":3209,"County":"Los Angeles","ZIP":90746,"City":"Carson","CIscore":62.2,"CIscoreP":"97","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":27.16,"DPM_pctl":81,"DrinkingWa":479.84,"DW_pctl":"51","Pesticides":24.047,"Pest_pctl":66,"Tox_Releas":8163.05,"TR_pctl":91,"Traffic":816.41,"Traff_Pctl":"58","Cleanups":68.05,"Clean_Pctl":98,"Groundwate":121.5,"GW_pctl":98,"Haz_Waste":14.19,"Haz_pctl":100,"Imp__Water":18,"IWB_pctl":98,"Solid_Wast":28.8,"Solid_pctl":99,"PollutionS":9.44,"Poll_pctl":100,"Asthma":70.62,"Asthma_Pct":79,"Low_Birth_":6.28,"LBW_pctl":"82","Cardiovasc":7.67,"CVD_pctl":46,"Education":11.3,"Edu_pctl":"43","Linguistic":5.6,"Ling_pctl":"40","Poverty":35.9,"Pov_pctl":"54","Unemployme":16.9,"Unem_pctl":"90","Housing_Bu":21,"HB_pctl":"63","PopCharSco":6.59,"Pop_Pctl":"70","Children__":11.2,"Pop_11_64_":72,"Elderly___":16.8,"Hispanic__":"32.2","White____":"12.9","African_Am":"49.1","Native_Ame":"0.3","Asian_Amer":"2.6","Other____":"2.9","Shape_Leng":7868.68410551,"Shape_Area":3433952.0565}},{"arcs":[[1091,1092,1093,1094]],"type":"Polygon","properties":{"Tract_1":6037543601,"Percentile":"56-60%","Population":3910,"County":"Los Angeles","ZIP":90745,"City":"Carson","CIscore":29.08,"CIscoreP":"58","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":23.77,"DPM_pctl":73,"DrinkingWa":182.06,"DW_pctl":"14","Pesticides":0,"Pest_pctl":0,"Tox_Releas":7622.76,"TR_pctl":89,"Traffic":1407.27,"Traff_Pctl":"81","Cleanups":6.4,"Clean_Pctl":49,"Groundwate":3.3,"GW_pctl":23,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":1.3,"Solid_pctl":37,"PollutionS":5.06,"Poll_pctl":48,"Asthma":60.31,"Asthma_Pct":70,"Low_Birth_":5.36,"LBW_pctl":"62","Cardiovasc":9.96,"CVD_pctl":74,"Education":16,"Edu_pctl":"54","Linguistic":5,"Ling_pctl":"36","Poverty":18.4,"Pov_pctl":"23","Unemployme":14.2,"Unem_pctl":"81","Housing_Bu":10.8,"HB_pctl":"16","PopCharSco":5.75,"Pop_Pctl":"58","Children__":11,"Pop_11_64_":76.1,"Elderly___":12.9,"Hispanic__":"37.2","White____":"8.5","African_Am":"5.8","Native_Ame":"0.2","Asian_Amer":"45.9","Other____":"2.4","Shape_Leng":3321.86219983,"Shape_Area":647458.525828}},{"arcs":[[1095,1096,1097]],"type":"Polygon","properties":{"Tract_1":6037554201,"Percentile":"71-75%","Population":4108,"County":"Los Angeles","ZIP":90706,"City":"Bellflower","CIscore":36.22,"CIscoreP":"70","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":21.7,"DPM_pctl":66,"DrinkingWa":323.54,"DW_pctl":"34","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8111.52,"TR_pctl":90,"Traffic":1657.52,"Traff_Pctl":"86","Cleanups":0,"Clean_Pctl":0,"Groundwate":36.15,"GW_pctl":86,"Haz_Waste":0.01,"Haz_pctl":9,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.46,"Poll_pctl":57,"Asthma":79.03,"Asthma_Pct":85,"Low_Birth_":5.41,"LBW_pctl":"64","Cardiovasc":11.13,"CVD_pctl":84,"Education":25.2,"Edu_pctl":"70","Linguistic":8.7,"Ling_pctl":"54","Poverty":32.9,"Pov_pctl":"49","Unemployme":9.7,"Unem_pctl":"54","Housing_Bu":13.1,"HB_pctl":"26","PopCharSco":6.64,"Pop_Pctl":"71","Children__":15,"Pop_11_64_":76.4,"Elderly___":8.6,"Hispanic__":"53.4","White____":"21.1","African_Am":"9.8","Native_Ame":"0.3","Asian_Amer":"13.3","Other____":"2.1","Shape_Leng":4017.26046652,"Shape_Area":969104.40557}},{"arcs":[[-690,1098,1099,-267]],"type":"Polygon","properties":{"Tract_1":6037554404,"Percentile":"81-85%","Population":4447,"County":"Los Angeles","ZIP":90706,"City":"Bellflower","CIscore":43.12,"CIscoreP":"80","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":21.73,"DPM_pctl":66,"DrinkingWa":299.5,"DW_pctl":"32","Pesticides":0.072,"Pest_pctl":18,"Tox_Releas":7019.46,"TR_pctl":88,"Traffic":2342.99,"Traff_Pctl":"94","Cleanups":0,"Clean_Pctl":0,"Groundwate":11.75,"GW_pctl":53,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":5.45,"Poll_pctl":57,"Asthma":73.52,"Asthma_Pct":81,"Low_Birth_":7.1,"LBW_pctl":"91","Cardiovasc":10.39,"CVD_pctl":78,"Education":25.5,"Edu_pctl":"71","Linguistic":10.1,"Ling_pctl":"59","Poverty":59.9,"Pov_pctl":"84","Unemployme":13.8,"Unem_pctl":"79","Housing_Bu":18.5,"HB_pctl":"52","PopCharSco":7.91,"Pop_Pctl":"89","Children__":15.2,"Pop_11_64_":78.4,"Elderly___":6.4,"Hispanic__":"49.1","White____":"17.7","African_Am":"16.5","Native_Ame":"0.3","Asian_Amer":"13.4","Other____":"2.9","Shape_Leng":3705.80608494,"Shape_Area":843650.841175}},{"arcs":[[1100,1101,-1099]],"type":"Polygon","properties":{"Tract_1":6037554403,"Percentile":"86-90%","Population":5483,"County":"Los Angeles","ZIP":90706,"City":"Bellflower","CIscore":49,"CIscoreP":"88","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":21.73,"DPM_pctl":66,"DrinkingWa":300.01,"DW_pctl":"32","Pesticides":2.237,"Pest_pctl":46,"Tox_Releas":7367.58,"TR_pctl":89,"Traffic":2052.97,"Traff_Pctl":"91","Cleanups":0,"Clean_Pctl":0,"Groundwate":32.6,"GW_pctl":84,"Haz_Waste":0.01,"Haz_pctl":9,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":6,"Poll_pctl":69,"Asthma":75.56,"Asthma_Pct":82,"Low_Birth_":7.4,"LBW_pctl":"94","Cardiovasc":10.66,"CVD_pctl":80,"Education":28.8,"Edu_pctl":"75","Linguistic":10.3,"Ling_pctl":"60","Poverty":55.5,"Pov_pctl":"80","Unemployme":11.6,"Unem_pctl":"67","Housing_Bu":25.9,"HB_pctl":"79","PopCharSco":8.17,"Pop_Pctl":"91","Children__":17.3,"Pop_11_64_":76.4,"Elderly___":6.3,"Hispanic__":"49.5","White____":"13.6","African_Am":"22","Native_Ame":"0.3","Asian_Amer":"12.2","Other____":"2.4","Shape_Leng":3717.44317464,"Shape_Area":849189.598531}},{"arcs":[[1102,1103]],"type":"Polygon","properties":{"Tract_1":6037554519,"Percentile":"46-50%","Population":3613,"County":"Los Angeles","ZIP":90703,"City":"Cerritos","CIscore":23.07,"CIscoreP":"45","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":16.86,"DPM_pctl":51,"DrinkingWa":287.39,"DW_pctl":"30","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5843.99,"TR_pctl":84,"Traffic":461.94,"Traff_Pctl":"27","Cleanups":0.1,"Clean_Pctl":2,"Groundwate":4,"GW_pctl":27,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":8.7,"Solid_pctl":87,"PollutionS":5.05,"Poll_pctl":47,"Asthma":34.19,"Asthma_Pct":32,"Low_Birth_":6.47,"LBW_pctl":"85","Cardiovasc":7.29,"CVD_pctl":41,"Education":6.5,"Edu_pctl":"26","Linguistic":17.1,"Ling_pctl":"79","Poverty":19.9,"Pov_pctl":"26","Unemployme":5.8,"Unem_pctl":"19","Housing_Bu":13.3,"HB_pctl":"27","PopCharSco":4.57,"Pop_Pctl":"41","Children__":7.6,"Pop_11_64_":69.4,"Elderly___":23,"Hispanic__":"9","White____":"17.9","African_Am":"4.2","Native_Ame":"0.1","Asian_Amer":"66.4","Other____":"2.4","Shape_Leng":5972.12648376,"Shape_Area":1742351.1554}},{"arcs":[[1104,1105,1106]],"type":"Polygon","properties":{"Tract_1":6037554511,"Percentile":"71-75%","Population":4029,"County":"Los Angeles","ZIP":90703,"City":"Cerritos","CIscore":38.7,"CIscoreP":"74","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":18.68,"DPM_pctl":58,"DrinkingWa":255.86,"DW_pctl":"26","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5857.59,"TR_pctl":84,"Traffic":903.83,"Traff_Pctl":"63","Cleanups":33.45,"Clean_Pctl":92,"Groundwate":20,"GW_pctl":71,"Haz_Waste":5.77,"Haz_pctl":98,"Imp__Water":8,"IWB_pctl":76,"Solid_Wast":1.4,"Solid_pctl":37,"PollutionS":7.17,"Poll_pctl":89,"Asthma":44.98,"Asthma_Pct":49,"Low_Birth_":7.14,"LBW_pctl":"92","Cardiovasc":9.59,"CVD_pctl":70,"Education":9.5,"Edu_pctl":"37","Linguistic":14.3,"Ling_pctl":"73","Poverty":19.7,"Pov_pctl":"26","Unemployme":4.9,"Unem_pctl":"12","Housing_Bu":11.8,"HB_pctl":"20","PopCharSco":5.39,"Pop_Pctl":"53","Children__":9.5,"Pop_11_64_":76,"Elderly___":14.5,"Hispanic__":"9.9","White____":"12.5","African_Am":"4.9","Native_Ame":"0","Asian_Amer":"70.1","Other____":"2.6","Shape_Leng":6085.68398868,"Shape_Area":2372927.53112}},{"arcs":[[1107,1108]],"type":"Polygon","properties":{"Tract_1":6037554518,"Percentile":"36-40%","Population":5435,"County":"Los Angeles","ZIP":90703,"City":"Cerritos","CIscore":19.19,"CIscoreP":"36","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":20.16,"DPM_pctl":62,"DrinkingWa":255.86,"DW_pctl":"26","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5701.09,"TR_pctl":83,"Traffic":1078.7,"Traff_Pctl":"71","Cleanups":1.5,"Clean_Pctl":22,"Groundwate":6,"GW_pctl":36,"Haz_Waste":0.1,"Haz_pctl":32,"Imp__Water":8,"IWB_pctl":76,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.61,"Poll_pctl":60,"Asthma":36.41,"Asthma_Pct":36,"Low_Birth_":3.3,"LBW_pctl":"13","Cardiovasc":7.87,"CVD_pctl":49,"Education":8.8,"Edu_pctl":"35","Linguistic":10.2,"Ling_pctl":"60","Poverty":12.6,"Pov_pctl":"12","Unemployme":7.7,"Unem_pctl":"36","Housing_Bu":12.3,"HB_pctl":"23","PopCharSco":3.42,"Pop_Pctl":"24","Children__":9.5,"Pop_11_64_":74.9,"Elderly___":15.6,"Hispanic__":"9.1","White____":"16.5","African_Am":"6.2","Native_Ame":"0.1","Asian_Amer":"65.3","Other____":"2.7","Shape_Leng":6477.38169166,"Shape_Area":1796227.42053}},{"arcs":[[1109,1110,1111,1112,1113,1114]],"type":"Polygon","properties":{"Tract_1":6037554513,"Percentile":"31-35%","Population":2507,"County":"Los Angeles","ZIP":90703,"City":"Cerritos","CIscore":18.45,"CIscoreP":"34","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":18.37,"DPM_pctl":56,"DrinkingWa":382.4,"DW_pctl":"40","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5583.79,"TR_pctl":83,"Traffic":482.2,"Traff_Pctl":"29","Cleanups":1.4,"Clean_Pctl":21,"Groundwate":7.5,"GW_pctl":41,"Haz_Waste":0.04,"Haz_pctl":19,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":1.25,"Solid_pctl":37,"PollutionS":4.67,"Poll_pctl":40,"Asthma":29.98,"Asthma_Pct":25,"Low_Birth_":5.84,"LBW_pctl":"73","Cardiovasc":6.39,"CVD_pctl":29,"Education":6.6,"Edu_pctl":"26","Linguistic":15.6,"Ling_pctl":"76","Poverty":11.4,"Pov_pctl":"9","Unemployme":2.8,"Unem_pctl":"2","Housing_Bu":19.2,"HB_pctl":"56","PopCharSco":3.96,"Pop_Pctl":"32","Children__":9.4,"Pop_11_64_":73.7,"Elderly___":16.9,"Hispanic__":"8.8","White____":"9.8","African_Am":"9.5","Native_Ame":"0.2","Asian_Amer":"69.8","Other____":"1.9","Shape_Leng":3192.15961377,"Shape_Area":566191.679296}},{"arcs":[[1115,-1002,1116,-677,1117,-1023,1118,1119]],"type":"Polygon","properties":{"Tract_1":6037554522,"Percentile":"66-70%","Population":4787,"County":"Los Angeles","ZIP":90703,"City":"Cerritos","CIscore":34.33,"CIscoreP":"67","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":22.61,"DPM_pctl":69,"DrinkingWa":348.69,"DW_pctl":"36","Pesticides":56.167,"Pest_pctl":72,"Tox_Releas":5828.58,"TR_pctl":84,"Traffic":1748.1,"Traff_Pctl":"88","Cleanups":9,"Clean_Pctl":60,"Groundwate":19.75,"GW_pctl":70,"Haz_Waste":0.1,"Haz_pctl":43,"Imp__Water":3,"IWB_pctl":41,"Solid_Wast":1.7,"Solid_pctl":40,"PollutionS":7.43,"Poll_pctl":92,"Asthma":37.72,"Asthma_Pct":38,"Low_Birth_":6.06,"LBW_pctl":"78","Cardiovasc":7.71,"CVD_pctl":47,"Education":10.9,"Edu_pctl":"42","Linguistic":7.6,"Ling_pctl":"49","Poverty":13.4,"Pov_pctl":"13","Unemployme":9.8,"Unem_pctl":"54","Housing_Bu":10.8,"HB_pctl":"16","PopCharSco":4.62,"Pop_Pctl":"42","Children__":9.2,"Pop_11_64_":71.9,"Elderly___":18.9,"Hispanic__":"15.9","White____":"20.3","African_Am":"6.6","Native_Ame":"0.3","Asian_Amer":"53.5","Other____":"3.5","Shape_Leng":6340.4017983,"Shape_Area":2190508.76437}},{"arcs":[[1120,1121,1122,-614,1123,1124,1125,1126]],"type":"Polygon","properties":{"Tract_1":6037296500,"Percentile":"91-95%","Population":3910,"County":"Los Angeles","ZIP":90731,"City":"San Pedro","CIscore":52.54,"CIscoreP":"91","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":50.42,"DPM_pctl":96,"DrinkingWa":198.88,"DW_pctl":"15","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6158.94,"TR_pctl":85,"Traffic":988.75,"Traff_Pctl":"67","Cleanups":10.75,"Clean_Pctl":64,"Groundwate":15.3,"GW_pctl":62,"Haz_Waste":0.44,"Haz_pctl":74,"Imp__Water":8,"IWB_pctl":76,"Solid_Wast":1.5,"Solid_pctl":39,"PollutionS":6.84,"Poll_pctl":85,"Asthma":71.31,"Asthma_Pct":80,"Low_Birth_":5.5,"LBW_pctl":"66","Cardiovasc":8.18,"CVD_pctl":53,"Education":36.5,"Edu_pctl":"84","Linguistic":12.9,"Ling_pctl":"69","Poverty":54.7,"Pov_pctl":"79","Unemployme":16.4,"Unem_pctl":"89","Housing_Bu":31,"HB_pctl":"89","PopCharSco":7.68,"Pop_Pctl":"86","Children__":15.5,"Pop_11_64_":75.3,"Elderly___":9.2,"Hispanic__":"72.8","White____":"13.2","African_Am":"9.1","Native_Ame":"0.2","Asian_Amer":"3.5","Other____":"1.1","Shape_Leng":4220.83370514,"Shape_Area":907992.031774}},{"arcs":[[1127,1128,1129]],"type":"Polygon","properties":{"Tract_1":6037297110,"Percentile":"96-100%","Population":4679,"County":"Los Angeles","ZIP":90731,"City":"San Pedro","CIscore":59.81,"CIscoreP":"96","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":51.9,"DPM_pctl":96,"DrinkingWa":198.88,"DW_pctl":"15","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5380.05,"TR_pctl":82,"Traffic":678.7,"Traff_Pctl":"48","Cleanups":22.15,"Clean_Pctl":85,"Groundwate":30.55,"GW_pctl":82,"Haz_Waste":1.46,"Haz_pctl":90,"Imp__Water":12,"IWB_pctl":91,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":6.85,"Poll_pctl":85,"Asthma":84.98,"Asthma_Pct":88,"Low_Birth_":7.74,"LBW_pctl":"95","Cardiovasc":9.68,"CVD_pctl":71,"Education":31.8,"Edu_pctl":"79","Linguistic":21.2,"Ling_pctl":"86","Poverty":56.1,"Pov_pctl":"80","Unemployme":16.8,"Unem_pctl":"90","Housing_Bu":27.6,"HB_pctl":"83","PopCharSco":8.73,"Pop_Pctl":"96","Children__":13.7,"Pop_11_64_":78.3,"Elderly___":8,"Hispanic__":"64.5","White____":"20.4","African_Am":"8.2","Native_Ame":"0.4","Asian_Amer":"4.1","Other____":"2.3","Shape_Leng":2792.73398461,"Shape_Area":487426.549311}},{"arcs":[[1130,-340,1131,1132,1133,1134,1135,1136,1137,-1062]],"type":"Polygon","properties":{"Tract_1":6037297400,"Percentile":"31-35%","Population":3603,"County":"Los Angeles","ZIP":90732,"City":"San Pedro","CIscore":18.55,"CIscoreP":"35","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":7.84,"DPM_pctl":22,"DrinkingWa":425.65,"DW_pctl":"44","Pesticides":0,"Pest_pctl":0,"Tox_Releas":4194.54,"TR_pctl":77,"Traffic":443.14,"Traff_Pctl":"25","Cleanups":32.2,"Clean_Pctl":91,"Groundwate":3,"GW_pctl":22,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":4,"IWB_pctl":49,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.46,"Poll_pctl":35,"Asthma":37.25,"Asthma_Pct":37,"Low_Birth_":7.35,"LBW_pctl":"93","Cardiovasc":5.17,"CVD_pctl":14,"Education":7.9,"Edu_pctl":"32","Linguistic":5.1,"Ling_pctl":"37","Poverty":14.6,"Pov_pctl":"16","Unemployme":10.9,"Unem_pctl":"63","Housing_Bu":10.1,"HB_pctl":"13","PopCharSco":4.16,"Pop_Pctl":"35","Children__":7.9,"Pop_11_64_":61.4,"Elderly___":30.7,"Hispanic__":"15.3","White____":"75.2","African_Am":"1.9","Native_Ame":"0.3","Asian_Amer":"4.4","Other____":"2.9","Shape_Leng":6575.8373836,"Shape_Area":2247463.27106}},{"arcs":[[-60,1138,-1060,1139,1140]],"type":"Polygon","properties":{"Tract_1":6037297500,"Percentile":"46-50%","Population":5163,"County":"Los Angeles","ZIP":90731,"City":"San Pedro","CIscore":24.58,"CIscoreP":"49","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":36.91,"DPM_pctl":91,"DrinkingWa":420.55,"DW_pctl":"44","Pesticides":0,"Pest_pctl":0,"Tox_Releas":4404.11,"TR_pctl":78,"Traffic":425.49,"Traff_Pctl":"23","Cleanups":37.9,"Clean_Pctl":94,"Groundwate":120.3,"GW_pctl":98,"Haz_Waste":0.01,"Haz_pctl":9,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":6.15,"Poll_pctl":73,"Asthma":72.68,"Asthma_Pct":80,"Low_Birth_":4.74,"LBW_pctl":"45","Cardiovasc":8.33,"CVD_pctl":55,"Education":6.7,"Edu_pctl":"27","Linguistic":1,"Ling_pctl":"6","Poverty":14.4,"Pov_pctl":"15","Unemployme":2.7,"Unem_pctl":"2","Housing_Bu":15,"HB_pctl":"35","PopCharSco":3.99,"Pop_Pctl":"32","Children__":11.4,"Pop_11_64_":73,"Elderly___":15.6,"Hispanic__":"28.4","White____":"59.5","African_Am":"3.6","Native_Ame":"0.2","Asian_Amer":"4.6","Other____":"3.7","Shape_Leng":6217.07278669,"Shape_Area":2223905.1485}},{"arcs":[[1141,1142,-618,1143,-615,-1123]],"type":"Polygon","properties":{"Tract_1":6037609900,"Percentile":"46-50%","Population":2034,"County":"Los Angeles","ZIP":90732,"City":"San Pedro","CIscore":24.09,"CIscoreP":"48","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":39.25,"DPM_pctl":93,"DrinkingWa":198.88,"DW_pctl":"15","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5230.54,"TR_pctl":81,"Traffic":549.36,"Traff_Pctl":"36","Cleanups":4.4,"Clean_Pctl":40,"Groundwate":8.55,"GW_pctl":44,"Haz_Waste":0.12,"Haz_pctl":49,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":4.97,"Poll_pctl":46,"Asthma":57.77,"Asthma_Pct":66,"Low_Birth_":3.83,"LBW_pctl":"23","Cardiovasc":6.7,"CVD_pctl":33,"Education":31.2,"Edu_pctl":"78","Linguistic":6.6,"Ling_pctl":"45","Poverty":30.3,"Pov_pctl":"45","Unemployme":16,"Unem_pctl":"88","Housing_Bu":8.8,"HB_pctl":"9","PopCharSco":4.85,"Pop_Pctl":"45","Children__":11.6,"Pop_11_64_":70.6,"Elderly___":17.8,"Hispanic__":"55.3","White____":"29.7","African_Am":"6.4","Native_Ame":"0.4","Asian_Amer":"5.3","Other____":"2.9","Shape_Leng":4281.38779191,"Shape_Area":534331.266297}},{"arcs":[[1144,1145,1146,1147,1148]],"type":"Polygon","properties":{"Tract_1":6037296220,"Percentile":"91-95%","Population":4307,"County":"Los Angeles","ZIP":90731,"City":"San Pedro","CIscore":54.4,"CIscoreP":"93","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":51.9,"DPM_pctl":96,"DrinkingWa":198.88,"DW_pctl":"15","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5925.16,"TR_pctl":84,"Traffic":468.99,"Traff_Pctl":"28","Cleanups":16.5,"Clean_Pctl":79,"Groundwate":23.4,"GW_pctl":75,"Haz_Waste":2.54,"Haz_pctl":93,"Imp__Water":12,"IWB_pctl":91,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":6.64,"Poll_pctl":82,"Asthma":84.98,"Asthma_Pct":88,"Low_Birth_":5.32,"LBW_pctl":"61","Cardiovasc":9.68,"CVD_pctl":71,"Education":37.5,"Edu_pctl":"85","Linguistic":21.2,"Ling_pctl":"86","Poverty":73.1,"Pov_pctl":"95","Unemployme":23.8,"Unem_pctl":"98","Housing_Bu":20.1,"HB_pctl":"59","PopCharSco":8.2,"Pop_Pctl":"92","Children__":15.4,"Pop_11_64_":74.1,"Elderly___":10.5,"Hispanic__":"65.2","White____":"13","African_Am":"11.4","Native_Ame":"0.2","Asian_Amer":"8.1","Other____":"2.1","Shape_Leng":2920.35523974,"Shape_Area":533611.975073}},{"arcs":[[-354,1149,-362,1150,1151,1152,1153,1154,1155]],"type":"Polygon","properties":{"Tract_1":6037670413,"Percentile":"1-5%","Population":4782,"County":"Los Angeles","ZIP":90275,"City":"Rancho Palos Verdes","CIscore":4.67,"CIscoreP":"3","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":3.31,"DPM_pctl":10,"DrinkingWa":187.24,"DW_pctl":"14","Pesticides":0,"Pest_pctl":0,"Tox_Releas":1987.62,"TR_pctl":68,"Traffic":336.91,"Traff_Pctl":"15","Cleanups":0,"Clean_Pctl":0,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":5,"IWB_pctl":55,"Solid_Wast":0.1,"Solid_pctl":1,"PollutionS":3.15,"Poll_pctl":11,"Asthma":10.59,"Asthma_Pct":1,"Low_Birth_":4.12,"LBW_pctl":"29","Cardiovasc":3.84,"CVD_pctl":4,"Education":1.8,"Edu_pctl":"5","Linguistic":10.4,"Ling_pctl":"60","Poverty":8.3,"Pov_pctl":"5","Unemployme":4.5,"Unem_pctl":"9","Housing_Bu":8.5,"HB_pctl":"8","PopCharSco":1.49,"Pop_Pctl":"3","Children__":11.2,"Pop_11_64_":64.8,"Elderly___":24,"Hispanic__":"5.7","White____":"48.2","African_Am":"2.1","Native_Ame":"0.2","Asian_Amer":"40.4","Other____":"3.5","Shape_Leng":6363.35117424,"Shape_Area":2181238.34262}},{"arcs":[[-741,1156,1157,1158,1159,-744,1160]],"type":"Polygon","properties":{"Tract_1":6037574500,"Percentile":"26-30%","Population":6357,"County":"Los Angeles","ZIP":90815,"City":"Long Beach","CIscore":16.42,"CIscoreP":"29","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":17.87,"DPM_pctl":54,"DrinkingWa":249.02,"DW_pctl":"25","Pesticides":0.006,"Pest_pctl":7,"Tox_Releas":7724.94,"TR_pctl":90,"Traffic":1997.57,"Traff_Pctl":"91","Cleanups":36,"Clean_Pctl":93,"Groundwate":9,"GW_pctl":46,"Haz_Waste":0.05,"Haz_pctl":26,"Imp__Water":19,"IWB_pctl":99,"Solid_Wast":1,"Solid_pctl":33,"PollutionS":6.71,"Poll_pctl":83,"Asthma":26.95,"Asthma_Pct":19,"Low_Birth_":4.03,"LBW_pctl":"27","Cardiovasc":7.08,"CVD_pctl":38,"Education":5,"Edu_pctl":"20","Linguistic":0,"Ling_pctl":"0","Poverty":18.6,"Pov_pctl":"24","Unemployme":6.9,"Unem_pctl":"28","Housing_Bu":12.4,"HB_pctl":"23","PopCharSco":2.45,"Pop_Pctl":"12","Children__":11.5,"Pop_11_64_":72.3,"Elderly___":16.2,"Hispanic__":"17","White____":"66.2","African_Am":"3.6","Native_Ame":"0.4","Asian_Amer":"8.9","Other____":"4","Shape_Leng":7715.00040265,"Shape_Area":2631808.40083}},{"arcs":[[1161,1162,1163,1164,1165,1166]],"type":"Polygon","properties":{"Tract_1":6037574901,"Percentile":"11-15%","Population":3725,"County":"Los Angeles","ZIP":90815,"City":"Long Beach","CIscore":9.9,"CIscoreP":"13","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":21.19,"DPM_pctl":65,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":7523.82,"TR_pctl":89,"Traffic":640.32,"Traff_Pctl":"45","Cleanups":0,"Clean_Pctl":0,"Groundwate":7.35,"GW_pctl":40,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.04,"Poll_pctl":26,"Asthma":28.12,"Asthma_Pct":22,"Low_Birth_":2.27,"LBW_pctl":"3","Cardiovasc":7.36,"CVD_pctl":42,"Education":3,"Edu_pctl":"10","Linguistic":2.4,"Ling_pctl":"18","Poverty":15,"Pov_pctl":"16","Unemployme":10.3,"Unem_pctl":"58","Housing_Bu":12.2,"HB_pctl":"22","PopCharSco":2.45,"Pop_Pctl":"12","Children__":13.3,"Pop_11_64_":75.3,"Elderly___":11.4,"Hispanic__":"15.4","White____":"70","African_Am":"1.7","Native_Ame":"0.2","Asian_Amer":"8.4","Other____":"4.2","Shape_Leng":5172.32711386,"Shape_Area":1341140.5027}},{"arcs":[[1167,1168,1169]],"type":"Polygon","properties":{"Tract_1":6037577100,"Percentile":"21-25%","Population":6700,"County":"Los Angeles","ZIP":90814,"City":"Long Beach","CIscore":13.11,"CIscoreP":"20","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":13.13,"DPM_pctl":39,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8398.65,"TR_pctl":91,"Traffic":1038.73,"Traff_Pctl":"69","Cleanups":0,"Clean_Pctl":0,"Groundwate":4.8,"GW_pctl":29,"Haz_Waste":0.21,"Haz_pctl":62,"Imp__Water":10,"IWB_pctl":86,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.16,"Poll_pctl":50,"Asthma":27.42,"Asthma_Pct":20,"Low_Birth_":3.98,"LBW_pctl":"26","Cardiovasc":4.98,"CVD_pctl":12,"Education":3.6,"Edu_pctl":"13","Linguistic":0.7,"Ling_pctl":"3","Poverty":34.7,"Pov_pctl":"52","Unemployme":6.1,"Unem_pctl":"21","Housing_Bu":19.6,"HB_pctl":"57","PopCharSco":2.54,"Pop_Pctl":"13","Children__":9.3,"Pop_11_64_":81.5,"Elderly___":9.2,"Hispanic__":"21.2","White____":"60.4","African_Am":"6.4","Native_Ame":"0.4","Asian_Amer":"7.1","Other____":"4.5","Shape_Leng":4427.29148459,"Shape_Area":1214873.93883}},{"arcs":[[1170,1171,1172]],"type":"Polygon","properties":{"Tract_1":6037575002,"Percentile":"46-50%","Population":4627,"County":"Los Angeles","ZIP":90804,"City":"Long Beach","CIscore":24.1,"CIscoreP":"48","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":25.99,"DPM_pctl":78,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":7809.55,"TR_pctl":90,"Traffic":833.21,"Traff_Pctl":"59","Cleanups":0.9,"Clean_Pctl":13,"Groundwate":16.25,"GW_pctl":64,"Haz_Waste":0.75,"Haz_pctl":84,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.35,"Poll_pctl":54,"Asthma":70.51,"Asthma_Pct":79,"Low_Birth_":3.34,"LBW_pctl":"14","Cardiovasc":8.96,"CVD_pctl":63,"Education":10.1,"Edu_pctl":"40","Linguistic":3,"Ling_pctl":"23","Poverty":25.6,"Pov_pctl":"37","Unemployme":8.3,"Unem_pctl":"41","Housing_Bu":14.7,"HB_pctl":"34","PopCharSco":4.51,"Pop_Pctl":"40","Children__":8.7,"Pop_11_64_":77.6,"Elderly___":13.7,"Hispanic__":"26.3","White____":"46.1","African_Am":"9.7","Native_Ame":"0.3","Asian_Amer":"13.4","Other____":"4.1","Shape_Leng":4494.18301951,"Shape_Area":964157.139252}},{"arcs":[[1173,-1046,1174,1175,1176,1177]],"type":"Polygon","properties":{"Tract_1":6037572201,"Percentile":"81-85%","Population":6197,"County":"Los Angeles","ZIP":90806,"City":"Long Beach","CIscore":44.11,"CIscoreP":"82","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":27.39,"DPM_pctl":81,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0.668,"Pest_pctl":35,"Tox_Releas":8045.9,"TR_pctl":90,"Traffic":1826.56,"Traff_Pctl":"89","Cleanups":6.75,"Clean_Pctl":50,"Groundwate":30.1,"GW_pctl":82,"Haz_Waste":0.1,"Haz_pctl":43,"Imp__Water":11,"IWB_pctl":90,"Solid_Wast":6.45,"Solid_pctl":80,"PollutionS":7.66,"Poll_pctl":94,"Asthma":70.85,"Asthma_Pct":79,"Low_Birth_":5.59,"LBW_pctl":"68","Cardiovasc":8.5,"CVD_pctl":57,"Education":16.2,"Edu_pctl":"55","Linguistic":5.7,"Ling_pctl":"40","Poverty":25.3,"Pov_pctl":"37","Unemployme":10,"Unem_pctl":"56","Housing_Bu":13.3,"HB_pctl":"27","PopCharSco":5.76,"Pop_Pctl":"58","Children__":11.2,"Pop_11_64_":73,"Elderly___":15.8,"Hispanic__":"30.5","White____":"17.6","African_Am":"16.9","Native_Ame":"0.2","Asian_Amer":"31.3","Other____":"3.5","Shape_Leng":5548.98317807,"Shape_Area":1550519.57928}},{"arcs":[[1178,1179,1180,1181]],"type":"Polygon","properties":{"Tract_1":6037294820,"Percentile":"91-95%","Population":3579,"County":"Los Angeles","ZIP":90744,"City":"Wilmington","CIscore":54.38,"CIscoreP":"93","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":47.38,"DPM_pctl":95,"DrinkingWa":198.88,"DW_pctl":"15","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8010.09,"TR_pctl":90,"Traffic":700.69,"Traff_Pctl":"50","Cleanups":20.15,"Clean_Pctl":84,"Groundwate":20.25,"GW_pctl":71,"Haz_Waste":0.54,"Haz_pctl":78,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":3.5,"Solid_pctl":65,"PollutionS":6.54,"Poll_pctl":80,"Asthma":70.22,"Asthma_Pct":79,"Low_Birth_":4.98,"LBW_pctl":"52","Cardiovasc":10.57,"CVD_pctl":79,"Education":53.7,"Edu_pctl":"96","Linguistic":33.1,"Ling_pctl":"96","Poverty":74.9,"Pov_pctl":"96","Unemployme":13.1,"Unem_pctl":"76","Housing_Bu":30.2,"HB_pctl":"88","PopCharSco":8.32,"Pop_Pctl":"93","Children__":21,"Pop_11_64_":75.3,"Elderly___":3.7,"Hispanic__":"94.3","White____":"2.4","African_Am":"2","Native_Ame":"0.5","Asian_Amer":"0.6","Other____":"0.1","Shape_Leng":2500.51699744,"Shape_Area":383493.362859}},{"arcs":[[1182,1183,1184]],"type":"Polygon","properties":{"Tract_1":6037602004,"Percentile":"81-85%","Population":4126,"County":"Los Angeles","ZIP":90303,"City":"Inglewood","CIscore":45.18,"CIscoreP":"83","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":18.08,"DPM_pctl":55,"DrinkingWa":290.05,"DW_pctl":"31","Pesticides":0.125,"Pest_pctl":23,"Tox_Releas":4907.11,"TR_pctl":80,"Traffic":688.21,"Traff_Pctl":"49","Cleanups":1,"Clean_Pctl":18,"Groundwate":0.75,"GW_pctl":4,"Haz_Waste":0.01,"Haz_pctl":9,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.06,"Poll_pctl":48,"Asthma":104.23,"Asthma_Pct":93,"Low_Birth_":7.17,"LBW_pctl":"92","Cardiovasc":12.19,"CVD_pctl":90,"Education":52.7,"Edu_pctl":"95","Linguistic":14,"Ling_pctl":"72","Poverty":53.2,"Pov_pctl":"77","Unemployme":10.6,"Unem_pctl":"61","Housing_Bu":39.7,"HB_pctl":"98","PopCharSco":8.93,"Pop_Pctl":"97","Children__":16.4,"Pop_11_64_":77.3,"Elderly___":6.3,"Hispanic__":"73.2","White____":"0.8","African_Am":"23.6","Native_Ame":"0","Asian_Amer":"1.7","Other____":"0.7","Shape_Leng":3097.69971909,"Shape_Area":590457.579217}},{"arcs":[[1185,-1183,1186]],"type":"Polygon","properties":{"Tract_1":6037602003,"Percentile":"81-85%","Population":5124,"County":"Los Angeles","ZIP":90303,"City":"Inglewood","CIscore":46.05,"CIscoreP":"84","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":20.98,"DPM_pctl":65,"DrinkingWa":255.06,"DW_pctl":"26","Pesticides":0.003,"Pest_pctl":5,"Tox_Releas":4886.51,"TR_pctl":80,"Traffic":1949.42,"Traff_Pctl":"90","Cleanups":0.5,"Clean_Pctl":8,"Groundwate":3,"GW_pctl":22,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.38,"Poll_pctl":55,"Asthma":95.84,"Asthma_Pct":91,"Low_Birth_":5.09,"LBW_pctl":"55","Cardiovasc":11.27,"CVD_pctl":85,"Education":49.9,"Edu_pctl":"94","Linguistic":26.5,"Ling_pctl":"92","Poverty":63.3,"Pov_pctl":"87","Unemployme":12.7,"Unem_pctl":"74","Housing_Bu":33.7,"HB_pctl":"93","PopCharSco":8.57,"Pop_Pctl":"95","Children__":18.7,"Pop_11_64_":75.3,"Elderly___":6,"Hispanic__":"80.5","White____":"1.8","African_Am":"14.6","Native_Ame":"0.2","Asian_Amer":"1.3","Other____":"1.5","Shape_Leng":3149.13795369,"Shape_Area":625274.221173}},{"arcs":[[1187,1188,1189,1190,1191]],"type":"Polygon","properties":{"Tract_1":6037602103,"Percentile":"91-95%","Population":6992,"County":"Los Angeles","ZIP":90250,"City":"Hawthorne","CIscore":51.78,"CIscoreP":"91","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":32.96,"DPM_pctl":88,"DrinkingWa":394.99,"DW_pctl":"41","Pesticides":3.268,"Pest_pctl":49,"Tox_Releas":4770.29,"TR_pctl":79,"Traffic":1758.15,"Traff_Pctl":"88","Cleanups":6.9,"Clean_Pctl":50,"Groundwate":7.25,"GW_pctl":40,"Haz_Waste":0.01,"Haz_pctl":9,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":1,"Solid_pctl":33,"PollutionS":6.57,"Poll_pctl":80,"Asthma":66.69,"Asthma_Pct":76,"Low_Birth_":6.09,"LBW_pctl":"78","Cardiovasc":9.45,"CVD_pctl":68,"Education":37,"Edu_pctl":"84","Linguistic":18.5,"Ling_pctl":"82","Poverty":51.1,"Pov_pctl":"74","Unemployme":10.5,"Unem_pctl":"60","Housing_Bu":30.8,"HB_pctl":"89","PopCharSco":7.88,"Pop_Pctl":"88","Children__":15.7,"Pop_11_64_":75.7,"Elderly___":8.6,"Hispanic__":"68.3","White____":"4.8","African_Am":"19.7","Native_Ame":"0.3","Asian_Amer":"4.7","Other____":"2.2","Shape_Leng":3638.34138703,"Shape_Area":833177.349079}},{"arcs":[[1192,1193,1194,1195,1196,1197,1198,1199]],"type":"Polygon","properties":{"Tract_1":6037554512,"Percentile":"61-65%","Population":6108,"County":"Los Angeles","ZIP":90703,"City":"Cerritos","CIscore":30.84,"CIscoreP":"61","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":17.85,"DPM_pctl":54,"DrinkingWa":255.86,"DW_pctl":"26","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5776.73,"TR_pctl":84,"Traffic":1257.16,"Traff_Pctl":"77","Cleanups":12.25,"Clean_Pctl":70,"Groundwate":1.5,"GW_pctl":9,"Haz_Waste":1.02,"Haz_pctl":87,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0.5,"Solid_pctl":20,"PollutionS":6.34,"Poll_pctl":76,"Asthma":44.98,"Asthma_Pct":49,"Low_Birth_":6.58,"LBW_pctl":"86","Cardiovasc":9.59,"CVD_pctl":70,"Education":5.5,"Edu_pctl":"22","Linguistic":12.6,"Ling_pctl":"68","Poverty":12.3,"Pov_pctl":"11","Unemployme":2.2,"Unem_pctl":"1","Housing_Bu":12.8,"HB_pctl":"25","PopCharSco":4.86,"Pop_Pctl":"45","Children__":8.1,"Pop_11_64_":73.4,"Elderly___":18.5,"Hispanic__":"9.3","White____":"14.3","African_Am":"6.6","Native_Ame":"0","Asian_Amer":"66.9","Other____":"2.8","Shape_Leng":8066.78316088,"Shape_Area":3837486.47828}},{"arcs":[[1200,-1195,1201,-1193,1202,1203]],"type":"Polygon","properties":{"Tract_1":6037554517,"Percentile":"51-55%","Population":4883,"County":"Los Angeles","ZIP":90703,"City":"Cerritos","CIscore":27.28,"CIscoreP":"54","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":17.85,"DPM_pctl":54,"DrinkingWa":255.86,"DW_pctl":"26","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5715.68,"TR_pctl":83,"Traffic":1196.87,"Traff_Pctl":"75","Cleanups":1,"Clean_Pctl":18,"Groundwate":2,"GW_pctl":14,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0.7,"Solid_pctl":23,"PollutionS":5.08,"Poll_pctl":48,"Asthma":44.98,"Asthma_Pct":49,"Low_Birth_":6.07,"LBW_pctl":"78","Cardiovasc":9.59,"CVD_pctl":70,"Education":3.1,"Edu_pctl":"11","Linguistic":14.1,"Ling_pctl":"72","Poverty":17.7,"Pov_pctl":"22","Unemployme":8.2,"Unem_pctl":"41","Housing_Bu":16.7,"HB_pctl":"44","PopCharSco":5.37,"Pop_Pctl":"53","Children__":10,"Pop_11_64_":76.4,"Elderly___":13.6,"Hispanic__":"9.6","White____":"12.3","African_Am":"4","Native_Ame":"0.1","Asian_Amer":"70.8","Other____":"3.2","Shape_Leng":4841.13018112,"Shape_Area":1313983.68589}},{"arcs":[[-997,1204,-667,1205,-1000,1206,1207]],"type":"Polygon","properties":{"Tract_1":6037554515,"Percentile":"41-45%","Population":3703,"County":"Los Angeles","ZIP":90703,"City":"Cerritos","CIscore":22.13,"CIscoreP":"43","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":16.27,"DPM_pctl":50,"DrinkingWa":351.79,"DW_pctl":"37","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5831.34,"TR_pctl":84,"Traffic":497.63,"Traff_Pctl":"30","Cleanups":0,"Clean_Pctl":0,"Groundwate":10.75,"GW_pctl":51,"Haz_Waste":0.05,"Haz_pctl":26,"Imp__Water":2,"IWB_pctl":29,"Solid_Wast":1.65,"Solid_pctl":40,"PollutionS":4.8,"Poll_pctl":43,"Asthma":33.81,"Asthma_Pct":31,"Low_Birth_":8.29,"LBW_pctl":"98","Cardiovasc":7.05,"CVD_pctl":38,"Education":7.5,"Edu_pctl":"30","Linguistic":13.6,"Ling_pctl":"71","Poverty":17,"Pov_pctl":"20","Unemployme":6.2,"Unem_pctl":"22","Housing_Bu":12.2,"HB_pctl":"22","PopCharSco":4.61,"Pop_Pctl":"41","Children__":10.3,"Pop_11_64_":69.6,"Elderly___":20.1,"Hispanic__":"16","White____":"17.3","African_Am":"6","Native_Ame":"0","Asian_Amer":"57.4","Other____":"3.3","Shape_Leng":4978.16113861,"Shape_Area":1208799.57502}},{"arcs":[[1208,1209,1210,1211]],"type":"Polygon","properties":{"Tract_1":6037551300,"Percentile":"66-70%","Population":5422,"County":"Los Angeles","ZIP":90241,"City":"Downey","CIscore":34.45,"CIscoreP":"67","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":16.41,"DPM_pctl":50,"DrinkingWa":668.52,"DW_pctl":"79","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6551.43,"TR_pctl":87,"Traffic":906.78,"Traff_Pctl":"63","Cleanups":8.4,"Clean_Pctl":56,"Groundwate":53.75,"GW_pctl":92,"Haz_Waste":0.01,"Haz_pctl":9,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":1.1,"Solid_pctl":33,"PollutionS":6.26,"Poll_pctl":75,"Asthma":45.31,"Asthma_Pct":50,"Low_Birth_":3.78,"LBW_pctl":"22","Cardiovasc":8.65,"CVD_pctl":59,"Education":30.2,"Edu_pctl":"77","Linguistic":12.6,"Ling_pctl":"68","Poverty":48.5,"Pov_pctl":"71","Unemployme":7.5,"Unem_pctl":"34","Housing_Bu":21,"HB_pctl":"63","PopCharSco":5.5,"Pop_Pctl":"54","Children__":13.4,"Pop_11_64_":72.7,"Elderly___":13.9,"Hispanic__":"71.9","White____":"18","African_Am":"3.9","Native_Ame":"0.2","Asian_Amer":"4.9","Other____":"1","Shape_Leng":5056.57536135,"Shape_Area":1527924.99958}},{"arcs":[[1212,1213,1214,1215]],"type":"Polygon","properties":{"Tract_1":6037552800,"Percentile":"71-75%","Population":6401,"County":"Los Angeles","ZIP":90650,"City":"Norwalk","CIscore":37.91,"CIscoreP":"73","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":26.92,"DPM_pctl":80,"DrinkingWa":489.71,"DW_pctl":"52","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5319.04,"TR_pctl":82,"Traffic":572.41,"Traff_Pctl":"39","Cleanups":2,"Clean_Pctl":27,"Groundwate":9,"GW_pctl":46,"Haz_Waste":0.1,"Haz_pctl":43,"Imp__Water":3,"IWB_pctl":41,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.69,"Poll_pctl":62,"Asthma":62.88,"Asthma_Pct":72,"Low_Birth_":4.64,"LBW_pctl":"42","Cardiovasc":13.42,"CVD_pctl":94,"Education":29,"Edu_pctl":"75","Linguistic":14,"Ling_pctl":"72","Poverty":34.7,"Pov_pctl":"52","Unemployme":5.6,"Unem_pctl":"17","Housing_Bu":25.2,"HB_pctl":"77","PopCharSco":6.67,"Pop_Pctl":"72","Children__":16,"Pop_11_64_":77.2,"Elderly___":6.8,"Hispanic__":"72.1","White____":"12.5","African_Am":"3.3","Native_Ame":"0.1","Asian_Amer":"11","Other____":"1","Shape_Leng":4833.72284556,"Shape_Area":1292808.34675}},{"arcs":[[1216,1217,1218,1219,1220,1221]],"type":"Polygon","properties":{"Tract_1":6037552900,"Percentile":"76-80%","Population":6881,"County":"Los Angeles","ZIP":90650,"City":"Norwalk","CIscore":42.86,"CIscoreP":"80","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":26.93,"DPM_pctl":80,"DrinkingWa":350.5,"DW_pctl":"37","Pesticides":38.696,"Pest_pctl":69,"Tox_Releas":5404.88,"TR_pctl":82,"Traffic":551.4,"Traff_Pctl":"36","Cleanups":1,"Clean_Pctl":18,"Groundwate":7,"GW_pctl":39,"Haz_Waste":0.56,"Haz_pctl":79,"Imp__Water":3,"IWB_pctl":41,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":6.31,"Poll_pctl":76,"Asthma":62.19,"Asthma_Pct":71,"Low_Birth_":4.86,"LBW_pctl":"49","Cardiovasc":13.27,"CVD_pctl":94,"Education":21.8,"Edu_pctl":"65","Linguistic":12.8,"Ling_pctl":"69","Poverty":39.9,"Pov_pctl":"60","Unemployme":7.9,"Unem_pctl":"38","Housing_Bu":22,"HB_pctl":"67","PopCharSco":6.79,"Pop_Pctl":"73","Children__":14.2,"Pop_11_64_":76.1,"Elderly___":9.7,"Hispanic__":"61","White____":"14.6","African_Am":"5","Native_Ame":"0.2","Asian_Amer":"17.3","Other____":"1.9","Shape_Leng":4870.8634872,"Shape_Area":1306017.19447}},{"arcs":[[-928,-22,1222]],"type":"Polygon","properties":{"Tract_1":6037552400,"Percentile":"91-95%","Population":2794,"County":"Los Angeles","ZIP":90650,"City":"Norwalk","CIscore":54.65,"CIscoreP":"93","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":29.85,"DPM_pctl":85,"DrinkingWa":487.12,"DW_pctl":"52","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5540.84,"TR_pctl":83,"Traffic":1539.28,"Traff_Pctl":"84","Cleanups":12.75,"Clean_Pctl":71,"Groundwate":16.6,"GW_pctl":65,"Haz_Waste":1.44,"Haz_pctl":90,"Imp__Water":2,"IWB_pctl":29,"Solid_Wast":3.15,"Solid_pctl":62,"PollutionS":7.6,"Poll_pctl":93,"Asthma":62.78,"Asthma_Pct":72,"Low_Birth_":6.11,"LBW_pctl":"78","Cardiovasc":13.4,"CVD_pctl":94,"Education":37.6,"Edu_pctl":"85","Linguistic":5.4,"Ling_pctl":"39","Poverty":41.9,"Pov_pctl":"62","Unemployme":10.2,"Unem_pctl":"58","Housing_Bu":16.3,"HB_pctl":"42","PopCharSco":7.19,"Pop_Pctl":"79","Children__":16,"Pop_11_64_":76.4,"Elderly___":7.6,"Hispanic__":"83.9","White____":"6.4","African_Am":"2.1","Native_Ame":"0.4","Asian_Amer":"6.1","Other____":"1","Shape_Leng":4784.08571288,"Shape_Area":930611.443719}},{"arcs":[[1223,1224,1225,1226,1227,1228]],"type":"Polygon","properties":{"Tract_1":6037553000,"Percentile":"76-80%","Population":4825,"County":"Los Angeles","ZIP":90650,"City":"Norwalk","CIscore":39.41,"CIscoreP":"75","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":26.95,"DPM_pctl":80,"DrinkingWa":364.52,"DW_pctl":"38","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5498.68,"TR_pctl":82,"Traffic":2319.22,"Traff_Pctl":"94","Cleanups":1,"Clean_Pctl":18,"Groundwate":3,"GW_pctl":22,"Haz_Waste":0.7,"Haz_pctl":83,"Imp__Water":3,"IWB_pctl":41,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":6.23,"Poll_pctl":74,"Asthma":61.02,"Asthma_Pct":70,"Low_Birth_":5.94,"LBW_pctl":"75","Cardiovasc":13.02,"CVD_pctl":93,"Education":21.9,"Edu_pctl":"65","Linguistic":2.2,"Ling_pctl":"16","Poverty":29.4,"Pov_pctl":"44","Unemployme":8.1,"Unem_pctl":"40","Housing_Bu":17.5,"HB_pctl":"48","PopCharSco":6.33,"Pop_Pctl":"67","Children__":13.8,"Pop_11_64_":77.5,"Elderly___":8.7,"Hispanic__":"69.9","White____":"17.6","African_Am":"3.7","Native_Ame":"0.2","Asian_Amer":"7.4","Other____":"1.3","Shape_Leng":4962.73140088,"Shape_Area":1259340.00666}},{"arcs":[[-736,1229,1230,1231]],"type":"Polygon","properties":{"Tract_1":6037293304,"Percentile":"66-70%","Population":4178,"County":"Los Angeles","ZIP":90710,"City":"Harbor City","CIscore":35.32,"CIscoreP":"69","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":19.1,"DPM_pctl":59,"DrinkingWa":194.73,"DW_pctl":"15","Pesticides":0,"Pest_pctl":0,"Tox_Releas":7697.98,"TR_pctl":90,"Traffic":1063.34,"Traff_Pctl":"70","Cleanups":0.9,"Clean_Pctl":13,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.68,"Haz_pctl":82,"Imp__Water":9,"IWB_pctl":81,"Solid_Wast":2.9,"Solid_pctl":59,"PollutionS":5.82,"Poll_pctl":65,"Asthma":41.26,"Asthma_Pct":44,"Low_Birth_":4.81,"LBW_pctl":"47","Cardiovasc":7.21,"CVD_pctl":40,"Education":29.8,"Edu_pctl":"76","Linguistic":17.1,"Ling_pctl":"79","Poverty":44.3,"Pov_pctl":"66","Unemployme":13,"Unem_pctl":"76","Housing_Bu":22.5,"HB_pctl":"69","PopCharSco":6.07,"Pop_Pctl":"63","Children__":16,"Pop_11_64_":76.7,"Elderly___":7.3,"Hispanic__":"63","White____":"15.2","African_Am":"7.1","Native_Ame":"0.2","Asian_Amer":"12.3","Other____":"2.3","Shape_Leng":3027.13616248,"Shape_Area":569373.309721}},{"arcs":[[-115,1232,1233]],"type":"Polygon","properties":{"Tract_1":6037650605,"Percentile":"56-60%","Population":2763,"County":"Los Angeles","ZIP":90503,"City":"Torrance","CIscore":28.37,"CIscoreP":"57","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":15.7,"DPM_pctl":48,"DrinkingWa":192.1,"DW_pctl":"15","Pesticides":0,"Pest_pctl":0,"Tox_Releas":26432.02,"TR_pctl":99,"Traffic":790,"Traff_Pctl":"56","Cleanups":5.6,"Clean_Pctl":46,"Groundwate":11.05,"GW_pctl":52,"Haz_Waste":1.16,"Haz_pctl":88,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":3.25,"Solid_pctl":63,"PollutionS":6.03,"Poll_pctl":70,"Asthma":28.34,"Asthma_Pct":22,"Low_Birth_":5.49,"LBW_pctl":"66","Cardiovasc":6.44,"CVD_pctl":30,"Education":10,"Edu_pctl":"39","Linguistic":20.4,"Ling_pctl":"85","Poverty":27.3,"Pov_pctl":"40","Unemployme":9.1,"Unem_pctl":"49","Housing_Bu":17,"HB_pctl":"45","PopCharSco":4.71,"Pop_Pctl":"43","Children__":11.8,"Pop_11_64_":76.9,"Elderly___":11.3,"Hispanic__":"8.8","White____":"34.2","African_Am":"3.7","Native_Ame":"0.1","Asian_Amer":"49","Other____":"4.2","Shape_Leng":2802.54605725,"Shape_Area":484741.424702}},{"arcs":[[1234,1235,1236,1237]],"type":"Polygon","properties":{"Tract_1":6037650604,"Percentile":"36-40%","Population":5412,"County":"Los Angeles","ZIP":90503,"City":"Torrance","CIscore":19.97,"CIscoreP":"38","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":15.77,"DPM_pctl":48,"DrinkingWa":218.85,"DW_pctl":"17","Pesticides":0,"Pest_pctl":0,"Tox_Releas":15991.6,"TR_pctl":97,"Traffic":735.03,"Traff_Pctl":"53","Cleanups":0.25,"Clean_Pctl":5,"Groundwate":15,"GW_pctl":61,"Haz_Waste":1.04,"Haz_pctl":87,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":2.25,"Solid_pctl":53,"PollutionS":5.64,"Poll_pctl":61,"Asthma":28.34,"Asthma_Pct":22,"Low_Birth_":2.76,"LBW_pctl":"7","Cardiovasc":6.44,"CVD_pctl":30,"Education":6.2,"Edu_pctl":"25","Linguistic":16.8,"Ling_pctl":"79","Poverty":38.2,"Pov_pctl":"57","Unemployme":7,"Unem_pctl":"29","Housing_Bu":19,"HB_pctl":"55","PopCharSco":3.54,"Pop_Pctl":"25","Children__":11.9,"Pop_11_64_":76.7,"Elderly___":11.4,"Hispanic__":"18.3","White____":"28.9","African_Am":"5.4","Native_Ame":"0.3","Asian_Amer":"43.1","Other____":"4.1","Shape_Leng":2891.08758313,"Shape_Area":516061.831214}},{"arcs":[[1238,-312,1239,1240]],"type":"Polygon","properties":{"Tract_1":6037241202,"Percentile":"91-95%","Population":4943,"County":"Los Angeles","ZIP":90044,"City":"Los Angeles","CIscore":57.51,"CIscoreP":"95","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":24.76,"DPM_pctl":76,"DrinkingWa":664.07,"DW_pctl":"79","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5096.13,"TR_pctl":81,"Traffic":3690.19,"Traff_Pctl":"99","Cleanups":1,"Clean_Pctl":18,"Groundwate":3,"GW_pctl":22,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":2.65,"Solid_pctl":57,"PollutionS":6.66,"Poll_pctl":82,"Asthma":89.18,"Asthma_Pct":89,"Low_Birth_":8,"LBW_pctl":"97","Cardiovasc":10.09,"CVD_pctl":75,"Education":45.4,"Edu_pctl":"91","Linguistic":11.2,"Ling_pctl":"63","Poverty":69.1,"Pov_pctl":"92","Unemployme":11.7,"Unem_pctl":"68","Housing_Bu":27.1,"HB_pctl":"82","PopCharSco":8.63,"Pop_Pctl":"96","Children__":16.1,"Pop_11_64_":74.8,"Elderly___":9.1,"Hispanic__":"56","White____":"0.9","African_Am":"41","Native_Ame":"0.2","Asian_Amer":"0.3","Other____":"1.5","Shape_Leng":4275.11418235,"Shape_Area":1163643.11897}},{"arcs":[[-936,1241,1242,1243,1244,-1231,1245,1246,1247]],"type":"Polygon","properties":{"Tract_1":6037293302,"Percentile":"56-60%","Population":4720,"County":"Los Angeles","ZIP":90710,"City":"Harbor City","CIscore":29.77,"CIscoreP":"59","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":19.17,"DPM_pctl":59,"DrinkingWa":413.39,"DW_pctl":"43","Pesticides":0,"Pest_pctl":0,"Tox_Releas":7811.6,"TR_pctl":90,"Traffic":765.07,"Traff_Pctl":"55","Cleanups":10,"Clean_Pctl":63,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.43,"Haz_pctl":74,"Imp__Water":3,"IWB_pctl":41,"Solid_Wast":1.7,"Solid_pctl":40,"PollutionS":5.84,"Poll_pctl":65,"Asthma":38.08,"Asthma_Pct":39,"Low_Birth_":4.94,"LBW_pctl":"51","Cardiovasc":6.57,"CVD_pctl":31,"Education":20.7,"Edu_pctl":"63","Linguistic":10.4,"Ling_pctl":"60","Poverty":39.3,"Pov_pctl":"58","Unemployme":9,"Unem_pctl":"48","Housing_Bu":20.4,"HB_pctl":"61","PopCharSco":5.1,"Pop_Pctl":"49","Children__":13.7,"Pop_11_64_":76.4,"Elderly___":9.9,"Hispanic__":"44.7","White____":"24.3","African_Am":"5.7","Native_Ame":"0.1","Asian_Amer":"22.8","Other____":"2.5","Shape_Leng":4673.20159019,"Shape_Area":1116628.219}},{"arcs":[[1248,1249,1250,1251,1252,1253,1254,1255,1256,1257,1258,1259,1260,1261,1262,1263]],"type":"Polygon","properties":{"Tract_1":6037670403,"Percentile":"1-5%","Population":2407,"County":"Los Angeles","ZIP":90275,"City":"Rancho Palos Verdes","CIscore":5.62,"CIscoreP":"4","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":6.16,"DPM_pctl":17,"DrinkingWa":187.24,"DW_pctl":"14","Pesticides":0,"Pest_pctl":0,"Tox_Releas":4002.57,"TR_pctl":77,"Traffic":466.69,"Traff_Pctl":"27","Cleanups":4.5,"Clean_Pctl":42,"Groundwate":5,"GW_pctl":32,"Haz_Waste":0.02,"Haz_pctl":16,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":3.65,"Poll_pctl":19,"Asthma":10.14,"Asthma_Pct":1,"Low_Birth_":4,"LBW_pctl":"26","Cardiovasc":3.59,"CVD_pctl":2,"Education":1.4,"Edu_pctl":"3","Linguistic":7.8,"Ling_pctl":"50","Poverty":11.5,"Pov_pctl":"9","Unemployme":7.1,"Unem_pctl":"30","Housing_Bu":8.1,"HB_pctl":"7","PopCharSco":1.54,"Pop_Pctl":"4","Children__":9.6,"Pop_11_64_":62.8,"Elderly___":27.6,"Hispanic__":"5.5","White____":"54.1","African_Am":"1.3","Native_Ame":"0.2","Asian_Amer":"34.6","Other____":"4.2","Shape_Leng":5883.69863412,"Shape_Area":1669815.36778}},{"arcs":[[1264,1265,1266]],"type":"Polygon","properties":{"Tract_1":6037574100,"Percentile":"11-15%","Population":5098,"County":"Los Angeles","ZIP":90808,"City":"Long Beach","CIscore":10.66,"CIscoreP":"15","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":18.19,"DPM_pctl":56,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0.642,"Pest_pctl":35,"Tox_Releas":6407.55,"TR_pctl":86,"Traffic":446.27,"Traff_Pctl":"26","Cleanups":9.4,"Clean_Pctl":61,"Groundwate":9.3,"GW_pctl":47,"Haz_Waste":0.1,"Haz_pctl":32,"Imp__Water":9,"IWB_pctl":81,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.55,"Poll_pctl":59,"Asthma":25.77,"Asthma_Pct":17,"Low_Birth_":2.92,"LBW_pctl":"8","Cardiovasc":6.8,"CVD_pctl":34,"Education":5.6,"Edu_pctl":"22","Linguistic":0,"Ling_pctl":"0","Poverty":12.5,"Pov_pctl":"11","Unemployme":7.9,"Unem_pctl":"38","Housing_Bu":10.5,"HB_pctl":"15","PopCharSco":1.92,"Pop_Pctl":"7","Children__":12.3,"Pop_11_64_":74.4,"Elderly___":13.3,"Hispanic__":"18.2","White____":"68.3","African_Am":"1.9","Native_Ame":"0.2","Asian_Amer":"7.3","Other____":"4.1","Shape_Leng":6196.23819602,"Shape_Area":1839456.88533}},{"arcs":[[1267,1268,1269,1270,-1160]],"type":"Polygon","properties":{"Tract_1":6037574400,"Percentile":"31-35%","Population":5141,"County":"Los Angeles","ZIP":90815,"City":"Long Beach","CIscore":17.47,"CIscoreP":"32","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":18.33,"DPM_pctl":56,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":7042.64,"TR_pctl":88,"Traffic":1214.05,"Traff_Pctl":"76","Cleanups":9,"Clean_Pctl":60,"Groundwate":12.9,"GW_pctl":56,"Haz_Waste":0.1,"Haz_pctl":43,"Imp__Water":16,"IWB_pctl":97,"Solid_Wast":1,"Solid_pctl":33,"PollutionS":6.32,"Poll_pctl":76,"Asthma":29.27,"Asthma_Pct":24,"Low_Birth_":5,"LBW_pctl":"52","Cardiovasc":7.66,"CVD_pctl":46,"Education":5,"Edu_pctl":"20","Linguistic":0.5,"Ling_pctl":"2","Poverty":13,"Pov_pctl":"12","Unemployme":6.5,"Unem_pctl":"25","Housing_Bu":7,"HB_pctl":"5","PopCharSco":2.77,"Pop_Pctl":"16","Children__":11.3,"Pop_11_64_":72.9,"Elderly___":15.8,"Hispanic__":"15.5","White____":"69.1","African_Am":"2.8","Native_Ame":"0.4","Asian_Amer":"8.7","Other____":"3.5","Shape_Leng":7447.17001928,"Shape_Area":3399241.57906}},{"arcs":[[1271,1272,1273]],"type":"Polygon","properties":{"Tract_1":6037576802,"Percentile":"36-40%","Population":3992,"County":"Los Angeles","ZIP":90814,"City":"Long Beach","CIscore":19.72,"CIscoreP":"38","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":13.13,"DPM_pctl":39,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8529.35,"TR_pctl":91,"Traffic":1005.96,"Traff_Pctl":"68","Cleanups":0,"Clean_Pctl":0,"Groundwate":10.8,"GW_pctl":51,"Haz_Waste":0.2,"Haz_pctl":61,"Imp__Water":5,"IWB_pctl":55,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.07,"Poll_pctl":48,"Asthma":29.57,"Asthma_Pct":24,"Low_Birth_":5.05,"LBW_pctl":"54","Cardiovasc":5.14,"CVD_pctl":14,"Education":8.6,"Edu_pctl":"35","Linguistic":3,"Ling_pctl":"23","Poverty":32.3,"Pov_pctl":"48","Unemployme":8.7,"Unem_pctl":"45","Housing_Bu":23.3,"HB_pctl":"72","PopCharSco":3.89,"Pop_Pctl":"31","Children__":8.1,"Pop_11_64_":85,"Elderly___":6.9,"Hispanic__":"29.7","White____":"49.4","African_Am":"9.6","Native_Ame":"0.5","Asian_Amer":"6.9","Other____":"3.9","Shape_Leng":2823.30376366,"Shape_Area":467847.886354}},{"arcs":[[1274,1275,1276,1277,1278,-1273]],"type":"Polygon","properties":{"Tract_1":6037576801,"Percentile":"56-60%","Population":4325,"County":"Los Angeles","ZIP":90814,"City":"Long Beach","CIscore":27.63,"CIscoreP":"55","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":13.13,"DPM_pctl":39,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8744.54,"TR_pctl":92,"Traffic":764.43,"Traff_Pctl":"55","Cleanups":0,"Clean_Pctl":0,"Groundwate":6,"GW_pctl":36,"Haz_Waste":0.21,"Haz_pctl":62,"Imp__Water":5,"IWB_pctl":55,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.8,"Poll_pctl":42,"Asthma":28.78,"Asthma_Pct":23,"Low_Birth_":7.2,"LBW_pctl":"92","Cardiovasc":4.95,"CVD_pctl":12,"Education":23.8,"Edu_pctl":"68","Linguistic":3.9,"Ling_pctl":"29","Poverty":52.8,"Pov_pctl":"77","Unemployme":12.4,"Unem_pctl":"72","Housing_Bu":36.8,"HB_pctl":"96","PopCharSco":5.75,"Pop_Pctl":"58","Children__":9.9,"Pop_11_64_":81.8,"Elderly___":8.3,"Hispanic__":"36.1","White____":"41.9","African_Am":"11","Native_Ame":"0.5","Asian_Amer":"7.5","Other____":"2.9","Shape_Leng":3001.25792221,"Shape_Area":515537.496802}},{"arcs":[[1279,1280,1281,1282,1283,1284]],"type":"Polygon","properties":{"Tract_1":6037576700,"Percentile":"11-15%","Population":4047,"County":"Los Angeles","ZIP":90803,"City":"Long Beach","CIscore":8.83,"CIscoreP":"11","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":13.13,"DPM_pctl":39,"DrinkingWa":250.77,"DW_pctl":"25","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8655.36,"TR_pctl":92,"Traffic":997.27,"Traff_Pctl":"68","Cleanups":0,"Clean_Pctl":0,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":5,"IWB_pctl":55,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.23,"Poll_pctl":30,"Asthma":23.23,"Asthma_Pct":13,"Low_Birth_":3.97,"LBW_pctl":"25","Cardiovasc":5.9,"CVD_pctl":23,"Education":4.1,"Edu_pctl":"15","Linguistic":1.3,"Ling_pctl":"8","Poverty":26.6,"Pov_pctl":"39","Unemployme":6.2,"Unem_pctl":"22","Housing_Bu":10.7,"HB_pctl":"15","PopCharSco":2.09,"Pop_Pctl":"8","Children__":6.9,"Pop_11_64_":80.2,"Elderly___":12.9,"Hispanic__":"19.4","White____":"64.7","African_Am":"5.6","Native_Ame":"0.4","Asian_Amer":"6.3","Other____":"3.7","Shape_Leng":3625.20493379,"Shape_Area":781762.113197}},{"arcs":[[1285,1286,1287,1288,1289,-91,1290,1291]],"type":"Polygon","properties":{"Tract_1":6037576601,"Percentile":"66-70%","Population":4399,"County":"Los Angeles","ZIP":90802,"City":"Long Beach","CIscore":35.49,"CIscoreP":"69","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":208.4,"DPM_pctl":100,"DrinkingWa":252.97,"DW_pctl":"26","Pesticides":0,"Pest_pctl":0,"Tox_Releas":9112.31,"TR_pctl":92,"Traffic":614.32,"Traff_Pctl":"43","Cleanups":2,"Clean_Pctl":27,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.06,"Haz_pctl":28,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":11,"Solid_pctl":91,"PollutionS":5.93,"Poll_pctl":67,"Asthma":83.08,"Asthma_Pct":87,"Low_Birth_":6.86,"LBW_pctl":"89","Cardiovasc":9.29,"CVD_pctl":66,"Education":5.6,"Edu_pctl":"22","Linguistic":3.4,"Ling_pctl":"26","Poverty":28,"Pov_pctl":"41","Unemployme":6.7,"Unem_pctl":"26","Housing_Bu":19.6,"HB_pctl":"57","PopCharSco":5.98,"Pop_Pctl":"62","Children__":5.7,"Pop_11_64_":85.2,"Elderly___":9.1,"Hispanic__":"25.8","White____":"48.8","African_Am":"13.6","Native_Ame":"0.5","Asian_Amer":"7.5","Other____":"3.8","Shape_Leng":3203.96508112,"Shape_Area":462246.590853}},{"arcs":[[[1292,1293,1294,-94]],[[1295,-1289,1296]],[[1297,1298,-1286,1299,1300,-1283]]],"type":"MultiPolygon","properties":{"Tract_1":6037576602,"Percentile":"41-45%","Population":3995,"County":"Los Angeles","ZIP":90802,"City":"Long Beach","CIscore":21.19,"CIscoreP":"41","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":81.21,"DPM_pctl":99,"DrinkingWa":255.06,"DW_pctl":"26","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8555.85,"TR_pctl":91,"Traffic":751.92,"Traff_Pctl":"54","Cleanups":0.25,"Clean_Pctl":5,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":5,"IWB_pctl":55,"Solid_Wast":2.75,"Solid_pctl":59,"PollutionS":5.28,"Poll_pctl":53,"Asthma":48.18,"Asthma_Pct":54,"Low_Birth_":5.99,"LBW_pctl":"76","Cardiovasc":6.21,"CVD_pctl":26,"Education":3,"Edu_pctl":"10","Linguistic":2.1,"Ling_pctl":"15","Poverty":25.3,"Pov_pctl":"37","Unemployme":6.8,"Unem_pctl":"27","Housing_Bu":15.4,"HB_pctl":"37","PopCharSco":4.01,"Pop_Pctl":"33","Children__":4.1,"Pop_11_64_":84.3,"Elderly___":11.6,"Hispanic__":"22.3","White____":"57.9","African_Am":"8.2","Native_Ame":"0.3","Asian_Amer":"7.2","Other____":"4.1","Shape_Leng":11944.6008873,"Shape_Area":1025217.43679}},{"arcs":[[1301,1302,1303,1304,1305]],"type":"Polygon","properties":{"Tract_1":6037576501,"Percentile":"71-75%","Population":3369,"County":"Los Angeles","ZIP":90802,"City":"Long Beach","CIscore":36.94,"CIscoreP":"72","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":208.4,"DPM_pctl":100,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":9479.85,"TR_pctl":93,"Traffic":669.67,"Traff_Pctl":"48","Cleanups":2,"Clean_Pctl":27,"Groundwate":3,"GW_pctl":22,"Haz_Waste":0.05,"Haz_pctl":26,"Imp__Water":5,"IWB_pctl":55,"Solid_Wast":5.5,"Solid_pctl":76,"PollutionS":5.88,"Poll_pctl":66,"Asthma":77.98,"Asthma_Pct":84,"Low_Birth_":4.38,"LBW_pctl":"35","Cardiovasc":8.64,"CVD_pctl":59,"Education":22.3,"Edu_pctl":"66","Linguistic":8,"Ling_pctl":"51","Poverty":48.5,"Pov_pctl":"71","Unemployme":7.8,"Unem_pctl":"37","Housing_Bu":28.3,"HB_pctl":"84","PopCharSco":6.29,"Pop_Pctl":"66","Children__":13.4,"Pop_11_64_":78.4,"Elderly___":8.2,"Hispanic__":"46.4","White____":"27.5","African_Am":"17.1","Native_Ame":"0.3","Asian_Amer":"5.5","Other____":"3.2","Shape_Leng":2221.67157951,"Shape_Area":289629.839321}},{"arcs":[[1306,1307,1308,-1278]],"type":"Polygon","properties":{"Tract_1":6037576503,"Percentile":"36-40%","Population":4454,"County":"Los Angeles","ZIP":90802,"City":"Long Beach","CIscore":20.21,"CIscoreP":"39","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":13.13,"DPM_pctl":39,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8893.23,"TR_pctl":92,"Traffic":709.45,"Traff_Pctl":"51","Cleanups":0.1,"Clean_Pctl":2,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.01,"Haz_pctl":9,"Imp__Water":5,"IWB_pctl":55,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.04,"Poll_pctl":26,"Asthma":45.3,"Asthma_Pct":50,"Low_Birth_":5.21,"LBW_pctl":"58","Cardiovasc":5.43,"CVD_pctl":17,"Education":17.1,"Edu_pctl":"57","Linguistic":4.6,"Ling_pctl":"34","Poverty":52.4,"Pov_pctl":"76","Unemployme":5.7,"Unem_pctl":"18","Housing_Bu":30.7,"HB_pctl":"89","PopCharSco":5,"Pop_Pctl":"47","Children__":12.6,"Pop_11_64_":78.5,"Elderly___":8.9,"Hispanic__":"46.9","White____":"27.6","African_Am":"14.7","Native_Ame":"0.4","Asian_Amer":"7.5","Other____":"2.9","Shape_Leng":2410.91972262,"Shape_Area":312032.218806}},{"arcs":[[-102,1309,1310,1311,-1304,1312]],"type":"Polygon","properties":{"Tract_1":6037576200,"Percentile":"86-90%","Population":6158,"County":"Los Angeles","ZIP":90802,"City":"Long Beach","CIscore":48.56,"CIscoreP":"87","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":208.4,"DPM_pctl":100,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0.967,"Pest_pctl":38,"Tox_Releas":9832.28,"TR_pctl":93,"Traffic":481.95,"Traff_Pctl":"29","Cleanups":3,"Clean_Pctl":33,"Groundwate":6.3,"GW_pctl":37,"Haz_Waste":0.3,"Haz_pctl":69,"Imp__Water":5,"IWB_pctl":55,"Solid_Wast":5.5,"Solid_pctl":76,"PollutionS":6.64,"Poll_pctl":82,"Asthma":73.7,"Asthma_Pct":81,"Low_Birth_":7.53,"LBW_pctl":"94","Cardiovasc":8.09,"CVD_pctl":52,"Education":27.6,"Edu_pctl":"74","Linguistic":8.1,"Ling_pctl":"52","Poverty":66.9,"Pov_pctl":"91","Unemployme":5.6,"Unem_pctl":"17","Housing_Bu":33.7,"HB_pctl":"93","PopCharSco":7.31,"Pop_Pctl":"81","Children__":11.8,"Pop_11_64_":80.2,"Elderly___":8,"Hispanic__":"46.5","White____":"24.4","African_Am":"19.8","Native_Ame":"0.7","Asian_Amer":"5.7","Other____":"2.9","Shape_Leng":3418.74584284,"Shape_Area":697262.796798}},{"arcs":[[-85,1313,1314]],"type":"Polygon","properties":{"Tract_1":6037576401,"Percentile":"86-90%","Population":4779,"County":"Los Angeles","ZIP":90813,"City":"Long Beach","CIscore":49.89,"CIscoreP":"89","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":163.33,"DPM_pctl":100,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":9305.19,"TR_pctl":93,"Traffic":895.51,"Traff_Pctl":"62","Cleanups":0.25,"Clean_Pctl":5,"Groundwate":8,"GW_pctl":43,"Haz_Waste":0.07,"Haz_pctl":29,"Imp__Water":4,"IWB_pctl":49,"Solid_Wast":1.1,"Solid_pctl":33,"PollutionS":5.66,"Poll_pctl":61,"Asthma":101.72,"Asthma_Pct":93,"Low_Birth_":6.7,"LBW_pctl":"87","Cardiovasc":10.02,"CVD_pctl":75,"Education":48.8,"Edu_pctl":"93","Linguistic":17.9,"Ling_pctl":"81","Poverty":82.1,"Pov_pctl":"99","Unemployme":9.8,"Unem_pctl":"54","Housing_Bu":39.7,"HB_pctl":"98","PopCharSco":8.82,"Pop_Pctl":"97","Children__":18.2,"Pop_11_64_":77.2,"Elderly___":4.6,"Hispanic__":"67.7","White____":"5.9","African_Am":"10.7","Native_Ame":"0.2","Asian_Amer":"13.9","Other____":"1.7","Shape_Leng":2413.41350498,"Shape_Area":324248.633795}},{"arcs":[[-1309,1315,1316,1317]],"type":"Polygon","properties":{"Tract_1":6037576403,"Percentile":"76-80%","Population":5033,"County":"Los Angeles","ZIP":90813,"City":"Long Beach","CIscore":42.47,"CIscoreP":"80","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":18.81,"DPM_pctl":58,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8758.72,"TR_pctl":92,"Traffic":886.35,"Traff_Pctl":"62","Cleanups":0,"Clean_Pctl":0,"Groundwate":3,"GW_pctl":22,"Haz_Waste":0.11,"Haz_pctl":46,"Imp__Water":4,"IWB_pctl":49,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.81,"Poll_pctl":43,"Asthma":88.07,"Asthma_Pct":89,"Low_Birth_":6.56,"LBW_pctl":"86","Cardiovasc":8.81,"CVD_pctl":61,"Education":45.2,"Edu_pctl":"91","Linguistic":19.2,"Ling_pctl":"83","Poverty":72.2,"Pov_pctl":"94","Unemployme":19,"Unem_pctl":"94","Housing_Bu":37.7,"HB_pctl":"97","PopCharSco":8.83,"Pop_Pctl":"97","Children__":17.7,"Pop_11_64_":78.5,"Elderly___":3.8,"Hispanic__":"53.5","White____":"7.4","African_Am":"17.2","Native_Ame":"0.6","Asian_Amer":"18.9","Other____":"2.4","Shape_Leng":2418.09301533,"Shape_Area":325040.47898}},{"arcs":[[1318,1319,1320,1321,1322,-876,1323,-52,1324]],"type":"Polygon","properties":{"Tract_1":6037294110,"Percentile":"76-80%","Population":4140,"County":"Los Angeles","ZIP":90744,"City":"Wilmington","CIscore":40.11,"CIscoreP":"76","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":26.13,"DPM_pctl":79,"DrinkingWa":230.13,"DW_pctl":"23","Pesticides":4.304,"Pest_pctl":52,"Tox_Releas":10604.13,"TR_pctl":94,"Traffic":845.52,"Traff_Pctl":"60","Cleanups":3.65,"Clean_Pctl":35,"Groundwate":19,"GW_pctl":69,"Haz_Waste":8.63,"Haz_pctl":99,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":6.9,"Solid_pctl":81,"PollutionS":7.09,"Poll_pctl":88,"Asthma":53.39,"Asthma_Pct":61,"Low_Birth_":4.76,"LBW_pctl":"46","Cardiovasc":8.14,"CVD_pctl":53,"Education":36.3,"Edu_pctl":"83","Linguistic":11.1,"Ling_pctl":"63","Poverty":42.9,"Pov_pctl":"64","Unemployme":7.9,"Unem_pctl":"38","Housing_Bu":14.5,"HB_pctl":"33","PopCharSco":5.66,"Pop_Pctl":"57","Children__":15.1,"Pop_11_64_":75.5,"Elderly___":9.4,"Hispanic__":"86.3","White____":"6.4","African_Am":"1.2","Native_Ame":"0.1","Asian_Amer":"5","Other____":"0.9","Shape_Leng":5109.96580339,"Shape_Area":993615.8646}},{"arcs":[[1325,-630,1326,1327,1328]],"type":"Polygon","properties":{"Tract_1":6037294610,"Percentile":"86-90%","Population":4065,"County":"Los Angeles","ZIP":90744,"City":"Wilmington","CIscore":51.01,"CIscoreP":"90","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":30.87,"DPM_pctl":86,"DrinkingWa":198.88,"DW_pctl":"15","Pesticides":2.759,"Pest_pctl":48,"Tox_Releas":9448.88,"TR_pctl":93,"Traffic":1073.7,"Traff_Pctl":"71","Cleanups":4.4,"Clean_Pctl":40,"Groundwate":19.95,"GW_pctl":70,"Haz_Waste":0.96,"Haz_pctl":86,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":5.4,"Solid_pctl":75,"PollutionS":7.05,"Poll_pctl":87,"Asthma":70.22,"Asthma_Pct":79,"Low_Birth_":4.09,"LBW_pctl":"28","Cardiovasc":10.57,"CVD_pctl":79,"Education":43.5,"Edu_pctl":"90","Linguistic":17.1,"Ling_pctl":"79","Poverty":59.8,"Pov_pctl":"84","Unemployme":9.2,"Unem_pctl":"49","Housing_Bu":28.6,"HB_pctl":"85","PopCharSco":7.24,"Pop_Pctl":"80","Children__":17.1,"Pop_11_64_":73.3,"Elderly___":9.6,"Hispanic__":"92.3","White____":"4.1","African_Am":"1.1","Native_Ame":"0.2","Asian_Amer":"1.6","Other____":"0.6","Shape_Leng":3639.09690639,"Shape_Area":818685.646389}},{"arcs":[[1329,1330,1331,-1092,1332,-730]],"type":"Polygon","properties":{"Tract_1":6037543604,"Percentile":"76-80%","Population":5620,"County":"Los Angeles","ZIP":90745,"City":"Carson","CIscore":39.4,"CIscoreP":"75","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":20.01,"DPM_pctl":62,"DrinkingWa":182.06,"DW_pctl":"14","Pesticides":81.063,"Pest_pctl":75,"Tox_Releas":14358.78,"TR_pctl":96,"Traffic":1279.31,"Traff_Pctl":"78","Cleanups":2.75,"Clean_Pctl":31,"Groundwate":6.05,"GW_pctl":36,"Haz_Waste":1.15,"Haz_pctl":88,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":1,"Solid_pctl":33,"PollutionS":6.5,"Poll_pctl":79,"Asthma":60.31,"Asthma_Pct":70,"Low_Birth_":9.59,"LBW_pctl":"100","Cardiovasc":9.96,"CVD_pctl":74,"Education":18.9,"Edu_pctl":"60","Linguistic":2.5,"Ling_pctl":"18","Poverty":13.8,"Pov_pctl":"14","Unemployme":13.8,"Unem_pctl":"79","Housing_Bu":8.4,"HB_pctl":"8","PopCharSco":6.06,"Pop_Pctl":"63","Children__":11.6,"Pop_11_64_":73.1,"Elderly___":15.3,"Hispanic__":"34.6","White____":"9.1","African_Am":"5.3","Native_Ame":"0.1","Asian_Amer":"47.8","Other____":"3.1","Shape_Leng":6881.73097047,"Shape_Area":2626557.72703}},{"arcs":[[1333,1334,1335,-1308]],"type":"Polygon","properties":{"Tract_1":6037576502,"Percentile":"71-75%","Population":4543,"County":"Los Angeles","ZIP":90802,"City":"Long Beach","CIscore":37.21,"CIscoreP":"72","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":194.97,"DPM_pctl":100,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":9393.38,"TR_pctl":93,"Traffic":742.01,"Traff_Pctl":"53","Cleanups":0.25,"Clean_Pctl":5,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.02,"Haz_pctl":10,"Imp__Water":5,"IWB_pctl":55,"Solid_Wast":2.75,"Solid_pctl":59,"PollutionS":5.3,"Poll_pctl":53,"Asthma":73.31,"Asthma_Pct":81,"Low_Birth_":5.93,"LBW_pctl":"75","Cardiovasc":8.04,"CVD_pctl":51,"Education":14.6,"Edu_pctl":"51","Linguistic":4.5,"Ling_pctl":"33","Poverty":58.2,"Pov_pctl":"82","Unemployme":15.9,"Unem_pctl":"87","Housing_Bu":25.3,"HB_pctl":"77","PopCharSco":7.02,"Pop_Pctl":"77","Children__":12.4,"Pop_11_64_":83.3,"Elderly___":4.3,"Hispanic__":"45.7","White____":"26","African_Am":"17.5","Native_Ame":"0.5","Asian_Amer":"6.4","Other____":"3.9","Shape_Leng":2447.18598801,"Shape_Area":307211.977504}},{"arcs":[[1336,-632,1337,-1329,1338]],"type":"Polygon","properties":{"Tract_1":6037294620,"Percentile":"96-100%","Population":4219,"County":"Los Angeles","ZIP":90744,"City":"Wilmington","CIscore":62.11,"CIscoreP":"97","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":36.66,"DPM_pctl":91,"DrinkingWa":198.88,"DW_pctl":"15","Pesticides":0,"Pest_pctl":0,"Tox_Releas":10211.22,"TR_pctl":94,"Traffic":949.48,"Traff_Pctl":"65","Cleanups":11.75,"Clean_Pctl":66,"Groundwate":36.1,"GW_pctl":86,"Haz_Waste":18.74,"Haz_pctl":100,"Imp__Water":16,"IWB_pctl":97,"Solid_Wast":11.1,"Solid_pctl":91,"PollutionS":7.88,"Poll_pctl":95,"Asthma":70.22,"Asthma_Pct":79,"Low_Birth_":5.04,"LBW_pctl":"53","Cardiovasc":10.57,"CVD_pctl":79,"Education":46,"Edu_pctl":"92","Linguistic":23.5,"Ling_pctl":"89","Poverty":56.6,"Pov_pctl":"81","Unemployme":10.9,"Unem_pctl":"63","Housing_Bu":28.4,"HB_pctl":"85","PopCharSco":7.88,"Pop_Pctl":"88","Children__":16.1,"Pop_11_64_":75.1,"Elderly___":8.8,"Hispanic__":"95.5","White____":"1.5","African_Am":"1.7","Native_Ame":"0","Asian_Amer":"0.9","Other____":"0.4","Shape_Leng":3851.60195504,"Shape_Area":846987.233285}},{"arcs":[[1339,-634,1340,1341,-728]],"type":"Polygon","properties":{"Tract_1":6037294410,"Percentile":"81-85%","Population":4579,"County":"Los Angeles","ZIP":90710,"City":"Harbor City","CIscore":44.42,"CIscoreP":"82","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":20.01,"DPM_pctl":62,"DrinkingWa":420.9,"DW_pctl":"44","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8483.01,"TR_pctl":91,"Traffic":1424.73,"Traff_Pctl":"81","Cleanups":9,"Clean_Pctl":60,"Groundwate":3.8,"GW_pctl":25,"Haz_Waste":0.55,"Haz_pctl":78,"Imp__Water":12,"IWB_pctl":91,"Solid_Wast":3.2,"Solid_pctl":63,"PollutionS":7.02,"Poll_pctl":87,"Asthma":44.56,"Asthma_Pct":49,"Low_Birth_":5.58,"LBW_pctl":"68","Cardiovasc":7.77,"CVD_pctl":48,"Education":19.5,"Edu_pctl":"61","Linguistic":10.7,"Ling_pctl":"61","Poverty":54.7,"Pov_pctl":"79","Unemployme":13.5,"Unem_pctl":"78","Housing_Bu":19.7,"HB_pctl":"58","PopCharSco":6.33,"Pop_Pctl":"67","Children__":16.5,"Pop_11_64_":75.4,"Elderly___":8.1,"Hispanic__":"40.9","White____":"13.5","African_Am":"23.9","Native_Ame":"0.1","Asian_Amer":"18.4","Other____":"3.1","Shape_Leng":3837.57256588,"Shape_Area":837411.29129}},{"arcs":[[1342,-731,1343,-1322,1344]],"type":"Polygon","properties":{"Tract_1":6037294200,"Percentile":"76-80%","Population":4951,"County":"Los Angeles","ZIP":90744,"City":"Wilmington","CIscore":40.31,"CIscoreP":"77","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":20.01,"DPM_pctl":62,"DrinkingWa":228.23,"DW_pctl":"22","Pesticides":5.316,"Pest_pctl":53,"Tox_Releas":10530.32,"TR_pctl":94,"Traffic":980.53,"Traff_Pctl":"67","Cleanups":5,"Clean_Pctl":44,"Groundwate":51.25,"GW_pctl":91,"Haz_Waste":1.76,"Haz_pctl":91,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":1.7,"Solid_pctl":40,"PollutionS":6.84,"Poll_pctl":85,"Asthma":66.68,"Asthma_Pct":76,"Low_Birth_":3.55,"LBW_pctl":"17","Cardiovasc":10.06,"CVD_pctl":75,"Education":21.7,"Edu_pctl":"65","Linguistic":12.7,"Ling_pctl":"68","Poverty":41.3,"Pov_pctl":"61","Unemployme":7.7,"Unem_pctl":"36","Housing_Bu":19.6,"HB_pctl":"57","PopCharSco":5.89,"Pop_Pctl":"60","Children__":15.9,"Pop_11_64_":74.8,"Elderly___":9.3,"Hispanic__":"87.7","White____":"6.5","African_Am":"0.9","Native_Ame":"0.3","Asian_Amer":"3.2","Other____":"1.4","Shape_Leng":3929.85348227,"Shape_Area":956675.819102}},{"arcs":[[1345,1346,1347,1348,1349]],"type":"Polygon","properties":{"Tract_1":6037543903,"Percentile":"91-95%","Population":3804,"County":"Los Angeles","ZIP":90745,"City":"Carson","CIscore":51.84,"CIscoreP":"91","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":25.32,"DPM_pctl":77,"DrinkingWa":182.06,"DW_pctl":"14","Pesticides":0.007,"Pest_pctl":7,"Tox_Releas":8128.23,"TR_pctl":91,"Traffic":2135.4,"Traff_Pctl":"92","Cleanups":35.8,"Clean_Pctl":93,"Groundwate":64,"GW_pctl":94,"Haz_Waste":5.5,"Haz_pctl":97,"Imp__Water":14,"IWB_pctl":94,"Solid_Wast":3.45,"Solid_pctl":63,"PollutionS":8.1,"Poll_pctl":97,"Asthma":60.31,"Asthma_Pct":70,"Low_Birth_":6.04,"LBW_pctl":"77","Cardiovasc":9.96,"CVD_pctl":74,"Education":15.3,"Edu_pctl":"53","Linguistic":14.6,"Ling_pctl":"73","Poverty":28.3,"Pov_pctl":"42","Unemployme":10.1,"Unem_pctl":"57","Housing_Bu":12.5,"HB_pctl":"24","PopCharSco":6.4,"Pop_Pctl":"68","Children__":12.2,"Pop_11_64_":73.8,"Elderly___":14,"Hispanic__":"43.1","White____":"8","African_Am":"5","Native_Ame":"0","Asian_Amer":"41.4","Other____":"2.5","Shape_Leng":6557.9867311,"Shape_Area":1360112.3315}},{"arcs":[[1350,1351,1352,1353,-1176]],"type":"Polygon","properties":{"Tract_1":6037572202,"Percentile":"71-75%","Population":3609,"County":"Los Angeles","ZIP":90806,"City":"Long Beach","CIscore":37.26,"CIscoreP":"72","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":29.12,"DPM_pctl":84,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":9126.59,"TR_pctl":92,"Traffic":821.18,"Traff_Pctl":"58","Cleanups":8.25,"Clean_Pctl":56,"Groundwate":14.3,"GW_pctl":59,"Haz_Waste":0.23,"Haz_pctl":63,"Imp__Water":11,"IWB_pctl":90,"Solid_Wast":12.5,"Solid_pctl":93,"PollutionS":7.08,"Poll_pctl":88,"Asthma":94.23,"Asthma_Pct":91,"Low_Birth_":3.97,"LBW_pctl":"25","Cardiovasc":10.75,"CVD_pctl":81,"Education":14.1,"Edu_pctl":"50","Linguistic":6.7,"Ling_pctl":"45","Poverty":19.1,"Pov_pctl":"25","Unemployme":8.3,"Unem_pctl":"41","Housing_Bu":11,"HB_pctl":"17","PopCharSco":5.27,"Pop_Pctl":"51","Children__":12.1,"Pop_11_64_":74.6,"Elderly___":13.3,"Hispanic__":"34.3","White____":"17.3","African_Am":"15.4","Native_Ame":"0.2","Asian_Amer":"30","Other____":"2.8","Shape_Leng":5478.21341552,"Shape_Area":1546203.68469}},{"arcs":[[-1095,1354,1355,-476]],"type":"Polygon","properties":{"Tract_1":6037543701,"Percentile":"66-70%","Population":2994,"County":"Los Angeles","ZIP":90745,"City":"Carson","CIscore":33.4,"CIscoreP":"66","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":23.9,"DPM_pctl":73,"DrinkingWa":182.06,"DW_pctl":"14","Pesticides":0,"Pest_pctl":0,"Tox_Releas":7780.3,"TR_pctl":90,"Traffic":544.23,"Traff_Pctl":"36","Cleanups":3.3,"Clean_Pctl":34,"Groundwate":8.4,"GW_pctl":43,"Haz_Waste":0.26,"Haz_pctl":67,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.82,"Poll_pctl":43,"Asthma":60.31,"Asthma_Pct":70,"Low_Birth_":6.32,"LBW_pctl":"82","Cardiovasc":9.96,"CVD_pctl":74,"Education":33.6,"Edu_pctl":"80","Linguistic":16.8,"Ling_pctl":"79","Poverty":31.5,"Pov_pctl":"47","Unemployme":6.6,"Unem_pctl":"25","Housing_Bu":20.2,"HB_pctl":"60","PopCharSco":6.93,"Pop_Pctl":"75","Children__":11.8,"Pop_11_64_":77,"Elderly___":11.2,"Hispanic__":"50","White____":"7.5","African_Am":"1.6","Native_Ame":"0.1","Asian_Amer":"39.2","Other____":"1.6","Shape_Leng":3394.08590666,"Shape_Area":635914.028739}},{"arcs":[[-959,-944,1356,-242]],"type":"Polygon","properties":{"Tract_1":6037602105,"Percentile":"91-95%","Population":4273,"County":"Los Angeles","ZIP":90250,"City":"Hawthorne","CIscore":55.44,"CIscoreP":"94","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":30.76,"DPM_pctl":86,"DrinkingWa":320.15,"DW_pctl":"34","Pesticides":0.008,"Pest_pctl":7,"Tox_Releas":5054.43,"TR_pctl":80,"Traffic":998.5,"Traff_Pctl":"68","Cleanups":14.5,"Clean_Pctl":76,"Groundwate":19.05,"GW_pctl":69,"Haz_Waste":0.08,"Haz_pctl":31,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":6.7,"Poll_pctl":83,"Asthma":78.54,"Asthma_Pct":84,"Low_Birth_":7.64,"LBW_pctl":"95","Cardiovasc":10.73,"CVD_pctl":81,"Education":39.9,"Edu_pctl":"87","Linguistic":15.2,"Ling_pctl":"75","Poverty":60.3,"Pov_pctl":"85","Unemployme":7.5,"Unem_pctl":"34","Housing_Bu":28.2,"HB_pctl":"84","PopCharSco":8.27,"Pop_Pctl":"92","Children__":15.8,"Pop_11_64_":77.3,"Elderly___":6.9,"Hispanic__":"66.6","White____":"6.4","African_Am":"19.5","Native_Ame":"0.4","Asian_Amer":"5.5","Other____":"1.6","Shape_Leng":3188.96405694,"Shape_Area":635560.531478}},{"arcs":[[1357,1358,1359,1360,-536]],"type":"Polygon","properties":{"Tract_1":6037601600,"Percentile":"96-100%","Population":4375,"County":"Los Angeles","ZIP":90304,"City":"Inglewood","CIscore":65.05,"CIscoreP":"98","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":38.92,"DPM_pctl":93,"DrinkingWa":287.5,"DW_pctl":"30","Pesticides":4.756,"Pest_pctl":52,"Tox_Releas":4095.51,"TR_pctl":77,"Traffic":2827.76,"Traff_Pctl":"97","Cleanups":10.4,"Clean_Pctl":64,"Groundwate":39.3,"GW_pctl":87,"Haz_Waste":0.1,"Haz_pctl":43,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":2,"Solid_pctl":50,"PollutionS":7.53,"Poll_pctl":93,"Asthma":68.69,"Asthma_Pct":78,"Low_Birth_":6.04,"LBW_pctl":"77","Cardiovasc":11.11,"CVD_pctl":84,"Education":48.3,"Edu_pctl":"93","Linguistic":31.7,"Ling_pctl":"95","Poverty":51.3,"Pov_pctl":"75","Unemployme":12.8,"Unem_pctl":"75","Housing_Bu":39,"HB_pctl":"97","PopCharSco":8.64,"Pop_Pctl":"96","Children__":17.3,"Pop_11_64_":75.4,"Elderly___":7.3,"Hispanic__":"92.5","White____":"2.5","African_Am":"2.2","Native_Ame":"0","Asian_Amer":"2.2","Other____":"0.5","Shape_Leng":3917.29746738,"Shape_Area":913310.616086}},{"arcs":[[1361,1362,1363,-1190,1364,-1358,1365,1366]],"type":"Polygon","properties":{"Tract_1":6037601700,"Percentile":"91-95%","Population":5646,"County":"Los Angeles","ZIP":90304,"City":"Inglewood","CIscore":54.8,"CIscoreP":"93","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":38.92,"DPM_pctl":93,"DrinkingWa":255.67,"DW_pctl":"26","Pesticides":15.451,"Pest_pctl":62,"Tox_Releas":4611.89,"TR_pctl":79,"Traffic":2630.69,"Traff_Pctl":"96","Cleanups":0.8,"Clean_Pctl":11,"Groundwate":6,"GW_pctl":36,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":6.65,"Poll_pctl":82,"Asthma":63.66,"Asthma_Pct":73,"Low_Birth_":6.79,"LBW_pctl":"88","Cardiovasc":10.07,"CVD_pctl":75,"Education":51.9,"Edu_pctl":"95","Linguistic":20.7,"Ling_pctl":"85","Poverty":61.1,"Pov_pctl":"85","Unemployme":7.6,"Unem_pctl":"35","Housing_Bu":41.9,"HB_pctl":"99","PopCharSco":8.24,"Pop_Pctl":"92","Children__":16.9,"Pop_11_64_":78.7,"Elderly___":4.4,"Hispanic__":"91","White____":"1.7","African_Am":"4.7","Native_Ame":"0.1","Asian_Amer":"1.9","Other____":"0.6","Shape_Leng":3868.22041686,"Shape_Area":783159.382309}},{"arcs":[[1367,1368,1369,1370]],"type":"Polygon","properties":{"Tract_1":6037601801,"Percentile":"81-85%","Population":3789,"County":"Los Angeles","ZIP":90304,"City":"Inglewood","CIscore":44.96,"CIscoreP":"83","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":38.92,"DPM_pctl":93,"DrinkingWa":290.56,"DW_pctl":"31","Pesticides":15.256,"Pest_pctl":62,"Tox_Releas":4151.58,"TR_pctl":77,"Traffic":1015.03,"Traff_Pctl":"68","Cleanups":0,"Clean_Pctl":0,"Groundwate":1.5,"GW_pctl":9,"Haz_Waste":0.1,"Haz_pctl":43,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.74,"Poll_pctl":63,"Asthma":53.61,"Asthma_Pct":61,"Low_Birth_":5.6,"LBW_pctl":"68","Cardiovasc":8.18,"CVD_pctl":53,"Education":60.4,"Edu_pctl":"98","Linguistic":21.4,"Ling_pctl":"86","Poverty":65.2,"Pov_pctl":"89","Unemployme":13.9,"Unem_pctl":"80","Housing_Bu":37.2,"HB_pctl":"96","PopCharSco":7.83,"Pop_Pctl":"88","Children__":17.6,"Pop_11_64_":78,"Elderly___":4.4,"Hispanic__":"90.3","White____":"1.8","African_Am":"4.8","Native_Ame":"0.2","Asian_Amer":"2","Other____":"1","Shape_Leng":3215.05225727,"Shape_Area":483962.221651}},{"arcs":[[-535,-1368,1371,1372]],"type":"Polygon","properties":{"Tract_1":6037601802,"Percentile":"81-85%","Population":4658,"County":"Los Angeles","ZIP":90304,"City":"Inglewood","CIscore":44.22,"CIscoreP":"82","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":38.92,"DPM_pctl":93,"DrinkingWa":255.67,"DW_pctl":"26","Pesticides":15.388,"Pest_pctl":62,"Tox_Releas":4443.3,"TR_pctl":78,"Traffic":909.79,"Traff_Pctl":"63","Cleanups":0,"Clean_Pctl":0,"Groundwate":3.3,"GW_pctl":23,"Haz_Waste":0.02,"Haz_pctl":10,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.48,"Poll_pctl":57,"Asthma":68.31,"Asthma_Pct":77,"Low_Birth_":5.49,"LBW_pctl":"66","Cardiovasc":11.03,"CVD_pctl":83,"Education":48,"Edu_pctl":"93","Linguistic":23.6,"Ling_pctl":"89","Poverty":51.7,"Pov_pctl":"75","Unemployme":10.3,"Unem_pctl":"58","Housing_Bu":29.6,"HB_pctl":"87","PopCharSco":8.07,"Pop_Pctl":"90","Children__":18,"Pop_11_64_":77,"Elderly___":5,"Hispanic__":"94.8","White____":"2.1","African_Am":"1.7","Native_Ame":"0.1","Asian_Amer":"0.8","Other____":"0.5","Shape_Leng":3219.56202229,"Shape_Area":485779.389934}},{"arcs":[[1373,1374,-964,1375]],"type":"Polygon","properties":{"Tract_1":6037601900,"Percentile":"81-85%","Population":5685,"County":"Los Angeles","ZIP":90303,"City":"Inglewood","CIscore":45.45,"CIscoreP":"84","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":21.99,"DPM_pctl":67,"DrinkingWa":286.02,"DW_pctl":"30","Pesticides":0,"Pest_pctl":0,"Tox_Releas":4586.06,"TR_pctl":79,"Traffic":1277.4,"Traff_Pctl":"78","Cleanups":0.1,"Clean_Pctl":2,"Groundwate":4.5,"GW_pctl":29,"Haz_Waste":0.08,"Haz_pctl":31,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.91,"Poll_pctl":45,"Asthma":104.06,"Asthma_Pct":93,"Low_Birth_":6.78,"LBW_pctl":"88","Cardiovasc":12.17,"CVD_pctl":89,"Education":48.6,"Edu_pctl":"93","Linguistic":17.4,"Ling_pctl":"80","Poverty":64.5,"Pov_pctl":"89","Unemployme":15.4,"Unem_pctl":"86","Housing_Bu":33.6,"HB_pctl":"93","PopCharSco":9.26,"Pop_Pctl":"99","Children__":19.1,"Pop_11_64_":76.6,"Elderly___":4.3,"Hispanic__":"82.4","White____":"1.3","African_Am":"13.9","Native_Ame":"0.1","Asian_Amer":"1.2","Other____":"1.1","Shape_Leng":3362.43977782,"Shape_Area":696904.953174}},{"arcs":[[-948,-1357,1376,-1363]],"type":"Polygon","properties":{"Tract_1":6037602104,"Percentile":"91-95%","Population":5416,"County":"Los Angeles","ZIP":90250,"City":"Hawthorne","CIscore":51.62,"CIscoreP":"90","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":32.14,"DPM_pctl":88,"DrinkingWa":390.89,"DW_pctl":"41","Pesticides":1.738,"Pest_pctl":44,"Tox_Releas":4840.72,"TR_pctl":80,"Traffic":2036.88,"Traff_Pctl":"91","Cleanups":9.5,"Clean_Pctl":61,"Groundwate":6.3,"GW_pctl":37,"Haz_Waste":0.04,"Haz_pctl":19,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":7.01,"Poll_pctl":87,"Asthma":63.56,"Asthma_Pct":73,"Low_Birth_":5.53,"LBW_pctl":"66","Cardiovasc":8.86,"CVD_pctl":62,"Education":32.9,"Edu_pctl":"80","Linguistic":13.1,"Ling_pctl":"70","Poverty":54.3,"Pov_pctl":"78","Unemployme":10.2,"Unem_pctl":"58","Housing_Bu":31.2,"HB_pctl":"90","PopCharSco":7.36,"Pop_Pctl":"81","Children__":16.3,"Pop_11_64_":77.5,"Elderly___":6.2,"Hispanic__":"63.4","White____":"3.9","African_Am":"25.3","Native_Ame":"0.3","Asian_Amer":"5","Other____":"2","Shape_Leng":3500.34014897,"Shape_Area":719332.078954}},{"arcs":[[1377,1378,1379,1380,1381]],"type":"Polygon","properties":{"Tract_1":6037602700,"Percentile":"91-95%","Population":3045,"County":"Los Angeles","ZIP":90250,"City":"Hawthorne","CIscore":54.38,"CIscoreP":"93","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":22.45,"DPM_pctl":68,"DrinkingWa":379.16,"DW_pctl":"40","Pesticides":0,"Pest_pctl":0,"Tox_Releas":4956.96,"TR_pctl":80,"Traffic":2178.33,"Traff_Pctl":"93","Cleanups":33.4,"Clean_Pctl":92,"Groundwate":143.5,"GW_pctl":99,"Haz_Waste":1.02,"Haz_pctl":87,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":4.7,"Solid_pctl":70,"PollutionS":8.17,"Poll_pctl":97,"Asthma":74.98,"Asthma_Pct":82,"Low_Birth_":7.14,"LBW_pctl":"92","Cardiovasc":9,"CVD_pctl":64,"Education":14.6,"Edu_pctl":"51","Linguistic":0.9,"Ling_pctl":"5","Poverty":25.5,"Pov_pctl":"37","Unemployme":20.4,"Unem_pctl":"96","Housing_Bu":19.5,"HB_pctl":"57","PopCharSco":6.65,"Pop_Pctl":"71","Children__":9.3,"Pop_11_64_":72.8,"Elderly___":17.9,"Hispanic__":"14","White____":"2","African_Am":"79.8","Native_Ame":"0.2","Asian_Amer":"2.2","Other____":"1.7","Shape_Leng":6623.4188077,"Shape_Area":2492181.30377}},{"arcs":[[1382,1383,1384,1385]],"type":"Polygon","properties":{"Tract_1":6037600601,"Percentile":"66-70%","Population":2461,"County":"Los Angeles","ZIP":90303,"City":"Inglewood","CIscore":33.93,"CIscoreP":"67","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":18.08,"DPM_pctl":55,"DrinkingWa":276.67,"DW_pctl":"29","Pesticides":7.596,"Pest_pctl":56,"Tox_Releas":4795.38,"TR_pctl":79,"Traffic":891.1,"Traff_Pctl":"62","Cleanups":0.25,"Clean_Pctl":5,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.77,"Poll_pctl":42,"Asthma":91.37,"Asthma_Pct":90,"Low_Birth_":10,"LBW_pctl":"100","Cardiovasc":10.35,"CVD_pctl":77,"Education":9.7,"Edu_pctl":"38","Linguistic":1.1,"Ling_pctl":"7","Poverty":27.5,"Pov_pctl":"41","Unemployme":12.8,"Unem_pctl":"75","Housing_Bu":26.5,"HB_pctl":"81","PopCharSco":7.11,"Pop_Pctl":"78","Children__":9.7,"Pop_11_64_":70,"Elderly___":20.3,"Hispanic__":"7.3","White____":"1.2","African_Am":"88.6","Native_Ame":"0.2","Asian_Amer":"0.6","Other____":"2.1","Shape_Leng":3213.14391422,"Shape_Area":645311.465488}},{"arcs":[[1386,1387,1388]],"type":"Polygon","properties":{"Tract_1":6037651102,"Percentile":"46-50%","Population":3639,"County":"Los Angeles","ZIP":90505,"City":"Torrance","CIscore":24.98,"CIscoreP":"50","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":14.74,"DPM_pctl":45,"DrinkingWa":188.14,"DW_pctl":"14","Pesticides":0,"Pest_pctl":0,"Tox_Releas":7717.3,"TR_pctl":90,"Traffic":833.05,"Traff_Pctl":"59","Cleanups":7.65,"Clean_Pctl":54,"Groundwate":25.8,"GW_pctl":78,"Haz_Waste":0.56,"Haz_pctl":79,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":2,"Solid_pctl":50,"PollutionS":5.92,"Poll_pctl":67,"Asthma":28.68,"Asthma_Pct":23,"Low_Birth_":5.1,"LBW_pctl":"55","Cardiovasc":6.81,"CVD_pctl":35,"Education":6.4,"Edu_pctl":"25","Linguistic":10.4,"Ling_pctl":"60","Poverty":28.4,"Pov_pctl":"42","Unemployme":7.9,"Unem_pctl":"38","Housing_Bu":18.8,"HB_pctl":"54","PopCharSco":4.22,"Pop_Pctl":"36","Children__":8.7,"Pop_11_64_":65.8,"Elderly___":25.5,"Hispanic__":"12.6","White____":"47","African_Am":"2.4","Native_Ame":"0.1","Asian_Amer":"33.9","Other____":"4","Shape_Leng":4265.17166329,"Shape_Area":836470.913624}},{"arcs":[[1389,1390,-1113,1391,1392,1393,1394,-925]],"type":"Polygon","properties":{"Tract_1":6037552602,"Percentile":"86-90%","Population":4191,"County":"Los Angeles","ZIP":90650,"City":"Norwalk","CIscore":49.42,"CIscoreP":"88","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":29.85,"DPM_pctl":85,"DrinkingWa":508.89,"DW_pctl":"54","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5410.86,"TR_pctl":82,"Traffic":417.85,"Traff_Pctl":"23","Cleanups":4.65,"Clean_Pctl":43,"Groundwate":32.5,"GW_pctl":83,"Haz_Waste":0.94,"Haz_pctl":86,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":5,"Solid_pctl":74,"PollutionS":6.64,"Poll_pctl":82,"Asthma":53.77,"Asthma_Pct":61,"Low_Birth_":6.11,"LBW_pctl":"78","Cardiovasc":11.47,"CVD_pctl":86,"Education":22,"Edu_pctl":"66","Linguistic":18.8,"Ling_pctl":"82","Poverty":42.4,"Pov_pctl":"63","Unemployme":9.8,"Unem_pctl":"54","Housing_Bu":25,"HB_pctl":"77","PopCharSco":7.44,"Pop_Pctl":"82","Children__":13.7,"Pop_11_64_":74.9,"Elderly___":11.4,"Hispanic__":"49.9","White____":"8.9","African_Am":"5.4","Native_Ame":"0.1","Asian_Amer":"33.7","Other____":"1.8","Shape_Leng":5049.7499489,"Shape_Area":1373306.99202}},{"arcs":[[-1215,1395,1396,1397]],"type":"Polygon","properties":{"Tract_1":6037552700,"Percentile":"76-80%","Population":6985,"County":"Los Angeles","ZIP":90650,"City":"Norwalk","CIscore":41.18,"CIscoreP":"78","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":29.38,"DPM_pctl":84,"DrinkingWa":489.04,"DW_pctl":"52","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5264.4,"TR_pctl":81,"Traffic":539.35,"Traff_Pctl":"35","Cleanups":2.5,"Clean_Pctl":30,"Groundwate":39.25,"GW_pctl":87,"Haz_Waste":0.18,"Haz_pctl":56,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.7,"Solid_pctl":23,"PollutionS":6.01,"Poll_pctl":69,"Asthma":62.88,"Asthma_Pct":72,"Low_Birth_":5.33,"LBW_pctl":"62","Cardiovasc":13.42,"CVD_pctl":94,"Education":21.7,"Edu_pctl":"65","Linguistic":12.1,"Ling_pctl":"66","Poverty":35.1,"Pov_pctl":"53","Unemployme":8,"Unem_pctl":"39","Housing_Bu":19.7,"HB_pctl":"58","PopCharSco":6.86,"Pop_Pctl":"74","Children__":14.6,"Pop_11_64_":77.2,"Elderly___":8.2,"Hispanic__":"73.8","White____":"12.2","African_Am":"2.6","Native_Ame":"0.2","Asian_Amer":"10.1","Other____":"1.1","Shape_Leng":5029.19839794,"Shape_Area":1374239.86574}},{"arcs":[[1398,-1219,1399,-1393]],"type":"Polygon","properties":{"Tract_1":6037552601,"Percentile":"81-85%","Population":5720,"County":"Los Angeles","ZIP":90650,"City":"Norwalk","CIscore":44.75,"CIscoreP":"82","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":29.07,"DPM_pctl":83,"DrinkingWa":364.52,"DW_pctl":"38","Pesticides":0.584,"Pest_pctl":34,"Tox_Releas":5345.92,"TR_pctl":82,"Traffic":639.03,"Traff_Pctl":"45","Cleanups":1.5,"Clean_Pctl":22,"Groundwate":32,"GW_pctl":83,"Haz_Waste":0.2,"Haz_pctl":61,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.96,"Poll_pctl":68,"Asthma":62.88,"Asthma_Pct":72,"Low_Birth_":5.22,"LBW_pctl":"58","Cardiovasc":13.42,"CVD_pctl":94,"Education":43.9,"Edu_pctl":"90","Linguistic":22.8,"Ling_pctl":"88","Poverty":47.8,"Pov_pctl":"70","Unemployme":9.9,"Unem_pctl":"55","Housing_Bu":16.9,"HB_pctl":"45","PopCharSco":7.51,"Pop_Pctl":"83","Children__":16.2,"Pop_11_64_":76.6,"Elderly___":7.2,"Hispanic__":"92","White____":"3.6","African_Am":"0.6","Native_Ame":"0.4","Asian_Amer":"2.8","Other____":"0.6","Shape_Leng":3381.14576676,"Shape_Area":713085.397462}},{"arcs":[[-262,1400,1401,1402,1403,-1227,1404,1405]],"type":"Polygon","properties":{"Tract_1":6037553100,"Percentile":"81-85%","Population":6298,"County":"Los Angeles","ZIP":90706,"City":"Bellflower","CIscore":43.81,"CIscoreP":"81","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":27.54,"DPM_pctl":81,"DrinkingWa":737.68,"DW_pctl":"85","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5816.36,"TR_pctl":84,"Traffic":1798.58,"Traff_Pctl":"88","Cleanups":0,"Clean_Pctl":0,"Groundwate":3.6,"GW_pctl":24,"Haz_Waste":0.16,"Haz_pctl":55,"Imp__Water":4,"IWB_pctl":49,"Solid_Wast":2.2,"Solid_pctl":52,"PollutionS":6.73,"Poll_pctl":83,"Asthma":79.03,"Asthma_Pct":85,"Low_Birth_":5.22,"LBW_pctl":"58","Cardiovasc":11.13,"CVD_pctl":84,"Education":14.3,"Edu_pctl":"51","Linguistic":7.8,"Ling_pctl":"50","Poverty":35.5,"Pov_pctl":"53","Unemployme":7.8,"Unem_pctl":"37","Housing_Bu":19.9,"HB_pctl":"59","PopCharSco":6.51,"Pop_Pctl":"69","Children__":13.7,"Pop_11_64_":76.2,"Elderly___":10.1,"Hispanic__":"44.6","White____":"24.3","African_Am":"15.2","Native_Ame":"0.3","Asian_Amer":"12.6","Other____":"2.9","Shape_Leng":6915.73017391,"Shape_Area":2072149.60493}},{"arcs":[[1406,-994,1407,1408,1409,1410]],"type":"Polygon","properties":{"Tract_1":6037554514,"Percentile":"31-35%","Population":4322,"County":"Los Angeles","ZIP":90703,"City":"Cerritos","CIscore":18.01,"CIscoreP":"33","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":17.85,"DPM_pctl":54,"DrinkingWa":347.98,"DW_pctl":"36","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5662.68,"TR_pctl":83,"Traffic":1862.94,"Traff_Pctl":"89","Cleanups":0.9,"Clean_Pctl":13,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.5,"Solid_pctl":20,"PollutionS":4.61,"Poll_pctl":38,"Asthma":35.37,"Asthma_Pct":34,"Low_Birth_":3.03,"LBW_pctl":"9","Cardiovasc":7.85,"CVD_pctl":49,"Education":11.7,"Edu_pctl":"44","Linguistic":10.6,"Ling_pctl":"61","Poverty":21.5,"Pov_pctl":"30","Unemployme":9.7,"Unem_pctl":"54","Housing_Bu":14.9,"HB_pctl":"35","PopCharSco":3.91,"Pop_Pctl":"31","Children__":9.7,"Pop_11_64_":75.6,"Elderly___":14.7,"Hispanic__":"14","White____":"16.5","African_Am":"10","Native_Ame":"0.1","Asian_Amer":"56.3","Other____":"3.1","Shape_Leng":6630.30302916,"Shape_Area":1506307.95255}},{"arcs":[[1411,1412,1413,-995,-1407,-1201]],"type":"Polygon","properties":{"Tract_1":6037554516,"Percentile":"51-55%","Population":3902,"County":"Los Angeles","ZIP":90703,"City":"Cerritos","CIscore":25.35,"CIscoreP":"51","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":16.43,"DPM_pctl":50,"DrinkingWa":348.16,"DW_pctl":"36","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5809.41,"TR_pctl":84,"Traffic":444.39,"Traff_Pctl":"25","Cleanups":0,"Clean_Pctl":0,"Groundwate":3,"GW_pctl":22,"Haz_Waste":0.05,"Haz_pctl":26,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":9,"Solid_pctl":87,"PollutionS":5.24,"Poll_pctl":52,"Asthma":36.69,"Asthma_Pct":37,"Low_Birth_":7.5,"LBW_pctl":"94","Cardiovasc":7.67,"CVD_pctl":46,"Education":7.7,"Edu_pctl":"31","Linguistic":9.8,"Ling_pctl":"58","Poverty":13.4,"Pov_pctl":"13","Unemployme":6.4,"Unem_pctl":"24","Housing_Bu":17,"HB_pctl":"45","PopCharSco":4.84,"Pop_Pctl":"45","Children__":8.1,"Pop_11_64_":73.7,"Elderly___":18.2,"Hispanic__":"12.1","White____":"15.6","African_Am":"6.2","Native_Ame":"0.1","Asian_Amer":"63.4","Other____":"2.6","Shape_Leng":6561.58418482,"Shape_Area":1456373.08708}},{"arcs":[[1414,1415,1416,-1220,1417]],"type":"Polygon","properties":{"Tract_1":6037554600,"Percentile":"76-80%","Population":4374,"County":"Los Angeles","ZIP":90650,"City":"Norwalk","CIscore":41.23,"CIscoreP":"78","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":28.5,"DPM_pctl":83,"DrinkingWa":400.8,"DW_pctl":"42","Pesticides":1597.444,"Pest_pctl":91,"Tox_Releas":5568.32,"TR_pctl":83,"Traffic":635.76,"Traff_Pctl":"45","Cleanups":0.1,"Clean_Pctl":2,"Groundwate":9,"GW_pctl":46,"Haz_Waste":0.31,"Haz_pctl":70,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":1,"Solid_pctl":33,"PollutionS":6.55,"Poll_pctl":80,"Asthma":34.75,"Asthma_Pct":33,"Low_Birth_":6.18,"LBW_pctl":"80","Cardiovasc":7.65,"CVD_pctl":46,"Education":30.4,"Edu_pctl":"77","Linguistic":24,"Ling_pctl":"89","Poverty":43.6,"Pov_pctl":"65","Unemployme":8.7,"Unem_pctl":"45","Housing_Bu":21.7,"HB_pctl":"66","PopCharSco":6.29,"Pop_Pctl":"66","Children__":11.1,"Pop_11_64_":76.3,"Elderly___":12.6,"Hispanic__":"43","White____":"17.4","African_Am":"4.4","Native_Ame":"0.2","Asian_Amer":"33.6","Other____":"1.3","Shape_Leng":4428.89603723,"Shape_Area":1051148.92708}},{"arcs":[[1418,-1416,1419,1420,1421,-1004,1422,-1120,1423,-1027,1424,-264,1425,1426,-1225,1427]],"type":"Polygon","properties":{"Tract_1":6037554521,"Percentile":"71-75%","Population":5752,"County":"Los Angeles","ZIP":90703,"City":"Cerritos","CIscore":39,"CIscoreP":"74","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":28.51,"DPM_pctl":83,"DrinkingWa":350.97,"DW_pctl":"37","Pesticides":161.614,"Pest_pctl":79,"Tox_Releas":5955.11,"TR_pctl":85,"Traffic":2535.76,"Traff_Pctl":"95","Cleanups":2.25,"Clean_Pctl":29,"Groundwate":11.3,"GW_pctl":52,"Haz_Waste":1,"Haz_pctl":87,"Imp__Water":4,"IWB_pctl":49,"Solid_Wast":2,"Solid_pctl":50,"PollutionS":7.91,"Poll_pctl":96,"Asthma":38.21,"Asthma_Pct":39,"Low_Birth_":7.67,"LBW_pctl":"95","Cardiovasc":8.33,"CVD_pctl":55,"Education":11.5,"Edu_pctl":"44","Linguistic":5.6,"Ling_pctl":"40","Poverty":17.3,"Pov_pctl":"21","Unemployme":6.1,"Unem_pctl":"21","Housing_Bu":14.8,"HB_pctl":"34","PopCharSco":4.93,"Pop_Pctl":"46","Children__":8.5,"Pop_11_64_":70.8,"Elderly___":20.7,"Hispanic__":"16.9","White____":"25","African_Am":"9.4","Native_Ame":"0.1","Asian_Amer":"45.6","Other____":"2.9","Shape_Leng":11751.8504411,"Shape_Area":4943410.58019}},{"arcs":[[1428,1429,1430,1431,-46,1432,1433,1434,1435,-898,-920]],"type":"Polygon","properties":{"Tract_1":6037571701,"Percentile":"96-100%","Population":6352,"County":"Los Angeles","ZIP":90805,"City":"Long Beach","CIscore":58.46,"CIscoreP":"96","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":21.52,"DPM_pctl":66,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6355.62,"TR_pctl":86,"Traffic":2288.07,"Traff_Pctl":"93","Cleanups":5,"Clean_Pctl":44,"Groundwate":19,"GW_pctl":69,"Haz_Waste":0.38,"Haz_pctl":72,"Imp__Water":13,"IWB_pctl":93,"Solid_Wast":3.85,"Solid_pctl":66,"PollutionS":7.11,"Poll_pctl":88,"Asthma":84.93,"Asthma_Pct":87,"Low_Birth_":6.47,"LBW_pctl":"85","Cardiovasc":10.4,"CVD_pctl":78,"Education":27.5,"Edu_pctl":"74","Linguistic":12.8,"Ling_pctl":"69","Poverty":53.9,"Pov_pctl":"78","Unemployme":18.1,"Unem_pctl":"93","Housing_Bu":21.3,"HB_pctl":"64","PopCharSco":8.23,"Pop_Pctl":"92","Children__":17.5,"Pop_11_64_":76.1,"Elderly___":6.4,"Hispanic__":"57.8","White____":"9","African_Am":"14.2","Native_Ame":"0.3","Asian_Amer":"16.3","Other____":"2.4","Shape_Leng":7493.58809215,"Shape_Area":1912255.07002}},{"arcs":[[1436,1437,1438,1439,1440]],"type":"Polygon","properties":{"Tract_1":6037572100,"Percentile":"86-90%","Population":1045,"County":"Los Angeles","ZIP":90806,"City":"Long Beach","CIscore":47.36,"CIscoreP":"86","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":20.9,"DPM_pctl":64,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":5.765,"Pest_pctl":54,"Tox_Releas":7269.61,"TR_pctl":89,"Traffic":3044.55,"Traff_Pctl":"98","Cleanups":9,"Clean_Pctl":60,"Groundwate":28.3,"GW_pctl":80,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":12,"IWB_pctl":91,"Solid_Wast":0.25,"Solid_pctl":10,"PollutionS":6.92,"Poll_pctl":86,"Asthma":93.96,"Asthma_Pct":91,"Low_Birth_":8.54,"LBW_pctl":"98","Cardiovasc":10.69,"CVD_pctl":80,"Education":14,"Edu_pctl":"50","Linguistic":2.1,"Ling_pctl":"15","Poverty":4.9,"Pov_pctl":"1","Unemployme":13.7,"Unem_pctl":"79","Housing_Bu":0,"HB_pctl":"NA","PopCharSco":6.84,"Pop_Pctl":"74","Children__":11.3,"Pop_11_64_":78.1,"Elderly___":10.6,"Hispanic__":"29.3","White____":"18.8","African_Am":"13.7","Native_Ame":"0.5","Asian_Amer":"34.3","Other____":"3.5","Shape_Leng":4109.29011983,"Shape_Area":790449.847045}},{"arcs":[[1441,1442,1443,1444,1445,-1049,1446,1447,1448,1449,-43,1450]],"type":"Polygon","properties":{"Tract_1":6037572301,"Percentile":"96-100%","Population":3833,"County":"Los Angeles","ZIP":90810,"City":"Long Beach","CIscore":62.87,"CIscoreP":"97","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":26.67,"DPM_pctl":80,"DrinkingWa":218.07,"DW_pctl":"17","Pesticides":10.299,"Pest_pctl":59,"Tox_Releas":9073.59,"TR_pctl":92,"Traffic":2119,"Traff_Pctl":"92","Cleanups":14.6,"Clean_Pctl":76,"Groundwate":13.95,"GW_pctl":58,"Haz_Waste":3.68,"Haz_pctl":95,"Imp__Water":23,"IWB_pctl":100,"Solid_Wast":6.5,"Solid_pctl":80,"PollutionS":8.5,"Poll_pctl":98,"Asthma":72.09,"Asthma_Pct":80,"Low_Birth_":5.24,"LBW_pctl":"59","Cardiovasc":9.55,"CVD_pctl":70,"Education":30.3,"Edu_pctl":"77","Linguistic":12.2,"Ling_pctl":"67","Poverty":46.6,"Pov_pctl":"69","Unemployme":12.9,"Unem_pctl":"76","Housing_Bu":25.5,"HB_pctl":"78","PopCharSco":7.4,"Pop_Pctl":"82","Children__":16.3,"Pop_11_64_":76.2,"Elderly___":7.5,"Hispanic__":"58.8","White____":"4.1","African_Am":"8","Native_Ame":"0.1","Asian_Amer":"26.8","Other____":"2.2","Shape_Leng":5865.43138564,"Shape_Area":820274.583337}},{"arcs":[[1451,1452,1453,-1177]],"type":"Polygon","properties":{"Tract_1":6037572302,"Percentile":"81-85%","Population":3483,"County":"Los Angeles","ZIP":90810,"City":"Long Beach","CIscore":45.67,"CIscoreP":"84","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":27.92,"DPM_pctl":82,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":9.953,"Pest_pctl":58,"Tox_Releas":8277.79,"TR_pctl":91,"Traffic":1936.95,"Traff_Pctl":"90","Cleanups":1.3,"Clean_Pctl":20,"Groundwate":6.55,"GW_pctl":38,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":11,"IWB_pctl":90,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":6.42,"Poll_pctl":77,"Asthma":67.58,"Asthma_Pct":76,"Low_Birth_":5.5,"LBW_pctl":"66","Cardiovasc":8.88,"CVD_pctl":62,"Education":20.9,"Edu_pctl":"64","Linguistic":12.2,"Ling_pctl":"67","Poverty":37.9,"Pov_pctl":"57","Unemployme":14.7,"Unem_pctl":"83","Housing_Bu":24.4,"HB_pctl":"75","PopCharSco":7.11,"Pop_Pctl":"78","Children__":14.9,"Pop_11_64_":76.1,"Elderly___":9,"Hispanic__":"53.9","White____":"3.7","African_Am":"12.2","Native_Ame":"0.1","Asian_Amer":"27.7","Other____":"2.3","Shape_Leng":3463.31686087,"Shape_Area":752096.561734}},{"arcs":[[1454,1455,1456,1457,1458,1459]],"type":"Polygon","properties":{"Tract_1":6037241002,"Percentile":"91-95%","Population":3606,"County":"Los Angeles","ZIP":90059,"City":"Los Angeles","CIscore":57.54,"CIscoreP":"95","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":27.11,"DPM_pctl":80,"DrinkingWa":689.46,"DW_pctl":"82","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5511.98,"TR_pctl":82,"Traffic":3801.82,"Traff_Pctl":"99","Cleanups":7.35,"Clean_Pctl":53,"Groundwate":3.75,"GW_pctl":25,"Haz_Waste":0.02,"Haz_pctl":16,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":0.7,"Solid_pctl":23,"PollutionS":6.94,"Poll_pctl":86,"Asthma":77.55,"Asthma_Pct":83,"Low_Birth_":7.46,"LBW_pctl":"94","Cardiovasc":8.96,"CVD_pctl":63,"Education":44.6,"Edu_pctl":"91","Linguistic":5,"Ling_pctl":"36","Poverty":61.9,"Pov_pctl":"86","Unemployme":22.7,"Unem_pctl":"98","Housing_Bu":29.9,"HB_pctl":"88","PopCharSco":8.29,"Pop_Pctl":"93","Children__":18.2,"Pop_11_64_":75.3,"Elderly___":6.5,"Hispanic__":"54.7","White____":"0.6","African_Am":"42.9","Native_Ame":"0","Asian_Amer":"0.3","Other____":"1.5","Shape_Leng":3967.21417038,"Shape_Area":710032.953865}},{"arcs":[[1460,1461,1462,1463,1464,1465,1466]],"type":"Polygon","properties":{"Tract_1":6037241001,"Percentile":"96-100%","Population":4285,"County":"Los Angeles","ZIP":90061,"City":"Los Angeles","CIscore":60.89,"CIscoreP":"97","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":25.17,"DPM_pctl":77,"DrinkingWa":628.73,"DW_pctl":"71","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5406,"TR_pctl":82,"Traffic":3597.62,"Traff_Pctl":"99","Cleanups":0.9,"Clean_Pctl":13,"Groundwate":3,"GW_pctl":22,"Haz_Waste":0.02,"Haz_pctl":16,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":2,"Solid_pctl":50,"PollutionS":6.63,"Poll_pctl":81,"Asthma":85.81,"Asthma_Pct":88,"Low_Birth_":8.81,"LBW_pctl":"99","Cardiovasc":10.32,"CVD_pctl":77,"Education":41.9,"Edu_pctl":"89","Linguistic":13,"Ling_pctl":"69","Poverty":68.3,"Pov_pctl":"92","Unemployme":21.1,"Unem_pctl":"97","Housing_Bu":47.6,"HB_pctl":"100","PopCharSco":9.18,"Pop_Pctl":"98","Children__":18.8,"Pop_11_64_":76.1,"Elderly___":5.1,"Hispanic__":"61.7","White____":"0.9","African_Am":"35.6","Native_Ame":"0.3","Asian_Amer":"0.5","Other____":"1.1","Shape_Leng":5528.05472121,"Shape_Area":901084.828041}},{"arcs":[[-500,1467,1468]],"type":"Polygon","properties":{"Tract_1":6037602507,"Percentile":"81-85%","Population":4156,"County":"Los Angeles","ZIP":90250,"City":"Hawthorne","CIscore":44.78,"CIscoreP":"83","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":23.4,"DPM_pctl":72,"DrinkingWa":255.67,"DW_pctl":"26","Pesticides":0.01,"Pest_pctl":8,"Tox_Releas":4978.57,"TR_pctl":80,"Traffic":1017.4,"Traff_Pctl":"69","Cleanups":1.1,"Clean_Pctl":19,"Groundwate":20.5,"GW_pctl":72,"Haz_Waste":0.02,"Haz_pctl":10,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.83,"Poll_pctl":65,"Asthma":67.04,"Asthma_Pct":76,"Low_Birth_":8.24,"LBW_pctl":"97","Cardiovasc":9.05,"CVD_pctl":64,"Education":18.2,"Edu_pctl":"59","Linguistic":10.3,"Ling_pctl":"60","Poverty":53.8,"Pov_pctl":"78","Unemployme":11.7,"Unem_pctl":"68","Housing_Bu":26.3,"HB_pctl":"80","PopCharSco":7.68,"Pop_Pctl":"86","Children__":15.5,"Pop_11_64_":78,"Elderly___":6.5,"Hispanic__":"36.5","White____":"5.4","African_Am":"49","Native_Ame":"0.2","Asian_Amer":"6.5","Other____":"2.4","Shape_Leng":2411.60378849,"Shape_Area":323570.18574}},{"arcs":[[-240,1469,1470]],"type":"Polygon","properties":{"Tract_1":6037602506,"Percentile":"76-80%","Population":4329,"County":"Los Angeles","ZIP":90250,"City":"Hawthorne","CIscore":42.65,"CIscoreP":"80","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":23.4,"DPM_pctl":72,"DrinkingWa":255.67,"DW_pctl":"26","Pesticides":0.007,"Pest_pctl":7,"Tox_Releas":4948.24,"TR_pctl":80,"Traffic":756.94,"Traff_Pctl":"54","Cleanups":5.15,"Clean_Pctl":45,"Groundwate":18,"GW_pctl":68,"Haz_Waste":0.06,"Haz_pctl":28,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.97,"Poll_pctl":68,"Asthma":66.13,"Asthma_Pct":75,"Low_Birth_":5.62,"LBW_pctl":"69","Cardiovasc":8.91,"CVD_pctl":62,"Education":28,"Edu_pctl":"74","Linguistic":7.1,"Ling_pctl":"47","Poverty":53.4,"Pov_pctl":"77","Unemployme":11.3,"Unem_pctl":"66","Housing_Bu":26.8,"HB_pctl":"81","PopCharSco":7.14,"Pop_Pctl":"78","Children__":15.4,"Pop_11_64_":80.3,"Elderly___":4.3,"Hispanic__":"35.9","White____":"4.4","African_Am":"49.2","Native_Ame":"0.1","Asian_Amer":"7.9","Other____":"2.4","Shape_Leng":2406.19738579,"Shape_Area":322456.294945}},{"arcs":[[1471,1472,1473]],"type":"Polygon","properties":{"Tract_1":6037602505,"Percentile":"86-90%","Population":4072,"County":"Los Angeles","ZIP":90250,"City":"Hawthorne","CIscore":47.12,"CIscoreP":"86","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":23.82,"DPM_pctl":73,"DrinkingWa":378.31,"DW_pctl":"40","Pesticides":0,"Pest_pctl":0,"Tox_Releas":4988.58,"TR_pctl":80,"Traffic":1387.73,"Traff_Pctl":"80","Cleanups":2.1,"Clean_Pctl":28,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.02,"Haz_pctl":16,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":5.66,"Poll_pctl":61,"Asthma":78.54,"Asthma_Pct":84,"Low_Birth_":6.64,"LBW_pctl":"87","Cardiovasc":10.73,"CVD_pctl":81,"Education":27.7,"Edu_pctl":"74","Linguistic":10.2,"Ling_pctl":"60","Poverty":62.3,"Pov_pctl":"86","Unemployme":12.9,"Unem_pctl":"76","Housing_Bu":30,"HB_pctl":"88","PopCharSco":8.33,"Pop_Pctl":"93","Children__":19.2,"Pop_11_64_":76.9,"Elderly___":3.9,"Hispanic__":"52.8","White____":"5.2","African_Am":"35.4","Native_Ame":"0.2","Asian_Amer":"4.5","Other____":"1.9","Shape_Leng":2411.68611503,"Shape_Area":323190.039059}},{"arcs":[[1474,-1474,1475,1476]],"type":"Polygon","properties":{"Tract_1":6037602504,"Percentile":"76-80%","Population":4407,"County":"Los Angeles","ZIP":90250,"City":"Hawthorne","CIscore":42.33,"CIscoreP":"79","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":23.4,"DPM_pctl":72,"DrinkingWa":255.67,"DW_pctl":"26","Pesticides":0,"Pest_pctl":0,"Tox_Releas":4955.72,"TR_pctl":80,"Traffic":1473.48,"Traff_Pctl":"82","Cleanups":3.2,"Clean_Pctl":33,"Groundwate":2,"GW_pctl":14,"Haz_Waste":0.05,"Haz_pctl":26,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":5.74,"Poll_pctl":63,"Asthma":78.54,"Asthma_Pct":84,"Low_Birth_":5.23,"LBW_pctl":"59","Cardiovasc":10.73,"CVD_pctl":81,"Education":20,"Edu_pctl":"62","Linguistic":13.1,"Ling_pctl":"70","Poverty":53.7,"Pov_pctl":"78","Unemployme":10.2,"Unem_pctl":"58","Housing_Bu":23.2,"HB_pctl":"71","PopCharSco":7.37,"Pop_Pctl":"81","Children__":16.8,"Pop_11_64_":79.1,"Elderly___":4.1,"Hispanic__":"44.1","White____":"5","African_Am":"38.5","Native_Ame":"0.2","Asian_Amer":"9.6","Other____":"2.5","Shape_Leng":2409.37592492,"Shape_Area":321812.380443}},{"arcs":[[1477,-510,1478,-252]],"type":"Polygon","properties":{"Tract_1":6037600303,"Percentile":"86-90%","Population":3664,"County":"Los Angeles","ZIP":90044,"City":"Los Angeles","CIscore":50.76,"CIscoreP":"90","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":21.82,"DPM_pctl":67,"DrinkingWa":255.67,"DW_pctl":"26","Pesticides":0,"Pest_pctl":0,"Tox_Releas":4845.47,"TR_pctl":80,"Traffic":693.4,"Traff_Pctl":"50","Cleanups":13.5,"Clean_Pctl":74,"Groundwate":5,"GW_pctl":32,"Haz_Waste":0.05,"Haz_pctl":26,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":5.1,"Solid_pctl":74,"PollutionS":5.72,"Poll_pctl":63,"Asthma":115.42,"Asthma_Pct":96,"Low_Birth_":6.86,"LBW_pctl":"89","Cardiovasc":12.3,"CVD_pctl":90,"Education":34.7,"Edu_pctl":"82","Linguistic":15.9,"Ling_pctl":"77","Poverty":54.4,"Pov_pctl":"78","Unemployme":10.7,"Unem_pctl":"61","Housing_Bu":45.2,"HB_pctl":"99","PopCharSco":8.88,"Pop_Pctl":"97","Children__":18.6,"Pop_11_64_":75.8,"Elderly___":5.6,"Hispanic__":"50.1","White____":"0.7","African_Am":"46.6","Native_Ame":"0.1","Asian_Amer":"0.5","Other____":"2","Shape_Leng":2777.88741818,"Shape_Area":363666.343814}},{"arcs":[[-1247,1479,-714,1480,1481,1482,-720,1483]],"type":"Polygon","properties":{"Tract_1":6037651001,"Percentile":"56-60%","Population":5522,"County":"Los Angeles","ZIP":90501,"City":"Torrance","CIscore":28.59,"CIscoreP":"57","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":18.53,"DPM_pctl":57,"DrinkingWa":417.29,"DW_pctl":"43","Pesticides":0,"Pest_pctl":0,"Tox_Releas":7565.72,"TR_pctl":89,"Traffic":659.71,"Traff_Pctl":"47","Cleanups":18.2,"Clean_Pctl":82,"Groundwate":14,"GW_pctl":59,"Haz_Waste":0.26,"Haz_pctl":67,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":4.5,"Solid_pctl":70,"PollutionS":6.24,"Poll_pctl":74,"Asthma":54.64,"Asthma_Pct":62,"Low_Birth_":4.19,"LBW_pctl":"31","Cardiovasc":6.61,"CVD_pctl":32,"Education":11.5,"Edu_pctl":"44","Linguistic":7.6,"Ling_pctl":"49","Poverty":26.1,"Pov_pctl":"38","Unemployme":10.1,"Unem_pctl":"57","Housing_Bu":17.1,"HB_pctl":"46","PopCharSco":4.58,"Pop_Pctl":"41","Children__":11.3,"Pop_11_64_":73.2,"Elderly___":15.5,"Hispanic__":"23.3","White____":"41.4","African_Am":"2.7","Native_Ame":"0.2","Asian_Amer":"28","Other____":"4.4","Shape_Leng":5812.18807324,"Shape_Area":1424552.86768}},{"arcs":[[-283,1484,1485,1486,-626,1487,1488,1489,1490]],"type":"Polygon","properties":{"Tract_1":6037670701,"Percentile":"6-10%","Population":6882,"County":"Los Angeles","ZIP":90275,"City":"Rancho Palos Verdes","CIscore":8.21,"CIscoreP":"9","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":11.27,"DPM_pctl":32,"DrinkingWa":422.32,"DW_pctl":"44","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6515.26,"TR_pctl":87,"Traffic":728.99,"Traff_Pctl":"52","Cleanups":2.95,"Clean_Pctl":31,"Groundwate":9.5,"GW_pctl":47,"Haz_Waste":0.06,"Haz_pctl":26,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":3.2,"Solid_pctl":63,"PollutionS":5.05,"Poll_pctl":48,"Asthma":14.25,"Asthma_Pct":3,"Low_Birth_":3.88,"LBW_pctl":"24","Cardiovasc":4.04,"CVD_pctl":5,"Education":7.7,"Edu_pctl":"31","Linguistic":6.3,"Ling_pctl":"43","Poverty":13.8,"Pov_pctl":"14","Unemployme":5.2,"Unem_pctl":"14","Housing_Bu":6.2,"HB_pctl":"3","PopCharSco":1.63,"Pop_Pctl":"4","Children__":10.2,"Pop_11_64_":67.9,"Elderly___":21.9,"Hispanic__":"18.5","White____":"57.4","African_Am":"4.8","Native_Ame":"0.1","Asian_Amer":"15.8","Other____":"3.4","Shape_Leng":10253.4731826,"Shape_Area":2987618.65943}},{"arcs":[[1491,1492,-710,1493,1494]],"type":"Polygon","properties":{"Tract_1":6037670002,"Percentile":"41-45%","Population":4001,"County":"Los Angeles","ZIP":90717,"City":"Lomita","CIscore":21.41,"CIscoreP":"42","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":18.53,"DPM_pctl":57,"DrinkingWa":152.86,"DW_pctl":"9","Pesticides":0,"Pest_pctl":0,"Tox_Releas":7205.85,"TR_pctl":88,"Traffic":1107.92,"Traff_Pctl":"72","Cleanups":1,"Clean_Pctl":18,"Groundwate":1,"GW_pctl":6,"Haz_Waste":0.11,"Haz_pctl":46,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.7,"Solid_pctl":23,"PollutionS":4.61,"Poll_pctl":38,"Asthma":50.79,"Asthma_Pct":57,"Low_Birth_":3.81,"LBW_pctl":"22","Cardiovasc":7.35,"CVD_pctl":42,"Education":17.3,"Edu_pctl":"57","Linguistic":10,"Ling_pctl":"59","Poverty":28.3,"Pov_pctl":"42","Unemployme":7.3,"Unem_pctl":"32","Housing_Bu":19.2,"HB_pctl":"56","PopCharSco":4.65,"Pop_Pctl":"42","Children__":13.3,"Pop_11_64_":74.9,"Elderly___":11.8,"Hispanic__":"37.7","White____":"38.7","African_Am":"4","Native_Ame":"0.3","Asian_Amer":"14.8","Other____":"4.3","Shape_Leng":3882.15328423,"Shape_Area":859454.876199}},{"arcs":[[1495,1496,-1345,-1327]],"type":"Polygon","properties":{"Tract_1":6037294520,"Percentile":"81-85%","Population":3564,"County":"Los Angeles","ZIP":90744,"City":"Wilmington","CIscore":43.31,"CIscoreP":"81","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":20.01,"DPM_pctl":62,"DrinkingWa":198.88,"DW_pctl":"15","Pesticides":3.452,"Pest_pctl":50,"Tox_Releas":8989.7,"TR_pctl":92,"Traffic":1099.89,"Traff_Pctl":"72","Cleanups":3.85,"Clean_Pctl":36,"Groundwate":26.4,"GW_pctl":78,"Haz_Waste":0.38,"Haz_pctl":72,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":1.4,"Solid_pctl":37,"PollutionS":6.4,"Poll_pctl":77,"Asthma":70.22,"Asthma_Pct":79,"Low_Birth_":4.46,"LBW_pctl":"38","Cardiovasc":10.57,"CVD_pctl":79,"Education":38.4,"Edu_pctl":"85","Linguistic":22.2,"Ling_pctl":"87","Poverty":48.2,"Pov_pctl":"71","Unemployme":4.3,"Unem_pctl":"8","Housing_Bu":24.4,"HB_pctl":"75","PopCharSco":6.77,"Pop_Pctl":"73","Children__":19,"Pop_11_64_":75.8,"Elderly___":5.2,"Hispanic__":"94.7","White____":"2.7","African_Am":"1","Native_Ame":"0.2","Asian_Amer":"1.1","Other____":"0.3","Shape_Leng":2903.69143469,"Shape_Area":484220.496078}},{"arcs":[[1497,-601,1498,-1121]],"type":"Polygon","properties":{"Tract_1":6037296600,"Percentile":"91-95%","Population":5218,"County":"Los Angeles","ZIP":90731,"City":"San Pedro","CIscore":53.7,"CIscoreP":"92","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":51.9,"DPM_pctl":96,"DrinkingWa":198.88,"DW_pctl":"15","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5497.86,"TR_pctl":82,"Traffic":1003.54,"Traff_Pctl":"68","Cleanups":19.5,"Clean_Pctl":83,"Groundwate":33.5,"GW_pctl":84,"Haz_Waste":0.8,"Haz_pctl":84,"Imp__Water":8,"IWB_pctl":76,"Solid_Wast":0.5,"Solid_pctl":20,"PollutionS":7.08,"Poll_pctl":88,"Asthma":84.98,"Asthma_Pct":88,"Low_Birth_":4.12,"LBW_pctl":"29","Cardiovasc":9.68,"CVD_pctl":71,"Education":35.2,"Edu_pctl":"82","Linguistic":17.3,"Ling_pctl":"79","Poverty":64.7,"Pov_pctl":"89","Unemployme":13.3,"Unem_pctl":"77","Housing_Bu":31.3,"HB_pctl":"90","PopCharSco":7.58,"Pop_Pctl":"84","Children__":14.8,"Pop_11_64_":76.3,"Elderly___":8.9,"Hispanic__":"70.8","White____":"18","African_Am":"5.9","Native_Ame":"0.4","Asian_Amer":"3.2","Other____":"1.7","Shape_Leng":3739.45915605,"Shape_Area":841914.306258}},{"arcs":[[1499,1500]],"type":"Polygon","properties":{"Tract_1":6037575103,"Percentile":"81-85%","Population":5119,"County":"Los Angeles","ZIP":90804,"City":"Long Beach","CIscore":44.7,"CIscoreP":"82","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":25.99,"DPM_pctl":78,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0.016,"Pest_pctl":10,"Tox_Releas":7938.26,"TR_pctl":90,"Traffic":1203.87,"Traff_Pctl":"75","Cleanups":1.3,"Clean_Pctl":20,"Groundwate":23,"GW_pctl":75,"Haz_Waste":2.2,"Haz_pctl":93,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.88,"Poll_pctl":66,"Asthma":86.52,"Asthma_Pct":88,"Low_Birth_":6.43,"LBW_pctl":"84","Cardiovasc":10.65,"CVD_pctl":80,"Education":23.1,"Edu_pctl":"67","Linguistic":4.2,"Ling_pctl":"32","Poverty":54.9,"Pov_pctl":"79","Unemployme":8.2,"Unem_pctl":"41","Housing_Bu":35.4,"HB_pctl":"95","PopCharSco":7.6,"Pop_Pctl":"85","Children__":14.6,"Pop_11_64_":80.4,"Elderly___":5,"Hispanic__":"43.3","White____":"20.4","African_Am":"19.9","Native_Ame":"0.5","Asian_Amer":"12","Other____":"3.9","Shape_Leng":2797.96705966,"Shape_Area":479382.544383}},{"arcs":[[-1336,1501,1502,-1316]],"type":"Polygon","properties":{"Tract_1":6037576402,"Percentile":"86-90%","Population":5181,"County":"Los Angeles","ZIP":90813,"City":"Long Beach","CIscore":49.47,"CIscoreP":"88","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":145.97,"DPM_pctl":100,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":9028.41,"TR_pctl":92,"Traffic":1048.49,"Traff_Pctl":"70","Cleanups":0.1,"Clean_Pctl":2,"Groundwate":5,"GW_pctl":32,"Haz_Waste":0.07,"Haz_pctl":29,"Imp__Water":4,"IWB_pctl":49,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.36,"Poll_pctl":54,"Asthma":114.09,"Asthma_Pct":95,"Low_Birth_":6.4,"LBW_pctl":"83","Cardiovasc":11.17,"CVD_pctl":84,"Education":50.9,"Edu_pctl":"95","Linguistic":24.1,"Ling_pctl":"90","Poverty":69.9,"Pov_pctl":"93","Unemployme":13.9,"Unem_pctl":"80","Housing_Bu":36.3,"HB_pctl":"96","PopCharSco":9.24,"Pop_Pctl":"99","Children__":19.3,"Pop_11_64_":76.5,"Elderly___":4.2,"Hispanic__":"67.1","White____":"5.9","African_Am":"10","Native_Ame":"0.1","Asian_Amer":"15.6","Other____":"1.3","Shape_Leng":2416.66256794,"Shape_Area":324174.26495}},{"arcs":[[1503,1504,-1311,1505]],"type":"Polygon","properties":{"Tract_1":6037575902,"Percentile":"91-95%","Population":4762,"County":"Los Angeles","ZIP":90802,"City":"Long Beach","CIscore":51.28,"CIscoreP":"90","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":208.4,"DPM_pctl":100,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":1.7,"Pest_pctl":43,"Tox_Releas":10609.02,"TR_pctl":94,"Traffic":461.27,"Traff_Pctl":"27","Cleanups":2.1,"Clean_Pctl":28,"Groundwate":10.5,"GW_pctl":51,"Haz_Waste":0.24,"Haz_pctl":64,"Imp__Water":21,"IWB_pctl":99,"Solid_Wast":1.1,"Solid_pctl":33,"PollutionS":6.72,"Poll_pctl":83,"Asthma":79.81,"Asthma_Pct":85,"Low_Birth_":6.59,"LBW_pctl":"86","Cardiovasc":8.87,"CVD_pctl":62,"Education":13.5,"Edu_pctl":"49","Linguistic":11.5,"Ling_pctl":"64","Poverty":58.3,"Pov_pctl":"83","Unemployme":10.8,"Unem_pctl":"62","Housing_Bu":31,"HB_pctl":"89","PopCharSco":7.63,"Pop_Pctl":"85","Children__":9.3,"Pop_11_64_":80.5,"Elderly___":10.2,"Hispanic__":"37.3","White____":"29.4","African_Am":"19.9","Native_Ame":"0.4","Asian_Amer":"8.9","Other____":"4.2","Shape_Leng":2386.8314167,"Shape_Area":350593.500877}},{"arcs":[[1506,1507,1508,1509,-2]],"type":"Polygon","properties":{"Tract_1":6037575401,"Percentile":"96-100%","Population":5155,"County":"Los Angeles","ZIP":90813,"City":"Long Beach","CIscore":67.2,"CIscoreP":"99","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":29.12,"DPM_pctl":84,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":1.427,"Pest_pctl":42,"Tox_Releas":14453.79,"TR_pctl":96,"Traffic":820.59,"Traff_Pctl":"58","Cleanups":0,"Clean_Pctl":0,"Groundwate":57,"GW_pctl":93,"Haz_Waste":1.2,"Haz_pctl":88,"Imp__Water":19,"IWB_pctl":99,"Solid_Wast":2.5,"Solid_pctl":57,"PollutionS":7.42,"Poll_pctl":92,"Asthma":116.32,"Asthma_Pct":96,"Low_Birth_":6.19,"LBW_pctl":"80","Cardiovasc":11.4,"CVD_pctl":85,"Education":54.2,"Edu_pctl":"96","Linguistic":24.9,"Ling_pctl":"90","Poverty":79.1,"Pov_pctl":"98","Unemployme":14.2,"Unem_pctl":"81","Housing_Bu":23.7,"HB_pctl":"73","PopCharSco":9.06,"Pop_Pctl":"98","Children__":19.8,"Pop_11_64_":76.5,"Elderly___":3.7,"Hispanic__":"76.9","White____":"5.7","African_Am":"11.5","Native_Ame":"0.2","Asian_Amer":"4.5","Other____":"1.3","Shape_Leng":3836.56019979,"Shape_Area":887871.361884}},{"arcs":[[1510,1511,-1504,1512,-100,1513,1514]],"type":"Polygon","properties":{"Tract_1":6037575901,"Percentile":"91-95%","Population":3454,"County":"Los Angeles","ZIP":90802,"City":"Long Beach","CIscore":52.97,"CIscoreP":"92","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":208.4,"DPM_pctl":100,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":1.479,"Pest_pctl":42,"Tox_Releas":11002.33,"TR_pctl":95,"Traffic":728.75,"Traff_Pctl":"52","Cleanups":0.4,"Clean_Pctl":6,"Groundwate":28.5,"GW_pctl":80,"Haz_Waste":0.5,"Haz_pctl":75,"Imp__Water":21,"IWB_pctl":99,"Solid_Wast":0.25,"Solid_pctl":10,"PollutionS":6.98,"Poll_pctl":86,"Asthma":83.03,"Asthma_Pct":87,"Low_Birth_":4.83,"LBW_pctl":"48","Cardiovasc":9.28,"CVD_pctl":66,"Education":29.9,"Edu_pctl":"76","Linguistic":13.6,"Ling_pctl":"71","Poverty":59.4,"Pov_pctl":"84","Unemployme":12.7,"Unem_pctl":"74","Housing_Bu":32.2,"HB_pctl":"91","PopCharSco":7.59,"Pop_Pctl":"85","Children__":16.5,"Pop_11_64_":79.1,"Elderly___":4.4,"Hispanic__":"51.2","White____":"15.6","African_Am":"22.3","Native_Ame":"0.5","Asian_Amer":"7.3","Other____":"3.1","Shape_Leng":2953.42062652,"Shape_Area":487085.50267}},{"arcs":[[1515,1516]],"type":"Polygon","properties":{"Tract_1":6037575102,"Percentile":"86-90%","Population":4510,"County":"Los Angeles","ZIP":90804,"City":"Long Beach","CIscore":50.56,"CIscoreP":"89","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":25.99,"DPM_pctl":78,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8108.78,"TR_pctl":90,"Traffic":1015.11,"Traff_Pctl":"68","Cleanups":1.85,"Clean_Pctl":25,"Groundwate":25.5,"GW_pctl":78,"Haz_Waste":2.13,"Haz_pctl":92,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.74,"Poll_pctl":63,"Asthma":86.52,"Asthma_Pct":88,"Low_Birth_":5.45,"LBW_pctl":"65","Cardiovasc":10.65,"CVD_pctl":80,"Education":47.9,"Edu_pctl":"93","Linguistic":19.6,"Ling_pctl":"84","Poverty":70.6,"Pov_pctl":"93","Unemployme":17.8,"Unem_pctl":"92","Housing_Bu":43.8,"HB_pctl":"99","PopCharSco":8.8,"Pop_Pctl":"97","Children__":18.1,"Pop_11_64_":77.1,"Elderly___":4.8,"Hispanic__":"58.5","White____":"5.8","African_Am":"9.5","Native_Ame":"0.3","Asian_Amer":"24","Other____":"2","Shape_Leng":2820.30880655,"Shape_Area":404936.633609}},{"arcs":[[1517,1518,1519,-88]],"type":"Polygon","properties":{"Tract_1":6037575803,"Percentile":"91-95%","Population":2837,"County":"Los Angeles","ZIP":90813,"City":"Long Beach","CIscore":53.83,"CIscoreP":"92","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":158.53,"DPM_pctl":100,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":2.759,"Pest_pctl":48,"Tox_Releas":11898.48,"TR_pctl":95,"Traffic":634.61,"Traff_Pctl":"45","Cleanups":0,"Clean_Pctl":0,"Groundwate":16.75,"GW_pctl":65,"Haz_Waste":0.12,"Haz_pctl":46,"Imp__Water":15,"IWB_pctl":96,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":6.44,"Poll_pctl":78,"Asthma":115.35,"Asthma_Pct":96,"Low_Birth_":5.81,"LBW_pctl":"73","Cardiovasc":11.29,"CVD_pctl":85,"Education":42.6,"Edu_pctl":"89","Linguistic":28.6,"Ling_pctl":"93","Poverty":73.4,"Pov_pctl":"95","Unemployme":8.6,"Unem_pctl":"44","Housing_Bu":20.8,"HB_pctl":"62","PopCharSco":8.36,"Pop_Pctl":"93","Children__":13.9,"Pop_11_64_":68.3,"Elderly___":17.8,"Hispanic__":"55.5","White____":"15.9","African_Am":"15.2","Native_Ame":"0.2","Asian_Amer":"11","Other____":"2.3","Shape_Leng":2104.31864805,"Shape_Area":199434.84486}},{"arcs":[[1520,1521,-1064,1522,-1137,1523,1524,1525,-622,1526,-620,1527]],"type":"Polygon","properties":{"Tract_1":6037297000,"Percentile":"26-30%","Population":5343,"County":"Los Angeles","ZIP":90732,"City":"San Pedro","CIscore":16.47,"CIscoreP":"29","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":20.99,"DPM_pctl":65,"DrinkingWa":198.57,"DW_pctl":"15","Pesticides":0,"Pest_pctl":0,"Tox_Releas":4787.85,"TR_pctl":79,"Traffic":427.11,"Traff_Pctl":"23","Cleanups":9.9,"Clean_Pctl":62,"Groundwate":1.5,"GW_pctl":9,"Haz_Waste":0.06,"Haz_pctl":28,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.1,"Poll_pctl":27,"Asthma":55.76,"Asthma_Pct":64,"Low_Birth_":4.36,"LBW_pctl":"35","Cardiovasc":6.69,"CVD_pctl":33,"Education":10.1,"Edu_pctl":"40","Linguistic":3.9,"Ling_pctl":"29","Poverty":16.9,"Pov_pctl":"20","Unemployme":8.2,"Unem_pctl":"41","Housing_Bu":15.6,"HB_pctl":"38","PopCharSco":4.02,"Pop_Pctl":"33","Children__":11.7,"Pop_11_64_":73,"Elderly___":15.3,"Hispanic__":"28.7","White____":"60.9","African_Am":"2.8","Native_Ame":"0.3","Asian_Amer":"3.9","Other____":"3.4","Shape_Leng":5726.69272556,"Shape_Area":1447982.94329}},{"arcs":[[1528,-1511,1529,1530,1531]],"type":"Polygon","properties":{"Tract_1":6037575801,"Percentile":"96-100%","Population":2446,"County":"Los Angeles","ZIP":90813,"City":"Long Beach","CIscore":64.47,"CIscoreP":"98","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":169.24,"DPM_pctl":100,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":2.337,"Pest_pctl":46,"Tox_Releas":13488.98,"TR_pctl":96,"Traffic":633.62,"Traff_Pctl":"45","Cleanups":0,"Clean_Pctl":0,"Groundwate":54.8,"GW_pctl":92,"Haz_Waste":0.41,"Haz_pctl":73,"Imp__Water":21,"IWB_pctl":99,"Solid_Wast":1.5,"Solid_pctl":39,"PollutionS":7.23,"Poll_pctl":90,"Asthma":112.42,"Asthma_Pct":95,"Low_Birth_":6.05,"LBW_pctl":"77","Cardiovasc":11.02,"CVD_pctl":83,"Education":53.4,"Edu_pctl":"96","Linguistic":11.5,"Ling_pctl":"64","Poverty":84.3,"Pov_pctl":"99","Unemployme":14.1,"Unem_pctl":"81","Housing_Bu":34.4,"HB_pctl":"94","PopCharSco":8.92,"Pop_Pctl":"97","Children__":19.9,"Pop_11_64_":77.1,"Elderly___":3,"Hispanic__":"79.3","White____":"9.5","African_Am":"6.9","Native_Ame":"0.5","Asian_Amer":"2.5","Other____":"1.3","Shape_Leng":2624.92246339,"Shape_Area":433806.823371}},{"arcs":[[-628,1532,1533,1534,1535]],"type":"Polygon","properties":{"Tract_1":6037294830,"Percentile":"96-100%","Population":3707,"County":"Los Angeles","ZIP":90744,"City":"Wilmington","CIscore":61.94,"CIscoreP":"97","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":49.83,"DPM_pctl":96,"DrinkingWa":198.88,"DW_pctl":"15","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8378.15,"TR_pctl":91,"Traffic":435.19,"Traff_Pctl":"24","Cleanups":50.3,"Clean_Pctl":96,"Groundwate":18.85,"GW_pctl":69,"Haz_Waste":2.31,"Haz_pctl":93,"Imp__Water":8,"IWB_pctl":76,"Solid_Wast":6.5,"Solid_pctl":80,"PollutionS":7.21,"Poll_pctl":89,"Asthma":70.22,"Asthma_Pct":79,"Low_Birth_":5.89,"LBW_pctl":"74","Cardiovasc":10.57,"CVD_pctl":79,"Education":54,"Edu_pctl":"96","Linguistic":23.1,"Ling_pctl":"88","Poverty":69.2,"Pov_pctl":"92","Unemployme":12.2,"Unem_pctl":"71","Housing_Bu":34,"HB_pctl":"94","PopCharSco":8.59,"Pop_Pctl":"95","Children__":19.4,"Pop_11_64_":74.2,"Elderly___":6.4,"Hispanic__":"90.1","White____":"3.1","African_Am":"3.9","Native_Ame":"0.4","Asian_Amer":"1.3","Other____":"1.3","Shape_Leng":4170.00908071,"Shape_Area":883763.330682}},{"arcs":[[-1343,-1497,1536]],"type":"Polygon","properties":{"Tract_1":6037294510,"Percentile":"86-90%","Population":4214,"County":"Los Angeles","ZIP":90744,"City":"Wilmington","CIscore":47.49,"CIscoreP":"86","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":20.17,"DPM_pctl":62,"DrinkingWa":198.88,"DW_pctl":"15","Pesticides":2.569,"Pest_pctl":47,"Tox_Releas":8477.44,"TR_pctl":91,"Traffic":1064.56,"Traff_Pctl":"70","Cleanups":0.95,"Clean_Pctl":13,"Groundwate":22.45,"GW_pctl":74,"Haz_Waste":0.64,"Haz_pctl":81,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":1,"Solid_pctl":33,"PollutionS":6.16,"Poll_pctl":73,"Asthma":70.22,"Asthma_Pct":79,"Low_Birth_":4.1,"LBW_pctl":"28","Cardiovasc":10.57,"CVD_pctl":79,"Education":50.5,"Edu_pctl":"94","Linguistic":20.6,"Ling_pctl":"85","Poverty":69.7,"Pov_pctl":"93","Unemployme":11.1,"Unem_pctl":"64","Housing_Bu":37.9,"HB_pctl":"97","PopCharSco":7.71,"Pop_Pctl":"86","Children__":17.8,"Pop_11_64_":76.5,"Elderly___":5.7,"Hispanic__":"92.9","White____":"3.8","African_Am":"1.1","Native_Ame":"0.1","Asian_Amer":"1.5","Other____":"0.5","Shape_Leng":2995.70416814,"Shape_Area":514875.675417}},{"arcs":[[1537,1538,1539,1540,-318,1541,-641,1542]],"type":"Polygon","properties":{"Tract_1":6037294900,"Percentile":"96-100%","Population":3265,"County":"Los Angeles","ZIP":90744,"City":"Wilmington","CIscore":62.08,"CIscoreP":"97","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":49.83,"DPM_pctl":96,"DrinkingWa":198.88,"DW_pctl":"15","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8089.27,"TR_pctl":90,"Traffic":1215.43,"Traff_Pctl":"76","Cleanups":10.9,"Clean_Pctl":65,"Groundwate":15.3,"GW_pctl":62,"Haz_Waste":5.41,"Haz_pctl":97,"Imp__Water":15,"IWB_pctl":96,"Solid_Wast":0.7,"Solid_pctl":23,"PollutionS":7.21,"Poll_pctl":89,"Asthma":70.22,"Asthma_Pct":79,"Low_Birth_":5.28,"LBW_pctl":"60","Cardiovasc":10.57,"CVD_pctl":79,"Education":57.8,"Edu_pctl":"97","Linguistic":23.8,"Ling_pctl":"89","Poverty":72.5,"Pov_pctl":"95","Unemployme":18.6,"Unem_pctl":"94","Housing_Bu":32.7,"HB_pctl":"92","PopCharSco":8.61,"Pop_Pctl":"96","Children__":20.3,"Pop_11_64_":74.5,"Elderly___":5.2,"Hispanic__":"88.6","White____":"3.6","African_Am":"4.6","Native_Ame":"0.2","Asian_Amer":"2.5","Other____":"0.6","Shape_Leng":4146.39557411,"Shape_Area":647409.209601}},{"arcs":[[1543,1544,1545,1546]],"type":"Polygon","properties":{"Tract_1":6037296210,"Percentile":"96-100%","Population":3019,"County":"Los Angeles","ZIP":90731,"City":"San Pedro","CIscore":62.31,"CIscoreP":"97","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":50.72,"DPM_pctl":96,"DrinkingWa":198.88,"DW_pctl":"15","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6724.98,"TR_pctl":87,"Traffic":743.12,"Traff_Pctl":"53","Cleanups":11,"Clean_Pctl":65,"Groundwate":32.55,"GW_pctl":84,"Haz_Waste":1.44,"Haz_pctl":90,"Imp__Water":8,"IWB_pctl":76,"Solid_Wast":1.2,"Solid_pctl":34,"PollutionS":6.97,"Poll_pctl":86,"Asthma":84.98,"Asthma_Pct":88,"Low_Birth_":7.41,"LBW_pctl":"94","Cardiovasc":9.68,"CVD_pctl":71,"Education":43.3,"Edu_pctl":"90","Linguistic":15.4,"Ling_pctl":"75","Poverty":64.3,"Pov_pctl":"88","Unemployme":18.4,"Unem_pctl":"93","Housing_Bu":34.1,"HB_pctl":"94","PopCharSco":8.94,"Pop_Pctl":"97","Children__":18.6,"Pop_11_64_":74.7,"Elderly___":6.7,"Hispanic__":"83.2","White____":"6.3","African_Am":"7.1","Native_Ame":"0.3","Asian_Amer":"1.4","Other____":"1.7","Shape_Leng":2920.59911833,"Shape_Area":557357.175959}},{"arcs":[[1547,-1180,1548]],"type":"Polygon","properties":{"Tract_1":6037294810,"Percentile":"91-95%","Population":3991,"County":"Los Angeles","ZIP":90744,"City":"Wilmington","CIscore":54.7,"CIscoreP":"93","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":49.54,"DPM_pctl":96,"DrinkingWa":198.88,"DW_pctl":"15","Pesticides":0,"Pest_pctl":0,"Tox_Releas":7865.17,"TR_pctl":90,"Traffic":802.19,"Traff_Pctl":"57","Cleanups":9.2,"Clean_Pctl":60,"Groundwate":12.15,"GW_pctl":54,"Haz_Waste":1.53,"Haz_pctl":90,"Imp__Water":8,"IWB_pctl":76,"Solid_Wast":2.5,"Solid_pctl":57,"PollutionS":6.95,"Poll_pctl":86,"Asthma":70.22,"Asthma_Pct":79,"Low_Birth_":4.35,"LBW_pctl":"35","Cardiovasc":10.57,"CVD_pctl":79,"Education":61.9,"Edu_pctl":"99","Linguistic":25.9,"Ling_pctl":"91","Poverty":78.5,"Pov_pctl":"98","Unemployme":11.2,"Unem_pctl":"65","Housing_Bu":28.8,"HB_pctl":"85","PopCharSco":7.87,"Pop_Pctl":"88","Children__":21.1,"Pop_11_64_":74.9,"Elderly___":4,"Hispanic__":"93.2","White____":"1.6","African_Am":"2.2","Native_Ame":"0.1","Asian_Amer":"2","Other____":"0.9","Shape_Leng":2305.95347103,"Shape_Area":320535.339266}},{"arcs":[[1549,-76,1550,1551,1552]],"type":"Polygon","properties":{"Tract_1":6037577501,"Percentile":"21-25%","Population":3435,"County":"Los Angeles","ZIP":90803,"City":"Long Beach","CIscore":14.79,"CIscoreP":"25","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":12.67,"DPM_pctl":38,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":9100.3,"TR_pctl":92,"Traffic":715.81,"Traff_Pctl":"51","Cleanups":2.25,"Clean_Pctl":29,"Groundwate":1.2,"GW_pctl":6,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":10,"IWB_pctl":86,"Solid_Wast":0.7,"Solid_pctl":23,"PollutionS":4.67,"Poll_pctl":40,"Asthma":28.26,"Asthma_Pct":22,"Low_Birth_":4.67,"LBW_pctl":"43","Cardiovasc":7.63,"CVD_pctl":46,"Education":2.5,"Edu_pctl":"8","Linguistic":0,"Ling_pctl":"0","Poverty":15.5,"Pov_pctl":"17","Unemployme":12.3,"Unem_pctl":"72","Housing_Bu":12.6,"HB_pctl":"24","PopCharSco":3.17,"Pop_Pctl":"21","Children__":8,"Pop_11_64_":68.8,"Elderly___":23.2,"Hispanic__":"10.1","White____":"82.9","African_Am":"0.8","Native_Ame":"0.2","Asian_Amer":"3.7","Other____":"2.3","Shape_Leng":4712.47917235,"Shape_Area":1361080.09036}},{"arcs":[[1553,1554,1555,1556]],"type":"Polygon","properties":{"Tract_1":6037575201,"Percentile":"91-95%","Population":4667,"County":"Los Angeles","ZIP":90813,"City":"Long Beach","CIscore":51.55,"CIscoreP":"90","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":29.12,"DPM_pctl":84,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8988.9,"TR_pctl":92,"Traffic":1185.08,"Traff_Pctl":"75","Cleanups":4,"Clean_Pctl":39,"Groundwate":15.75,"GW_pctl":63,"Haz_Waste":0.16,"Haz_pctl":54,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.59,"Poll_pctl":60,"Asthma":130.75,"Asthma_Pct":98,"Low_Birth_":6.29,"LBW_pctl":"82","Cardiovasc":12.73,"CVD_pctl":92,"Education":41,"Edu_pctl":"88","Linguistic":18.9,"Ling_pctl":"82","Poverty":63.3,"Pov_pctl":"87","Unemployme":16,"Unem_pctl":"88","Housing_Bu":32.8,"HB_pctl":"92","PopCharSco":9.23,"Pop_Pctl":"99","Children__":16.6,"Pop_11_64_":77.2,"Elderly___":6.2,"Hispanic__":"48.9","White____":"3.1","African_Am":"17.8","Native_Ame":"0.1","Asian_Amer":"27.8","Other____":"2.1","Shape_Leng":3217.48916657,"Shape_Area":566668.443848}},{"arcs":[[-1556,1557,1558,1559]],"type":"Polygon","properties":{"Tract_1":6037575202,"Percentile":"81-85%","Population":4916,"County":"Los Angeles","ZIP":90813,"City":"Long Beach","CIscore":45.96,"CIscoreP":"84","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":26.84,"DPM_pctl":80,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0.004,"Pest_pctl":6,"Tox_Releas":8546.11,"TR_pctl":91,"Traffic":1048.54,"Traff_Pctl":"70","Cleanups":4,"Clean_Pctl":39,"Groundwate":11.75,"GW_pctl":53,"Haz_Waste":0.15,"Haz_pctl":54,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.46,"Poll_pctl":57,"Asthma":112.75,"Asthma_Pct":95,"Low_Birth_":5.12,"LBW_pctl":"56","Cardiovasc":11.11,"CVD_pctl":84,"Education":45.6,"Edu_pctl":"91","Linguistic":39.1,"Ling_pctl":"98","Poverty":64.2,"Pov_pctl":"88","Unemployme":9.3,"Unem_pctl":"50","Housing_Bu":32.6,"HB_pctl":"92","PopCharSco":8.42,"Pop_Pctl":"94","Children__":19.2,"Pop_11_64_":75.9,"Elderly___":4.9,"Hispanic__":"61","White____":"2.8","African_Am":"6.8","Native_Ame":"0.1","Asian_Amer":"28","Other____":"1.4","Shape_Leng":2813.64196202,"Shape_Area":404313.846395}},{"arcs":[[1560,1561]],"type":"Polygon","properties":{"Tract_1":6037600202,"Percentile":"71-75%","Population":6205,"County":"Los Angeles","ZIP":90044,"City":"Los Angeles","CIscore":37.74,"CIscoreP":"73","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":21.05,"DPM_pctl":65,"DrinkingWa":479.96,"DW_pctl":"51","Pesticides":0,"Pest_pctl":0,"Tox_Releas":4823.64,"TR_pctl":80,"Traffic":943.53,"Traff_Pctl":"65","Cleanups":0,"Clean_Pctl":0,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.49,"Poll_pctl":36,"Asthma":83.79,"Asthma_Pct":87,"Low_Birth_":9.58,"LBW_pctl":"100","Cardiovasc":8.01,"CVD_pctl":51,"Education":31.7,"Edu_pctl":"78","Linguistic":10.6,"Ling_pctl":"61","Poverty":67.6,"Pov_pctl":"91","Unemployme":16,"Unem_pctl":"88","Housing_Bu":38.7,"HB_pctl":"97","PopCharSco":8.41,"Pop_Pctl":"94","Children__":17.2,"Pop_11_64_":75.3,"Elderly___":7.5,"Hispanic__":"51.5","White____":"1","African_Am":"45.5","Native_Ame":"0.2","Asian_Amer":"0.4","Other____":"1.3","Shape_Leng":4443.57047405,"Shape_Area":830068.512053}},{"arcs":[[1562,1563,1564]],"type":"Polygon","properties":{"Tract_1":6037600501,"Percentile":"71-75%","Population":2478,"County":"Los Angeles","ZIP":90303,"City":"Inglewood","CIscore":38.44,"CIscoreP":"74","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":18.08,"DPM_pctl":55,"DrinkingWa":289.46,"DW_pctl":"31","Pesticides":7.482,"Pest_pctl":56,"Tox_Releas":4901.14,"TR_pctl":80,"Traffic":624.93,"Traff_Pctl":"44","Cleanups":1,"Clean_Pctl":18,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.01,"Haz_pctl":9,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0.1,"Solid_pctl":1,"PollutionS":5.36,"Poll_pctl":55,"Asthma":99.24,"Asthma_Pct":93,"Low_Birth_":9.77,"LBW_pctl":"100","Cardiovasc":11.46,"CVD_pctl":86,"Education":8.8,"Edu_pctl":"35","Linguistic":0,"Ling_pctl":"0","Poverty":32.5,"Pov_pctl":"49","Unemployme":17.8,"Unem_pctl":"92","Housing_Bu":18.3,"HB_pctl":"52","PopCharSco":7.17,"Pop_Pctl":"79","Children__":10.8,"Pop_11_64_":70.8,"Elderly___":18.4,"Hispanic__":"13.4","White____":"1.1","African_Am":"81.8","Native_Ame":"0","Asian_Amer":"1","Other____":"2.6","Shape_Leng":3230.49187099,"Shape_Area":652225.604648}},{"arcs":[[1565,1566,1567]],"type":"Polygon","properties":{"Tract_1":6037600400,"Percentile":"81-85%","Population":3986,"County":"Los Angeles","ZIP":90047,"City":"Los Angeles","CIscore":44.92,"CIscoreP":"83","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":18.08,"DPM_pctl":55,"DrinkingWa":488.68,"DW_pctl":"52","Pesticides":7.505,"Pest_pctl":56,"Tox_Releas":4845.05,"TR_pctl":80,"Traffic":741.01,"Traff_Pctl":"53","Cleanups":5.6,"Clean_Pctl":46,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.06,"Haz_pctl":28,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.95,"Solid_pctl":24,"PollutionS":5.71,"Poll_pctl":62,"Asthma":142.9,"Asthma_Pct":98,"Low_Birth_":8.3,"LBW_pctl":"98","Cardiovasc":11.31,"CVD_pctl":85,"Education":16,"Edu_pctl":"54","Linguistic":0.8,"Ling_pctl":"4","Poverty":43.1,"Pov_pctl":"64","Unemployme":18,"Unem_pctl":"93","Housing_Bu":24.2,"HB_pctl":"74","PopCharSco":7.87,"Pop_Pctl":"88","Children__":12.4,"Pop_11_64_":72.5,"Elderly___":15.1,"Hispanic__":"12.8","White____":"1.7","African_Am":"81.9","Native_Ame":"0.1","Asian_Amer":"0.8","Other____":"2.7","Shape_Leng":4850.06644507,"Shape_Area":980439.784501}},{"arcs":[[1568,1569,1570,-1125,1571,-612,1572,-1486,1573,-281]],"type":"Polygon","properties":{"Tract_1":6037296300,"Percentile":"51-55%","Population":4221,"County":"Los Angeles","ZIP":90732,"City":"San Pedro","CIscore":26.61,"CIscoreP":"53","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":36.58,"DPM_pctl":91,"DrinkingWa":419.68,"DW_pctl":"44","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6183.43,"TR_pctl":86,"Traffic":982.18,"Traff_Pctl":"67","Cleanups":4.15,"Clean_Pctl":39,"Groundwate":3.5,"GW_pctl":24,"Haz_Waste":0.2,"Haz_pctl":57,"Imp__Water":8,"IWB_pctl":76,"Solid_Wast":4.5,"Solid_pctl":70,"PollutionS":6.71,"Poll_pctl":83,"Asthma":31.06,"Asthma_Pct":27,"Low_Birth_":5.74,"LBW_pctl":"71","Cardiovasc":4.06,"CVD_pctl":5,"Education":13.6,"Edu_pctl":"49","Linguistic":7.9,"Ling_pctl":"50","Poverty":19.9,"Pov_pctl":"26","Unemployme":8.9,"Unem_pctl":"47","Housing_Bu":15.4,"HB_pctl":"37","PopCharSco":3.97,"Pop_Pctl":"32","Children__":10.8,"Pop_11_64_":76.4,"Elderly___":12.8,"Hispanic__":"35.1","White____":"41.2","African_Am":"6.3","Native_Ame":"0.2","Asian_Amer":"13.3","Other____":"3.8","Shape_Leng":5188.63483024,"Shape_Area":1060741.21822}},{"arcs":[[1574,1575,1576,1577]],"type":"Polygon","properties":{"Tract_1":6037503202,"Percentile":"71-75%","Population":4462,"County":"Los Angeles","ZIP":90604,"City":"Whittier","CIscore":36.64,"CIscoreP":"71","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":15.51,"DPM_pctl":47,"DrinkingWa":548.98,"DW_pctl":"57","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5659.23,"TR_pctl":83,"Traffic":711.26,"Traff_Pctl":"51","Cleanups":0.5,"Clean_Pctl":8,"Groundwate":10.75,"GW_pctl":51,"Haz_Waste":0.08,"Haz_pctl":32,"Imp__Water":2,"IWB_pctl":29,"Solid_Wast":2,"Solid_pctl":50,"PollutionS":5.78,"Poll_pctl":64,"Asthma":57.53,"Asthma_Pct":66,"Low_Birth_":5,"LBW_pctl":"52","Cardiovasc":11.21,"CVD_pctl":84,"Education":24.1,"Edu_pctl":"69","Linguistic":8.3,"Ling_pctl":"53","Poverty":36,"Pov_pctl":"54","Unemployme":11,"Unem_pctl":"63","Housing_Bu":14.9,"HB_pctl":"35","PopCharSco":6.34,"Pop_Pctl":"67","Children__":13.7,"Pop_11_64_":74.4,"Elderly___":11.9,"Hispanic__":"76.2","White____":"16.5","African_Am":"0.9","Native_Ame":"0.5","Asian_Amer":"5","Other____":"0.9","Shape_Leng":4860.36928185,"Shape_Area":1135913.63489}},{"arcs":[[1578,1579,1580,1581,1582]],"type":"Polygon","properties":{"Tract_1":6037503401,"Percentile":"46-50%","Population":6529,"County":"Los Angeles","ZIP":90603,"City":"Whittier","CIscore":23.56,"CIscoreP":"47","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":8.61,"DPM_pctl":24,"DrinkingWa":586.28,"DW_pctl":"62","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6126.71,"TR_pctl":85,"Traffic":673.98,"Traff_Pctl":"48","Cleanups":6.75,"Clean_Pctl":50,"Groundwate":19,"GW_pctl":69,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.99,"Poll_pctl":46,"Asthma":46.08,"Asthma_Pct":51,"Low_Birth_":5.08,"LBW_pctl":"54","Cardiovasc":11.79,"CVD_pctl":88,"Education":8.6,"Edu_pctl":"35","Linguistic":7,"Ling_pctl":"46","Poverty":11.7,"Pov_pctl":"10","Unemployme":8,"Unem_pctl":"39","Housing_Bu":6.6,"HB_pctl":"4","PopCharSco":4.72,"Pop_Pctl":"43","Children__":11.7,"Pop_11_64_":74.2,"Elderly___":14.1,"Hispanic__":"48.6","White____":"43.5","African_Am":"1","Native_Ame":"0.2","Asian_Amer":"5.3","Other____":"1.4","Shape_Leng":5819.20527804,"Shape_Area":1942238.54805}},{"arcs":[[1583,1584,-983,1585,1586,1587]],"type":"Polygon","properties":{"Tract_1":6037553200,"Percentile":"81-85%","Population":7055,"County":"Los Angeles","ZIP":90706,"City":"Bellflower","CIscore":46.08,"CIscoreP":"84","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":24.59,"DPM_pctl":75,"DrinkingWa":757.05,"DW_pctl":"87","Pesticides":17.52,"Pest_pctl":63,"Tox_Releas":5507.34,"TR_pctl":82,"Traffic":808.03,"Traff_Pctl":"57","Cleanups":0.5,"Clean_Pctl":8,"Groundwate":2.5,"GW_pctl":15,"Haz_Waste":0.5,"Haz_pctl":77,"Imp__Water":3,"IWB_pctl":41,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":6.88,"Poll_pctl":85,"Asthma":68.38,"Asthma_Pct":77,"Low_Birth_":5.45,"LBW_pctl":"65","Cardiovasc":9.75,"CVD_pctl":72,"Education":19.2,"Edu_pctl":"60","Linguistic":13.4,"Ling_pctl":"71","Poverty":31.5,"Pov_pctl":"47","Unemployme":8.9,"Unem_pctl":"47","Housing_Bu":21.3,"HB_pctl":"64","PopCharSco":6.7,"Pop_Pctl":"72","Children__":13,"Pop_11_64_":76,"Elderly___":11,"Hispanic__":"56.3","White____":"22.9","African_Am":"7.5","Native_Ame":"0.6","Asian_Amer":"10.6","Other____":"2.1","Shape_Leng":6225.44331541,"Shape_Area":1926133.97823}},{"arcs":[[1588,-1418,1589,-1111]],"type":"Polygon","properties":{"Tract_1":6037554700,"Percentile":"66-70%","Population":4874,"County":"Los Angeles","ZIP":90650,"City":"Norwalk","CIscore":33.81,"CIscoreP":"66","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":21.04,"DPM_pctl":65,"DrinkingWa":416.82,"DW_pctl":"43","Pesticides":11.946,"Pest_pctl":60,"Tox_Releas":5505.87,"TR_pctl":82,"Traffic":627.85,"Traff_Pctl":"44","Cleanups":0.45,"Clean_Pctl":6,"Groundwate":14.5,"GW_pctl":59,"Haz_Waste":0.12,"Haz_pctl":49,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.5,"Solid_pctl":20,"PollutionS":5.82,"Poll_pctl":65,"Asthma":42.86,"Asthma_Pct":46,"Low_Birth_":5.05,"LBW_pctl":"54","Cardiovasc":9.21,"CVD_pctl":66,"Education":36.5,"Edu_pctl":"84","Linguistic":12.7,"Ling_pctl":"68","Poverty":47,"Pov_pctl":"69","Unemployme":7.2,"Unem_pctl":"31","Housing_Bu":14.4,"HB_pctl":"32","PopCharSco":5.81,"Pop_Pctl":"59","Children__":15.3,"Pop_11_64_":75.3,"Elderly___":9.4,"Hispanic__":"80.9","White____":"4.1","African_Am":"1.8","Native_Ame":"0.2","Asian_Amer":"11.6","Other____":"1.5","Shape_Leng":4204.08187829,"Shape_Area":801806.860231}},{"arcs":[[1590,-1421,1591,-1409,1592]],"type":"Polygon","properties":{"Tract_1":6037554801,"Percentile":"76-80%","Population":3366,"County":"Los Angeles","ZIP":90701,"City":"Artesia","CIscore":40.33,"CIscoreP":"77","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":25.67,"DPM_pctl":78,"DrinkingWa":474.64,"DW_pctl":"49","Pesticides":937.658,"Pest_pctl":89,"Tox_Releas":5721.33,"TR_pctl":83,"Traffic":2702.7,"Traff_Pctl":"96","Cleanups":0,"Clean_Pctl":0,"Groundwate":7,"GW_pctl":39,"Haz_Waste":0.04,"Haz_pctl":18,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":6.42,"Poll_pctl":78,"Asthma":33.04,"Asthma_Pct":30,"Low_Birth_":6.41,"LBW_pctl":"84","Cardiovasc":8.59,"CVD_pctl":58,"Education":39.2,"Edu_pctl":"86","Linguistic":18.2,"Ling_pctl":"81","Poverty":55.1,"Pov_pctl":"79","Unemployme":3.4,"Unem_pctl":"4","Housing_Bu":22.4,"HB_pctl":"68","PopCharSco":6.28,"Pop_Pctl":"66","Children__":14.9,"Pop_11_64_":76.7,"Elderly___":8.4,"Hispanic__":"76.2","White____":"7.6","African_Am":"2.5","Native_Ame":"0.1","Asian_Amer":"11.9","Other____":"1.7","Shape_Leng":4608.51221091,"Shape_Area":903327.671155}},{"arcs":[[1593,1594,1595,1596,1597,1598,1599,1600,1601]],"type":"Polygon","properties":{"Tract_1":6037553701,"Percentile":"96-100%","Population":4176,"County":"Los Angeles","ZIP":90723,"City":"Paramount","CIscore":64.32,"CIscoreP":"98","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":26.94,"DPM_pctl":80,"DrinkingWa":291.55,"DW_pctl":"31","Pesticides":0,"Pest_pctl":0,"Tox_Releas":7295.73,"TR_pctl":89,"Traffic":2498.36,"Traff_Pctl":"95","Cleanups":15.15,"Clean_Pctl":77,"Groundwate":39,"GW_pctl":87,"Haz_Waste":0.45,"Haz_pctl":74,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":10.75,"Solid_pctl":90,"PollutionS":8.18,"Poll_pctl":97,"Asthma":61.93,"Asthma_Pct":71,"Low_Birth_":5.22,"LBW_pctl":"58","Cardiovasc":11.54,"CVD_pctl":86,"Education":56.1,"Edu_pctl":"97","Linguistic":16.3,"Ling_pctl":"78","Poverty":61.6,"Pov_pctl":"86","Unemployme":10.7,"Unem_pctl":"61","Housing_Bu":25.1,"HB_pctl":"77","PopCharSco":7.86,"Pop_Pctl":"88","Children__":20,"Pop_11_64_":74.7,"Elderly___":5.3,"Hispanic__":"93","White____":"3.3","African_Am":"2.5","Native_Ame":"0.1","Asian_Amer":"0.5","Other____":"0.6","Shape_Leng":5631.93759403,"Shape_Area":1086839.20754}},{"arcs":[[1602,1603,1604,1605,1606]],"type":"Polygon","properties":{"Tract_1":6037553801,"Percentile":"96-100%","Population":4174,"County":"Los Angeles","ZIP":90723,"City":"Paramount","CIscore":61.13,"CIscoreP":"97","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":25.09,"DPM_pctl":77,"DrinkingWa":197.5,"DW_pctl":"15","Pesticides":0,"Pest_pctl":0,"Tox_Releas":13253.5,"TR_pctl":96,"Traffic":489.55,"Traff_Pctl":"30","Cleanups":24.5,"Clean_Pctl":87,"Groundwate":24.8,"GW_pctl":77,"Haz_Waste":1.68,"Haz_pctl":91,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":14.7,"Solid_pctl":95,"PollutionS":7.43,"Poll_pctl":92,"Asthma":61.93,"Asthma_Pct":71,"Low_Birth_":5.73,"LBW_pctl":"71","Cardiovasc":11.54,"CVD_pctl":86,"Education":44.6,"Edu_pctl":"91","Linguistic":18.6,"Ling_pctl":"82","Poverty":57.9,"Pov_pctl":"82","Unemployme":12,"Unem_pctl":"70","Housing_Bu":30.1,"HB_pctl":"88","PopCharSco":8.23,"Pop_Pctl":"92","Children__":20.4,"Pop_11_64_":73.9,"Elderly___":5.7,"Hispanic__":"75.2","White____":"3.9","African_Am":"16.8","Native_Ame":"0.1","Asian_Amer":"2.8","Other____":"1.3","Shape_Leng":4826.69476499,"Shape_Area":1301217.77515}},{"arcs":[[1607,1608,1609,-1007,1610,-987]],"type":"Polygon","properties":{"Tract_1":6037553502,"Percentile":"86-90%","Population":4183,"County":"Los Angeles","ZIP":90723,"City":"Paramount","CIscore":50.44,"CIscoreP":"89","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":20.99,"DPM_pctl":65,"DrinkingWa":310.51,"DW_pctl":"33","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6750.27,"TR_pctl":87,"Traffic":567.72,"Traff_Pctl":"38","Cleanups":5.95,"Clean_Pctl":47,"Groundwate":24.3,"GW_pctl":76,"Haz_Waste":0.94,"Haz_pctl":86,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":4.5,"Solid_pctl":70,"PollutionS":6.93,"Poll_pctl":86,"Asthma":56.7,"Asthma_Pct":65,"Low_Birth_":5.78,"LBW_pctl":"72","Cardiovasc":10.51,"CVD_pctl":79,"Education":33.6,"Edu_pctl":"80","Linguistic":19.5,"Ling_pctl":"84","Poverty":49,"Pov_pctl":"72","Unemployme":8.8,"Unem_pctl":"46","Housing_Bu":20.3,"HB_pctl":"60","PopCharSco":7.28,"Pop_Pctl":"80","Children__":15.9,"Pop_11_64_":76.1,"Elderly___":8,"Hispanic__":"76.4","White____":"5.7","African_Am":"12.5","Native_Ame":"0.1","Asian_Amer":"2.8","Other____":"2.4","Shape_Leng":4707.28896749,"Shape_Area":1266252.71081}},{"arcs":[[1611,1612,1613,1614,1615,-1609,1616,-1595,1617,1618,1619,1620]],"type":"Polygon","properties":{"Tract_1":6037553601,"Percentile":"96-100%","Population":4750,"County":"Los Angeles","ZIP":90723,"City":"Paramount","CIscore":65.37,"CIscoreP":"98","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":26.61,"DPM_pctl":80,"DrinkingWa":302.13,"DW_pctl":"32","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8306.37,"TR_pctl":91,"Traffic":1626.68,"Traff_Pctl":"85","Cleanups":23.35,"Clean_Pctl":86,"Groundwate":55.8,"GW_pctl":92,"Haz_Waste":0.92,"Haz_pctl":86,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":23.25,"Solid_pctl":98,"PollutionS":8.38,"Poll_pctl":98,"Asthma":50.32,"Asthma_Pct":57,"Low_Birth_":7.26,"LBW_pctl":"93","Cardiovasc":9.7,"CVD_pctl":72,"Education":48.6,"Edu_pctl":"93","Linguistic":16.1,"Ling_pctl":"77","Poverty":47.9,"Pov_pctl":"71","Unemployme":12,"Unem_pctl":"70","Housing_Bu":23.8,"HB_pctl":"73","PopCharSco":7.8,"Pop_Pctl":"87","Children__":18.1,"Pop_11_64_":77.1,"Elderly___":4.8,"Hispanic__":"75","White____":"4.6","African_Am":"15.8","Native_Ame":"0.1","Asian_Amer":"3.2","Other____":"1.2","Shape_Leng":8195.91473033,"Shape_Area":2035581.76108}},{"arcs":[[-1606,-1608,1621,-274,1622,1623]],"type":"Polygon","properties":{"Tract_1":6037553901,"Percentile":"86-90%","Population":6896,"County":"Los Angeles","ZIP":90723,"City":"Paramount","CIscore":48.47,"CIscoreP":"87","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":20.99,"DPM_pctl":65,"DrinkingWa":304.17,"DW_pctl":"33","Pesticides":0,"Pest_pctl":0,"Tox_Releas":9055.36,"TR_pctl":92,"Traffic":501.9,"Traff_Pctl":"31","Cleanups":5.7,"Clean_Pctl":46,"Groundwate":42.8,"GW_pctl":89,"Haz_Waste":0.71,"Haz_pctl":83,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":5.6,"Solid_pctl":76,"PollutionS":6.43,"Poll_pctl":78,"Asthma":52.24,"Asthma_Pct":59,"Low_Birth_":6.99,"LBW_pctl":"90","Cardiovasc":9.41,"CVD_pctl":68,"Education":36.8,"Edu_pctl":"84","Linguistic":12.5,"Ling_pctl":"68","Poverty":43,"Pov_pctl":"64","Unemployme":11.5,"Unem_pctl":"67","Housing_Bu":26.7,"HB_pctl":"81","PopCharSco":7.53,"Pop_Pctl":"84","Children__":14.1,"Pop_11_64_":78.3,"Elderly___":7.6,"Hispanic__":"78.4","White____":"7.9","African_Am":"7","Native_Ame":"0.2","Asian_Amer":"5.5","Other____":"1","Shape_Leng":4805.15241534,"Shape_Area":1281474.83846}},{"arcs":[[1624,1625,1626,1627,1628,1629,1630,1631,1632,1633,1634]],"type":"Polygon","properties":{"Tract_1":6037543501,"Percentile":"86-90%","Population":6805,"County":"Los Angeles","ZIP":90745,"City":"Carson","CIscore":49.82,"CIscoreP":"89","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":23.92,"DPM_pctl":73,"DrinkingWa":182.06,"DW_pctl":"14","Pesticides":0.09,"Pest_pctl":20,"Tox_Releas":7889.9,"TR_pctl":90,"Traffic":2151.94,"Traff_Pctl":"92","Cleanups":66.25,"Clean_Pctl":98,"Groundwate":29.1,"GW_pctl":81,"Haz_Waste":0.12,"Haz_pctl":49,"Imp__Water":3,"IWB_pctl":41,"Solid_Wast":25,"Solid_pctl":99,"PollutionS":7.6,"Poll_pctl":94,"Asthma":60.31,"Asthma_Pct":70,"Low_Birth_":6.79,"LBW_pctl":"88","Cardiovasc":9.96,"CVD_pctl":74,"Education":27.7,"Edu_pctl":"74","Linguistic":14.8,"Ling_pctl":"74","Poverty":31.1,"Pov_pctl":"46","Unemployme":5.5,"Unem_pctl":"17","Housing_Bu":14.8,"HB_pctl":"34","PopCharSco":6.55,"Pop_Pctl":"70","Children__":11,"Pop_11_64_":74.3,"Elderly___":14.7,"Hispanic__":"32.3","White____":"9.2","African_Am":"7.9","Native_Ame":"0.2","Asian_Amer":"47.5","Other____":"2.9","Shape_Leng":10554.9597974,"Shape_Area":2671657.89264}},{"arcs":[[1635,1636,-679,1637]],"type":"Polygon","properties":{"Tract_1":6037555002,"Percentile":"66-70%","Population":3475,"County":"Los Angeles","ZIP":90715,"City":"Lakewood","CIscore":35.69,"CIscoreP":"70","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":12.89,"DPM_pctl":38,"DrinkingWa":371.86,"DW_pctl":"39","Pesticides":2.387,"Pest_pctl":46,"Tox_Releas":5489.07,"TR_pctl":82,"Traffic":1968.46,"Traff_Pctl":"91","Cleanups":2,"Clean_Pctl":27,"Groundwate":4,"GW_pctl":27,"Haz_Waste":0.12,"Haz_pctl":49,"Imp__Water":9,"IWB_pctl":81,"Solid_Wast":0.75,"Solid_pctl":23,"PollutionS":6.43,"Poll_pctl":78,"Asthma":43.6,"Asthma_Pct":47,"Low_Birth_":6.21,"LBW_pctl":"80","Cardiovasc":6.89,"CVD_pctl":36,"Education":13.1,"Edu_pctl":"48","Linguistic":7.9,"Ling_pctl":"50","Poverty":34.1,"Pov_pctl":"51","Unemployme":7.2,"Unem_pctl":"31","Housing_Bu":27.5,"HB_pctl":"83","PopCharSco":5.55,"Pop_Pctl":"55","Children__":12.3,"Pop_11_64_":80.4,"Elderly___":7.3,"Hispanic__":"42.3","White____":"26.3","African_Am":"10.6","Native_Ame":"0.5","Asian_Amer":"16.7","Other____":"3.6","Shape_Leng":3896.42091912,"Shape_Area":914342.58107}},{"arcs":[[-183,1638,1639,-1040,1640,1641,1642,-1052]],"type":"Polygon","properties":{"Tract_1":6037571900,"Percentile":"46-50%","Population":5509,"County":"Los Angeles","ZIP":90807,"City":"Long Beach","CIscore":23.49,"CIscoreP":"46","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":20.48,"DPM_pctl":63,"DrinkingWa":279.54,"DW_pctl":"29","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6926.35,"TR_pctl":88,"Traffic":764.51,"Traff_Pctl":"55","Cleanups":7,"Clean_Pctl":52,"Groundwate":24.15,"GW_pctl":76,"Haz_Waste":0.1,"Haz_pctl":43,"Imp__Water":12,"IWB_pctl":91,"Solid_Wast":2,"Solid_pctl":50,"PollutionS":6.48,"Poll_pctl":79,"Asthma":49.43,"Asthma_Pct":55,"Low_Birth_":5.37,"LBW_pctl":"63","Cardiovasc":6.99,"CVD_pctl":37,"Education":3.7,"Edu_pctl":"14","Linguistic":4.1,"Ling_pctl":"31","Poverty":15.8,"Pov_pctl":"18","Unemployme":5.3,"Unem_pctl":"15","Housing_Bu":10.4,"HB_pctl":"14","PopCharSco":3.63,"Pop_Pctl":"27","Children__":11.3,"Pop_11_64_":76.8,"Elderly___":11.9,"Hispanic__":"18.7","White____":"48.3","African_Am":"16.4","Native_Ame":"0.5","Asian_Amer":"12","Other____":"4.1","Shape_Leng":7270.72297726,"Shape_Area":1947145.25506}},{"arcs":[[1643,-1444,1644,-1442,1645,-41,1646,1647,1648,-1437]],"type":"Polygon","properties":{"Tract_1":6037572400,"Percentile":"66-70%","Population":1152,"County":"Los Angeles","ZIP":90810,"City":"Long Beach","CIscore":34.75,"CIscoreP":"68","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":20.9,"DPM_pctl":64,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":21.495,"Pest_pctl":65,"Tox_Releas":7335.03,"TR_pctl":89,"Traffic":2869.97,"Traff_Pctl":"97","Cleanups":2.25,"Clean_Pctl":29,"Groundwate":13.25,"GW_pctl":57,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":12,"IWB_pctl":91,"Solid_Wast":1.25,"Solid_pctl":37,"PollutionS":6.81,"Poll_pctl":84,"Asthma":55.45,"Asthma_Pct":63,"Low_Birth_":4.04,"LBW_pctl":"27","Cardiovasc":7.08,"CVD_pctl":38,"Education":17.2,"Edu_pctl":"57","Linguistic":3.9,"Ling_pctl":"29","Poverty":46.6,"Pov_pctl":"69","Unemployme":12.4,"Unem_pctl":"72","Housing_Bu":0,"HB_pctl":"NA","PopCharSco":5.1,"Pop_Pctl":"49","Children__":12,"Pop_11_64_":75.6,"Elderly___":12.4,"Hispanic__":"37.8","White____":"5.1","African_Am":"31.6","Native_Ame":"0.3","Asian_Amer":"23.1","Other____":"2","Shape_Leng":3884.77731275,"Shape_Area":558837.626817}},{"arcs":[[1649,1650,1651,1652]],"type":"Polygon","properties":{"Tract_1":6037572002,"Percentile":"61-65%","Population":4409,"County":"Los Angeles","ZIP":90807,"City":"Long Beach","CIscore":30.61,"CIscoreP":"61","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":20.9,"DPM_pctl":64,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":7540.65,"TR_pctl":89,"Traffic":2600.55,"Traff_Pctl":"96","Cleanups":9,"Clean_Pctl":60,"Groundwate":27.8,"GW_pctl":80,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":12,"IWB_pctl":91,"Solid_Wast":0.25,"Solid_pctl":10,"PollutionS":6.27,"Poll_pctl":75,"Asthma":49.44,"Asthma_Pct":55,"Low_Birth_":6.62,"LBW_pctl":"87","Cardiovasc":6.99,"CVD_pctl":37,"Education":6.9,"Edu_pctl":"28","Linguistic":5.7,"Ling_pctl":"40","Poverty":25.5,"Pov_pctl":"37","Unemployme":7.2,"Unem_pctl":"31","Housing_Bu":15.3,"HB_pctl":"36","PopCharSco":4.88,"Pop_Pctl":"46","Children__":9.2,"Pop_11_64_":67.7,"Elderly___":23.1,"Hispanic__":"17.4","White____":"37.7","African_Am":"20.3","Native_Ame":"0.4","Asian_Amer":"20","Other____":"4.2","Shape_Leng":4252.49344087,"Shape_Area":1034268.61925}},{"arcs":[[1653,-1048,1654,1655,-1652,-1642,1656,1657]],"type":"Polygon","properties":{"Tract_1":6037572001,"Percentile":"46-50%","Population":5278,"County":"Los Angeles","ZIP":90807,"City":"Long Beach","CIscore":25.03,"CIscoreP":"50","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":20.5,"DPM_pctl":63,"DrinkingWa":286.02,"DW_pctl":"30","Pesticides":0,"Pest_pctl":0,"Tox_Releas":16578.37,"TR_pctl":97,"Traffic":962.32,"Traff_Pctl":"66","Cleanups":5.55,"Clean_Pctl":46,"Groundwate":40.65,"GW_pctl":88,"Haz_Waste":0.48,"Haz_pctl":75,"Imp__Water":11,"IWB_pctl":90,"Solid_Wast":2,"Solid_pctl":50,"PollutionS":7.02,"Poll_pctl":87,"Asthma":44.94,"Asthma_Pct":49,"Low_Birth_":4.61,"LBW_pctl":"42","Cardiovasc":6.48,"CVD_pctl":30,"Education":3.7,"Edu_pctl":"14","Linguistic":2.4,"Ling_pctl":"18","Poverty":15.1,"Pov_pctl":"16","Unemployme":8.7,"Unem_pctl":"45","Housing_Bu":17.9,"HB_pctl":"50","PopCharSco":3.57,"Pop_Pctl":"26","Children__":13.1,"Pop_11_64_":77.5,"Elderly___":9.4,"Hispanic__":"25.5","White____":"50.6","African_Am":"8.5","Native_Ame":"0.4","Asian_Amer":"10.7","Other____":"4.4","Shape_Leng":5122.27496022,"Shape_Area":1443470.35589}},{"arcs":[[1658,-174,1659,1660]],"type":"Polygon","properties":{"Tract_1":6037573700,"Percentile":"11-15%","Population":4554,"County":"Los Angeles","ZIP":90808,"City":"Long Beach","CIscore":9.57,"CIscoreP":"12","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":12.89,"DPM_pctl":38,"DrinkingWa":282.26,"DW_pctl":"29","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5536.16,"TR_pctl":83,"Traffic":469.09,"Traff_Pctl":"28","Cleanups":1.9,"Clean_Pctl":25,"Groundwate":6,"GW_pctl":36,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":2,"IWB_pctl":29,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":3.98,"Poll_pctl":25,"Asthma":30.58,"Asthma_Pct":26,"Low_Birth_":3.45,"LBW_pctl":"16","Cardiovasc":8.07,"CVD_pctl":51,"Education":7.7,"Edu_pctl":"31","Linguistic":1,"Ling_pctl":"6","Poverty":10.3,"Pov_pctl":"8","Unemployme":7.1,"Unem_pctl":"30","Housing_Bu":5.4,"HB_pctl":"2","PopCharSco":2.4,"Pop_Pctl":"12","Children__":12.3,"Pop_11_64_":74.7,"Elderly___":13,"Hispanic__":"19.7","White____":"66.8","African_Am":"2.2","Native_Ame":"0.4","Asian_Amer":"7.2","Other____":"3.7","Shape_Leng":5612.17888095,"Shape_Area":1816587.24603}},{"arcs":[[-1661,1661,1662]],"type":"Polygon","properties":{"Tract_1":6037573800,"Percentile":"11-15%","Population":4284,"County":"Los Angeles","ZIP":90808,"City":"Long Beach","CIscore":10.27,"CIscoreP":"14","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":12.89,"DPM_pctl":38,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0.064,"Pest_pctl":17,"Tox_Releas":5778.14,"TR_pctl":84,"Traffic":385.67,"Traff_Pctl":"20","Cleanups":4,"Clean_Pctl":39,"Groundwate":6,"GW_pctl":36,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":9,"IWB_pctl":81,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.62,"Poll_pctl":38,"Asthma":30.62,"Asthma_Pct":26,"Low_Birth_":2.88,"LBW_pctl":"8","Cardiovasc":8.08,"CVD_pctl":52,"Education":4,"Edu_pctl":"15","Linguistic":1.7,"Ling_pctl":"12","Poverty":12.9,"Pov_pctl":"12","Unemployme":7.1,"Unem_pctl":"30","Housing_Bu":6.6,"HB_pctl":"4","PopCharSco":2.22,"Pop_Pctl":"10","Children__":12.6,"Pop_11_64_":75.5,"Elderly___":11.9,"Hispanic__":"20.6","White____":"65.8","African_Am":"2.3","Native_Ame":"0.3","Asian_Amer":"7","Other____":"3.9","Shape_Leng":5437.20395633,"Shape_Area":1530686.70138}},{"arcs":[[1663,1664,1665]],"type":"Polygon","properties":{"Tract_1":6037573902,"Percentile":"31-35%","Population":2091,"County":"Los Angeles","ZIP":90808,"City":"Long Beach","CIscore":18.61,"CIscoreP":"35","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":15.06,"DPM_pctl":46,"DrinkingWa":251.93,"DW_pctl":"25","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6558.32,"TR_pctl":87,"Traffic":1846.2,"Traff_Pctl":"89","Cleanups":0.9,"Clean_Pctl":13,"Groundwate":30,"GW_pctl":82,"Haz_Waste":0.1,"Haz_pctl":43,"Imp__Water":14,"IWB_pctl":94,"Solid_Wast":1.25,"Solid_pctl":37,"PollutionS":6.36,"Poll_pctl":76,"Asthma":21.88,"Asthma_Pct":11,"Low_Birth_":7.06,"LBW_pctl":"91","Cardiovasc":5.66,"CVD_pctl":20,"Education":3.2,"Edu_pctl":"11","Linguistic":2.1,"Ling_pctl":"15","Poverty":13.6,"Pov_pctl":"13","Unemployme":4.5,"Unem_pctl":"9","Housing_Bu":14.2,"HB_pctl":"31","PopCharSco":2.93,"Pop_Pctl":"18","Children__":7.8,"Pop_11_64_":72.5,"Elderly___":19.7,"Hispanic__":"13.1","White____":"68.7","African_Am":"4","Native_Ame":"0","Asian_Amer":"10.4","Other____":"3.8","Shape_Leng":4321.08961747,"Shape_Area":683008.894408}},{"arcs":[[1666,-1294,1667,1668,1669,1670,1671,1672,1673,-98,1674,-96]],"type":"Polygon","properties":{"Tract_1":6037980033,"Percentile":"NA","Population":61,"County":"Los Angeles","ZIP":90802,"City":"Long Beach","CIscore":0,"CIscoreP":"NA","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":197.21,"DPM_pctl":100,"DrinkingWa":458.47,"DW_pctl":"47","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8541.43,"TR_pctl":91,"Traffic":855.64,"Traff_Pctl":"60","Cleanups":78.4,"Clean_Pctl":99,"Groundwate":164.55,"GW_pctl":99,"Haz_Waste":7.67,"Haz_pctl":99,"Imp__Water":29,"IWB_pctl":100,"Solid_Wast":13.2,"Solid_pctl":93,"PollutionS":8.67,"Poll_pctl":99,"Asthma":61.02,"Asthma_Pct":70,"Low_Birth_":0,"LBW_pctl":"NA","Cardiovasc":6.23,"CVD_pctl":27,"Education":0,"Edu_pctl":"NA","Linguistic":0,"Ling_pctl":"NA","Poverty":0,"Pov_pctl":"NA","Unemployme":0,"Unem_pctl":"NA","Housing_Bu":0,"HB_pctl":"NA","PopCharSco":0,"Pop_Pctl":"NA","Children__":0,"Pop_11_64_":80.3,"Elderly___":19.7,"Hispanic__":"13.1","White____":"57.4","African_Am":"4.9","Native_Ame":"0","Asian_Amer":"19.7","Other____":"4.9","Shape_Leng":26110.768296,"Shape_Area":28624615.949}},{"arcs":[[1675,-1669,1676,-68,1677,-1069,1678,1679,-1149,1680,1681,1682,1683,-1570,1684,-279,1685,-277,1686,1687,-1540,1688,-1533]],"type":"Polygon","properties":{"Tract_1":6037980031,"Percentile":"NA","Population":1262,"County":"Los Angeles","ZIP":90731,"City":"San Pedro","CIscore":0,"CIscoreP":"NA","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":83.47,"DPM_pctl":99,"DrinkingWa":433.22,"DW_pctl":"45","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6944.87,"TR_pctl":88,"Traffic":624.04,"Traff_Pctl":"44","Cleanups":141.5,"Clean_Pctl":100,"Groundwate":335.85,"GW_pctl":100,"Haz_Waste":13.85,"Haz_pctl":100,"Imp__Water":20,"IWB_pctl":99,"Solid_Wast":20.25,"Solid_pctl":97,"PollutionS":8.45,"Poll_pctl":98,"Asthma":82.43,"Asthma_Pct":86,"Low_Birth_":0,"LBW_pctl":"NA","Cardiovasc":9.39,"CVD_pctl":68,"Education":18.6,"Edu_pctl":"59","Linguistic":0,"Ling_pctl":"NA","Poverty":0,"Pov_pctl":"NA","Unemployme":0,"Unem_pctl":"NA","Housing_Bu":0,"HB_pctl":"NA","PopCharSco":0,"Pop_Pctl":"NA","Children__":0.4,"Pop_11_64_":89.5,"Elderly___":10.1,"Hispanic__":"30.9","White____":"40.6","African_Am":"17.5","Native_Ame":"1.9","Asian_Amer":"5.9","Other____":"3.2","Shape_Leng":24977.3157502,"Shape_Area":25794131.4095}},{"arcs":[[1689,1690,1691,-1073,1692]],"type":"Polygon","properties":{"Tract_1":6037980030,"Percentile":"NA","Population":0,"County":"Los Angeles","ZIP":90245,"City":"El Segundo","CIscore":0,"CIscoreP":"NA","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":36.63,"DPM_pctl":91,"DrinkingWa":0,"DW_pctl":"NA","Pesticides":0.001,"Pest_pctl":2,"Tox_Releas":14009.9,"TR_pctl":96,"Traffic":753.26,"Traff_Pctl":"54","Cleanups":48,"Clean_Pctl":96,"Groundwate":43.5,"GW_pctl":89,"Haz_Waste":12.88,"Haz_pctl":100,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":0.25,"Solid_pctl":10,"PollutionS":7.99,"Poll_pctl":96,"Asthma":0,"Asthma_Pct":0,"Low_Birth_":0,"LBW_pctl":"NA","Cardiovasc":0,"CVD_pctl":0,"Education":0,"Edu_pctl":"NA","Linguistic":0,"Ling_pctl":"NA","Poverty":0,"Pov_pctl":"NA","Unemployme":0,"Unem_pctl":"NA","Housing_Bu":0,"HB_pctl":"NA","PopCharSco":0,"Pop_Pctl":"NA","Children__":0,"Pop_11_64_":100,"Elderly___":0,"Hispanic__":"NA","White____":"NA","African_Am":"NA","Native_Ame":"NA","Asian_Amer":"NA","Other____":"NA","Shape_Leng":9158.84447073,"Shape_Area":4277890.46509}},{"arcs":[[-177,1693,1694,1695,1696,1697,1698,1699,1700,1701,-1043,1702,-1658,1703,-1038,1704]],"type":"Polygon","properties":{"Tract_1":6037980018,"Percentile":"NA","Population":1,"County":"Los Angeles","ZIP":90807,"City":"Long Beach","CIscore":0,"CIscoreP":"NA","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":25.99,"DPM_pctl":78,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":10.977,"Pest_pctl":59,"Tox_Releas":9843.6,"TR_pctl":93,"Traffic":2057.81,"Traff_Pctl":"91","Cleanups":4,"Clean_Pctl":39,"Groundwate":3.3,"GW_pctl":23,"Haz_Waste":0.02,"Haz_pctl":10,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":5.81,"Poll_pctl":65,"Asthma":14.97,"Asthma_Pct":3,"Low_Birth_":0,"LBW_pctl":"NA","Cardiovasc":3.94,"CVD_pctl":4,"Education":0,"Edu_pctl":"NA","Linguistic":0,"Ling_pctl":"NA","Poverty":0,"Pov_pctl":"NA","Unemployme":0,"Unem_pctl":"NA","Housing_Bu":0,"HB_pctl":"NA","PopCharSco":0,"Pop_Pctl":"NA","Children__":0,"Pop_11_64_":0,"Elderly___":100,"Hispanic__":"0","White____":"100","African_Am":"0","Native_Ame":"0","Asian_Amer":"0","Other____":"0","Shape_Leng":16887.1366474,"Shape_Area":7392199.09348}},{"arcs":[[-538,1705,-1369]],"type":"Polygon","properties":{"Tract_1":6037601501,"Percentile":"86-90%","Population":3890,"County":"Los Angeles","ZIP":90304,"City":"Inglewood","CIscore":50.7,"CIscoreP":"90","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":38.92,"DPM_pctl":93,"DrinkingWa":288.68,"DW_pctl":"31","Pesticides":5.692,"Pest_pctl":54,"Tox_Releas":3371.02,"TR_pctl":75,"Traffic":2460.31,"Traff_Pctl":"95","Cleanups":10.4,"Clean_Pctl":64,"Groundwate":22.3,"GW_pctl":74,"Haz_Waste":0.02,"Haz_pctl":10,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":6.71,"Poll_pctl":83,"Asthma":65.34,"Asthma_Pct":75,"Low_Birth_":3.25,"LBW_pctl":"12","Cardiovasc":10.49,"CVD_pctl":78,"Education":54,"Edu_pctl":"96","Linguistic":23.2,"Ling_pctl":"89","Poverty":71.3,"Pov_pctl":"94","Unemployme":14,"Unem_pctl":"80","Housing_Bu":35.2,"HB_pctl":"95","PopCharSco":7.56,"Pop_Pctl":"84","Children__":18.5,"Pop_11_64_":76.6,"Elderly___":4.9,"Hispanic__":"89.9","White____":"1.9","African_Am":"6.5","Native_Ame":"0.1","Asian_Amer":"1.1","Other____":"0.4","Shape_Leng":3209.93317236,"Shape_Area":472751.260991}},{"arcs":[[-1256,1706,-1254,1707,-1252,1708,1709,1710,1711,-350,1712,1713,1714,1715,1716]],"type":"Polygon","properties":{"Tract_1":6037670405,"Percentile":"1-5%","Population":2646,"County":"Los Angeles","ZIP":90275,"City":"Rancho Palos Verdes","CIscore":4.6,"CIscoreP":"3","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":6.12,"DPM_pctl":17,"DrinkingWa":187.24,"DW_pctl":"14","Pesticides":0,"Pest_pctl":0,"Tox_Releas":3678.65,"TR_pctl":76,"Traffic":401.83,"Traff_Pctl":"21","Cleanups":4,"Clean_Pctl":39,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":3.15,"Poll_pctl":11,"Asthma":13.28,"Asthma_Pct":2,"Low_Birth_":0,"LBW_pctl":"0","Cardiovasc":4.42,"CVD_pctl":8,"Education":1.9,"Edu_pctl":"5","Linguistic":13.7,"Ling_pctl":"71","Poverty":12.4,"Pov_pctl":"11","Unemployme":2.8,"Unem_pctl":"2","Housing_Bu":15,"HB_pctl":"35","PopCharSco":1.46,"Pop_Pctl":"3","Children__":8.5,"Pop_11_64_":58.3,"Elderly___":33.2,"Hispanic__":"4.1","White____":"56.2","African_Am":"2","Native_Ame":"0.2","Asian_Amer":"33.6","Other____":"3.9","Shape_Leng":6680.4825827,"Shape_Area":1507589.06807}},{"arcs":[[-1489,1717,-624,1718,-1525,1719,-1135,1720,-1133,1721,1722,1723,-336,1724,-334,1725,-332,1726,-330,1727,1728,1729,1730,1731,1732]],"type":"Polygon","properties":{"Tract_1":6037670702,"Percentile":"6-10%","Population":5477,"County":"Los Angeles","ZIP":90275,"City":"Rancho Palos Verdes","CIscore":6.76,"CIscoreP":"6","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":9.17,"DPM_pctl":26,"DrinkingWa":407.77,"DW_pctl":"43","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5151.93,"TR_pctl":81,"Traffic":380.59,"Traff_Pctl":"19","Cleanups":4.4,"Clean_Pctl":40,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.02,"Haz_pctl":10,"Imp__Water":4,"IWB_pctl":49,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":4.02,"Poll_pctl":26,"Asthma":12.04,"Asthma_Pct":1,"Low_Birth_":5.13,"LBW_pctl":"56","Cardiovasc":3.78,"CVD_pctl":3,"Education":2.2,"Edu_pctl":"6","Linguistic":5,"Ling_pctl":"36","Poverty":0,"Pov_pctl":"NA","Unemployme":2.3,"Unem_pctl":"1","Housing_Bu":4.3,"HB_pctl":"1","PopCharSco":1.68,"Pop_Pctl":"5","Children__":9.7,"Pop_11_64_":65,"Elderly___":25.3,"Hispanic__":"9.2","White____":"72.5","African_Am":"1.9","Native_Ame":"0.2","Asian_Amer":"12.4","Other____":"3.9","Shape_Leng":18603.6941579,"Shape_Area":6793758.77692}},{"arcs":[[1733,-1729,1734,-328,1735,-1710,1736,1737,1738,1739,-1731]],"type":"Polygon","properties":{"Tract_1":6037670500,"Percentile":"1-5%","Population":1860,"County":"Los Angeles","ZIP":90274,"City":"Palos Verdes Peninsula","CIscore":4.27,"CIscoreP":"2","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":7.96,"DPM_pctl":22,"DrinkingWa":187.24,"DW_pctl":"14","Pesticides":0,"Pest_pctl":0,"Tox_Releas":4487.58,"TR_pctl":78,"Traffic":585.99,"Traff_Pctl":"40","Cleanups":17.9,"Clean_Pctl":81,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":3,"IWB_pctl":41,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.01,"Poll_pctl":26,"Asthma":11.42,"Asthma_Pct":1,"Low_Birth_":0,"LBW_pctl":"NA","Cardiovasc":3.63,"CVD_pctl":3,"Education":3.5,"Edu_pctl":"13","Linguistic":5.9,"Ling_pctl":"41","Poverty":5.5,"Pov_pctl":"1","Unemployme":5.3,"Unem_pctl":"15","Housing_Bu":8.8,"HB_pctl":"9","PopCharSco":1.07,"Pop_Pctl":"1","Children__":7.8,"Pop_11_64_":64.6,"Elderly___":27.6,"Hispanic__":"5.5","White____":"74.1","African_Am":"1.5","Native_Ame":"0","Asian_Amer":"16.3","Other____":"2.6","Shape_Leng":14564.860965,"Shape_Area":7746938.60938}},{"arcs":[[1740,1741,1742,-724,1743,-715]],"type":"Polygon","properties":{"Tract_1":6037651222,"Percentile":"21-25%","Population":6211,"County":"Los Angeles","ZIP":90505,"City":"Torrance","CIscore":13.39,"CIscoreP":"21","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":8.83,"DPM_pctl":25,"DrinkingWa":188.14,"DW_pctl":"14","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6102.44,"TR_pctl":85,"Traffic":671.31,"Traff_Pctl":"48","Cleanups":2.05,"Clean_Pctl":27,"Groundwate":14.55,"GW_pctl":59,"Haz_Waste":0.15,"Haz_pctl":54,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":4.58,"Poll_pctl":38,"Asthma":28.68,"Asthma_Pct":23,"Low_Birth_":5.85,"LBW_pctl":"74","Cardiovasc":6.81,"CVD_pctl":35,"Education":2.2,"Edu_pctl":"6","Linguistic":3.5,"Ling_pctl":"26","Poverty":14.3,"Pov_pctl":"15","Unemployme":2.6,"Unem_pctl":"2","Housing_Bu":10.4,"HB_pctl":"14","PopCharSco":2.92,"Pop_Pctl":"18","Children__":11,"Pop_11_64_":79.4,"Elderly___":9.6,"Hispanic__":"12.9","White____":"42.5","African_Am":"2.5","Native_Ame":"0.2","Asian_Amer":"37.3","Other____":"4.5","Shape_Leng":5504.15682289,"Shape_Area":1523557.85258}},{"arcs":[[1744,-411,1745,1746,-417,-1743]],"type":"Polygon","properties":{"Tract_1":6037651302,"Percentile":"6-10%","Population":6311,"County":"Los Angeles","ZIP":90505,"City":"Torrance","CIscore":8.26,"CIscoreP":"9","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":8.83,"DPM_pctl":25,"DrinkingWa":253.31,"DW_pctl":"26","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5202.9,"TR_pctl":81,"Traffic":564.97,"Traff_Pctl":"38","Cleanups":0.25,"Clean_Pctl":5,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.1,"Haz_pctl":43,"Imp__Water":8,"IWB_pctl":76,"Solid_Wast":1.1,"Solid_pctl":33,"PollutionS":4.61,"Poll_pctl":38,"Asthma":22.82,"Asthma_Pct":12,"Low_Birth_":4.07,"LBW_pctl":"28","Cardiovasc":5.74,"CVD_pctl":21,"Education":4.9,"Edu_pctl":"19","Linguistic":3.7,"Ling_pctl":"28","Poverty":8.3,"Pov_pctl":"5","Unemployme":3.5,"Unem_pctl":"4","Housing_Bu":10.9,"HB_pctl":"16","PopCharSco":1.79,"Pop_Pctl":"6","Children__":11.2,"Pop_11_64_":69.1,"Elderly___":19.7,"Hispanic__":"9.6","White____":"67.5","African_Am":"0.8","Native_Ame":"0.2","Asian_Amer":"17.7","Other____":"4.2","Shape_Leng":9545.80849415,"Shape_Area":2401483.96532}},{"arcs":[[-1482,1747,-712,1748,1749,1750]],"type":"Polygon","properties":{"Tract_1":6037651002,"Percentile":"41-45%","Population":4606,"County":"Los Angeles","ZIP":90501,"City":"Torrance","CIscore":21.91,"CIscoreP":"43","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":18.43,"DPM_pctl":57,"DrinkingWa":186.75,"DW_pctl":"14","Pesticides":0,"Pest_pctl":0,"Tox_Releas":7698.74,"TR_pctl":90,"Traffic":1096.75,"Traff_Pctl":"72","Cleanups":12.25,"Clean_Pctl":70,"Groundwate":20.55,"GW_pctl":72,"Haz_Waste":1.22,"Haz_pctl":88,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":2.4,"Solid_pctl":53,"PollutionS":6.38,"Poll_pctl":77,"Asthma":50.72,"Asthma_Pct":57,"Low_Birth_":4.38,"LBW_pctl":"35","Cardiovasc":6.23,"CVD_pctl":27,"Education":4.7,"Edu_pctl":"18","Linguistic":8,"Ling_pctl":"51","Poverty":14.5,"Pov_pctl":"15","Unemployme":4.6,"Unem_pctl":"10","Housing_Bu":15.7,"HB_pctl":"38","PopCharSco":3.43,"Pop_Pctl":"24","Children__":9.6,"Pop_11_64_":73.4,"Elderly___":17,"Hispanic__":"17.2","White____":"40.2","African_Am":"2.3","Native_Ame":"0.3","Asian_Amer":"36.3","Other____":"3.6","Shape_Leng":4710.9771393,"Shape_Area":1177749.4334}},{"arcs":[[-1508,1751,1752,1753]],"type":"Polygon","properties":{"Tract_1":6037575402,"Percentile":"91-95%","Population":4065,"County":"Los Angeles","ZIP":90813,"City":"Long Beach","CIscore":56,"CIscoreP":"94","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":29.12,"DPM_pctl":84,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":1.613,"Pest_pctl":43,"Tox_Releas":11328.4,"TR_pctl":95,"Traffic":808.09,"Traff_Pctl":"57","Cleanups":0,"Clean_Pctl":0,"Groundwate":16.8,"GW_pctl":65,"Haz_Waste":0.07,"Haz_pctl":29,"Imp__Water":11,"IWB_pctl":90,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":6.14,"Poll_pctl":72,"Asthma":91.22,"Asthma_Pct":90,"Low_Birth_":7.26,"LBW_pctl":"93","Cardiovasc":9.1,"CVD_pctl":64,"Education":62.7,"Edu_pctl":"99","Linguistic":27,"Ling_pctl":"92","Poverty":71,"Pov_pctl":"94","Unemployme":15.4,"Unem_pctl":"86","Housing_Bu":39.3,"HB_pctl":"97","PopCharSco":9.12,"Pop_Pctl":"98","Children__":19.8,"Pop_11_64_":76.8,"Elderly___":3.4,"Hispanic__":"77","White____":"3.7","African_Am":"11.7","Native_Ame":"0.5","Asian_Amer":"5.5","Other____":"1.5","Shape_Leng":2417.4023641,"Shape_Area":324737.90465}},{"arcs":[[-1752,1754,1755,1756]],"type":"Polygon","properties":{"Tract_1":6037573002,"Percentile":"86-90%","Population":3990,"County":"Los Angeles","ZIP":90806,"City":"Long Beach","CIscore":51.06,"CIscoreP":"90","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":29.12,"DPM_pctl":84,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":11638.87,"TR_pctl":95,"Traffic":768.58,"Traff_Pctl":"55","Cleanups":0.5,"Clean_Pctl":8,"Groundwate":15.9,"GW_pctl":63,"Haz_Waste":0.07,"Haz_pctl":29,"Imp__Water":11,"IWB_pctl":90,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.66,"Poll_pctl":61,"Asthma":88.36,"Asthma_Pct":89,"Low_Birth_":7.89,"LBW_pctl":"96","Cardiovasc":9.89,"CVD_pctl":74,"Education":39,"Edu_pctl":"86","Linguistic":31.6,"Ling_pctl":"95","Poverty":74.9,"Pov_pctl":"96","Unemployme":11,"Unem_pctl":"63","Housing_Bu":39.8,"HB_pctl":"98","PopCharSco":9.02,"Pop_Pctl":"98","Children__":20.6,"Pop_11_64_":76.1,"Elderly___":3.3,"Hispanic__":"71.4","White____":"3.3","African_Am":"16.6","Native_Ame":"0.4","Asian_Amer":"7","Other____":"1.3","Shape_Leng":2415.19605211,"Shape_Area":323979.90053}},{"arcs":[[1757,1758,1759,1760,-1281,1761,-1168]],"type":"Polygon","properties":{"Tract_1":6037577200,"Percentile":"16-20%","Population":5414,"County":"Los Angeles","ZIP":90803,"City":"Long Beach","CIscore":12.83,"CIscoreP":"20","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":13.13,"DPM_pctl":39,"DrinkingWa":248.75,"DW_pctl":"25","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8676.56,"TR_pctl":92,"Traffic":883.99,"Traff_Pctl":"62","Cleanups":0,"Clean_Pctl":0,"Groundwate":6,"GW_pctl":36,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":10,"IWB_pctl":86,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.71,"Poll_pctl":41,"Asthma":28.26,"Asthma_Pct":22,"Low_Birth_":2.96,"LBW_pctl":"8","Cardiovasc":7.63,"CVD_pctl":46,"Education":3.8,"Edu_pctl":"14","Linguistic":2.9,"Ling_pctl":"22","Poverty":15.9,"Pov_pctl":"18","Unemployme":7.6,"Unem_pctl":"35","Housing_Bu":17.4,"HB_pctl":"47","PopCharSco":2.72,"Pop_Pctl":"15","Children__":5.8,"Pop_11_64_":83.5,"Elderly___":10.7,"Hispanic__":"17.5","White____":"68.6","African_Am":"3.9","Native_Ame":"0.4","Asian_Amer":"6.4","Other____":"3.3","Shape_Leng":4280.43427799,"Shape_Area":991990.978513}},{"arcs":[[1762,1763,1764,1765,1766,1767,1768,1769,-1701,1770,-1699]],"type":"Polygon","properties":{"Tract_1":6037573402,"Percentile":"81-85%","Population":6430,"County":"Los Angeles","ZIP":90755,"City":"Signal Hill","CIscore":43.19,"CIscoreP":"80","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":27.03,"DPM_pctl":80,"DrinkingWa":296.76,"DW_pctl":"32","Pesticides":0.013,"Pest_pctl":9,"Tox_Releas":8732.79,"TR_pctl":92,"Traffic":1317.13,"Traff_Pctl":"79","Cleanups":40.2,"Clean_Pctl":94,"Groundwate":81.8,"GW_pctl":96,"Haz_Waste":1.34,"Haz_pctl":89,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":7.2,"Solid_pctl":83,"PollutionS":7.55,"Poll_pctl":93,"Asthma":41.95,"Asthma_Pct":45,"Low_Birth_":5.31,"LBW_pctl":"61","Cardiovasc":7.82,"CVD_pctl":48,"Education":18.1,"Edu_pctl":"58","Linguistic":5.8,"Ling_pctl":"41","Poverty":45.6,"Pov_pctl":"68","Unemployme":12.9,"Unem_pctl":"76","Housing_Bu":18.4,"HB_pctl":"52","PopCharSco":5.72,"Pop_Pctl":"58","Children__":14.9,"Pop_11_64_":77.7,"Elderly___":7.4,"Hispanic__":"36.2","White____":"25.2","African_Am":"14","Native_Ame":"0.2","Asian_Amer":"20.4","Other____":"3.9","Shape_Leng":10476.152804,"Shape_Area":2952136.44795}},{"arcs":[[-1651,1771,-1439,1772,-1648,1773,1774,-1431,-1053,-1643]],"type":"Polygon","properties":{"Tract_1":6037571800,"Percentile":"31-35%","Population":3190,"County":"Los Angeles","ZIP":90807,"City":"Long Beach","CIscore":18.35,"CIscoreP":"34","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":20.9,"DPM_pctl":64,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0.195,"Pest_pctl":26,"Tox_Releas":7033,"TR_pctl":88,"Traffic":2552.69,"Traff_Pctl":"95","Cleanups":9,"Clean_Pctl":60,"Groundwate":12.05,"GW_pctl":54,"Haz_Waste":0.08,"Haz_pctl":32,"Imp__Water":13,"IWB_pctl":93,"Solid_Wast":1.2,"Solid_pctl":34,"PollutionS":6.82,"Poll_pctl":84,"Asthma":39.83,"Asthma_Pct":42,"Low_Birth_":4.52,"LBW_pctl":"39","Cardiovasc":5.42,"CVD_pctl":17,"Education":4.5,"Edu_pctl":"17","Linguistic":1,"Ling_pctl":"6","Poverty":9.9,"Pov_pctl":"7","Unemployme":5.8,"Unem_pctl":"19","Housing_Bu":17.3,"HB_pctl":"47","PopCharSco":2.69,"Pop_Pctl":"15","Children__":9,"Pop_11_64_":71,"Elderly___":20,"Hispanic__":"16.4","White____":"59.5","African_Am":"8.7","Native_Ame":"0.2","Asian_Amer":"11.3","Other____":"3.9","Shape_Leng":7896.37049293,"Shape_Area":2773176.65919}},{"arcs":[[1775,1776,-1519,1777]],"type":"Polygon","properties":{"Tract_1":6037575802,"Percentile":"96-100%","Population":5167,"County":"Los Angeles","ZIP":90813,"City":"Long Beach","CIscore":62.2,"CIscoreP":"97","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":160.26,"DPM_pctl":100,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":2.754,"Pest_pctl":48,"Tox_Releas":12200.15,"TR_pctl":95,"Traffic":584.65,"Traff_Pctl":"40","Cleanups":0,"Clean_Pctl":0,"Groundwate":38.8,"GW_pctl":87,"Haz_Waste":0.16,"Haz_pctl":55,"Imp__Water":20,"IWB_pctl":99,"Solid_Wast":0.3,"Solid_pctl":11,"PollutionS":6.75,"Poll_pctl":83,"Asthma":122.08,"Asthma_Pct":97,"Low_Birth_":7.66,"LBW_pctl":"95","Cardiovasc":11.92,"CVD_pctl":88,"Education":41.1,"Edu_pctl":"88","Linguistic":14.8,"Ling_pctl":"74","Poverty":76.4,"Pov_pctl":"97","Unemployme":12.1,"Unem_pctl":"71","Housing_Bu":32.9,"HB_pctl":"92","PopCharSco":9.21,"Pop_Pctl":"99","Children__":19.3,"Pop_11_64_":77.2,"Elderly___":3.5,"Hispanic__":"76.6","White____":"8.5","African_Am":"10.1","Native_Ame":"0.4","Asian_Amer":"3.2","Other____":"1.3","Shape_Leng":2408.16456114,"Shape_Area":321289.881517}},{"arcs":[[1778,1779,1780,1781,-1764,1782,-1697]],"type":"Polygon","properties":{"Tract_1":6037573403,"Percentile":"56-60%","Population":3208,"County":"Los Angeles","ZIP":90755,"City":"Signal Hill","CIscore":30.21,"CIscoreP":"60","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":25.99,"DPM_pctl":78,"DrinkingWa":296.69,"DW_pctl":"32","Pesticides":0.053,"Pest_pctl":16,"Tox_Releas":8557.8,"TR_pctl":91,"Traffic":807.86,"Traff_Pctl":"57","Cleanups":35.25,"Clean_Pctl":93,"Groundwate":122.15,"GW_pctl":98,"Haz_Waste":1.79,"Haz_pctl":91,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":3.5,"Solid_pctl":65,"PollutionS":7.22,"Poll_pctl":90,"Asthma":41.13,"Asthma_Pct":44,"Low_Birth_":6.04,"LBW_pctl":"77","Cardiovasc":7.53,"CVD_pctl":44,"Education":7.2,"Edu_pctl":"29","Linguistic":2.3,"Ling_pctl":"17","Poverty":17.6,"Pov_pctl":"22","Unemployme":3.4,"Unem_pctl":"4","Housing_Bu":19.5,"HB_pctl":"57","PopCharSco":4.19,"Pop_Pctl":"35","Children__":11.6,"Pop_11_64_":78.6,"Elderly___":9.8,"Hispanic__":"18.6","White____":"41.7","African_Am":"11.5","Native_Ame":"0.2","Asian_Amer":"24","Other____":"3.9","Shape_Leng":7340.79950253,"Shape_Area":1697713.34176}},{"arcs":[[-1672,1783,1784,1785,1786,1787]],"type":"Polygon","properties":{"Tract_1":6037575500,"Percentile":"NA","Population":76,"County":"Los Angeles","ZIP":90813,"City":"Long Beach","CIscore":0,"CIscoreP":"NA","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":34.15,"DPM_pctl":89,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":16800.22,"TR_pctl":97,"Traffic":1109.69,"Traff_Pctl":"72","Cleanups":19.15,"Clean_Pctl":83,"Groundwate":39.5,"GW_pctl":87,"Haz_Waste":13.48,"Haz_pctl":100,"Imp__Water":24,"IWB_pctl":100,"Solid_Wast":13.5,"Solid_pctl":94,"PollutionS":8.2,"Poll_pctl":97,"Asthma":130.75,"Asthma_Pct":98,"Low_Birth_":0,"LBW_pctl":"NA","Cardiovasc":12.73,"CVD_pctl":92,"Education":52.2,"Edu_pctl":"95","Linguistic":0,"Ling_pctl":"NA","Poverty":89.2,"Pov_pctl":"100","Unemployme":0,"Unem_pctl":"NA","Housing_Bu":0,"HB_pctl":"NA","PopCharSco":0,"Pop_Pctl":"NA","Children__":10.5,"Pop_11_64_":76.3,"Elderly___":13.2,"Hispanic__":"50","White____":"30.3","African_Am":"5.3","Native_Ame":"0","Asian_Amer":"14.5","Other____":"0","Shape_Leng":5375.05916115,"Shape_Area":1381518.424}},{"arcs":[[1788,-1599,1789,1790,1791,1792,1793,1794,-1601]],"type":"Polygon","properties":{"Tract_1":6037541802,"Percentile":"81-85%","Population":5431,"County":"Los Angeles","ZIP":90262,"City":"Lynwood","CIscore":44.69,"CIscoreP":"82","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":26.94,"DPM_pctl":80,"DrinkingWa":260.28,"DW_pctl":"26","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6576.85,"TR_pctl":87,"Traffic":2926.08,"Traff_Pctl":"97","Cleanups":2,"Clean_Pctl":27,"Groundwate":6,"GW_pctl":36,"Haz_Waste":0.05,"Haz_pctl":26,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":1.6,"Solid_pctl":40,"PollutionS":6.49,"Poll_pctl":79,"Asthma":45.5,"Asthma_Pct":50,"Low_Birth_":5.46,"LBW_pctl":"65","Cardiovasc":8.31,"CVD_pctl":55,"Education":46.8,"Edu_pctl":"92","Linguistic":17,"Ling_pctl":"79","Poverty":59.9,"Pov_pctl":"84","Unemployme":13.1,"Unem_pctl":"76","Housing_Bu":17.7,"HB_pctl":"49","PopCharSco":6.89,"Pop_Pctl":"75","Children__":18.4,"Pop_11_64_":76,"Elderly___":5.6,"Hispanic__":"87.9","White____":"1.2","African_Am":"9.7","Native_Ame":"0.2","Asian_Amer":"0.4","Other____":"0.6","Shape_Leng":4546.0650397,"Shape_Area":1094409.56134}},{"arcs":[[1795,1796,1797,-1456,1798,1799,1800]],"type":"Polygon","properties":{"Tract_1":6037540700,"Percentile":"96-100%","Population":3014,"County":"Los Angeles","ZIP":90059,"City":"Los Angeles","CIscore":60.24,"CIscoreP":"97","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":19.88,"DPM_pctl":61,"DrinkingWa":393.18,"DW_pctl":"41","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5736.4,"TR_pctl":83,"Traffic":2609.34,"Traff_Pctl":"96","Cleanups":5.65,"Clean_Pctl":46,"Groundwate":24,"GW_pctl":76,"Haz_Waste":0.28,"Haz_pctl":68,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":1.75,"Solid_pctl":41,"PollutionS":7.15,"Poll_pctl":89,"Asthma":89.12,"Asthma_Pct":89,"Low_Birth_":5.52,"LBW_pctl":"66","Cardiovasc":9.98,"CVD_pctl":74,"Education":34,"Edu_pctl":"81","Linguistic":12.4,"Ling_pctl":"67","Poverty":70,"Pov_pctl":"93","Unemployme":20.7,"Unem_pctl":"96","Housing_Bu":32.9,"HB_pctl":"92","PopCharSco":8.42,"Pop_Pctl":"94","Children__":18.8,"Pop_11_64_":76,"Elderly___":5.2,"Hispanic__":"61.3","White____":"0.6","African_Am":"36.7","Native_Ame":"0.2","Asian_Amer":"0.2","Other____":"1","Shape_Leng":4937.94462889,"Shape_Area":1144133.56147}},{"arcs":[[1801,1802,1803,-755,1804,1805,1806,1807]],"type":"Polygon","properties":{"Tract_1":6037540901,"Percentile":"96-100%","Population":4994,"County":"Los Angeles","ZIP":90061,"City":"Los Angeles","CIscore":65.75,"CIscoreP":"98","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":27.84,"DPM_pctl":82,"DrinkingWa":479.94,"DW_pctl":"51","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5497.89,"TR_pctl":82,"Traffic":1815.31,"Traff_Pctl":"89","Cleanups":13.05,"Clean_Pctl":73,"Groundwate":32.1,"GW_pctl":83,"Haz_Waste":0.18,"Haz_pctl":56,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":8,"Solid_pctl":86,"PollutionS":7.44,"Poll_pctl":92,"Asthma":81.72,"Asthma_Pct":86,"Low_Birth_":8.61,"LBW_pctl":"98","Cardiovasc":10.17,"CVD_pctl":76,"Education":37.6,"Edu_pctl":"85","Linguistic":16.9,"Ling_pctl":"79","Poverty":58.5,"Pov_pctl":"83","Unemployme":15.4,"Unem_pctl":"86","Housing_Bu":29,"HB_pctl":"86","PopCharSco":8.84,"Pop_Pctl":"97","Children__":14.8,"Pop_11_64_":74.4,"Elderly___":10.8,"Hispanic__":"64.4","White____":"1.8","African_Am":"32.2","Native_Ame":"0.1","Asian_Amer":"0.4","Other____":"1.1","Shape_Leng":4806.6984075,"Shape_Area":1165206.96891}},{"arcs":[[1808,1809,1810,1811,1812,1813,1814,-1797]],"type":"Polygon","properties":{"Tract_1":6037540800,"Percentile":"86-90%","Population":5042,"County":"Los Angeles","ZIP":90059,"City":"Los Angeles","CIscore":49.61,"CIscoreP":"88","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":24.33,"DPM_pctl":74,"DrinkingWa":465.34,"DW_pctl":"48","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5754.92,"TR_pctl":83,"Traffic":663.59,"Traff_Pctl":"47","Cleanups":19.55,"Clean_Pctl":83,"Groundwate":38.25,"GW_pctl":87,"Haz_Waste":0.22,"Haz_pctl":62,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":1.25,"Solid_pctl":37,"PollutionS":7.11,"Poll_pctl":88,"Asthma":83.01,"Asthma_Pct":87,"Low_Birth_":7.92,"LBW_pctl":"96","Cardiovasc":9.44,"CVD_pctl":68,"Education":24.9,"Edu_pctl":"70","Linguistic":1.2,"Ling_pctl":"7","Poverty":38.6,"Pov_pctl":"58","Unemployme":7.7,"Unem_pctl":"36","Housing_Bu":27.5,"HB_pctl":"83","PopCharSco":6.97,"Pop_Pctl":"76","Children__":14.6,"Pop_11_64_":74.6,"Elderly___":10.8,"Hispanic__":"41","White____":"0.6","African_Am":"56.3","Native_Ame":"0.2","Asian_Amer":"0.3","Other____":"1.6","Shape_Leng":8063.56006494,"Shape_Area":1993388.68207}},{"arcs":[[1815,-1804,1816,1817,1818]],"type":"Polygon","properties":{"Tract_1":6037540902,"Percentile":"91-95%","Population":4506,"County":"Los Angeles","ZIP":90061,"City":"Los Angeles","CIscore":56.55,"CIscoreP":"94","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":27.84,"DPM_pctl":82,"DrinkingWa":250.96,"DW_pctl":"25","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6863.28,"TR_pctl":88,"Traffic":608.86,"Traff_Pctl":"42","Cleanups":36.4,"Clean_Pctl":93,"Groundwate":90.8,"GW_pctl":97,"Haz_Waste":0.82,"Haz_pctl":85,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":11.2,"Solid_pctl":91,"PollutionS":7.21,"Poll_pctl":89,"Asthma":80.21,"Asthma_Pct":85,"Low_Birth_":6.51,"LBW_pctl":"85","Cardiovasc":10.11,"CVD_pctl":76,"Education":27.4,"Edu_pctl":"73","Linguistic":4.4,"Ling_pctl":"33","Poverty":49.9,"Pov_pctl":"73","Unemployme":15.2,"Unem_pctl":"85","Housing_Bu":26.9,"HB_pctl":"81","PopCharSco":7.84,"Pop_Pctl":"88","Children__":13.4,"Pop_11_64_":73.3,"Elderly___":13.3,"Hispanic__":"37","White____":"1","African_Am":"60.4","Native_Ame":"0.2","Asian_Amer":"0.2","Other____":"1.2","Shape_Leng":6336.0697622,"Shape_Area":2521719.98437}},{"arcs":[[1819,1820,-172,1821,-943,1822]],"type":"Polygon","properties":{"Tract_1":6037541605,"Percentile":"96-100%","Population":5323,"County":"Los Angeles","ZIP":90221,"City":"Compton","CIscore":58.38,"CIscoreP":"96","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":23.7,"DPM_pctl":73,"DrinkingWa":444.63,"DW_pctl":"46","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5994.22,"TR_pctl":85,"Traffic":569.24,"Traff_Pctl":"38","Cleanups":0.4,"Clean_Pctl":6,"Groundwate":35.35,"GW_pctl":85,"Haz_Waste":2.62,"Haz_pctl":94,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":4,"Solid_pctl":68,"PollutionS":6.94,"Poll_pctl":86,"Asthma":87.61,"Asthma_Pct":88,"Low_Birth_":5.26,"LBW_pctl":"60","Cardiovasc":13.56,"CVD_pctl":95,"Education":49.5,"Edu_pctl":"94","Linguistic":15.7,"Ling_pctl":"76","Poverty":69.9,"Pov_pctl":"93","Unemployme":13.2,"Unem_pctl":"77","Housing_Bu":22,"HB_pctl":"67","PopCharSco":8.41,"Pop_Pctl":"94","Children__":19,"Pop_11_64_":75.3,"Elderly___":5.7,"Hispanic__":"76.3","White____":"0.8","African_Am":"21.5","Native_Ame":"0.1","Asian_Amer":"0.5","Other____":"0.8","Shape_Leng":4272.64661098,"Shape_Area":867045.234972}},{"arcs":[[1823,1824,1825,1826,1827,1828,-1579]],"type":"Polygon","properties":{"Tract_1":6037503702,"Percentile":"41-45%","Population":5040,"County":"Los Angeles","ZIP":90604,"City":"Whittier","CIscore":21.05,"CIscoreP":"41","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":9.51,"DPM_pctl":27,"DrinkingWa":516.39,"DW_pctl":"55","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6024.62,"TR_pctl":85,"Traffic":771.77,"Traff_Pctl":"55","Cleanups":0,"Clean_Pctl":0,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.59,"Poll_pctl":38,"Asthma":55.63,"Asthma_Pct":64,"Low_Birth_":3.02,"LBW_pctl":"9","Cardiovasc":12.16,"CVD_pctl":89,"Education":13.4,"Edu_pctl":"49","Linguistic":5.4,"Ling_pctl":"39","Poverty":26.1,"Pov_pctl":"38","Unemployme":7.7,"Unem_pctl":"36","Housing_Bu":9.3,"HB_pctl":"10","PopCharSco":4.58,"Pop_Pctl":"41","Children__":12.2,"Pop_11_64_":74.6,"Elderly___":13.2,"Hispanic__":"48.9","White____":"43.3","African_Am":"1.6","Native_Ame":"0.2","Asian_Amer":"4.4","Other____":"1.5","Shape_Leng":5886.16982634,"Shape_Area":1726704.08188}},{"arcs":[[1829,1830,1831,1832]],"type":"Polygon","properties":{"Tract_1":6037503501,"Percentile":"56-60%","Population":6481,"County":"Los Angeles","ZIP":90604,"City":"Whittier","CIscore":29.96,"CIscoreP":"59","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":11.78,"DPM_pctl":34,"DrinkingWa":547.43,"DW_pctl":"57","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5610.12,"TR_pctl":83,"Traffic":483.33,"Traff_Pctl":"29","Cleanups":9,"Clean_Pctl":60,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.1,"Haz_pctl":43,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.3,"Solid_pctl":11,"PollutionS":4.9,"Poll_pctl":44,"Asthma":56.67,"Asthma_Pct":65,"Low_Birth_":5.07,"LBW_pctl":"54","Cardiovasc":12.37,"CVD_pctl":90,"Education":22.6,"Edu_pctl":"66","Linguistic":7.2,"Ling_pctl":"47","Poverty":36.5,"Pov_pctl":"55","Unemployme":4.4,"Unem_pctl":"9","Housing_Bu":21,"HB_pctl":"63","PopCharSco":6.11,"Pop_Pctl":"63","Children__":14.8,"Pop_11_64_":77.1,"Elderly___":8.1,"Hispanic__":"68.3","White____":"25","African_Am":"1.1","Native_Ame":"0.4","Asian_Amer":"3.9","Other____":"1.2","Shape_Leng":6785.28097904,"Shape_Area":1558170.95306}},{"arcs":[[-1830,1833,1834]],"type":"Polygon","properties":{"Tract_1":6037503502,"Percentile":"46-50%","Population":4130,"County":"Los Angeles","ZIP":90604,"City":"Whittier","CIscore":23.38,"CIscoreP":"46","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":11.78,"DPM_pctl":34,"DrinkingWa":514.6,"DW_pctl":"55","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5705.72,"TR_pctl":83,"Traffic":459.22,"Traff_Pctl":"27","Cleanups":18,"Clean_Pctl":82,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.43,"Poll_pctl":35,"Asthma":57.41,"Asthma_Pct":66,"Low_Birth_":5,"LBW_pctl":"52","Cardiovasc":12.52,"CVD_pctl":91,"Education":15.5,"Edu_pctl":"53","Linguistic":5.5,"Ling_pctl":"39","Poverty":29.8,"Pov_pctl":"44","Unemployme":5.2,"Unem_pctl":"14","Housing_Bu":8.6,"HB_pctl":"8","PopCharSco":5.27,"Pop_Pctl":"51","Children__":12.8,"Pop_11_64_":75.8,"Elderly___":11.4,"Hispanic__":"60.5","White____":"31.3","African_Am":"1","Native_Ame":"0.2","Asian_Amer":"5.4","Other____":"1.6","Shape_Leng":5454.98680851,"Shape_Area":1248858.31279}},{"arcs":[[1835,-365,1836,1837,1838,1839,1840]],"type":"Polygon","properties":{"Tract_1":6037503601,"Percentile":"26-30%","Population":4168,"County":"Los Angeles","ZIP":90638,"City":"La Mirada","CIscore":15.77,"CIscoreP":"27","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":16.46,"DPM_pctl":50,"DrinkingWa":596.08,"DW_pctl":"64","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5552.33,"TR_pctl":83,"Traffic":592.39,"Traff_Pctl":"41","Cleanups":0,"Clean_Pctl":0,"Groundwate":9,"GW_pctl":46,"Haz_Waste":0.05,"Haz_pctl":26,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.81,"Poll_pctl":43,"Asthma":33.69,"Asthma_Pct":31,"Low_Birth_":2.91,"LBW_pctl":"8","Cardiovasc":8.69,"CVD_pctl":59,"Education":10.5,"Edu_pctl":"41","Linguistic":2.5,"Ling_pctl":"18","Poverty":21,"Pov_pctl":"29","Unemployme":8.5,"Unem_pctl":"43","Housing_Bu":12,"HB_pctl":"21","PopCharSco":3.28,"Pop_Pctl":"22","Children__":12,"Pop_11_64_":70.6,"Elderly___":17.4,"Hispanic__":"46.6","White____":"42.1","African_Am":"3.5","Native_Ame":"0.4","Asian_Amer":"5.4","Other____":"2","Shape_Leng":5102.30551343,"Shape_Area":1392957.11781}},{"arcs":[[-1597,1841,-1604,1842,-160,1843,1844,1845]],"type":"Polygon","properties":{"Tract_1":6037553702,"Percentile":"96-100%","Population":4902,"County":"Los Angeles","ZIP":90723,"City":"Paramount","CIscore":61.44,"CIscoreP":"97","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":27.04,"DPM_pctl":80,"DrinkingWa":197.5,"DW_pctl":"15","Pesticides":0,"Pest_pctl":0,"Tox_Releas":7011.65,"TR_pctl":88,"Traffic":1855.98,"Traff_Pctl":"89","Cleanups":12.6,"Clean_Pctl":71,"Groundwate":17.75,"GW_pctl":67,"Haz_Waste":0.36,"Haz_pctl":72,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":2.5,"Solid_pctl":57,"PollutionS":7.4,"Poll_pctl":92,"Asthma":61.93,"Asthma_Pct":71,"Low_Birth_":5.65,"LBW_pctl":"69","Cardiovasc":11.54,"CVD_pctl":86,"Education":58.7,"Edu_pctl":"98","Linguistic":25.2,"Ling_pctl":"91","Poverty":58.4,"Pov_pctl":"83","Unemployme":11.2,"Unem_pctl":"65","Housing_Bu":29.4,"HB_pctl":"87","PopCharSco":8.3,"Pop_Pctl":"93","Children__":18.1,"Pop_11_64_":76.2,"Elderly___":5.7,"Hispanic__":"91.6","White____":"1.8","African_Am":"4.7","Native_Ame":"0","Asian_Amer":"1.7","Other____":"0.2","Shape_Leng":5442.10963591,"Shape_Area":856322.706743}},{"arcs":[[-298,1846,1847,1848,1849]],"type":"Polygon","properties":{"Tract_1":6037554101,"Percentile":"81-85%","Population":3799,"County":"Los Angeles","ZIP":90706,"City":"Bellflower","CIscore":43.6,"CIscoreP":"81","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":24.75,"DPM_pctl":75,"DrinkingWa":744.04,"DW_pctl":"86","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5994.52,"TR_pctl":85,"Traffic":772.07,"Traff_Pctl":"55","Cleanups":0,"Clean_Pctl":0,"Groundwate":6,"GW_pctl":36,"Haz_Waste":0.05,"Haz_pctl":26,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":1,"Solid_pctl":33,"PollutionS":5.74,"Poll_pctl":63,"Asthma":79.03,"Asthma_Pct":85,"Low_Birth_":4.39,"LBW_pctl":"36","Cardiovasc":11.13,"CVD_pctl":84,"Education":31.8,"Edu_pctl":"79","Linguistic":16.5,"Ling_pctl":"78","Poverty":67.2,"Pov_pctl":"91","Unemployme":11.9,"Unem_pctl":"69","Housing_Bu":24.4,"HB_pctl":"75","PopCharSco":7.59,"Pop_Pctl":"85","Children__":18,"Pop_11_64_":77.9,"Elderly___":4.1,"Hispanic__":"69.6","White____":"11.2","African_Am":"9.1","Native_Ame":"0.3","Asian_Amer":"8.3","Other____":"1.5","Shape_Leng":3834.33696989,"Shape_Area":473316.867484}},{"arcs":[[1850,-1607,1851,1852,-831,1853,1854,-162]],"type":"Polygon","properties":{"Tract_1":6037553802,"Percentile":"96-100%","Population":6342,"County":"Los Angeles","ZIP":90723,"City":"Paramount","CIscore":60.08,"CIscoreP":"96","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":27.36,"DPM_pctl":81,"DrinkingWa":197.42,"DW_pctl":"15","Pesticides":23.626,"Pest_pctl":66,"Tox_Releas":6628,"TR_pctl":87,"Traffic":1022.2,"Traff_Pctl":"69","Cleanups":11,"Clean_Pctl":65,"Groundwate":17.8,"GW_pctl":67,"Haz_Waste":1.74,"Haz_pctl":91,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":8.5,"Solid_pctl":86,"PollutionS":8.28,"Poll_pctl":98,"Asthma":53.74,"Asthma_Pct":61,"Low_Birth_":4.78,"LBW_pctl":"46","Cardiovasc":9.57,"CVD_pctl":70,"Education":39.9,"Edu_pctl":"87","Linguistic":20.8,"Ling_pctl":"86","Poverty":56.9,"Pov_pctl":"81","Unemployme":10.4,"Unem_pctl":"59","Housing_Bu":32.5,"HB_pctl":"92","PopCharSco":7.26,"Pop_Pctl":"80","Children__":16.7,"Pop_11_64_":73.8,"Elderly___":9.5,"Hispanic__":"71.7","White____":"9.2","African_Am":"13.1","Native_Ame":"0.5","Asian_Amer":"4.5","Other____":"0.9","Shape_Leng":7434.40352268,"Shape_Area":1778822.79147}},{"arcs":[[1855,-985,1856,-1584,1857,-1016]],"type":"Polygon","properties":{"Tract_1":6037554001,"Percentile":"76-80%","Population":4171,"County":"Los Angeles","ZIP":90706,"City":"Bellflower","CIscore":42.7,"CIscoreP":"80","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":20.99,"DPM_pctl":65,"DrinkingWa":754,"DW_pctl":"87","Pesticides":1.836,"Pest_pctl":44,"Tox_Releas":5881.64,"TR_pctl":84,"Traffic":824.12,"Traff_Pctl":"59","Cleanups":0,"Clean_Pctl":0,"Groundwate":2.1,"GW_pctl":14,"Haz_Waste":0.5,"Haz_pctl":77,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":6.15,"Poll_pctl":72,"Asthma":79.03,"Asthma_Pct":85,"Low_Birth_":6.13,"LBW_pctl":"79","Cardiovasc":11.13,"CVD_pctl":84,"Education":19.2,"Edu_pctl":"60","Linguistic":7.4,"Ling_pctl":"48","Poverty":30.3,"Pov_pctl":"45","Unemployme":7.8,"Unem_pctl":"37","Housing_Bu":22,"HB_pctl":"67","PopCharSco":6.95,"Pop_Pctl":"76","Children__":13.8,"Pop_11_64_":77.4,"Elderly___":8.8,"Hispanic__":"56","White____":"23.5","African_Am":"6","Native_Ame":"0.2","Asian_Amer":"12.3","Other____":"1.9","Shape_Leng":4907.70328269,"Shape_Area":1083053.43794}},{"arcs":[[1858,1859,-946,1860,1861,1862]],"type":"Polygon","properties":{"Tract_1":6037602200,"Percentile":"76-80%","Population":7314,"County":"Los Angeles","ZIP":90250,"City":"Hawthorne","CIscore":41.63,"CIscoreP":"78","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":30.83,"DPM_pctl":86,"DrinkingWa":399.56,"DW_pctl":"42","Pesticides":0.002,"Pest_pctl":4,"Tox_Releas":4721.41,"TR_pctl":79,"Traffic":1982.59,"Traff_Pctl":"91","Cleanups":10.3,"Clean_Pctl":63,"Groundwate":48.3,"GW_pctl":91,"Haz_Waste":1.15,"Haz_pctl":88,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":2,"Solid_pctl":50,"PollutionS":7.37,"Poll_pctl":91,"Asthma":52.63,"Asthma_Pct":60,"Low_Birth_":5.73,"LBW_pctl":"71","Cardiovasc":7.57,"CVD_pctl":45,"Education":23.9,"Edu_pctl":"68","Linguistic":5,"Ling_pctl":"36","Poverty":47.2,"Pov_pctl":"70","Unemployme":8.3,"Unem_pctl":"41","Housing_Bu":15.2,"HB_pctl":"36","PopCharSco":5.65,"Pop_Pctl":"56","Children__":13.6,"Pop_11_64_":78.5,"Elderly___":7.9,"Hispanic__":"50.2","White____":"26.5","African_Am":"10","Native_Ame":"0.2","Asian_Amer":"10.3","Other____":"2.8","Shape_Leng":7211.31308658,"Shape_Area":2112354.63629}},{"arcs":[[1863,1864,1865,1866,-487,1867,-555,1868]],"type":"Polygon","properties":{"Tract_1":6037603400,"Percentile":"86-90%","Population":4367,"County":"Los Angeles","ZIP":90249,"City":"Gardena","CIscore":47.98,"CIscoreP":"87","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":22.99,"DPM_pctl":70,"DrinkingWa":255.67,"DW_pctl":"26","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6416.32,"TR_pctl":86,"Traffic":946.55,"Traff_Pctl":"65","Cleanups":4.5,"Clean_Pctl":42,"Groundwate":28.25,"GW_pctl":80,"Haz_Waste":0.32,"Haz_pctl":70,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":2.75,"Solid_pctl":59,"PollutionS":6.98,"Poll_pctl":86,"Asthma":73.09,"Asthma_Pct":81,"Low_Birth_":6.75,"LBW_pctl":"88","Cardiovasc":8.98,"CVD_pctl":63,"Education":15.9,"Edu_pctl":"54","Linguistic":8.8,"Ling_pctl":"54","Poverty":40.7,"Pov_pctl":"61","Unemployme":10.1,"Unem_pctl":"57","Housing_Bu":18,"HB_pctl":"50","PopCharSco":6.87,"Pop_Pctl":"75","Children__":13.1,"Pop_11_64_":73,"Elderly___":13.9,"Hispanic__":"42.9","White____":"12.6","African_Am":"13.7","Native_Ame":"0.1","Asian_Amer":"27.8","Other____":"2.9","Shape_Leng":4749.19374823,"Shape_Area":1135085.36824}},{"arcs":[[1869,1870,1871,1872,-540]],"type":"Polygon","properties":{"Tract_1":6037603004,"Percentile":"76-80%","Population":1512,"County":"Los Angeles","ZIP":90247,"City":"Gardena","CIscore":42.32,"CIscoreP":"79","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":27.42,"DPM_pctl":81,"DrinkingWa":255.67,"DW_pctl":"26","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6728.34,"TR_pctl":87,"Traffic":810.67,"Traff_Pctl":"58","Cleanups":4.5,"Clean_Pctl":42,"Groundwate":11.3,"GW_pctl":52,"Haz_Waste":0.13,"Haz_pctl":50,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":5,"Solid_pctl":74,"PollutionS":6.17,"Poll_pctl":73,"Asthma":79.41,"Asthma_Pct":85,"Low_Birth_":5.73,"LBW_pctl":"71","Cardiovasc":10.07,"CVD_pctl":75,"Education":15.3,"Edu_pctl":"53","Linguistic":24.6,"Ling_pctl":"90","Poverty":39.2,"Pov_pctl":"58","Unemployme":5.1,"Unem_pctl":"13","Housing_Bu":20.5,"HB_pctl":"61","PopCharSco":6.85,"Pop_Pctl":"74","Children__":10.8,"Pop_11_64_":72.9,"Elderly___":16.3,"Hispanic__":"28.4","White____":"6.3","African_Am":"19.8","Native_Ame":"0","Asian_Amer":"43.3","Other____":"2.2","Shape_Leng":2501.52356713,"Shape_Area":224712.67462}},{"arcs":[[1873,1874,1875,1876,1877,-1695]],"type":"Polygon","properties":{"Tract_1":6037574202,"Percentile":"41-45%","Population":2161,"County":"Los Angeles","ZIP":90815,"City":"Long Beach","CIscore":21.07,"CIscoreP":"41","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":25.99,"DPM_pctl":78,"DrinkingWa":285.61,"DW_pctl":"30","Pesticides":16.101,"Pest_pctl":62,"Tox_Releas":8508.32,"TR_pctl":91,"Traffic":2280.75,"Traff_Pctl":"93","Cleanups":31.8,"Clean_Pctl":91,"Groundwate":63.3,"GW_pctl":94,"Haz_Waste":0.78,"Haz_pctl":84,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":2.5,"Solid_pctl":57,"PollutionS":8,"Poll_pctl":96,"Asthma":28.65,"Asthma_Pct":23,"Low_Birth_":3.41,"LBW_pctl":"15","Cardiovasc":6.3,"CVD_pctl":28,"Education":12.9,"Edu_pctl":"47","Linguistic":1.5,"Ling_pctl":"10","Poverty":31.6,"Pov_pctl":"47","Unemployme":4.4,"Unem_pctl":"9","Housing_Bu":14.3,"HB_pctl":"32","PopCharSco":2.63,"Pop_Pctl":"14","Children__":12.4,"Pop_11_64_":70.1,"Elderly___":17.5,"Hispanic__":"28.6","White____":"55.9","African_Am":"5.5","Native_Ame":"0.3","Asian_Amer":"6.6","Other____":"3.2","Shape_Leng":6087.49001632,"Shape_Area":1356318.23494}},{"arcs":[[1878,1879,1880]],"type":"Polygon","properties":{"Tract_1":6037574201,"Percentile":"31-35%","Population":3117,"County":"Los Angeles","ZIP":90815,"City":"Long Beach","CIscore":17.69,"CIscoreP":"32","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":24.34,"DPM_pctl":74,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":1.437,"Pest_pctl":42,"Tox_Releas":7398.8,"TR_pctl":89,"Traffic":1363.12,"Traff_Pctl":"80","Cleanups":1.9,"Clean_Pctl":25,"Groundwate":9,"GW_pctl":46,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.29,"Poll_pctl":53,"Asthma":29.27,"Asthma_Pct":24,"Low_Birth_":5.74,"LBW_pctl":"71","Cardiovasc":7.66,"CVD_pctl":46,"Education":4,"Edu_pctl":"15","Linguistic":1.6,"Ling_pctl":"11","Poverty":16.7,"Pov_pctl":"20","Unemployme":7.3,"Unem_pctl":"32","Housing_Bu":9,"HB_pctl":"9","PopCharSco":3.34,"Pop_Pctl":"23","Children__":11.8,"Pop_11_64_":74.2,"Elderly___":14,"Hispanic__":"22.3","White____":"57.6","African_Am":"3","Native_Ame":"0.2","Asian_Amer":"12.4","Other____":"4.5","Shape_Leng":4825.0145827,"Shape_Area":1292778.43551}},{"arcs":[[1881,1882,1883,1884,1885,1886,1887,1888,-1164,1889]],"type":"Polygon","properties":{"Tract_1":6037574601,"Percentile":"NA","Population":1863,"County":"Los Angeles","ZIP":90840,"City":"Long Beach","CIscore":0,"CIscoreP":"NA","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":18.33,"DPM_pctl":56,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":7780.97,"TR_pctl":90,"Traffic":597.55,"Traff_Pctl":"41","Cleanups":1.4,"Clean_Pctl":21,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":3.74,"Poll_pctl":20,"Asthma":14.54,"Asthma_Pct":3,"Low_Birth_":0,"LBW_pctl":"NA","Cardiovasc":3.81,"CVD_pctl":3,"Education":0,"Edu_pctl":"NA","Linguistic":0,"Ling_pctl":"NA","Poverty":0,"Pov_pctl":"NA","Unemployme":28.9,"Unem_pctl":"100","Housing_Bu":0,"HB_pctl":"NA","PopCharSco":0,"Pop_Pctl":"NA","Children__":0.4,"Pop_11_64_":99.3,"Elderly___":0.3,"Hispanic__":"22.1","White____":"48.9","African_Am":"5.9","Native_Ame":"0.2","Asian_Amer":"16","Other____":"6.9","Shape_Leng":5907.10721922,"Shape_Area":1300513.53278}},{"arcs":[[1890,1891,1892,1893,-761,1894]],"type":"Polygon","properties":{"Tract_1":6037291210,"Percentile":"96-100%","Population":4967,"County":"Los Angeles","ZIP":90247,"City":"Gardena","CIscore":69.62,"CIscoreP":"99","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":27.17,"DPM_pctl":81,"DrinkingWa":695.9,"DW_pctl":"82","Pesticides":26.858,"Pest_pctl":67,"Tox_Releas":7007.62,"TR_pctl":88,"Traffic":2498.31,"Traff_Pctl":"95","Cleanups":27.4,"Clean_Pctl":89,"Groundwate":72.55,"GW_pctl":95,"Haz_Waste":1.54,"Haz_pctl":90,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":14.45,"Solid_pctl":95,"PollutionS":9.3,"Poll_pctl":100,"Asthma":70.23,"Asthma_Pct":79,"Low_Birth_":6.18,"LBW_pctl":"80","Cardiovasc":9.31,"CVD_pctl":67,"Education":24.8,"Edu_pctl":"70","Linguistic":19,"Ling_pctl":"83","Poverty":53,"Pov_pctl":"77","Unemployme":9.1,"Unem_pctl":"49","Housing_Bu":22.4,"HB_pctl":"68","PopCharSco":7.48,"Pop_Pctl":"83","Children__":14.7,"Pop_11_64_":75,"Elderly___":10.3,"Hispanic__":"62.6","White____":"5.6","African_Am":"13.5","Native_Ame":"0.1","Asian_Amer":"16.5","Other____":"1.6","Shape_Leng":4771.73371951,"Shape_Area":1242495.81134}},{"arcs":[[1895,1896,1897]],"type":"Polygon","properties":{"Tract_1":6037570203,"Percentile":"96-100%","Population":3973,"County":"Los Angeles","ZIP":90805,"City":"Long Beach","CIscore":58.73,"CIscoreP":"96","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":21.75,"DPM_pctl":66,"DrinkingWa":251.53,"DW_pctl":"25","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6835.64,"TR_pctl":88,"Traffic":2325.63,"Traff_Pctl":"94","Cleanups":4.6,"Clean_Pctl":43,"Groundwate":44.1,"GW_pctl":89,"Haz_Waste":0.96,"Haz_pctl":86,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":5,"Solid_pctl":74,"PollutionS":7.62,"Poll_pctl":94,"Asthma":64.59,"Asthma_Pct":74,"Low_Birth_":6.61,"LBW_pctl":"86","Cardiovasc":8.21,"CVD_pctl":54,"Education":32.1,"Edu_pctl":"79","Linguistic":15.7,"Ling_pctl":"76","Poverty":51.7,"Pov_pctl":"75","Unemployme":11.9,"Unem_pctl":"69","Housing_Bu":29.4,"HB_pctl":"87","PopCharSco":7.71,"Pop_Pctl":"86","Children__":19.1,"Pop_11_64_":76.5,"Elderly___":4.4,"Hispanic__":"60.7","White____":"5.2","African_Am":"23.3","Native_Ame":"0.2","Asian_Amer":"8.9","Other____":"1.8","Shape_Leng":4837.20588519,"Shape_Area":1304419.21761}},{"arcs":[[-1089,1898,1899,1900,-547,-1892,1901]],"type":"Polygon","properties":{"Tract_1":6037291220,"Percentile":"96-100%","Population":3353,"County":"Los Angeles","ZIP":90247,"City":"Gardena","CIscore":77.5,"CIscoreP":"100","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":27.16,"DPM_pctl":81,"DrinkingWa":695.72,"DW_pctl":"82","Pesticides":68.625,"Pest_pctl":73,"Tox_Releas":8937.65,"TR_pctl":92,"Traffic":2467.25,"Traff_Pctl":"95","Cleanups":17.4,"Clean_Pctl":81,"Groundwate":65.55,"GW_pctl":94,"Haz_Waste":0.86,"Haz_pctl":85,"Imp__Water":18,"IWB_pctl":98,"Solid_Wast":3.45,"Solid_pctl":63,"PollutionS":9.85,"Poll_pctl":100,"Asthma":66.49,"Asthma_Pct":75,"Low_Birth_":6.54,"LBW_pctl":"85","Cardiovasc":8.87,"CVD_pctl":62,"Education":31.4,"Edu_pctl":"78","Linguistic":23.1,"Ling_pctl":"88","Poverty":53.4,"Pov_pctl":"77","Unemployme":8.9,"Unem_pctl":"47","Housing_Bu":37.3,"HB_pctl":"96","PopCharSco":7.87,"Pop_Pctl":"88","Children__":14.8,"Pop_11_64_":74.7,"Elderly___":10.5,"Hispanic__":"65.1","White____":"4.5","African_Am":"11.5","Native_Ame":"0.1","Asian_Amer":"17","Other____":"1.7","Shape_Leng":3754.59794925,"Shape_Area":817856.953929}},{"arcs":[[1902,1903,-1634,1904,1905,1906,-548,1907,-1900]],"type":"Polygon","properties":{"Tract_1":6037291300,"Percentile":"91-95%","Population":2601,"County":"Los Angeles","ZIP":90248,"City":"Gardena","CIscore":57.04,"CIscoreP":"95","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":25.63,"DPM_pctl":78,"DrinkingWa":695.99,"DW_pctl":"82","Pesticides":0.07,"Pest_pctl":18,"Tox_Releas":10738.59,"TR_pctl":94,"Traffic":2462.83,"Traff_Pctl":"95","Cleanups":40.7,"Clean_Pctl":94,"Groundwate":36.85,"GW_pctl":86,"Haz_Waste":5.57,"Haz_pctl":97,"Imp__Water":18,"IWB_pctl":98,"Solid_Wast":9.2,"Solid_pctl":88,"PollutionS":9.44,"Poll_pctl":100,"Asthma":60.47,"Asthma_Pct":70,"Low_Birth_":7.61,"LBW_pctl":"95","Cardiovasc":9.11,"CVD_pctl":64,"Education":10.9,"Edu_pctl":"42","Linguistic":11.2,"Ling_pctl":"63","Poverty":19,"Pov_pctl":"25","Unemployme":3.4,"Unem_pctl":"4","Housing_Bu":22,"HB_pctl":"67","PopCharSco":6.04,"Pop_Pctl":"62","Children__":9.3,"Pop_11_64_":66.4,"Elderly___":24.3,"Hispanic__":"24.4","White____":"16.5","African_Am":"6.4","Native_Ame":"0.5","Asian_Amer":"48.3","Other____":"4.1","Shape_Leng":9577.10636771,"Shape_Area":2402012.40537}},{"arcs":[[1908,-1714,1909,1910,-347,1911,1912]],"type":"Polygon","properties":{"Tract_1":6037670406,"Percentile":"1-5%","Population":1903,"County":"Los Angeles","ZIP":90274,"City":"Palos Verdes Peninsula","CIscore":3.01,"CIscoreP":"1","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":6.09,"DPM_pctl":16,"DrinkingWa":187.24,"DW_pctl":"14","Pesticides":0,"Pest_pctl":0,"Tox_Releas":2520.19,"TR_pctl":71,"Traffic":255.53,"Traff_Pctl":"9","Cleanups":0.4,"Clean_Pctl":6,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":2.68,"Poll_pctl":5,"Asthma":11.15,"Asthma_Pct":1,"Low_Birth_":1.79,"LBW_pctl":"1","Cardiovasc":3.56,"CVD_pctl":2,"Education":0,"Edu_pctl":"NA","Linguistic":12.3,"Ling_pctl":"67","Poverty":6.9,"Pov_pctl":"3","Unemployme":2.4,"Unem_pctl":"1","Housing_Bu":11.5,"HB_pctl":"19","PopCharSco":1.13,"Pop_Pctl":"2","Children__":9.5,"Pop_11_64_":69.6,"Elderly___":20.9,"Hispanic__":"3.8","White____":"46.8","African_Am":"1.4","Native_Ame":"0.1","Asian_Amer":"43.9","Other____":"4.1","Shape_Leng":4443.29602345,"Shape_Area":1193020.45284}},{"arcs":[[1913,1914,1915,1916,1917,-1262,1918,1919,1920,-398,1921]],"type":"Polygon","properties":{"Tract_1":6037670202,"Percentile":"1-5%","Population":2594,"County":"Los Angeles","ZIP":90274,"City":"Palos Verdes Peninsula","CIscore":5.88,"CIscoreP":"4","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":8.39,"DPM_pctl":24,"DrinkingWa":184.21,"DW_pctl":"14","Pesticides":0,"Pest_pctl":0,"Tox_Releas":4819.86,"TR_pctl":80,"Traffic":563.59,"Traff_Pctl":"38","Cleanups":12.1,"Clean_Pctl":70,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.1,"Haz_pctl":43,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":3,"Solid_pctl":62,"PollutionS":4.58,"Poll_pctl":38,"Asthma":14.77,"Asthma_Pct":3,"Low_Birth_":4.21,"LBW_pctl":"31","Cardiovasc":4.43,"CVD_pctl":8,"Education":1.5,"Edu_pctl":"3","Linguistic":2.6,"Ling_pctl":"19","Poverty":13.1,"Pov_pctl":"12","Unemployme":5.6,"Unem_pctl":"17","Housing_Bu":5,"HB_pctl":"2","PopCharSco":1.28,"Pop_Pctl":"2","Children__":11.4,"Pop_11_64_":66.5,"Elderly___":22.1,"Hispanic__":"8.2","White____":"70.3","African_Am":"1.1","Native_Ame":"0.3","Asian_Amer":"16.8","Other____":"3.3","Shape_Leng":8236.36353312,"Shape_Area":2979674.24839}},{"arcs":[[-1492,1922,1923,1924]],"type":"Polygon","properties":{"Tract_1":6037670003,"Percentile":"66-70%","Population":5788,"County":"Los Angeles","ZIP":90717,"City":"Lomita","CIscore":33.51,"CIscoreP":"66","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":18.53,"DPM_pctl":57,"DrinkingWa":152.86,"DW_pctl":"9","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6738.89,"TR_pctl":87,"Traffic":1441.79,"Traff_Pctl":"82","Cleanups":11.65,"Clean_Pctl":66,"Groundwate":31.25,"GW_pctl":83,"Haz_Waste":1.4,"Haz_pctl":90,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":1.75,"Solid_pctl":41,"PollutionS":6.25,"Poll_pctl":74,"Asthma":42.41,"Asthma_Pct":46,"Low_Birth_":5.41,"LBW_pctl":"64","Cardiovasc":6.32,"CVD_pctl":28,"Education":7.8,"Edu_pctl":"31","Linguistic":13,"Ling_pctl":"69","Poverty":33.6,"Pov_pctl":"50","Unemployme":13.1,"Unem_pctl":"76","Housing_Bu":20.6,"HB_pctl":"62","PopCharSco":5.36,"Pop_Pctl":"53","Children__":11.1,"Pop_11_64_":77.3,"Elderly___":11.6,"Hispanic__":"32.1","White____":"47.8","African_Am":"2.7","Native_Ame":"0.5","Asian_Amer":"13","Other____":"3.9","Shape_Leng":5632.52941933,"Shape_Area":1505261.13128}},{"arcs":[[1925,-1920,1926,-1260,1927,-1258,1928,1929,-1153,1930,1931,-400]],"type":"Polygon","properties":{"Tract_1":6037670411,"Percentile":"6-10%","Population":4427,"County":"Los Angeles","ZIP":90275,"City":"Rancho Palos Verdes","CIscore":7.25,"CIscoreP":"7","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":7.56,"DPM_pctl":21,"DrinkingWa":187.24,"DW_pctl":"14","Pesticides":0,"Pest_pctl":0,"Tox_Releas":4040.9,"TR_pctl":77,"Traffic":467.64,"Traff_Pctl":"28","Cleanups":1.2,"Clean_Pctl":20,"Groundwate":3,"GW_pctl":22,"Haz_Waste":0.01,"Haz_pctl":9,"Imp__Water":5,"IWB_pctl":55,"Solid_Wast":0.5,"Solid_pctl":20,"PollutionS":4.1,"Poll_pctl":27,"Asthma":10.27,"Asthma_Pct":1,"Low_Birth_":5.16,"LBW_pctl":"57","Cardiovasc":3.66,"CVD_pctl":3,"Education":1.8,"Edu_pctl":"5","Linguistic":4.8,"Ling_pctl":"35","Poverty":12.2,"Pov_pctl":"11","Unemployme":5.4,"Unem_pctl":"16","Housing_Bu":6.2,"HB_pctl":"3","PopCharSco":1.77,"Pop_Pctl":"6","Children__":12.2,"Pop_11_64_":66.1,"Elderly___":21.7,"Hispanic__":"6.8","White____":"58.1","African_Am":"1.1","Native_Ame":"0.1","Asian_Amer":"29.2","Other____":"4.7","Shape_Leng":8796.74068222,"Shape_Area":2891558.64761}},{"arcs":[[-1354,1932,1933,1934]],"type":"Polygon","properties":{"Tract_1":6037572600,"Percentile":"86-90%","Population":5370,"County":"Los Angeles","ZIP":90810,"City":"Long Beach","CIscore":48.88,"CIscoreP":"88","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":32.71,"DPM_pctl":88,"DrinkingWa":218.3,"DW_pctl":"17","Pesticides":0,"Pest_pctl":0,"Tox_Releas":26157.02,"TR_pctl":99,"Traffic":1210.72,"Traff_Pctl":"76","Cleanups":7.9,"Clean_Pctl":55,"Groundwate":32.75,"GW_pctl":84,"Haz_Waste":3.94,"Haz_pctl":96,"Imp__Water":22,"IWB_pctl":99,"Solid_Wast":1,"Solid_pctl":33,"PollutionS":7.43,"Poll_pctl":92,"Asthma":70.09,"Asthma_Pct":79,"Low_Birth_":5.37,"LBW_pctl":"63","Cardiovasc":9.25,"CVD_pctl":66,"Education":22.6,"Edu_pctl":"66","Linguistic":10.9,"Ling_pctl":"62","Poverty":39.1,"Pov_pctl":"58","Unemployme":8.7,"Unem_pctl":"45","Housing_Bu":19.5,"HB_pctl":"57","PopCharSco":6.57,"Pop_Pctl":"70","Children__":13.1,"Pop_11_64_":76.2,"Elderly___":10.7,"Hispanic__":"45.2","White____":"4.4","African_Am":"10.9","Native_Ame":"0.1","Asian_Amer":"36.9","Other____":"2.5","Shape_Leng":4791.13940487,"Shape_Area":1277052.42365}},{"arcs":[[1935,1936,1937,1938]],"type":"Polygon","properties":{"Tract_1":6037573300,"Percentile":"91-95%","Population":4323,"County":"Los Angeles","ZIP":90806,"City":"Long Beach","CIscore":53.51,"CIscoreP":"92","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":28.55,"DPM_pctl":83,"DrinkingWa":290.27,"DW_pctl":"31","Pesticides":0.002,"Pest_pctl":4,"Tox_Releas":8524.78,"TR_pctl":91,"Traffic":1365.15,"Traff_Pctl":"80","Cleanups":8.65,"Clean_Pctl":57,"Groundwate":19.9,"GW_pctl":70,"Haz_Waste":0.32,"Haz_pctl":70,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.8,"Solid_pctl":24,"PollutionS":6.35,"Poll_pctl":76,"Asthma":66.28,"Asthma_Pct":75,"Low_Birth_":7.4,"LBW_pctl":"94","Cardiovasc":7.69,"CVD_pctl":46,"Education":41.5,"Edu_pctl":"88","Linguistic":18,"Ling_pctl":"81","Poverty":72.4,"Pov_pctl":"95","Unemployme":17.6,"Unem_pctl":"92","Housing_Bu":44.4,"HB_pctl":"99","PopCharSco":8.43,"Pop_Pctl":"94","Children__":16.2,"Pop_11_64_":77.9,"Elderly___":5.9,"Hispanic__":"37","White____":"3.5","African_Am":"15.9","Native_Ame":"0.2","Asian_Amer":"41.8","Other____":"1.6","Shape_Leng":4038.74069293,"Shape_Area":789551.881654}},{"arcs":[[-1753,1939,-1554,1940]],"type":"Polygon","properties":{"Tract_1":6037575300,"Percentile":"91-95%","Population":4947,"County":"Los Angeles","ZIP":90813,"City":"Long Beach","CIscore":54.49,"CIscoreP":"93","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":29.12,"DPM_pctl":84,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0.621,"Pest_pctl":35,"Tox_Releas":10236.92,"TR_pctl":94,"Traffic":946.81,"Traff_Pctl":"65","Cleanups":0,"Clean_Pctl":0,"Groundwate":9,"GW_pctl":46,"Haz_Waste":0.06,"Haz_pctl":28,"Imp__Water":11,"IWB_pctl":90,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.96,"Poll_pctl":68,"Asthma":127.37,"Asthma_Pct":97,"Low_Birth_":6.38,"LBW_pctl":"83","Cardiovasc":12.42,"CVD_pctl":91,"Education":47.5,"Edu_pctl":"93","Linguistic":24.4,"Ling_pctl":"90","Poverty":73.6,"Pov_pctl":"95","Unemployme":14.5,"Unem_pctl":"82","Housing_Bu":22.7,"HB_pctl":"70","PopCharSco":9.14,"Pop_Pctl":"98","Children__":18.2,"Pop_11_64_":73.7,"Elderly___":8.1,"Hispanic__":"58.6","White____":"2.7","African_Am":"15.8","Native_Ame":"0.5","Asian_Amer":"20","Other____":"2.3","Shape_Leng":3220.99308431,"Shape_Area":648423.867455}},{"arcs":[[1941,1942,1943,-3,-1787]],"type":"Polygon","properties":{"Tract_1":6037572900,"Percentile":"91-95%","Population":5250,"County":"Los Angeles","ZIP":90810,"City":"Long Beach","CIscore":55.29,"CIscoreP":"93","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":29.19,"DPM_pctl":84,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":20253.17,"TR_pctl":98,"Traffic":1559.97,"Traff_Pctl":"84","Cleanups":1.75,"Clean_Pctl":24,"Groundwate":9.5,"GW_pctl":47,"Haz_Waste":10.6,"Haz_pctl":99,"Imp__Water":11,"IWB_pctl":90,"Solid_Wast":3.05,"Solid_pctl":62,"PollutionS":7.13,"Poll_pctl":88,"Asthma":63.37,"Asthma_Pct":73,"Low_Birth_":5.85,"LBW_pctl":"74","Cardiovasc":8.12,"CVD_pctl":52,"Education":38.8,"Edu_pctl":"86","Linguistic":24.5,"Ling_pctl":"90","Poverty":59.5,"Pov_pctl":"84","Unemployme":11.7,"Unem_pctl":"68","Housing_Bu":31,"HB_pctl":"89","PopCharSco":7.76,"Pop_Pctl":"87","Children__":17.9,"Pop_11_64_":75,"Elderly___":7.1,"Hispanic__":"70.2","White____":"2.7","African_Am":"8.6","Native_Ame":"0.1","Asian_Amer":"16.6","Other____":"1.7","Shape_Leng":3634.80459804,"Shape_Area":773442.751608}},{"arcs":[[1944,1945,1946,1947,-1769,1948,1949]],"type":"Polygon","properties":{"Tract_1":6037573201,"Percentile":"96-100%","Population":4930,"County":"Los Angeles","ZIP":90806,"City":"Long Beach","CIscore":61.46,"CIscoreP":"97","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":29.12,"DPM_pctl":84,"DrinkingWa":290.6,"DW_pctl":"31","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8930.87,"TR_pctl":92,"Traffic":657.25,"Traff_Pctl":"47","Cleanups":4.5,"Clean_Pctl":42,"Groundwate":11.5,"GW_pctl":53,"Haz_Waste":0.36,"Haz_pctl":72,"Imp__Water":11,"IWB_pctl":90,"Solid_Wast":7.5,"Solid_pctl":85,"PollutionS":6.92,"Poll_pctl":86,"Asthma":81.84,"Asthma_Pct":86,"Low_Birth_":7.83,"LBW_pctl":"96","Cardiovasc":9.57,"CVD_pctl":70,"Education":46.7,"Edu_pctl":"92","Linguistic":25.5,"Ling_pctl":"91","Poverty":56.9,"Pov_pctl":"81","Unemployme":13.5,"Unem_pctl":"78","Housing_Bu":34.7,"HB_pctl":"94","PopCharSco":8.88,"Pop_Pctl":"97","Children__":17.6,"Pop_11_64_":76.2,"Elderly___":6.2,"Hispanic__":"60.5","White____":"4.6","African_Am":"14","Native_Ame":"0.1","Asian_Amer":"18.8","Other____":"1.9","Shape_Leng":3157.12451917,"Shape_Area":602443.185701}},{"arcs":[[1950,1951,1952,-1946]],"type":"Polygon","properties":{"Tract_1":6037573100,"Percentile":"86-90%","Population":7165,"County":"Los Angeles","ZIP":90806,"City":"Long Beach","CIscore":49.99,"CIscoreP":"89","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":29.12,"DPM_pctl":84,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":11952.5,"TR_pctl":95,"Traffic":798.55,"Traff_Pctl":"57","Cleanups":2.75,"Clean_Pctl":31,"Groundwate":11.3,"GW_pctl":52,"Haz_Waste":0.14,"Haz_pctl":51,"Imp__Water":11,"IWB_pctl":90,"Solid_Wast":4.2,"Solid_pctl":69,"PollutionS":6.53,"Poll_pctl":80,"Asthma":99.66,"Asthma_Pct":93,"Low_Birth_":5.74,"LBW_pctl":"71","Cardiovasc":11.31,"CVD_pctl":85,"Education":29.2,"Edu_pctl":"76","Linguistic":13.8,"Ling_pctl":"72","Poverty":40.2,"Pov_pctl":"60","Unemployme":8,"Unem_pctl":"39","Housing_Bu":25.2,"HB_pctl":"77","PopCharSco":7.66,"Pop_Pctl":"85","Children__":15.7,"Pop_11_64_":77.4,"Elderly___":6.9,"Hispanic__":"48.1","White____":"10.5","African_Am":"22.6","Native_Ame":"0.4","Asian_Amer":"16","Other____":"2.4","Shape_Leng":4564.78220078,"Shape_Area":1186256.82468}},{"arcs":[[1953,1954,-1952]],"type":"Polygon","properties":{"Tract_1":6037572700,"Percentile":"86-90%","Population":5499,"County":"Los Angeles","ZIP":90810,"City":"Long Beach","CIscore":48.35,"CIscoreP":"87","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":31.85,"DPM_pctl":88,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":20466.8,"TR_pctl":98,"Traffic":1167.61,"Traff_Pctl":"74","Cleanups":1.2,"Clean_Pctl":20,"Groundwate":23.05,"GW_pctl":75,"Haz_Waste":3.13,"Haz_pctl":95,"Imp__Water":22,"IWB_pctl":99,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":6.86,"Poll_pctl":85,"Asthma":69.64,"Asthma_Pct":78,"Low_Birth_":6.15,"LBW_pctl":"79","Cardiovasc":9.19,"CVD_pctl":65,"Education":21.5,"Edu_pctl":"65","Linguistic":11.7,"Ling_pctl":"65","Poverty":48.1,"Pov_pctl":"71","Unemployme":12.7,"Unem_pctl":"74","Housing_Bu":14.6,"HB_pctl":"33","PopCharSco":7.05,"Pop_Pctl":"77","Children__":13.4,"Pop_11_64_":74.3,"Elderly___":12.3,"Hispanic__":"37.8","White____":"3.7","African_Am":"9.4","Native_Ame":"0.2","Asian_Amer":"45.6","Other____":"3.2","Shape_Leng":4272.05791565,"Shape_Area":1069205.82452}},{"arcs":[[1955,-1943,1956,1957,1958,1959,1960]],"type":"Polygon","properties":{"Tract_1":6037572800,"Percentile":"96-100%","Population":839,"County":"Los Angeles","ZIP":90810,"City":"Long Beach","CIscore":66.29,"CIscoreP":"99","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":36.66,"DPM_pctl":91,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":27471.53,"TR_pctl":99,"Traffic":595.7,"Traff_Pctl":"41","Cleanups":7.15,"Clean_Pctl":53,"Groundwate":24.25,"GW_pctl":76,"Haz_Waste":11.41,"Haz_pctl":100,"Imp__Water":22,"IWB_pctl":99,"Solid_Wast":5.4,"Solid_pctl":75,"PollutionS":7.38,"Poll_pctl":91,"Asthma":72.09,"Asthma_Pct":80,"Low_Birth_":0,"LBW_pctl":"NA","Cardiovasc":9.55,"CVD_pctl":70,"Education":0,"Edu_pctl":"NA","Linguistic":0,"Ling_pctl":"NA","Poverty":91.5,"Pov_pctl":"100","Unemployme":34.6,"Unem_pctl":"100","Housing_Bu":49.1,"HB_pctl":"100","PopCharSco":8.98,"Pop_Pctl":"98","Children__":15.6,"Pop_11_64_":80.5,"Elderly___":3.9,"Hispanic__":"19","White____":"25.3","African_Am":"38.6","Native_Ame":"1.5","Asian_Amer":"9.4","Other____":"6.2","Shape_Leng":5048.51715854,"Shape_Area":1079962.21704}},{"arcs":[[1961,1962,1963]],"type":"Polygon","properties":{"Tract_1":6037577000,"Percentile":"71-75%","Population":6995,"County":"Los Angeles","ZIP":90804,"City":"Long Beach","CIscore":36.96,"CIscoreP":"72","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":18.49,"DPM_pctl":57,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8043.2,"TR_pctl":90,"Traffic":1076.78,"Traff_Pctl":"71","Cleanups":2,"Clean_Pctl":27,"Groundwate":25.25,"GW_pctl":78,"Haz_Waste":1.1,"Haz_pctl":87,"Imp__Water":9,"IWB_pctl":81,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":6.17,"Poll_pctl":73,"Asthma":70.28,"Asthma_Pct":79,"Low_Birth_":5.92,"LBW_pctl":"75","Cardiovasc":8.79,"CVD_pctl":61,"Education":11.5,"Edu_pctl":"44","Linguistic":1.6,"Ling_pctl":"11","Poverty":29.5,"Pov_pctl":"44","Unemployme":9.2,"Unem_pctl":"49","Housing_Bu":23.7,"HB_pctl":"73","PopCharSco":5.99,"Pop_Pctl":"62","Children__":8.6,"Pop_11_64_":84.8,"Elderly___":6.6,"Hispanic__":"27.1","White____":"44.6","African_Am":"13","Native_Ame":"0.3","Asian_Amer":"10.4","Other____":"4.7","Shape_Leng":6613.71643846,"Shape_Area":1847976.31977}},{"arcs":[[1964,-973,1965,1966,1967,1968,1969]],"type":"Polygon","properties":{"Tract_1":6037542200,"Percentile":"96-100%","Population":6962,"County":"Los Angeles","ZIP":90221,"City":"Compton","CIscore":57.6,"CIscoreP":"95","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":29.03,"DPM_pctl":83,"DrinkingWa":411.31,"DW_pctl":"43","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6312.96,"TR_pctl":86,"Traffic":1834.1,"Traff_Pctl":"89","Cleanups":0,"Clean_Pctl":0,"Groundwate":24.3,"GW_pctl":76,"Haz_Waste":0.27,"Haz_pctl":67,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":1.1,"Solid_pctl":33,"PollutionS":7.01,"Poll_pctl":87,"Asthma":82.68,"Asthma_Pct":87,"Low_Birth_":5.33,"LBW_pctl":"62","Cardiovasc":12.72,"CVD_pctl":92,"Education":45.9,"Edu_pctl":"92","Linguistic":12.1,"Ling_pctl":"66","Poverty":56.7,"Pov_pctl":"81","Unemployme":17.7,"Unem_pctl":"92","Housing_Bu":20.7,"HB_pctl":"62","PopCharSco":8.22,"Pop_Pctl":"92","Children__":18.9,"Pop_11_64_":74.7,"Elderly___":6.4,"Hispanic__":"75.1","White____":"1","African_Am":"21.8","Native_Ame":"0.1","Asian_Amer":"1","Other____":"1","Shape_Leng":5184.8537605,"Shape_Area":1389043.17721}},{"arcs":[[-1940,-1757,-1945,1970]],"type":"Polygon","properties":{"Tract_1":6037573202,"Percentile":"91-95%","Population":6230,"County":"Los Angeles","ZIP":90806,"City":"Long Beach","CIscore":51.55,"CIscoreP":"90","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":29.12,"DPM_pctl":84,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":9823.74,"TR_pctl":93,"Traffic":898.05,"Traff_Pctl":"63","Cleanups":1.1,"Clean_Pctl":19,"Groundwate":12.5,"GW_pctl":55,"Haz_Waste":0.25,"Haz_pctl":66,"Imp__Water":11,"IWB_pctl":90,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":6.05,"Poll_pctl":70,"Asthma":88.45,"Asthma_Pct":89,"Low_Birth_":6.43,"LBW_pctl":"84","Cardiovasc":9.9,"CVD_pctl":74,"Education":38.8,"Edu_pctl":"86","Linguistic":11.2,"Ling_pctl":"63","Poverty":63.1,"Pov_pctl":"87","Unemployme":15.9,"Unem_pctl":"87","Housing_Bu":29.2,"HB_pctl":"86","PopCharSco":8.51,"Pop_Pctl":"95","Children__":16.7,"Pop_11_64_":78.2,"Elderly___":5.1,"Hispanic__":"58","White____":"3.2","African_Am":"17","Native_Ame":"0.2","Asian_Amer":"20.1","Other____":"1.5","Shape_Leng":3222.33873289,"Shape_Area":648966.285053}},{"arcs":[[1971,1972,-942,1973,1974,-465,1975,1976,-787]],"type":"Polygon","properties":{"Tract_1":6037541603,"Percentile":"96-100%","Population":2983,"County":"Los Angeles","ZIP":90222,"City":"Compton","CIscore":63.2,"CIscoreP":"98","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":18.7,"DPM_pctl":58,"DrinkingWa":641.57,"DW_pctl":"72","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6010.26,"TR_pctl":85,"Traffic":752.18,"Traff_Pctl":"54","Cleanups":54.8,"Clean_Pctl":97,"Groundwate":50.3,"GW_pctl":91,"Haz_Waste":13.73,"Haz_pctl":100,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":18.5,"Solid_pctl":97,"PollutionS":7.74,"Poll_pctl":95,"Asthma":67.98,"Asthma_Pct":77,"Low_Birth_":5.24,"LBW_pctl":"59","Cardiovasc":9.16,"CVD_pctl":65,"Education":56.5,"Edu_pctl":"97","Linguistic":11.7,"Ling_pctl":"65","Poverty":74.9,"Pov_pctl":"96","Unemployme":21.9,"Unem_pctl":"97","Housing_Bu":37.8,"HB_pctl":"97","PopCharSco":8.17,"Pop_Pctl":"91","Children__":20.9,"Pop_11_64_":72.4,"Elderly___":6.7,"Hispanic__":"79.1","White____":"1.1","African_Am":"19","Native_Ame":"0","Asian_Amer":"0.1","Other____":"0.6","Shape_Leng":6254.51366243,"Shape_Area":1254616.97566}},{"arcs":[[1977,-434,1978,1979,1980,-439]],"type":"Polygon","properties":{"Tract_1":6037551600,"Percentile":"NA","Population":31,"County":"Los Angeles","ZIP":90242,"City":"Downey","CIscore":0,"CIscoreP":"NA","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":16.41,"DPM_pctl":50,"DrinkingWa":225.79,"DW_pctl":"19","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6938.73,"TR_pctl":88,"Traffic":679.27,"Traff_Pctl":"48","Cleanups":0,"Clean_Pctl":0,"Groundwate":6.25,"GW_pctl":37,"Haz_Waste":0.06,"Haz_pctl":26,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0.5,"Solid_pctl":20,"PollutionS":5.11,"Poll_pctl":49,"Asthma":57.03,"Asthma_Pct":66,"Low_Birth_":0,"LBW_pctl":"NA","Cardiovasc":10.07,"CVD_pctl":75,"Education":0,"Edu_pctl":"NA","Linguistic":0,"Ling_pctl":"NA","Poverty":0,"Pov_pctl":"NA","Unemployme":0,"Unem_pctl":"NA","Housing_Bu":0,"HB_pctl":"NA","PopCharSco":0,"Pop_Pctl":"NA","Children__":0,"Pop_11_64_":100,"Elderly___":0,"Hispanic__":"35.5","White____":"16.1","African_Am":"38.7","Native_Ame":"0","Asian_Amer":"9.7","Other____":"0","Shape_Leng":4801.33336759,"Shape_Area":915070.875145}},{"arcs":[[-469,1981]],"type":"Polygon","properties":{"Tract_1":6037550400,"Percentile":"56-60%","Population":1534,"County":"Los Angeles","ZIP":90241,"City":"Downey","CIscore":29.22,"CIscoreP":"58","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":27,"DPM_pctl":80,"DrinkingWa":640.53,"DW_pctl":"72","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5914.19,"TR_pctl":84,"Traffic":3646.72,"Traff_Pctl":"99","Cleanups":0,"Clean_Pctl":0,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.06,"Haz_pctl":28,"Imp__Water":3,"IWB_pctl":41,"Solid_Wast":2.5,"Solid_pctl":57,"PollutionS":6.55,"Poll_pctl":80,"Asthma":35.15,"Asthma_Pct":34,"Low_Birth_":6.56,"LBW_pctl":"86","Cardiovasc":7.03,"CVD_pctl":38,"Education":14.8,"Edu_pctl":"52","Linguistic":3.7,"Ling_pctl":"28","Poverty":13.3,"Pov_pctl":"13","Unemployme":8.3,"Unem_pctl":"41","Housing_Bu":14.8,"HB_pctl":"34","PopCharSco":4.46,"Pop_Pctl":"39","Children__":12.9,"Pop_11_64_":76.9,"Elderly___":10.2,"Hispanic__":"74.3","White____":"17.6","African_Am":"2.2","Native_Ame":"0.3","Asian_Amer":"5.3","Other____":"0.3","Shape_Leng":4531.3773147,"Shape_Area":874036.938828}},{"arcs":[[1982,1983,1984,1985]],"type":"Polygon","properties":{"Tract_1":6037551201,"Percentile":"51-55%","Population":3588,"County":"Los Angeles","ZIP":90242,"City":"Downey","CIscore":26.53,"CIscoreP":"53","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":17.62,"DPM_pctl":54,"DrinkingWa":675.26,"DW_pctl":"80","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6287.38,"TR_pctl":86,"Traffic":828,"Traff_Pctl":"59","Cleanups":0.4,"Clean_Pctl":6,"Groundwate":4.3,"GW_pctl":28,"Haz_Waste":0.01,"Haz_pctl":9,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.25,"Solid_pctl":10,"PollutionS":5.13,"Poll_pctl":50,"Asthma":51.88,"Asthma_Pct":59,"Low_Birth_":4.38,"LBW_pctl":"35","Cardiovasc":9.2,"CVD_pctl":66,"Education":20.1,"Edu_pctl":"62","Linguistic":11.3,"Ling_pctl":"64","Poverty":27,"Pov_pctl":"40","Unemployme":7.1,"Unem_pctl":"30","Housing_Bu":15.5,"HB_pctl":"37","PopCharSco":5.17,"Pop_Pctl":"50","Children__":13.6,"Pop_11_64_":73.8,"Elderly___":12.6,"Hispanic__":"70.1","White____":"18.2","African_Am":"3.9","Native_Ame":"0.1","Asian_Amer":"6.1","Other____":"1.6","Shape_Leng":3928.57235921,"Shape_Area":786347.417856}},{"arcs":[[1986,1987,1988,-1983,1989,-1210]],"type":"Polygon","properties":{"Tract_1":6037551202,"Percentile":"66-70%","Population":7666,"County":"Los Angeles","ZIP":90242,"City":"Downey","CIscore":35.99,"CIscoreP":"70","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":19.01,"DPM_pctl":59,"DrinkingWa":682.24,"DW_pctl":"81","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6082.82,"TR_pctl":85,"Traffic":658.35,"Traff_Pctl":"47","Cleanups":14.5,"Clean_Pctl":76,"Groundwate":37.75,"GW_pctl":87,"Haz_Waste":0.1,"Haz_pctl":43,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.6,"Solid_pctl":21,"PollutionS":6.48,"Poll_pctl":79,"Asthma":54.8,"Asthma_Pct":63,"Low_Birth_":4.04,"LBW_pctl":"27","Cardiovasc":9.69,"CVD_pctl":71,"Education":22.6,"Edu_pctl":"66","Linguistic":11.7,"Ling_pctl":"65","Poverty":33.1,"Pov_pctl":"49","Unemployme":5.1,"Unem_pctl":"13","Housing_Bu":23.4,"HB_pctl":"72","PopCharSco":5.55,"Pop_Pctl":"55","Children__":14.8,"Pop_11_64_":75.2,"Elderly___":10,"Hispanic__":"73.2","White____":"15.6","African_Am":"3.7","Native_Ame":"0.1","Asian_Amer":"6.3","Other____":"1.1","Shape_Leng":4790.25703594,"Shape_Area":1404432.95943}},{"arcs":[[1990,1991,1992,-1988,-527]],"type":"Polygon","properties":{"Tract_1":6037551700,"Percentile":"81-85%","Population":6547,"County":"Los Angeles","ZIP":90242,"City":"Downey","CIscore":44.2,"CIscoreP":"82","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":20.99,"DPM_pctl":65,"DrinkingWa":650.32,"DW_pctl":"73","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6001.02,"TR_pctl":85,"Traffic":1482.98,"Traff_Pctl":"83","Cleanups":0.9,"Clean_Pctl":13,"Groundwate":5.75,"GW_pctl":34,"Haz_Waste":0.12,"Haz_pctl":49,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0.5,"Solid_pctl":20,"PollutionS":6.56,"Poll_pctl":80,"Asthma":53.29,"Asthma_Pct":61,"Low_Birth_":5.39,"LBW_pctl":"63","Cardiovasc":9.43,"CVD_pctl":68,"Education":30.1,"Edu_pctl":"77","Linguistic":11,"Ling_pctl":"62","Poverty":39.4,"Pov_pctl":"59","Unemployme":9.8,"Unem_pctl":"54","Housing_Bu":25.6,"HB_pctl":"78","PopCharSco":6.74,"Pop_Pctl":"73","Children__":15.6,"Pop_11_64_":76.1,"Elderly___":8.3,"Hispanic__":"79.1","White____":"11.4","African_Am":"4.1","Native_Ame":"0.2","Asian_Amer":"3.9","Other____":"1.2","Shape_Leng":4821.81686809,"Shape_Area":1301318.22409}},{"arcs":[[-308,-1616,1993,1994,1995]],"type":"Polygon","properties":{"Tract_1":6037553602,"Percentile":"91-95%","Population":4730,"County":"Los Angeles","ZIP":90723,"City":"Paramount","CIscore":56.33,"CIscoreP":"94","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":21.88,"DPM_pctl":67,"DrinkingWa":228.54,"DW_pctl":"23","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6635.74,"TR_pctl":87,"Traffic":1542.92,"Traff_Pctl":"84","Cleanups":5.5,"Clean_Pctl":46,"Groundwate":24.25,"GW_pctl":76,"Haz_Waste":0.18,"Haz_pctl":57,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":10.25,"Solid_pctl":90,"PollutionS":7.29,"Poll_pctl":90,"Asthma":57.83,"Asthma_Pct":66,"Low_Birth_":6.24,"LBW_pctl":"81","Cardiovasc":10.87,"CVD_pctl":82,"Education":36.6,"Edu_pctl":"84","Linguistic":9.5,"Ling_pctl":"57","Poverty":55.1,"Pov_pctl":"79","Unemployme":9.4,"Unem_pctl":"51","Housing_Bu":33.1,"HB_pctl":"93","PopCharSco":7.73,"Pop_Pctl":"86","Children__":17.1,"Pop_11_64_":78.3,"Elderly___":4.6,"Hispanic__":"70.1","White____":"4.2","African_Am":"20.7","Native_Ame":"0.1","Asian_Amer":"3.9","Other____":"1.1","Shape_Leng":3356.99445232,"Shape_Area":605688.384355}},{"arcs":[[1996,-449,1997,1998]],"type":"Polygon","properties":{"Tract_1":6037503703,"Percentile":"31-35%","Population":7876,"County":"Los Angeles","ZIP":90638,"City":"La Mirada","CIscore":18.49,"CIscoreP":"34","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":11.02,"DPM_pctl":31,"DrinkingWa":514.51,"DW_pctl":"55","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6024.92,"TR_pctl":85,"Traffic":790.21,"Traff_Pctl":"56","Cleanups":1.2,"Clean_Pctl":20,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0.25,"Solid_pctl":10,"PollutionS":4.9,"Poll_pctl":44,"Asthma":30.84,"Asthma_Pct":27,"Low_Birth_":3.45,"LBW_pctl":"16","Cardiovasc":7.78,"CVD_pctl":48,"Education":9.1,"Edu_pctl":"36","Linguistic":17.9,"Ling_pctl":"81","Poverty":18.9,"Pov_pctl":"24","Unemployme":8,"Unem_pctl":"39","Housing_Bu":14.7,"HB_pctl":"34","PopCharSco":3.78,"Pop_Pctl":"29","Children__":8.8,"Pop_11_64_":67.2,"Elderly___":24,"Hispanic__":"20.4","White____":"30.9","African_Am":"1.8","Native_Ame":"0.2","Asian_Amer":"44.8","Other____":"1.9","Shape_Leng":6556.54491353,"Shape_Area":2641267.60211}},{"arcs":[[-1980,1999,-19,2000,2001,-1995,2002,-1614,2003,-1612,2004,-1620,2005,2006,2007]],"type":"Polygon","properties":{"Tract_1":6037536200,"Percentile":"91-95%","Population":7289,"County":"Los Angeles","ZIP":90280,"City":"South Gate","CIscore":54.84,"CIscoreP":"93","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":23.28,"DPM_pctl":71,"DrinkingWa":416.54,"DW_pctl":"43","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6696.76,"TR_pctl":87,"Traffic":1659.89,"Traff_Pctl":"86","Cleanups":4.8,"Clean_Pctl":43,"Groundwate":29,"GW_pctl":81,"Haz_Waste":0.4,"Haz_pctl":73,"Imp__Water":10,"IWB_pctl":86,"Solid_Wast":9.95,"Solid_pctl":89,"PollutionS":7.86,"Poll_pctl":95,"Asthma":38.73,"Asthma_Pct":40,"Low_Birth_":5.17,"LBW_pctl":"57","Cardiovasc":9.49,"CVD_pctl":69,"Education":41,"Edu_pctl":"88","Linguistic":16.8,"Ling_pctl":"79","Poverty":48.5,"Pov_pctl":"71","Unemployme":13.7,"Unem_pctl":"79","Housing_Bu":26.1,"HB_pctl":"80","PopCharSco":6.98,"Pop_Pctl":"76","Children__":15.1,"Pop_11_64_":77.1,"Elderly___":7.8,"Hispanic__":"87.3","White____":"8.5","African_Am":"1.1","Native_Ame":"0.2","Asian_Amer":"2.2","Other____":"0.7","Shape_Leng":9790.66338726,"Shape_Area":2208700.19826}},{"arcs":[[2008,2009,2010,2011,2012,2013,2014]],"type":"Polygon","properties":{"Tract_1":6037542000,"Percentile":"91-95%","Population":5732,"County":"Los Angeles","ZIP":90221,"City":"Compton","CIscore":53.01,"CIscoreP":"92","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":26.94,"DPM_pctl":80,"DrinkingWa":428.55,"DW_pctl":"44","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6103.34,"TR_pctl":85,"Traffic":699.89,"Traff_Pctl":"50","Cleanups":0.1,"Clean_Pctl":2,"Groundwate":30.5,"GW_pctl":82,"Haz_Waste":0.1,"Haz_pctl":43,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":6.19,"Poll_pctl":73,"Asthma":76.03,"Asthma_Pct":83,"Low_Birth_":6.79,"LBW_pctl":"88","Cardiovasc":11.88,"CVD_pctl":88,"Education":35.4,"Edu_pctl":"82","Linguistic":12.4,"Ling_pctl":"67","Poverty":56.1,"Pov_pctl":"80","Unemployme":13.7,"Unem_pctl":"79","Housing_Bu":28.7,"HB_pctl":"85","PopCharSco":8.57,"Pop_Pctl":"95","Children__":18.1,"Pop_11_64_":75.1,"Elderly___":6.8,"Hispanic__":"71.1","White____":"0.9","African_Am":"25.6","Native_Ame":"0.6","Asian_Amer":"1.1","Other____":"0.7","Shape_Leng":4230.39089173,"Shape_Area":975438.84945}},{"arcs":[[2015,2016,-1082,2017,-652]],"type":"Polygon","properties":{"Tract_1":6037540102,"Percentile":"91-95%","Population":6972,"County":"Los Angeles","ZIP":90262,"City":"Lynwood","CIscore":51.57,"CIscoreP":"90","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":25.69,"DPM_pctl":78,"DrinkingWa":291.72,"DW_pctl":"31","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6345.33,"TR_pctl":86,"Traffic":2548.35,"Traff_Pctl":"95","Cleanups":15.75,"Clean_Pctl":78,"Groundwate":8.75,"GW_pctl":44,"Haz_Waste":0.1,"Haz_pctl":43,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0.9,"Solid_pctl":24,"PollutionS":6.99,"Poll_pctl":87,"Asthma":56.52,"Asthma_Pct":65,"Low_Birth_":4.57,"LBW_pctl":"41","Cardiovasc":10.81,"CVD_pctl":82,"Education":45,"Edu_pctl":"91","Linguistic":15.6,"Ling_pctl":"76","Poverty":55.2,"Pov_pctl":"79","Unemployme":12.9,"Unem_pctl":"76","Housing_Bu":25.6,"HB_pctl":"78","PopCharSco":7.38,"Pop_Pctl":"81","Children__":16.6,"Pop_11_64_":77.5,"Elderly___":5.9,"Hispanic__":"85.4","White____":"1.5","African_Am":"11.7","Native_Ame":"0.1","Asian_Amer":"0.7","Other____":"0.6","Shape_Leng":4727.5104565,"Shape_Area":1243065.99631}},{"arcs":[[2018,2019,-1243,2020,2021,2022,2023,2024]],"type":"Polygon","properties":{"Tract_1":6037543603,"Percentile":"71-75%","Population":3690,"County":"Los Angeles","ZIP":90710,"City":"Harbor City","CIscore":36.43,"CIscoreP":"71","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":20.01,"DPM_pctl":62,"DrinkingWa":414.34,"DW_pctl":"43","Pesticides":15.602,"Pest_pctl":62,"Tox_Releas":10722.18,"TR_pctl":94,"Traffic":1372,"Traff_Pctl":"80","Cleanups":4.15,"Clean_Pctl":39,"Groundwate":3,"GW_pctl":22,"Haz_Waste":2.35,"Haz_pctl":93,"Imp__Water":12,"IWB_pctl":91,"Solid_Wast":1,"Solid_pctl":33,"PollutionS":7.44,"Poll_pctl":92,"Asthma":52.17,"Asthma_Pct":59,"Low_Birth_":5.03,"LBW_pctl":"53","Cardiovasc":9.58,"CVD_pctl":70,"Education":7.4,"Edu_pctl":"30","Linguistic":9.3,"Ling_pctl":"56","Poverty":18.3,"Pov_pctl":"23","Unemployme":6.1,"Unem_pctl":"21","Housing_Bu":15.7,"HB_pctl":"38","PopCharSco":4.89,"Pop_Pctl":"46","Children__":6.2,"Pop_11_64_":64.3,"Elderly___":29.5,"Hispanic__":"17.9","White____":"29.5","African_Am":"28.1","Native_Ame":"0.3","Asian_Amer":"20.4","Other____":"3.9","Shape_Leng":5344.29265825,"Shape_Area":1477179.74263}},{"arcs":[[2025,2026,2027,2028,2029,2030]],"type":"Polygon","properties":{"Tract_1":6037541001,"Percentile":"96-100%","Population":1164,"County":"Los Angeles","ZIP":90248,"City":"Gardena","CIscore":68.1,"CIscoreP":"99","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":27.31,"DPM_pctl":81,"DrinkingWa":473.98,"DW_pctl":"49","Pesticides":3.758,"Pest_pctl":51,"Tox_Releas":6502.6,"TR_pctl":87,"Traffic":470.36,"Traff_Pctl":"28","Cleanups":46.95,"Clean_Pctl":96,"Groundwate":74,"GW_pctl":95,"Haz_Waste":8.05,"Haz_pctl":99,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":22.75,"Solid_pctl":98,"PollutionS":8.07,"Poll_pctl":97,"Asthma":68.35,"Asthma_Pct":77,"Low_Birth_":6.6,"LBW_pctl":"86","Cardiovasc":10.28,"CVD_pctl":77,"Education":28.3,"Edu_pctl":"75","Linguistic":0,"Ling_pctl":"NA","Poverty":47.2,"Pov_pctl":"70","Unemployme":17.7,"Unem_pctl":"92","Housing_Bu":36.3,"HB_pctl":"96","PopCharSco":8.43,"Pop_Pctl":"94","Children__":12.6,"Pop_11_64_":72.5,"Elderly___":14.9,"Hispanic__":"43.8","White____":"2.7","African_Am":"47.8","Native_Ame":"0.1","Asian_Amer":"3.5","Other____":"2.1","Shape_Leng":6555.00227363,"Shape_Area":2603801.78346}},{"arcs":[[2031,2032,-245,2033,-950,2034,-1381]],"type":"Polygon","properties":{"Tract_1":6037600502,"Percentile":"91-95%","Population":2355,"County":"Los Angeles","ZIP":90303,"City":"Inglewood","CIscore":52.62,"CIscoreP":"91","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":22.67,"DPM_pctl":69,"DrinkingWa":249.29,"DW_pctl":"25","Pesticides":6.035,"Pest_pctl":54,"Tox_Releas":4914.44,"TR_pctl":80,"Traffic":2786.31,"Traff_Pctl":"96","Cleanups":2.9,"Clean_Pctl":31,"Groundwate":9.1,"GW_pctl":46,"Haz_Waste":0.46,"Haz_pctl":75,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0.5,"Solid_pctl":20,"PollutionS":7.25,"Poll_pctl":90,"Asthma":90.2,"Asthma_Pct":89,"Low_Birth_":7.18,"LBW_pctl":"92","Cardiovasc":10.66,"CVD_pctl":80,"Education":25.8,"Edu_pctl":"71","Linguistic":10.2,"Ling_pctl":"60","Poverty":26.7,"Pov_pctl":"39","Unemployme":13.7,"Unem_pctl":"79","Housing_Bu":10.7,"HB_pctl":"15","PopCharSco":7.26,"Pop_Pctl":"80","Children__":12.7,"Pop_11_64_":76,"Elderly___":11.3,"Hispanic__":"49.5","White____":"1.9","African_Am":"45.6","Native_Ame":"0.3","Asian_Amer":"1.5","Other____":"1.2","Shape_Leng":4224.22849934,"Shape_Area":749745.318609}},{"arcs":[[-501,2035,2036,-1866,2037]],"type":"Polygon","properties":{"Tract_1":6037603500,"Percentile":"81-85%","Population":3074,"County":"Los Angeles","ZIP":90249,"City":"Gardena","CIscore":43.37,"CIscoreP":"81","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":23.4,"DPM_pctl":72,"DrinkingWa":255.67,"DW_pctl":"26","Pesticides":0.02,"Pest_pctl":11,"Tox_Releas":5427.35,"TR_pctl":82,"Traffic":935.23,"Traff_Pctl":"64","Cleanups":4.5,"Clean_Pctl":42,"Groundwate":42.5,"GW_pctl":89,"Haz_Waste":0.26,"Haz_pctl":67,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":1,"Solid_pctl":33,"PollutionS":6.9,"Poll_pctl":85,"Asthma":93.59,"Asthma_Pct":91,"Low_Birth_":5.56,"LBW_pctl":"67","Cardiovasc":11.42,"CVD_pctl":85,"Education":22.3,"Edu_pctl":"66","Linguistic":17,"Ling_pctl":"79","Poverty":24.1,"Pov_pctl":"35","Unemployme":3.3,"Unem_pctl":"4","Housing_Bu":11.2,"HB_pctl":"18","PopCharSco":6.28,"Pop_Pctl":"66","Children__":11.2,"Pop_11_64_":76.1,"Elderly___":12.7,"Hispanic__":"40.8","White____":"19.4","African_Am":"10.3","Native_Ame":"0.4","Asian_Amer":"26.2","Other____":"3","Shape_Leng":3985.71482903,"Shape_Area":794219.475136}},{"arcs":[[-103,2038,2039,2040,2041]],"type":"Polygon","properties":{"Tract_1":6037293201,"Percentile":"71-75%","Population":6629,"County":"Los Angeles","ZIP":90501,"City":"Torrance","CIscore":36.92,"CIscoreP":"72","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":18.74,"DPM_pctl":58,"DrinkingWa":226.8,"DW_pctl":"19","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8380.26,"TR_pctl":91,"Traffic":851.54,"Traff_Pctl":"60","Cleanups":40.25,"Clean_Pctl":94,"Groundwate":23.25,"GW_pctl":75,"Haz_Waste":0.09,"Haz_pctl":32,"Imp__Water":3,"IWB_pctl":41,"Solid_Wast":2,"Solid_pctl":50,"PollutionS":6.41,"Poll_pctl":77,"Asthma":60.74,"Asthma_Pct":70,"Low_Birth_":4.44,"LBW_pctl":"37","Cardiovasc":7.28,"CVD_pctl":41,"Education":24.6,"Edu_pctl":"70","Linguistic":17.3,"Ling_pctl":"79","Poverty":34.3,"Pov_pctl":"51","Unemployme":8.8,"Unem_pctl":"46","Housing_Bu":20.7,"HB_pctl":"62","PopCharSco":5.76,"Pop_Pctl":"58","Children__":14,"Pop_11_64_":77.6,"Elderly___":8.4,"Hispanic__":"53.2","White____":"15.9","African_Am":"4.6","Native_Ame":"0.2","Asian_Amer":"24","Other____":"2.1","Shape_Leng":4251.91519337,"Shape_Area":1072769.71543}},{"arcs":[[-1632,2042,2043,-2040,2044,-1906,2045]],"type":"Polygon","properties":{"Tract_1":6037292000,"Percentile":"96-100%","Population":6543,"County":"Los Angeles","ZIP":90501,"City":"Torrance","CIscore":66.67,"CIscoreP":"99","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":19.7,"DPM_pctl":61,"DrinkingWa":426.43,"DW_pctl":"44","Pesticides":0.029,"Pest_pctl":13,"Tox_Releas":10548.66,"TR_pctl":94,"Traffic":2511.49,"Traff_Pctl":"95","Cleanups":102.2,"Clean_Pctl":99,"Groundwate":51.35,"GW_pctl":91,"Haz_Waste":6.71,"Haz_pctl":98,"Imp__Water":14,"IWB_pctl":94,"Solid_Wast":10.7,"Solid_pctl":90,"PollutionS":8.82,"Poll_pctl":99,"Asthma":59.49,"Asthma_Pct":69,"Low_Birth_":5.95,"LBW_pctl":"76","Cardiovasc":7.15,"CVD_pctl":39,"Education":28,"Edu_pctl":"74","Linguistic":17,"Ling_pctl":"79","Poverty":56.7,"Pov_pctl":"81","Unemployme":18.6,"Unem_pctl":"94","Housing_Bu":35.6,"HB_pctl":"95","PopCharSco":7.56,"Pop_Pctl":"84","Children__":17.5,"Pop_11_64_":76.4,"Elderly___":6.1,"Hispanic__":"59.7","White____":"11","African_Am":"13.2","Native_Ame":"0.1","Asian_Amer":"14.2","Other____":"1.8","Shape_Leng":9746.68570959,"Shape_Area":4002828.6236}},{"arcs":[[2046,2047,2048,2049]],"type":"Polygon","properties":{"Tract_1":6037293202,"Percentile":"81-85%","Population":6742,"County":"Los Angeles","ZIP":90501,"City":"Torrance","CIscore":43.57,"CIscoreP":"81","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":19.23,"DPM_pctl":59,"DrinkingWa":225.09,"DW_pctl":"19","Pesticides":0,"Pest_pctl":0,"Tox_Releas":7805.6,"TR_pctl":90,"Traffic":718.41,"Traff_Pctl":"51","Cleanups":8.2,"Clean_Pctl":56,"Groundwate":22,"GW_pctl":74,"Haz_Waste":0.56,"Haz_pctl":79,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":2.2,"Solid_pctl":52,"PollutionS":5.9,"Poll_pctl":67,"Asthma":60.73,"Asthma_Pct":70,"Low_Birth_":5.44,"LBW_pctl":"64","Cardiovasc":7.28,"CVD_pctl":41,"Education":30.9,"Edu_pctl":"78","Linguistic":17.9,"Ling_pctl":"81","Poverty":64.8,"Pov_pctl":"89","Unemployme":14.6,"Unem_pctl":"83","Housing_Bu":31.4,"HB_pctl":"90","PopCharSco":7.38,"Pop_Pctl":"81","Children__":17.5,"Pop_11_64_":77.6,"Elderly___":4.9,"Hispanic__":"69.7","White____":"6.7","African_Am":"6.3","Native_Ame":"0.2","Asian_Amer":"15.2","Other____":"1.9","Shape_Leng":4360.21937616,"Shape_Area":1054428.70362}},{"arcs":[[2050,-1320,2051,2052]],"type":"Polygon","properties":{"Tract_1":6037294120,"Percentile":"91-95%","Population":2370,"County":"Los Angeles","ZIP":90744,"City":"Wilmington","CIscore":57.54,"CIscoreP":"95","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":36.66,"DPM_pctl":91,"DrinkingWa":198.88,"DW_pctl":"15","Pesticides":0.144,"Pest_pctl":24,"Tox_Releas":14172.6,"TR_pctl":96,"Traffic":766.97,"Traff_Pctl":"55","Cleanups":14.1,"Clean_Pctl":75,"Groundwate":18,"GW_pctl":68,"Haz_Waste":8.12,"Haz_pctl":99,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":10.7,"Solid_pctl":90,"PollutionS":7.17,"Poll_pctl":89,"Asthma":70.22,"Asthma_Pct":79,"Low_Birth_":5.31,"LBW_pctl":"61","Cardiovasc":10.57,"CVD_pctl":79,"Education":55.9,"Edu_pctl":"97","Linguistic":19.3,"Ling_pctl":"83","Poverty":58,"Pov_pctl":"82","Unemployme":12.3,"Unem_pctl":"72","Housing_Bu":24.5,"HB_pctl":"75","PopCharSco":8.02,"Pop_Pctl":"90","Children__":17.1,"Pop_11_64_":76.7,"Elderly___":6.2,"Hispanic__":"91.7","White____":"1.4","African_Am":"5.3","Native_Ame":"0.2","Asian_Amer":"0.7","Other____":"0.8","Shape_Leng":5209.33686463,"Shape_Area":1552812.22338}},{"arcs":[[2053,2054,-134,2055,2056]],"type":"Polygon","properties":{"Tract_1":6037621201,"Percentile":"11-15%","Population":6452,"County":"Los Angeles","ZIP":90277,"City":"Redondo Beach","CIscore":10,"CIscoreP":"13","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":15.43,"DPM_pctl":47,"DrinkingWa":237.22,"DW_pctl":"24","Pesticides":0.268,"Pest_pctl":28,"Tox_Releas":8565.43,"TR_pctl":91,"Traffic":561.23,"Traff_Pctl":"37","Cleanups":13.25,"Clean_Pctl":73,"Groundwate":2.5,"GW_pctl":15,"Haz_Waste":0.1,"Haz_pctl":43,"Imp__Water":8,"IWB_pctl":76,"Solid_Wast":4,"Solid_pctl":68,"PollutionS":6.37,"Poll_pctl":77,"Asthma":20.25,"Asthma_Pct":8,"Low_Birth_":3.04,"LBW_pctl":"9","Cardiovasc":5.31,"CVD_pctl":16,"Education":3.8,"Edu_pctl":"14","Linguistic":4.9,"Ling_pctl":"36","Poverty":11.1,"Pov_pctl":"9","Unemployme":7,"Unem_pctl":"29","Housing_Bu":8.7,"HB_pctl":"9","PopCharSco":1.57,"Pop_Pctl":"4","Children__":10,"Pop_11_64_":79.7,"Elderly___":10.3,"Hispanic__":"15.4","White____":"68.6","African_Am":"2.7","Native_Ame":"0.2","Asian_Amer":"8.5","Other____":"4.5","Shape_Leng":5291.59414085,"Shape_Area":1641157.24782}},{"arcs":[[-151,2057,2058,2059,2060]],"type":"Polygon","properties":{"Tract_1":6037620301,"Percentile":"1-5%","Population":4657,"County":"Los Angeles","ZIP":90266,"City":"Manhattan Beach","CIscore":4.53,"CIscoreP":"2","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":34.69,"DPM_pctl":89,"DrinkingWa":142.18,"DW_pctl":"9","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5267.74,"TR_pctl":81,"Traffic":654.56,"Traff_Pctl":"47","Cleanups":14.9,"Clean_Pctl":77,"Groundwate":11.75,"GW_pctl":53,"Haz_Waste":6.11,"Haz_pctl":98,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":6.48,"Poll_pctl":79,"Asthma":14.9,"Asthma_Pct":3,"Low_Birth_":3.11,"LBW_pctl":"10","Cardiovasc":4.55,"CVD_pctl":8,"Education":1.7,"Edu_pctl":"4","Linguistic":0.9,"Ling_pctl":"5","Poverty":5,"Pov_pctl":"1","Unemployme":5.7,"Unem_pctl":"18","Housing_Bu":5.7,"HB_pctl":"2","PopCharSco":0.7,"Pop_Pctl":"0","Children__":18,"Pop_11_64_":69.6,"Elderly___":12.4,"Hispanic__":"6.9","White____":"82.2","African_Am":"0.6","Native_Ame":"0.1","Asian_Amer":"6.1","Other____":"4.1","Shape_Leng":4329.1695621,"Shape_Area":1031138.75559}},{"arcs":[[2061,2062,-147,-2061,2063,2064]],"type":"Polygon","properties":{"Tract_1":6037620303,"Percentile":"6-10%","Population":4547,"County":"Los Angeles","ZIP":90266,"City":"Manhattan Beach","CIscore":6.94,"CIscoreP":"7","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":12.71,"DPM_pctl":38,"DrinkingWa":142.12,"DW_pctl":"9","Pesticides":0,"Pest_pctl":0,"Tox_Releas":3949.45,"TR_pctl":77,"Traffic":701.85,"Traff_Pctl":"50","Cleanups":14,"Clean_Pctl":75,"Groundwate":11.75,"GW_pctl":53,"Haz_Waste":6.2,"Haz_pctl":98,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.84,"Poll_pctl":65,"Asthma":16.77,"Asthma_Pct":5,"Low_Birth_":3.72,"LBW_pctl":"20","Cardiovasc":5.2,"CVD_pctl":14,"Education":5.8,"Edu_pctl":"23","Linguistic":1.3,"Ling_pctl":"8","Poverty":8.3,"Pov_pctl":"5","Unemployme":4.3,"Unem_pctl":"8","Housing_Bu":7.1,"HB_pctl":"5","PopCharSco":1.19,"Pop_Pctl":"2","Children__":16.7,"Pop_11_64_":70.5,"Elderly___":12.8,"Hispanic__":"6.2","White____":"82.9","African_Am":"0.4","Native_Ame":"0","Asian_Amer":"6.4","Other____":"4.1","Shape_Leng":4857.64539979,"Shape_Area":1161373.593}},{"arcs":[[-2062,2065,2066,2067]],"type":"Polygon","properties":{"Tract_1":6037620400,"Percentile":"6-10%","Population":5090,"County":"Los Angeles","ZIP":90266,"City":"Manhattan Beach","CIscore":7.56,"CIscoreP":"7","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":23.93,"DPM_pctl":73,"DrinkingWa":209.7,"DW_pctl":"16","Pesticides":0,"Pest_pctl":0,"Tox_Releas":4281.27,"TR_pctl":78,"Traffic":815.79,"Traff_Pctl":"58","Cleanups":23,"Clean_Pctl":86,"Groundwate":70.2,"GW_pctl":95,"Haz_Waste":8.02,"Haz_pctl":99,"Imp__Water":5,"IWB_pctl":55,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":6.82,"Poll_pctl":84,"Asthma":15.38,"Asthma_Pct":4,"Low_Birth_":3.1,"LBW_pctl":"10","Cardiovasc":4.33,"CVD_pctl":7,"Education":0.7,"Edu_pctl":"1","Linguistic":3.2,"Ling_pctl":"24","Poverty":9.7,"Pov_pctl":"6","Unemployme":6.8,"Unem_pctl":"27","Housing_Bu":10.3,"HB_pctl":"14","PopCharSco":1.11,"Pop_Pctl":"2","Children__":12.6,"Pop_11_64_":71.6,"Elderly___":15.8,"Hispanic__":"8.4","White____":"73.9","African_Am":"1.1","Native_Ame":"0.2","Asian_Amer":"11.7","Other____":"4.7","Shape_Leng":6433.58091037,"Shape_Area":2577429.02861}},{"arcs":[[-146,-2063,2068]],"type":"Polygon","properties":{"Tract_1":6037620901,"Percentile":"1-5%","Population":2621,"County":"Los Angeles","ZIP":90266,"City":"Manhattan Beach","CIscore":3.72,"CIscoreP":"2","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":8.3,"DPM_pctl":23,"DrinkingWa":142.65,"DW_pctl":"9","Pesticides":0,"Pest_pctl":0,"Tox_Releas":3950.12,"TR_pctl":77,"Traffic":707.51,"Traff_Pctl":"51","Cleanups":2.1,"Clean_Pctl":28,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.11,"Haz_pctl":46,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.43,"Poll_pctl":34,"Asthma":15.73,"Asthma_Pct":4,"Low_Birth_":3.33,"LBW_pctl":"14","Cardiovasc":4.93,"CVD_pctl":12,"Education":1.1,"Edu_pctl":"2","Linguistic":0,"Ling_pctl":"0","Poverty":10.6,"Pov_pctl":"8","Unemployme":5.1,"Unem_pctl":"13","Housing_Bu":8.6,"HB_pctl":"8","PopCharSco":0.84,"Pop_Pctl":"1","Children__":14.8,"Pop_11_64_":70.8,"Elderly___":14.4,"Hispanic__":"5.3","White____":"83.5","African_Am":"1","Native_Ame":"0.2","Asian_Amer":"6.9","Other____":"3","Shape_Leng":3928.3390371,"Shape_Area":871347.103384}},{"arcs":[[2069,2070,2071,2072,2073]],"type":"Polygon","properties":{"Tract_1":6037620800,"Percentile":"16-20%","Population":7575,"County":"Los Angeles","ZIP":90266,"City":"Manhattan Beach","CIscore":11.16,"CIscoreP":"15","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":15.26,"DPM_pctl":47,"DrinkingWa":142.51,"DW_pctl":"9","Pesticides":0,"Pest_pctl":0,"Tox_Releas":4672.5,"TR_pctl":79,"Traffic":758.77,"Traff_Pctl":"54","Cleanups":6.5,"Clean_Pctl":50,"Groundwate":1.6,"GW_pctl":9,"Haz_Waste":0.45,"Haz_pctl":74,"Imp__Water":5,"IWB_pctl":55,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.19,"Poll_pctl":51,"Asthma":15.14,"Asthma_Pct":3,"Low_Birth_":5.87,"LBW_pctl":"74","Cardiovasc":4.45,"CVD_pctl":8,"Education":4.7,"Edu_pctl":"18","Linguistic":2,"Ling_pctl":"14","Poverty":9.3,"Pov_pctl":"6","Unemployme":5,"Unem_pctl":"13","Housing_Bu":10.6,"HB_pctl":"15","PopCharSco":2.15,"Pop_Pctl":"9","Children__":12.2,"Pop_11_64_":74.7,"Elderly___":13.1,"Hispanic__":"8","White____":"69.7","African_Am":"1.1","Native_Ame":"0.2","Asian_Amer":"15.6","Other____":"5.5","Shape_Leng":6428.87570156,"Shape_Area":2483532.02791}},{"arcs":[[-1449,2074,-1959,2075,2076,-1670,-1676,-627,2077,2078,-859,2079,-864,2080]],"type":"Polygon","properties":{"Tract_1":6037980014,"Percentile":"NA","Population":239,"County":"Los Angeles","ZIP":90744,"City":"Wilmington","CIscore":0,"CIscoreP":"NA","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":173.11,"DPM_pctl":100,"DrinkingWa":437.57,"DW_pctl":"45","Pesticides":0,"Pest_pctl":0,"Tox_Releas":14288.14,"TR_pctl":96,"Traffic":796.25,"Traff_Pctl":"57","Cleanups":106.8,"Clean_Pctl":99,"Groundwate":111.4,"GW_pctl":98,"Haz_Waste":28.7,"Haz_pctl":100,"Imp__Water":28,"IWB_pctl":100,"Solid_Wast":32.85,"Solid_pctl":100,"PollutionS":8.72,"Poll_pctl":99,"Asthma":36.71,"Asthma_Pct":37,"Low_Birth_":0,"LBW_pctl":"NA","Cardiovasc":4.56,"CVD_pctl":9,"Education":0,"Edu_pctl":"NA","Linguistic":0,"Ling_pctl":"NA","Poverty":0,"Pov_pctl":"NA","Unemployme":100,"Unem_pctl":"100","Housing_Bu":0,"HB_pctl":"NA","PopCharSco":0,"Pop_Pctl":"NA","Children__":1.7,"Pop_11_64_":75.7,"Elderly___":22.6,"Hispanic__":"13.4","White____":"76.6","African_Am":"5","Native_Ame":"0","Asian_Amer":"3.3","Other____":"1.7","Shape_Leng":20701.997696,"Shape_Area":7460170.1036}},{"arcs":[[-1862,2081,-247,2082,-2067,-1691,2083,2084,-502,2085]],"type":"Polygon","properties":{"Tract_1":6037980013,"Percentile":"NA","Population":59,"County":"Los Angeles","ZIP":90245,"City":"El Segundo","CIscore":0,"CIscoreP":"NA","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":34.97,"DPM_pctl":90,"DrinkingWa":174.65,"DW_pctl":"13","Pesticides":2.599,"Pest_pctl":47,"Tox_Releas":5997.08,"TR_pctl":85,"Traffic":959.23,"Traff_Pctl":"66","Cleanups":28.4,"Clean_Pctl":90,"Groundwate":56.6,"GW_pctl":93,"Haz_Waste":7.5,"Haz_pctl":99,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":7.26,"Poll_pctl":90,"Asthma":27.04,"Asthma_Pct":20,"Low_Birth_":0,"LBW_pctl":"NA","Cardiovasc":7.48,"CVD_pctl":44,"Education":0,"Edu_pctl":"NA","Linguistic":0,"Ling_pctl":"NA","Poverty":0,"Pov_pctl":"NA","Unemployme":0,"Unem_pctl":"NA","Housing_Bu":0,"HB_pctl":"NA","PopCharSco":0,"Pop_Pctl":"NA","Children__":40.6,"Pop_11_64_":57.7,"Elderly___":1.7,"Hispanic__":"79.7","White____":"11.9","African_Am":"5.1","Native_Ame":"0","Asian_Amer":"3.4","Other____":"0","Shape_Leng":10443.5567898,"Shape_Area":5305897.77255}},{"arcs":[[2086,-1924,2087,-407,2088,-1741,-1389,2089,-1750]],"type":"Polygon","properties":{"Tract_1":6037651101,"Percentile":"31-35%","Population":5103,"County":"Los Angeles","ZIP":90505,"City":"Torrance","CIscore":17.62,"CIscoreP":"32","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":17.89,"DPM_pctl":54,"DrinkingWa":217.18,"DW_pctl":"17","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8030.27,"TR_pctl":90,"Traffic":990.35,"Traff_Pctl":"67","Cleanups":57.3,"Clean_Pctl":97,"Groundwate":78.05,"GW_pctl":96,"Haz_Waste":4.79,"Haz_pctl":96,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":3.45,"Solid_pctl":63,"PollutionS":6.91,"Poll_pctl":85,"Asthma":27.3,"Asthma_Pct":20,"Low_Birth_":3.95,"LBW_pctl":"25","Cardiovasc":6.09,"CVD_pctl":25,"Education":4.9,"Edu_pctl":"19","Linguistic":9.8,"Ling_pctl":"58","Poverty":14.2,"Pov_pctl":"15","Unemployme":5.4,"Unem_pctl":"16","Housing_Bu":11.9,"HB_pctl":"21","PopCharSco":2.55,"Pop_Pctl":"13","Children__":12,"Pop_11_64_":67,"Elderly___":21,"Hispanic__":"11.2","White____":"42.3","African_Am":"3.3","Native_Ame":"0.1","Asian_Amer":"39.7","Other____":"3.4","Shape_Leng":11444.6885416,"Shape_Area":5576737.60036}},{"arcs":[[2090,-200,2091,-1490,2092,2093,-413,2094,2095,-735]],"type":"Polygon","properties":{"Tract_1":6037670100,"Percentile":"51-55%","Population":6659,"County":"Los Angeles","ZIP":90717,"City":"Lomita","CIscore":25.37,"CIscoreP":"51","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":15.88,"DPM_pctl":48,"DrinkingWa":381.03,"DW_pctl":"40","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6897.5,"TR_pctl":88,"Traffic":966.55,"Traff_Pctl":"66","Cleanups":4.65,"Clean_Pctl":43,"Groundwate":9.75,"GW_pctl":48,"Haz_Waste":0.15,"Haz_pctl":54,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":3.2,"Solid_pctl":63,"PollutionS":5.73,"Poll_pctl":63,"Asthma":35.22,"Asthma_Pct":34,"Low_Birth_":5.1,"LBW_pctl":"55","Cardiovasc":5.52,"CVD_pctl":18,"Education":11.2,"Edu_pctl":"43","Linguistic":14.6,"Ling_pctl":"73","Poverty":36.3,"Pov_pctl":"54","Unemployme":7.4,"Unem_pctl":"33","Housing_Bu":17,"HB_pctl":"45","PopCharSco":4.43,"Pop_Pctl":"39","Children__":12.2,"Pop_11_64_":75.2,"Elderly___":12.6,"Hispanic__":"31.2","White____":"41.7","African_Am":"6.6","Native_Ame":"0.4","Asian_Amer":"16.1","Other____":"3.9","Shape_Leng":7576.8485349,"Shape_Area":1448977.24471}},{"arcs":[[-1716,2096,-1913,2097,2098,2099,2100]],"type":"Polygon","properties":{"Tract_1":6037670407,"Percentile":"1-5%","Population":5758,"County":"Los Angeles","ZIP":90275,"City":"Rancho Palos Verdes","CIscore":5.41,"CIscoreP":"4","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":6.01,"DPM_pctl":16,"DrinkingWa":187.24,"DW_pctl":"14","Pesticides":0,"Pest_pctl":0,"Tox_Releas":3120.58,"TR_pctl":74,"Traffic":407.84,"Traff_Pctl":"22","Cleanups":0.4,"Clean_Pctl":6,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":2.96,"Poll_pctl":8,"Asthma":10.36,"Asthma_Pct":1,"Low_Birth_":3.93,"LBW_pctl":"25","Cardiovasc":3.71,"CVD_pctl":3,"Education":1.9,"Edu_pctl":"5","Linguistic":18.2,"Ling_pctl":"81","Poverty":10.4,"Pov_pctl":"8","Unemployme":6.3,"Unem_pctl":"23","Housing_Bu":9.8,"HB_pctl":"12","PopCharSco":1.83,"Pop_Pctl":"6","Children__":9.6,"Pop_11_64_":74.8,"Elderly___":15.6,"Hispanic__":"6.2","White____":"39.2","African_Am":"2.8","Native_Ame":"0","Asian_Amer":"47.8","Other____":"3.9","Shape_Leng":5292.15906755,"Shape_Area":1254711.91669}},{"arcs":[[-415,2101,-2093,-1733,2102,-1739,2103,-1249,2104,-1917,2105,2106,-1914]],"type":"Polygon","properties":{"Tract_1":6037670201,"Percentile":"11-15%","Population":3852,"County":"Los Angeles","ZIP":90274,"City":"Palos Verdes Peninsula","CIscore":8.65,"CIscoreP":"10","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":8.83,"DPM_pctl":25,"DrinkingWa":184,"DW_pctl":"14","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5331.27,"TR_pctl":82,"Traffic":562.04,"Traff_Pctl":"38","Cleanups":11.9,"Clean_Pctl":67,"Groundwate":6,"GW_pctl":36,"Haz_Waste":0.12,"Haz_pctl":49,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":1.7,"Solid_pctl":40,"PollutionS":4.62,"Poll_pctl":39,"Asthma":16.34,"Asthma_Pct":4,"Low_Birth_":5.69,"LBW_pctl":"70","Cardiovasc":4.1,"CVD_pctl":5,"Education":0.6,"Edu_pctl":"1","Linguistic":0.7,"Ling_pctl":"3","Poverty":5.7,"Pov_pctl":"2","Unemployme":6.3,"Unem_pctl":"23","Housing_Bu":11.5,"HB_pctl":"19","PopCharSco":1.87,"Pop_Pctl":"6","Children__":10.1,"Pop_11_64_":67.3,"Elderly___":22.6,"Hispanic__":"8.7","White____":"68.5","African_Am":"1.6","Native_Ame":"0","Asian_Amer":"16.5","Other____":"4.6","Shape_Leng":14434.4582017,"Shape_Area":4878286.93223}},{"arcs":[[-1266,2107,2108]],"type":"Polygon","properties":{"Tract_1":6037574000,"Percentile":"16-20%","Population":5277,"County":"Los Angeles","ZIP":90808,"City":"Long Beach","CIscore":12.72,"CIscoreP":"19","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":15.83,"DPM_pctl":48,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6358.29,"TR_pctl":86,"Traffic":372.53,"Traff_Pctl":"18","Cleanups":9,"Clean_Pctl":60,"Groundwate":12,"GW_pctl":54,"Haz_Waste":0.05,"Haz_pctl":26,"Imp__Water":18,"IWB_pctl":98,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":5.19,"Poll_pctl":51,"Asthma":23.29,"Asthma_Pct":13,"Low_Birth_":5.8,"LBW_pctl":"72","Cardiovasc":6.14,"CVD_pctl":26,"Education":5,"Edu_pctl":"20","Linguistic":1.7,"Ling_pctl":"12","Poverty":7.1,"Pov_pctl":"3","Unemployme":5.5,"Unem_pctl":"17","Housing_Bu":4,"HB_pctl":"1","PopCharSco":2.45,"Pop_Pctl":"12","Children__":11.7,"Pop_11_64_":72.2,"Elderly___":16.1,"Hispanic__":"18.6","White____":"67.4","African_Am":"2.4","Native_Ame":"0.2","Asian_Amer":"7.5","Other____":"3.8","Shape_Leng":5834.81686523,"Shape_Area":1817354.73567}},{"arcs":[[2109,2110,2111,-70]],"type":"Polygon","properties":{"Tract_1":6037550000,"Percentile":"96-100%","Population":1146,"County":"Los Angeles","ZIP":90650,"City":"Norwalk","CIscore":60.26,"CIscoreP":"97","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":24.85,"DPM_pctl":76,"DrinkingWa":448.58,"DW_pctl":"46","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5613.69,"TR_pctl":83,"Traffic":718.24,"Traff_Pctl":"51","Cleanups":36.8,"Clean_Pctl":93,"Groundwate":28.35,"GW_pctl":80,"Haz_Waste":0.34,"Haz_pctl":71,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":7,"Solid_pctl":83,"PollutionS":7.27,"Poll_pctl":90,"Asthma":54.27,"Asthma_Pct":62,"Low_Birth_":0,"LBW_pctl":"NA","Cardiovasc":11.57,"CVD_pctl":86,"Education":41.5,"Edu_pctl":"88","Linguistic":0,"Ling_pctl":"NA","Poverty":55.2,"Pov_pctl":"79","Unemployme":17.4,"Unem_pctl":"91","Housing_Bu":0,"HB_pctl":"NA","PopCharSco":8.29,"Pop_Pctl":"93","Children__":6.6,"Pop_11_64_":86.2,"Elderly___":7.2,"Hispanic__":"33.6","White____":"32.7","African_Am":"13.5","Native_Ame":"0.3","Asian_Amer":"16.5","Other____":"3.3","Shape_Leng":4438.33237644,"Shape_Area":787647.048628}},{"arcs":[[2112,2113,-72,2114,-2111]],"type":"Polygon","properties":{"Tract_1":6037550100,"Percentile":"81-85%","Population":7518,"County":"Los Angeles","ZIP":90650,"City":"Norwalk","CIscore":45.1,"CIscoreP":"83","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":25.73,"DPM_pctl":78,"DrinkingWa":493.24,"DW_pctl":"52","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5467.1,"TR_pctl":82,"Traffic":977.79,"Traff_Pctl":"67","Cleanups":24.4,"Clean_Pctl":87,"Groundwate":36.7,"GW_pctl":86,"Haz_Waste":0.31,"Haz_pctl":70,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":2.6,"Solid_pctl":57,"PollutionS":7.31,"Poll_pctl":91,"Asthma":55.35,"Asthma_Pct":63,"Low_Birth_":5.41,"LBW_pctl":"64","Cardiovasc":11.8,"CVD_pctl":88,"Education":26.2,"Edu_pctl":"72","Linguistic":9.6,"Ling_pctl":"58","Poverty":29.2,"Pov_pctl":"43","Unemployme":7.9,"Unem_pctl":"38","Housing_Bu":13.1,"HB_pctl":"26","PopCharSco":6.17,"Pop_Pctl":"64","Children__":13.8,"Pop_11_64_":76.4,"Elderly___":9.8,"Hispanic__":"77.2","White____":"11.5","African_Am":"2.4","Native_Ame":"0.1","Asian_Amer":"8","Other____":"0.8","Shape_Leng":5637.40353344,"Shape_Area":1643686.18884}},{"arcs":[[2115,2116,-428,2117,2118,2119,2120]],"type":"Polygon","properties":{"Tract_1":6037552200,"Percentile":"86-90%","Population":6835,"County":"Los Angeles","ZIP":90650,"City":"Norwalk","CIscore":48.46,"CIscoreP":"87","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":29.5,"DPM_pctl":84,"DrinkingWa":557.71,"DW_pctl":"58","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5255.48,"TR_pctl":81,"Traffic":1220.98,"Traff_Pctl":"76","Cleanups":1,"Clean_Pctl":18,"Groundwate":28,"GW_pctl":80,"Haz_Waste":0.04,"Haz_pctl":19,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.5,"Solid_pctl":20,"PollutionS":6.23,"Poll_pctl":74,"Asthma":62.88,"Asthma_Pct":72,"Low_Birth_":5.61,"LBW_pctl":"68","Cardiovasc":13.42,"CVD_pctl":94,"Education":35.4,"Edu_pctl":"82","Linguistic":18,"Ling_pctl":"81","Poverty":49.5,"Pov_pctl":"73","Unemployme":8.1,"Unem_pctl":"40","Housing_Bu":27.4,"HB_pctl":"83","PopCharSco":7.78,"Pop_Pctl":"87","Children__":18.9,"Pop_11_64_":75.8,"Elderly___":5.3,"Hispanic__":"78.8","White____":"7.1","African_Am":"5.2","Native_Ame":"0.4","Asian_Amer":"7.6","Other____":"1","Shape_Leng":6796.36270824,"Shape_Area":1695526.47552}},{"arcs":[[2121,2122,2123,-424,2124,-2116,2125]],"type":"Polygon","properties":{"Tract_1":6037552100,"Percentile":"86-90%","Population":5891,"County":"Los Angeles","ZIP":90650,"City":"Norwalk","CIscore":48.66,"CIscoreP":"87","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":27.1,"DPM_pctl":80,"DrinkingWa":471.03,"DW_pctl":"48","Pesticides":0.016,"Pest_pctl":10,"Tox_Releas":5295.16,"TR_pctl":81,"Traffic":493.8,"Traff_Pctl":"30","Cleanups":4.5,"Clean_Pctl":42,"Groundwate":21,"GW_pctl":72,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":3,"IWB_pctl":41,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":5.87,"Poll_pctl":66,"Asthma":62.88,"Asthma_Pct":72,"Low_Birth_":6.81,"LBW_pctl":"89","Cardiovasc":13.42,"CVD_pctl":94,"Education":27.5,"Edu_pctl":"74","Linguistic":29.8,"Ling_pctl":"94","Poverty":39.8,"Pov_pctl":"59","Unemployme":14,"Unem_pctl":"80","Housing_Bu":21.9,"HB_pctl":"67","PopCharSco":8.3,"Pop_Pctl":"93","Children__":12.8,"Pop_11_64_":68.2,"Elderly___":19,"Hispanic__":"64.9","White____":"13.9","African_Am":"3.2","Native_Ame":"0.2","Asian_Amer":"16.7","Other____":"1.1","Shape_Leng":5332.17788821,"Shape_Area":1461599.9566}},{"arcs":[[-430,2126,-2122,-1228,2127,2128,-529,-471]],"type":"Polygon","properties":{"Tract_1":6037551900,"Percentile":"86-90%","Population":5344,"County":"Los Angeles","ZIP":90650,"City":"Norwalk","CIscore":47.95,"CIscoreP":"87","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":26.92,"DPM_pctl":80,"DrinkingWa":482.57,"DW_pctl":"51","Pesticides":1.35,"Pest_pctl":41,"Tox_Releas":5441.04,"TR_pctl":82,"Traffic":2337.24,"Traff_Pctl":"94","Cleanups":7,"Clean_Pctl":52,"Groundwate":3,"GW_pctl":22,"Haz_Waste":0.06,"Haz_pctl":28,"Imp__Water":3,"IWB_pctl":41,"Solid_Wast":0.5,"Solid_pctl":20,"PollutionS":6.87,"Poll_pctl":85,"Asthma":62.88,"Asthma_Pct":72,"Low_Birth_":5.27,"LBW_pctl":"60","Cardiovasc":13.42,"CVD_pctl":94,"Education":23.4,"Edu_pctl":"68","Linguistic":15.6,"Ling_pctl":"76","Poverty":35.1,"Pov_pctl":"53","Unemployme":9.2,"Unem_pctl":"49","Housing_Bu":17.9,"HB_pctl":"50","PopCharSco":6.98,"Pop_Pctl":"76","Children__":13.1,"Pop_11_64_":75.8,"Elderly___":11.1,"Hispanic__":"65.8","White____":"16.2","African_Am":"6.6","Native_Ame":"0.3","Asian_Amer":"10.1","Other____":"1.1","Shape_Leng":5290.89541367,"Shape_Area":1570587.65333}},{"arcs":[[2129,-272,2130,2131,-1852,2132]],"type":"Polygon","properties":{"Tract_1":6037553902,"Percentile":"91-95%","Population":5809,"County":"Los Angeles","ZIP":90723,"City":"Paramount","CIscore":51.76,"CIscoreP":"91","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":21.73,"DPM_pctl":66,"DrinkingWa":665.89,"DW_pctl":"79","Pesticides":0,"Pest_pctl":0,"Tox_Releas":10607.91,"TR_pctl":94,"Traffic":537.86,"Traff_Pctl":"35","Cleanups":2.4,"Clean_Pctl":29,"Groundwate":43.25,"GW_pctl":89,"Haz_Waste":0.48,"Haz_pctl":75,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":4.25,"Solid_pctl":69,"PollutionS":6.8,"Poll_pctl":84,"Asthma":53.36,"Asthma_Pct":61,"Low_Birth_":6.48,"LBW_pctl":"85","Cardiovasc":9.65,"CVD_pctl":71,"Education":32.9,"Edu_pctl":"80","Linguistic":12.7,"Ling_pctl":"68","Poverty":52.3,"Pov_pctl":"76","Unemployme":11.5,"Unem_pctl":"67","Housing_Bu":27.5,"HB_pctl":"83","PopCharSco":7.61,"Pop_Pctl":"85","Children__":17.3,"Pop_11_64_":77.1,"Elderly___":5.6,"Hispanic__":"76.7","White____":"8.7","African_Am":"8.9","Native_Ame":"0.2","Asian_Amer":"4.6","Other____":"0.9","Shape_Leng":4488.66346177,"Shape_Area":1058189.32669}},{"arcs":[[2133,2134,2135,2136,2137,-1461,2138,2139,2140]],"type":"Polygon","properties":{"Tract_1":6037240900,"Percentile":"91-95%","Population":5620,"County":"Los Angeles","ZIP":90059,"City":"Los Angeles","CIscore":57.54,"CIscoreP":"95","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":24.77,"DPM_pctl":76,"DrinkingWa":664.07,"DW_pctl":"79","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5408.97,"TR_pctl":82,"Traffic":806.62,"Traff_Pctl":"57","Cleanups":0,"Clean_Pctl":0,"Groundwate":3,"GW_pctl":22,"Haz_Waste":0.02,"Haz_pctl":16,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":7,"Solid_pctl":83,"PollutionS":6.38,"Poll_pctl":77,"Asthma":80.9,"Asthma_Pct":86,"Low_Birth_":8.04,"LBW_pctl":"97","Cardiovasc":9.32,"CVD_pctl":67,"Education":46.7,"Edu_pctl":"92","Linguistic":21.4,"Ling_pctl":"86","Poverty":72.7,"Pov_pctl":"95","Unemployme":15.3,"Unem_pctl":"86","Housing_Bu":36.3,"HB_pctl":"96","PopCharSco":9.02,"Pop_Pctl":"98","Children__":19.7,"Pop_11_64_":74.7,"Elderly___":5.6,"Hispanic__":"73.9","White____":"0.3","African_Am":"24.8","Native_Ame":"0.1","Asian_Amer":"0.2","Other____":"0.7","Shape_Leng":4343.35433371,"Shape_Area":1070548.79105}},{"arcs":[[-2137,2141,-2135,2142,2143,-2140,2144,2145]],"type":"Polygon","properties":{"Tract_1":6037240800,"Percentile":"91-95%","Population":4377,"County":"Los Angeles","ZIP":90002,"City":"Los Angeles","CIscore":52.05,"CIscoreP":"91","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":24.77,"DPM_pctl":76,"DrinkingWa":664.07,"DW_pctl":"79","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5367.47,"TR_pctl":82,"Traffic":841.47,"Traff_Pctl":"60","Cleanups":0,"Clean_Pctl":0,"Groundwate":3,"GW_pctl":22,"Haz_Waste":0.02,"Haz_pctl":16,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":7.2,"Solid_pctl":83,"PollutionS":6.41,"Poll_pctl":77,"Asthma":58.49,"Asthma_Pct":67,"Low_Birth_":6.62,"LBW_pctl":"87","Cardiovasc":7.94,"CVD_pctl":50,"Education":36.6,"Edu_pctl":"84","Linguistic":15.6,"Ling_pctl":"76","Poverty":67.2,"Pov_pctl":"91","Unemployme":18.5,"Unem_pctl":"93","Housing_Bu":45.5,"HB_pctl":"99","PopCharSco":8.12,"Pop_Pctl":"91","Children__":18.2,"Pop_11_64_":76.5,"Elderly___":5.3,"Hispanic__":"63.4","White____":"0.8","African_Am":"34","Native_Ame":"0.3","Asian_Amer":"0.4","Other____":"1","Shape_Leng":4122.44417379,"Shape_Area":639562.409314}},{"arcs":[[2146,2147,2148,2149,-1467]],"type":"Polygon","properties":{"Tract_1":6037241110,"Percentile":"86-90%","Population":3074,"County":"Los Angeles","ZIP":90061,"City":"Los Angeles","CIscore":47.77,"CIscoreP":"87","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":24.76,"DPM_pctl":76,"DrinkingWa":664.07,"DW_pctl":"79","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5264.93,"TR_pctl":81,"Traffic":587.94,"Traff_Pctl":"40","Cleanups":0,"Clean_Pctl":0,"Groundwate":3,"GW_pctl":22,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":0.3,"Solid_pctl":11,"PollutionS":5.45,"Poll_pctl":57,"Asthma":86.19,"Asthma_Pct":88,"Low_Birth_":6.36,"LBW_pctl":"83","Cardiovasc":11.15,"CVD_pctl":84,"Education":50.6,"Edu_pctl":"94","Linguistic":14.5,"Ling_pctl":"73","Poverty":66.7,"Pov_pctl":"91","Unemployme":10.9,"Unem_pctl":"63","Housing_Bu":48,"HB_pctl":"100","PopCharSco":8.76,"Pop_Pctl":"97","Children__":19.5,"Pop_11_64_":75.4,"Elderly___":5.1,"Hispanic__":"70.1","White____":"0.6","African_Am":"28.2","Native_Ame":"0","Asian_Amer":"0.1","Other____":"1","Shape_Leng":3209.28838325,"Shape_Area":486618.111369}},{"arcs":[[2150,2151,2152]],"type":"Polygon","properties":{"Tract_1":6037241300,"Percentile":"91-95%","Population":2313,"County":"Los Angeles","ZIP":90044,"City":"Los Angeles","CIscore":53.51,"CIscoreP":"92","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":27.84,"DPM_pctl":82,"DrinkingWa":664.07,"DW_pctl":"79","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5143.43,"TR_pctl":81,"Traffic":4220.05,"Traff_Pctl":"100","Cleanups":1.9,"Clean_Pctl":25,"Groundwate":0.5,"GW_pctl":3,"Haz_Waste":0.01,"Haz_pctl":9,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":3.2,"Solid_pctl":63,"PollutionS":6.24,"Poll_pctl":74,"Asthma":93.68,"Asthma_Pct":91,"Low_Birth_":7.94,"LBW_pctl":"96","Cardiovasc":10.17,"CVD_pctl":76,"Education":31.3,"Edu_pctl":"78","Linguistic":17.2,"Ling_pctl":"79","Poverty":53.1,"Pov_pctl":"77","Unemployme":10.3,"Unem_pctl":"58","Housing_Bu":36.5,"HB_pctl":"96","PopCharSco":8.58,"Pop_Pctl":"95","Children__":17.5,"Pop_11_64_":72.9,"Elderly___":9.6,"Hispanic__":"51.7","White____":"1","African_Am":"45.1","Native_Ame":"0.1","Asian_Amer":"0.4","Other____":"1.8","Shape_Leng":3034.38942307,"Shape_Area":522808.279669}},{"arcs":[[2153,2154,-2148,2155]],"type":"Polygon","properties":{"Tract_1":6037241120,"Percentile":"96-100%","Population":4564,"County":"Los Angeles","ZIP":90061,"City":"Los Angeles","CIscore":59.67,"CIscoreP":"96","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":24.76,"DPM_pctl":76,"DrinkingWa":664.07,"DW_pctl":"79","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5162.4,"TR_pctl":81,"Traffic":3617.7,"Traff_Pctl":"99","Cleanups":0,"Clean_Pctl":0,"Groundwate":3,"GW_pctl":22,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":0.7,"Solid_pctl":23,"PollutionS":6.23,"Poll_pctl":74,"Asthma":92.97,"Asthma_Pct":90,"Low_Birth_":8.92,"LBW_pctl":"99","Cardiovasc":12.03,"CVD_pctl":89,"Education":43.8,"Edu_pctl":"90","Linguistic":17.9,"Ling_pctl":"81","Poverty":71.9,"Pov_pctl":"94","Unemployme":19.9,"Unem_pctl":"95","Housing_Bu":47,"HB_pctl":"100","PopCharSco":9.57,"Pop_Pctl":"100","Children__":19.4,"Pop_11_64_":75.5,"Elderly___":5.1,"Hispanic__":"65.1","White____":"0.7","African_Am":"32.3","Native_Ame":"0.4","Asian_Amer":"0.4","Other____":"1.2","Shape_Leng":3535.73317103,"Shape_Area":661132.328153}},{"arcs":[[-1459,2156,-1808,2157,-1806,2158,2159]],"type":"Polygon","properties":{"Tract_1":6037241400,"Percentile":"91-95%","Population":3285,"County":"Los Angeles","ZIP":90061,"City":"Los Angeles","CIscore":56.47,"CIscoreP":"94","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":27.84,"DPM_pctl":82,"DrinkingWa":676.29,"DW_pctl":"80","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5321.76,"TR_pctl":82,"Traffic":4008.29,"Traff_Pctl":"99","Cleanups":2.25,"Clean_Pctl":29,"Groundwate":1.5,"GW_pctl":9,"Haz_Waste":0.01,"Haz_pctl":9,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":1,"Solid_pctl":33,"PollutionS":6.1,"Poll_pctl":71,"Asthma":104.45,"Asthma_Pct":94,"Low_Birth_":7.28,"LBW_pctl":"93","Cardiovasc":13.23,"CVD_pctl":94,"Education":41.1,"Edu_pctl":"88","Linguistic":19.7,"Ling_pctl":"84","Poverty":75.9,"Pov_pctl":"97","Unemployme":10.3,"Unem_pctl":"58","Housing_Bu":46,"HB_pctl":"99","PopCharSco":9.26,"Pop_Pctl":"99","Children__":19.2,"Pop_11_64_":74.9,"Elderly___":5.9,"Hispanic__":"62.7","White____":"0.5","African_Am":"34.9","Native_Ame":"0.1","Asian_Amer":"0.5","Other____":"1.4","Shape_Leng":3354.02178595,"Shape_Area":570187.235123}},{"arcs":[[2160,2161,2162]],"type":"Polygon","properties":{"Tract_1":6037242000,"Percentile":"91-95%","Population":3938,"County":"Los Angeles","ZIP":90002,"City":"Los Angeles","CIscore":54.46,"CIscoreP":"93","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":25.04,"DPM_pctl":76,"DrinkingWa":656.22,"DW_pctl":"74","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5564.57,"TR_pctl":83,"Traffic":884.23,"Traff_Pctl":"62","Cleanups":0,"Clean_Pctl":0,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.05,"Haz_pctl":26,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":7,"Solid_pctl":83,"PollutionS":6.3,"Poll_pctl":75,"Asthma":68.42,"Asthma_Pct":77,"Low_Birth_":8.53,"LBW_pctl":"98","Cardiovasc":8.81,"CVD_pctl":61,"Education":44.3,"Edu_pctl":"91","Linguistic":20.3,"Ling_pctl":"85","Poverty":68.1,"Pov_pctl":"92","Unemployme":16.7,"Unem_pctl":"90","Housing_Bu":27.5,"HB_pctl":"83","PopCharSco":8.64,"Pop_Pctl":"96","Children__":20.8,"Pop_11_64_":73,"Elderly___":6.2,"Hispanic__":"65.2","White____":"0.7","African_Am":"33","Native_Ame":"0.2","Asian_Amer":"0.4","Other____":"0.6","Shape_Leng":3208.3860269,"Shape_Area":645040.215847}},{"arcs":[[2163,-853,2164,2165,2166]],"type":"Polygon","properties":{"Tract_1":6037504001,"Percentile":"36-40%","Population":5709,"County":"Los Angeles","ZIP":90638,"City":"La Mirada","CIscore":20.26,"CIscoreP":"39","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":23.95,"DPM_pctl":73,"DrinkingWa":201.73,"DW_pctl":"15","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5662.89,"TR_pctl":83,"Traffic":584.28,"Traff_Pctl":"40","Cleanups":1,"Clean_Pctl":18,"Groundwate":8.5,"GW_pctl":44,"Haz_Waste":0.15,"Haz_pctl":54,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.3,"Solid_pctl":11,"PollutionS":4.96,"Poll_pctl":45,"Asthma":22.24,"Asthma_Pct":11,"Low_Birth_":5.86,"LBW_pctl":"74","Cardiovasc":6.15,"CVD_pctl":26,"Education":4.8,"Edu_pctl":"19","Linguistic":7.4,"Ling_pctl":"48","Poverty":22.4,"Pov_pctl":"31","Unemployme":9.9,"Unem_pctl":"55","Housing_Bu":19.3,"HB_pctl":"56","PopCharSco":4.09,"Pop_Pctl":"34","Children__":6.1,"Pop_11_64_":82.5,"Elderly___":11.4,"Hispanic__":"28.5","White____":"52.9","African_Am":"3.6","Native_Ame":"0.2","Asian_Amer":"11.3","Other____":"3.4","Shape_Leng":5510.99413715,"Shape_Area":1384547.27955}},{"arcs":[[2167,-1827,2168,-455,2169,2170,-1581,2171]],"type":"Polygon","properties":{"Tract_1":6037503701,"Percentile":"41-45%","Population":4717,"County":"Los Angeles","ZIP":90604,"City":"Whittier","CIscore":22.44,"CIscoreP":"44","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":10.79,"DPM_pctl":31,"DrinkingWa":518.17,"DW_pctl":"55","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5807.03,"TR_pctl":84,"Traffic":482.51,"Traff_Pctl":"29","Cleanups":4.5,"Clean_Pctl":42,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.08,"Poll_pctl":27,"Asthma":59.53,"Asthma_Pct":69,"Low_Birth_":4.42,"LBW_pctl":"36","Cardiovasc":12.94,"CVD_pctl":93,"Education":11.2,"Edu_pctl":"43","Linguistic":6.9,"Ling_pctl":"46","Poverty":25.7,"Pov_pctl":"37","Unemployme":7.7,"Unem_pctl":"36","Housing_Bu":15.8,"HB_pctl":"39","PopCharSco":5.51,"Pop_Pctl":"54","Children__":13,"Pop_11_64_":74.4,"Elderly___":12.6,"Hispanic__":"51.7","White____":"39.5","African_Am":"1.7","Native_Ame":"0.3","Asian_Amer":"4.9","Other____":"1.9","Shape_Leng":4751.60755626,"Shape_Area":1153625.14972}},{"arcs":[[2172,2173,2174,-159,2175,-460]],"type":"Polygon","properties":{"Tract_1":6037543322,"Percentile":"81-85%","Population":6611,"County":"Los Angeles","ZIP":90746,"City":"Carson","CIscore":44.82,"CIscoreP":"83","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":27.15,"DPM_pctl":80,"DrinkingWa":182.06,"DW_pctl":"14","Pesticides":0,"Pest_pctl":0,"Tox_Releas":7601.1,"TR_pctl":89,"Traffic":511.58,"Traff_Pctl":"32","Cleanups":18.45,"Clean_Pctl":82,"Groundwate":28,"GW_pctl":80,"Haz_Waste":0.16,"Haz_pctl":55,"Imp__Water":14,"IWB_pctl":94,"Solid_Wast":1.9,"Solid_pctl":41,"PollutionS":6.76,"Poll_pctl":83,"Asthma":84.92,"Asthma_Pct":87,"Low_Birth_":9.18,"LBW_pctl":"99","Cardiovasc":8.75,"CVD_pctl":60,"Education":11,"Edu_pctl":"42","Linguistic":1.2,"Ling_pctl":"7","Poverty":20.2,"Pov_pctl":"27","Unemployme":16.5,"Unem_pctl":"89","Housing_Bu":20.8,"HB_pctl":"62","PopCharSco":6.63,"Pop_Pctl":"71","Children__":9.9,"Pop_11_64_":71.5,"Elderly___":18.6,"Hispanic__":"9.6","White____":"3.1","African_Am":"76","Native_Ame":"0.1","Asian_Amer":"8","Other____":"3.2","Shape_Leng":5580.15953534,"Shape_Area":1965999.13019}},{"arcs":[[2176,-2024,2177,-2050,2178,2179,2180]],"type":"Polygon","properties":{"Tract_1":6037543602,"Percentile":"61-65%","Population":7762,"County":"Los Angeles","ZIP":90502,"City":"Torrance","CIscore":31.78,"CIscoreP":"63","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":21.58,"DPM_pctl":66,"DrinkingWa":181.98,"DW_pctl":"14","Pesticides":13.088,"Pest_pctl":61,"Tox_Releas":7972.86,"TR_pctl":90,"Traffic":1453.11,"Traff_Pctl":"82","Cleanups":8.9,"Clean_Pctl":57,"Groundwate":9,"GW_pctl":46,"Haz_Waste":2.35,"Haz_pctl":93,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.5,"Solid_pctl":20,"PollutionS":6.63,"Poll_pctl":81,"Asthma":35.31,"Asthma_Pct":34,"Low_Birth_":4.9,"LBW_pctl":"50","Cardiovasc":5.66,"CVD_pctl":20,"Education":13.7,"Edu_pctl":"49","Linguistic":18,"Ling_pctl":"81","Poverty":31.4,"Pov_pctl":"47","Unemployme":12.8,"Unem_pctl":"75","Housing_Bu":15.6,"HB_pctl":"38","PopCharSco":4.8,"Pop_Pctl":"45","Children__":11.4,"Pop_11_64_":73.1,"Elderly___":15.5,"Hispanic__":"31.9","White____":"20.8","African_Am":"8","Native_Ame":"0.5","Asian_Amer":"35.6","Other____":"3.2","Shape_Leng":5243.77271365,"Shape_Area":1616868.28569}},{"arcs":[[-1626,2181,2182,2183,2184,2185]],"type":"Polygon","properties":{"Tract_1":6037543801,"Percentile":"96-100%","Population":5263,"County":"Los Angeles","ZIP":90745,"City":"Carson","CIscore":59.43,"CIscoreP":"96","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":23.92,"DPM_pctl":73,"DrinkingWa":182.06,"DW_pctl":"14","Pesticides":0.064,"Pest_pctl":17,"Tox_Releas":7538.74,"TR_pctl":89,"Traffic":2376.9,"Traff_Pctl":"94","Cleanups":116.3,"Clean_Pctl":100,"Groundwate":53,"GW_pctl":92,"Haz_Waste":0.28,"Haz_pctl":68,"Imp__Water":14,"IWB_pctl":94,"Solid_Wast":45.5,"Solid_pctl":100,"PollutionS":8.43,"Poll_pctl":98,"Asthma":60.31,"Asthma_Pct":70,"Low_Birth_":8.86,"LBW_pctl":"99","Cardiovasc":9.96,"CVD_pctl":74,"Education":21.8,"Edu_pctl":"65","Linguistic":13.2,"Ling_pctl":"70","Poverty":30.4,"Pov_pctl":"46","Unemployme":16.5,"Unem_pctl":"89","Housing_Bu":7.5,"HB_pctl":"6","PopCharSco":7.05,"Pop_Pctl":"77","Children__":11,"Pop_11_64_":73.6,"Elderly___":15.4,"Hispanic__":"45.4","White____":"10.9","African_Am":"4.8","Native_Ame":"0.3","Asian_Amer":"35.5","Other____":"3","Shape_Leng":6837.35232052,"Shape_Area":2197977.52532}},{"arcs":[[2186,-2185,2187,2188]],"type":"Polygon","properties":{"Tract_1":6037543802,"Percentile":"86-90%","Population":7126,"County":"Los Angeles","ZIP":90745,"City":"Carson","CIscore":48.39,"CIscoreP":"87","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":23.92,"DPM_pctl":73,"DrinkingWa":182.06,"DW_pctl":"14","Pesticides":0,"Pest_pctl":0,"Tox_Releas":7557,"TR_pctl":89,"Traffic":596.63,"Traff_Pctl":"41","Cleanups":26.25,"Clean_Pctl":88,"Groundwate":32.1,"GW_pctl":83,"Haz_Waste":0.26,"Haz_pctl":67,"Imp__Water":14,"IWB_pctl":94,"Solid_Wast":7.8,"Solid_pctl":85,"PollutionS":7.16,"Poll_pctl":89,"Asthma":60.31,"Asthma_Pct":70,"Low_Birth_":8.5,"LBW_pctl":"98","Cardiovasc":9.96,"CVD_pctl":74,"Education":17.2,"Edu_pctl":"57","Linguistic":15.9,"Ling_pctl":"77","Poverty":32,"Pov_pctl":"48","Unemployme":6.6,"Unem_pctl":"25","Housing_Bu":16.2,"HB_pctl":"41","PopCharSco":6.76,"Pop_Pctl":"73","Children__":11.8,"Pop_11_64_":73.2,"Elderly___":15,"Hispanic__":"33.1","White____":"7.2","African_Am":"8.2","Native_Ame":"0.1","Asian_Amer":"48.5","Other____":"2.9","Shape_Leng":4978.12315538,"Shape_Area":1357584.0127}},{"arcs":[[2189,2190,2191,2192,2193,-1810,2194,-673]],"type":"Polygon","properties":{"Tract_1":6037541300,"Percentile":"91-95%","Population":6044,"County":"Los Angeles","ZIP":90222,"City":"Compton","CIscore":52.25,"CIscoreP":"91","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":18.7,"DPM_pctl":58,"DrinkingWa":424.4,"DW_pctl":"44","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5838.5,"TR_pctl":84,"Traffic":523.82,"Traff_Pctl":"33","Cleanups":10.25,"Clean_Pctl":63,"Groundwate":9.5,"GW_pctl":47,"Haz_Waste":0.12,"Haz_pctl":49,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.83,"Poll_pctl":65,"Asthma":102.03,"Asthma_Pct":93,"Low_Birth_":7.92,"LBW_pctl":"96","Cardiovasc":12,"CVD_pctl":89,"Education":37.4,"Edu_pctl":"84","Linguistic":12.2,"Ling_pctl":"67","Poverty":64,"Pov_pctl":"88","Unemployme":14.4,"Unem_pctl":"82","Housing_Bu":25.9,"HB_pctl":"79","PopCharSco":8.96,"Pop_Pctl":"98","Children__":17.6,"Pop_11_64_":74.2,"Elderly___":8.2,"Hispanic__":"58.6","White____":"0.8","African_Am":"38.8","Native_Ame":"0.2","Asian_Amer":"0.5","Other____":"1.1","Shape_Leng":4955.27876926,"Shape_Area":1352389.08214}},{"arcs":[[2195,-1812,2196,-2193,2197,2198,2199,2200]],"type":"Polygon","properties":{"Tract_1":6037541200,"Percentile":"91-95%","Population":5662,"County":"Los Angeles","ZIP":90222,"City":"Compton","CIscore":56.54,"CIscoreP":"94","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":22.33,"DPM_pctl":68,"DrinkingWa":514.08,"DW_pctl":"55","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5901.16,"TR_pctl":84,"Traffic":738.39,"Traff_Pctl":"53","Cleanups":19.5,"Clean_Pctl":83,"Groundwate":39.55,"GW_pctl":88,"Haz_Waste":0.33,"Haz_pctl":70,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":5.5,"Solid_pctl":76,"PollutionS":7.6,"Poll_pctl":93,"Asthma":95.09,"Asthma_Pct":91,"Low_Birth_":6.08,"LBW_pctl":"78","Cardiovasc":10.93,"CVD_pctl":82,"Education":21.3,"Edu_pctl":"64","Linguistic":5.6,"Ling_pctl":"40","Poverty":41.3,"Pov_pctl":"61","Unemployme":11.1,"Unem_pctl":"64","Housing_Bu":22.5,"HB_pctl":"69","PopCharSco":7.44,"Pop_Pctl":"82","Children__":13.6,"Pop_11_64_":71.1,"Elderly___":15.3,"Hispanic__":"29.3","White____":"0.7","African_Am":"68.1","Native_Ame":"0.2","Asian_Amer":"0.4","Other____":"1.3","Shape_Leng":7006.7579869,"Shape_Area":2141951.60933}},{"arcs":[[-1823,-1973,2201,-773,2202,2203,2204]],"type":"Polygon","properties":{"Tract_1":6037541604,"Percentile":"96-100%","Population":6207,"County":"Los Angeles","ZIP":90221,"City":"Compton","CIscore":63.96,"CIscoreP":"98","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":22.23,"DPM_pctl":67,"DrinkingWa":479.04,"DW_pctl":"49","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5974.85,"TR_pctl":85,"Traffic":706.2,"Traff_Pctl":"51","Cleanups":4.8,"Clean_Pctl":43,"Groundwate":38.05,"GW_pctl":87,"Haz_Waste":5.66,"Haz_pctl":97,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":5.7,"Solid_pctl":76,"PollutionS":6.88,"Poll_pctl":85,"Asthma":79.9,"Asthma_Pct":85,"Low_Birth_":6.38,"LBW_pctl":"83","Cardiovasc":12.39,"CVD_pctl":91,"Education":56.3,"Edu_pctl":"97","Linguistic":16.9,"Ling_pctl":"79","Poverty":77.5,"Pov_pctl":"98","Unemployme":18.4,"Unem_pctl":"93","Housing_Bu":42,"HB_pctl":"99","PopCharSco":9.3,"Pop_Pctl":"99","Children__":21.5,"Pop_11_64_":74.2,"Elderly___":4.3,"Hispanic__":"81.4","White____":"0.6","African_Am":"16.7","Native_Ame":"0.2","Asian_Amer":"0.3","Other____":"0.7","Shape_Leng":3712.41887333,"Shape_Area":833608.307599}},{"arcs":[[2205,2206,2207,-207]],"type":"Polygon","properties":{"Tract_1":6037620521,"Percentile":"31-35%","Population":4097,"County":"Los Angeles","ZIP":90278,"City":"Redondo Beach","CIscore":17.18,"CIscoreP":"31","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":20.89,"DPM_pctl":64,"DrinkingWa":305.77,"DW_pctl":"33","Pesticides":0,"Pest_pctl":0,"Tox_Releas":7423.99,"TR_pctl":89,"Traffic":727.16,"Traff_Pctl":"52","Cleanups":2,"Clean_Pctl":27,"Groundwate":0.3,"GW_pctl":2,"Haz_Waste":0.01,"Haz_pctl":9,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.54,"Poll_pctl":37,"Asthma":31.51,"Asthma_Pct":28,"Low_Birth_":5.4,"LBW_pctl":"63","Cardiovasc":6.08,"CVD_pctl":25,"Education":7.3,"Edu_pctl":"29","Linguistic":7.4,"Ling_pctl":"48","Poverty":16.8,"Pov_pctl":"20","Unemployme":4.5,"Unem_pctl":"9","Housing_Bu":21.4,"HB_pctl":"65","PopCharSco":3.78,"Pop_Pctl":"29","Children__":13.6,"Pop_11_64_":79.7,"Elderly___":6.7,"Hispanic__":"23.1","White____":"53.6","African_Am":"5.4","Native_Ame":"0.1","Asian_Amer":"12.2","Other____":"5.5","Shape_Leng":3209.50907393,"Shape_Area":643802.147749}},{"arcs":[[2208,2209,-2207,2210]],"type":"Polygon","properties":{"Tract_1":6037620522,"Percentile":"16-20%","Population":4632,"County":"Los Angeles","ZIP":90278,"City":"Redondo Beach","CIscore":11.11,"CIscoreP":"15","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":20.89,"DPM_pctl":64,"DrinkingWa":236.44,"DW_pctl":"23","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6181.85,"TR_pctl":86,"Traffic":682.16,"Traff_Pctl":"49","Cleanups":4,"Clean_Pctl":39,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.02,"Haz_pctl":16,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.48,"Poll_pctl":36,"Asthma":24.33,"Asthma_Pct":15,"Low_Birth_":3.09,"LBW_pctl":"10","Cardiovasc":5.05,"CVD_pctl":13,"Education":7.1,"Edu_pctl":"28","Linguistic":6,"Ling_pctl":"42","Poverty":17.3,"Pov_pctl":"21","Unemployme":10.7,"Unem_pctl":"61","Housing_Bu":12.4,"HB_pctl":"23","PopCharSco":2.48,"Pop_Pctl":"12","Children__":13.9,"Pop_11_64_":77.7,"Elderly___":8.4,"Hispanic__":"15.9","White____":"60.6","African_Am":"3","Native_Ame":"0.3","Asian_Amer":"15.2","Other____":"5.1","Shape_Leng":3459.21562463,"Shape_Area":748351.05196}},{"arcs":[[2211,2212,2213,2214]],"type":"Polygon","properties":{"Tract_1":6037620701,"Percentile":"26-30%","Population":6704,"County":"Los Angeles","ZIP":90278,"City":"Redondo Beach","CIscore":15.84,"CIscoreP":"27","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":20.18,"DPM_pctl":62,"DrinkingWa":236.61,"DW_pctl":"23","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6261.38,"TR_pctl":86,"Traffic":613.75,"Traff_Pctl":"43","Cleanups":4,"Clean_Pctl":39,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.1,"Haz_pctl":43,"Imp__Water":5,"IWB_pctl":55,"Solid_Wast":0.5,"Solid_pctl":20,"PollutionS":5.24,"Poll_pctl":52,"Asthma":31.92,"Asthma_Pct":29,"Low_Birth_":3.6,"LBW_pctl":"18","Cardiovasc":6.41,"CVD_pctl":29,"Education":5.7,"Edu_pctl":"23","Linguistic":3.8,"Ling_pctl":"29","Poverty":14.7,"Pov_pctl":"16","Unemployme":9.4,"Unem_pctl":"51","Housing_Bu":17.2,"HB_pctl":"46","PopCharSco":3.02,"Pop_Pctl":"19","Children__":12.8,"Pop_11_64_":77.7,"Elderly___":9.5,"Hispanic__":"14.8","White____":"64.3","African_Am":"2.3","Native_Ame":"0.4","Asian_Amer":"12.8","Other____":"5.5","Shape_Leng":4638.48319375,"Shape_Area":1016222.86005}},{"arcs":[[2215,2216,2217,2218,2219,2220]],"type":"Polygon","properties":{"Tract_1":6037620602,"Percentile":"16-20%","Population":5376,"County":"Los Angeles","ZIP":90278,"City":"Redondo Beach","CIscore":12.3,"CIscoreP":"18","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":20.89,"DPM_pctl":64,"DrinkingWa":236.89,"DW_pctl":"23","Pesticides":0,"Pest_pctl":0,"Tox_Releas":16405.86,"TR_pctl":97,"Traffic":695.55,"Traff_Pctl":"50","Cleanups":10,"Clean_Pctl":63,"Groundwate":10.75,"GW_pctl":51,"Haz_Waste":0.1,"Haz_pctl":32,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":2,"Solid_pctl":50,"PollutionS":5.8,"Poll_pctl":64,"Asthma":23.98,"Asthma_Pct":14,"Low_Birth_":4.65,"LBW_pctl":"43","Cardiovasc":4.82,"CVD_pctl":11,"Education":6.9,"Edu_pctl":"28","Linguistic":4.5,"Ling_pctl":"33","Poverty":12.2,"Pov_pctl":"11","Unemployme":4.2,"Unem_pctl":"8","Housing_Bu":10,"HB_pctl":"12","PopCharSco":2.12,"Pop_Pctl":"9","Children__":12.1,"Pop_11_64_":76.9,"Elderly___":11,"Hispanic__":"20.2","White____":"61.5","African_Am":"2.1","Native_Ame":"0.3","Asian_Amer":"12.1","Other____":"3.9","Shape_Leng":5702.55071328,"Shape_Area":1350667.7055}},{"arcs":[[2221,-140,2222,-143]],"type":"Polygon","properties":{"Tract_1":6037621002,"Percentile":"1-5%","Population":1093,"County":"Los Angeles","ZIP":90254,"City":"Hermosa Beach","CIscore":2.8,"CIscoreP":"1","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":8.3,"DPM_pctl":23,"DrinkingWa":236.39,"DW_pctl":"23","Pesticides":0,"Pest_pctl":0,"Tox_Releas":4010.23,"TR_pctl":77,"Traffic":249.34,"Traff_Pctl":"8","Cleanups":0,"Clean_Pctl":0,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":3.5,"Poll_pctl":16,"Asthma":12.6,"Asthma_Pct":2,"Low_Birth_":3.33,"LBW_pctl":"14","Cardiovasc":5.4,"CVD_pctl":17,"Education":0.9,"Edu_pctl":"1","Linguistic":0,"Ling_pctl":"NA","Poverty":13,"Pov_pctl":"12","Unemployme":2.8,"Unem_pctl":"2","Housing_Bu":2.4,"HB_pctl":"0","PopCharSco":0.8,"Pop_Pctl":"1","Children__":7.5,"Pop_11_64_":80.4,"Elderly___":12.1,"Hispanic__":"6.9","White____":"84.7","African_Am":"1.4","Native_Ame":"0.2","Asian_Amer":"3.2","Other____":"3.7","Shape_Leng":4670.41490897,"Shape_Area":328356.056771}},{"arcs":[[2223,-2221,-2215,2224,-210,2225,2226,2227]],"type":"Polygon","properties":{"Tract_1":6037620601,"Percentile":"31-35%","Population":5523,"County":"Los Angeles","ZIP":90278,"City":"Redondo Beach","CIscore":17.65,"CIscoreP":"32","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":20.89,"DPM_pctl":64,"DrinkingWa":306.03,"DW_pctl":"33","Pesticides":0,"Pest_pctl":0,"Tox_Releas":10869.21,"TR_pctl":94,"Traffic":742.98,"Traff_Pctl":"53","Cleanups":3,"Clean_Pctl":33,"Groundwate":1.5,"GW_pctl":9,"Haz_Waste":0.1,"Haz_pctl":43,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.4,"Solid_pctl":12,"PollutionS":5.1,"Poll_pctl":49,"Asthma":33.1,"Asthma_Pct":30,"Low_Birth_":4.75,"LBW_pctl":"45","Cardiovasc":6.6,"CVD_pctl":32,"Education":3.9,"Edu_pctl":"14","Linguistic":3,"Ling_pctl":"23","Poverty":17.5,"Pov_pctl":"21","Unemployme":9.4,"Unem_pctl":"51","Housing_Bu":17,"HB_pctl":"45","PopCharSco":3.46,"Pop_Pctl":"24","Children__":12.2,"Pop_11_64_":79.5,"Elderly___":8.3,"Hispanic__":"21.7","White____":"53.6","African_Am":"4.5","Native_Ame":"0.3","Asian_Amer":"15","Other____":"4.8","Shape_Leng":6104.74974811,"Shape_Area":1365118.66309}},{"arcs":[[2228,2229,2230,2231,2232,-138,2233,2234,-2213]],"type":"Polygon","properties":{"Tract_1":6037621001,"Percentile":"1-5%","Population":4119,"County":"Los Angeles","ZIP":90254,"City":"Hermosa Beach","CIscore":6,"CIscoreP":"5","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":9.16,"DPM_pctl":26,"DrinkingWa":236.34,"DW_pctl":"23","Pesticides":0,"Pest_pctl":0,"Tox_Releas":4820.59,"TR_pctl":80,"Traffic":716.64,"Traff_Pctl":"51","Cleanups":0,"Clean_Pctl":0,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.05,"Haz_pctl":26,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":4.35,"Poll_pctl":33,"Asthma":12.53,"Asthma_Pct":2,"Low_Birth_":4.83,"LBW_pctl":"48","Cardiovasc":4.99,"CVD_pctl":12,"Education":0.1,"Edu_pctl":"0","Linguistic":0.4,"Ling_pctl":"1","Poverty":6.7,"Pov_pctl":"3","Unemployme":4.2,"Unem_pctl":"8","Housing_Bu":11.6,"HB_pctl":"19","PopCharSco":1.38,"Pop_Pctl":"3","Children__":10.4,"Pop_11_64_":76.7,"Elderly___":12.9,"Hispanic__":"8","White____":"78.7","African_Am":"1.1","Native_Ame":"0","Asian_Amer":"7.5","Other____":"4.7","Shape_Leng":4857.72735674,"Shape_Area":932427.315462}},{"arcs":[[2235,2236,2237]],"type":"Polygon","properties":{"Tract_1":6037620501,"Percentile":"16-20%","Population":5390,"County":"Los Angeles","ZIP":90278,"City":"Redondo Beach","CIscore":12.3,"CIscoreP":"18","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":20.89,"DPM_pctl":64,"DrinkingWa":302.93,"DW_pctl":"32","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5487.87,"TR_pctl":82,"Traffic":1643.36,"Traff_Pctl":"86","Cleanups":5.5,"Clean_Pctl":46,"Groundwate":15,"GW_pctl":61,"Haz_Waste":0.25,"Haz_pctl":66,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":2,"Solid_pctl":50,"PollutionS":6.37,"Poll_pctl":77,"Asthma":30.64,"Asthma_Pct":26,"Low_Birth_":3.59,"LBW_pctl":"18","Cardiovasc":6.05,"CVD_pctl":25,"Education":3.8,"Edu_pctl":"14","Linguistic":1.7,"Ling_pctl":"12","Poverty":14.5,"Pov_pctl":"15","Unemployme":5.6,"Unem_pctl":"17","Housing_Bu":10.2,"HB_pctl":"13","PopCharSco":1.93,"Pop_Pctl":"7","Children__":13,"Pop_11_64_":77.4,"Elderly___":9.6,"Hispanic__":"14.1","White____":"66.4","African_Am":"2.3","Native_Ame":"0.1","Asian_Amer":"12.3","Other____":"4.8","Shape_Leng":6446.67309221,"Shape_Area":2597460.27003}},{"arcs":[[2238,2239,2240,-2231,2241,-2229,2242]],"type":"Polygon","properties":{"Tract_1":6037621102,"Percentile":"1-5%","Population":2883,"County":"Los Angeles","ZIP":90254,"City":"Hermosa Beach","CIscore":5.15,"CIscoreP":"3","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":14.83,"DPM_pctl":45,"DrinkingWa":237.22,"DW_pctl":"24","Pesticides":0.094,"Pest_pctl":20,"Tox_Releas":6380.87,"TR_pctl":86,"Traffic":659.05,"Traff_Pctl":"47","Cleanups":3.5,"Clean_Pctl":35,"Groundwate":2.5,"GW_pctl":15,"Haz_Waste":0.01,"Haz_pctl":9,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":0.7,"Solid_pctl":23,"PollutionS":5.23,"Poll_pctl":52,"Asthma":12.46,"Asthma_Pct":2,"Low_Birth_":2.72,"LBW_pctl":"6","Cardiovasc":4.26,"CVD_pctl":6,"Education":1.7,"Edu_pctl":"4","Linguistic":0.7,"Ling_pctl":"3","Poverty":11.5,"Pov_pctl":"9","Unemployme":8.2,"Unem_pctl":"41","Housing_Bu":10.2,"HB_pctl":"13","PopCharSco":0.98,"Pop_Pctl":"1","Children__":13.7,"Pop_11_64_":78.2,"Elderly___":8.1,"Hispanic__":"9.8","White____":"78","African_Am":"0.8","Native_Ame":"0.2","Asian_Amer":"6.9","Other____":"4.3","Shape_Leng":3315.14918303,"Shape_Area":548601.921969}},{"arcs":[[-2220,2243,-580,2244,-2057,2245,2246,-2243,-2212]],"type":"Polygon","properties":{"Tract_1":6037620702,"Percentile":"11-15%","Population":7059,"County":"Los Angeles","ZIP":90278,"City":"Redondo Beach","CIscore":9.42,"CIscoreP":"12","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":20.68,"DPM_pctl":64,"DrinkingWa":237.22,"DW_pctl":"24","Pesticides":0.017,"Pest_pctl":10,"Tox_Releas":8422.15,"TR_pctl":91,"Traffic":440.12,"Traff_Pctl":"25","Cleanups":5.9,"Clean_Pctl":47,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.01,"Haz_pctl":9,"Imp__Water":5,"IWB_pctl":55,"Solid_Wast":4,"Solid_pctl":68,"PollutionS":5.41,"Poll_pctl":56,"Asthma":27.67,"Asthma_Pct":21,"Low_Birth_":3.03,"LBW_pctl":"9","Cardiovasc":5.69,"CVD_pctl":20,"Education":2.6,"Edu_pctl":"8","Linguistic":3.2,"Ling_pctl":"24","Poverty":11.3,"Pov_pctl":"9","Unemployme":4.9,"Unem_pctl":"12","Housing_Bu":14.2,"HB_pctl":"31","PopCharSco":1.74,"Pop_Pctl":"5","Children__":16,"Pop_11_64_":74.6,"Elderly___":9.4,"Hispanic__":"14.5","White____":"65.2","African_Am":"1.9","Native_Ame":"0.2","Asian_Amer":"12.9","Other____":"5.3","Shape_Leng":5173.81192654,"Shape_Area":1323288.2977}},{"arcs":[[2247,-131,-2055,2248]],"type":"Polygon","properties":{"Tract_1":6037621301,"Percentile":"16-20%","Population":6769,"County":"Los Angeles","ZIP":90277,"City":"Redondo Beach","CIscore":12.43,"CIscoreP":"19","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":15.61,"DPM_pctl":48,"DrinkingWa":237.22,"DW_pctl":"24","Pesticides":0,"Pest_pctl":0,"Tox_Releas":7776.53,"TR_pctl":90,"Traffic":728.51,"Traff_Pctl":"52","Cleanups":4,"Clean_Pctl":39,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.1,"Haz_pctl":43,"Imp__Water":8,"IWB_pctl":76,"Solid_Wast":0.5,"Solid_pctl":20,"PollutionS":5.4,"Poll_pctl":55,"Asthma":23.26,"Asthma_Pct":13,"Low_Birth_":4.02,"LBW_pctl":"27","Cardiovasc":6.3,"CVD_pctl":28,"Education":2.9,"Edu_pctl":"10","Linguistic":1.5,"Ling_pctl":"10","Poverty":10.8,"Pov_pctl":"8","Unemployme":7.1,"Unem_pctl":"30","Housing_Bu":18.5,"HB_pctl":"52","PopCharSco":2.3,"Pop_Pctl":"10","Children__":10.9,"Pop_11_64_":77.3,"Elderly___":11.8,"Hispanic__":"12.8","White____":"67.7","African_Am":"2.3","Native_Ame":"0.1","Asian_Amer":"12.5","Other____":"4.7","Shape_Leng":5291.5450109,"Shape_Area":1566344.29748}},{"arcs":[[2249,2250,-1887]],"type":"Polygon","properties":{"Tract_1":6037574700,"Percentile":"NA","Population":117,"County":"Los Angeles","ZIP":90815,"City":"Long Beach","CIscore":0,"CIscoreP":"NA","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":14.59,"DPM_pctl":44,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8000.43,"TR_pctl":90,"Traffic":800.47,"Traff_Pctl":"57","Cleanups":5,"Clean_Pctl":44,"Groundwate":3.75,"GW_pctl":25,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.7,"Solid_pctl":23,"PollutionS":4.37,"Poll_pctl":33,"Asthma":12.59,"Asthma_Pct":2,"Low_Birth_":0,"LBW_pctl":"NA","Cardiovasc":3.33,"CVD_pctl":2,"Education":0,"Edu_pctl":"NA","Linguistic":0,"Ling_pctl":"NA","Poverty":0,"Pov_pctl":"NA","Unemployme":0,"Unem_pctl":"NA","Housing_Bu":0,"HB_pctl":"NA","PopCharSco":0,"Pop_Pctl":"NA","Children__":0,"Pop_11_64_":53,"Elderly___":47,"Hispanic__":"10.3","White____":"53.8","African_Am":"30.8","Native_Ame":"0","Asian_Amer":"5.1","Other____":"0","Shape_Leng":2588.16274244,"Shape_Area":420540.301005}},{"arcs":[[2251,-1884,2252,-1157]],"type":"Polygon","properties":{"Tract_1":6037574602,"Percentile":"6-10%","Population":1277,"County":"Los Angeles","ZIP":90815,"City":"Long Beach","CIscore":8.22,"CIscoreP":"9","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":15.1,"DPM_pctl":46,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8084.43,"TR_pctl":90,"Traffic":841.55,"Traff_Pctl":"60","Cleanups":38.4,"Clean_Pctl":94,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.05,"Haz_pctl":26,"Imp__Water":15,"IWB_pctl":96,"Solid_Wast":2,"Solid_pctl":50,"PollutionS":5.84,"Poll_pctl":65,"Asthma":19.2,"Asthma_Pct":7,"Low_Birth_":0,"LBW_pctl":"NA","Cardiovasc":5.04,"CVD_pctl":13,"Education":4.3,"Edu_pctl":"16","Linguistic":2.9,"Ling_pctl":"22","Poverty":16.6,"Pov_pctl":"19","Unemployme":1.2,"Unem_pctl":"0","Housing_Bu":12.1,"HB_pctl":"22","PopCharSco":1.41,"Pop_Pctl":"3","Children__":6.6,"Pop_11_64_":57.2,"Elderly___":36.2,"Hispanic__":"8","White____":"67","African_Am":"4.5","Native_Ame":"0.4","Asian_Amer":"17.2","Other____":"3","Shape_Leng":3062.31002767,"Shape_Area":580230.572188}},{"arcs":[[2253,2254,2255,2256,2257,-1166]],"type":"Polygon","properties":{"Tract_1":6037574800,"Percentile":"31-35%","Population":3000,"County":"Los Angeles","ZIP":90815,"City":"Long Beach","CIscore":17.28,"CIscoreP":"31","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":21.02,"DPM_pctl":65,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":7763.48,"TR_pctl":90,"Traffic":762.94,"Traff_Pctl":"54","Cleanups":4,"Clean_Pctl":39,"Groundwate":9.75,"GW_pctl":48,"Haz_Waste":0.01,"Haz_pctl":9,"Imp__Water":9,"IWB_pctl":81,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.26,"Poll_pctl":52,"Asthma":28.86,"Asthma_Pct":23,"Low_Birth_":6.11,"LBW_pctl":"78","Cardiovasc":6.14,"CVD_pctl":26,"Education":1.7,"Edu_pctl":"4","Linguistic":1.2,"Ling_pctl":"7","Poverty":16.2,"Pov_pctl":"19","Unemployme":7.5,"Unem_pctl":"34","Housing_Bu":16.1,"HB_pctl":"40","PopCharSco":3.28,"Pop_Pctl":"22","Children__":7.5,"Pop_11_64_":75.8,"Elderly___":16.7,"Hispanic__":"12.2","White____":"67.7","African_Am":"3.8","Native_Ame":"0.2","Asian_Amer":"12.1","Other____":"3.9","Shape_Leng":4659.28772455,"Shape_Area":1099423.14945}},{"arcs":[[2258,-1553,2259,2260,-1170,2261,2262]],"type":"Polygon","properties":{"Tract_1":6037577603,"Percentile":"31-35%","Population":8255,"County":"Los Angeles","ZIP":90803,"City":"Long Beach","CIscore":17.34,"CIscoreP":"31","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":12.9,"DPM_pctl":38,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8480.35,"TR_pctl":91,"Traffic":864.79,"Traff_Pctl":"61","Cleanups":2,"Clean_Pctl":27,"Groundwate":16,"GW_pctl":64,"Haz_Waste":0.01,"Haz_pctl":9,"Imp__Water":10,"IWB_pctl":86,"Solid_Wast":4,"Solid_pctl":68,"PollutionS":5.68,"Poll_pctl":62,"Asthma":25.34,"Asthma_Pct":17,"Low_Birth_":5.47,"LBW_pctl":"65","Cardiovasc":5.24,"CVD_pctl":15,"Education":2,"Edu_pctl":"6","Linguistic":1.6,"Ling_pctl":"11","Poverty":18.8,"Pov_pctl":"24","Unemployme":6.5,"Unem_pctl":"25","Housing_Bu":22.2,"HB_pctl":"68","PopCharSco":3.05,"Pop_Pctl":"19","Children__":9.6,"Pop_11_64_":74,"Elderly___":16.4,"Hispanic__":"11.9","White____":"74.5","African_Am":"2.4","Native_Ame":"0.2","Asian_Amer":"7.2","Other____":"3.8","Shape_Leng":7409.10637099,"Shape_Area":2984572.94284}},{"arcs":[[2263,2264,2265,2266,-1758,-2261]],"type":"Polygon","properties":{"Tract_1":6037577400,"Percentile":"16-20%","Population":3253,"County":"Los Angeles","ZIP":90803,"City":"Long Beach","CIscore":10.95,"CIscoreP":"15","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":13.13,"DPM_pctl":39,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8671.13,"TR_pctl":92,"Traffic":582.96,"Traff_Pctl":"40","Cleanups":0,"Clean_Pctl":0,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":10,"IWB_pctl":86,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.07,"Poll_pctl":27,"Asthma":28.26,"Asthma_Pct":22,"Low_Birth_":3.65,"LBW_pctl":"19","Cardiovasc":7.63,"CVD_pctl":46,"Education":4.5,"Edu_pctl":"17","Linguistic":1.5,"Ling_pctl":"10","Poverty":18.7,"Pov_pctl":"24","Unemployme":4.9,"Unem_pctl":"12","Housing_Bu":18.5,"HB_pctl":"52","PopCharSco":2.69,"Pop_Pctl":"15","Children__":7.9,"Pop_11_64_":80.4,"Elderly___":11.7,"Hispanic__":"13.9","White____":"76.4","African_Am":"1.9","Native_Ame":"0.2","Asian_Amer":"4.9","Other____":"2.8","Shape_Leng":3612.76146306,"Shape_Area":643577.55593}},{"arcs":[[-740,2267,-738,-2263,2268,2269]],"type":"Polygon","properties":{"Tract_1":6037577602,"Percentile":"66-70%","Population":3441,"County":"Los Angeles","ZIP":90803,"City":"Long Beach","CIscore":33.35,"CIscoreP":"66","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":12.66,"DPM_pctl":38,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8502.09,"TR_pctl":91,"Traffic":856.11,"Traff_Pctl":"60","Cleanups":31.75,"Clean_Pctl":91,"Groundwate":14.5,"GW_pctl":59,"Haz_Waste":0.55,"Haz_pctl":79,"Imp__Water":16,"IWB_pctl":97,"Solid_Wast":10,"Solid_pctl":89,"PollutionS":7.01,"Poll_pctl":87,"Asthma":28.23,"Asthma_Pct":22,"Low_Birth_":6.52,"LBW_pctl":"85","Cardiovasc":7.62,"CVD_pctl":45,"Education":2.4,"Edu_pctl":"7","Linguistic":2.1,"Ling_pctl":"15","Poverty":19.5,"Pov_pctl":"26","Unemployme":15.3,"Unem_pctl":"86","Housing_Bu":23.3,"HB_pctl":"72","PopCharSco":4.76,"Pop_Pctl":"44","Children__":5.7,"Pop_11_64_":69.4,"Elderly___":24.9,"Hispanic__":"11.7","White____":"72.6","African_Am":"3.1","Native_Ame":"0.5","Asian_Amer":"9.5","Other____":"2.7","Shape_Leng":5261.81205194,"Shape_Area":1392405.08677}},{"arcs":[[2270,-1760,2271,-2266,2272,-74]],"type":"Polygon","properties":{"Tract_1":6037577300,"Percentile":"16-20%","Population":5547,"County":"Los Angeles","ZIP":90803,"City":"Long Beach","CIscore":11.8,"CIscoreP":"17","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":13.13,"DPM_pctl":39,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8753.13,"TR_pctl":92,"Traffic":593.28,"Traff_Pctl":"41","Cleanups":0,"Clean_Pctl":0,"Groundwate":6,"GW_pctl":36,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.2,"Poll_pctl":29,"Asthma":28.26,"Asthma_Pct":22,"Low_Birth_":2.63,"LBW_pctl":"6","Cardiovasc":7.63,"CVD_pctl":46,"Education":2.2,"Edu_pctl":"6","Linguistic":0.4,"Ling_pctl":"1","Poverty":23.6,"Pov_pctl":"34","Unemployme":8.8,"Unem_pctl":"46","Housing_Bu":20.7,"HB_pctl":"62","PopCharSco":2.81,"Pop_Pctl":"16","Children__":7.1,"Pop_11_64_":84.7,"Elderly___":8.2,"Hispanic__":"14.7","White____":"74.2","African_Am":"2.2","Native_Ame":"0.3","Asian_Amer":"5.5","Other____":"3.1","Shape_Leng":4006.03243474,"Shape_Area":899390.882146}},{"arcs":[[-826,2273,-657,2274,-661,2275,-1665,2276,2277,2278]],"type":"Polygon","properties":{"Tract_1":6037555202,"Percentile":"41-45%","Population":3399,"County":"Los Angeles","ZIP":90808,"City":"Long Beach","CIscore":22.01,"CIscoreP":"43","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":12.6,"DPM_pctl":37,"DrinkingWa":387.98,"DW_pctl":"41","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6189.4,"TR_pctl":86,"Traffic":1675.76,"Traff_Pctl":"86","Cleanups":0.5,"Clean_Pctl":8,"Groundwate":21.5,"GW_pctl":73,"Haz_Waste":0.1,"Haz_pctl":43,"Imp__Water":14,"IWB_pctl":94,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.99,"Poll_pctl":69,"Asthma":26.82,"Asthma_Pct":19,"Low_Birth_":6,"LBW_pctl":"76","Cardiovasc":6.72,"CVD_pctl":33,"Education":10.3,"Edu_pctl":"40","Linguistic":3.4,"Ling_pctl":"26","Poverty":14,"Pov_pctl":"14","Unemployme":8.8,"Unem_pctl":"46","Housing_Bu":10.3,"HB_pctl":"14","PopCharSco":3.68,"Pop_Pctl":"28","Children__":11.3,"Pop_11_64_":71.8,"Elderly___":16.9,"Hispanic__":"19.1","White____":"59.7","African_Am":"5.6","Native_Ame":"0.1","Asian_Amer":"11.3","Other____":"4.2","Shape_Leng":5368.05266975,"Shape_Area":1101096.21717}},{"arcs":[[2279,2280,-2163,2281]],"type":"Polygon","properties":{"Tract_1":6037242600,"Percentile":"96-100%","Population":4409,"County":"Los Angeles","ZIP":90059,"City":"Los Angeles","CIscore":66.48,"CIscoreP":"99","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":25.04,"DPM_pctl":76,"DrinkingWa":627.17,"DW_pctl":"71","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5631.46,"TR_pctl":83,"Traffic":3279.99,"Traff_Pctl":"98","Cleanups":0,"Clean_Pctl":0,"Groundwate":4.5,"GW_pctl":29,"Haz_Waste":0.11,"Haz_pctl":46,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":7,"Solid_pctl":83,"PollutionS":7.1,"Poll_pctl":88,"Asthma":105.29,"Asthma_Pct":94,"Low_Birth_":7.05,"LBW_pctl":"91","Cardiovasc":11.72,"CVD_pctl":87,"Education":58,"Edu_pctl":"98","Linguistic":10,"Ling_pctl":"59","Poverty":88.1,"Pov_pctl":"100","Unemployme":39.7,"Unem_pctl":"100","Housing_Bu":34.3,"HB_pctl":"94","PopCharSco":9.37,"Pop_Pctl":"99","Children__":27.2,"Pop_11_64_":70.1,"Elderly___":2.7,"Hispanic__":"59.9","White____":"0.9","African_Am":"38.2","Native_Ame":"0.1","Asian_Amer":"0.2","Other____":"0.7","Shape_Leng":2789.34161499,"Shape_Area":475382.405072}},{"arcs":[[2282,2283,2284,2285]],"type":"Polygon","properties":{"Tract_1":6037242700,"Percentile":"96-100%","Population":5273,"County":"Los Angeles","ZIP":90059,"City":"Los Angeles","CIscore":67.52,"CIscoreP":"99","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":25.04,"DPM_pctl":76,"DrinkingWa":628.08,"DW_pctl":"71","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5725.47,"TR_pctl":83,"Traffic":2101.41,"Traff_Pctl":"92","Cleanups":4.85,"Clean_Pctl":43,"Groundwate":9.5,"GW_pctl":47,"Haz_Waste":0.15,"Haz_pctl":54,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":1.2,"Solid_pctl":34,"PollutionS":7.21,"Poll_pctl":89,"Asthma":88.01,"Asthma_Pct":89,"Low_Birth_":7.7,"LBW_pctl":"95","Cardiovasc":10.5,"CVD_pctl":78,"Education":48.8,"Edu_pctl":"93","Linguistic":17.5,"Ling_pctl":"80","Poverty":85.5,"Pov_pctl":"99","Unemployme":20.4,"Unem_pctl":"96","Housing_Bu":40.1,"HB_pctl":"98","PopCharSco":9.37,"Pop_Pctl":"99","Children__":20.1,"Pop_11_64_":74.6,"Elderly___":5.3,"Hispanic__":"72.3","White____":"0.4","African_Am":"25.7","Native_Ame":"0.1","Asian_Amer":"0.4","Other____":"1.1","Shape_Leng":4378.11642792,"Shape_Area":1015746.97296}},{"arcs":[[2286,2287,2288,-1079,2289]],"type":"Polygon","properties":{"Tract_1":6037243000,"Percentile":"96-100%","Population":6769,"County":"Los Angeles","ZIP":90002,"City":"Los Angeles","CIscore":57.76,"CIscoreP":"95","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":25.04,"DPM_pctl":76,"DrinkingWa":631.94,"DW_pctl":"71","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5878.67,"TR_pctl":84,"Traffic":750.45,"Traff_Pctl":"54","Cleanups":40.35,"Clean_Pctl":94,"Groundwate":9.5,"GW_pctl":47,"Haz_Waste":0.75,"Haz_pctl":84,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":15.5,"Solid_pctl":95,"PollutionS":7.42,"Poll_pctl":92,"Asthma":74.11,"Asthma_Pct":81,"Low_Birth_":4.7,"LBW_pctl":"44","Cardiovasc":9.79,"CVD_pctl":73,"Education":49.5,"Edu_pctl":"94","Linguistic":16.7,"Ling_pctl":"78","Poverty":70.9,"Pov_pctl":"94","Unemployme":10.2,"Unem_pctl":"58","Housing_Bu":39.5,"HB_pctl":"98","PopCharSco":7.79,"Pop_Pctl":"87","Children__":20.3,"Pop_11_64_":74.3,"Elderly___":5.4,"Hispanic__":"79.4","White____":"1.2","African_Am":"18.6","Native_Ame":"0.2","Asian_Amer":"0","Other____":"0.6","Shape_Leng":3382.44761631,"Shape_Area":721804.222378}},{"arcs":[[-767,2290,2291,-2287,2292]],"type":"Polygon","properties":{"Tract_1":6037243100,"Percentile":"96-100%","Population":5350,"County":"Los Angeles","ZIP":90059,"City":"Los Angeles","CIscore":73.54,"CIscoreP":"100","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":25.04,"DPM_pctl":76,"DrinkingWa":664.07,"DW_pctl":"79","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5852.28,"TR_pctl":84,"Traffic":2521.07,"Traff_Pctl":"95","Cleanups":25.25,"Clean_Pctl":88,"Groundwate":12.15,"GW_pctl":54,"Haz_Waste":0.56,"Haz_pctl":79,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":3.7,"Solid_pctl":65,"PollutionS":7.7,"Poll_pctl":94,"Asthma":105.29,"Asthma_Pct":94,"Low_Birth_":9.99,"LBW_pctl":"100","Cardiovasc":11.72,"CVD_pctl":87,"Education":60.8,"Edu_pctl":"98","Linguistic":16.5,"Ling_pctl":"78","Poverty":76,"Pov_pctl":"97","Unemployme":15,"Unem_pctl":"84","Housing_Bu":35.9,"HB_pctl":"95","PopCharSco":9.54,"Pop_Pctl":"100","Children__":22.4,"Pop_11_64_":72.1,"Elderly___":5.5,"Hispanic__":"64.7","White____":"1.8","African_Am":"31.8","Native_Ame":"0.2","Asian_Amer":"0.4","Other____":"1","Shape_Leng":3254.71360133,"Shape_Area":601949.966041}},{"arcs":[[2293,2294,2295,-1794,2296,2297]],"type":"Polygon","properties":{"Tract_1":6037540000,"Percentile":"96-100%","Population":6973,"County":"Los Angeles","ZIP":90262,"City":"Lynwood","CIscore":60.44,"CIscoreP":"97","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":24.64,"DPM_pctl":75,"DrinkingWa":450.47,"DW_pctl":"46","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6565.78,"TR_pctl":87,"Traffic":2861.79,"Traff_Pctl":"97","Cleanups":4.65,"Clean_Pctl":43,"Groundwate":10,"GW_pctl":50,"Haz_Waste":0.08,"Haz_pctl":31,"Imp__Water":10,"IWB_pctl":86,"Solid_Wast":6.2,"Solid_pctl":79,"PollutionS":7.38,"Poll_pctl":91,"Asthma":56.29,"Asthma_Pct":65,"Low_Birth_":6.44,"LBW_pctl":"84","Cardiovasc":10.77,"CVD_pctl":81,"Education":46.1,"Edu_pctl":"92","Linguistic":19.2,"Ling_pctl":"83","Poverty":52.8,"Pov_pctl":"77","Unemployme":11,"Unem_pctl":"63","Housing_Bu":32.6,"HB_pctl":"92","PopCharSco":8.19,"Pop_Pctl":"92","Children__":19.1,"Pop_11_64_":75.9,"Elderly___":5,"Hispanic__":"90.6","White____":"1.6","African_Am":"5.5","Native_Ame":"0","Asian_Amer":"1.6","Other____":"0.6","Shape_Leng":6011.27712522,"Shape_Area":1855282.62233}},{"arcs":[[2298,2299,-2011,2300,2301,2302,2303]],"type":"Polygon","properties":{"Tract_1":6037541700,"Percentile":"96-100%","Population":6366,"County":"Los Angeles","ZIP":90262,"City":"Lynwood","CIscore":58.08,"CIscoreP":"95","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":26.94,"DPM_pctl":80,"DrinkingWa":422.18,"DW_pctl":"44","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6163.89,"TR_pctl":86,"Traffic":2981.66,"Traff_Pctl":"97","Cleanups":14.4,"Clean_Pctl":76,"Groundwate":21.5,"GW_pctl":73,"Haz_Waste":0.1,"Haz_pctl":43,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":7.27,"Poll_pctl":90,"Asthma":52.08,"Asthma_Pct":59,"Low_Birth_":6.33,"LBW_pctl":"82","Cardiovasc":9.79,"CVD_pctl":73,"Education":43.3,"Edu_pctl":"90","Linguistic":16,"Ling_pctl":"77","Poverty":53.3,"Pov_pctl":"77","Unemployme":13.4,"Unem_pctl":"78","Housing_Bu":32.1,"HB_pctl":"91","PopCharSco":7.99,"Pop_Pctl":"90","Children__":16.6,"Pop_11_64_":76.6,"Elderly___":6.8,"Hispanic__":"82.8","White____":"1.4","African_Am":"14.7","Native_Ame":"0.1","Asian_Amer":"0.8","Other____":"0.2","Shape_Leng":5335.2224079,"Shape_Area":1410234.33747}},{"arcs":[[-1793,2304,2305,-2299,2306]],"type":"Polygon","properties":{"Tract_1":6037541801,"Percentile":"76-80%","Population":4903,"County":"Los Angeles","ZIP":90262,"City":"Lynwood","CIscore":41.68,"CIscoreP":"78","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":26.94,"DPM_pctl":80,"DrinkingWa":242.17,"DW_pctl":"24","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6299.19,"TR_pctl":86,"Traffic":2045.11,"Traff_Pctl":"91","Cleanups":1.4,"Clean_Pctl":21,"Groundwate":4.3,"GW_pctl":28,"Haz_Waste":0.02,"Haz_pctl":10,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":5.89,"Poll_pctl":66,"Asthma":47.28,"Asthma_Pct":53,"Low_Birth_":5.25,"LBW_pctl":"59","Cardiovasc":8.67,"CVD_pctl":59,"Education":46,"Edu_pctl":"92","Linguistic":12.9,"Ling_pctl":"69","Poverty":64,"Pov_pctl":"88","Unemployme":11.7,"Unem_pctl":"68","Housing_Bu":26.4,"HB_pctl":"80","PopCharSco":7.08,"Pop_Pctl":"77","Children__":18.8,"Pop_11_64_":76.8,"Elderly___":4.4,"Hispanic__":"81.1","White____":"1.7","African_Am":"14","Native_Ame":"0.1","Asian_Amer":"1.9","Other____":"1.2","Shape_Leng":3723.88313362,"Shape_Area":717149.154363}},{"arcs":[[2307,2308,-900,2309,-1435,2310,2311,2312,-969,2313,-12]],"type":"Polygon","properties":{"Tract_1":6037543305,"Percentile":"96-100%","Population":2666,"County":"Los Angeles","ZIP":90220,"City":"Compton","CIscore":73.54,"CIscoreP":"100","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":31.2,"DPM_pctl":87,"DrinkingWa":383.1,"DW_pctl":"40","Pesticides":36.2,"Pest_pctl":69,"Tox_Releas":6896.1,"TR_pctl":88,"Traffic":1418.39,"Traff_Pctl":"81","Cleanups":53,"Clean_Pctl":96,"Groundwate":149.5,"GW_pctl":99,"Haz_Waste":2.67,"Haz_pctl":94,"Imp__Water":13,"IWB_pctl":93,"Solid_Wast":10.75,"Solid_pctl":90,"PollutionS":9.34,"Poll_pctl":100,"Asthma":106.87,"Asthma_Pct":94,"Low_Birth_":10,"LBW_pctl":"100","Cardiovasc":12.47,"CVD_pctl":91,"Education":19.7,"Edu_pctl":"61","Linguistic":1.9,"Ling_pctl":"13","Poverty":34.1,"Pov_pctl":"51","Unemployme":12.1,"Unem_pctl":"71","Housing_Bu":30.6,"HB_pctl":"89","PopCharSco":7.87,"Pop_Pctl":"88","Children__":9.5,"Pop_11_64_":72.7,"Elderly___":17.8,"Hispanic__":"27.2","White____":"26.9","African_Am":"37.3","Native_Ame":"0.6","Asian_Amer":"5.2","Other____":"2.9","Shape_Leng":12148.7261194,"Shape_Area":8481954.24067}},{"arcs":[[2314,-2044,2315,2316]],"type":"Polygon","properties":{"Tract_1":6037543502,"Percentile":"81-85%","Population":4560,"County":"Los Angeles","ZIP":90502,"City":"Torrance","CIscore":43.27,"CIscoreP":"80","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":23.92,"DPM_pctl":73,"DrinkingWa":182.07,"DW_pctl":"14","Pesticides":0.036,"Pest_pctl":14,"Tox_Releas":8544.75,"TR_pctl":91,"Traffic":1571.45,"Traff_Pctl":"84","Cleanups":92.5,"Clean_Pctl":99,"Groundwate":30.3,"GW_pctl":82,"Haz_Waste":1.12,"Haz_pctl":88,"Imp__Water":3,"IWB_pctl":41,"Solid_Wast":19.55,"Solid_pctl":97,"PollutionS":7.92,"Poll_pctl":96,"Asthma":47.6,"Asthma_Pct":53,"Low_Birth_":5.14,"LBW_pctl":"56","Cardiovasc":7.74,"CVD_pctl":47,"Education":19.4,"Edu_pctl":"61","Linguistic":17.6,"Ling_pctl":"80","Poverty":21,"Pov_pctl":"29","Unemployme":8.1,"Unem_pctl":"40","Housing_Bu":19.3,"HB_pctl":"56","PopCharSco":5.46,"Pop_Pctl":"54","Children__":13,"Pop_11_64_":76.5,"Elderly___":10.5,"Hispanic__":"50.1","White____":"18.9","African_Am":"3.6","Native_Ame":"0.4","Asian_Amer":"23.8","Other____":"3.2","Shape_Leng":4846.14602982,"Shape_Area":1117616.79393}},{"arcs":[[-1974,2317,2318,2319,-671,2320,2321]],"type":"Polygon","properties":{"Tract_1":6037542601,"Percentile":"96-100%","Population":3016,"County":"Los Angeles","ZIP":90222,"City":"Compton","CIscore":63.25,"CIscoreP":"98","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":18.7,"DPM_pctl":58,"DrinkingWa":477.51,"DW_pctl":"49","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5934.91,"TR_pctl":84,"Traffic":604.98,"Traff_Pctl":"42","Cleanups":7,"Clean_Pctl":52,"Groundwate":24.5,"GW_pctl":76,"Haz_Waste":5.3,"Haz_pctl":97,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":6,"Solid_pctl":79,"PollutionS":7.19,"Poll_pctl":89,"Asthma":99.6,"Asthma_Pct":93,"Low_Birth_":6.68,"LBW_pctl":"87","Cardiovasc":11.71,"CVD_pctl":87,"Education":48.1,"Edu_pctl":"93","Linguistic":16.6,"Ling_pctl":"78","Poverty":66.5,"Pov_pctl":"90","Unemployme":14.7,"Unem_pctl":"83","Housing_Bu":20,"HB_pctl":"59","PopCharSco":8.8,"Pop_Pctl":"97","Children__":21.7,"Pop_11_64_":73.1,"Elderly___":5.2,"Hispanic__":"85.1","White____":"0.6","African_Am":"13.7","Native_Ame":"0.1","Asian_Amer":"0","Other____":"0.4","Shape_Leng":3233.55404247,"Shape_Area":552902.516462}},{"arcs":[[2322,-2318,-941,2323]],"type":"Polygon","properties":{"Tract_1":6037542602,"Percentile":"96-100%","Population":5496,"County":"Los Angeles","ZIP":90220,"City":"Compton","CIscore":59.14,"CIscoreP":"96","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":18.7,"DPM_pctl":58,"DrinkingWa":444.63,"DW_pctl":"46","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5905.58,"TR_pctl":84,"Traffic":585.05,"Traff_Pctl":"40","Cleanups":1.6,"Clean_Pctl":23,"Groundwate":32.8,"GW_pctl":84,"Haz_Waste":2.65,"Haz_pctl":94,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":3.5,"Solid_pctl":65,"PollutionS":6.8,"Poll_pctl":84,"Asthma":94.08,"Asthma_Pct":91,"Low_Birth_":6.61,"LBW_pctl":"86","Cardiovasc":10.9,"CVD_pctl":82,"Education":44.3,"Edu_pctl":"91","Linguistic":13.4,"Ling_pctl":"71","Poverty":62.3,"Pov_pctl":"86","Unemployme":12.1,"Unem_pctl":"71","Housing_Bu":30.2,"HB_pctl":"88","PopCharSco":8.7,"Pop_Pctl":"96","Children__":18.4,"Pop_11_64_":75.9,"Elderly___":5.7,"Hispanic__":"71.8","White____":"1.1","African_Am":"25.2","Native_Ame":"0.2","Asian_Amer":"1","Other____":"0.7","Shape_Leng":3781.68567041,"Shape_Area":875534.059647}},{"arcs":[[2324,2325,-2200,2326]],"type":"Polygon","properties":{"Tract_1":6037542800,"Percentile":"86-90%","Population":3123,"County":"Los Angeles","ZIP":90220,"City":"Compton","CIscore":50.13,"CIscoreP":"89","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":18.7,"DPM_pctl":58,"DrinkingWa":527.92,"DW_pctl":"56","Pesticides":1.151,"Pest_pctl":40,"Tox_Releas":5918.46,"TR_pctl":84,"Traffic":559.54,"Traff_Pctl":"37","Cleanups":1,"Clean_Pctl":18,"Groundwate":8.5,"GW_pctl":44,"Haz_Waste":0.1,"Haz_pctl":43,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":1.25,"Solid_pctl":37,"PollutionS":6.34,"Poll_pctl":76,"Asthma":95.3,"Asthma_Pct":91,"Low_Birth_":7.43,"LBW_pctl":"94","Cardiovasc":11.04,"CVD_pctl":83,"Education":25.2,"Edu_pctl":"70","Linguistic":6.4,"Ling_pctl":"44","Poverty":36.5,"Pov_pctl":"55","Unemployme":15.5,"Unem_pctl":"86","Housing_Bu":20.4,"HB_pctl":"61","PopCharSco":7.91,"Pop_Pctl":"89","Children__":14,"Pop_11_64_":74.3,"Elderly___":11.7,"Hispanic__":"40.7","White____":"0.7","African_Am":"55.7","Native_Ame":"0.2","Asian_Amer":"0.3","Other____":"2.3","Shape_Leng":3552.25703073,"Shape_Area":776635.998408}},{"arcs":[[2327,2328,-2191,2329,2330,2331]],"type":"Polygon","properties":{"Tract_1":6037542700,"Percentile":"86-90%","Population":5720,"County":"Los Angeles","ZIP":90220,"City":"Compton","CIscore":47.43,"CIscoreP":"86","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":18.7,"DPM_pctl":58,"DrinkingWa":478.61,"DW_pctl":"49","Pesticides":0.327,"Pest_pctl":30,"Tox_Releas":5872.75,"TR_pctl":84,"Traffic":510.73,"Traff_Pctl":"32","Cleanups":1.4,"Clean_Pctl":21,"Groundwate":9.8,"GW_pctl":48,"Haz_Waste":0.01,"Haz_pctl":9,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.55,"Poll_pctl":59,"Asthma":101.83,"Asthma_Pct":93,"Low_Birth_":7.41,"LBW_pctl":"94","Cardiovasc":11.84,"CVD_pctl":88,"Education":41.7,"Edu_pctl":"88","Linguistic":7.4,"Ling_pctl":"48","Poverty":54.1,"Pov_pctl":"78","Unemployme":11.9,"Unem_pctl":"69","Housing_Bu":27.2,"HB_pctl":"82","PopCharSco":8.55,"Pop_Pctl":"95","Children__":17.7,"Pop_11_64_":76.2,"Elderly___":6.1,"Hispanic__":"72.2","White____":"0.7","African_Am":"26","Native_Ame":"0.1","Asian_Amer":"0.4","Other____":"0.5","Shape_Leng":4142.28340455,"Shape_Area":994658.493985}},{"arcs":[[2332,2333,2334,-2325,2335,2336]],"type":"Polygon","properties":{"Tract_1":6037542900,"Percentile":"91-95%","Population":3285,"County":"Los Angeles","ZIP":90220,"City":"Compton","CIscore":52.28,"CIscoreP":"91","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":26.93,"DPM_pctl":80,"DrinkingWa":511.22,"DW_pctl":"54","Pesticides":1.314,"Pest_pctl":41,"Tox_Releas":6143.25,"TR_pctl":85,"Traffic":488.07,"Traff_Pctl":"30","Cleanups":0,"Clean_Pctl":0,"Groundwate":13,"GW_pctl":57,"Haz_Waste":0.02,"Haz_pctl":10,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":1.15,"Solid_pctl":33,"PollutionS":6.18,"Poll_pctl":73,"Asthma":110.81,"Asthma_Pct":95,"Low_Birth_":6.15,"LBW_pctl":"79","Cardiovasc":12.82,"CVD_pctl":92,"Education":46.4,"Edu_pctl":"92","Linguistic":16.3,"Ling_pctl":"78","Poverty":58.4,"Pov_pctl":"83","Unemployme":9.5,"Unem_pctl":"52","Housing_Bu":22.2,"HB_pctl":"68","PopCharSco":8.46,"Pop_Pctl":"94","Children__":18.3,"Pop_11_64_":73.6,"Elderly___":8.1,"Hispanic__":"76.3","White____":"0.9","African_Am":"20.5","Native_Ame":"0.1","Asian_Amer":"1.2","Other____":"1.1","Shape_Leng":4346.61058101,"Shape_Area":812881.431365}},{"arcs":[[-726,2337,2338,-420,2339,-124,-2248]],"type":"Polygon","properties":{"Tract_1":6037621400,"Percentile":"6-10%","Population":4414,"County":"Los Angeles","ZIP":90277,"City":"Redondo Beach","CIscore":8.11,"CIscoreP":"9","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":13.24,"DPM_pctl":40,"DrinkingWa":236.93,"DW_pctl":"23","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6192.6,"TR_pctl":86,"Traffic":582.35,"Traff_Pctl":"40","Cleanups":4,"Clean_Pctl":39,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":8,"IWB_pctl":76,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.59,"Poll_pctl":38,"Asthma":22.8,"Asthma_Pct":12,"Low_Birth_":3.43,"LBW_pctl":"15","Cardiovasc":6.18,"CVD_pctl":26,"Education":1.3,"Edu_pctl":"3","Linguistic":1.2,"Ling_pctl":"7","Poverty":12.3,"Pov_pctl":"11","Unemployme":5.5,"Unem_pctl":"17","Housing_Bu":16.7,"HB_pctl":"44","PopCharSco":1.77,"Pop_Pctl":"5","Children__":11.5,"Pop_11_64_":76.5,"Elderly___":12,"Hispanic__":"11.1","White____":"72.9","African_Am":"1.2","Native_Ame":"0.4","Asian_Amer":"9.1","Other____":"5.3","Shape_Leng":4880.61018872,"Shape_Area":1272708.06637}},{"arcs":[[2340,-120,-520,-1864,2341]],"type":"Polygon","properties":{"Tract_1":6037650001,"Percentile":"61-65%","Population":5853,"County":"Los Angeles","ZIP":90504,"City":"Torrance","CIscore":31.02,"CIscoreP":"61","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":22.51,"DPM_pctl":68,"DrinkingWa":288.27,"DW_pctl":"30","Pesticides":0,"Pest_pctl":0,"Tox_Releas":9881.74,"TR_pctl":93,"Traffic":727.41,"Traff_Pctl":"52","Cleanups":28,"Clean_Pctl":90,"Groundwate":16.3,"GW_pctl":64,"Haz_Waste":0.15,"Haz_pctl":54,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":3,"Solid_pctl":62,"PollutionS":7.1,"Poll_pctl":88,"Asthma":45.71,"Asthma_Pct":51,"Low_Birth_":5.25,"LBW_pctl":"59","Cardiovasc":7.04,"CVD_pctl":38,"Education":9,"Edu_pctl":"36","Linguistic":16.9,"Ling_pctl":"79","Poverty":27.9,"Pov_pctl":"41","Unemployme":4.3,"Unem_pctl":"8","Housing_Bu":9.4,"HB_pctl":"11","PopCharSco":4.37,"Pop_Pctl":"38","Children__":9.2,"Pop_11_64_":72,"Elderly___":18.8,"Hispanic__":"20","White____":"25.4","African_Am":"2.9","Native_Ame":"0.2","Asian_Amer":"47.4","Other____":"4.2","Shape_Leng":5186.93303728,"Shape_Area":1611793.24884}},{"arcs":[[2342,2343,-2217,2344,2345,2346,2347,2348,-567,2349]],"type":"Polygon","properties":{"Tract_1":6037650300,"Percentile":"61-65%","Population":6704,"County":"Los Angeles","ZIP":90504,"City":"Torrance","CIscore":31.49,"CIscoreP":"62","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":21.04,"DPM_pctl":65,"DrinkingWa":217.49,"DW_pctl":"17","Pesticides":0,"Pest_pctl":0,"Tox_Releas":108491.55,"TR_pctl":100,"Traffic":1297.23,"Traff_Pctl":"78","Cleanups":11.75,"Clean_Pctl":66,"Groundwate":16.75,"GW_pctl":65,"Haz_Waste":0.68,"Haz_pctl":82,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":2,"Solid_pctl":50,"PollutionS":6.65,"Poll_pctl":82,"Asthma":41.03,"Asthma_Pct":44,"Low_Birth_":4.27,"LBW_pctl":"33","Cardiovasc":6.64,"CVD_pctl":32,"Education":10.4,"Edu_pctl":"41","Linguistic":10.2,"Ling_pctl":"60","Poverty":32.2,"Pov_pctl":"48","Unemployme":11.9,"Unem_pctl":"69","Housing_Bu":19.6,"HB_pctl":"57","PopCharSco":4.74,"Pop_Pctl":"43","Children__":10.4,"Pop_11_64_":74.7,"Elderly___":14.9,"Hispanic__":"24.9","White____":"34.5","African_Am":"3.8","Native_Ame":"0.4","Asian_Amer":"31.6","Other____":"4.8","Shape_Leng":6380.70002384,"Shape_Area":1873889.51252}},{"arcs":[[-570,2350,-562,2351,2352]],"type":"Polygon","properties":{"Tract_1":6037650101,"Percentile":"66-70%","Population":5831,"County":"Los Angeles","ZIP":90504,"City":"Torrance","CIscore":33.33,"CIscoreP":"66","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":22.51,"DPM_pctl":68,"DrinkingWa":421.05,"DW_pctl":"44","Pesticides":0.228,"Pest_pctl":27,"Tox_Releas":21734.02,"TR_pctl":98,"Traffic":1922.89,"Traff_Pctl":"90","Cleanups":41.6,"Clean_Pctl":95,"Groundwate":45.35,"GW_pctl":90,"Haz_Waste":5.46,"Haz_pctl":97,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":5,"Solid_pctl":74,"PollutionS":8.78,"Poll_pctl":99,"Asthma":44.43,"Asthma_Pct":48,"Low_Birth_":4.5,"LBW_pctl":"39","Cardiovasc":6.91,"CVD_pctl":36,"Education":5.1,"Edu_pctl":"20","Linguistic":4.2,"Ling_pctl":"32","Poverty":17.4,"Pov_pctl":"21","Unemployme":14.6,"Unem_pctl":"83","Housing_Bu":7.2,"HB_pctl":"5","PopCharSco":3.8,"Pop_Pctl":"30","Children__":10.9,"Pop_11_64_":69.3,"Elderly___":19.8,"Hispanic__":"17.3","White____":"24","African_Am":"2.1","Native_Ame":"0.2","Asian_Amer":"51","Other____":"5.4","Shape_Leng":5614.55083322,"Shape_Area":1893415.65568}},{"arcs":[[-743,2353,-77,-1550,-2259,2354]],"type":"Polygon","properties":{"Tract_1":6037577604,"Percentile":"16-20%","Population":1388,"County":"Los Angeles","ZIP":90803,"City":"Long Beach","CIscore":12.75,"CIscoreP":"20","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":12.66,"DPM_pctl":38,"DrinkingWa":249.04,"DW_pctl":"25","Pesticides":0,"Pest_pctl":0,"Tox_Releas":9369.93,"TR_pctl":93,"Traffic":771.98,"Traff_Pctl":"55","Cleanups":10.9,"Clean_Pctl":65,"Groundwate":18.6,"GW_pctl":68,"Haz_Waste":0.25,"Haz_pctl":66,"Imp__Water":11,"IWB_pctl":90,"Solid_Wast":7.45,"Solid_pctl":84,"PollutionS":6.67,"Poll_pctl":82,"Asthma":25.97,"Asthma_Pct":18,"Low_Birth_":0,"LBW_pctl":"NA","Cardiovasc":7.05,"CVD_pctl":38,"Education":4.3,"Edu_pctl":"16","Linguistic":0.5,"Ling_pctl":"2","Poverty":13.4,"Pov_pctl":"13","Unemployme":6.2,"Unem_pctl":"22","Housing_Bu":8.2,"HB_pctl":"7","PopCharSco":1.91,"Pop_Pctl":"7","Children__":5.4,"Pop_11_64_":68.2,"Elderly___":26.4,"Hispanic__":"9.2","White____":"78.6","African_Am":"2.5","Native_Ame":"0.1","Asian_Amer":"6.2","Other____":"3.3","Shape_Leng":8676.07372194,"Shape_Area":1503297.55636}},{"arcs":[[2355,2356,2357,2358]],"type":"Polygon","properties":{"Tract_1":6037576904,"Percentile":"71-75%","Population":3288,"County":"Los Angeles","ZIP":90804,"City":"Long Beach","CIscore":36.52,"CIscoreP":"71","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":13.13,"DPM_pctl":39,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8414.1,"TR_pctl":91,"Traffic":1210.19,"Traff_Pctl":"76","Cleanups":0,"Clean_Pctl":0,"Groundwate":14.25,"GW_pctl":59,"Haz_Waste":0.54,"Haz_pctl":78,"Imp__Water":4,"IWB_pctl":49,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.31,"Poll_pctl":53,"Asthma":71.45,"Asthma_Pct":80,"Low_Birth_":4.68,"LBW_pctl":"43","Cardiovasc":8.92,"CVD_pctl":62,"Education":20.5,"Edu_pctl":"63","Linguistic":8.5,"Ling_pctl":"53","Poverty":53.2,"Pov_pctl":"77","Unemployme":12.2,"Unem_pctl":"71","Housing_Bu":31.3,"HB_pctl":"90","PopCharSco":6.88,"Pop_Pctl":"75","Children__":12,"Pop_11_64_":83.6,"Elderly___":4.4,"Hispanic__":"39.4","White____":"29.5","African_Am":"15.2","Native_Ame":"0.4","Asian_Amer":"12.3","Other____":"3.3","Shape_Leng":2624.14838766,"Shape_Area":366234.872887}},{"arcs":[[2359,2360,-1755]],"type":"Polygon","properties":{"Tract_1":6037573004,"Percentile":"86-90%","Population":5153,"County":"Los Angeles","ZIP":90806,"City":"Long Beach","CIscore":49.35,"CIscoreP":"88","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":29.12,"DPM_pctl":84,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":13287.33,"TR_pctl":96,"Traffic":934.06,"Traff_Pctl":"64","Cleanups":0.25,"Clean_Pctl":5,"Groundwate":18.5,"GW_pctl":68,"Haz_Waste":0.04,"Haz_pctl":18,"Imp__Water":11,"IWB_pctl":90,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":5.78,"Poll_pctl":64,"Asthma":84.87,"Asthma_Pct":87,"Low_Birth_":6.21,"LBW_pctl":"80","Cardiovasc":9.45,"CVD_pctl":68,"Education":31.9,"Edu_pctl":"79","Linguistic":13.5,"Ling_pctl":"71","Poverty":65.8,"Pov_pctl":"90","Unemployme":17.4,"Unem_pctl":"91","Housing_Bu":44.7,"HB_pctl":"99","PopCharSco":8.54,"Pop_Pctl":"95","Children__":20.2,"Pop_11_64_":75.9,"Elderly___":3.9,"Hispanic__":"61.8","White____":"8.3","African_Am":"21.5","Native_Ame":"0.3","Asian_Amer":"6.3","Other____":"1.9","Shape_Leng":2624.4545348,"Shape_Area":409331.396199}},{"arcs":[[2361,-1430,2362,-8]],"type":"Polygon","properties":{"Tract_1":6037571703,"Percentile":"76-80%","Population":3667,"County":"Los Angeles","ZIP":90805,"City":"Long Beach","CIscore":40.18,"CIscoreP":"76","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":21.53,"DPM_pctl":66,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5768.12,"TR_pctl":83,"Traffic":850.9,"Traff_Pctl":"60","Cleanups":0,"Clean_Pctl":0,"Groundwate":4,"GW_pctl":27,"Haz_Waste":0,"Haz_pctl":0,"Imp__Water":12,"IWB_pctl":91,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.79,"Poll_pctl":42,"Asthma":87.58,"Asthma_Pct":88,"Low_Birth_":7.09,"LBW_pctl":"91","Cardiovasc":10.71,"CVD_pctl":81,"Education":33.2,"Edu_pctl":"80","Linguistic":12.4,"Ling_pctl":"67","Poverty":57.4,"Pov_pctl":"82","Unemployme":16.3,"Unem_pctl":"88","Housing_Bu":19.6,"HB_pctl":"57","PopCharSco":8.39,"Pop_Pctl":"94","Children__":16.4,"Pop_11_64_":70.5,"Elderly___":13.1,"Hispanic__":"59.3","White____":"8","African_Am":"14.8","Native_Ame":"0.1","Asian_Amer":"15.5","Other____":"2.2","Shape_Leng":2957.59869292,"Shape_Area":397281.607564}},{"arcs":[[-1318,2363,-80,2364,-2356,2365]],"type":"Polygon","properties":{"Tract_1":6037576901,"Percentile":"86-90%","Population":6092,"County":"Los Angeles","ZIP":90804,"City":"Long Beach","CIscore":47.22,"CIscoreP":"86","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":18.45,"DPM_pctl":57,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":8454.55,"TR_pctl":91,"Traffic":953.27,"Traff_Pctl":"65","Cleanups":0,"Clean_Pctl":0,"Groundwate":17.25,"GW_pctl":66,"Haz_Waste":1.1,"Haz_pctl":87,"Imp__Water":4,"IWB_pctl":49,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.53,"Poll_pctl":58,"Asthma":74.2,"Asthma_Pct":82,"Low_Birth_":8.45,"LBW_pctl":"98","Cardiovasc":9.24,"CVD_pctl":66,"Education":40.6,"Edu_pctl":"87","Linguistic":18.6,"Ling_pctl":"82","Poverty":71.7,"Pov_pctl":"94","Unemployme":10.5,"Unem_pctl":"60","Housing_Bu":32,"HB_pctl":"91","PopCharSco":8.54,"Pop_Pctl":"95","Children__":17.1,"Pop_11_64_":78.7,"Elderly___":4.2,"Hispanic__":"55.9","White____":"11","African_Am":"12.7","Native_Ame":"0.2","Asian_Amer":"17.5","Other____":"2.7","Shape_Leng":2817.76421155,"Shape_Area":445025.796348}},{"arcs":[[-1765,2366,2367,2368,-1767,2369]],"type":"Polygon","properties":{"Tract_1":6037575101,"Percentile":"91-95%","Population":4754,"County":"Los Angeles","ZIP":90804,"City":"Long Beach","CIscore":54.84,"CIscoreP":"93","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":25.99,"DPM_pctl":78,"DrinkingWa":287.16,"DW_pctl":"30","Pesticides":0.043,"Pest_pctl":15,"Tox_Releas":7988.11,"TR_pctl":90,"Traffic":1159.87,"Traff_Pctl":"74","Cleanups":8.8,"Clean_Pctl":57,"Groundwate":17.1,"GW_pctl":66,"Haz_Waste":1.18,"Haz_pctl":88,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.1,"Solid_pctl":1,"PollutionS":6.26,"Poll_pctl":75,"Asthma":86.41,"Asthma_Pct":88,"Low_Birth_":6.96,"LBW_pctl":"90","Cardiovasc":10.64,"CVD_pctl":80,"Education":37.3,"Edu_pctl":"84","Linguistic":17.9,"Ling_pctl":"81","Poverty":56.5,"Pov_pctl":"81","Unemployme":12.6,"Unem_pctl":"74","Housing_Bu":36.2,"HB_pctl":"96","PopCharSco":8.76,"Pop_Pctl":"97","Children__":17.6,"Pop_11_64_":78.1,"Elderly___":4.3,"Hispanic__":"50","White____":"9.6","African_Am":"15.5","Native_Ame":"0.3","Asian_Amer":"21.8","Other____":"2.8","Shape_Leng":3111.94084464,"Shape_Area":421284.793899}},{"arcs":[[2370,2371,2372,2373,-1780,2374,-1877,2375]],"type":"Polygon","properties":{"Tract_1":6037575001,"Percentile":"46-50%","Population":3608,"County":"Los Angeles","ZIP":90815,"City":"Long Beach","CIscore":23.59,"CIscoreP":"47","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":25.99,"DPM_pctl":78,"DrinkingWa":289.1,"DW_pctl":"31","Pesticides":0.008,"Pest_pctl":7,"Tox_Releas":8301.07,"TR_pctl":91,"Traffic":802.32,"Traff_Pctl":"57","Cleanups":11.6,"Clean_Pctl":66,"Groundwate":15.8,"GW_pctl":63,"Haz_Waste":0.82,"Haz_pctl":85,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":6,"Poll_pctl":69,"Asthma":34.18,"Asthma_Pct":32,"Low_Birth_":4.53,"LBW_pctl":"40","Cardiovasc":6.02,"CVD_pctl":24,"Education":6.2,"Edu_pctl":"25","Linguistic":5.2,"Ling_pctl":"38","Poverty":23.7,"Pov_pctl":"34","Unemployme":8.5,"Unem_pctl":"43","Housing_Bu":26.2,"HB_pctl":"80","PopCharSco":3.93,"Pop_Pctl":"32","Children__":10.9,"Pop_11_64_":83.2,"Elderly___":5.9,"Hispanic__":"23.6","White____":"41.5","African_Am":"11.2","Native_Ame":"0.5","Asian_Amer":"18.1","Other____":"5","Shape_Leng":4731.19946067,"Shape_Area":942483.635681}},{"arcs":[[2376,2377,2378,-2371,2379,-1875,2380]],"type":"Polygon","properties":{"Tract_1":6037574902,"Percentile":"41-45%","Population":4783,"County":"Los Angeles","ZIP":90815,"City":"Long Beach","CIscore":21.28,"CIscoreP":"42","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":25.99,"DPM_pctl":78,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":7832.21,"TR_pctl":90,"Traffic":639.75,"Traff_Pctl":"45","Cleanups":0.9,"Clean_Pctl":13,"Groundwate":15.5,"GW_pctl":62,"Haz_Waste":0.08,"Haz_pctl":31,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":4.74,"Poll_pctl":41,"Asthma":29.23,"Asthma_Pct":24,"Low_Birth_":5.04,"LBW_pctl":"53","Cardiovasc":7.26,"CVD_pctl":41,"Education":4.4,"Edu_pctl":"17","Linguistic":1.6,"Ling_pctl":"11","Poverty":44.2,"Pov_pctl":"66","Unemployme":10.1,"Unem_pctl":"57","Housing_Bu":29.3,"HB_pctl":"87","PopCharSco":4.49,"Pop_Pctl":"40","Children__":7.7,"Pop_11_64_":86.4,"Elderly___":5.9,"Hispanic__":"20.6","White____":"44.8","African_Am":"10","Native_Ame":"0.4","Asian_Amer":"19.2","Other____":"5","Shape_Leng":3953.75904589,"Shape_Area":812071.041158}},{"arcs":[[2381,2382,-1162,2383,-1880,2384,-1269]],"type":"Polygon","properties":{"Tract_1":6037574300,"Percentile":"21-25%","Population":5795,"County":"Los Angeles","ZIP":90815,"City":"Long Beach","CIscore":13.62,"CIscoreP":"22","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.21,"PM_2_5_Pct":"66","Diesel_PM":18.33,"DPM_pctl":56,"DrinkingWa":220.01,"DW_pctl":"18","Pesticides":0,"Pest_pctl":0,"Tox_Releas":7149.01,"TR_pctl":88,"Traffic":1549.82,"Traff_Pctl":"84","Cleanups":9,"Clean_Pctl":60,"Groundwate":15.6,"GW_pctl":63,"Haz_Waste":0.05,"Haz_pctl":26,"Imp__Water":9,"IWB_pctl":81,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.92,"Poll_pctl":67,"Asthma":28.11,"Asthma_Pct":22,"Low_Birth_":3.53,"LBW_pctl":"17","Cardiovasc":7.36,"CVD_pctl":42,"Education":6.4,"Edu_pctl":"25","Linguistic":1.3,"Ling_pctl":"8","Poverty":19.8,"Pov_pctl":"26","Unemployme":3.2,"Unem_pctl":"3","Housing_Bu":12.6,"HB_pctl":"24","PopCharSco":2.3,"Pop_Pctl":"10","Children__":11,"Pop_11_64_":73.5,"Elderly___":15.5,"Hispanic__":"15.8","White____":"68.9","African_Am":"2.5","Native_Ame":"0.1","Asian_Amer":"8.9","Other____":"3.9","Shape_Leng":7715.06339782,"Shape_Area":2484740.42265}},{"arcs":[[-29,2385,2386]],"type":"Polygon","properties":{"Tract_1":6037503000,"Percentile":"96-100%","Population":6057,"County":"Los Angeles","ZIP":90605,"City":"Whittier","CIscore":58.16,"CIscoreP":"96","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":23.49,"DPM_pctl":72,"DrinkingWa":494.25,"DW_pctl":"53","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5413,"TR_pctl":82,"Traffic":534.3,"Traff_Pctl":"34","Cleanups":37.1,"Clean_Pctl":93,"Groundwate":42.1,"GW_pctl":89,"Haz_Waste":0.44,"Haz_pctl":74,"Imp__Water":2,"IWB_pctl":29,"Solid_Wast":9.7,"Solid_pctl":88,"PollutionS":7.48,"Poll_pctl":93,"Asthma":61.52,"Asthma_Pct":71,"Low_Birth_":5.33,"LBW_pctl":"62","Cardiovasc":11.41,"CVD_pctl":85,"Education":39,"Edu_pctl":"86","Linguistic":20.4,"Ling_pctl":"85","Poverty":59.5,"Pov_pctl":"84","Unemployme":8,"Unem_pctl":"39","Housing_Bu":34.2,"HB_pctl":"94","PopCharSco":7.78,"Pop_Pctl":"87","Children__":17.2,"Pop_11_64_":77.4,"Elderly___":5.4,"Hispanic__":"91.8","White____":"5.5","African_Am":"0.4","Native_Ame":"0.1","Asian_Amer":"1.9","Other____":"0.3","Shape_Leng":4889.43239992,"Shape_Area":1328343.21977}},{"arcs":[[2387,2388,-1575,2389,-1577]],"type":"Polygon","properties":{"Tract_1":6037503201,"Percentile":"61-65%","Population":3912,"County":"Los Angeles","ZIP":90604,"City":"Whittier","CIscore":30.63,"CIscoreP":"61","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":11.88,"DPM_pctl":34,"DrinkingWa":368.32,"DW_pctl":"38","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5547.47,"TR_pctl":83,"Traffic":519.61,"Traff_Pctl":"33","Cleanups":0.25,"Clean_Pctl":5,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.12,"Haz_pctl":49,"Imp__Water":2,"IWB_pctl":29,"Solid_Wast":0.8,"Solid_pctl":24,"PollutionS":4.67,"Poll_pctl":40,"Asthma":71.72,"Asthma_Pct":80,"Low_Birth_":6.18,"LBW_pctl":"80","Cardiovasc":15.38,"CVD_pctl":98,"Education":19.1,"Edu_pctl":"60","Linguistic":0,"Ling_pctl":"NA","Poverty":24.5,"Pov_pctl":"35","Unemployme":5.4,"Unem_pctl":"16","Housing_Bu":13.7,"HB_pctl":"29","PopCharSco":6.57,"Pop_Pctl":"70","Children__":12.6,"Pop_11_64_":73.6,"Elderly___":13.8,"Hispanic__":"66.9","White____":"25.7","African_Am":"1.2","Native_Ame":"0.2","Asian_Amer":"4.4","Other____":"1.6","Shape_Leng":4612.95708732,"Shape_Area":1340165.2398}},{"arcs":[[-675,-1796,-2291,2390,2391]],"type":"Polygon","properties":{"Tract_1":6037540600,"Percentile":"91-95%","Population":4271,"County":"Los Angeles","ZIP":90059,"City":"Los Angeles","CIscore":56.96,"CIscoreP":"95","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":19.1,"DPM_pctl":59,"DrinkingWa":450.12,"DW_pctl":"46","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5887.75,"TR_pctl":84,"Traffic":2071.43,"Traff_Pctl":"92","Cleanups":33.9,"Clean_Pctl":92,"Groundwate":24.75,"GW_pctl":77,"Haz_Waste":1.84,"Haz_pctl":91,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":3.95,"Solid_pctl":66,"PollutionS":7.41,"Poll_pctl":92,"Asthma":54.14,"Asthma_Pct":62,"Low_Birth_":7.49,"LBW_pctl":"94","Cardiovasc":6.49,"CVD_pctl":30,"Education":48.6,"Edu_pctl":"93","Linguistic":8.5,"Ling_pctl":"53","Poverty":69.1,"Pov_pctl":"92","Unemployme":19.4,"Unem_pctl":"95","Housing_Bu":39.2,"HB_pctl":"97","PopCharSco":7.69,"Pop_Pctl":"86","Children__":18.6,"Pop_11_64_":74.2,"Elderly___":7.2,"Hispanic__":"64.5","White____":"1","African_Am":"33","Native_Ame":"0.1","Asian_Amer":"0.5","Other____":"0.9","Shape_Leng":3934.09790503,"Shape_Area":948732.806114}},{"arcs":[[2392,-2333,2393,-2336,2394,-870]],"type":"Polygon","properties":{"Tract_1":6037542501,"Percentile":"86-90%","Population":4307,"County":"Los Angeles","ZIP":90220,"City":"Compton","CIscore":46.95,"CIscoreP":"85","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":24.04,"DPM_pctl":73,"DrinkingWa":444.63,"DW_pctl":"46","Pesticides":0.419,"Pest_pctl":32,"Tox_Releas":6081.02,"TR_pctl":85,"Traffic":593.93,"Traff_Pctl":"41","Cleanups":0,"Clean_Pctl":0,"Groundwate":2,"GW_pctl":14,"Haz_Waste":0.01,"Haz_pctl":9,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":0.2,"Solid_pctl":9,"PollutionS":5.46,"Poll_pctl":57,"Asthma":110.81,"Asthma_Pct":95,"Low_Birth_":5.97,"LBW_pctl":"76","Cardiovasc":12.82,"CVD_pctl":92,"Education":34,"Edu_pctl":"81","Linguistic":8,"Ling_pctl":"51","Poverty":55.6,"Pov_pctl":"80","Unemployme":23.9,"Unem_pctl":"99","Housing_Bu":26.8,"HB_pctl":"81","PopCharSco":8.61,"Pop_Pctl":"96","Children__":18.3,"Pop_11_64_":75.8,"Elderly___":5.9,"Hispanic__":"40.7","White____":"0.7","African_Am":"51.6","Native_Ame":"0.1","Asian_Amer":"5.6","Other____":"1.3","Shape_Leng":3656.35004842,"Shape_Area":581697.827615}},{"arcs":[[-2030,2395,-480,-2335,2396,2397]],"type":"Polygon","properties":{"Tract_1":6037543000,"Percentile":"96-100%","Population":4345,"County":"Los Angeles","ZIP":90220,"City":"Compton","CIscore":61.35,"CIscoreP":"97","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":27.73,"DPM_pctl":81,"DrinkingWa":499.77,"DW_pctl":"53","Pesticides":0.501,"Pest_pctl":33,"Tox_Releas":6326.09,"TR_pctl":86,"Traffic":392.43,"Traff_Pctl":"20","Cleanups":14.9,"Clean_Pctl":77,"Groundwate":30.05,"GW_pctl":82,"Haz_Waste":6.31,"Haz_pctl":98,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":12,"Solid_pctl":92,"PollutionS":7.51,"Poll_pctl":93,"Asthma":105.05,"Asthma_Pct":94,"Low_Birth_":6.96,"LBW_pctl":"90","Cardiovasc":12.21,"CVD_pctl":90,"Education":21.8,"Edu_pctl":"65","Linguistic":6.5,"Ling_pctl":"44","Poverty":35.3,"Pov_pctl":"53","Unemployme":15.6,"Unem_pctl":"87","Housing_Bu":27.7,"HB_pctl":"83","PopCharSco":8.17,"Pop_Pctl":"92","Children__":14.5,"Pop_11_64_":72.9,"Elderly___":12.6,"Hispanic__":"41.6","White____":"0.5","African_Am":"55.4","Native_Ame":"0.1","Asian_Amer":"0.3","Other____":"2.1","Shape_Leng":4607.3517262,"Shape_Area":1315243.07788}},{"arcs":[[2398,-1629,-2180,2399,-2315]],"type":"Polygon","properties":{"Tract_1":6037543503,"Percentile":"61-65%","Population":5687,"County":"Los Angeles","ZIP":90502,"City":"Torrance","CIscore":31.61,"CIscoreP":"62","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":11.63,"PM_2_5_Pct":"69","Diesel_PM":23.92,"DPM_pctl":73,"DrinkingWa":182.04,"DW_pctl":"14","Pesticides":0,"Pest_pctl":0,"Tox_Releas":7820.82,"TR_pctl":90,"Traffic":1677.03,"Traff_Pctl":"86","Cleanups":62.9,"Clean_Pctl":97,"Groundwate":39.3,"GW_pctl":87,"Haz_Waste":0.08,"Haz_pctl":32,"Imp__Water":3,"IWB_pctl":41,"Solid_Wast":14.2,"Solid_pctl":94,"PollutionS":7.16,"Poll_pctl":89,"Asthma":44.66,"Asthma_Pct":49,"Low_Birth_":4.56,"LBW_pctl":"40","Cardiovasc":7.27,"CVD_pctl":41,"Education":19.8,"Edu_pctl":"62","Linguistic":9.3,"Ling_pctl":"56","Poverty":17.7,"Pov_pctl":"22","Unemployme":7.5,"Unem_pctl":"34","Housing_Bu":15,"HB_pctl":"35","PopCharSco":4.41,"Pop_Pctl":"38","Children__":9,"Pop_11_64_":71,"Elderly___":20,"Hispanic__":"29.6","White____":"18.9","African_Am":"7.8","Native_Ame":"0.2","Asian_Amer":"40.8","Other____":"2.8","Shape_Leng":6167.12736864,"Shape_Area":1683361.45561}},{"arcs":[[2400,-975,2401,2402,2403,-971]],"type":"Polygon","properties":{"Tract_1":6037543202,"Percentile":"96-100%","Population":4867,"County":"Los Angeles","ZIP":90220,"City":"Compton","CIscore":70.82,"CIscoreP":"99","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":35.92,"DPM_pctl":90,"DrinkingWa":444.22,"DW_pctl":"46","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6626.91,"TR_pctl":87,"Traffic":1641.48,"Traff_Pctl":"86","Cleanups":20.9,"Clean_Pctl":84,"Groundwate":63.5,"GW_pctl":94,"Haz_Waste":1.25,"Haz_pctl":89,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":6.2,"Solid_pctl":79,"PollutionS":8.31,"Poll_pctl":98,"Asthma":110.81,"Asthma_Pct":95,"Low_Birth_":5.2,"LBW_pctl":"58","Cardiovasc":12.82,"CVD_pctl":92,"Education":48.2,"Edu_pctl":"93","Linguistic":8,"Ling_pctl":"51","Poverty":62.9,"Pov_pctl":"87","Unemployme":14.8,"Unem_pctl":"84","Housing_Bu":42,"HB_pctl":"99","PopCharSco":8.52,"Pop_Pctl":"95","Children__":19.4,"Pop_11_64_":75.1,"Elderly___":5.5,"Hispanic__":"73.6","White____":"0.9","African_Am":"23.5","Native_Ame":"0","Asian_Amer":"1.1","Other____":"0.8","Shape_Leng":9108.8443706,"Shape_Area":3091766.39206}},{"arcs":[[-157,-2183,2404,-1625,2405,2406]],"type":"Polygon","properties":{"Tract_1":6037543400,"Percentile":"96-100%","Population":4090,"County":"Los Angeles","ZIP":90746,"City":"Carson","CIscore":60.1,"CIscoreP":"96","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":27.11,"DPM_pctl":80,"DrinkingWa":249.65,"DW_pctl":"25","Pesticides":0.058,"Pest_pctl":17,"Tox_Releas":7947.75,"TR_pctl":90,"Traffic":1988.92,"Traff_Pctl":"91","Cleanups":65.35,"Clean_Pctl":98,"Groundwate":61,"GW_pctl":93,"Haz_Waste":0.74,"Haz_pctl":83,"Imp__Water":14,"IWB_pctl":94,"Solid_Wast":25.3,"Solid_pctl":99,"PollutionS":8.73,"Poll_pctl":99,"Asthma":93.65,"Asthma_Pct":91,"Low_Birth_":5.25,"LBW_pctl":"59","Cardiovasc":9.43,"CVD_pctl":68,"Education":28.8,"Edu_pctl":"75","Linguistic":9.1,"Ling_pctl":"56","Poverty":32.6,"Pov_pctl":"49","Unemployme":12.2,"Unem_pctl":"71","Housing_Bu":17.8,"HB_pctl":"49","PopCharSco":6.89,"Pop_Pctl":"75","Children__":13.2,"Pop_11_64_":73.7,"Elderly___":13.1,"Hispanic__":"56.2","White____":"5.9","African_Am":"17.2","Native_Ame":"0.2","Asian_Amer":"18.2","Other____":"2.3","Shape_Leng":8242.4211232,"Shape_Area":3112099.41445}},{"arcs":[[2407,-2174,2408,2409]],"type":"Polygon","properties":{"Tract_1":6037543304,"Percentile":"71-75%","Population":6061,"County":"Los Angeles","ZIP":90746,"City":"Carson","CIscore":36.88,"CIscoreP":"72","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":29.27,"DPM_pctl":84,"DrinkingWa":182.06,"DW_pctl":"14","Pesticides":0.363,"Pest_pctl":30,"Tox_Releas":7818.9,"TR_pctl":90,"Traffic":494.75,"Traff_Pctl":"30","Cleanups":7.65,"Clean_Pctl":54,"Groundwate":15.75,"GW_pctl":63,"Haz_Waste":1.58,"Haz_pctl":90,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":0.9,"Solid_pctl":24,"PollutionS":6.14,"Poll_pctl":72,"Asthma":90.87,"Asthma_Pct":90,"Low_Birth_":6.89,"LBW_pctl":"89","Cardiovasc":9.14,"CVD_pctl":65,"Education":9,"Edu_pctl":"36","Linguistic":2,"Ling_pctl":"14","Poverty":16.6,"Pov_pctl":"19","Unemployme":17.1,"Unem_pctl":"91","Housing_Bu":10,"HB_pctl":"12","PopCharSco":6.01,"Pop_Pctl":"62","Children__":9.3,"Pop_11_64_":71.8,"Elderly___":18.9,"Hispanic__":"6.4","White____":"1.6","African_Am":"87.1","Native_Ame":"0.1","Asian_Amer":"2.5","Other____":"2.4","Shape_Leng":5089.29243543,"Shape_Area":1616602.31549}},{"arcs":[[2410,-981,2411,-2403]],"type":"Polygon","properties":{"Tract_1":6037543201,"Percentile":"91-95%","Population":3607,"County":"Los Angeles","ZIP":90220,"City":"Compton","CIscore":56.24,"CIscoreP":"94","Ozone":0.042,"Ozone_Pctl":32,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":35.92,"DPM_pctl":90,"DrinkingWa":444.12,"DW_pctl":"46","Pesticides":0.052,"Pest_pctl":16,"Tox_Releas":6415.25,"TR_pctl":86,"Traffic":586.35,"Traff_Pctl":"40","Cleanups":1.1,"Clean_Pctl":19,"Groundwate":3,"GW_pctl":22,"Haz_Waste":0.22,"Haz_pctl":63,"Imp__Water":6,"IWB_pctl":63,"Solid_Wast":2.25,"Solid_pctl":53,"PollutionS":6.39,"Poll_pctl":77,"Asthma":110.81,"Asthma_Pct":95,"Low_Birth_":10.56,"LBW_pctl":"100","Cardiovasc":12.82,"CVD_pctl":92,"Education":27.4,"Edu_pctl":"73","Linguistic":4.7,"Ling_pctl":"35","Poverty":57.2,"Pov_pctl":"82","Unemployme":17.2,"Unem_pctl":"91","Housing_Bu":30.8,"HB_pctl":"89","PopCharSco":8.79,"Pop_Pctl":"97","Children__":16.3,"Pop_11_64_":74.7,"Elderly___":9,"Hispanic__":"59","White____":"1","African_Am":"38","Native_Ame":"0","Asian_Amer":"0.6","Other____":"1.4","Shape_Leng":4073.05242427,"Shape_Area":1010148.58181}},{"arcs":[[2412,-1848,2413,2414,2415]],"type":"Polygon","properties":{"Tract_1":6037554103,"Percentile":"61-65%","Population":1572,"County":"Los Angeles","ZIP":90706,"City":"Bellflower","CIscore":32.17,"CIscoreP":"63","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":26.44,"DPM_pctl":79,"DrinkingWa":361.44,"DW_pctl":"38","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5556.96,"TR_pctl":83,"Traffic":903.27,"Traff_Pctl":"63","Cleanups":0,"Clean_Pctl":0,"Groundwate":0,"GW_pctl":0,"Haz_Waste":0.05,"Haz_pctl":26,"Imp__Water":3,"IWB_pctl":41,"Solid_Wast":0,"Solid_pctl":0,"PollutionS":5.06,"Poll_pctl":48,"Asthma":79.03,"Asthma_Pct":85,"Low_Birth_":7.63,"LBW_pctl":"95","Cardiovasc":11.13,"CVD_pctl":84,"Education":19.6,"Edu_pctl":"61","Linguistic":0,"Ling_pctl":"NA","Poverty":19.4,"Pov_pctl":"26","Unemployme":5.7,"Unem_pctl":"18","Housing_Bu":8.4,"HB_pctl":"8","PopCharSco":6.36,"Pop_Pctl":"67","Children__":15.8,"Pop_11_64_":76.6,"Elderly___":7.6,"Hispanic__":"54.3","White____":"21.1","African_Am":"9.5","Native_Ame":"0.1","Asian_Amer":"12.5","Other____":"2.5","Shape_Leng":2683.85338932,"Shape_Area":369565.724995}},{"arcs":[[-931,2416,-24,2417,-2119,2418,2419]],"type":"Polygon","properties":{"Tract_1":6037552301,"Percentile":"86-90%","Population":4900,"County":"Los Angeles","ZIP":90650,"City":"Norwalk","CIscore":48.84,"CIscoreP":"88","Ozone":0.046,"Ozone_Pctl":53,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":29.85,"DPM_pctl":85,"DrinkingWa":567.26,"DW_pctl":"60","Pesticides":0,"Pest_pctl":0,"Tox_Releas":5237.18,"TR_pctl":81,"Traffic":1379.41,"Traff_Pctl":"80","Cleanups":26,"Clean_Pctl":88,"Groundwate":20.6,"GW_pctl":72,"Haz_Waste":0.29,"Haz_pctl":68,"Imp__Water":0,"IWB_pctl":0,"Solid_Wast":8.45,"Solid_pctl":86,"PollutionS":7.76,"Poll_pctl":95,"Asthma":54.13,"Asthma_Pct":62,"Low_Birth_":5.34,"LBW_pctl":"62","Cardiovasc":11.54,"CVD_pctl":86,"Education":19.2,"Edu_pctl":"60","Linguistic":23.2,"Ling_pctl":"89","Poverty":30,"Pov_pctl":"45","Unemployme":10.8,"Unem_pctl":"62","Housing_Bu":5.5,"HB_pctl":"2","PopCharSco":6.3,"Pop_Pctl":"66","Children__":13.4,"Pop_11_64_":77.9,"Elderly___":8.7,"Hispanic__":"65","White____":"11.1","African_Am":"6.7","Native_Ame":"0.4","Asian_Amer":"15.3","Other____":"1.6","Shape_Leng":5295.13370952,"Shape_Area":1254683.12788}},{"arcs":[[-1791,2420,-1845,2421,2422,2423,2424,2425,2426]],"type":"Polygon","properties":{"Tract_1":6037542104,"Percentile":"91-95%","Population":3524,"County":"Los Angeles","ZIP":90221,"City":"Compton","CIscore":56.16,"CIscoreP":"94","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":26.94,"DPM_pctl":80,"DrinkingWa":167.27,"DW_pctl":"10","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6485.75,"TR_pctl":87,"Traffic":2040.3,"Traff_Pctl":"91","Cleanups":0.7,"Clean_Pctl":11,"Groundwate":18.75,"GW_pctl":69,"Haz_Waste":0.04,"Haz_pctl":18,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":1.2,"Solid_pctl":34,"PollutionS":6.25,"Poll_pctl":74,"Asthma":87.61,"Asthma_Pct":88,"Low_Birth_":7.06,"LBW_pctl":"91","Cardiovasc":13.56,"CVD_pctl":95,"Education":42,"Edu_pctl":"89","Linguistic":18.1,"Ling_pctl":"81","Poverty":47.6,"Pov_pctl":"70","Unemployme":14.5,"Unem_pctl":"82","Housing_Bu":29.5,"HB_pctl":"87","PopCharSco":8.98,"Pop_Pctl":"98","Children__":18.8,"Pop_11_64_":75.5,"Elderly___":5.7,"Hispanic__":"85.6","White____":"0.5","African_Am":"12.2","Native_Ame":"0","Asian_Amer":"1","Other____":"0.6","Shape_Leng":3420.05835276,"Shape_Area":615810.43263}},{"arcs":[[-2426,2427,-2424,2428,2429,2430,2431]],"type":"Polygon","properties":{"Tract_1":6037542103,"Percentile":"86-90%","Population":4114,"County":"Los Angeles","ZIP":90221,"City":"Compton","CIscore":51.19,"CIscoreP":"90","Ozone":0.044,"Ozone_Pctl":40,"PM2_5":12.05,"PM_2_5_Pct":"82","Diesel_PM":26.94,"DPM_pctl":80,"DrinkingWa":353.42,"DW_pctl":"37","Pesticides":0,"Pest_pctl":0,"Tox_Releas":6291.48,"TR_pctl":86,"Traffic":699,"Traff_Pctl":"50","Cleanups":0,"Clean_Pctl":0,"Groundwate":15.1,"GW_pctl":62,"Haz_Waste":0.02,"Haz_pctl":16,"Imp__Water":7,"IWB_pctl":72,"Solid_Wast":0.25,"Solid_pctl":10,"PollutionS":5.71,"Poll_pctl":62,"Asthma":87.61,"Asthma_Pct":88,"Low_Birth_":6.34,"LBW_pctl":"83","Cardiovasc":13.56,"CVD_pctl":95,"Education":52.4,"Edu_pctl":"95","Linguistic":12.6,"Ling_pctl":"68","Poverty":66.7,"Pov_pctl":"91","Unemployme":13.8,"Unem_pctl":"79","Housing_Bu":30.7,"HB_pctl":"89","PopCharSco":8.97,"Pop_Pctl":"98","Children__":19.7,"Pop_11_64_":75.5,"Elderly___":4.8,"Hispanic__":"83.5","White____":"0.8","African_Am":"14.4","Native_Ame":"0","Asian_Amer":"0.8","Other____":"0.5","Shape_Leng":3451.03368956,"Shape_Area":565851.039439}}]}},"crs":{"type":"name","properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"}}}

/***/ }),
/* 197 */
/***/ (function(module, exports) {

module.exports = {"type":"FeatureCollection","crs":{"type":"name","properties":{"name":"urn:ogc:def:crs:OGC:1.3:CRS84"}},"features":[{"type":"Feature","properties":{"id":1369,"osm_id":26663609,"name":"Chevron Oil Refinery","type":"industrial","area":0.000364,"z_order":5},"geometry":{"type":"Polygon","coordinates":[[[-118.4268902376499,33.915986124538584],[-118.42635807061744,33.91624965157436],[-118.42141425648762,33.91627102542745],[-118.41362931245811,33.91624965157436],[-118.40809331686913,33.91623531851994],[-118.40174184592034,33.91616415616198],[-118.39701906257721,33.916197935231764],[-118.39699760490511,33.91504056204158],[-118.3962744142993,33.914974680282626],[-118.3962057665123,33.90831458765902],[-118.39624868185653,33.90704665716595],[-118.39636024498779,33.90590688597243],[-118.3964632585778,33.904681535547496],[-118.39642503709933,33.902021454756344],[-118.3969336509839,33.902023969327296],[-118.41218946913096,33.90209773007521],[-118.41242776663819,33.902288083096295],[-118.41347491780165,33.90214559074235],[-118.41459071675212,33.90218825462949],[-118.41647890808001,33.90220258768392],[-118.41725146809551,33.90227375004187],[-118.41942296775066,33.906227493768824],[-118.42072752716061,33.906604930868724],[-118.42156873496312,33.907652165851204],[-118.42313087025754,33.91080778475799],[-118.42474447043749,33.91288767021146],[-118.42624650748617,33.915110048018875],[-118.4268902376499,33.915986124538584]]]}},{"type":"Feature","properties":{"id":5619,"osm_id":49891847,"name":"Los Angeles Refinery - Wilmington Plant","type":"industrial","area":0.000162,"z_order":5},"geometry":{"type":"Polygon","coordinates":[[[-118.29574698059712,33.77622518137599],[-118.29574698059712,33.77657185689125],[-118.29558873026521,33.77891669430403],[-118.29558873026521,33.77936495848576],[-118.29562820902913,33.77979687795627],[-118.2957271154866,33.78037229560914],[-118.29525077192923,33.780659124335756],[-118.2949475146724,33.78046349071567],[-118.2938350684832,33.77969285853791],[-118.29373104906483,33.77958079249248],[-118.29311866721898,33.7791231405792],[-118.29296133889642,33.7791231405792],[-118.29251181742922,33.77897595435948],[-118.28960421903734,33.77843423195736],[-118.28890474921752,33.778389891689585],[-118.28301704897135,33.77873941705192],[-118.28295946529656,33.77812762193929],[-118.28237541428342,33.778219655236114],[-118.28249913117426,33.778760036533725],[-118.28217927774917,33.77878912173773],[-118.28213560803363,33.77810792446681],[-118.28179454839349,33.77753854178425],[-118.28161450511334,33.77470503941643],[-118.28097680991989,33.77455793701574],[-118.28019025212609,33.77461635888088],[-118.28019025212609,33.77322923772468],[-118.28040935507505,33.773044752035815],[-118.2807211618731,33.77290469043379],[-118.28097404389183,33.77273889638903],[-118.28115106968686,33.77246556252655],[-118.28113137221442,33.77221804492583],[-118.28099365754528,33.77202425532445],[-118.28037004394916,33.77168562643624],[-118.28056450410278,33.770851375613375],[-118.28243970348078,33.7667557262657],[-118.29350306129852,33.76676746093014],[-118.29353365524511,33.767039537507166],[-118.29353541544477,33.76732192382508],[-118.29353541544477,33.767517725083216],[-118.29352108239033,33.76817997925295],[-118.29351026973524,33.76892278351218],[-118.29353365524511,33.76923668578604],[-118.29362174904746,33.76975527413538],[-118.29373507237835,33.77017822496953],[-118.2939597073834,33.77082086548583],[-118.29498464650347,33.77354096070371],[-118.29538915715062,33.77461107828185],[-118.29552930257168,33.774998154570426],[-118.29561203195603,33.77527618229868],[-118.29569476134033,33.77566761717688],[-118.29573071970495,33.775918738995955],[-118.29574698059712,33.77622518137599]]]}},{"type":"Feature","properties":{"id":6725,"osm_id":65417336,"name":"Tesoro Carson Refinery","type":"industrial","area":0.00025,"z_order":5},"geometry":{"type":"Polygon","coordinates":[[[-118.254683953131,33.808838244614776],[-118.25211431307511,33.81207868838166],[-118.25119163317378,33.81322415926937],[-118.25003291887906,33.81466375113942],[-118.24804271978954,33.817115038722505],[-118.24661042017527,33.8188799322547],[-118.24587557872402,33.819775790065904],[-118.24285532755353,33.823412362576754],[-118.24221277085624,33.82416103416821],[-118.23322200623622,33.824169918985575],[-118.23205256310544,33.824178971441],[-118.2317843422039,33.82395609663564],[-118.23145174828595,33.82402734281259],[-118.23128000308994,33.82414326453349],[-118.23053971340165,33.824169918985575],[-118.23148393479414,33.821656270042865],[-118.23073274863172,33.82153372661847],[-118.23279285279372,33.81589832165784],[-118.23307607730196,33.81525651933182],[-118.23349441808935,33.81399076813361],[-118.23440645297364,33.811566051183576],[-118.23556516726836,33.80827665710217],[-118.2384833268582,33.808330133644404],[-118.25454447826222,33.808597516355626],[-118.254683953131,33.808838244614776]]]}},{"type":"Feature","properties":{"id":11373,"osm_id":107758176,"name":"Torrance Refinery","type":"industrial","area":0.000264,"z_order":5},"geometry":{"type":"Polygon","coordinates":[[[-118.34429731071099,33.85249069342825],[-118.34397544562913,33.852989584305135],[-118.34370722472755,33.85360439690291],[-118.34363212287514,33.854032041602835],[-118.34357847869482,33.85817504870343],[-118.31820536814118,33.858192818338146],[-118.31820536814118,33.857996849441975],[-118.31793714723963,33.85798796462461],[-118.31790705620726,33.8505873308556],[-118.31790521218855,33.850138899035834],[-118.317901105056,33.849132148645644],[-118.31789448335246,33.84747378910279],[-118.31789414807635,33.847411763019295],[-118.3184413187155,33.847331548205915],[-118.33749522864761,33.847411763019295],[-118.33772053420493,33.84750086265004],[-118.34238757789194,33.851029392428984],[-118.34340681731781,33.851858027376714],[-118.34429731071099,33.85249069342825]]]}},{"type":"Feature","properties":{"id":11377,"osm_id":107727887,"name":"Tesoro Los Angeles Refinery","type":"industrial","area":0.000154,"z_order":5},"geometry":{"type":"Polygon","coordinates":[[[-118.23927256686105,33.79504657731405],[-118.23461675492428,33.80775949367634],[-118.23342585412136,33.8075633571421],[-118.22836184350008,33.80611027040794],[-118.22801843692707,33.80413105161156],[-118.22799706307396,33.803524872374055],[-118.22919860889387,33.79687399984394],[-118.22969213535275,33.79462714687923],[-118.22993940149637,33.79370002456923],[-118.23031004925471,33.79298194692435],[-118.2308615784835,33.79211115100367],[-118.23085051437131,33.792016184040705],[-118.23093902726885,33.791857766070706],[-118.23112837446152,33.791572194629595],[-118.23128897172633,33.791411429726736],[-118.2314655784262,33.79122669258078],[-118.23264818114494,33.78955299415509],[-118.23366364871441,33.788034025662],[-118.23444785957533,33.786874892272124],[-118.23492420313269,33.78618439108868],[-118.23527305794276,33.785676028661214],[-118.23541110788804,33.78568415910729],[-118.23549626802428,33.785528926260525],[-118.23622012918233,33.785712238482944],[-118.23640210030024,33.78578742415439],[-118.23659086075969,33.785885827697655],[-118.23675740917577,33.785996385000516],[-118.23689495620685,33.78610124260922],[-118.23706116934677,33.786253457970844],[-118.2372186653074,33.786476416595264],[-118.23736962338356,33.78679149233554],[-118.23744346795051,33.787195248611425],[-118.23740432446269,33.78719885282979],[-118.23737314378289,33.7872017864959],[-118.23740516265299,33.78731284671295],[-118.23754296114117,33.78797082611206],[-118.2375509239492,33.788379779167904],[-118.23759434220763,33.78884463951789],[-118.23782107268848,33.7916820813802],[-118.23784060252288,33.79200897560398],[-118.23789072630383,33.792568216183696],[-118.23790111986379,33.792698219501915],[-118.23792693612558,33.79281087228057],[-118.23799432662706,33.79311865576511],[-118.23806716536565,33.793324599126095],[-118.23822281730759,33.79366306037622],[-118.2383068039774,33.79381125242435],[-118.2385194528609,33.79410428375928],[-118.23855130409295,33.79420578860672],[-118.23884416778984,33.79454969809393],[-118.23927256686105,33.79504657731405]]]}},{"type":"Feature","properties":{"id":11405,"osm_id":107726690,"name":"Los Angeles Refinery (Phillips 66)","type":"industrial","area":0.000122,"z_order":5},"geometry":{"type":"Polygon","coordinates":[[[-118.25735115853986,33.80204496354975],[-118.25610652973761,33.80493345120237],[-118.2488967519039,33.80480864466412],[-118.24765220692068,33.8080892377472],[-118.24378010293064,33.80811195270479],[-118.24156082642742,33.80810105623067],[-118.23828157444883,33.80805864380062],[-118.23780347069183,33.80804154471815],[-118.23749124479859,33.80802058996019],[-118.23667417687723,33.80795403764901],[-118.2357644051068,33.807871056807585],[-118.23579332267275,33.807680955243626],[-118.2358544267469,33.80748833910868],[-118.23607386497196,33.80744098135577],[-118.23605081473823,33.807198325258895],[-118.2362559199089,33.80651302085542],[-118.23636211862211,33.80623449021297],[-118.23640444723311,33.80618352824166],[-118.23649530706352,33.80599761762929],[-118.2364181097353,33.8059728910149],[-118.23669907112966,33.80523746283046],[-118.2368235423918,33.80488919475359],[-118.23822063801276,33.801135359417344],[-118.23829934408356,33.80102463447642],[-118.23842021112733,33.80090812602231],[-118.2385307684302,33.800822965886084],[-118.23856865463253,33.80084341772982],[-118.23860997741515,33.80086579741129],[-118.23869136569499,33.80090971858394],[-118.23876018112004,33.80086127118358],[-118.23888725077215,33.80090209105202],[-118.23908204620189,33.80078742661661],[-118.25292031688427,33.80007043861917],[-118.25325743702992,33.8000794910746],[-118.25362297182733,33.80011033647827],[-118.25396084634423,33.80019055129165],[-118.25439050270091,33.8003259190279],[-118.25473323872168,33.80049364091039],[-118.25735115853986,33.80204496354975]]]}},{"type":"Feature","properties":{"id":32439,"osm_id":230787366,"name":null,"type":"industrial","area":0.000052,"z_order":5},"geometry":{"type":"Polygon","coordinates":[[[-118.23946007003502,33.77721164756047],[-118.23942796734588,33.77769763030648],[-118.23910140839824,33.77834496468856],[-118.23788837937096,33.78028822512033],[-118.23746987094552,33.78060933583089],[-118.2367886736746,33.780783260321755],[-118.23322661628295,33.78092583649473],[-118.2286086067295,33.78129212566341],[-118.22878571634355,33.78074378155779],[-118.2296547520646,33.77925004259325],[-118.2307329162698,33.7782824356909],[-118.23146256094104,33.77778304189982],[-118.23263653029954,33.77735439137151],[-118.23397763480732,33.77707795620486],[-118.23645063151962,33.7769396548025],[-118.23743776825636,33.77685499758044],[-118.23772811738228,33.776663890188075],[-118.2377434562651,33.776346635152976],[-118.23745914210944,33.77636448860673],[-118.237040717503,33.776560625141],[-118.23607512225745,33.77665433481846],[-118.23438533057765,33.77679255240181],[-118.23414476995656,33.77676648468292],[-118.23378535394849,33.77675759986556],[-118.23299142007991,33.776913587083634],[-118.23189707880157,33.777225729157806],[-118.2305015757422,33.77795185342973],[-118.22912903909756,33.77903152637751],[-118.2293428614475,33.77881242342855],[-118.229552828122,33.77807733052023],[-118.22939105739074,33.776377899651806],[-118.23089921322878,33.7763160412064],[-118.23144646768696,33.77629827157164],[-118.23137136583452,33.77544658639019],[-118.23120967892231,33.775468295519424],[-118.23116215353132,33.774982899506654],[-118.23714884405396,33.77455039330289],[-118.23763692227575,33.77462616570759],[-118.23843622056238,33.774996226732696],[-118.23861861077545,33.77515229776977],[-118.23894516972307,33.77557072237619],[-118.2392516121031,33.77637857020406],[-118.23946007003502,33.77721164756047]]]}},{"type":"Feature","properties":{"id":49097,"osm_id":374487818,"name":"Newhall Refinery (Closed)","type":"industrial","area":0.000023,"z_order":5},"geometry":{"type":"Polygon","coordinates":[[[-118.50907781575135,34.34756017683997],[-118.50807064626602,34.34927746116219],[-118.50804114196686,34.35082685596379],[-118.50802454579858,34.351699495903205],[-118.50579110387895,34.352016331843146],[-118.50481704291114,34.350081537133605],[-118.50418026972706,34.3488805780469],[-118.50406627584391,34.34755238167003],[-118.50422854948935,34.34634329213725],[-118.50569094013602,34.34630465156363],[-118.50668486621434,34.34527946098646],[-118.50862460624676,34.345766198103775],[-118.5082525335649,34.34703027292136],[-118.50907781575135,34.34756017683997]]]}}]}

/***/ }),
/* 198 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74);
module.exports = __webpack_require__(73);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// 1.0.12/script.js